import { GenService } from "./gen-ser.service";
import { SplitNumber } from "../common/material-split-number/material-split-number.component";
import { RevisedDate } from "../common/material-revised-date/material-revised-date.component";
import moment from 'moment';
import { formatDate } from "@angular/common";
import { DataService } from "./dataservice.service";

export class configDefs {
	static dateFormat: string = 'MMM DD, YYYY';
	static defYesKeyId: string = "yes";
	static defNotApplicableText: string = "Not Applicable";
	static defSOCreationDays: number;
	static defSOReleaseDays: number;
	static defPlndOrdrHandidODDays: number;
	//static defPlndSLDSubmissDays:number;
	static defPlndSchDrwBOMSubmissDays: number;
	static defGAFDrwSubmissDays: number;
	static defPlndGTPCTPTBBSizCalSubmissDays: number;
	static defPlndDrawingApprovalDays: number;
	static defPlndC40Days: number;
	static defPlndC50Days: number;
	static defPlndC60Days: number;
	static defPlndImpBrkPORlsDays: number;
	static defPlndImpVSCPORlsDays: number;
	static defPlndAlstomGERlyPORlsDays: number;
	static defPlndRelayPORlsDays: number;
	static defPlndCBPORlsDays: number;
	static defPlndCTPTPORlsDays: number;
	static defPlndJumperPORlsDays: number;
	static defPlndImpErthSwthPORlsDays: number;
	static defPlndRychmSlvPORlsDays: number;
	static defPlndMtrBoxPORlsDays: number;
	static defPlndCBRcptPORlsWeeks: number;
	static defPlndCTPTPORlsWeeks: number;
	static defPlndRelayPORlsWeeks: number;
	static defPlndJumperPORlsWeeks: number;
	static defPlndMtrngBoxPORlsWeeks: number;
	static defPlndImpEthSwthPORlsWeeks: number;
	static defPlndRychmSlvRcptWeeks: number;
	static defPlndImpBrkrRcptWeeks: number;
	static defPlndImpVSCRcptWeeks: number;
	static defPlndAlstomGERlyRcptWeeks: number;

	static defPlndProdStartDays: number;
	static defPlndProdEndDays: number;
	static defPlndMechStikrDays: number;
	static defPlndElecTestDays: number;
	static defPlndFATDays: number;
	static defReqFATDays: number;
	static defPlndDispatchDays: number;
	static defPlndBrkrPORlsDays: number;
	static defPlndSAPORlsDays: number;
	static defPlndLooseMatIsuToDisp: number;
	static defPlndMechElecTestDays: number;
	static defReqMechElecTestDays: number;
	static defPlndGreStiDays: number;
	static defReqGreStiDays: number;
	static defReqDispatchDays: number;
	static defPlndMatIsuToLineDays: number;
	static defReqMatIsuToLineDays: number;
	static defReqSARecptDays: number;
	static defPlndSARecptWeeks: number;
	static defReqRelRecptDays: number;
	static defPlndRelRecptWeeks: number;
	static defPlndCTPTRecptWeeks: number;
	static defReqCTPTRecptDays: number;
	static defPlndCTFinByPMToSCMDays: number = 1;
	static defPlndPacDispClrDays: number;
	static defPlndCTFinalfrmSCMDays: number;
	static defPlndCTFinlEnggToPMDays: number;
	static defPlndGERelayPORelDays: number;
	static defPlndLinLoadWeeks: number;
	static defPlndPicLisIsuToStorDays: number;
	static defReqPicLisIsuToStorDays: number;
	static defReqImpBrekRecptDays: number;
	static defPlndImpVSCRecptDays: number;
	static defReqImpVSCRecptDays: number;
	static defPlndGERelayRecptWeek: number;
	static defReqGERelayRecptDays: number;
	static defReqJumRecptDays: number = 1;

	static defDaysPerWeek: number;

	//new vars , need cross check
	static defSplMatPSCmDays: number = 3;
	static defsplmatpricactPlannDays: number = 3;
	static defPlndSLDGAAprvlDays: number = 10;
	static defPlndLongLeadReleaseDays: number = 2;
	static defReqMechStikrDays: number = 5;
	static defReqMechStikrDaysBoughtout: number = 8;
	static defPlndABGSubmisDays: number = 14;
	static defPlndABGCollDays: number = 15;
	static defPlndCPBGSubmisDays: number = 14;
	static defPlndPBGSubmisDays: number = 10;
	static defReqPBGSubmisDays: number = 10
	static defReqPacDispClrDays: number = 4;
	static defReqLooseMatIsuToDisp: number = 1;
	static splMatFinalizatoingivenbyEnggToPM: number = 2;
	static defInhouseFabsubtracdays: number = 2;

	static correctGMT530: boolean = true;
	static GMT530Millis: number = 5.5 * 3600 * 1000;

	static getDaysDifference(_date1: Date, _date2: Date) {
		if (_date1 && _date2) {
			var timeDiff = _date1.getTime() - _date2.getTime();
			return Math.ceil(timeDiff / 86400000);//24 * 3600 * 1000  =86400000
		}
		return null;
	}
	static getDaysDifference2(_date1: Date, _date2: Date) {
		if (_date1 && _date2) {
			// if(configDefs.correctGMT530 == true){

			// }
			return Math.floor((_date1.getTime() + 19800000) / 86400000) -
				Math.floor((_date2.getTime() + 19800000) / 86400000)
			//return Math.ceil(timeDiff);//24 * 3600 * 1000  =86400000
		}
		return null;
	}
	static getMinValue(_ar): number {
		for (var i = 0; i < _ar.length; i++) {
			if (_ar[i] == null) {
				_ar.splice(i, 1);
				i--;
			}
		}
		if (_ar.length > 0) {
			return Math.min(..._ar);
		}
		return null;
	}

	static addWorkingDays(_srcDate: Date, _noOfDays: number): Date {
		if (_srcDate) {
			var _calDate = new Date(_srcDate.getTime());
			_calDate.setDate(_calDate.getDate() + _noOfDays);
			return _calDate;
		}
		return null;
	}
	static subtractWorkingDays(_srcDate: Date, _noOfDays: number): Date {
		var _calDate = new Date(_srcDate.getTime());
		_calDate.setDate(_calDate.getDate() - _noOfDays);
		return _calDate;
	}
	static addWorkingWeeks(_srcDate: Date, _noOfWeeks: number): Date {
		if (_srcDate) {
			var _calDate = new Date(_srcDate.getTime());
			_calDate.setDate(_calDate.getDate() + Math.ceil((_noOfWeeks * configDefs.defDaysPerWeek)));
			return _calDate;
		}
		return null;
	}
	static subtractWorkingWeeks(_srcDate: Date, _noOfWeeks: number): Date {
		var _calDate = new Date(_srcDate.getTime());
		_calDate.setDate(_calDate.getDate() - Math.ceil((_noOfWeeks * configDefs.defDaysPerWeek)));
		return _calDate;
	}
	static compareMyTaskDays(_diffDays: number, _ignoreIfAfterDays: number = 7): MyTaskJobStatus {
		if (_diffDays != null) {
			if (_diffDays == 0) {
				return MyTaskJobStatus.RUNNING;
			}
			else if (_diffDays < 0) {
				return MyTaskJobStatus.DELAYED;
			}
			else if (_diffDays <= _ignoreIfAfterDays) {
				return MyTaskJobStatus.UPCOMING;
			}
		}
		return MyTaskJobStatus.UNKNOWN;
	}

	static defTypeOfProducts: Array<ProductVariant>;
	static defNoOfPanels: Array<PanelNumDef>;
	static defComplexityOfJobs: Array<JobComplexityDef>;
	static defjobPriorityList: Array<JobPriorityDef>;
	static defNoOfFeederList: Array<FeederTypeDef>;

	static getTimeForSLDSubmission(_panelTypeID: string, _noOfPanelsId: string, _jobComplexityId: string, _jobPriorityId: string, _noOfFeederListId: string) {
		let _panelEfrt: number, _noOfPanelsEfrt: number, _jobComplexEfrt: number, _jobPriorityEfrt: number, _noOfFeederEfrt: number;

		if (_panelTypeID == null || _noOfPanelsId == null || _jobComplexityId == null || _noOfFeederListId == null)
			return null;

		for (var i = 0; i < configDefs.defTypeOfProducts.length; i++) {
			if (configDefs.defTypeOfProducts[i].productVariantId == _panelTypeID) {
				_panelEfrt = configDefs.defTypeOfProducts[i].enggEfforts;
				break;
			}
		}
		for (var i = 0; i < configDefs.defNoOfPanels.length; i++) {
			if (configDefs.defNoOfPanels[i].noOfPanelsId == _noOfPanelsId) {
				_noOfPanelsEfrt = configDefs.defNoOfPanels[i].enggEfforts;
				break;
			}
		}
		for (var i = 0; i < configDefs.defComplexityOfJobs.length; i++) {
			if (configDefs.defComplexityOfJobs[i].complexityOfJobsId == _jobComplexityId) {
				_jobComplexEfrt = configDefs.defComplexityOfJobs[i].enggEfforts;
				break;
			}
		}
		// for(var i=0;i<configDefs.defjobPriorityList.length;i++){
		// 	if(configDefs.defjobPriorityList[i].priorityOfJobsId == _jobPriorityId){
		// 		_jobPriorityEfrt = configDefs.defjobPriorityList[i].enggEfforts;
		// 		break;
		// 	}
		// }
		for (var i = 0; i < configDefs.defNoOfFeederList.length; i++) {
			if (configDefs.defNoOfFeederList[i].noOfFeederTypesId == _noOfFeederListId) {
				_noOfFeederEfrt = configDefs.defNoOfFeederList[i].enggEfforts;
				break;
			}
		}

		return configDefs.calcTimeForSLDSubmiss(_panelEfrt, _noOfPanelsEfrt, _jobComplexEfrt, _noOfFeederEfrt);
	}


	static getTimeForGAFDrwSubmission(_sldSubmissTime: number) {
		if (_sldSubmissTime) {
			return Math.ceil(_sldSubmissTime + configDefs.defGAFDrwSubmissDays)
		}
		return null;
	}

	static getTimeForSchDrwBOMSubmission(_panelTypeID: string, _noOfPanelsId: string, _jobComplexityId: string, _jobPriorityId: string, _noOfFeederListId: string) {
		let _panelEfrt: number, _noOfPanelsEfrt: number, _jobComplexEfrt: number, _jobPriorityEfrt: number, _noOfFeederEfrt: number;

		for (var i = 0; i < configDefs.defTypeOfProducts.length; i++) {
			if (configDefs.defTypeOfProducts[i].productVariantId == _panelTypeID) {
				_panelEfrt = configDefs.defTypeOfProducts[i].enggEfforts;
				break;
			}
		}
		for (var i = 0; i < configDefs.defNoOfPanels.length; i++) {
			if (configDefs.defNoOfPanels[i].noOfPanelsId == _noOfPanelsId) {
				_noOfPanelsEfrt = configDefs.defNoOfPanels[i].enggEfforts;
				break;
			}
		}
		for (var i = 0; i < configDefs.defComplexityOfJobs.length; i++) {
			if (configDefs.defComplexityOfJobs[i].complexityOfJobsId == _jobComplexityId) {
				_jobComplexEfrt = configDefs.defComplexityOfJobs[i].enggEfforts;
				break;
			}
		}
		// for(var i=0;i<configDefs.defjobPriorityList.length;i++){
		// 	if(configDefs.defjobPriorityList[i].priorityOfJobsId == _jobPriorityId){
		// 		_jobPriorityEfrt = configDefs.defjobPriorityList[i].enggEfforts;
		// 		break;
		// 	}
		// }
		for (var i = 0; i < configDefs.defNoOfFeederList.length; i++) {
			if (configDefs.defNoOfFeederList[i].noOfFeederTypesId == _noOfFeederListId) {
				_noOfFeederEfrt = configDefs.defNoOfFeederList[i].enggEfforts;
				break;
			}
		}

		if (_panelEfrt && _noOfPanelsEfrt && _jobComplexEfrt && _noOfFeederEfrt) {//&& _jobPriorityEfrt
			var _effctiveScore = configDefs.calcEffectiveScore(_panelEfrt, _noOfPanelsEfrt, _jobComplexEfrt, _noOfFeederEfrt);
			var _sldSubmisTime = configDefs.calcTimeForSLDSubmiss(_panelEfrt, _noOfPanelsEfrt, _jobComplexEfrt, _noOfFeederEfrt);

			return Math.ceil((_effctiveScore + configDefs.defPlndSchDrwBOMSubmissDays) + _sldSubmisTime);
		}
		return null;
	}

	static getTimeForGTPCTPTBBSizingSubmission(_schDrwBOMTime: number) {
		//let _schDrwBOMTime:number = configDefs.getTimeForSchDrwBOMSubmission(_panelTypeID, _noOfPanelsId, _jobComplexityId, _jobPriorityId, _noOfFeederListId);

		if (_schDrwBOMTime) {
			return Math.ceil(_schDrwBOMTime + configDefs.defPlndGTPCTPTBBSizCalSubmissDays);
		}
		return null;
	}

	static getEffectiveScore(_panelTypeID: string, _noOfPanelsId: string, _jobComplexityId: string, _jobPriorityId: string, _noOfFeederListId: string) {
		let _panelEfrt: number, _noOfPanelsEfrt: number, _jobComplexEfrt: number, _jobPriorityEfrt: number, _noOfFeederEfrt: number;

		for (var i = 0; i < configDefs.defTypeOfProducts.length; i++) {
			if (configDefs.defTypeOfProducts[i].productVariantId == _panelTypeID) {
				_panelEfrt = configDefs.defTypeOfProducts[i].enggEfforts;
				break;
			}
		}
		for (var i = 0; i < configDefs.defNoOfPanels.length; i++) {
			if (configDefs.defNoOfPanels[i].noOfPanelsId == _noOfPanelsId) {
				_noOfPanelsEfrt = configDefs.defNoOfPanels[i].enggEfforts;
				break;
			}
		}
		for (var i = 0; i < configDefs.defComplexityOfJobs.length; i++) {
			if (configDefs.defComplexityOfJobs[i].complexityOfJobsId == _jobComplexityId) {
				_jobComplexEfrt = configDefs.defComplexityOfJobs[i].enggEfforts;
				break;
			}
		}
		// for(var i=0;i<configDefs.defjobPriorityList.length;i++){
		// 	if(configDefs.defjobPriorityList[i].priorityOfJobsId == _jobPriorityId){
		// 		_jobPriorityEfrt = configDefs.defjobPriorityList[i].enggEfforts;
		// 		break;
		// 	}
		// }
		for (var i = 0; i < configDefs.defNoOfFeederList.length; i++) {
			if (configDefs.defNoOfFeederList[i].noOfFeederTypesId == _noOfFeederListId) {
				_noOfFeederEfrt = configDefs.defNoOfFeederList[i].enggEfforts;
				break;
			}
		}

		return configDefs.calcEffectiveScore(_panelEfrt, _noOfPanelsEfrt, _jobComplexEfrt, _noOfFeederEfrt);

	}

	static calcEffectiveScore(_panelEfrt: number, _noOfPanelsEfrt: number, _jobComplexEfrt: number, _noOfFeederEfrt: number) {
		if (_panelEfrt && _noOfPanelsEfrt && _jobComplexEfrt && _noOfFeederEfrt) {//&& _jobPriorityEfrt
			return _panelEfrt * _noOfPanelsEfrt * _jobComplexEfrt * _noOfFeederEfrt;
		}
		return null;
	}

	static calcTimeForSLDSubmiss(_panelEfrt: number, _noOfPanelsEfrt: number, _jobComplexEfrt: number, _noOfFeederEfrt: number) {
		if (_panelEfrt && _noOfPanelsEfrt && _jobComplexEfrt && _noOfFeederEfrt) {//&& _jobPriorityEfrt
			return Math.ceil((_panelEfrt * _jobComplexEfrt) + _noOfPanelsEfrt + _noOfFeederEfrt);
		}
		return null;
	}

	static getJobPriorityEfforts(_priorityOfJobsId: string): number {
		if (configDefs.defjobPriorityList) {
			for (var i = 0; i < configDefs.defjobPriorityList.length; i++) {
				if (configDefs.defjobPriorityList[i].priorityOfJobsId == _priorityOfJobsId) {
					return configDefs.defjobPriorityList[i].enggEfforts;
				}
			}
		}
		return 0;
	}

	static isVSCQtyEnable(_variantId: string, _equipTypeId: string, _brkrTypeID: string): boolean {
		return ((_brkrTypeID == '004') && (_variantId == '001') &&
			(_equipTypeId == '009' || _equipTypeId == '010'));
	}

	static getDateNum(_tmpDate: Date): number {
		if (_tmpDate != null) {
			return _tmpDate.getTime();
		}
		return null;
	}

	static isApplicable(_applicableId: string) {
		return (_applicableId == "001");
	}
	static isNumEmty(_num: number) {
		if (_num == null || isNaN(_num)) return true;
		return false;
	}
	static isStrEmty(_str: string) {
		if (_str == null || _str == '') return true;
		return false;
	}
	static isDtEmty(_dt: Date) {
		if (_dt == null || !(_dt instanceof Date) || _dt.getTime() == 0) return true;
		return false;
	}
	static isDtEmtyforComts(_dt: Date) {
		if (_dt == null) {
			return true;
		}
		return false;
	}
	static cloneDt(_dt: Date) {
		if (_dt == null) return null;
		return new Date(_dt.getTime());
	}
	constructor() {
	}
}
export class convDefs {

	constructor() {

	}
	public static convToPlannedDateToken(_dateJson: any): PlannedDateToken {
		if (_dateJson) {
			return new PlannedDateToken(
				GenService.convToDate(_dateJson.plannedDate), (_dateJson.isOveridden == 1 ? true : false),
				GenService.convToDate(_dateJson.actualPlannedDate), _dateJson.addNotes, _dateJson.userOveridden
			);
		}
		return new PlannedDateToken(null, false, null, '', '');
	}
	public static convToActualDateToken(_dateJson: any): ActualDateToken {
		if (_dateJson) {
			return new ActualDateToken(
				GenService.convToDate(_dateJson.actualDate), (_dateJson.isOveridden == 1 ? true : false),
				GenService.convToDate(_dateJson.expActualDate), _dateJson.addNotes, _dateJson.userOveridden
			);
		}
		return new ActualDateToken(null, false, null, '', '');
	}
	public static convToActualDateToken_Compat(_dateJson: any): ActualDateToken {
		if (_dateJson) {
			return new ActualDateToken(
				GenService.convToDate(_dateJson), false, null, '', ''
			);
		}
		return new ActualDateToken(null, false, null, '', '');
	}
	public static convToRequestDateToken(_dateJson: any): RequestDateToken {
		if (_dateJson) {
			return new RequestDateToken(
				GenService.convToDate(_dateJson.requestDate), (_dateJson.isOveridden == 1 ? true : false),
				GenService.convToDate(_dateJson.plndRequestDate), _dateJson.addNotes, _dateJson.userOveridden
			);
		}
		return new RequestDateToken(null, false, null, '', '');
	}
}

export class RevenueMonth {
	private _year: number = null;
	private _month: number = null;
	constructor(private _monthId: string, private _monthName: string, private _monthVal: number, private _orderNo: number) {
		let _tmpYear: number = parseInt((_monthVal / 100) + '', 10);
		if (_tmpYear > 0) {
			this._year = _tmpYear;
			this._month = _monthVal % 100;
		}
	}


	get monthId() {
		return this._monthId;
	}
	get monthName() {
		return this._monthName;
	}
	get year() {
		return this._year;
	}
	get month() {
		return this._month;
	}
	get orderNo(): number {
		return this._orderNo;
	}
}

export class Plant {
	constructor(private _plantId: string, private _plantName: string, private _isActive: boolean) {
	}

	get plantId(): string {
		return this._plantId;
	}
	get plantName(): string {
		return this._plantName;
	}
	get isActive(): boolean {
		return this._isActive;
	}
	cloneSelf() {
		return new Plant(this._plantId, this._plantName, this._isActive);
	}
}

export class Region {
	constructor(private _regionId: string, private _regionName: string, private _isActive: boolean) {
	}

	get regionId(): string {
		return this._regionId;
	}
	get regionName(): string {
		return this._regionName;
	}
	get isActive(): boolean {
		return this._isActive;
	}
	cloneSelf() {
		return new Region(this._regionId, this._regionName, this._isActive);
	}
}
export class OrderType {
	constructor(private _ordertypeId: string, private _ordertypeName: string, private _isActive: boolean) {
	}

	get ordertypeId(): string {
		return this._ordertypeId;
	}
	get ordertypeName(): string {
		return this._ordertypeName;
	}
	get isActive(): boolean {
		return this._isActive;
	}
	cloneSelf() {
		return new OrderType(this._ordertypeId, this._ordertypeName, this._isActive);
	}
}
export class GenDataType {
	constructor(private _genTypeId: string, private _genTypeName: string, private _isActive: boolean) {
	}

	get genTypeId(): string {
		return this._genTypeId;
	}
	get genTypeName(): string {
		return this._genTypeName;
	}
	get isActive(): boolean {
		return this._isActive;
	}
	cloneSelf() {
		return new GenDataType(this._genTypeId, this._genTypeName, this._isActive);
	}
}
export class RelayConfig {
	constructor(private _relayconfigId: string, private _relayconfigName: string, private _isActive: boolean) {
	}
	get relayconfigId(): string {
		return this._relayconfigId;
	}
	get relayconfigName(): string {
		return this._relayconfigName
	}
	get isActive(): boolean {
		return this._isActive;
	}
	cloneSelf() {
		return new RelayConfig(this._relayconfigId, this._relayconfigName, this._isActive);
	}
}

export class RelayConfigUI {
	constructor(private _relayconfigId: string, private _relayconfigName: string, private _isActive: boolean) {
	}
	get relayconfigId(): string {
		return this._relayconfigId;
	}
	get relayconfigName(): string {
		return this._relayconfigName
	}
	get isActive(): boolean {
		return this._isActive;
	}
	cloneSelf() {
		return new RelayConfig(this._relayconfigId, this._relayconfigName, this._isActive);
	}
}

export class SaleChannel {
	constructor(private _saleChannelId: string, private _saleChannelName: string, private _isActive: boolean) {
	}

	get saleChannelId(): string {
		return this._saleChannelId;
	}
	get saleChannelName(): string {
		return this._saleChannelName;
	}
	get isActive(): boolean {
		return this._isActive;
	}
	cloneSelf() {
		return new SaleChannel(this._saleChannelId, this._saleChannelName, this._isActive);
	}
}

export class EmailGrp {
	constructor(private _emailGrpId: string, private _emailGrpName: string, private _emailId: string, private _isActive: boolean) {
	}
	get emailGrpId(): string {
		return this._emailGrpId;
	}
	get emailGrpName(): string {
		return this._emailGrpName;
	}
	get emailId(): string {
		return this._emailId;
	}
	cloneSelf() {
		return new EmailGrp(this._emailGrpId, this._emailGrpName, this._emailId, this._isActive);
	}
}

export class SuperAdmin {
	constructor(private _superAdminId: string, private _superAdminName: string, private _emailId: string, private _isActive: boolean) {
	}
	get superAdminId(): string {
		return this._superAdminId;
	}
	get superAdminName(): string {
		return this._superAdminName;
	}
	get emailId(): string {
		return this._emailId;
	}
	cloneSelf() {
		return new SuperAdmin(this._superAdminId, this._superAdminName, this._emailId, this._isActive);
	}
}
export class GenUserDef {
	constructor(private _userId: string, private _userName: string, private _userEmailId: string, private _isActive: boolean) {
	}
	get userId(): string {
		return this._userId;
	}
	get userName(): string {
		return this._userName;
	}
	get userEmailId(): string {
		return this._userEmailId;
	}
	cloneSelf() {
		return new GenUserDef(this._userId, this._userName, this._userEmailId, this._isActive);
	}
}

export class ProjectManager {
	constructor(private _projectManagerId: string, private _projectManagerName: string, private _emailId: string, private _isActive: boolean) {
	}
	get projectManagerId(): string {
		return this._projectManagerId;
	}
	get projectManagerName(): string {
		return this._projectManagerName;
	}
	get emailId(): string {
		return this._emailId;
	}
	cloneSelf() {
		return new ProjectManager(this._projectManagerId, this._projectManagerName, this._emailId, this._isActive);
	}
}

export class ProjectEngineer {
	constructor(private _projectEngineerId: string, private _projectEngineerName: string, private _emailId: string, private _isActive: boolean) {
	}

	get projectEngineerId(): string {
		return this._projectEngineerId;
	}
	get projectEngineerName(): string {
		return this._projectEngineerName;
	}
	get emailId(): string {
		return this._emailId;
	}
	cloneSelf() {
		return new ProjectEngineer(this._projectEngineerId, this._projectEngineerName, this._emailId, this._isActive);
	}
}

export class ProductVariant {
	constructor(private _productVariantId: string, private _productVariantName: string, private _enggEfforts: number, private _isActive: boolean) {
	}
	get productVariantId(): string {
		return this._productVariantId;
	}
	get productVariantName(): string {
		return this._productVariantName;
	}
	get enggEfforts(): number {
		return this._enggEfforts;
	}
	cloneSelf() {
		return new ProductVariant(this._productVariantId, this._productVariantName, this._enggEfforts, this._isActive);
	}
}

export class EquipmentType {
	constructor(private _equipmentTypeId: string, private _equipmentTypeName: string, private _variant_ids: Array<string>, private _isActive: boolean) {
		if (_variant_ids == null) _variant_ids = [];
	}

	get equipmentTypeId(): string {
		return this._equipmentTypeId;
	}
	get equipmentTypeName(): string {
		return this._equipmentTypeName;
	}
	get variantIDs(): Array<string> {
		return this._variant_ids;
	}
	cloneSelf() {
		return new EquipmentType(this._equipmentTypeId, this._equipmentTypeName, this.variantIDs, this._isActive);
	}
}
export class MechanicalDesignEngineer {
	constructor(private _mechanicalDesignEngineerId: string, private _mechanicalDesignEngineerName: string, private _mechanicalDesignEngineerEmailId: string, private _isActive: boolean) {
	}
	get mechanicalDesignEngineerId(): string {
		return this._mechanicalDesignEngineerId;
	}
	get mechanicalDesignEngineerName(): string {
		return this._mechanicalDesignEngineerName;
	}
	get emailId(): string {
		return this._mechanicalDesignEngineerEmailId;
	}
	cloneSelf() {
		return new MechanicalDesignEngineer(this._mechanicalDesignEngineerId, this._mechanicalDesignEngineerName, this._mechanicalDesignEngineerEmailId, this._isActive);
	}
}
export class RefMonth {
	constructor(private _monthId: string, private _monthDisplayName: string) {
	}

	get monthId(): string {
		return this._monthId;
	}
	get monthDisplayName(): string {
		return this._monthDisplayName;
	}
	cloneSelf() {
		return new RefMonth(this._monthId, this._monthDisplayName);
	}
}

export class DesignEngineer {
	constructor(private _designEngineerId: string, private _designEngineerName: string) {
	}

	get designEngineerId(): string {
		return this._designEngineerId;
	}
	get designEngineerName(): string {
		return this._designEngineerName;
	}
	cloneSelf() {
		return new DesignEngineer(this._designEngineerId, this._designEngineerName);
	}
}
export class MarketingEngineer {
	constructor(private _marketingEngineerId: string, private _marketingEngineerName: string, private _emailId: string, private _isActive: boolean) {
	}

	get marketingEngineerId(): string {
		return this._marketingEngineerId;
	}
	get marketingEngineerName(): string {
		return this._marketingEngineerName;
	}
	get emailId(): string {
		return this._emailId;
	}
	cloneSelf() {
		return new MarketingEngineer(this._marketingEngineerId, this._marketingEngineerName, this._emailId, this._isActive);
	}
}
export class ElectricalTestingEngineer {
	constructor(private _elecTestEnggId: string, private _elecTestEnggName: string, private _emailId: string, private _isActive: boolean) {
	}

	get elecTestEnggId(): string {
		return this._elecTestEnggId;
	}
	get elecTestEnggName(): string {
		return this._elecTestEnggName;
	}
	get emailId(): string {
		return this._emailId;
	}
	get isActive(): boolean {
		return this._isActive == true;
	}
	static getObj(_json: any): ElectricalTestingEngineer {
		return new ElectricalTestingEngineer(_json.elec_test_engineer_id, _json.elec_test_engineer_name, _json.email_id, _json.is_active);
	}
}
export class MechanicalTestingEngineer {
	constructor(private _mechTestEnggId: string, private _mechTestEnggName: string, private _emailId: string, private _isActive: boolean) {
	}

	get mechTestEnggId(): string {
		return this._mechTestEnggId;
	}
	get mechTestEnggName(): string {
		return this._mechTestEnggName;
	}
	get emailId(): string {
		return this._emailId;
	}
	get isActive(): boolean {
		return this._isActive == true;
	}
	static getObj(_json: any): MechanicalTestingEngineer {
		return new MechanicalTestingEngineer(_json.mech_test_engineer_id, _json.mech_test_engineer_name, _json.email_id, _json.is_active);
	}

}
export class AdvancePayPercent {
	constructor(private _advancePayPercentId: string, private _advancePayPercentDisplay: string, private _advancePayPercentValue: number, private _isActive: boolean) {
	}

	get advancePayPercentId(): string {
		return this._advancePayPercentId;
	}
	get advancePayPercentDisplay(): string {
		return this._advancePayPercentDisplay;
	}
	cloneSelf() {
		return new AdvancePayPercent(this._advancePayPercentId, this._advancePayPercentDisplay, this._advancePayPercentValue, this._isActive);
	}
}

export class AdvancePayMilestone {
	constructor(private _advancePayMilestoneId: string, private _advancePayMilestoneName: string, private _isActive: boolean) {
	}

	get advancePayMilestoneId(): string {
		return this._advancePayMilestoneId;
	}
	get advancePayMilestoneName(): string {
		return this._advancePayMilestoneName;
	}
	cloneSelf() {
		return new AdvancePayMilestone(this._advancePayMilestoneId, this._advancePayMilestoneName, this._isActive);
	}
}

export class AdvancePayCondition {
	constructor(private _advancePayConditionId: string, private _advancePayConditionName: string, private _isActive: boolean) {
	}

	get advancePayConditionId(): string {
		return this._advancePayConditionId;
	}
	get advancePayConditionName(): string {
		return this._advancePayConditionName;
	}
	cloneSelf() {
		return new AdvancePayCondition(this._advancePayConditionId, this._advancePayConditionName, this._isActive);
	}
}

export class YesNoOption {
	constructor(private _optionId: string, private _optionDisplayName: string) {
	}
	get optionId(): string {
		return this._optionId;
	}
	get optionDisplayName(): string {
		return this._optionDisplayName;
	}
	cloneSelf() {
		return new YesNoOption(this._optionId, this._optionDisplayName);
	}
}
export class ReqNonReqOption {
	constructor(private _optionId: string, private _optionDisplayName: string) {
	}
	get optionId(): string {
		return this._optionId;
	}
	get optionDisplayName(): string {
		return this._optionDisplayName;
	}
	cloneSelf() {
		return new ReqNonReqOption(this._optionId, this._optionDisplayName);
	}
}

export class ProjStatus {
	constructor(private _statusId: string, private _statusDisplayName: string) {
	}
	get statusId(): string {
		return this._statusId;
	}
	get statusDisplayName(): string {
		return this._statusDisplayName;
	}
}

export class LDPercentDef {
	constructor(private _ldPercentId: string, private _ldPercentName: string, private _isActive: boolean) {
	}

	get ldPercentId(): string {
		return this._ldPercentId;
	}
	get ldPercentName(): string {
		return this._ldPercentName;
	}
	cloneSelf() {
		return new LDPercentDef(this._ldPercentId, this._ldPercentName, this._isActive);
	}
}

export class LDCAPDef {
	constructor(private _ldCAPId: string, private _ldCAPName: string, private _isActive: boolean) {
	}

	get ldCapId(): string {
		return this._ldCAPId;
	}
	get ldCAPName(): string {
		return this._ldCAPName;
	}
	cloneSelf() {
		return new LDCAPDef(this._ldCAPId, this._ldCAPName, this._isActive);
	}
}

export class DeliveryTermDef {
	constructor(private _deliveryTermId: string, private _deliveryTermName: string, private _isActive: boolean) {
	}

	get deliveryTermId(): string {
		return this._deliveryTermId;
	}
	get deliveryTermName(): string {
		return this._deliveryTermName;
	}
	cloneSelf() {
		return new DeliveryTermDef(this._deliveryTermId, this._deliveryTermName, this._isActive);
	}
}


export class BusbarSleeveDef {
	constructor(private _busbarSleeveId: string, private _busbarSleeveName: string, private _isActive: boolean) {
	}

	get busbarSleeveId(): string {
		return this._busbarSleeveId;
	}
	get busbarSleeveName(): string {
		return this._busbarSleeveName;
	}
	cloneSelf() {
		return new BusbarSleeveDef(this._busbarSleeveId, this._busbarSleeveName, this._isActive);
	}
}
export class BoardnameDef {
	constructor(private _boardname: string, private _isActive: boolean) {
	}
	get boardname(): string {
		return this._boardname;
	}
	cloneSelf() {
		return new BoardnameDef(this._boardname, this._isActive);
	}
}

export class DelayReason {
	constructor(private _delayreason: string, private _isActive: boolean) {
	}
	get delayreason(): string {
		return this._delayreason;
	}
	cloneSelf() {
		return new DelayReason(this._delayreason, this._isActive);
	}
}
export class PanelNumDef {
	constructor(private _noOfPanelsId: string, private _noOfPanelsName: string, private _enggEfforts: number, private _isActive: boolean) {
	}

	get noOfPanelsId(): string {
		return this._noOfPanelsId;
	}
	get noOfPanelsName(): string {
		return this._noOfPanelsName;
	}
	get enggEfforts(): number {
		return this._enggEfforts;
	}
	cloneSelf() {
		return new PanelNumDef(this._noOfPanelsId, this._noOfPanelsName, this._enggEfforts, this._isActive);
	}
}

export class FeederTypeDef {
	constructor(private _noOfFeederTypeId: string, private _noOfFeederTypeName: string, private _enggEfforts: number, private _isActive: boolean) {
	}

	get noOfFeederTypesId(): string {
		return this._noOfFeederTypeId;
	}
	get noOfFeederTypeName(): string {
		return this._noOfFeederTypeName;
	}
	get enggEfforts(): number {
		return this._enggEfforts;
	}
	cloneSelf() {
		return new FeederTypeDef(this._noOfFeederTypeId, this._noOfFeederTypeName, this._enggEfforts, this._isActive);
	}
}

export class JobComplexityDef {
	constructor(private _complexityOfJobsId: string, private _complexityOfJobsName: string, private _enggEfforts: number, private _isActive: boolean) {
	}

	get complexityOfJobsId(): string {
		return this._complexityOfJobsId;
	}
	get complexityOfJobsName(): string {
		return this._complexityOfJobsName;
	}
	get enggEfforts(): number {
		return this._enggEfforts;
	}
	cloneSelf() {
		return new JobComplexityDef(this._complexityOfJobsId, this._complexityOfJobsName, this._enggEfforts, this._isActive);
	}
}

export class JobPriorityDef {
	constructor(private _priorityOfJobsId: string, private _priorityOfJobsName: string, private _enggEfforts: number, private _isActive: boolean) {
	}

	get priorityOfJobsId(): string {
		return this._priorityOfJobsId;
	}
	get priorityOfJobsName(): string {
		return this._priorityOfJobsName;
	}
	get enggEfforts(): number {
		return this._enggEfforts;
	}
	cloneSelf() {
		return new JobPriorityDef(this._priorityOfJobsId, this._priorityOfJobsName, this._enggEfforts, this._isActive);
	}
}

export class PaymentTermDef {
	constructor(private _paymentTermId: string, private _paymentTermName: string, private _isActive: boolean) {
	}

	get paymentTermId(): string {
		return this._paymentTermId;
	}
	get paymentTermName(): string {
		return this._paymentTermName;
	}
	cloneSelf() {
		return new PaymentTermDef(this._paymentTermId, this._paymentTermName, this._isActive);
	}
}

export class BusbarMaterialDef {
	constructor(private _busbarMaterialId: string, private _busbarMaterialName: string, private _isActive: boolean) {
	}

	get busbarMaterialId(): string {
		return this._busbarMaterialId;
	}
	get busbarMaterialName(): string {
		return this._busbarMaterialName;
	}
	cloneSelf() {
		return new BusbarMaterialDef(this._busbarMaterialId, this._busbarMaterialName, this._isActive);
	}
}

export class ApplicabilityOptionDef {
	constructor(private _applicId: string, private _applicName: string) {
	}

	get applicId(): string {
		return this._applicId;
	}
	get applicName(): string {
		return this._applicName;
	}
	cloneSelf() {
		return new ApplicabilityOptionDef(this._applicId, this._applicName);
	}
}

export class WarrantyInMonth {
	constructor(private _warrantyInMonthId: string, private _warrantyInMonthValue: string) {

	}
	get warrantyInMonthId(): string {
		return this._warrantyInMonthId;
	}
	get warrantyInMonthValue(): string {
		return this._warrantyInMonthValue;
	}
	cloneSelf() {
		return new WarrantyInMonth(this._warrantyInMonthId, this._warrantyInMonthValue);
	}

}
export class ConfigItems {
	constructor(private _confId: string, private _confName: string, private _confParaName: string, private _confType: string, private _confValue: string, private _orderNo: number, private _isActive: boolean) {
	}
	get confId(): string {
		return this._confId;
	}
	get confName(): string {
		return this._confName;
	}
	get confParaName(): string {
		return this._confParaName;
	}
	get confType(): string {
		return this._confType;
	}
	get confValue(): string {
		return this._confValue;
	}
	get orderNo(): number {
		return this._orderNo;
	}
	get IsActive(): boolean {
		return this._isActive;
	}
	cloneSelf() {
		return new ConfigItems(this._confId, this._confName, this._confParaName, this._confType, this._confValue, this._orderNo, this._isActive);
	}
}
export class ElectricalDesignEngineer {
	constructor(private _electricalDesignEngineerId: string, private _electricalDesignEngineerName: string, private _electricalDesignEngineerEmailId: string, private _isActive: boolean) {
	}
	get electricalDesignEngineerId(): string {
		return this._electricalDesignEngineerId;
	}
	get electricalDesignEngineerName(): string {
		return this._electricalDesignEngineerName;
	}
	get electricalDesignEngineerEmailId(): string {
		return this._electricalDesignEngineerEmailId;
	}
	cloneSelf() {
		return new ElectricalDesignEngineer(this._electricalDesignEngineerId, this._electricalDesignEngineerName, this._electricalDesignEngineerEmailId, this._isActive);
	}
}
export class C30Engineer {
	constructor(private _c30EngineerId: string, private _c30EngineerName: string, private _c30EngineerEmailId: string, private _isActive: boolean) {
	}
	get c30EngineerId(): string {
		return this._c30EngineerId;
	}
	get c30EngineerName(): string {
		return this._c30EngineerName;
	}
	get c30EngineerEmailId(): string {
		return this._c30EngineerEmailId;
	}
	cloneSelf() {
		return new C30Engineer(this._c30EngineerId, this._c30EngineerName, this._c30EngineerEmailId, this._isActive);
	}
}
export class ContractualDeliveryWeeks {
	constructor(private _contractualDeliveryWeeksId: string, private _contractualDeliveryWeeksName: string, private _contractualDeliveryWeeksCount: number, private _isActive: boolean) {
	}

	get contractualDeliveryWeeksId(): string {
		return this._contractualDeliveryWeeksId;
	}
	get contractualDeliveryWeeksName(): string {
		return this._contractualDeliveryWeeksName;
	}
	get contractualDeliveryWeeksCount(): number {
		return this._contractualDeliveryWeeksCount;
	}
	cloneSelf() {
		return new ContractualDeliveryWeeks(this._contractualDeliveryWeeksId, this._contractualDeliveryWeeksName, this._contractualDeliveryWeeksCount, this._isActive);
	}
}

export class WarrantyMonths {
	constructor(private _warrantyMonthsId: string, private _warrantyMonthsName: string, private _warrantyMonthsCount: number, private _isActive: boolean) {
	}
	get warrantyMonthsId(): string {
		return this._warrantyMonthsId;
	}
	get warrantyMonthsName(): string {
		return this._warrantyMonthsName;
	}
	get warrantyMonthsCount(): number {
		return this._warrantyMonthsCount;
	}
	cloneSelf() {
		return new WarrantyMonths(this._warrantyMonthsId, this._warrantyMonthsName, this._warrantyMonthsCount, this._isActive);
	}
}
export class InsulationLevel {
	constructor(private _insulationLevelId: string, private _insulationLevelName: string, private _insulationLevelValue: number, private _isActive: boolean) {
	}
	get insulationLevelId(): string {
		return this._insulationLevelId;
	}
	get insulationLevelName(): string {
		return this._insulationLevelName;
	}
	get insulationLevelValue(): number {
		return this._insulationLevelValue;
	}
	cloneSelf() {
		return new InsulationLevel(this.insulationLevelId, this._insulationLevelName, this._insulationLevelValue, this._isActive);
	}
}

export class SuborderNumbers {
	constructor(private _suborderNumbersId: string, private _suborderNumbersName: string, private _isActive: boolean) {
	}
	get suborderNumbersId(): string {
		return this._suborderNumbersId;
	}
	get suborderNumbersName(): string {
		return this._suborderNumbersName;
	}
	cloneSelf() {
		return new SuborderNumbers(this._suborderNumbersId, this._suborderNumbersName, this._isActive);
	}
}
export class DatasheetNumbers {
	constructor(private _datasheetNumbersId: string, private _datasheetNumbersName: string, private _isActive: boolean) {
	}
	get datasheetNumbersId(): string {
		return this._datasheetNumbersId;
	}
	get datasheetNumbersName(): string {
		return this._datasheetNumbersName;
	}
	cloneSelf() {
		return new DatasheetNumbers(this._datasheetNumbersId, this._datasheetNumbersName, this._isActive);
	}
}
// Check if it's useful for other type
export class OptionsSubOptsDef {
	constructor(private _optionId: string, private _optionName: string, private _isActive: boolean, private _hasNewTab?: boolean) {
	}
	get optionId(): string {
		return this._optionId;
	}
	get optionName(): string {
		return this._optionName;
	}
	get isActive(): boolean {
		return this._isActive;
	}
	get hasNewTab(): boolean {
		return this._hasNewTab;
	}
	cloneSelf() {
		return new OptionsSubOptsDef(this._optionId, this._optionName, this._isActive, this._hasNewTab);
	}
}
export class OptionsDef {
	constructor(private _optionId: string, private _optionName: string, private _isActive: boolean, private _orderNo?: number) {
	}
	get optionId(): string {
		return this._optionId;
	}
	get optionName(): string {
		return this._optionName;
	}
	get isActive(): boolean {
		return this._isActive;
	}
	get orderNo(): number {
		return this._orderNo;
	}

	cloneSelf() {
		return new OptionsDef(this._optionId, this._optionName, this._isActive, this._orderNo);
	}
}
export class OptionsConnectedDef {
	constructor(private _optionId: string, private _optionName: string, private _connectedOptionId: Array<string>, private _isActive: boolean) {
	}
	get optionId(): string {
		return this._optionId;
	}
	get optionName(): string {
		return this._optionName;
	}
	get connectedOptionId(): Array<string> {
		return this._connectedOptionId;
	}
	get isActive(): boolean {
		return this._isActive;
	}
	cloneSelf() {
		return new OptionsConnectedDef(this._optionId, this._optionName, this._connectedOptionId, this._isActive);
	}
}

export class OptionsConnectedValueDef {
	constructor(private _optionId: string, private _optionName: string, private _connectedValue: string, private _connectedOptionId: Array<string>, private _isActive: boolean, private _connectedValueList?: Array<string>) {
	}
	get optionId(): string {
		return this._optionId;
	}
	get optionName(): string {
		return this._optionName;
	}
	get connectedValue(): string {
		return this._connectedValue;
	}
	get connectedOptionId(): Array<string> {
		return this._connectedOptionId;
	}
	get isActive(): boolean {
		return this._isActive;
	}
	get connectedValueList(): Array<string> {
		return this._connectedValueList;
	}
	cloneSelf() {
		return new OptionsConnectedValueDef(this._optionId, this._optionName, this._connectedValue, this._connectedOptionId, this._isActive, this._connectedValueList);
	}
}

export class DSBreakerPS {

	constructor(private _optionId: string, private _optionName: string, private _rtd_volt: string, private _dry_freq: string, private _rated_imp_volt: string, private _shrt_time_curr: string,
		private _shrt_time_curr_sec: string, private _prod_type: string, private _switch_type: string, private _vcb_curr: string, private _panel_width: string, private _rack_type: string, private _isActive: boolean) {

	}
	get optionId(): string {
		return this._optionId;
	}
	get optionName(): string {
		return this._optionName;
	}
	get rtd_volt(): string {
		return this._rtd_volt;
	}
	get dry_freq(): string {
		return this._dry_freq;
	}
	get rated_imp_volt(): string {
		return this._rated_imp_volt;
	}
	get shrt_time_curr(): string {
		return this._shrt_time_curr;
	}
	get shrt_time_curr_sec(): string {
		return this._shrt_time_curr_sec;
	}
	get prod_type(): string {
		return this._prod_type;
	}
	get switch_type(): string {
		return this._switch_type;
	}
	get vcb_curr(): string {
		return this._vcb_curr;
	}
	get panel_width(): string {
		return this._panel_width;
	}
	get rack_type(): string {
		return this._rack_type;
	}
	get isActive(): boolean {
		return this._isActive;
	}
	cloneSelf() {
		return new DSBreakerPS(this._optionId, this._optionName, this._rtd_volt, this._dry_freq, this._rated_imp_volt, this._shrt_time_curr, this._shrt_time_curr_sec, this._prod_type, this._switch_type, this._vcb_curr, this._panel_width, this._rack_type, this._isActive);
	}
}

export class DSForceCooling {

	constructor(private _optionId: string, private _optionName: string, private _bus_curr: string, private _vcb_curr: string, private _vcb_pole: string, private _amb_temp: string,
		private _main_busbar: string, private _prod_type: string, private _applic_id: string, private _no_of_fans: string, private _location_of_fans: Array<string>, private _isActive: boolean) {

	}
	get optionId(): string {
		return this._optionId;
	}
	get optionName(): string {
		return this._optionName;
	}
	get bus_curr(): string {
		return this._bus_curr;
	}
	get vcb_curr(): string {
		return this._vcb_curr;
	}
	get vcb_pole(): string {
		return this._vcb_pole;
	}
	get amb_temp(): string {
		return this._amb_temp;
	}
	get main_busbar(): string {
		return this._main_busbar;
	}
	get prod_type(): string {
		return this._prod_type;
	}
	get applic_id(): string {
		return this._applic_id;
	}
	get no_of_fans(): string {
		return this._no_of_fans;
	}
	get location_of_fans(): Array<string> {
		return this._location_of_fans;
	}
	get isActive(): boolean {
		return this._isActive;
	}
	cloneSelf() {
		return new DSForceCooling(this._optionId, this._optionName, this._bus_curr, this._vcb_curr, this._vcb_pole, this._amb_temp, this._main_busbar, this._prod_type, this._applic_id, this._no_of_fans, this._location_of_fans, this._isActive);
	}
}
export class KIOSKApplicability {
	constructor(private _kioskApplicabilityId: string, private _kioskApplicabilityName: string, private _kioskApplicabilityValue: number, private _isActive: boolean) {
	}
	get kioskApplicabilityId(): string {
		return this._kioskApplicabilityId;
	}
	get kioskApplicabilityName(): string {
		return this._kioskApplicabilityName;
	}
	get kioskApplicabilityValue(): number {
		return this._kioskApplicabilityValue;
	}
	cloneSelf() {
		return new KIOSKApplicability(this._kioskApplicabilityId, this._kioskApplicabilityName, this._kioskApplicabilityValue, this._isActive);
	}
}

export class BreakerType {
	constructor(private _breakerTypeId: string, private _breakerTypeName: string, private _breakerTypeValue: number, private _variant_ids: Array<string>, private _isActive: boolean) {
		if (_variant_ids == null) _variant_ids = [];
	}
	get breakerTypeId(): string {
		return this._breakerTypeId;
	}
	get breakerTypeName(): string {
		return this._breakerTypeName;
	}
	get breakerTypeValue(): number {
		return this._breakerTypeValue;
	}
	get variantIDs(): Array<string> {
		return this._variant_ids;
	}
	cloneSelf() {
		return new BreakerType(this._breakerTypeId, this._breakerTypeName, this._breakerTypeValue, this._variant_ids, this._isActive);
	}
}

export class ManufacturtingStrategy {
	constructor(private _manufacturtingStrategyId: string, private _manufacturtingStrategyName: string, private _manufacturtingStrategyValue: string, private _isActive: boolean) {
	}
	get manufacturtingStrategyId(): string {
		return this._manufacturtingStrategyId;
	}
	get manufacturtingStrategyName(): string {
		return this._manufacturtingStrategyName;
	}
	get manufacturtingStrategyValue(): string {
		return this._manufacturtingStrategyValue;
	}
	cloneSelf() {
		return new ManufacturtingStrategy(this._manufacturtingStrategyId, this._manufacturtingStrategyName, this._manufacturtingStrategyValue, this._isActive);
	}
}

export class PBGPayCondition {
	constructor(private _pbgPayConditionId: string, private _pbgPayConditionName: string, private _isActive: boolean) {
	}

	get pbgPayConditionId(): string {
		return this._pbgPayConditionId;
	}
	get pbgPayConditionName(): string {
		return this._pbgPayConditionName;
	}
	cloneSelf() {
		return new PBGPayCondition(this._pbgPayConditionId, this._pbgPayConditionName, this._isActive);
	}
}
export class CPBGPayCondition {
	constructor(private _cpbgPayConditionId: string, private _cpbgPayConditionName: string, private _isActive: boolean) {
	}

	get cpbgPayConditionId(): string {
		return this._cpbgPayConditionId;
	}
	get cpbgPayConditionName(): string {
		return this._cpbgPayConditionName;
	}
	cloneSelf() {
		return new CPBGPayCondition(this._cpbgPayConditionId, this._cpbgPayConditionName, this._isActive);
	}
}
export class retentionPaymentCondition {
	constructor(private _RetentionPayConditionId: string, private _retentionPayConditionName: string) {
	}

	get retentionPayConditionId(): string {
		return this._RetentionPayConditionId;
	}
	get retentionPayConditionName(): string {
		return this._retentionPayConditionName;
	}
	cloneSelf() {
		return new retentionPaymentCondition(this._RetentionPayConditionId, this._retentionPayConditionName);
	}
}

export class retentionMilestone {
	constructor(private _RetentionMilestoneId: string, private _retentionMilestoneName: string) {
	}

	get retentionMilestoneId(): string {
		return this._RetentionMilestoneId;
	}
	get retentionMilestoneName(): string {
		return this._retentionMilestoneName;
	}
	cloneSelf() {
		return new retentionMilestone(this._RetentionMilestoneId, this._retentionMilestoneName);
	}
}
export class RetentionPayment {
	constructor(private _retentionPayConditionId: string, private _retentionMilestoneId: string) {

	}
	get retentionPayCondition(): string {
		return this._retentionPayConditionId;
	}
	set retentionPayCondition(_SetVal: string) {
		this._retentionPayConditionId = _SetVal;
	}
	get retentionMilestone(): string {
		if (this.isRetentionConditionApplicable == true)
			return this._retentionMilestoneId;
		return null;
	}
	set retentionMilestone(_SetVal: string) {
		this._retentionMilestoneId = _SetVal;
	}
	public static getObj(_json: any): RetentionPayment {
		return new RetentionPayment(_json.retPayId, _json.retMstoneId)
	}
	get isRetentionConditionApplicable(): boolean {
		return (this._retentionPayConditionId != null && this._retentionPayConditionId != "NA");
	}
	public getJson(): any {
		let _json: any = {};
		_json.retPayId = this.retentionPayCondition;
		_json.retMstoneId = this.retentionMilestone;
		return _json;
	}
	cloneSelf(): RetentionPayment {
		return new RetentionPayment(this._retentionPayConditionId, this._retentionMilestoneId);
	}

}

export class OrderHandoverApproval {
	constructor(private _handoverByName: string, private _handoverById: string, private _handoverStatus: string, private _handoverDate: Date) {

	}
	get isFunctionComplete(): boolean {
		//type of equip
		if (configDefs.isStrEmty(this.handoverByName)) return false;
		if (configDefs.isStrEmty(this.handoverById)) return false;
		if (configDefs.isStrEmty(this.handoverStatus)) return false;
		if (configDefs.isDtEmty(this.handoverDate)) return false;
		return true;
	}

	get handoverByName(): string {
		return this._handoverByName;
	}
	set handoverByName(_SetVal: string) {
		this._handoverByName = _SetVal;
	}
	get handoverById(): string {
		return this._handoverById;
	}
	set handoverById(_SetVal: string) {
		this._handoverById = _SetVal;
	}
	get handoverStatus(): string {
		return this._handoverStatus;
	}
	set handoverStatus(_SetVal: string) {
		this._handoverStatus = _SetVal;
	}
	get handoverDate(): Date {
		return this._handoverDate;
	}
	set handoverDate(_SetVal: Date) {
		this._handoverDate = _SetVal;
	}

	static getObj(_json: any): OrderHandoverApproval {
		return new OrderHandoverApproval(_json.handoverByName, _json.handoverById, _json.handoverStatus, GenService.convToDate(_json.handoverDate));
	}

	static getDefaultObj(): OrderHandoverApproval {
		return new OrderHandoverApproval('', '', '', null);
	}

	public getJson(): any {
		let _json: any = {};
		_json.handoverByName = this.handoverByName;
		_json.handoverById = this.handoverById;
		_json.handoverStatus = this.handoverStatus;
		_json.handoverDate = GenService.convToDateNum(this.handoverDate);
		return _json;

	}
	cloneSelf() {
		return new OrderHandoverApproval(this.handoverByName, this.handoverById, this.handoverStatus, this.handoverDate);
	}

}
export class MarketingIP {

	constructor(private _marketingId: string, private _plantId: string, private _marketingEngineerId: string,
		private _projectManagerId: string, private _mktElectricalDesignEngineerId: string, private _mktMechanicalDesignEngineerId: string, private _saleChannelId: string, private _regionId: string, private _purchaseOrderDate: Date,
		private _customerPoValue: string, private _clearPoReceiptDate: Date, private _salesOrderNo: string, private _customerName: string,
		private _projectName: string, private _consultantName: string, private _warrantyMonthId: string,
		private _specialPoint: SpecialPoint, private _ordertypeId: string,
		private _contractDeliveryDateFirm: string, private _contractDeliveryDateInWeek: number, private _contractDeliveryDate: Date,
		private _ldApplicabilityId: string, private _ldPercent: string, private _ldCap: number, private _deliveryTerm: string,
		private _placeOfDelivery: string, private _paymentTermId: string, private _paymentDaysNo: string, private _fcmMatCost: string,
		private _fcmGm: string, private _fcmGmPercent: string, private _fcmNm: string, private _fcmNmPercent: string, private _advPaymentConditionId: string, private _advPaymentId: string,
		private _advPaymentMilestoneId: string, private _abgFormatReceivedId: string, private _pbgPaymentConditionId: string,
		private _pbgPaymentMilestoneId: string, private _pbgFormatReceivedId: string, private _cpbgPaymentConditionId: string,
		private _retentionPayment: Array<RetentionPayment>,
		private _splPriceApplicId: string, private _specialPriceFile: SpecialPriceFile,
		private _soCreationPlannedToken: PlannedDateToken, private _soReleasePlannedToken: PlannedDateToken, private _plannedOverHandingToken: PlannedDateToken,
		private _soCreationActualToken: ActualDateToken, private _soReleaseActualToken: ActualDateToken, private _actualHandingToken: ActualDateToken,
		private _marketingHandoverDetails: OrderHandoverApproval,
		private _pmHandoverDetails: OrderHandoverApproval,
		private _electricalEnggHandoverDetails: OrderHandoverApproval,
		private _mechanicalEnggHandoverDetails: OrderHandoverApproval,
		// SAP fields
		private _mktEngNameSAP: string, private _pmNameSAP: string, private _saleChnlNameSAP: string, private _regionNameSAP: string,
		private _wrntyMonNameSAP: string, private _ordertypeNameSAP: string,
		private _ldDetailsSAP: string, private _dlvryTermSAP: string, private _pymntTermNameSAP: string, private _pymntDaysNoDetailsSAP: string,
		private _advPymntDetailsSAP: string,
		private _fromSAP: boolean,
		// saleChnlName": "IN01/DT/BG",
		//     "regionName": "INFB",
		//     "custPoVal": "23300000.00",
		//     "salesOrdNo": "4203107423",
		//     "custName": "",
		//     "wrntyMonName": "024",
		//     "ordertypeName": "ZOR",
		//     "ldDetails": "",
		//     "dlvryTerm": "FOR",
		//     "placeOfDlvry": "Rampura Agucha Mines",
		//     "pymntTermName": "Y014",
		//     "pymntDaysNoDetails": "Post",
		//     "fcmMatCost": "-15423193.00",
		//     "fcmGm": "0.00",
		//     "fcmNm": "23300000.00",
		//     "advPymntDetails": "5% Advance against PO acceptance and submission of PI / Balance 95% through 60 days PDC <(>&<)> submission of PBG (of 5% order value) valid for warranty period.",
		//     "pbgPymntDetails"
		// 	 "soActCreationDate": "20250616",
		//     "soActReleaseDate": "20251219",
		//     "createdDate"
		private _status: FunctionStatus) {
	}

	private _parentSORef: SalesOrder;

	refreshStatus() {
		if (this.parentSORef) {
			if (this.parentSORef.projectStatus == SOStatus.Marketing) {
				this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
			}
			else if (this.parentSORef.projectStatus > SOStatus.Marketing) {
				let _isTempComplete: boolean = this.isFunctionComplete();

				if (_isTempComplete == true) {
					this._status = FunctionStatus.SUBMITTED_COMPLETE;
				}
				else {
					this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
				}
			}
		}
		else {
			this._status = FunctionStatus.WAITING_FOR_PREV;
		}
	}
	private isFunctionComplete(): boolean {
		if (configDefs.isStrEmty(this.plantId)) return false;
		if (configDefs.isStrEmty(this.marketingEngineerId)) return false;
		if (configDefs.isStrEmty(this.projectManagerId)) return false;
		if (configDefs.isStrEmty(this.mktElectricalDesignEngineerId)) return false;
		if (configDefs.isStrEmty(this.mktMechanicalDesignEngineerId)) return false;
		if (configDefs.isStrEmty(this.saleChannelId)) return false;
		if (configDefs.isStrEmty(this.regionId)) return false;
		if (configDefs.isDtEmty(this.purchaseOrderDate)) return false;
		if (configDefs.isStrEmty(this.customerPoValue + '')) return false;
		if (configDefs.isDtEmty(this.clearPoReceiptDate)) return false;
		if (configDefs.isStrEmty(this.salesOrderNo)) return false;
		if (configDefs.isStrEmty(this.customerName)) return false;
		if (configDefs.isStrEmty(this.projectName)) return false;
		if (configDefs.isStrEmty(this.consultantName)) return false;
		if (configDefs.isStrEmty(this.warrantyMonthId)) return false;

		//special point optional
		if (configDefs.isStrEmty(this.ordertypeId)) return false;
		if (configDefs.isStrEmty(this.contractDeliveryDateFirm)) return false;
		if (this.isContractDeliveryDateFirm) {
			if (configDefs.isDtEmty(this.contractDeliveryDate)) return false;
		}
		else {
			if (configDefs.isNumEmty(this.contractDeliveryDateInWeek)) return false;
		}
		if (configDefs.isStrEmty(this.deliveryTerm)) return false;

		if (configDefs.isStrEmty(this.ldApplicabilityId)) return false;
		if (this.isLdApplicable) {
			if (configDefs.isStrEmty(this.ldPercent)) return false;
			//if (configDefs.isNumEmty(this.ldCap)) return false;
			let _tmpLDCap: any = this.ldCap;
			if (configDefs.isStrEmty(_tmpLDCap)) return false;
		}
		if (configDefs.isStrEmty(this.placeOfDelivery)) return false;

		if (configDefs.isStrEmty(this.paymentTermId)) return false;
		//new condition-->
		if (this.isPIPaymentCondition == false) {
			if (configDefs.isStrEmty(this.paymentDaysNo)) return false;
		}

		if (configDefs.isStrEmty(this.fcmMatCost + '')) return false;
		if (configDefs.isStrEmty(this.fcmGm + '')) return false;
		if (configDefs.isStrEmty(this.fcmGmPercent + '')) return false;
		if (configDefs.isStrEmty(this.fcmNm + '')) return false;
		if (configDefs.isStrEmty(this.fcmNmPercent + '')) return false;

		if (configDefs.isStrEmty(this.advPaymentConditionId)) return false;
		//new condition-->
		// if (this.advPaymentNoCondition) {
		if (configDefs.isStrEmty(this.advPaymentId)) return false;
		if (configDefs.isStrEmty(this.advPaymentMilestoneId)) return false;


		// }
		if (this.advPaymentNoCondition == false) {
			if (configDefs.isStrEmty(this.abgFormatReceivedId)) {
				return false;
			}
		}

		if (configDefs.isStrEmty(this.pbgPaymentConditionId)) return false;
		//new--corect>
		if (this.isPBGPymtCondApplicable) {
			if (configDefs.isStrEmty(this.pbgPaymentMilestoneId)) return false;
			if (configDefs.isStrEmty(this.pbgFormatReceivedId)) return false;
		}
		if (configDefs.isStrEmty(this.cpbgPaymentConditionId)) return false;
		//new-->
		for (var i = 0; i < this.retentionPayment.length; i++) {
			if (configDefs.isStrEmty(this.retentionPayment[i].retentionPayCondition)) {
				return false;
			}
			if (this.retentionPayment[i].isRetentionConditionApplicable) {
				if ((configDefs.isStrEmty(this.retentionPayment[i].retentionMilestone))) return false;
			}
		}

		if (configDefs.isStrEmty(this.splPriceApplicId)) return false;
		if (this.isSplPriceApplicable) {
			if (this.specialPriceFile.FileArray.length == 0) return false;
		}
		if (configDefs.isDtEmty(this.soCreationDatePlanned)) return false;
		if (configDefs.isDtEmty(this.soReleaseDatePlanned)) return false;
		if (configDefs.isDtEmty(this.plannedOverHandingDate)) return false;

		if (configDefs.isDtEmty(this.soCreationDateActual)) return false;
		if (configDefs.isDtEmty(this.soReleaseDateActual)) return false;
		if (configDefs.isDtEmty(this.actualHandingOverDate)) return false;
		return true;
	}
	get parentSORef(): SalesOrder {
		return this._parentSORef;
	}
	set parentSORef(SORef: SalesOrder) {
		this._parentSORef = SORef;
		//this.refreshStatus();
	}
	get marketingId(): string {
		return this._marketingId;
	}
	set marketingId(_SetVal: string) {
		this._marketingId = _SetVal;
	}
	get plantId(): string {
		return this._plantId;
	}
	set plantId(_SetVal: string) {
		this._plantId = _SetVal;
	}
	get marketingEngineerId(): string {
		return this._marketingEngineerId;
	}
	set marketingEngineerId(_SetVal: string) {
		this._marketingEngineerId = _SetVal;
	}
	get projectManagerId(): string {
		return this._projectManagerId;
	}
	set projectManagerId(_SetVal: string) {
		this._projectManagerId = _SetVal;
	}
	get mktElectricalDesignEngineerId(): string {
		return this._mktElectricalDesignEngineerId;
	}
	set mktElectricalDesignEngineerId(_SetVal: string) {
		this._mktElectricalDesignEngineerId = _SetVal;
	}
	get mktMechanicalDesignEngineerId(): string {
		return this._mktMechanicalDesignEngineerId;
	}
	set mktMechanicalDesignEngineerId(_SetVal: string) {
		this._mktMechanicalDesignEngineerId = _SetVal;
	}
	get saleChannelId(): string {
		return this._saleChannelId;
	}
	set saleChannelId(_SetVal: string) {
		this._saleChannelId = _SetVal;
	}
	get regionId(): string {
		return this._regionId;
	}
	set regionId(_SetVal: string) {
		this._regionId = _SetVal;
	}
	get ordertypeId(): string {
		return this._ordertypeId;
	}
	set ordertypeId(_setVal: string) {
		this._ordertypeId = _setVal;
	}
	get purchaseOrderDate(): Date {
		return this._purchaseOrderDate;
	}
	set purchaseOrderDate(_SetVal: Date) {
		this._purchaseOrderDate = _SetVal;
	}
	get customerPoValue(): string {
		return this._customerPoValue;
	}
	set customerPoValue(_SetVal: string) {
		this._customerPoValue = _SetVal;
	}
	get clearPoReceiptDate(): Date {
		return this._clearPoReceiptDate;
	}
	set clearPoReceiptDate(_SetVal: Date) {
		this._clearPoReceiptDate = _SetVal;
		//console.log("check for clear date",this.clearPoReceiptDate);
	}
	get salesOrderNo(): string {
		return this._salesOrderNo;
	}
	set salesOrderNo(_SetVal: string) {
		this._salesOrderNo = _SetVal;
	}
	get isSalesOrderNoValid(): boolean {
		if (this._salesOrderNo &&
			(configDefs.isNumEmty(parseInt(this._salesOrderNo, 10)) == false) &&
			(this._salesOrderNo + '').length == 10) {
			return true;
		}
		return false;
	}
	get isSalesOrderNoEntered(): boolean {
		if (this.salesOrderNo && this.salesOrderNo != '') return true;
		return false;
	}

	get customerName(): string {
		return this._customerName;
	}
	set customerName(_SetVal: string) {
		this._customerName = _SetVal;
	}
	get projectName(): string {
		return this._projectName;
	}
	set projectName(_SetVal: string) {
		this._projectName = _SetVal;
	}
	get consultantName(): string {
		return this._consultantName;
	}
	set consultantName(_SetVal: string) {
		this._consultantName = _SetVal;
	}
	get warrantyMonthId(): string {
		return this._warrantyMonthId;
	}
	set warrantyMonthId(_SetVal: string) {
		this._warrantyMonthId = _SetVal;
	}
	get specialPoint(): SpecialPoint {
		return this._specialPoint;
	}
	set specialPoint(_SetVal: SpecialPoint) {
		this._specialPoint = _SetVal;
	}
	get contractDeliveryDateFirm(): string {
		return this._contractDeliveryDateFirm;
	}
	get isContractDeliveryDateFirm(): boolean {
		return this._contractDeliveryDateFirm == configDefs.defYesKeyId;
	}
	set contractDeliveryDateFirm(_SetVal: string) {
		this._contractDeliveryDateFirm = _SetVal;
	}
	get contractDeliveryDateInWeek(): number {
		if (this.isContractDeliveryDateFirm == false)
			return this._contractDeliveryDateInWeek;
		return null;
	}
	set contractDeliveryDateInWeek(_SetVal: number) {
		this._contractDeliveryDateInWeek = _SetVal;
	}
	get contractDeliveryDateLabel(): string {
		if (this.isContractDeliveryDateFirm == true) {
			return "Firm Delivery Date";
		}
		else {
			return "Final Contractual Delivery Date";
		}
	}
	get contractDeliveryDate(): Date {
		if (this.isContractDeliveryDateFirm == true) {
			return this._contractDeliveryDate;
		}
		else {
			return this.parentSORef.lastContractualDate;
		}
	}
	set contractDeliveryDate(_SetVal: Date) {
		if (this.isContractDeliveryDateFirm == true) {
			this._contractDeliveryDate = _SetVal;
		}
	}
	get ldApplicabilityId(): string {
		return this._ldApplicabilityId;
	}
	set ldApplicabilityId(_SetVal: string) {
		this._ldApplicabilityId = _SetVal;
	}
	get isLdApplicable(): boolean {
		return this._ldApplicabilityId == configDefs.defYesKeyId;
	}
	get ldPercent(): string {
		if (this.isLdApplicable == true)
			return this._ldPercent;
		return null;
	}
	set ldPercent(_SetVal: string) {
		this._ldPercent = _SetVal;
	}
	get ldCap(): number {
		if (this.isLdApplicable == true)
			return this._ldCap;
		return null;
	}
	set ldCap(_SetVal: number) {
		this._ldCap = _SetVal;
	}
	get deliveryTerm(): string {
		return this._deliveryTerm;
	}
	set deliveryTerm(_SetVal: string) {
		this._deliveryTerm = _SetVal;
	}
	get placeOfDelivery(): string {
		return this._placeOfDelivery;
	}
	set placeOfDelivery(_SetVal: string) {
		this._placeOfDelivery = _SetVal;
	}
	get paymentTermId(): string {
		return this._paymentTermId;
	}
	set paymentTermId(_SetVal: string) {
		this._paymentTermId = _SetVal;
	}
	get isPIPaymentCondition(): boolean {
		return this.paymentTermId == 'pi';
	}
	get paymentDaysNo(): string {
		if (this.isPIPaymentCondition) {
			return null;
		}
		return this._paymentDaysNo;
	}
	set paymentDaysNo(_SetVal: string) {
		this._paymentDaysNo = _SetVal;
	}
	get fcmMatCost(): string {
		return this._fcmMatCost;
	}
	set fcmMatCost(_SetVal: string) {
		this._fcmMatCost = _SetVal;
	}
	private _fcmGmGroup: SplitNumber;
	get fcmGmGroup(): SplitNumber {
		if (this._fcmGmGroup == null ||
			this._fcmGmGroup.number1 != this.fcmGm ||
			this._fcmGmGroup.number2 != this.fcmGmPercent) {
			this._fcmGmGroup = new SplitNumber(this.fcmGm, 'MINR', this.fcmGmPercent, '%');
		}
		return this._fcmGmGroup;
	}
	private _fcmNmGroup: SplitNumber;
	get fcmNmGroup(): SplitNumber {
		if (this._fcmNmGroup == null ||
			this._fcmNmGroup.number1 != this.fcmNm ||
			this._fcmNmGroup.number2 != this.fcmNmPercent) {
			this._fcmNmGroup = new SplitNumber(this.fcmNm, 'MINR', this.fcmNmPercent, '%');
		}
		return this._fcmNmGroup;
	}
	get fcmGm(): string {
		return this._fcmGm;
	}
	set fcmGm(_SetVal: string) {
		this._fcmGm = _SetVal;
	}
	get fcmGmPercent(): string {
		return this._fcmGmPercent;
	}
	set fcmGmPercent(_SetVal: string) {
		this._fcmGmPercent = _SetVal;
	}
	get fcmNm(): string {
		return this._fcmNm;
	}
	set fcmNm(_SetVal: string) {
		this._fcmNm = _SetVal;
	}
	get fcmNmPercent(): string {
		return this._fcmNmPercent;
	}
	set fcmNmPercent(_SetVal: string) {
		this._fcmNmPercent = _SetVal;
	}
	get advPaymentConditionId(): string {
		return this._advPaymentConditionId;
	}
	get advPaymentNoCondition(): boolean {
		return (this._advPaymentConditionId == null || this._advPaymentConditionId == '000');
	}
	set advPaymentConditionId(_SetVal: string) {
		this._advPaymentConditionId = _SetVal;
	}
	get advPaymentId(): string {
		//if (this.advPaymentNoCondition == false)
		return this._advPaymentId;
		//return null;
	}
	set advPaymentId(_SetVal: string) {
		this._advPaymentId = _SetVal;
	}
	get advPaymentMilestoneId(): string {
		//if (this.advPaymentNoCondition == false)
		return this._advPaymentMilestoneId;
		//return null;
	}
	set advPaymentMilestoneId(_SetVal: string) {
		this._advPaymentMilestoneId = _SetVal;
	}
	get abgFormatReceivedId(): string {
		if (this.advPaymentNoCondition == false) {
			return this._abgFormatReceivedId;
		}
		return null;
	}
	set abgFormatReceivedId(_SetVal: string) {
		this._abgFormatReceivedId = _SetVal;
	}
	get pbgPaymentConditionId(): string {
		return this._pbgPaymentConditionId;
	}
	get isPBGPymtCondApplicable(): boolean {
		return (this._pbgPaymentConditionId != null && this._pbgPaymentConditionId != "000");
	}
	get pbgPaymentMilestoneId(): string {
		if (this.isPBGPymtCondApplicable == true)
			return this._pbgPaymentMilestoneId;
		return null;
	}
	set pbgPaymentMilestoneId(_SetVal: string) {
		this._pbgPaymentMilestoneId = _SetVal;
	}
	get pbgFormatReceivedId(): string {
		if (this.isPBGPymtCondApplicable == true) {
			return this._pbgFormatReceivedId;
		}
		return null;
	}
	set pbgFormatReceivedId(_SetVal: string) {
		this._pbgFormatReceivedId = _SetVal;
	}
	set pbgPaymentConditionId(_SetVal: string) {
		this._pbgPaymentConditionId = _SetVal;
	}
	get cpbgPaymentConditionId(): string {
		return this._cpbgPaymentConditionId;
	}
	get isCPBGPymtCondApplicable(): boolean {
		return (this._cpbgPaymentConditionId != null && this._cpbgPaymentConditionId != "000");
	}
	set cpbgPaymentConditionId(_SetVal: string) {
		this._cpbgPaymentConditionId = _SetVal;
	}
	get retentionPayment(): Array<RetentionPayment> {
		return this._retentionPayment;
	}
	set retentionPayment(_SetVal: Array<RetentionPayment>) {
		this._retentionPayment = _SetVal;
	}
	get isRetentionConditionEnabled(): boolean {
		let _retVal: boolean = false;
		for (var i = 0; i < this.retentionPayment.length; i++) {
			if (this.retentionPayment[i].isRetentionConditionApplicable == true) {
				_retVal = true;
				break;
			}
		}
		return _retVal;
	}
	addPaymentCond(_newCond: RetentionPayment) {
		this._retentionPayment.push(_newCond);

	}
	removePaymentCond(_remCondi: RetentionPayment) {
		let index: number = this._retentionPayment.indexOf(_remCondi);
		if (index >= 0) {
			this._retentionPayment.splice(index, 1);
		}
	}

	get splPriceApplicId(): string {
		return this._splPriceApplicId;
	}
	set splPriceApplicId(_SetVal: string) {
		this._splPriceApplicId = _SetVal;
	}
	get isSplPriceApplicable(): boolean {
		return this._splPriceApplicId == configDefs.defYesKeyId;
	}
	get specialPriceFile(): SpecialPriceFile {
		return this._specialPriceFile;
	}
	set specialPriceFile(_SetVal: SpecialPriceFile) {
		this._specialPriceFile = _SetVal;
	}

	get soCreationPlannedToken(): PlannedDateToken {
		return this._soCreationPlannedToken;
	}

	set soCreationPlannedToken(_SetVal: PlannedDateToken) {
		if (this._soCreationPlannedToken.actualPlannedDate == null)
			this._soCreationPlannedToken.actualPlannedDate = this.soCreationDatePlanned;
		this._soCreationPlannedToken.plannedDate = _SetVal.plannedDate;
		this._soCreationPlannedToken.isOveridden = _SetVal.isOveridden;
		this._soCreationPlannedToken.addNotes = _SetVal.addNotes;
		this._soCreationPlannedToken.userOveridden = _SetVal.userOveridden;
	}
	get soCreationDatePlanned(): Date {
		if (this._soCreationPlannedToken.plannedDate == null || this._soCreationPlannedToken.isOveridden == false) {
			var _tmpDate = this.clearPoReceiptDate;
			if (_tmpDate != null && configDefs.defSOCreationDays) {
				this._soCreationPlannedToken.plannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defSOCreationDays);
			}
			else {
				this._soCreationPlannedToken.plannedDate = null;
			}
		}
		return this._soCreationPlannedToken.plannedDate;
	}
	set soCreationDatePlanned(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set soCreationDatePlanned directly");
		this._soCreationPlannedToken.plannedDate = _SetVal;
	}
	get soReleasePlannedToken(): PlannedDateToken {
		return this._soReleasePlannedToken;
	}
	set soReleasePlannedToken(_SetVal: PlannedDateToken) {
		if (this._soReleasePlannedToken.actualPlannedDate == null)
			this._soReleasePlannedToken.actualPlannedDate = this.soReleaseDatePlanned;
		this._soReleasePlannedToken.plannedDate = _SetVal.plannedDate;
		this._soReleasePlannedToken.isOveridden = _SetVal.isOveridden;
		this._soReleasePlannedToken.addNotes = _SetVal.addNotes;
		this._soReleasePlannedToken.userOveridden = _SetVal.userOveridden;
	}
	get soReleaseDatePlanned(): Date {
		if (this._soReleasePlannedToken.plannedDate == null || this._soReleasePlannedToken.isOveridden == false) {
			var _tmpDate = this.clearPoReceiptDate;
			if (_tmpDate != null && configDefs.defSOReleaseDays) {
				this._soReleasePlannedToken.plannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defSOReleaseDays);
			}
			else {
				this._soReleasePlannedToken.plannedDate = null;
			}
		}
		return this._soReleasePlannedToken.plannedDate;
	}
	set soReleaseDatePlanned(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set soReleaseDatePlanned directly");
		this._soReleasePlannedToken.plannedDate = _SetVal;
	}
	get plannedOverHandingToken(): PlannedDateToken {
		return this._plannedOverHandingToken;
	}
	set plannedOverHandingToken(_SetVal: PlannedDateToken) {
		//_plannedOverHandingToken
		if (this._plannedOverHandingToken.actualPlannedDate == null)
			this._plannedOverHandingToken.actualPlannedDate = this.plannedOverHandingDate;
		this._plannedOverHandingToken.plannedDate = _SetVal.plannedDate;
		this._plannedOverHandingToken.isOveridden = _SetVal.isOveridden;
		this._plannedOverHandingToken.addNotes = _SetVal.addNotes;
		this._plannedOverHandingToken.userOveridden = _SetVal.userOveridden;
	}
	get plannedOverHandingDate(): Date {
		if (this._plannedOverHandingToken.plannedDate == null || this._plannedOverHandingToken.isOveridden == false) {
			var _tmpDate = this.clearPoReceiptDate;
			if (_tmpDate != null && configDefs.defPlndOrdrHandidODDays) {
				this._plannedOverHandingToken.plannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndOrdrHandidODDays);
			}
			else {
				this._plannedOverHandingToken.plannedDate = null;
			}
		}
		return this._plannedOverHandingToken.plannedDate;
	}
	set plannedOverHandingDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set plannedOverHandingDate directly");
		this._plannedOverHandingToken.plannedDate = _SetVal;
	}
	get soCreationActualToken(): ActualDateToken {
		return this._soCreationActualToken;
	}
	set soCreationActualToken(_SetVal: ActualDateToken) {
		if (this._soCreationActualToken.expActualDate == null)
			this._soCreationActualToken.expActualDate = this.soCreationDatePlanned;
		this._soCreationActualToken.actualDate = _SetVal.actualDate;
		this._soCreationActualToken.isOveridden = _SetVal.isOveridden;
		this._soCreationActualToken.addNotes = _SetVal.addNotes;
		this._soCreationActualToken.userOveridden = _SetVal.userOveridden;
	}
	get soCreationDateActual(): Date {
		return this._soCreationActualToken.actualDate;
	}
	set soCreationDateActual(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set soCreationDateActual directly");
		this._soCreationActualToken.actualDate = _SetVal;
	}
	get soReleaseActualToken(): ActualDateToken {
		return this._soReleaseActualToken;
	}
	set soReleaseActualToken(_SetVal: ActualDateToken) {
		if (this._soReleaseActualToken.expActualDate == null)
			this._soReleaseActualToken.expActualDate = this.soReleaseDatePlanned;
		this._soReleaseActualToken.actualDate = _SetVal.actualDate;
		this._soReleaseActualToken.isOveridden = _SetVal.isOveridden;
		this._soReleaseActualToken.addNotes = _SetVal.addNotes;
		this._soReleaseActualToken.userOveridden = _SetVal.userOveridden;
	}
	get soReleaseDateActual(): Date {
		return this._soReleaseActualToken.actualDate;
	}
	set soReleaseDateActual(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set soReleaseDateActual directly");
		this._soReleaseActualToken.actualDate = _SetVal;
	}
	get actualHandingOverToken(): ActualDateToken {
		return this._actualHandingToken;
	}
	set actualHandingOverToken(_SetVal: ActualDateToken) {
		if (this._actualHandingToken.expActualDate == null)
			this._actualHandingToken.expActualDate = this.plannedOverHandingDate;
		this._actualHandingToken.actualDate = _SetVal.actualDate;
		this._actualHandingToken.isOveridden = _SetVal.isOveridden;
		this._actualHandingToken.addNotes = _SetVal.addNotes;
		this._actualHandingToken.userOveridden = _SetVal.userOveridden;
	}
	get actualHandingOverDate(): Date {
		return this._actualHandingToken.actualDate;
	}
	set actualHandingOverDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set actualHandingOverDate directly");
		this._actualHandingToken.actualDate = _SetVal;
	}
	get marketingHandoverDetails(): OrderHandoverApproval {
		return this._marketingHandoverDetails;
	}
	set marketingHandoverDetails(_SetVal: OrderHandoverApproval) {
		this._marketingHandoverDetails = _SetVal;
	}
	get pmHandoverDetails(): OrderHandoverApproval {
		return this._pmHandoverDetails;
	}
	set pmHandoverDetails(_SetVal: OrderHandoverApproval) {
		this._pmHandoverDetails = _SetVal;
	}
	get electricalEnggHandoverDetails(): OrderHandoverApproval {
		return this._electricalEnggHandoverDetails;
	}
	set electricalEnggHandoverDetails(_SetVal: OrderHandoverApproval) {
		this._electricalEnggHandoverDetails = _SetVal;
	}
	get mechanicalEnggHandoverDetails(): OrderHandoverApproval {
		return this._mechanicalEnggHandoverDetails;
	}
	set mechanicalEnggHandoverDetails(_SetVal: OrderHandoverApproval) {
		this._mechanicalEnggHandoverDetails = _SetVal;
	}
	//#region SAP Fields
	get mktEngNameSAP(): string {
		return this._mktEngNameSAP;
	}
	set mktEngNameSAP(_SetVal: string) {
		this._mktEngNameSAP = _SetVal;
	}
	get pmNameSAP(): string {
		return this._pmNameSAP;
	}
	set pmNameSAP(_SetVal: string) {
		this._pmNameSAP = _SetVal;
	}
	get saleChnlNameSAP(): string {
		return this._saleChnlNameSAP;
	}
	set saleChnlNameSAP(_SetVal: string) {
		this._saleChnlNameSAP = _SetVal;
	}
	get regionNameSAP(): string {
		return this._regionNameSAP;
	}
	set regionNameSAP(_SetVal: string) {
		this._regionNameSAP = _SetVal;
	}
	get wrntyMonNameSAP(): string {
		return this._wrntyMonNameSAP;
	}
	set wrntyMonNameSAP(_SetVal: string) {
		this._wrntyMonNameSAP = _SetVal;
	}
	get ordertypeNameSAP(): string {
		return this._ordertypeNameSAP;
	}
	set ordertypeNameSAP(_SetVal: string) {
		this._ordertypeNameSAP = _SetVal;
	}
	get ldDetailsSAP(): string {
		return this._ldDetailsSAP;
	}
	set ldDetailsSAP(_SetVal: string) {
		this._ldDetailsSAP = _SetVal;
	}
	get dlvryTermSAP(): string {
		return this._dlvryTermSAP;
	}
	set dlvryTermSAP(_SetVal: string) {
		this._dlvryTermSAP = _SetVal;
	}
	get pymntTermNameSAP(): string {
		return this._pymntTermNameSAP;
	}
	set pymntTermNameSAP(_SetVal: string) {
		this._pymntTermNameSAP = _SetVal;
	}
	get pymntDaysNoDetailsSAP(): string {
		return this._pymntDaysNoDetailsSAP;
	}
	set pymntDaysNoDetailsSAP(_SetVal: string) {
		this._pymntDaysNoDetailsSAP = _SetVal;
	}
	get advPymntDetailsSAP(): string {
		return this._advPymntDetailsSAP;
	}
	set advPymntDetailsSAP(_SetVal: string) {
		this._advPymntDetailsSAP = _SetVal;
	}
	get fromSAP(): boolean {
		return this._fromSAP;
	}
	set fromSAP(_SetVal: boolean) {
		this._fromSAP = _SetVal;
	}
	//#endregion SAP Fields
	get isSubmittedFwd(): boolean {
		return this.parentSORef.projectStatus > SOStatus.Marketing;
	}
	get readyForPMComercial(): boolean {
		if (this.actualHandingOverDate && this.salesOrderNo && this.salesOrderNo != '' && this.clearPoReceiptDate
			&& this.isSplPriceConditionFulfilled && this.contractDeliveryDateFirm && this.deliveryTerm && this.regionId) {
			if (this.isContractDeliveryDateFirm == false && this.contractDeliveryDateInWeek) {
				return true;
			}
			else {
				if (this.isContractDeliveryDateFirm == true && !this.contractDeliveryDateInWeek && this.contractDeliveryDate) {
					return true;
				}
			}
		}

		return false;
	}
	get isSplPriceConditionFulfilled(): boolean {
		if (!this.isSplPriceApplicable || this.specialPriceFile.FileArray.length > 0) {
			return true;
		}
		return false;
	}
	get marketingDays(): number {
		let _tmpPlannedDate: Date = this.plannedOverHandingDate;
		let _tmpActualDate: Date = this.actualHandingOverDate;
		if (_tmpPlannedDate && _tmpActualDate) {
			return configDefs.getDaysDifference(_tmpPlannedDate, _tmpActualDate);
		}
		return null;
	}

	// START
	get homDate(): string {
		let _tmpPlannedDate: Date = this.actualHandingOverDate;
		if (_tmpPlannedDate != null) {
			return formatDate(_tmpPlannedDate, 'dd-MMM-yy', 'en-IN');
		}
		return null;
	}




	//END
	get marketingDaysTooltip(): string {
		let _tmpPlannedDate: Date = this.plannedOverHandingDate;
		let _tmpActualDate: Date = this.actualHandingOverDate;
		if (_tmpPlannedDate && _tmpActualDate) {
			return 'Order HandingOver Date : \r\n' +
				'\tPlanned\t> ' + moment(_tmpPlannedDate).format(configDefs.dateFormat) + '\r\n' +
				'\tActual\t> ' + moment(_tmpActualDate).format(configDefs.dateFormat);
		}
		return '';
	}
	get lastDispatchPlannedFromPlant(): Date {
		return this.parentSORef.lastDispatchPlannedFromPlant;
	}

	get lastDrawingApprovalDate(): Date {
		let _lastActDate: Date = this.parentSORef.lastDrawingApprovalActualDate;

		if (_lastActDate) {
			return _lastActDate;
		}
		return this.lastDrawingApprovalPlannedDate;
	}

	get lastDrawingApprovalPlannedDate(): Date {
		return this.parentSORef.lastDrawingApprovalPlannedDate;
	}
	get status(): FunctionStatus {
		return this._status;
	}
	cloneSelf() {
		let _RetPayCon: RetentionPayment[] = [];
		if (this.retentionPayment) {
			for (var i = 0; i < this.retentionPayment.length; i++) {
				_RetPayCon.push(this.retentionPayment[i].cloneSelf());
			}
		}
		else {
			_RetPayCon.push(new RetentionPayment(null, null));
		}

		return new MarketingIP(this._marketingId, this._plantId, this._marketingEngineerId, this._projectManagerId, this._mktElectricalDesignEngineerId, this._mktMechanicalDesignEngineerId,
			this._saleChannelId, this._regionId, this._purchaseOrderDate, this._customerPoValue, this._clearPoReceiptDate,
			this._salesOrderNo, this._customerName, this._projectName, this._consultantName, this._warrantyMonthId, this._specialPoint.cloneSelf(), this._ordertypeId,
			this._contractDeliveryDateFirm, this._contractDeliveryDateInWeek, this._contractDeliveryDate, this._ldApplicabilityId,
			this._ldPercent, this._ldCap, this._deliveryTerm, this._placeOfDelivery, this._paymentTermId, this._paymentDaysNo,
			this._fcmMatCost, this._fcmGm, this._fcmGmPercent, this._fcmNm, this._fcmNmPercent, this._advPaymentConditionId, this._advPaymentId, this._advPaymentMilestoneId, this._abgFormatReceivedId,
			this._pbgPaymentConditionId, this._pbgPaymentMilestoneId, this._pbgFormatReceivedId, this._cpbgPaymentConditionId, _RetPayCon,
			this._splPriceApplicId, this._specialPriceFile.cloneSelf(),
			this._soCreationPlannedToken.cloneSelf(), this._soReleasePlannedToken.cloneSelf(),
			this._plannedOverHandingToken, this._soCreationActualToken, this._soReleaseActualToken, this._actualHandingToken.cloneSelf(),
			this._marketingHandoverDetails.cloneSelf(), this._pmHandoverDetails.cloneSelf(), this._electricalEnggHandoverDetails.cloneSelf(), this._mechanicalEnggHandoverDetails.cloneSelf(),
			this._mktEngNameSAP, this._pmNameSAP, this._saleChnlNameSAP, this._regionNameSAP, this._wrntyMonNameSAP,
			this._ordertypeNameSAP, this._ldDetailsSAP, this._dlvryTermSAP, this._pymntTermNameSAP, this._pymntDaysNoDetailsSAP,
			this._advPymntDetailsSAP, this._fromSAP,
			this._status);
	}

	public static getObj(_json: any): MarketingIP {
		let _marObj: any = _json;
		let _retelist: Array<RetentionPayment> = [];
		if (_json.retention) {
			for (var i = 0; i < _json.retention.length; i++) {
				_retelist.push(RetentionPayment.getObj(_json.retention[i]));
			}
		}
		else {
			_retelist.push(new RetentionPayment(null, null));
		}

		let _marketingIp: MarketingIP = new MarketingIP(_marObj.mktId, _marObj.plantId, _marObj.mktEngId, _marObj.pmId, _marObj.mktElecEngId, _marObj.mktMechEngId,
			_marObj.saleChnlId, _marObj.regionId, GenService.convToDate(_marObj.poDate), _marObj.custPoVal,
			GenService.convToDate(_marObj.clearPoReceiptDate), _marObj.salesOrdNo, _marObj.custName, _marObj.projName,
			_marObj.consultantName, _marObj.wrntyMonId, SpecialPoint.getObj(_marObj.specialPoint), _marObj.ordertypeId, _marObj.contractDlvryDateFirm,
			_marObj.contractDlvryDateInWeek, GenService.convToDate(_marObj.contractDlvryDate), _marObj.ldApplicability, _marObj.ldPer, _marObj.ldCap,
			_marObj.dlvryTerm, _marObj.placeOfDlvry, _marObj.pymntTermId, _marObj.pymntDaysNo, _marObj.fcmMatCost, _marObj.fcmGm, _marObj.fcmGmPercent,
			_marObj.fcmNm, _marObj.fcmNmPercent, _marObj.advPymntCondId, _marObj.advPymntId, _marObj.advPymntMilestoneId, _marObj.abgFormatReceivedId, _marObj.pbgPymntCondId, _marObj.pbgPymntMilestoneId,
			_marObj.pbgFormatReceivedId, _marObj.cpbgPymntCondId, _retelist,
			_marObj.splPrcApplicId, SpecialPriceFile.getObj(_marObj.splPrcFileToken),
			convDefs.convToPlannedDateToken(_marObj.soCreationPlanToken), convDefs.convToPlannedDateToken(_marObj.soReleasePlanToken),
			convDefs.convToPlannedDateToken(_marObj.planHandlingToken), convDefs.convToActualDateToken(_marObj.soActCreationToken),
			convDefs.convToActualDateToken(_marObj.soActReleaseToken), convDefs.convToActualDateToken(_marObj.actHandingOverToken),
			_marObj.marketingHandoverDetails ? OrderHandoverApproval.getObj(_marObj.marketingHandoverDetails) : OrderHandoverApproval.getDefaultObj(),
			_marObj.pmHandoverDetails ? OrderHandoverApproval.getObj(_marObj.pmHandoverDetails) : OrderHandoverApproval.getDefaultObj(),
			_marObj.electricalEnggHandoverDetails ? OrderHandoverApproval.getObj(_marObj.electricalEnggHandoverDetails) : OrderHandoverApproval.getDefaultObj(),
			_marObj.mechanicalEnggHandoverDetails ? OrderHandoverApproval.getObj(_marObj.mechanicalEnggHandoverDetails) : OrderHandoverApproval.getDefaultObj(),
			_marObj.mktEngNameSAP, _marObj.pmNameSAP, _marObj.saleChnlNameSAP, _marObj.regionNameSAP, _marObj.wrntyMonNameSAP,
			_marObj.ordertypeNameSAP, _marObj.ldDetailsSAP, _marObj.dlvryTermSAP, _marObj.pymntTermNameSAP, _marObj.pymntDaysNoDetailsSAP,
			_marObj.advPymntDetailsSAP, _marObj.fromSAP,
			_marObj.status);

		return _marketingIp;
	}

	public getJson(): any {
		let _json: any = {};

		_json.mktId = this.marketingId;
		_json.plantId = this.plantId;
		_json.mktEngId = this.marketingEngineerId;
		_json.pmId = this.projectManagerId;
		_json.mktElecEngId = this.mktElectricalDesignEngineerId ? this.mktElectricalDesignEngineerId : '';
		_json.mktMechEngId = this.mktMechanicalDesignEngineerId ? this.mktMechanicalDesignEngineerId : '';
		_json.saleChnlId = this.saleChannelId;
		_json.regionId = this.regionId;
		_json.poDate = GenService.convToDateNum(this.purchaseOrderDate);
		_json.custPoVal = this.customerPoValue;
		_json.clearPoReceiptDate = GenService.convToDateNum(this.clearPoReceiptDate);
		_json.salesOrdNo = this.salesOrderNo;
		_json.custName = this.customerName;
		_json.projName = this.projectName;
		_json.consultantName = this.consultantName;
		_json.wrntyMonId = this.warrantyMonthId;
		_json.specialPoint = this.specialPoint.getJson();
		_json.ordertypeId = this.ordertypeId;
		_json.contractDlvryDateFirm = this.contractDeliveryDateFirm;
		_json.contractDlvryDateInWeek = this.contractDeliveryDateInWeek;
		_json.contractDlvryDate = GenService.convToDateNum(this.contractDeliveryDate);
		_json.ldApplicability = this.ldApplicabilityId;
		_json.ldPer = this.ldPercent;
		_json.ldCap = this.ldCap;
		_json.dlvryTerm = this.deliveryTerm;
		_json.placeOfDlvry = this.placeOfDelivery;
		_json.pymntTermId = this.paymentTermId;
		_json.pymntDaysNo = this.paymentDaysNo;
		_json.fcmMatCost = this.fcmMatCost;
		_json.fcmGm = this.fcmGm;
		_json.fcmGmPercent = this.fcmGmPercent;
		_json.fcmNm = this.fcmNm;
		_json.fcmNmPercent = this.fcmNmPercent;
		_json.advPymntCondId = this.advPaymentConditionId;
		_json.advPymntId = this.advPaymentId;
		_json.advPymntMilestoneId = this.advPaymentMilestoneId;
		_json.abgFormatReceivedId = this.abgFormatReceivedId;
		_json.pbgPymntCondId = this.pbgPaymentConditionId;
		_json.pbgPymntMilestoneId = this.pbgPaymentMilestoneId;
		_json.pbgFormatReceivedId = this.pbgFormatReceivedId;
		_json.cpbgPymntCondId = this.cpbgPaymentConditionId;
		_json.retention = [];
		_json.splPrcApplicId = this._splPriceApplicId;
		_json.splPrcFileToken = (this.specialPriceFile ? this.specialPriceFile.getJson() : null);
		_json.soCreationPlanToken = this.soCreationPlannedToken.getJson();
		_json.soReleasePlanToken = this.soReleasePlannedToken.getJson();
		_json.planHandlingToken = this.plannedOverHandingToken.getJson();
		_json.soActCreationToken = this.soCreationActualToken.getJson();
		_json.soActReleaseToken = this.soReleaseActualToken.getJson();
		_json.actHandingOverToken = this.actualHandingOverToken.getJson();
		_json.marketingHandoverDetails = (this.marketingHandoverDetails ? this.marketingHandoverDetails.getJson() : null);
		_json.pmHandoverDetails = (this.pmHandoverDetails ? this.pmHandoverDetails.getJson() : null);
		_json.electricalEnggHandoverDetails = (this.electricalEnggHandoverDetails ? this.electricalEnggHandoverDetails.getJson() : null);
		_json.mechanicalEnggHandoverDetails = (this.mechanicalEnggHandoverDetails ? this.mechanicalEnggHandoverDetails.getJson() : null);
		_json.mktEngNameSAP = this.mktEngNameSAP ? this.mktEngNameSAP : '';
		_json.pmNameSAP = this.pmNameSAP ? this.pmNameSAP : '';
		_json.saleChnlNameSAP = this.saleChnlNameSAP ? this.saleChnlNameSAP : '';
		_json.regionNameSAP = this.regionNameSAP ? this.regionNameSAP : '';
		_json.wrntyMonNameSAP = this.wrntyMonNameSAP ? this.wrntyMonNameSAP : '';
		_json.ordertypeNameSAP = this.ordertypeNameSAP ? this.ordertypeNameSAP : '';
		_json.ldDetailsSAP = this.ldDetailsSAP ? this.ldDetailsSAP : '';
		_json.dlvryTermSAP = this.dlvryTermSAP ? this.dlvryTermSAP : '';
		_json.pymntTermNameSAP = this.pymntTermNameSAP ? this.pymntTermNameSAP : '';
		_json.pymntDaysNoDetailsSAP = this.pymntDaysNoDetailsSAP ? this.pymntDaysNoDetailsSAP : '';
		_json.advPymntDetailsSAP = this.advPymntDetailsSAP ? this.advPymntDetailsSAP : '';
		_json.status = this.status;
		for (var i = 0; i < this._retentionPayment.length; i++) {
			_json.retention.push(this._retentionPayment[i].getJson());
		}



		return _json;
	}
}

export class PmCommercialIP {

	constructor(private _projectEngineerId: string, private _poAmendment: string, private _poAmendmentValue: string, private _retentionDetailsSubmission: string, private _actDateforRetrentionDetailsSubm: Date,
		private _abgOrAcgSubmissionDetails: string, private _abgUploads: GenFileUploads, private _abgOrAcgPlndSubToken: PlannedDateToken, private _abgOrAcgActSubToken: ActualDateToken,
		private _abgOrAcgPlndCollToken: PlannedDateToken, private _abgOrAcgActCollToken: ActualDateToken,
		private _pbgSubmissionDetails: string, private _pbgUploads: GenFileUploads,
		private _pbgPlndSubToken: PlannedDateToken,
		//private _pbgReqSubDateToken: RequestDateToken,
		private _pbgReqSubDate: Date,
		private _pbgActSubToken: ActualDateToken,
		private _pbgPlndCollToken: PlannedDateToken, private _pbgActCollToken: ActualDateToken,
		private _cpbgSubmissionDetails: string,
		private _cpbgPlndSubToken: PlannedDateToken, private _cpbgActSubToken: ActualDateToken,
		private _cpbgPlndCollToken: PlannedDateToken, private _cpbgActCollToken: ActualDateToken,
		private _saleOrderChangeApplcId: string, private _salesOrderNoNew: string, private _customerPoNo: string, private _pmPoDate: Date, private _fatCallLetterDate: Date, private _workDaysNo: string, private _fatDetails: Array<FatDataList>, private _status: FunctionStatus) {
		if (!this._saleOrderChangeApplcId) {
			this._saleOrderChangeApplcId = "no";
		}
	}

	private _parentSORef: SalesOrder;
	refreshStatus() {
		if (this.parentSORef) {
			if (this.parentSORef.projectStatus < SOStatus.PM_Commercial) {
				this._status = FunctionStatus.WAITING_FOR_PREV;
			}
			else if (this.parentSORef.projectStatus == SOStatus.PM_Commercial) {
				this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
			}
			else if (this.parentSORef.projectStatus > SOStatus.PM_Commercial) {
				let _isTempComplete: boolean = this.isFunctionComplete();

				if (_isTempComplete == true) {
					this._status = FunctionStatus.SUBMITTED_COMPLETE;
				}
				else {
					this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
				}
			}
		}
		else {
			this._status = FunctionStatus.WAITING_FOR_PREV;
		}
	}
	private isFunctionComplete(): boolean {
		if (configDefs.isStrEmty(this.projectEngineerId)) return false;

		if (configDefs.isStrEmty(this.poAmmendmentid)) return false;
		if (this.isAmmendmentIsYes) {
			if (configDefs.isStrEmty(this.poAmmendmentValue)) return false;
		}

		if (this.isAbgFormatReceieved) {
			if (configDefs.isStrEmty(this.abgOrAcgSubmissionDetails)) return false;
			if (configDefs.isDtEmty(this.abgOrAcgPlndSubDate)) return false;
			if (configDefs.isDtEmty(this.abgOrAcgActSubDate)) return false;
			if (configDefs.isDtEmty(this.abgOrAcgPlndCollDate)) return false;
			if (configDefs.isDtEmty(this.abgOrAcgActCollDate)) return false;
		}

		if (this.parentSORef.marketingIP.isPBGPymtCondApplicable == true) {
			if (configDefs.isStrEmty(this.pbgSubmissionDetails)) return false;
			if (configDefs.isDtEmty(this.pbgPlndSubDate)) return false;
			if (configDefs.isDtEmty(this.pbgActSubDate)) return false;
			// if(configDefs.isDtEmty(this.pbgPlndCollDate)) return false;
			if (configDefs.isDtEmty(this.pbgReqSubDate)) return false;
			if (configDefs.isDtEmty(this.pbgActCollDate)) return false;
		}

		if (this.parentSORef.marketingIP.isCPBGPymtCondApplicable == true) {
			if (configDefs.isStrEmty(this.cpbgSubmissionDetails)) return false;
			if (configDefs.isDtEmty(this.cpbgPlndSubDate)) return false;
			if (configDefs.isDtEmty(this.cpbgActSubDate)) return false;
			// if (configDefs.isDtEmty(this.cpbgPlndCollDate)) return false;
			if (configDefs.isDtEmty(this.cpbgActCollDate)) return false;
		}
		if (this.isRetentionEnabled) {
			for (var i = 0; i < this.parentSORef.marketingIP.retentionPayment.length; i++) {
				if (configDefs.isStrEmty(this.retentionDetailsSubmission)) return false;
				if (this.isDetailsRequiredForRetentionDetailSub) {
					if (configDefs.isDtEmty(this.actDateforRetrentionDetailsSubm)) return false;
				}
			}
		}
		// if(configDefs.isStrEmty(this.saleOrderChangeApplcId))return false;
		if (this.isSaleOrderChangeApplicable) {
			if (configDefs.isStrEmty(this.salesOrderNoNew)) return false;
		}


		return true;
	}
	get isInputEnabled(): boolean {
		return this.parentSORef.projectStatus > SOStatus.Marketing;
	}
	get parentSORef(): SalesOrder {
		return this._parentSORef;
	}
	set parentSORef(SORef: SalesOrder) {
		this._parentSORef = SORef;
		//this.refreshStatus();
	}
	get abgAcgSubmission_Enable(): boolean {
		if (this.parentSORef.marketingIP.advPaymentNoCondition == true) {
			return false;
		}
		if (this.parentSORef.marketingIP.abgFormatReceivedId == configDefs.defYesKeyId) {
			return true;
		}
		return false;
	}
	get isRetentionEnabled(): boolean {
		return this.parentSORef.marketingIP.isRetentionConditionEnabled;
	}
	get abgAcgSubmission_DisableMessage(): string {
		if (this.parentSORef.marketingIP.advPaymentNoCondition == true) {
			return configDefs.defNotApplicableText;
		}
		if (this.parentSORef.marketingIP.abgFormatReceivedId == "no") {
			return "ABG Format not received, contact Marketing";
		}
		return "-";
	}
	get pbgSubmission_Enable(): boolean {
		if (this.parentSORef.marketingIP.isPBGPymtCondApplicable == false) {
			return false;
		}
		if (this.parentSORef.marketingIP.pbgFormatReceivedId == configDefs.defYesKeyId) {
			return true;
		}
		return false;
	}
	get pbgSubmission_DisableMessage(): string {
		if (this.parentSORef.marketingIP.isPBGPymtCondApplicable == false) {
			return configDefs.defNotApplicableText;
		}
		if (this.parentSORef.marketingIP.pbgFormatReceivedId == "no") {
			return "PBG Format not received, contact Marketing";
		}
		return "-";
	}
	get cpbgSubmission_Enable(): boolean {
		if (this.parentSORef.marketingIP.isCPBGPymtCondApplicable == false) {
			return false;
		}
		return true;
	}
	get cpbgSubmission_DisableMessage(): string {
		if (this.parentSORef.marketingIP.isCPBGPymtCondApplicable == false) {
			return configDefs.defNotApplicableText;
		}
		return "-";
	}
	get projectEngineerId(): string {
		return this._projectEngineerId;
	}
	set projectEngineerId(_SetVal: string) {
		this._projectEngineerId = _SetVal;
	}
	get poAmmendmentid(): string {
		return this._poAmendment;
	}
	get isAmmendmentIsYes(): boolean {
		return this._poAmendment == "yes";
	}
	set poAmmendmentid(_SetVal: string) {
		this._poAmendment = _SetVal;
	}
	get poAmmendmentValue(): string {
		if (this.isAmmendmentIsYes) {
			return this._poAmendmentValue;
		}
		return null;
	}
	set poAmmendmentValue(_SetVal: string) {
		this._poAmendmentValue = _SetVal;
	}
	get retentionDetailsSubmission(): string {
		return this._retentionDetailsSubmission;
	}
	get isDetailsRequiredForRetentionDetailSub(): boolean {
		return this._retentionDetailsSubmission == configDefs.defYesKeyId
	}
	set retentionDetailsSubmission(_SetVal: string) {
		this._retentionDetailsSubmission = _SetVal;
	}

	get actDateforRetrentionDetailsSubm(): Date {
		return this._actDateforRetrentionDetailsSubm
	}
	set actDateforRetrentionDetailsSubm(_SetVal: Date) {
		this._actDateforRetrentionDetailsSubm = _SetVal;
	}
	get abgOrAcgSubmissionDetails(): string {
		if (this.advPaymentNoCondition == false)
			return this._abgOrAcgSubmissionDetails;
		return null;
	}
	get isAbgFormatReceieved(): boolean {
		if (this.parentSORef.marketingIP.abgFormatReceivedId == "yes") {
			return true;
		}
		else
			return false;
	}
	set abgOrAcgSubmissionDetails(_SetVal: string) {
		this._abgOrAcgSubmissionDetails = _SetVal;
	}
	get abgOrAcgPlndSubToken(): PlannedDateToken {
		return this._abgOrAcgPlndSubToken;
	}
	set abgOrAcgPlndSubToken(_SetVal: PlannedDateToken) {
		// if (this._abgOrAcgPlndSubToken.actualPlannedDate == null)
		// 	this._abgOrAcgPlndSubToken.actualPlannedDate = this.abgOrAcgPlndSubDate;
		this._abgOrAcgPlndSubToken.plannedDate = _SetVal.plannedDate;
		this._abgOrAcgPlndSubToken.isOveridden = _SetVal.isOveridden;
		this._abgOrAcgPlndSubToken.addNotes = _SetVal.addNotes;
		this._abgOrAcgPlndSubToken.userOveridden = _SetVal.userOveridden;
	}
	get abgUploads(): GenFileUploads {
		return this._abgUploads;
	}
	set abgUploads(_SetVal: GenFileUploads) {
		this._abgUploads = _SetVal;
	}
	get abgOrAcgPlndSubDateLabel(): string {
		if (this.abgOrAcgPlndSubDateIsRevised == true) {
			return "Revised (Planned) Submissoin Date";
		}
		else {
			return "Planned Submission Date";
		}
	}
	get abgOrAcgPlndSubDateIsRevised(): boolean {
		if (this.abgOrAcgPlndSubDate_Initial && this.abgOrAcgPlndSubDate) {
			if (GenService.areDatesSame(this.abgOrAcgPlndSubDate_Initial, this.abgOrAcgPlndSubDate) == false) {
				return true;
			}
		}
		return false;
	}
	get abgOrAcgPlndSubDate_Initial(): Date {
		if (this._abgOrAcgPlndSubToken.actualPlannedDate == null || this._abgOrAcgPlndSubToken.isOveridden == false) {
			var _tmpDate = this.parentSORef.marketingIP.soReleaseDatePlanned;

			if (_tmpDate != null && configDefs.defPlndABGSubmisDays) {
				this._abgOrAcgPlndSubToken.actualPlannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndABGSubmisDays);
			}
			else {
				this._abgOrAcgPlndSubToken.actualPlannedDate = null;
			}
		}
		return this._abgOrAcgPlndSubToken.actualPlannedDate;
	}
	get abgOrAcgPlndSubDate(): Date {
		if (this._abgOrAcgPlndSubToken.plannedDate == null || this._abgOrAcgPlndSubToken.isOveridden == false) {
			var _tmpDate = this.parentSORef.marketingIP.soReleaseDateActual;
			if (_tmpDate == null) {
				_tmpDate = this.parentSORef.marketingIP.soReleaseDatePlanned
			}
			if (_tmpDate != null && configDefs.defPlndABGSubmisDays) {
				this._abgOrAcgPlndSubToken.plannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndABGSubmisDays);
			}
			else {
				this._abgOrAcgPlndSubToken.plannedDate = null;
			}
		}
		return this._abgOrAcgPlndSubToken.plannedDate;
	}
	private _abgOrAcgPlndSubGroup: RevisedDate
	get abgOrAcgPlndSubGroup(): RevisedDate {
		this._abgOrAcgPlndSubGroup = new RevisedDate(this.abgOrAcgPlndSubDate_Initial, this.abgOrAcgPlndSubDateIsRevised, this.abgOrAcgPlndSubDate);

		return this._abgOrAcgPlndSubGroup;
	}
	set abgOrAcgPlndSubDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set abgOrAcgPlndSubDate directly");
		this._abgOrAcgPlndSubToken.plannedDate = _SetVal;
	}
	get abgOrAcgActSubToken(): ActualDateToken {
		return this._abgOrAcgActSubToken;
	}
	set abgOrAcgActSubToken(_SetVal: ActualDateToken) {
		if (this._abgOrAcgActSubToken.expActualDate == null)
			this._abgOrAcgActSubToken.expActualDate = this.abgOrAcgPlndSubDate;
		this._abgOrAcgActSubToken.actualDate = _SetVal.actualDate;
		this._abgOrAcgActSubToken.isOveridden = _SetVal.isOveridden;
		this._abgOrAcgActSubToken.addNotes = _SetVal.addNotes;
		this._abgOrAcgActSubToken.userOveridden = _SetVal.userOveridden;
	}
	get abgOrAcgActSubDate(): Date {
		return this.abgOrAcgActSubToken.actualDate;
	}
	set abgOrAcgActSubDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set abgOrAcgActSubDate directly");
		this.abgOrAcgActSubToken.actualDate = _SetVal;
	}
	get abgOrAcgPlndCollToken(): PlannedDateToken {
		return this._abgOrAcgPlndCollToken;
	}
	set abgOrAcgPlndCollToken(_SetVal: PlannedDateToken) {
		if (this._abgOrAcgPlndCollToken.actualPlannedDate == null)
			this._abgOrAcgPlndCollToken.actualPlannedDate = this.abgOrAcgPlndCollDate;
		this._abgOrAcgPlndCollToken.plannedDate = _SetVal.plannedDate;
		this._abgOrAcgPlndCollToken.isOveridden = _SetVal.isOveridden;
		this._abgOrAcgPlndCollToken.addNotes = _SetVal.addNotes;
		this._abgOrAcgPlndCollToken.userOveridden = _SetVal.userOveridden;
	}
	get abgOrAcgPlndCollDate(): Date {
		if (this._abgOrAcgPlndCollToken.plannedDate == null || this._abgOrAcgPlndCollToken.isOveridden == false) {
			var _tmpDate = this.abgOrAcgPlndSubDate_Initial;
			if (_tmpDate != null && configDefs.defPlndABGCollDays) {
				this._abgOrAcgPlndCollToken.plannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndABGCollDays);
			}
			else {
				this._abgOrAcgPlndCollToken.plannedDate = null;
			}
		}
		return this._abgOrAcgPlndCollToken.plannedDate;
	}
	set abgOrAcgPlndCollDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set abgOrAcgPlndCollDate directly");
		this._abgOrAcgPlndCollToken.plannedDate = _SetVal;
	}
	get abgOrAcgActCollToken(): ActualDateToken {
		return this._abgOrAcgActCollToken;
	}
	set abgOrAcgActCollToken(_SetVal: ActualDateToken) {
		if (this._abgOrAcgActCollToken.expActualDate == null)
			this._abgOrAcgActCollToken.expActualDate = this.abgOrAcgPlndCollDate;
		this._abgOrAcgActCollToken.actualDate = _SetVal.actualDate;
		this._abgOrAcgActCollToken.isOveridden = _SetVal.isOveridden;
		this._abgOrAcgActCollToken.addNotes = _SetVal.addNotes;
		this._abgOrAcgActCollToken.userOveridden = _SetVal.userOveridden;
	}
	get abgOrAcgActCollDate(): Date {
		return this._abgOrAcgActCollToken.actualDate
	}
	set abgOrAcgActCollDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set abgOrAcgPlndSubDate directly");
		this._abgOrAcgActCollToken.actualDate = _SetVal;
	}
	get pbgSubmissionDetails(): string {
		if (this.isPBGPymtCondApplicable == true)
			return this._pbgSubmissionDetails;
		return null;
	}
	set pbgSubmissionDetails(_SetVal: string) {
		this._pbgSubmissionDetails = _SetVal;
	}
	get pbgUploads(): GenFileUploads {
		return this._pbgUploads;
	}
	set pbgUploads(_SetVal: GenFileUploads) {
		this._pbgUploads = _SetVal;
	}
	get pbgPlndSubToken(): PlannedDateToken {
		return this._pbgPlndSubToken;
	}
	set pbgPlndSubToken(_SetVal: PlannedDateToken) {
		// if (this._pbgPlndSubToken.actualPlannedDate == null)
		// 	this._pbgPlndSubToken.actualPlannedDate = this.pbgPlndSubDate;
		this._pbgPlndSubToken.plannedDate = _SetVal.plannedDate;
		this._pbgPlndSubToken.isOveridden = _SetVal.isOveridden;
		this._pbgPlndSubToken.addNotes = _SetVal.addNotes;
		this._pbgPlndSubToken.userOveridden = _SetVal.userOveridden;
	}
	get pbgPlndSubDateLabel(): string {
		if (this.pbgPlndSubDateisrevised == true) {
			return "Revised (Planned) Date"
		} else {
			return "Planned Date"
		}
	}
	get pbgPlndSubDateisrevised(): boolean {
		if (this.pbgPlndSubDate_Initial && this.pbgPlndSubDate) {
			if (GenService.areDatesSame(this.pbgPlndSubDate_Initial, this.pbgPlndSubDate) == false) {
				return true;
			}
		}
		return false;
	}
	get pbgPlndSubDate_Initial(): Date {
		if (this._pbgPlndSubToken.actualPlannedDate == null || this._pbgPlndCollToken.isOveridden == false) {
			var _tmpDate = this.parentSORef.lastDispatchPlannedFromPlant_Initial;

			if (_tmpDate != null && configDefs.defPlndPBGSubmisDays) {
				this._pbgPlndSubToken.actualPlannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndPBGSubmisDays);
			}
			else {
				this._pbgPlndSubToken.actualPlannedDate = null;
			}
		}
		return this._pbgPlndSubToken.actualPlannedDate;
	}

	get pbgPlndSubDate(): Date {
		if (this._pbgPlndSubToken.plannedDate == null || this._pbgPlndCollToken.isOveridden == false) {
			var _tmpDate = this.parentSORef.lastDispatchPlannedFromPlant;
			if (_tmpDate == null) {
				_tmpDate = this.parentSORef.lastDispatchPlannedFromPlant_Initial;
			}
			if (_tmpDate != null && configDefs.defPlndPBGSubmisDays) {
				this._pbgPlndSubToken.plannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndPBGSubmisDays);
			}
			else {
				this._pbgPlndSubToken.plannedDate = null;
			}
		}
		return this._pbgPlndSubToken.plannedDate;
	}
	private _pbgPlndSubGroup: RevisedDate;
	get pbgPlndSubGroup(): RevisedDate {
		this._pbgPlndSubGroup = new RevisedDate(this.pbgPlndSubDate_Initial, this.pbgPlndSubDateisrevised, this.pbgPlndSubDate);

		return this._pbgPlndSubGroup;
	}
	set pbgPlndSubDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set pbgPlndSubDate directly");
		this._pbgPlndSubToken.plannedDate = _SetVal;
	}
	get pbgActSubToken(): ActualDateToken {
		return this._pbgActSubToken;
	}
	get pbgReqSubDate(): Date {
		var _tmpDate = this.parentSORef.lastDispatchRequestedFromPlant;
		if (_tmpDate != null && configDefs.defReqPBGSubmisDays) {
			this._pbgReqSubDate = configDefs.addWorkingDays(_tmpDate, configDefs.defReqPBGSubmisDays);
		}
		return this._pbgReqSubDate;
	}

	set pbgReqSubDate(_SetVal: Date) {
		this._pbgReqSubDate = _SetVal;
	}
	///
	// get pbgReqSubDateToken(): RequestDateToken {
	// 	return this._pbgReqSubDateToken;
	// }
	// set pbgReqSubDateToken(_SetVal: RequestDateToken) {
	// 	if (this._pbgReqSubDateToken.plndRequestDate == null)
	// 		this._pbgReqSubDateToken.plndRequestDate = this.pbgReqSubDate;
	// 	this._pbgReqSubDateToken.requestDate = _SetVal.requestDate;
	// 	this._pbgReqSubDateToken.isOveridden = _SetVal.isOveridden;
	// 	this._pbgReqSubDateToken.addNotes = _SetVal.addNotes;
	// 	this._pbgReqSubDateToken.userOveridden = _SetVal.userOveridden;
	// }
	// get pbgReqSubDate(): Date {
	// 	if (this._pbgReqSubDateToken.requestDate == null || this._pbgReqSubDateToken.isOveridden == false) {
	// 		var _tmpDate = this.parentSORef.lastDispatchRequestedFromPlant;
	// 		if (_tmpDate != null && configDefs.defReqPBGSubmisDays) {
	// 			this._pbgReqSubDateToken.requestDate = configDefs.addWorkingDays(_tmpDate, configDefs.defReqPBGSubmisDays);
	// 		}
	// 	}
	// 	return this._pbgReqSubDateToken.requestDate;
	// }
	// set pbgReqSubDate(_SetVal: Date) {
	// 	console.log('wrong execution, requestedpbgsubmissiondate')
	// 	this._pbgReqSubDateToken.requestDate = _SetVal;
	// }
	set pbgActSubToken(_SetVal: ActualDateToken) {
		if (this._pbgActSubToken.expActualDate == null)
			this._pbgActSubToken.expActualDate = this.pbgPlndSubDate;
		this._pbgActSubToken.actualDate = _SetVal.actualDate;
		this._pbgActSubToken.isOveridden = _SetVal.isOveridden;
		this._pbgActSubToken.addNotes = _SetVal.addNotes;
		this._pbgActSubToken.userOveridden = _SetVal.userOveridden;
	}
	get pbgActSubDate(): Date {
		return this._pbgActSubToken.actualDate;
	}
	set pbgActSubDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set pbgActSubDate directly");
		this._pbgActSubToken.actualDate = _SetVal;
	}

	get pbgPlndCollToken(): PlannedDateToken {
		return this._pbgPlndCollToken;
	}
	set pbgPlndCollToken(_SetVal: PlannedDateToken) {
		if (this._pbgPlndCollToken.actualPlannedDate == null)
			this._pbgPlndCollToken.actualPlannedDate = this.pbgPlndCollDate;
		this._pbgPlndCollToken.plannedDate = _SetVal.plannedDate;
		this._pbgPlndCollToken.isOveridden = _SetVal.isOveridden;
		this._pbgPlndCollToken.addNotes = _SetVal.addNotes;
		this._pbgPlndCollToken.userOveridden = _SetVal.userOveridden;
	}
	get pbgPlndCollDate(): Date {
		// if(this._pbgPlndCollToken.plannedDate == null || this._pbgPlndCollToken.isOveridden == false){
		// 	var _tmpDate = this.parentSORef.marketingIP.planneddis;
		// 	if(_tmpDate != null && configDefs.defPlndCPBGSubmisDays){
		// 		this._cpbgPlndSubToken.plannedDate = configDefs.addWorkingDays(_tmpDate,configDefs.defPlndCPBGSubmisDays);
		// 	}
		// }
		return this._pbgPlndCollToken.plannedDate;
	}
	set pbgPlndCollDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set pbgPlndCollDate directly");
		this._pbgPlndCollToken.plannedDate = _SetVal;
	}
	get pbgActCollToken(): ActualDateToken {
		return this._pbgActCollToken;
	}
	set pbgActCollToken(_SetVal: ActualDateToken) {
		if (this._pbgActCollToken.expActualDate == null)
			this._pbgActCollToken.expActualDate = this.pbgPlndCollDate;
		this._pbgActCollToken.actualDate = _SetVal.actualDate;
		this._pbgActCollToken.isOveridden = _SetVal.isOveridden;
		this._pbgActCollToken.addNotes = _SetVal.addNotes;
		this._pbgActCollToken.userOveridden = _SetVal.userOveridden;
	}
	get pbgActCollDate(): Date {
		return this._pbgActCollToken.actualDate;
	}
	set pbgActCollDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set pbgActCollDate directly");
		this._pbgActCollToken.actualDate = _SetVal;
	}
	get cpbgSubmissionDetails(): string {
		if (this.isCPBGPymtCondApplicable == true)
			return this._cpbgSubmissionDetails;
		return null;
	}
	set cpbgSubmissionDetails(_SetVal: string) {
		this._cpbgSubmissionDetails = _SetVal;
	}
	get cpbgPlndSubToken(): PlannedDateToken {
		return this._cpbgPlndSubToken;
	}
	set cpbgPlndSubToken(_SetVal: PlannedDateToken) {
		// if (this._cpbgPlndSubToken.actualPlannedDate == null)
		// 	this._cpbgPlndSubToken.actualPlannedDate = this.cpbgPlndSubDate;
		this._cpbgPlndSubToken.plannedDate = _SetVal.plannedDate;
		this._cpbgPlndSubToken.isOveridden = _SetVal.isOveridden;
		this._cpbgPlndSubToken.addNotes = _SetVal.addNotes;
		this._cpbgPlndSubToken.userOveridden = _SetVal.userOveridden;
	}
	get cpbgPlndSubDateLabel(): string {
		if (this.cpbgPlndSubDateIsRevised == true) {
			return "Revised (Planned) Submissoin Date";
		}
		else {
			return "Planned Submission Date";
		}
	}
	get cpbgPlndSubDateIsRevised(): boolean {
		if (this.cpbgPlndSubDate_Initial && this.cpbgPlndSubDate) {
			if (GenService.areDatesSame(this.cpbgPlndSubDate_Initial, this.cpbgPlndSubDate) == false) {
				return true;
			}
		}
		return false;
	}
	get cpbgPlndSubDate_Initial(): Date {
		if (this._cpbgPlndSubToken.actualPlannedDate == null || this._cpbgPlndSubToken.isOveridden == false) {
			var _tmpDate = this.parentSORef.marketingIP.soReleaseDatePlanned;

			if (_tmpDate != null && configDefs.defPlndABGSubmisDays) {
				this._cpbgPlndSubToken.actualPlannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndABGSubmisDays);
			}
			else {
				this._cpbgPlndSubToken.actualPlannedDate = null;
			}
		}
		return this._cpbgPlndSubToken.actualPlannedDate;
	}

	get cpbgPlndSubDate(): Date {
		if (this._cpbgPlndSubToken.plannedDate == null || this._cpbgPlndSubToken.isOveridden == false) {
			var _tmpDate = this.parentSORef.marketingIP.soReleaseDateActual;
			if (_tmpDate == null) {
				_tmpDate = this.parentSORef.marketingIP.soReleaseDatePlanned
			}
			if (_tmpDate != null && configDefs.defPlndCPBGSubmisDays) {
				this._cpbgPlndSubToken.plannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndCPBGSubmisDays);
			}
			else {
				this._cpbgPlndSubToken.plannedDate = null;
			}
		}
		return this._cpbgPlndSubToken.plannedDate;
	}
	private _cpbgPlndSubGroup: RevisedDate;
	get cpbgPlndSubGroup(): RevisedDate {
		this._cpbgPlndSubGroup = new RevisedDate(this.cpbgPlndSubDate_Initial, this.cpbgPlndSubDateIsRevised, this.cpbgPlndSubDate);

		return this._cpbgPlndSubGroup;
	}
	set cpbgPlndSubDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set cpbgPlndSubDate directly");
		this._cpbgPlndSubToken.plannedDate = _SetVal;
	}
	get cpbgActSubToken(): ActualDateToken {
		return this._cpbgActSubToken;
	}
	set cpbgActSubToken(_SetVal: ActualDateToken) {
		if (this._cpbgActSubToken.expActualDate == null)
			this._cpbgActSubToken.expActualDate = this.cpbgPlndSubDate;
		this._cpbgActSubToken.actualDate = _SetVal.actualDate;
		this._cpbgActSubToken.isOveridden = _SetVal.isOveridden;
		this._cpbgActSubToken.addNotes = _SetVal.addNotes;
		this._cpbgActSubToken.userOveridden = _SetVal.userOveridden;
	}
	get cpbgActSubDate(): Date {
		return this._cpbgActSubToken.actualDate;
	}
	set cpbgActSubDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set cpbgActSubDate directly");
		this._cpbgActSubToken.actualDate = _SetVal;
	}
	get cpbgPlndCollToken(): PlannedDateToken {
		return this._cpbgPlndCollToken;
	}
	set cpbgPlndCollToken(_SetVal: PlannedDateToken) {
		if (this._cpbgPlndCollToken.actualPlannedDate == null)
			this._cpbgPlndCollToken.actualPlannedDate = this.cpbgPlndCollDate;
		this._cpbgPlndCollToken.plannedDate = _SetVal.plannedDate;
		this._cpbgPlndCollToken.isOveridden = _SetVal.isOveridden;
		this._cpbgPlndCollToken.addNotes = _SetVal.addNotes;
		this._cpbgPlndCollToken.userOveridden = _SetVal.userOveridden;
	}
	get cpbgPlndCollDate(): Date {
		return this._cpbgPlndCollToken.plannedDate;
	}
	set cpbgPlndCollDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set cpbgPlndCollDate directly");
		this._cpbgPlndCollToken.plannedDate = _SetVal;
	}
	get cpbgActCollToken(): ActualDateToken {
		return this._cpbgActCollToken;
	}
	set cpbgActCollToken(_SetVal: ActualDateToken) {
		if (this._cpbgActCollToken.expActualDate == null)
			this._cpbgActCollToken.expActualDate = this.cpbgPlndCollDate;
		this._cpbgActCollToken.actualDate = _SetVal.actualDate;
		this._cpbgActCollToken.isOveridden = _SetVal.isOveridden;
		this._cpbgActCollToken.addNotes = _SetVal.addNotes;
		this._cpbgActCollToken.userOveridden = _SetVal.userOveridden;
	}
	get cpbgActCollDate(): Date {
		return this._cpbgActCollToken.actualDate;
	}
	set cpbgActCollDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set cpbgActCollDate directly");
		this._cpbgActCollToken.actualDate = _SetVal;
	}

	get advPaymentNoCondition(): boolean {
		return this.parentSORef.marketingIP.advPaymentNoCondition;
	}
	get isPBGPymtCondApplicable(): boolean {
		return this.parentSORef.marketingIP.isPBGPymtCondApplicable;
	}
	get isCPBGPymtCondApplicable(): boolean {
		return this.parentSORef.marketingIP.isCPBGPymtCondApplicable;

	}
	get saleOrderChangeApplcId(): string {
		return this._saleOrderChangeApplcId;
	}
	get isSaleOrderChangeApplicable(): boolean {
		if (this.saleOrderChangeApplcId == "yes") return true;
		return false
	}
	set saleOrderChangeApplcId(_SetVal: string) {
		this._saleOrderChangeApplcId = _SetVal;
	}
	get salesOrderNoNew(): string {
		return this._salesOrderNoNew;
	}
	set salesOrderNoNew(_SetVal: string) {
		this._salesOrderNoNew = _SetVal;
	}
	get customerPoNo(): string {
		return this._customerPoNo;
	}
	set customerPoNo(_SetVal: string) {
		this._customerPoNo = _SetVal;
	}
	get pmPoDate(): Date {
		return this._pmPoDate;
	}
	set pmPoDate(_SetVal: Date) {
		this._pmPoDate = _SetVal;
	}
	get fatCallLetterDate(): Date {
		return this._fatCallLetterDate;
	}
	set fatCallLetterDate(_SetVal: Date) {
		this._fatCallLetterDate = _SetVal;
	}
	get workDaysNo(): string {
		return this._workDaysNo;
	}
	set workDaysNo(_SetVal: string) {
		this._workDaysNo = _SetVal;
	}
	get fatDetails(): Array<FatDataList> {
		return this._fatDetails;
	}
	set fatDetails(_SetVal: Array<FatDataList>) {
		this._fatDetails = _SetVal;
	}
	get status(): FunctionStatus {
		return this._status;
	}
	get isPmCommSubmitted(): boolean {
		return this.parentSORef.isSubOrdesEnabled;
	}
	get SsoNos() {
		let _tmpsso = this.parentSORef.subSalesOrder;
		let _ssoArray = [];
		for (let i = 0; i < _tmpsso.length; i++) {
			let _noTmp = _tmpsso[i].pmTechSubSalesOrder.subOrderNo;
			_ssoArray.push(_noTmp);
		}
		return _ssoArray;
	}
	addFatData(_date: Date, _ssos, _userName) {
		this._fatDetails.push(new FatDataList(_date, _ssos, new Date(new Date().toDateString()), _userName));
	}
	cloneSelf() {
		let _tmpFat: Array<FatDataList> = [];
		this.fatDetails.forEach((_data: FatDataList) => {
			_tmpFat.push(_data.cloneSelf());
		})
		return new PmCommercialIP(this._projectEngineerId, this._poAmendment, this._poAmendmentValue, this._retentionDetailsSubmission, configDefs.cloneDt(this.actDateforRetrentionDetailsSubm),
			this._abgOrAcgSubmissionDetails, this.abgUploads.cloneSelf(), this._abgOrAcgPlndSubToken, this._abgOrAcgActSubToken, this._abgOrAcgPlndCollToken, this._abgOrAcgActCollToken,
			this._pbgSubmissionDetails, this.pbgUploads.cloneSelf(), this._pbgPlndSubToken,
			// this.pbgReqSubDateToken,
			configDefs.cloneDt(this.pbgReqSubDate),
			this._pbgActSubToken, this._pbgPlndCollToken, this._pbgActCollToken,
			this._cpbgSubmissionDetails, this._cpbgPlndSubToken, this._cpbgActSubToken, this._cpbgPlndCollToken, this._cpbgActCollToken, this._saleOrderChangeApplcId, this._salesOrderNoNew,
			this._customerPoNo, configDefs.cloneDt(this._pmPoDate), configDefs.cloneDt(this._fatCallLetterDate), this._workDaysNo, _tmpFat, this.status);
	}

	public static getObj(_json: any): PmCommercialIP {
		let _fatData: Array<FatDataList> = [];
		if (_json.fatDetails) {
			for (var j = 0; j < _json.fatDetails.length; j++) {
				_fatData.push(FatDataList.getObj(_json.fatDetails[j]));
			}
		}

		let _pmCommercialIp: PmCommercialIP = new PmCommercialIP(_json.projEngId, _json.poAmmendId, _json.poAmmendValue, _json.retDetailsSub, GenService.convToDate(_json.retenDetSubActDate),
			_json.abgACGSubDetails, GenFileUploads.getObj(_json.abgUploads), convDefs.convToPlannedDateToken(_json.abgACGPlndSubToken), convDefs.convToActualDateToken(_json.abgACGActSubToken),
			convDefs.convToPlannedDateToken(_json.abgACGPlndColToken), convDefs.convToActualDateToken(_json.abgACGActColToken),
			_json.pbgSubDetails, GenFileUploads.getObj(_json.pbgUploads), convDefs.convToPlannedDateToken(_json.pbgPlndSubToken),
			GenService.convToDate(_json.pbgrequsubdate),
			//convDefs.convToRequestDateToken(_json.pbgrequsubdate),
			convDefs.convToActualDateToken(_json.pbgActSubToken), convDefs.convToPlannedDateToken(_json.pbgPlndColToken), convDefs.convToActualDateToken(_json.pbgActColToken),
			_json.cpbgSubDetails, convDefs.convToPlannedDateToken(_json.cpbgPlndSubToken), convDefs.convToActualDateToken(_json.cpbgActSubToken),
			convDefs.convToPlannedDateToken(_json.cpbgPlndColToken), convDefs.convToActualDateToken(_json.cpbgActColToken), _json.saleOrderChngApplcId, _json.saleOrderNoNew,
			_json.custPoNo, GenService.convToDate(_json.pmPoDate), GenService.convToDate(_json.fatCallLtrDate), _json.workDaysNo, _fatData, _json.status);
		return _pmCommercialIp;
	}

	public getJson(): any {
		let _fData: any = [];
		this.fatDetails.forEach((_fD: FatDataList) => {
			_fData.push(_fD.getJson());
		})

		let _json: any = {};
		_json.projEngId = this.projectEngineerId;
		_json.poAmmendId = this.poAmmendmentid;
		_json.poAmmendValue = this.poAmmendmentValue;
		_json.retDetailsSub = this.retentionDetailsSubmission;
		_json.retenDetSubActDate = GenService.convToDateNum(this.actDateforRetrentionDetailsSubm);
		_json.abgACGSubDetails = this.abgOrAcgSubmissionDetails;
		_json.abgUploads = this.abgUploads.getJson();
		_json.abgACGPlndSubToken = this.abgOrAcgPlndSubToken.getJson();
		_json.abgACGActSubToken = this.abgOrAcgActSubToken.getJson();
		_json.abgACGPlndColToken = this.abgOrAcgPlndCollToken.getJson();
		_json.abgACGActColToken = this.abgOrAcgActCollToken.getJson();
		_json.pbgSubDetails = this.pbgSubmissionDetails;
		_json.pbgUploads = this.pbgUploads.getJson();
		_json.pbgPlndSubToken = this.pbgPlndSubToken.getJson();
		_json.pbgrequsubdate = GenService.convToDateNum(this.pbgReqSubDate);
		_json.pbgActSubToken = this.pbgActSubToken.getJson();
		_json.pbgPlndColToken = this.pbgPlndCollToken.getJson();
		_json.pbgActColToken = this.pbgActCollToken.getJson();
		_json.cpbgSubDetails = this.cpbgSubmissionDetails;
		_json.cpbgPlndSubToken = this.cpbgPlndSubToken.getJson();
		_json.cpbgActSubToken = this.cpbgActSubToken.getJson();
		_json.cpbgPlndColToken = this.cpbgPlndCollToken.getJson();
		_json.cpbgActColToken = this.cpbgActCollToken.getJson();
		_json.saleOrderChngApplcId = this.saleOrderChangeApplcId;
		_json.saleOrderNoNew = this.salesOrderNoNew;
		_json.custPoNo = this.customerPoNo;
		_json.pmPoDate = GenService.convToDateNum(this.pmPoDate);
		_json.fatCallLtrDate = GenService.convToDateNum(this.fatCallLetterDate);
		_json.workDaysNo = this.workDaysNo;
		_json.fatDetails = _fData;
		return _json;
	}
}
export class MultiOptDetails_3DS {
	constructor(private _type1: string, private _type2: string, private _type3: string) {

	}
	get isFunctionComplete(): boolean {
		//type of equip
		if (configDefs.isStrEmty(this.type1)) return false;
		if (configDefs.isStrEmty(this.type2)) return false;
		if (configDefs.isStrEmty(this.type3)) return false;
		return true;
	}

	get type1(): string {
		return this._type1;
	}
	set type1(_SetVal: string) {
		this._type1 = _SetVal;
	}
	get type2(): string {
		return this._type2;
	}
	set type2(_SetVal: string) {
		this._type2 = _SetVal;
	}
	get type3(): string {
		return this._type3;
	}
	set type3(_SetVal: string) {
		this._type3 = _SetVal;
	}


	static getObj(_json: any): MultiOptDetails_3DS {
		return new MultiOptDetails_3DS(_json.type1, _json.type2, _json.type3);
	}
	public getJson(): any {
		let _json: any = {};
		_json.type1 = this.type1;
		_json.type2 = this.type2;
		_json.type3 = this.type3;
		return _json;

	}
	cloneSelf() {
		return new MultiOptDetails_3DS(this.type1, this.type2, this.type3);
	}

}
export class MultiOptDetails_1DS {
	constructor(private _type1: string) {

	}
	get isFunctionComplete(): boolean {
		//type of equip
		if (configDefs.isStrEmty(this.type1)) return false;
		return true;
	}

	get type1(): string {
		return this._type1;
	}
	set type1(_SetVal: string) {
		this._type1 = _SetVal;
	}

	static getObj(_json: any): MultiOptDetails_1DS {
		return new MultiOptDetails_1DS(_json.type1);
	}
	public getJson(): any {
		let _json: any = {};
		_json.type1 = this.type1;
		return _json;

	}
	cloneSelf() {
		return new MultiOptDetails_1DS(this.type1);
	}

}
export class MultiOptDetails_2DS {
	constructor(private _type1: string, private _type2: string) {

	}
	get isFunctionComplete(): boolean {
		//type of equip
		if (configDefs.isStrEmty(this.type1)) return false;
		if (configDefs.isStrEmty(this.type2)) return false;
		return true;
	}

	get type1(): string {
		return this._type1;
	}
	set type1(_SetVal: string) {
		this._type1 = _SetVal;
	}
	get type2(): string {
		return this._type2;
	}
	set type2(_SetVal: string) {
		this._type2 = _SetVal;
	}


	static getObj(_json: any): MultiOptDetails_2DS {
		return new MultiOptDetails_2DS(_json.type1, _json.type2);
	}
	public getJson(): any {
		let _json: any = {};
		_json.type1 = this.type1;
		_json.type2 = this.type2;
		return _json;

	}
	cloneSelf() {
		return new MultiOptDetails_2DS(this.type1, this.type2);
	}

}
export class MultiOptDetails_4DS {
	constructor(private _type1: string, private _type2: string, private _type3: string, private _type4: string) {

	}
	get isFunctionComplete(): boolean {
		//type of equip
		if (configDefs.isStrEmty(this.type1)) return false;
		if (configDefs.isStrEmty(this.type2)) return false;
		if (configDefs.isStrEmty(this.type3)) return false;
		if (configDefs.isStrEmty(this.type4)) return false;
		return true;
	}

	get type1(): string {
		return this._type1;
	}
	set type1(_SetVal: string) {
		this._type1 = _SetVal;
	}
	get type2(): string {
		return this._type2;
	}
	set type2(_SetVal: string) {
		this._type2 = _SetVal;
	}
	get type3(): string {
		return this._type3;
	}
	set type3(_SetVal: string) {
		this._type3 = _SetVal;
	}
	get type4(): string {
		return this._type4;
	}
	set type4(_SetVal: string) {
		this._type4 = _SetVal;
	}

	static getObj(_json: any): MultiOptDetails_4DS {
		return new MultiOptDetails_4DS(_json.type1, _json.type2, _json.type3, _json.type4);
	}
	public getJson(): any {
		let _json: any = {};
		_json.type1 = this.type1;
		_json.type2 = this.type2;
		_json.type3 = this.type3;
		_json.type4 = this.type4;
		return _json;

	}
	cloneSelf() {
		return new MultiOptDetails_4DS(this.type1, this.type2, this.type3, this.type4);
	}

}
export class MultiOptDetails_5DS {
	constructor(private _type1: string, private _type2: string, private _type3: string, private _type4: string, private _type5: string) {

	}
	get isFunctionComplete(): boolean {
		//type of equip
		if (configDefs.isStrEmty(this.type1)) return false;
		if (configDefs.isStrEmty(this.type2)) return false;
		if (configDefs.isStrEmty(this.type3)) return false;
		if (configDefs.isStrEmty(this.type4)) return false;
		if (configDefs.isStrEmty(this.type5)) return false;
		return true;
	}

	get type1(): string {
		return this._type1;
	}
	set type1(_SetVal: string) {
		this._type1 = _SetVal;
	}
	get type2(): string {
		return this._type2;
	}
	set type2(_SetVal: string) {
		this._type2 = _SetVal;
	}
	get type3(): string {
		return this._type3;
	}
	set type3(_SetVal: string) {
		this._type3 = _SetVal;
	}
	get type4(): string {
		return this._type4;
	}
	set type4(_SetVal: string) {
		this._type4 = _SetVal;
	}
	get type5(): string {
		return this._type5;
	}
	set type5(_SetVal: string) {
		this._type5 = _SetVal;
	}

	static getObj(_json: any): MultiOptDetails_5DS {
		return new MultiOptDetails_5DS(_json.type1, _json.type2, _json.type3, _json.type4, _json.type5);
	}
	public getJson(): any {
		let _json: any = {};
		_json.type1 = this.type1;
		_json.type2 = this.type2;
		_json.type3 = this.type3;
		_json.type4 = this.type4;
		_json.type5 = this.type5;
		return _json;

	}
	cloneSelf() {
		return new MultiOptDetails_5DS(this.type1, this.type2, this.type3, this.type4, this.type5);
	}

}
export class MultiOptDetails_6DS {
	constructor(private _type1: string, private _type2: string, private _type3: string, private _type4: string, private _type5: string, private _type6: string) {

	}
	get isFunctionComplete(): boolean {
		//type of equip
		if (configDefs.isStrEmty(this.type1)) return false;
		if (configDefs.isStrEmty(this.type2)) return false;
		if (configDefs.isStrEmty(this.type3)) return false;
		if (configDefs.isStrEmty(this.type4)) return false;
		if (configDefs.isStrEmty(this.type5)) return false;
		if (configDefs.isStrEmty(this.type6)) return false;
		return true;
	}

	get type1(): string {
		return this._type1;
	}
	set type1(_SetVal: string) {
		this._type1 = _SetVal;
	}
	get type2(): string {
		return this._type2;
	}
	set type2(_SetVal: string) {
		this._type2 = _SetVal;
	}
	get type3(): string {
		return this._type3;
	}
	set type3(_SetVal: string) {
		this._type3 = _SetVal;
	}
	get type4(): string {
		return this._type4;
	}
	set type4(_SetVal: string) {
		this._type4 = _SetVal;
	}
	get type5(): string {
		return this._type5;
	}
	set type5(_SetVal: string) {
		this._type5 = _SetVal;
	}
	get type6(): string {
		return this._type6;
	}
	set type6(_SetVal: string) {
		this._type6 = _SetVal;
	}

	static getObj(_json: any): MultiOptDetails_6DS {
		return new MultiOptDetails_6DS(_json.type1, _json.type2, _json.type3, _json.type4, _json.type5, _json.type6);
	}
	public getJson(): any {
		let _json: any = {};
		_json.type1 = this.type1;
		_json.type2 = this.type2;
		_json.type3 = this.type3;
		_json.type4 = this.type4;
		_json.type5 = this.type5;
		_json.type6 = this.type6;
		return _json;

	}
	cloneSelf() {
		return new MultiOptDetails_6DS(this.type1, this.type2, this.type3, this.type4, this.type5, this.type6);
	}

}
export class MultiOptDetails_8DS {
	constructor(private _type1: string, private _type2: string, private _type3: string, private _type4: string, private _type5: string, private _type6: string,
		private _type7: string, private _type8: string) {

	}
	get isFunctionComplete(): boolean {
		//type of equip
		if (configDefs.isStrEmty(this.type1)) return false;
		if (configDefs.isStrEmty(this.type2)) return false;
		if (configDefs.isStrEmty(this.type3)) return false;
		if (configDefs.isStrEmty(this.type4)) return false;
		if (configDefs.isStrEmty(this.type5)) return false;
		if (configDefs.isStrEmty(this.type6)) return false;
		if (configDefs.isStrEmty(this.type7)) return false;
		if (configDefs.isStrEmty(this.type8)) return false;
		return true;
	}

	get type1(): string {
		return this._type1;
	}
	set type1(_SetVal: string) {
		this._type1 = _SetVal;
	}
	get type2(): string {
		return this._type2;
	}
	set type2(_SetVal: string) {
		this._type2 = _SetVal;
	}
	get type3(): string {
		return this._type3;
	}
	set type3(_SetVal: string) {
		this._type3 = _SetVal;
	}
	get type4(): string {
		return this._type4;
	}
	set type4(_SetVal: string) {
		this._type4 = _SetVal;
	}
	get type5(): string {
		return this._type5;
	}
	set type5(_SetVal: string) {
		this._type5 = _SetVal;
	}
	get type6(): string {
		return this._type6;
	}
	set type6(_SetVal: string) {
		this._type6 = _SetVal;
	}
	get type7(): string {
		return this._type7;
	}
	set type7(_SetVal: string) {
		this._type7 = _SetVal;
	}
	get type8(): string {
		return this._type8;
	}
	set type8(_SetVal: string) {
		this._type8 = _SetVal;
	}

	static getObj(_json: any): MultiOptDetails_8DS {
		return new MultiOptDetails_8DS(_json.type1, _json.type2, _json.type3, _json.type4, _json.type5, _json.type6, _json.type7, _json.type8);
	}
	public getJson(): any {
		let _json: any = {};
		_json.type1 = this.type1;
		_json.type2 = this.type2;
		_json.type3 = this.type3;
		_json.type4 = this.type4;
		_json.type5 = this.type5;
		_json.type6 = this.type6;
		_json.type7 = this.type7;
		_json.type8 = this.type8;
		return _json;

	}
	cloneSelf() {
		return new MultiOptDetails_8DS(this.type1, this.type2, this.type3, this.type4, this.type5, this.type6, this.type7, this.type8);
	}

}

export class MultiOptDetails_9DS {
	constructor(private _type1: string, private _type2: string, private _type3: string, private _type4: string, private _type5: string, private _type6: string,
		private _type7: string, private _type8: string, private _type9: string) {

	}
	get isFunctionComplete(): boolean {
		//type of equip
		if (configDefs.isStrEmty(this.type1)) return false;
		if (configDefs.isStrEmty(this.type2)) return false;
		if (configDefs.isStrEmty(this.type3)) return false;
		if (configDefs.isStrEmty(this.type4)) return false;
		if (configDefs.isStrEmty(this.type5)) return false;
		if (configDefs.isStrEmty(this.type6)) return false;
		if (configDefs.isStrEmty(this.type7)) return false;
		if (configDefs.isStrEmty(this.type8)) return false;
		if (configDefs.isStrEmty(this.type9)) return false;
		return true;
	}

	get type1(): string {
		return this._type1;
	}
	set type1(_SetVal: string) {
		this._type1 = _SetVal;
	}
	get type2(): string {
		return this._type2;
	}
	set type2(_SetVal: string) {
		this._type2 = _SetVal;
	}
	get type3(): string {
		return this._type3;
	}
	set type3(_SetVal: string) {
		this._type3 = _SetVal;
	}
	get type4(): string {
		return this._type4;
	}
	set type4(_SetVal: string) {
		this._type4 = _SetVal;
	}
	get type5(): string {
		return this._type5;
	}
	set type5(_SetVal: string) {
		this._type5 = _SetVal;
	}
	get type6(): string {
		return this._type6;
	}
	set type6(_SetVal: string) {
		this._type6 = _SetVal;
	}
	get type7(): string {
		return this._type7;
	}
	set type7(_SetVal: string) {
		this._type7 = _SetVal;
	}
	get type8(): string {
		return this._type8;
	}
	set type8(_SetVal: string) {
		this._type8 = _SetVal;
	}
	get type9(): string {
		return this._type9;
	}
	set type9(_SetVal: string) {
		this._type9 = _SetVal;
	}

	static getObj(_json: any): MultiOptDetails_9DS {
		return new MultiOptDetails_9DS(_json.type1, _json.type2, _json.type3, _json.type4, _json.type5, _json.type6, _json.type7, _json.type8, _json.type9);
	}
	public getJson(): any {
		let _json: any = {};
		_json.type1 = this.type1;
		_json.type2 = this.type2;
		_json.type3 = this.type3;
		_json.type4 = this.type4;
		_json.type5 = this.type5;
		_json.type6 = this.type6;
		_json.type7 = this.type7;
		_json.type8 = this.type8;
		_json.type9 = this.type9;
		return _json;

	}
	cloneSelf() {
		return new MultiOptDetails_9DS(this.type1, this.type2, this.type3, this.type4, this.type5, this.type6, this.type7, this.type8, this.type9);
	}

}
export class BreakerPS {
	constructor(private _breakerPsName: string, private _breakerQuantity: number) {

	}
	get isFunctionComplete(): boolean {
		//type of equip
		if (configDefs.isNumEmty(this.breakerQuantity)) return false;
		if (configDefs.isStrEmty(this.breakerPs)) return false;
		return true;
	}
	get breakerQuantity(): number {
		return this._breakerQuantity;
	}
	set breakerQuantity(_SetVal: number) {
		this._breakerQuantity = _SetVal;
	}
	get breakerPs(): string {
		return this._breakerPsName;
	}
	set breakerPs(_SetVal: string) {
		this._breakerPsName = _SetVal;
	}


	static getObj(_json: any): BreakerPS {
		return new BreakerPS(_json.brkrPs, _json.brkrQty);
	}
	public getJson(): any {
		let _json: any = {};
		_json.brkrPs = this.breakerPs;
		_json.brkrQty = this.breakerQuantity;
		return _json;

	}
	cloneSelf() {
		return new BreakerPS(this.breakerPs, this.breakerQuantity);
	}

}
export class CommentsOnSubmission {
	constructor(private _commentRcvdOnSubActDate: Date, private _complainceAgnstCommentActDate: Date) {
	}
	get isfunctionComplete(): boolean {
		if (configDefs.isDtEmtyforComts(this.commentRcvdOnSubActDate)) {
			return false;
		}
		if (configDefs.isDtEmtyforComts(this.complainceAgnstCommentActDate)) {
			return false;
		}
		return true;
	}
	get commentRcvdOnSubActDate(): Date {
		return this._commentRcvdOnSubActDate;
	}
	set commentRcvdOnSubActDate(_SetVal: Date) {
		this._commentRcvdOnSubActDate = _SetVal;
	}
	get complainceAgnstCommentActDate(): Date {
		return this._complainceAgnstCommentActDate;
	}
	set complainceAgnstCommentActDate(_SetVal: Date) {
		this._complainceAgnstCommentActDate = _SetVal;
	}
	public static getObj(_json: any): CommentsOnSubmission {
		return new CommentsOnSubmission(_json.commentRcvdOnSubActDate, _json.complainceAgnstCommentActDat)
	}
	public getJson(): any {
		let _json: any = {};
		_json.commentRcvdOnSubActDate = this.commentRcvdOnSubActDate;
		_json.complainceAgnstCommentActDat = this.complainceAgnstCommentActDate;
		return _json;
	}
	cloneSelf() {

		return new CommentsOnSubmission(this.commentRcvdOnSubActDate, this.complainceAgnstCommentActDate);
	}


}


export class Equipment {
	constructor(private _equipmentType: string, private _breakerType: string, private _panelQuantity: string,
		private _earthSwithApplicability: string, private _earthSwitchQuantity: string,
		private _contractualValue: string, private _vscQuantity: string, private _totalBreakerQuantity: number,
		private _breakerPSList: Array<BreakerPS>) {
	}


	get isFunctionComplete(): boolean {
		//type of equip


		if (configDefs.isStrEmty(this.equipmentType)) return false;
		if (configDefs.isStrEmty(this.breakerType)) return false;
		if (configDefs.isStrEmty(this.contractualValue)) return false;
		// if (configDefs.isStrEmty(this.vscQuantity)) return false;

		if (this.breakerPSList.length > 0) {
			for (var i = 0; i < this.breakerPSList.length; i++) {
				if (this.breakerPSList[i].isFunctionComplete == false)
					return false;
			}
		}
		if (this.isEarthSwitchApplicable) {
			if (configDefs.isStrEmty(this.earthSwitchQuantity)) return false;
		}
		if (configDefs.isNumEmty(this.totalBreakerQuantity)) return false;

		if (configDefs.isStrEmty(this.panelQuantity)) return false;
		return true;
	}
	get equipmentType(): string {
		return this._equipmentType;
	}
	set equipmentType(_SetVal: string) {

		this._equipmentType = _SetVal;
	}
	get breakerType(): string {
		return this._breakerType;
	}
	set breakerType(_SetVal: string) {
		this._breakerType = _SetVal;
	}
	get panelQuantityNum(): number {
		let _tmpNum: number = parseInt(this.panelQuantity, 10);
		if (configDefs.isNumEmty(_tmpNum))
			return 0;
		return _tmpNum;
	}
	get panelQuantity(): string {
		return this._panelQuantity;
	}
	set panelQuantity(_SetVal: string) {
		this._panelQuantity = _SetVal;
	}

	get contractualValue(): string {

		return this._contractualValue;
	}
	set contractualValue(_SetVal: string) {
		this._contractualValue = _SetVal;
	}

	get vscQuantity(): string {
		let _vscQty: number = 0;
		let equip: BreakerType
		// console.log("BreakerPAS",this.breakerType);
		// console.log("BreakerPAS2",this.equipmentType);
		if (this.breakerType == '004' && (this.equipmentType == '009' || this.equipmentType == '010')) {
			this.breakerPSList.forEach((_brkps: BreakerPS) => {
				_vscQty += _brkps.breakerQuantity;
			})

		}

		this._vscQuantity = _vscQty.toString();
		//console.log("Breaker Quantity in VSC",this._totalBreakerQuantity);
		//console.log("VSC Quantity Check",this._vscQuantity);
		return this._vscQuantity;
	}
	set vscQuantity(_SetVal: string) {
		this._vscQuantity = _SetVal;
	}
	get breakerPSList(): Array<BreakerPS> {
		return this._breakerPSList;
	}
	set breakerPSList(_SetVal: Array<BreakerPS>) {
		this._breakerPSList = _SetVal;
	}

	// get totalBreakerQuantity() : string{
	// 	return this._totalBreakerQuantity;
	// }
	get totalBreakerQuantity(): number {
		let _brekerQty: number = 0;
		if (this.breakerType == '004' && (this.equipmentType == '009' || this.equipmentType == '010')) {
			this.breakerPSList.forEach((_brup: BreakerPS) => {
				_brekerQty += 0;
			})
		}
		else {
			this.breakerPSList.forEach((_brkps: BreakerPS) => {
				_brekerQty += _brkps.breakerQuantity;
			})
		}
		this._totalBreakerQuantity = _brekerQty;
		//console.log("Breaker Quantity Check",this._totalBreakerQuantity);
		//console.log("VSC Quantity in Breaker",this._vscQuantity);
		return this._totalBreakerQuantity;
	}
	set totalBreakerQuantity(_SetVal: number) {
		this._totalBreakerQuantity = _SetVal;
	}
	addBreakerPS(_newBrkePS: BreakerPS) {

		this._breakerPSList.push(_newBrkePS);
	}
	removeBreakerPS(_rmvBrkrPS: BreakerPS) {
		let index: number = this._breakerPSList.indexOf(_rmvBrkrPS);
		if (index >= 0) {
			this._breakerPSList.splice(index, 1);
		}
	}
	get earthSwithApplicability(): string {
		return this._earthSwithApplicability;
	}
	set earthSwithApplicability(_SetVal: string) {
		this._earthSwithApplicability = _SetVal;
	}
	get isEarthSwitchApplicable(): boolean {
		return this._earthSwithApplicability == "001";
	}
	get earthSwitchQuantity(): string {
		if (this.isEarthSwitchApplicable) {
			return this._earthSwitchQuantity;
		} else {
			return null;
		}
	}
	set earthSwitchQuantity(_SetVal: string) {
		this._earthSwitchQuantity = _SetVal;
	}


	public static getObj(_json: any): Equipment {
		let _brkPSList: Array<BreakerPS> = [];
		if (_json.brkPSList) {
			for (var i = 0; i < _json.brkPSList.length; i++) {
				_brkPSList.push(BreakerPS.getObj(_json.brkPSList[i]));
			}
		}
		if (_brkPSList.length == 0) {
			_brkPSList.push(new BreakerPS("", 0));
		}

		return new Equipment(_json.equpType, _json.brkrType, _json.PanelQty, _json.earthSwitchApplic, _json.earthSwitchQuantity, _json.contractualValu, _json.vscQuantit, _json.totalBreakerQuantity, _brkPSList);
	}
	public getJson(): any {
		let _json: any = {};

		let _brkrPSJson: Array<any> = [];
		for (var i = 0; i < this.breakerPSList.length; i++) {
			_brkrPSJson.push(this.breakerPSList[i].getJson());
		}

		_json.equpType = this.equipmentType;
		_json.brkrType = this.breakerType;
		_json.PanelQty = this.panelQuantity;
		_json.contractualValu = this.contractualValue;
		_json.vscQuantit = this.vscQuantity;
		_json.brkPSList = _brkrPSJson;
		_json.earthSwitchApplic = this.earthSwithApplicability;
		_json.earthSwitchQuantity = this.earthSwitchQuantity;

		return _json;

	}
	cloneSelf() {
		let _brkPSList: Array<BreakerPS> = [];
		for (var i = 0; i < this.breakerPSList.length; i++) {
			_brkPSList.push(this.breakerPSList[i].cloneSelf());
		}

		return new Equipment(this.equipmentType, this.breakerType, this.panelQuantity, this.earthSwithApplicability, this.earthSwitchQuantity, this.contractualValue, this.vscQuantity, this.totalBreakerQuantity, _brkPSList);
	}
}

export class ElectricalDesignEngineerKPI {
	public _date: Date;
	constructor(private _electricalDesignEngName: string, private _sldCS: number, private _schemesAndOtherDrgs: number, private _approvalSldGaAndCs: number,
		private _c40: number, private _c60: number) { }


	get electricalDesignEngName(): string {
		return this._electricalDesignEngName;
	}
	get sldCS(): number {
		return this._sldCS;
	}
	get schemesAndOtherDrgs(): number {
		return this._schemesAndOtherDrgs;
	}

	get approvalSldGaAndCs(): number {
		return this._approvalSldGaAndCs;
	}

	get c40(): number {
		return this._c40;
	}
	get c60(): number {
		return this._c60;
	}

	set electricalDesignEngName(_edeName: string) {
		this._electricalDesignEngName = _edeName;
	}
	set sldCS(_sldCs: number) {
		this._sldCS = _sldCs;
	}
	set schemesAndOtherDrgs(_schemesDrgs: number) {
		this._schemesAndOtherDrgs = _schemesDrgs;
	}
	set approvalSldGaAndCs(_approvalSldGaAndCs: number) {
		this._approvalSldGaAndCs = _approvalSldGaAndCs;
	}
	// set witnessQuantity(qty:number){
	//     this._witnessQuantity = qty;
	// }
	set c40(_c40: number) {
		this._c40 = _c40;
	}
	set c60(_c60: number) {
		this._c60 = _c60;
	}


	cloneSelf(): ElectricalDesignEngineerKPI {
		return new ElectricalDesignEngineerKPI(this._electricalDesignEngName, this._sldCS, this._schemesAndOtherDrgs,
			this._approvalSldGaAndCs, this._c40, this._c60)
	}
}

export class ElectricalDesignEngineerKPI2 {
	public _date: Date;
	constructor(private _electricalDesignEngName: string, private _totalQtySO: number, private _totalContractualValue: number, private _totalQtySOC30Done: number,
		private _totalContractualValueC30Done: number, private _totalQtySOC40Done: number, private _totalContractualValueC40Done: number,
		private _totalQtySODispatch: number, private _totalContractualValueDispatch: number) { }


	get electricalDesignEngName(): string {
		return this._electricalDesignEngName;
	}
	get totalQtySO(): number {
		return this._totalQtySO;
	}
	get totalContractualValue(): number {
		return this._totalContractualValue;
	}

	get totalQtySOC30Done(): number {
		return this._totalQtySOC30Done;
	}

	get totalContractualValueC30Done(): number {
		return this._totalContractualValueC30Done;
	}
	get totalQtySOC40Done(): number {
		return this._totalQtySOC40Done;
	}

	get totalContractualValueC40Done(): number {
		return this._totalContractualValueC40Done;
	}

	get totalQtySODispatch(): number {
		return this._totalQtySODispatch;
	}
	get totalContractualValueDispatch(): number {
		return this._totalContractualValueDispatch;
	}

	set electricalDesignEngName(_edeName: string) {
		this._electricalDesignEngName = _edeName;
	}
	set totalQtySO(totalQtySO: number) {
		this._totalQtySO = totalQtySO;
	}
	set totalContractualValue(totalContractualValue: number) {
		this._totalContractualValue = totalContractualValue;
	}
	set totalQtySOC30Done(totalQtySOC30Done: number) {
		this._totalQtySOC30Done = totalQtySOC30Done;
	}
	set totalContractualValueC30Done(totalContractualValueC30Done: number) {
		this._totalContractualValueC30Done = totalContractualValueC30Done;
	}
	set totalQtySOC40Done(_c40: number) {
		this._totalQtySOC40Done = _c40;
	}
	set totalContractualValueC40Done(totalContractualValueC40Done: number) {
		this._totalContractualValueC40Done = totalContractualValueC40Done;
	}
	set totalQtySODispatch(totalQtySODispatch: number) {
		this._totalQtySODispatch = totalQtySODispatch;
	}
	set totalContractualValueDispatch(totalContractualValueDispatch: number) {
		this._totalContractualValueDispatch = totalContractualValueDispatch;
	}

	cloneSelf(): ElectricalDesignEngineerKPI2 {
		return new ElectricalDesignEngineerKPI2(this._electricalDesignEngName, this._totalQtySO, this._totalContractualValue,
			this._totalQtySOC30Done, this._totalContractualValueC30Done, this._totalQtySOC40Done, this._totalContractualValueC40Done,
			this._totalQtySODispatch, this._totalContractualValueDispatch)
	}
}

export class MechanicalDesignEngineerKPI {
	public _date: Date;
	constructor(private _mechanicalDesignEngName: string, private _gaAndCrossSec: number, private _c50: number) { }


	get mechanicalDesignEngName(): string {
		return this._mechanicalDesignEngName;
	}
	get gaAndCrossSec(): number {
		return this._gaAndCrossSec;
	}
	get c50(): number {
		return this._c50;
	}

	set mechanicalDesignEngName(_Name: string) {
		this._mechanicalDesignEngName = _Name;
	}
	set gaAndCrossSec(_gaAndCrossSec: number) {
		this._gaAndCrossSec = _gaAndCrossSec;
	}
	set c50(_c50: number) {
		this._c50 = _c50;
	}

	cloneSelf(): MechanicalDesignEngineerKPI {
		return new MechanicalDesignEngineerKPI(this._mechanicalDesignEngName, this._gaAndCrossSec, this._c50)
	}
}

export class MechanicalDesignEngineerKPI2 {
	public _date: Date;
	constructor(private _mechanicalDesignEngName: string, private _totalQtySO: number, private _totalContractualValue: number, private _totalQtySOC50Done: number,
		private _totalContractualValueC50Done: number,
		private _totalQtySODispatch: number, private _totalContractualValueDispatch: number) { }


	get mechanicalDesignEngName(): string {
		return this._mechanicalDesignEngName;
	}
	get totalQtySO(): number {
		return this._totalQtySO;
	}
	get totalContractualValue(): number {
		return this._totalContractualValue;
	}

	get totalQtySOC50Done(): number {
		return this._totalQtySOC50Done;
	}

	get totalContractualValueC50Done(): number {
		return this._totalContractualValueC50Done;
	}

	get totalQtySODispatch(): number {
		return this._totalQtySODispatch;
	}
	get totalContractualValueDispatch(): number {
		return this._totalContractualValueDispatch;
	}

	set mechanicalDesignEngName(_mdeName: string) {
		this._mechanicalDesignEngName = _mdeName;
	}
	set totalQtySO(totalQtySO: number) {
		this._totalQtySO = totalQtySO;
	}
	set totalContractualValue(totalContractualValue: number) {
		this._totalContractualValue = totalContractualValue;
	}
	set totalQtySOC50Done(totalQtySOC50Done: number) {
		this._totalQtySOC50Done = totalQtySOC50Done;
	}
	set totalContractualValueC50Done(totalContractualValueC50Done: number) {
		this._totalContractualValueC50Done = totalContractualValueC50Done;
	}

	set totalQtySODispatch(totalQtySODispatch: number) {
		this._totalQtySODispatch = totalQtySODispatch;
	}
	set totalContractualValueDispatch(totalContractualValueDispatch: number) {
		this._totalContractualValueDispatch = totalContractualValueDispatch;
	}

	cloneSelf(): MechanicalDesignEngineerKPI2 {
		return new MechanicalDesignEngineerKPI2(this._mechanicalDesignEngName, this._totalQtySO, this._totalContractualValue,
			this._totalQtySOC50Done, this._totalContractualValueC50Done,
			this._totalQtySODispatch, this._totalContractualValueDispatch)
	}
}

export class ProjectEngineerKPI {
	constructor(private _projectEngName: string, private _drawingApprovalDate: number) { }


	get projectEngName(): string {
		return this._projectEngName;
	}

	get drawingApproval(): number {
		return this._drawingApprovalDate;
	}

	set projectEngName(_Name: string) {
		this._projectEngName = _Name;
	}
	set drawingApproval(_drawingApprovalDate: number) {
		this._drawingApprovalDate = _drawingApprovalDate;
	}

	cloneSelf(): ProjectEngineerKPI {
		return new ProjectEngineerKPI(this._projectEngName, this._drawingApprovalDate)
	}
}

export class ProjectEngineerKPI2 {
	public _date: Date;
	constructor(private _projectEngName: string, private _totalQtySO: number, private _totalContractualValue: number, private _totalQtySODrgApprovalDone: number,
		private _totalContractualValueDrgApprovalDone: number,
		private _totalQtySODispatch: number, private _totalContractualValueDispatch: number) { }


	get projectEngName(): string {
		return this._projectEngName;
	}
	get totalQtySO(): number {
		return this._totalQtySO;
	}
	get totalContractualValue(): number {
		return this._totalContractualValue;
	}

	get totalQtySODrgApprovalDone(): number {
		return this._totalQtySODrgApprovalDone;
	}

	get totalContractualValueDrgApprovalDone(): number {
		return this._totalContractualValueDrgApprovalDone;
	}

	get totalQtySODispatch(): number {
		return this._totalQtySODispatch;
	}
	get totalContractualValueDispatch(): number {
		return this._totalContractualValueDispatch;
	}

	set projectEngName(_peName: string) {
		this._projectEngName = _peName;
	}
	set totalQtySO(totalQtySO: number) {
		this._totalQtySO = totalQtySO;
	}
	set totalContractualValue(totalContractualValue: number) {
		this._totalContractualValue = totalContractualValue;
	}
	set totalQtySODrgApprovalDone(_totalQtySODrgApprovalDone: number) {
		this._totalQtySODrgApprovalDone = _totalQtySODrgApprovalDone;
	}
	set totalContractualValueDrgApprovalDone(_totalContractualValueDrgApprovalDone: number) {
		this._totalContractualValueDrgApprovalDone = _totalContractualValueDrgApprovalDone;
	}

	set totalQtySODispatch(totalQtySODispatch: number) {
		this._totalQtySODispatch = totalQtySODispatch;
	}
	set totalContractualValueDispatch(totalContractualValueDispatch: number) {
		this._totalContractualValueDispatch = totalContractualValueDispatch;
	}

	cloneSelf(): ProjectEngineerKPI2 {
		return new ProjectEngineerKPI2(this._projectEngName, this._totalQtySO, this._totalContractualValue,
			this._totalQtySODrgApprovalDone, this._totalContractualValueDrgApprovalDone,
			this._totalQtySODispatch, this._totalContractualValueDispatch)
	}
}

export class MarketingEngineerKPI2 {
	public _date: Date;
	constructor(private _marketingEngName: string, private _totalQtySO: number, private _totalContractualValue: number,
		private _totalQtyHandOver: number, private _totalContractualValueHandOver: number,
		private _totalQtySODispatch: number, private _totalContractualValueDispatch: number) { }


	get marketingEngName(): string {
		return this._marketingEngName;
	}
	get totalQtySO(): number {
		return this._totalQtySO;
	}
	get totalContractualValue(): number {
		return this._totalContractualValue;
	}

	get totalQtyHandOver(): number {
		return this._totalQtyHandOver;
	}

	get totalContractualValueHandOver(): number {
		return this._totalContractualValueHandOver;
	}

	get totalQtySODispatch(): number {
		return this._totalQtySODispatch;
	}
	get totalContractualValueDispatch(): number {
		return this._totalContractualValueDispatch;
	}

	set marketingEngName(_meName: string) {
		this._marketingEngName = _meName;
	}
	set totalQtySO(totalQtySO: number) {
		this._totalQtySO = totalQtySO;
	}
	set totalContractualValue(totalContractualValue: number) {
		this._totalContractualValue = totalContractualValue;
	}
	set totalQtyHandOver(_totalQtyHandOver: number) {
		this._totalQtyHandOver = _totalQtyHandOver;
	}
	set totalContractualValueHandOver(_totalContractualValueHandOver: number) {
		this._totalContractualValueHandOver = _totalContractualValueHandOver;
	}

	set totalQtySODispatch(totalQtySODispatch: number) {
		this._totalQtySODispatch = totalQtySODispatch;
	}
	set totalContractualValueDispatch(totalContractualValueDispatch: number) {
		this._totalContractualValueDispatch = totalContractualValueDispatch;
	}

	cloneSelf(): MarketingEngineerKPI2 {
		return new MarketingEngineerKPI2(this._marketingEngName, this._totalQtySO, this._totalContractualValue,
			this._totalQtyHandOver, this._totalContractualValueHandOver,
			this._totalQtySODispatch, this._totalContractualValueDispatch)
	}
}

export class ScmIP {
	constructor(private _ctFinalizationFromSCMPlannedToken: PlannedDateToken, private _ctFinalizationFromSCMActualToken: ActualDateToken,
		private _splMatFGivenbySCMtoEnggPlannedDateToken: PlannedDateToken, private _splMatFGivenbySCMtoEnggActualDateToken: ActualDateToken, private _status: FunctionStatus) {

	}
	private _parentSORef: SalesOrder;
	private _parentSubSORef: SubSalesOrder;

	refreshStatus() {
		if (this.parentSORef && this.parentSubSORef && this.parentSORef.projectStatus >= SOStatus.Sub_Orders) {
			if (this.parentSubSORef.isSSOStatusSet(SSOStatus.SCM) == true) {
				if (this.parentSubSORef.isSSOStatusSet(SSOStatus.Engg_Procurement_From_SCM) == true) {
					let _isTempComplete: boolean = this.isFunctionComplete();

					if (_isTempComplete == true) {
						this._status = FunctionStatus.SUBMITTED_COMPLETE;
					}
					else {
						this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
					}
				}
				else {
					this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
				}

			}
			else {
				this._status = FunctionStatus.WAITING_FOR_PREV;
			}
		}
		else {
			this._status = FunctionStatus.WAITING_FOR_PREV;
		}
	}
	enableFormInput(): void {
		if (this._status == FunctionStatus.WAITING_FOR_PREV) {
			this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
		}
	}
	get isProjectLive(): boolean {
		return this.parentSubSORef.pmTechSubSalesOrder.projStatus == "live"
	}
	get isInputEnabled(): boolean {
		return this.parentSubSORef.isSSOStatusSet(SSOStatus.SCM);
	}
	private isFunctionComplete(): boolean {
		if (configDefs.isDtEmty(this.ctFinalizationFromSCMPlannedDate)) return false;
		if (configDefs.isDtEmty(this.ctFinalizationFromSCMActualDate)) return false;
		if (this.isSplMatFinDatesEnabled) {
			if (configDefs.isDtEmty(this.splMatFGivenbySCMtoEnggPlannedDate)) return false;
			if (configDefs.isDtEmty(this.splMatFGivenbySCMtoEnggActualDate)) return false;

		}
		return true;
	}
	get isEnggProcurementSubmitted(): boolean {
		return this.parentSubSORef.isSSOStatusSet(SSOStatus.Engg_Procurement_From_SCM);
	}
	get readyForEnggProcurement(): boolean {
		if (this.ctFinalizationFromSCMActualDate) return true;
		return false;
	}
	get parentSORef(): SalesOrder {
		return this._parentSORef;
	}
	set parentSORef(SORef: SalesOrder) {
		this._parentSORef = SORef;
		//this.refreshStatus();
	}
	get parentSubSORef(): SubSalesOrder {
		return this._parentSubSORef;
	}
	set parentSubSORef(SubSORef: SubSalesOrder) {
		this._parentSubSORef = SubSORef;
	}
	get status(): FunctionStatus {
		return this._status;
	}
	get ctFinalizationFromSCMPlannedToken(): PlannedDateToken {
		return this._ctFinalizationFromSCMPlannedToken;
	}
	set ctFinalizationFromSCMPlannedToken(_SetVal: PlannedDateToken) {
		// if (this._ctFinalizationFromSCMPlannedToken.actualPlannedDate == null)
		// 	this._ctFinalizationFromSCMPlannedToken.actualPlannedDate = this.ctFinalizationFromSCMPlannedDate;
		this._ctFinalizationFromSCMPlannedToken.plannedDate = _SetVal.plannedDate;
		this._ctFinalizationFromSCMPlannedToken.isOveridden = _SetVal.isOveridden;
		this._ctFinalizationFromSCMPlannedToken.addNotes = _SetVal.addNotes;
		this._ctFinalizationFromSCMPlannedToken.userOveridden = _SetVal.userOveridden;
	}

	get ctFinalizationFromSCMPlannedDateLabel(): string {
		if (this.ctFinalizationFromSCMPlannedDateIsRevised == true) {
			return "CT Finalization From SCM Revised (Planned)"
		} else {
			return "CT Finalization From SCM Planned"
		}
	}
	get ctFinalizationFromSCMPlannedDateIsRevised(): boolean {
		if (this.ctFinalizationFromSCMPlannedDate_Initial && this.ctFinalizationFromSCMPlannedDate) {
			if (GenService.areDatesSame(this.ctFinalizationFromSCMPlannedDate_Initial, this.ctFinalizationFromSCMPlannedDate) == false) {
				return true;
			}
		}
		return false;
	}
	get ctFinalizationFromSCMPlannedDate_Initial(): Date {
		if (this._ctFinalizationFromSCMPlannedToken.actualPlannedDate == null || this._ctFinalizationFromSCMPlannedToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.pmTechSubSalesOrder.plannedCtFinalizationDate_Initial;

			if (_tmpDate != null && configDefs.defPlndCTFinalfrmSCMDays) {
				this._ctFinalizationFromSCMPlannedToken.actualPlannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndCTFinalfrmSCMDays);
			}
			else {
				this._ctFinalizationFromSCMPlannedToken.actualPlannedDate = null;
			}
		}
		return this._ctFinalizationFromSCMPlannedToken.actualPlannedDate;
	}
	get ctFinalizationFromSCMPlannedDate(): Date {
		if (this._ctFinalizationFromSCMPlannedToken.plannedDate == null || this._ctFinalizationFromSCMPlannedToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.pmTechSubSalesOrder.actualCtFinalizationDate;
			if (_tmpDate == null) {
				_tmpDate = this.parentSubSORef.pmTechSubSalesOrder.plannedCtFinalizationDate;
			}
			if (_tmpDate != null && configDefs.defPlndCTFinalfrmSCMDays) {
				this._ctFinalizationFromSCMPlannedToken.plannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndCTFinalfrmSCMDays);
			}
			else {
				this._ctFinalizationFromSCMPlannedToken.plannedDate = null;
			}
		}
		return this._ctFinalizationFromSCMPlannedToken.plannedDate;
	}
	private _ctFinalizationFromSCMPlannedGroup: RevisedDate;
	get ctFinalizationFromSCMPlannedGroup(): RevisedDate {
		this._ctFinalizationFromSCMPlannedGroup = new RevisedDate(this.ctFinalizationFromSCMPlannedDate_Initial, this.ctFinalizationFromSCMPlannedDateIsRevised, this.ctFinalizationFromSCMPlannedDate);

		return this._ctFinalizationFromSCMPlannedGroup;
	}
	set ctFinalizationFromSCMPlannedDate(_SetVal: Date) {
		this._ctFinalizationFromSCMPlannedToken.plannedDate = _SetVal;
	}
	get ctFinalizationFromSCMActualToken(): ActualDateToken {
		return this._ctFinalizationFromSCMActualToken;
	}
	set ctFinalizationFromSCMActualToken(_SetVal: ActualDateToken) {
		if (this._ctFinalizationFromSCMActualToken.expActualDate == null)
			this._ctFinalizationFromSCMActualToken.expActualDate = this.ctFinalizationFromSCMPlannedDate;
		this._ctFinalizationFromSCMActualToken.actualDate = _SetVal.actualDate;
		this._ctFinalizationFromSCMActualToken.isOveridden = _SetVal.isOveridden;
		this._ctFinalizationFromSCMActualToken.addNotes = _SetVal.addNotes;
		this._ctFinalizationFromSCMActualToken.userOveridden = _SetVal.userOveridden;
	}
	get ctFinalizationFromSCMActualDate(): Date {
		return this._ctFinalizationFromSCMActualToken.actualDate;
	}
	set ctFinalizationFromSCMActualDate(_SetVal: Date) {
		//	console.log("Possible wrong place for execution, not supposed to set ctFinalizationFromSCMActualDate directly");
		this._ctFinalizationFromSCMActualToken.actualDate = _SetVal;
	}

	get splMatFGvnbySCMtoEnggPlannedToken(): PlannedDateToken {
		return this._splMatFGivenbySCMtoEnggPlannedDateToken;
	}
	set splMatFGvnbySCMtoEnggPlannedToken(_SetVal: PlannedDateToken) {
		// if (this._splMatFGivenbySCMtoEnggPlannedDateToken.actualPlannedDate == null)
		// 	this._splMatFGivenbySCMtoEnggPlannedDateToken.actualPlannedDate = this.splMatFGivenbySCMtoEnggPlannedDate;
		this._splMatFGivenbySCMtoEnggPlannedDateToken.plannedDate = _SetVal.plannedDate;
		this._splMatFGivenbySCMtoEnggPlannedDateToken.isOveridden = _SetVal.isOveridden;
		this._splMatFGivenbySCMtoEnggPlannedDateToken.addNotes = _SetVal.addNotes;
		this._splMatFGivenbySCMtoEnggPlannedDateToken.userOveridden = _SetVal.userOveridden;
	}
	get splMatFGivenbySCMtoEnggPlannedDateLabel(): string {
		if (this.splMatFGivenbySCMtoEnggPlannedDateIsRevised == true && this.parentSubSORef.enggDrawIP.isSplMatPapplicable == true) {
			return "Special Material Finalization From SCM Revised (Planned)"
		}
		else {
			return "Special Material Finalization From SCM Planned"
		}
	}
	get splMatFGivenbySCMtoEnggPlannedDateIsRevised(): boolean {
		if (this.splMatFGivenbySCMtoEnggPlannedDate_Initial && this.splMatFGivenbySCMtoEnggPlannedDate) {
			if (GenService.areDatesSame(this.splMatFGivenbySCMtoEnggPlannedDate_Initial, this.splMatFGivenbySCMtoEnggPlannedDate) == false) {
				return true;
			}
		}
		return false;
	}
	get splMatFGivenbySCMtoEnggPlannedDate_Initial(): Date {
		if (this.parentSubSORef.enggDrawIP.isSplMatPapplicable == true) {
			if (this._splMatFGivenbySCMtoEnggPlannedDateToken.actualPlannedDate == null || this._splMatFGivenbySCMtoEnggPlannedDateToken.isOveridden == false) {
				var _tmpDate = this.parentSubSORef.pmTechSubSalesOrder.splMatPriceFinalizationPlannedDate_Initial;
				if (_tmpDate != null && configDefs.defSplMatPSCmDays) {
					this._splMatFGivenbySCMtoEnggPlannedDateToken.actualPlannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defSplMatPSCmDays);
				}
				else {
					this._splMatFGivenbySCMtoEnggPlannedDateToken.actualPlannedDate = null;
				}
			}
			return this._splMatFGivenbySCMtoEnggPlannedDateToken.actualPlannedDate;
		}
		return null;
	}
	get splMatFGivenbySCMtoEnggPlannedDate(): Date {
		if (this.parentSubSORef.enggDrawIP.isSplMatPapplicable == true) {
			if (this._splMatFGivenbySCMtoEnggPlannedDateToken.plannedDate == null || this._splMatFGivenbySCMtoEnggPlannedDateToken.isOveridden == false) {

				var _tmpDate = this.parentSubSORef.pmTechSubSalesOrder.splMatFinalizationActualDate;
				if (_tmpDate == null) {
					_tmpDate = this.parentSubSORef.pmTechSubSalesOrder.splMatPriceFinalizationPlannedDate;
				}
				if (_tmpDate != null && configDefs.defSplMatPSCmDays) {
					this._splMatFGivenbySCMtoEnggPlannedDateToken.plannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defSplMatPSCmDays);
				}
				else {
					this._splMatFGivenbySCMtoEnggPlannedDateToken.plannedDate = null;
				}
			}
			return this._splMatFGivenbySCMtoEnggPlannedDateToken.plannedDate;
		}
		return null;
	}
	private _splMatFGivenbySCMtoEnggPlannedGroup: RevisedDate;
	get splMatFGivenbySCMtoEnggPlannedGroup(): RevisedDate {
		this._splMatFGivenbySCMtoEnggPlannedGroup = new RevisedDate(this.splMatFGivenbySCMtoEnggPlannedDate_Initial, this.splMatFGivenbySCMtoEnggPlannedDateIsRevised, this.splMatFGivenbySCMtoEnggPlannedDate);

		return this._splMatFGivenbySCMtoEnggPlannedGroup;
	}
	set splMatFGivenbySCMtoEnggPlannedDate(_SetVal: Date) {
		this._splMatFGivenbySCMtoEnggPlannedDateToken.plannedDate = _SetVal;
	}

	get splMatFGvnbySCMtoEnggActualToken(): ActualDateToken {
		return this._splMatFGivenbySCMtoEnggActualDateToken;
	}
	set splMatFGvnbySCMtoEnggActualToken(_SetVal: ActualDateToken) {
		if (this._splMatFGivenbySCMtoEnggActualDateToken.expActualDate == null)
			this._splMatFGivenbySCMtoEnggActualDateToken.expActualDate = this.splMatFGivenbySCMtoEnggPlannedDate;
		this._splMatFGivenbySCMtoEnggActualDateToken.actualDate = _SetVal.actualDate;
		this._splMatFGivenbySCMtoEnggActualDateToken.isOveridden = _SetVal.isOveridden;
		this._splMatFGivenbySCMtoEnggActualDateToken.addNotes = _SetVal.addNotes;
		this._splMatFGivenbySCMtoEnggActualDateToken.userOveridden = _SetVal.userOveridden;
	}
	get isSplMatPriceDatesEnabled(): boolean {
		if (this.parentSubSORef.enggDrawIP.isSplMatPapplicable &&
			(configDefs.isDtEmty(this.parentSubSORef.enggDrawIP.splMatActualDate) == false)
		) {
			return true;
		}
		return false;
	}
	get splMatFGivenbySCMtoEnggActualDate(): Date {
		if (this.isSplMatPriceDatesEnabled == false) {
			this._splMatFGivenbySCMtoEnggActualDateToken.actualDate = null;
		}
		return this._splMatFGivenbySCMtoEnggActualDateToken.actualDate;
	}
	set splMatFGivenbySCMtoEnggActualDate(_SetVal: Date) {
		//	console.log("Possible wrong place for execution, not supposed to set ctFinalizationFromSCMActualDate directly");
		this._splMatFGivenbySCMtoEnggActualDateToken.actualDate = _SetVal;
	}
	get isSplMatFinDatesEnabled(): boolean {
		if (this.parentSubSORef.enggDrawIP.isSplMatPapplicable &&
			(configDefs.isDtEmty(this.parentSubSORef.enggDrawIP.splMatActualDate) == false)
		) {
			return true;
		}
		return false;
	}
	get isSplMaterialpriceActualdatesGivenInSCM(): boolean {
		if (this.isSplMatFinDatesEnabled && (configDefs.isDtEmty(this.splMatFGivenbySCMtoEnggActualDate) == false))

			return true;

		return false;
	}

	// STARTS

	get CTfinSCMActDate(): string {
		let _CTfinDate: Date = this.ctFinalizationFromSCMActualDate;

		if (_CTfinDate != null) {
			return formatDate(_CTfinDate, 'dd-MMM-yy', 'en-IN');
		}
		return null;
	}

	// ENDS

	cloneSelf() {
		return new ScmIP(this._ctFinalizationFromSCMPlannedToken.cloneSelf(), this._ctFinalizationFromSCMActualToken.cloneSelf(), this._splMatFGivenbySCMtoEnggPlannedDateToken.cloneSelf(),
			this._splMatFGivenbySCMtoEnggActualDateToken.cloneSelf(), this.status);
	}
	public static getObj(_json: any): ScmIP {
		return new ScmIP(convDefs.convToPlannedDateToken(_json.ctFinalSCMPlanToken), convDefs.convToActualDateToken(_json.ctFinalSCMActToken),
			convDefs.convToPlannedDateToken(_json.splMatFinalSCMtoEnggPlanToken), convDefs.convToActualDateToken(_json.splMatFinalSCMtoEnggActToken), _json.status);
	}
	public getJson(): any {
		let _json: any = {};

		_json.ctFinalSCMPlanToken = this.ctFinalizationFromSCMPlannedToken.getJson();
		_json.ctFinalSCMActToken = this.ctFinalizationFromSCMActualToken.getJson();
		_json.splMatFinalSCMtoEnggPlanToken = this.splMatFGvnbySCMtoEnggPlannedToken.getJson();
		_json.splMatFinalSCMtoEnggActToken = this.splMatFGvnbySCMtoEnggActualToken.getJson();

		_json.status = this.status;

		return _json;
	}
}

// Audit entry for SLD Submission Date propagation across sub-orders (see EnggDrawIP.applySLDDatePropagation)
export class SLDPropagationLog {
	constructor(public sourceSubOrderId: string, public targetSubOrderIds: Array<string>,
		public uploadDate: Date, public uploadedByUserId: string, public timestamp: Date) {
	}
	cloneSelf(): SLDPropagationLog {
		return new SLDPropagationLog(this.sourceSubOrderId, (this.targetSubOrderIds || []).slice(),
			configDefs.cloneDt(this.uploadDate), this.uploadedByUserId, configDefs.cloneDt(this.timestamp));
	}
	static getObj(_j: any): SLDPropagationLog {
		if (!_j) return null;
		return new SLDPropagationLog(
			_j.sourceSubOrderId,
			Array.isArray(_j.targetSubOrderIds) ? _j.targetSubOrderIds.slice() : [],
			GenService.convToDate(_j.uploadDate),
			_j.uploadedByUserId,
			GenService.convToDate(_j.timestamp)
		);
	}
	getJson(): any {
		return {
			sourceSubOrderId: this.sourceSubOrderId,
			targetSubOrderIds: (this.targetSubOrderIds || []).slice(),
			uploadDate: GenService.convToDateNum(this.uploadDate),
			uploadedByUserId: this.uploadedByUserId,
			timestamp: GenService.convToDateNum(this.timestamp)
		};
	}
}

export class SLDPropagationResult {
	constructor(public sourceSubOrderId: string,
		public updated: Array<string>,
		public skipped: Array<{ subOrderNoId: string, reason: string }>,
		public uploadDate: Date, public timestamp: Date) {
	}
}

export class SchemePropagationLog {
	constructor(public sourceSubOrderId: string, public targetSubOrderIds: Array<string>,
		public uploadDate: Date, public uploadedByUserId: string, public timestamp: Date) {
	}
	cloneSelf(): SchemePropagationLog {
		return new SchemePropagationLog(this.sourceSubOrderId, (this.targetSubOrderIds || []).slice(),
			configDefs.cloneDt(this.uploadDate), this.uploadedByUserId, configDefs.cloneDt(this.timestamp));
	}
	static getObj(_j: any): SchemePropagationLog {
		if (!_j) return null;
		return new SchemePropagationLog(
			_j.sourceSubOrderId,
			Array.isArray(_j.targetSubOrderIds) ? _j.targetSubOrderIds.slice() : [],
			GenService.convToDate(_j.uploadDate),
			_j.uploadedByUserId,
			GenService.convToDate(_j.timestamp)
		);
	}
	getJson(): any {
		return {
			sourceSubOrderId: this.sourceSubOrderId,
			targetSubOrderIds: (this.targetSubOrderIds || []).slice(),
			uploadDate: GenService.convToDateNum(this.uploadDate),
			uploadedByUserId: this.uploadedByUserId,
			timestamp: GenService.convToDateNum(this.timestamp)
		};
	}
}

export class SchemePropagationResult {
	constructor(public sourceSubOrderId: string,
		public updated: Array<string>,
		public skipped: Array<{ subOrderNoId: string, reason: string }>,
		public uploadDate: Date, public timestamp: Date) {
	}
}

export class EnggDrawIP {
	constructor(private _electricalDesignEngineerId: string, private _mechanicalDesignEngineerId: string, private _c30EngineerId: string, private _initialSLDSubmissionActualDateToken: ActualDateToken,
		private _initialGAFDSubmissionActualDateToken: ActualDateToken, private _initialSchematicDBOMSubmissionActualDateToken: ActualDateToken, private _initialGTPCTPTBBSizingCalcSubmissionActualDateToken: ActualDateToken,
		private _finalDrawingSubmissionActualDateToken: ActualDateToken,
		// STARTS
		private _plannedMGAToken: PlannedDateToken, private _actualMGAToken: ActualDateToken,
		// ENDS
		private _sldGtpUploads: GenFileUploads, private _revSldGtpUploads: GenFileUploads, private _schemeUploads: GenFileUploads,
		private _gafMgaUploads: GenFileUploads, private _revGafMgaUploads: GenFileUploads,
		private _splMatPriceApplicableId: string, private _splMatPlannedDateToken: PlannedDateToken, private _splMatActualDateToken: ActualDateToken, private _ctFinalizationGivenByEnggToPMPlannedToken: PlannedDateToken, private _ctFinalizationGivenByEnggToPMActualToken: ActualDateToken,
		private _plannedSLDGAApprovalToken: PlannedDateToken, private _actualSLDGAApprovalToken: ActualDateToken, private _status: FunctionStatus) {
		if (!this._c30EngineerId) this._c30EngineerId = "001";
	}
	private _parentSORef: SalesOrder;
	private _parentSubSORef: SubSalesOrder;

	refreshStatus() {
		if (this.parentSORef && this.parentSubSORef && this.parentSORef.projectStatus >= SOStatus.Sub_Orders) {
			if (this.parentSubSORef.isSSOStatusSet(SSOStatus.Engg_Draw) == true) {
				if (this.parentSubSORef.isSSOStatusSet(SSOStatus.Engg_Procurement_From_EnggDraw) == true) {
					let _isTempComplete: boolean = this.isFunctionComplete();

					if (_isTempComplete == true) {
						this._status = FunctionStatus.SUBMITTED_COMPLETE;
					}
					else {
						this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
					}
				}
				else {
					this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
				}

			}
			else {
				this._status = FunctionStatus.WAITING_FOR_PREV;
			}
		}
		else {
			this._status = FunctionStatus.WAITING_FOR_PREV;
		}
	}

	private isFunctionComplete(): boolean {
		if (configDefs.isStrEmty(this.electricalDesignEngineerId)) return false;
		if (configDefs.isStrEmty(this.mechanicalDesignEngineerId)) return false;
		if (configDefs.isStrEmty(this.c30EngineerId)) return false;
		if (configDefs.isDtEmty(this.initialSLDSubmissionDateActual)) return false;
		if (configDefs.isDtEmty(this.initialGAFDSubmissionDateActual)) return false;
		if (configDefs.isDtEmty(this.initialSchematicDBOMSubmissionDateActual)) return false;
		if (configDefs.isDtEmty(this.initialGTPCTPTBBSizingCalcSubmissionDateActual)) return false;
		if (configDefs.isDtEmty(this.finalDrawingSubmissionDateActual)) return false;
		if (configDefs.isDtEmty(this.plannedMGADate)) return false;
		if (configDefs.isDtEmty(this.actualMGADate)) return false;
		if (configDefs.isDtEmty(this.ctFinalizationGivenByEnggToPMPlannedDate)) return false;
		if (configDefs.isDtEmty(this.ctFinalizationGivenByEnggToPMActualDate)) return false;
		if (configDefs.isDtEmty(this.plannedSLDGAApprovalDate)) return false;
		if (configDefs.isDtEmty(this.actualSLDGAApprovalDate)) return false;
		if (configDefs.isStrEmty(this.specialMatPriceApplicabilityId)) return false;
		if (this.isSplMatPapplicable) {
			if (configDefs.isDtEmty(this.splMatPlannedDate)) return false;
			if (configDefs.isDtEmty(this.splMatActualDate)) return false;
		}

		return true;
	}

	get isProjectLive(): boolean {
		return this.parentSubSORef.pmTechSubSalesOrder.projStatus == "live";
	}

	get isInputEnabled(): boolean {
		return this.parentSubSORef.isSSOStatusSet(SSOStatus.Engg_Draw);
	}

	get status(): FunctionStatus {
		return this._status;
	}
	enableFormInput(): void {
		if (this._status == FunctionStatus.WAITING_FOR_PREV) {
			this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
		}
	}

	get enggDays(): number {
		let _ctFEnggToPmDays: number = configDefs.getDaysDifference(this.ctFinalizationGivenByEnggToPMPlannedDate, this.ctFinalizationGivenByEnggToPMActualDate);
		let _sldGADays: number = configDefs.getDaysDifference(this.plannedSLDGAApprovalDate, this.actualSLDGAApprovalDate);
		return configDefs.getMinValue([_ctFEnggToPmDays, _sldGADays]);
	}

	// STARTS
	get sldgtpSubDate(): string {
		let _sldDate: Date = this.initialSLDSubmissionDateActual;
		let _gtpDate: Date = this.initialGTPCTPTBBSizingCalcSubmissionDateActual;

		if (_sldDate == null) {
			if (_gtpDate != null) {
				return formatDate(_gtpDate, 'dd-MMM-yy', 'en-IN');
			}
			else return null;
		}
		return formatDate(_sldDate, 'dd-MMM-yy', 'en-IN');
	}

	get gacsSubDate(): string {
		let _gacsDate: Date = this.initialGAFDSubmissionDateActual;
		if (_gacsDate != null) {
			return formatDate(_gacsDate, 'dd-MMM-yy', 'en-IN');
		}
		return null;
	}

	get schemeSubDate(): string {
		let _schDate: Date = this.initialSchematicDBOMSubmissionDateActual;
		if (_schDate != null) {
			return formatDate(_schDate, 'dd-MMM-yy', 'en-IN');
		}
		return null;
	}

	get mgaSubDate(): string {
		let _mgaDate_act: Date = this.actualMGADate;
		let _finalDrawDate: Date = this.parentSubSORef.pmTechSubSalesOrder.actualDrawingApprovalDate;

		if (_finalDrawDate == null) {
			if (_mgaDate_act != null) {
				return formatDate(_mgaDate_act, 'dd-MMM-yy', 'en-IN');
			}
			else return null;
		}
		return formatDate(_finalDrawDate, 'dd-MMM-yy', 'en-IN');
	}

	get mgaSubDateStatus(): string {
		let _mgaDate_act: Date = this.actualMGADate;
		let _finalDrawDate: Date = this.parentSubSORef.pmTechSubSalesOrder.actualDrawingApprovalDate;

		if (_finalDrawDate == null) {
			if (_mgaDate_act != null) {
				return formatDate(_mgaDate_act, 'dd-MMM-yy', 'en-IN');
			}
			else return null;
		}
		return formatDate(_finalDrawDate, 'dd-MMM-yy', 'en-IN');
	}

	get sldGaGtpAprvlDate(): string {
		let _sggactDate: Date = this.actualSLDGAApprovalDate;

		if (_sggactDate != null) {
			return formatDate(_sggactDate, 'dd-MMM-yy', 'en-IN');
		}

		return null;
	}

	get techCTDetsDate(): string {
		let _techCTDate: Date = this.ctFinalizationGivenByEnggToPMActualDate;

		if (_techCTDate != null) {
			return formatDate(_techCTDate, 'dd-MMM-yy', 'en-IN');
		}

		return null;
	}

	// ENDS

	get enggDaysTip(): string {
		let _tmpCTFinPlannedDate: Date = this.ctFinalizationGivenByEnggToPMPlannedDate
		let _tmpCTFinActualDate: Date = this.ctFinalizationGivenByEnggToPMActualDate
		let _tmpSLDGAPlannedDate: Date = this.plannedSLDGAApprovalDate
		let _tmpSLDGAActualDate: Date = this.actualSLDGAApprovalDate
		let _ctFEnggToPmDays: number = configDefs.getDaysDifference(this.ctFinalizationGivenByEnggToPMPlannedDate, this.ctFinalizationGivenByEnggToPMActualDate);
		let _sldGADays: number = configDefs.getDaysDifference(this.plannedSLDGAApprovalDate, this.actualSLDGAApprovalDate);
		if (_ctFEnggToPmDays || _sldGADays) {
			return 'CT Finalization Given by Engg to PM : \r\n' +
				'\tPlanned\t> ' + moment(_tmpCTFinPlannedDate).format(configDefs.dateFormat) + '\r\n' +
				'\tActual\t> ' + moment(_tmpCTFinActualDate).format(configDefs.dateFormat) + '\r\n' +
				'\tDiff Days\t> ' + _ctFEnggToPmDays + '\r\n\n' +
				'SLD GA Approval Date : \r\n' +
				'\tPlanned\t> ' + moment(_tmpSLDGAPlannedDate).format(configDefs.dateFormat) + '\r\n' +
				'\tActual\t> ' + moment(_tmpSLDGAActualDate).format(configDefs.dateFormat) + '\r\n' +
				'\tDiff Days\t> ' + _sldGADays;
		}
		return '';
	}
	get parentSORef(): SalesOrder {
		return this._parentSORef;
	}
	set parentSORef(SORef: SalesOrder) {
		this._parentSORef = SORef;
		//this.refreshStatus();
	}
	get parentSubSORef(): SubSalesOrder {
		return this._parentSubSORef;
	}
	set parentSubSORef(SubSORef: SubSalesOrder) {
		this._parentSubSORef = SubSORef;
	}
	get isEnggProcSubmitted(): boolean {
		return this.parentSubSORef.isSSOStatusSet(SSOStatus.Engg_Procurement_From_EnggDraw);
	}
	get readyForEnggProcurement(): boolean {
		if (this.actualSLDGAApprovalDate) return true;
		return false;
	}
	// STARTS
	// get isSCMSubmitted(): boolean {
	//     return this.parentSubSORef.isSSOStatusSet(SSOStatus.SCM);
	// }
	// get readyForSCM(): boolean {
	//     if (this.ctFinalizationGivenByEnggToPMActualDate){
	//         return true;
	//     }
	//     return false;
	// }

	get isPMTechScmSumitted(): boolean {
		return this.parentSubSORef.isSSOStatusSet(SSOStatus.PM_Tech_EnggDraw || SSOStatus.SCM);
	}
	get readyForPMScm(): boolean {
		if (this.ctFinalizationGivenByEnggToPMActualDate &&
			((this.isSplMatPapplicable == false) || this.splMatActualDate)) return true;
		return false;
	}
	// ENDS
	get isPMTechSubmitted(): boolean {
		return this.parentSubSORef.isSSOStatusSet(SSOStatus.PM_Tech_EnggDraw);
	}
	get readyForPMTech(): boolean {
		if (this.ctFinalizationGivenByEnggToPMActualDate &&
			((this.isSplMatPapplicable == false) || this.splMatActualDate)
		) {
			return true;
		}
		return false;
	}
	get electricalDesignEngineerId(): string {
		return this._electricalDesignEngineerId;
	}
	set electricalDesignEngineerId(_SetVal: string) {
		this._electricalDesignEngineerId = _SetVal;
	}
	get mechanicalDesignEngineerId(): string {
		return this._mechanicalDesignEngineerId;
	}
	set mechanicalDesignEngineerId(_SetVal: string) {
		this._mechanicalDesignEngineerId = _SetVal;
	}
	get c30EngineerId(): string {
		return this._c30EngineerId;
	}
	set c30EngineerId(_SetVal: string) {
		this._c30EngineerId = _SetVal;
	}
	get initialSLDSubmissionActualDateToken(): ActualDateToken {
		return this._initialSLDSubmissionActualDateToken;
	}
	set initialSLDSubmissionActualDateToken(_SetVal: ActualDateToken) {
		if (this._initialSLDSubmissionActualDateToken.expActualDate == null)
			this._initialSLDSubmissionActualDateToken.expActualDate = this.parentSubSORef.pmTechSubSalesOrder.plannedSldSubmissionDate;
		this._initialSLDSubmissionActualDateToken.actualDate = _SetVal.actualDate;
		this._initialSLDSubmissionActualDateToken.isOveridden = _SetVal.isOveridden;
		this._initialSLDSubmissionActualDateToken.addNotes = _SetVal.addNotes;
		this._initialSLDSubmissionActualDateToken.userOveridden = _SetVal.userOveridden;
	}
	get initialSLDSubmissionDateActual(): Date {
		// return this._initialSLDSubmissionActualDateToken.actualDate;
		var fileA = this.sldGtpUploads.FileArray;

		if (this._initialSLDSubmissionActualDateToken.actualDate == null) {
			if (fileA.length > 0) {
				if (fileA[0].DateTime) { // #TODO :Few data have no DateTime field
					this._initialSLDSubmissionActualDateToken.actualDate = new Date(fileA[0].DateTime.toDateString());
				}
				this._initialSLDSubmissionActualDateToken.userOveridden = fileA[0].username;
				this._initialSLDSubmissionActualDateToken.addNotes = "Auto Date Updated By System";
				this._initialSLDSubmissionActualDateToken.expActualDate = this.parentSubSORef.pmTechSubSalesOrder.plannedSldSubmissionDate;
				return this._initialSLDSubmissionActualDateToken.actualDate;
			}
		}
		else if (this._initialSLDSubmissionActualDateToken.actualDate != null) {
			return this._initialSLDSubmissionActualDateToken.actualDate;
		}

	}
	set initialSLDSubmissionDateActual(_SetVal: Date) {
		// console.log("Possible wrong place for execution, not supposed to set initialSLDSubmissionDateActual directly");
		this._initialSLDSubmissionActualDateToken.actualDate = _SetVal;
	}
	get initialGAFDSubmissionActualDateToken(): ActualDateToken {
		return this._initialGAFDSubmissionActualDateToken;
	}
	set initialGAFDSubmissionActualDateToken(_SetVal: ActualDateToken) {
		if (this._initialGAFDSubmissionActualDateToken.expActualDate == null)
			this._initialGAFDSubmissionActualDateToken.expActualDate = this.parentSubSORef.pmTechSubSalesOrder.plannedGaDrawingSubmissionDate;
		this._initialGAFDSubmissionActualDateToken.actualDate = _SetVal.actualDate;
		this._initialGAFDSubmissionActualDateToken.isOveridden = _SetVal.isOveridden;
		this._initialGAFDSubmissionActualDateToken.addNotes = _SetVal.addNotes;
		this._initialGAFDSubmissionActualDateToken.userOveridden = _SetVal.userOveridden;
	}
	get initialGAFDSubmissionDateActual(): Date {
		return this._initialGAFDSubmissionActualDateToken.actualDate;
	}
	set initialGAFDSubmissionDateActual(_SetVal: Date) {
		// console.log("Possible wrong place for execution, not supposed to set initialGAFDSubmissionDateActual directly");
		this._initialGAFDSubmissionActualDateToken.actualDate = _SetVal;
	}
	get initialSchematicDBOMSubmissionActualDateToken(): ActualDateToken {
		return this._initialSchematicDBOMSubmissionActualDateToken;
	}
	set initialSchematicDBOMSubmissionActualDateToken(_SetVal: ActualDateToken) {
		if (this._initialSchematicDBOMSubmissionActualDateToken.expActualDate == null)
			this._initialSchematicDBOMSubmissionActualDateToken.expActualDate = this.parentSubSORef.pmTechSubSalesOrder.plannedSchematicDrawingDate;
		this._initialSchematicDBOMSubmissionActualDateToken.actualDate = _SetVal.actualDate;
		this._initialSchematicDBOMSubmissionActualDateToken.isOveridden = _SetVal.isOveridden;
		this._initialSchematicDBOMSubmissionActualDateToken.addNotes = _SetVal.addNotes;
		this._initialSchematicDBOMSubmissionActualDateToken.userOveridden = _SetVal.userOveridden;
	}
	get initialSchematicDBOMSubmissionDateActual(): Date {
		// return this._initialSchematicDBOMSubmissionActualDateToken.actualDate;
		var fileB = this.schemeUploads.FileArray;

		if (this._initialSchematicDBOMSubmissionActualDateToken.actualDate == null) {
			if (fileB.length > 0) {
				this._initialSchematicDBOMSubmissionActualDateToken.actualDate = new Date(fileB[0].DateTime.toDateString());
				this._initialSchematicDBOMSubmissionActualDateToken.addNotes = "Auto Date Updated By System";
				this._initialSchematicDBOMSubmissionActualDateToken.userOveridden = fileB[0].username;
				this._initialSchematicDBOMSubmissionActualDateToken.expActualDate = this.parentSubSORef.pmTechSubSalesOrder.plannedSchematicDrawingDate;
				return this._initialSchematicDBOMSubmissionActualDateToken.actualDate;
			}
		}
		else if (this._initialSchematicDBOMSubmissionActualDateToken.actualDate != null) {
			return this._initialSchematicDBOMSubmissionActualDateToken.actualDate;
		}
	}
	set initialSchematicDBOMSubmissionDateActual(_SetVal: Date) {
		// console.log("Possible wrong place for execution, not supposed to set initialSchematicDBOMSubmissionDateActual directly");
		this._initialSchematicDBOMSubmissionActualDateToken.actualDate = _SetVal;
	}
	get initialGTPCTPTBBSizingCalcSubmissionActualDateToken(): ActualDateToken {
		return this._initialGTPCTPTBBSizingCalcSubmissionActualDateToken;
	}
	set initialGTPCTPTBBSizingCalcSubmissionActualDateToken(_SetVal: ActualDateToken) {
		if (this._initialGTPCTPTBBSizingCalcSubmissionActualDateToken.expActualDate == null)
			this._initialGTPCTPTBBSizingCalcSubmissionActualDateToken.expActualDate = this.parentSubSORef.pmTechSubSalesOrder.plannedSizingCalSubmissionDate;
		this._initialGTPCTPTBBSizingCalcSubmissionActualDateToken.actualDate = _SetVal.actualDate;
		this._initialGTPCTPTBBSizingCalcSubmissionActualDateToken.isOveridden = _SetVal.isOveridden;
		this._initialGTPCTPTBBSizingCalcSubmissionActualDateToken.addNotes = _SetVal.addNotes;
		this._initialGTPCTPTBBSizingCalcSubmissionActualDateToken.userOveridden = _SetVal.userOveridden;
	}
	get initialGTPCTPTBBSizingCalcSubmissionDateActual(): Date {
		// return this._initialGTPCTPTBBSizingCalcSubmissionActualDateToken.actualDate;
		var fileA = this.revSldGtpUploads.FileArray;

		if (this._initialGTPCTPTBBSizingCalcSubmissionActualDateToken.actualDate == null) {
			if (fileA.length > 0) {
				if (fileA[0].DateTime) { // #TODO :Few data have no DateTime field
					this._initialGTPCTPTBBSizingCalcSubmissionActualDateToken.actualDate = new Date(fileA[0].DateTime.toDateString());
				}
				this._initialGTPCTPTBBSizingCalcSubmissionActualDateToken.userOveridden = fileA[0].username;
				this._initialGTPCTPTBBSizingCalcSubmissionActualDateToken.addNotes = "Auto Date Updated By System";
				this._initialGTPCTPTBBSizingCalcSubmissionActualDateToken.expActualDate = this.parentSubSORef.pmTechSubSalesOrder.plannedSizingCalSubmissionDate;
				return this._initialGTPCTPTBBSizingCalcSubmissionActualDateToken.actualDate;
			}
		}
		else if (this._initialGTPCTPTBBSizingCalcSubmissionActualDateToken.actualDate != null) {
			return this._initialGTPCTPTBBSizingCalcSubmissionActualDateToken.actualDate;
		}
	}
	set initialGTPCTPTBBSizingCalcSubmissionDateActual(_SetVal: Date) {
		// console.log("Possible wrong place for execution, not supposed to set initialGTPCTPTBBSizingCalcSubmissionDateActual directly");
		this._initialGTPCTPTBBSizingCalcSubmissionActualDateToken.actualDate = _SetVal;
	}
	get finalDrawingSubmissionActualDateToken(): ActualDateToken {
		return this._finalDrawingSubmissionActualDateToken;
	}
	set finalDrawingSubmissionActualDateToken(_SetVal: ActualDateToken) {
		if (this._finalDrawingSubmissionActualDateToken.expActualDate == null)
			this._finalDrawingSubmissionActualDateToken.expActualDate = this.parentSubSORef.pmTechSubSalesOrder.plannedDrawingApprovalDate;
		this._finalDrawingSubmissionActualDateToken.actualDate = _SetVal.actualDate;
		this._finalDrawingSubmissionActualDateToken.isOveridden = _SetVal.isOveridden;
		this._finalDrawingSubmissionActualDateToken.addNotes = _SetVal.addNotes;
		this._finalDrawingSubmissionActualDateToken.userOveridden = _SetVal.userOveridden;
	}
	get finalDrawingSubmissionDateActual(): Date {
		return this._finalDrawingSubmissionActualDateToken.actualDate;
	}
	set finalDrawingSubmissionDateActual(_SetVal: Date) {
		this._finalDrawingSubmissionActualDateToken.actualDate = _SetVal;
	}
	get specialMatPriceApplicabilityId(): string {
		return this._splMatPriceApplicableId;
	}
	get isSplMatPapplicable(): boolean {
		return this._splMatPriceApplicableId == configDefs.defYesKeyId;
	}
	set specialMatPriceApplicabilityId(_setVal: string) {
		this._splMatPriceApplicableId = _setVal;
	}
	get sldGtpUploads(): GenFileUploads {
		return this._sldGtpUploads;
	}
	set sldGtpUploads(_setVal: GenFileUploads) {
		this._sldGtpUploads = _setVal;
	}
	get revSldGtpUploads(): GenFileUploads {
		return this._revSldGtpUploads;
	}
	set revSldGtpUploads(_setVal: GenFileUploads) {
		this._revSldGtpUploads = _setVal;
	}
	get schemeUploads(): GenFileUploads {
		return this._schemeUploads;
	}
	set schemeUploads(_setVal: GenFileUploads) {
		this._schemeUploads = _setVal;
	}
	get gafMgaUploads(): GenFileUploads {
		return this._gafMgaUploads;
	}
	set gafMgaUploads(_setVal: GenFileUploads) {
		this._gafMgaUploads = _setVal;
	}
	get revGafMgaUploads(): GenFileUploads {
		return this._revGafMgaUploads;
	}
	set revGafMgaUploads(_setVal: GenFileUploads) {
		this._revGafMgaUploads = _setVal;
	}
	get splMatPlannedDateLabel(): string {
		if (this.splMatPlannedDateIsRevised == true && this.parentSubSORef.enggDrawIP.isSplMatPapplicable == true) {
			return "Revised (Planned) Date"
		}
		else {
			return "Planned Date"
		}
	}
	get splMatPlannedDateIsRevised(): boolean {
		if (this.splMatPlannedDate_Initial && this.splMatPlannedDate) {
			if (GenService.areDatesSame(this.splMatPlannedDate_Initial, this.splMatPlannedDate) == false) {
				return true;
			}
		}
		return false;
	}

	get splMatPlannedDate_Initial(): Date {
		if (this.isSplMatPapplicable == true) {
			if (this._splMatPlannedDateToken.actualPlannedDate == null || this._splMatPlannedDateToken.isOveridden == false) {
				var _tmpDate = this.parentSubSORef.pmTechSubSalesOrder.plannedDrawingApprovalDate;

				if (_tmpDate != null && configDefs.splMatFinalizatoingivenbyEnggToPM) {
					this._splMatPlannedDateToken.actualPlannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.splMatFinalizatoingivenbyEnggToPM);
				}
				else {
					this._splMatPlannedDateToken.actualPlannedDate = null;
				}
			}
			return this._splMatPlannedDateToken.actualPlannedDate;
		}

		return null;
	}
	get splMatPlannedDate(): Date {
		if (this.isSplMatPapplicable == true) {
			if (this._splMatPlannedDateToken.plannedDate == null || this._splMatPlannedDateToken.isOveridden == false) {
				var _tmpDate = this.parentSubSORef.pmTechSubSalesOrder.actOrPlndDrawingApprovalDate;

				if (_tmpDate != null && configDefs.splMatFinalizatoingivenbyEnggToPM) {
					this._splMatPlannedDateToken.plannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.splMatFinalizatoingivenbyEnggToPM);
				}
				else {
					this._splMatPlannedDateToken.plannedDate = null;
				}
			}
			return this._splMatPlannedDateToken.plannedDate;
		}

		return null;
	}
	private _splMatPlannedGroup: RevisedDate;
	get splMatPlannedGroup(): RevisedDate {
		this._splMatPlannedGroup = new RevisedDate(this.splMatPlannedDate_Initial, this.splMatPlannedDateIsRevised, this.splMatPlannedDate);

		return this._splMatPlannedGroup;
	}
	set splMatPlannedDate(_SetVal: Date) {
		this._splMatPlannedDateToken.plannedDate = _SetVal;
	}
	get splMatPlannedDateToken(): PlannedDateToken {
		return this._splMatPlannedDateToken;
	}
	set splMatPlannedDateToken(_SetVal: PlannedDateToken) {
		// if (this._splMatPlannedDateToken.actualPlannedDate == null)
		// 	this._splMatPlannedDateToken.actualPlannedDate = this.splMatPlannedDate;
		this._splMatPlannedDateToken.plannedDate = _SetVal.plannedDate;
		this._splMatPlannedDateToken.isOveridden = _SetVal.isOveridden;
		this._splMatPlannedDateToken.addNotes = _SetVal.addNotes;
		this._splMatPlannedDateToken.userOveridden = _SetVal.userOveridden;
	}

	get splMatActualDateToken(): ActualDateToken {
		return this._splMatActualDateToken;
	}
	set splMatActualDateToken(_SetVal: ActualDateToken) {
		if (this._splMatActualDateToken.expActualDate == null)
			this._splMatActualDateToken.expActualDate = this.splMatActualDate;
		this._splMatActualDateToken.actualDate = _SetVal.actualDate;
		this._splMatActualDateToken.isOveridden = _SetVal.isOveridden;
		this._splMatActualDateToken.addNotes = _SetVal.addNotes;
		this._splMatActualDateToken.userOveridden = _SetVal.userOveridden;
	}
	get splMatActualDate(): Date {
		if (this.isSplMatPapplicable == true) {
			return this._splMatActualDateToken.actualDate;
		}
		return null;
	}
	set splMatActualDate(_SetVal: Date) {
		// console.log("Possible wrong place for execution, not supposed to set splmatactualdate directly");
		this._splMatActualDateToken.actualDate = _SetVal;
	}


	get ctFinalizationGivenByEnggToPMPlannedToken(): PlannedDateToken {
		return this._ctFinalizationGivenByEnggToPMPlannedToken;
	}
	set ctFinalizationGivenByEnggToPMPlannedToken(_SetVal: PlannedDateToken) {
		// if (this._ctFinalizationGivenByEnggToPMPlannedToken.actualPlannedDate == null)
		// 	this._ctFinalizationGivenByEnggToPMPlannedToken.actualPlannedDate = this.ctFinalizationGivenByEnggToPMPlannedDate;
		this._ctFinalizationGivenByEnggToPMPlannedToken.plannedDate = _SetVal.plannedDate;
		this._ctFinalizationGivenByEnggToPMPlannedToken.isOveridden = _SetVal.isOveridden;
		this._ctFinalizationGivenByEnggToPMPlannedToken.addNotes = _SetVal.addNotes;
		this._ctFinalizationGivenByEnggToPMPlannedToken.userOveridden = _SetVal.userOveridden;
	}
	get ctFinalizationGivenByEnggToPMPlannedDateLabel(): string {
		if (this.ctFinalizationGivenByEnggToPMPlannedDateisRevised == true) {
			return "Revised (Planned) Date";
		} else {
			return "Planned Date";
		}
	}
	get ctFinalizationGivenByEnggToPMPlannedDateisRevised(): boolean {
		//return this.parentSubSORef.pmTechSubSalesOrder.actualDrawingApprovalDate != null;
		if (this.ctFinalizationGivenByEnggToPMPlannedDate_Initial && this.ctFinalizationGivenByEnggToPMPlannedDate) {
			if (GenService.areDatesSame(this.ctFinalizationGivenByEnggToPMPlannedDate_Initial,
				this.ctFinalizationGivenByEnggToPMPlannedDate) == false) {
				return true;
			}
		}
		return false;
	}
	private _ctFinGvnByEnggToPMGroup: RevisedDate;
	get ctFinalizationGivenByEnggToPMPlannedGroup(): RevisedDate {
		this._ctFinGvnByEnggToPMGroup = new RevisedDate(this.ctFinalizationGivenByEnggToPMPlannedDate_Initial, this.ctFinalizationGivenByEnggToPMPlannedDateisRevised, this.ctFinalizationGivenByEnggToPMPlannedDate);

		return this._ctFinGvnByEnggToPMGroup;
	}

	get ctFinalizationGivenByEnggToPMPlannedDate_Initial(): Date {
		if (this._ctFinalizationGivenByEnggToPMPlannedToken.actualPlannedDate == null || this._ctFinalizationGivenByEnggToPMPlannedToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.pmTechSubSalesOrder.plannedDrawingApprovalDate;
			if (_tmpDate != null && configDefs.defPlndCTFinlEnggToPMDays) {
				this._ctFinalizationGivenByEnggToPMPlannedToken.actualPlannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndCTFinlEnggToPMDays);
			}
			else {
				this._ctFinalizationGivenByEnggToPMPlannedToken.actualPlannedDate = null;
			}
		}
		return this._ctFinalizationGivenByEnggToPMPlannedToken.actualPlannedDate;
	}

	get ctFinalizationGivenByEnggToPMPlannedDate(): Date {
		if (this._ctFinalizationGivenByEnggToPMPlannedToken.plannedDate == null || this._ctFinalizationGivenByEnggToPMPlannedToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.pmTechSubSalesOrder.actOrPlndDrawingApprovalDate;

			if (_tmpDate != null && configDefs.defPlndCTFinlEnggToPMDays) {
				this._ctFinalizationGivenByEnggToPMPlannedToken.plannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndCTFinlEnggToPMDays);
			}
			else {
				this._ctFinalizationGivenByEnggToPMPlannedToken.plannedDate = null;
			}
		}
		return this._ctFinalizationGivenByEnggToPMPlannedToken.plannedDate;
	}
	set ctFinalizationGivenByEnggToPMPlannedDate(_SetVal: Date) {
		// console.log("Possible wrong place for execution, not supposed to set ctFinalizationGivenByEnggToPMPlannedDate directly");
		this._ctFinalizationGivenByEnggToPMPlannedToken.plannedDate = _SetVal;
	}

	get ctFinalizationGivenByEnggToPMActualToken(): ActualDateToken {
		return this._ctFinalizationGivenByEnggToPMActualToken;
	}
	set ctFinalizationGivenByEnggToPMActualToken(_SetVal: ActualDateToken) {
		if (this._ctFinalizationGivenByEnggToPMActualToken.expActualDate == null)
			this._ctFinalizationGivenByEnggToPMActualToken.expActualDate = this.ctFinalizationGivenByEnggToPMPlannedDate;
		this._ctFinalizationGivenByEnggToPMActualToken.actualDate = _SetVal.actualDate;
		this._ctFinalizationGivenByEnggToPMActualToken.isOveridden = _SetVal.isOveridden;
		this._ctFinalizationGivenByEnggToPMActualToken.addNotes = _SetVal.addNotes;
		this._ctFinalizationGivenByEnggToPMActualToken.userOveridden = _SetVal.userOveridden;
	}
	get ctFinalizationGivenByEnggToPMActualDate(): Date {
		return this._ctFinalizationGivenByEnggToPMActualToken.actualDate;
	}
	set ctFinalizationGivenByEnggToPMActualDate(_SetVal: Date) {
		// console.log("Possible wrong place for execution, not supposed to set ctFinalizationGivenByEnggToPMActualDate directly");
		this._ctFinalizationGivenByEnggToPMActualToken.actualDate = _SetVal;
	}


	// STARTS

	get plannedMGAToken(): PlannedDateToken {
		return this._plannedMGAToken;
	}
	set plannedMGAToken(_SetVal: PlannedDateToken) {
		this._plannedMGAToken.plannedDate = _SetVal.plannedDate;
		this._plannedMGAToken.isOveridden = _SetVal.isOveridden;
		this._plannedMGAToken.addNotes = _SetVal.addNotes;
		this._plannedMGAToken.userOveridden = _SetVal.userOveridden;
	}
	get plannedMGADateLabel(): string {
		if (this.plannedMGADateisRevised == true) {
			return "MGA Revised (Planned)"
		}
		else {
			return "MGA Planned"
		}
	}
	get plannedMGADateisRevised(): boolean {
		if (this.plannedMGADate_Initial && this.plannedMGADate) {
			if (GenService.areDatesSame(this.plannedMGADate_Initial, this.plannedMGADate) == false) {
				return true;
			}
		}
		return false;
	}
	get plannedMGADate_Initial(): Date {
		if (this._plannedMGAToken.actualPlannedDate == null || this._plannedMGAToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.pmTechSubSalesOrder.plannedSchematicDrawingDate;

			if (_tmpDate != null && configDefs.defPlndC40Days) {
				this._plannedMGAToken.actualPlannedDate = configDefs.addWorkingDays(_tmpDate, 3);
			}
			else {
				this._plannedMGAToken.actualPlannedDate = null;
			}
		}
		return this._plannedMGAToken.actualPlannedDate;
	}
	get plannedMGADate(): Date {
		if (this._plannedMGAToken.plannedDate == null || this._plannedMGAToken.isOveridden == false) {
			// var _tmpDate = this.parentSubSORef.pmTechSubSalesOrder.actOrPlndDrawingApprovalDate;
			var _tmpDate = this.parentSubSORef.enggDrawIP.initialSchematicDBOMSubmissionDateActual;

			if (_tmpDate != null && configDefs.defPlndC40Days) {
				this._plannedMGAToken.plannedDate = configDefs.addWorkingDays(_tmpDate, 3);
			}
			else {
				this._plannedMGAToken.plannedDate = null;
			}
		}
		return this._plannedMGAToken.plannedDate;
	}
	private _plannedMGAGroup: RevisedDate;
	get plannedMGAGroup(): RevisedDate {
		this._plannedMGAGroup = new RevisedDate(this.plannedMGADate_Initial, this.plannedMGADateisRevised, this.plannedMGADate);

		return this._plannedMGAGroup;
	}
	set plannedMGADate(_SetVal: Date) {
		// console.log("Possible wrong place for execution, not supposed to set plannedMGADate directly");
		this._plannedMGAToken.plannedDate = _SetVal;
	}

	get actualMGAToken(): ActualDateToken {
		return this._actualMGAToken;
	}
	set actualMGAToken(_SetVal: ActualDateToken) {
		if (this._actualMGAToken.expActualDate == null)
			this._actualMGAToken.expActualDate = this.plannedMGADate;
		this._actualMGAToken.actualDate = _SetVal.actualDate;
		this._actualMGAToken.isOveridden = _SetVal.isOveridden;
		this._actualMGAToken.addNotes = _SetVal.addNotes;
		this._actualMGAToken.userOveridden = _SetVal.userOveridden;
	}
	get actualMGADate(): Date {
		return this._actualMGAToken.actualDate;
	}
	set actualMGADate(_SetVal: Date) {
		// console.log("Possible wrong place for execution, not supposed to set actualMGADate directly");
		this._actualMGAToken.actualDate = _SetVal;
	}
	// ENDS


	get plannedSLDGAApprovalToken(): PlannedDateToken {
		return this._plannedSLDGAApprovalToken;
	}
	set plannedSLDGAApprovalToken(_SetVal: PlannedDateToken) {
		// if (this._plannedSLDGAApprovalToken.actualPlannedDate == null)
		// 	this._plannedSLDGAApprovalToken.actualPlannedDate = this.plannedSLDGAApprovalDate;
		this._plannedSLDGAApprovalToken.plannedDate = _SetVal.plannedDate;
		this._plannedSLDGAApprovalToken.isOveridden = _SetVal.isOveridden;
		this._plannedSLDGAApprovalToken.addNotes = _SetVal.addNotes;
		this._plannedSLDGAApprovalToken.userOveridden = _SetVal.userOveridden;
	}
	get plannedSLDGAApprovalDateLabel(): string {
		if (this.plannedSLDGAApprovalDateisRevised == true) {
			return "Revised (Planned) Date"
		}
		else {
			return "Planned Date"
		}
	}
	get plannedSLDGAApprovalDateisRevised(): boolean {
		if (this.plannedSLDGAApprovalDate_Initial && this.plannedSLDGAApprovalDate) {
			if (GenService.areDatesSame(this.plannedSLDGAApprovalDate_Initial, this.plannedSLDGAApprovalDate) == false) {
				return true;
			}
		}
		return false;
	}
	get plannedSLDGAApprovalDate_Initial(): Date {
		if (this._plannedSLDGAApprovalToken.actualPlannedDate == null || this._plannedSLDGAApprovalToken.isOveridden == false) {
			var _pSldSubDt = this.parentSubSORef.pmTechSubSalesOrder.plannedSldSubmissionDate_Initial;
			var _pGADSubDt = this.parentSubSORef.pmTechSubSalesOrder.plannedGaDrawingSubmissionDate_Initial;

			var _tmpDate;
			if (_pSldSubDt == null)
				_tmpDate = _pGADSubDt;
			else if (_pGADSubDt == null)
				_tmpDate = _pSldSubDt;
			else {
				if (_pSldSubDt.getTime() > _pGADSubDt.getTime())
					_tmpDate = _pSldSubDt;
				else
					_tmpDate = _pGADSubDt;
			}

			if (_tmpDate != null && configDefs.defPlndSLDGAAprvlDays) {
				this._plannedSLDGAApprovalToken.actualPlannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndSLDGAAprvlDays);
			}
			else {
				this._plannedSLDGAApprovalToken.actualPlannedDate = null;
			}
		}
		return this._plannedSLDGAApprovalToken.actualPlannedDate;
	}
	get plannedSLDGAApprovalDate(): Date {
		if (this._plannedSLDGAApprovalToken.plannedDate == null || this._plannedSLDGAApprovalToken.isOveridden == false) {
			// var _pSldSubDt = this.parentSubSORef.pmTechSubSalesOrder.plannedSldSubmissionDate;
			var _pSldSubDt = this.parentSubSORef.enggDrawIP.initialSLDSubmissionDateActual;
			if (_pSldSubDt == null) {
				_pSldSubDt = this.parentSubSORef.pmTechSubSalesOrder.plannedSldSubmissionDate;
			}
			// var _pGADSubDt = this.parentSubSORef.pmTechSubSalesOrder.plannedGaDrawingSubmissionDate;
			var _pGADSubDt = this.parentSubSORef.enggDrawIP.initialGAFDSubmissionDateActual;
			if (_pGADSubDt == null) {
				_pGADSubDt = this.parentSubSORef.pmTechSubSalesOrder.plannedGaDrawingSubmissionDate
			}
			var _tmpDate;
			if (_pSldSubDt == null)
				_tmpDate = _pGADSubDt;
			else if (_pGADSubDt == null)
				_tmpDate = _pSldSubDt;
			else {
				if (_pSldSubDt.getTime() > _pGADSubDt.getTime())
					_tmpDate = _pSldSubDt;
				else
					_tmpDate = _pGADSubDt;
			}

			if (_tmpDate != null && configDefs.defPlndSLDGAAprvlDays) {
				this._plannedSLDGAApprovalToken.plannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndSLDGAAprvlDays);
			}
			else {
				this._plannedSLDGAApprovalToken.plannedDate = null;
			}
		}
		return this._plannedSLDGAApprovalToken.plannedDate;
	}
	private _plannedSLDGAApprovalGroup: RevisedDate;
	get plannedSLDGAApprovalGroup(): RevisedDate {
		this._plannedSLDGAApprovalGroup = new RevisedDate(this.plannedSLDGAApprovalDate_Initial, this.plannedSLDGAApprovalDateisRevised, this.plannedSLDGAApprovalDate);

		return this._plannedSLDGAApprovalGroup;

	}
	set plannedSLDGAApprovalDate(_SetVal: Date) {
		// console.log("Possible wrong place for execution, not supposed to set plannedSLDGAApprovalDate directly");
		this._plannedSLDGAApprovalToken.plannedDate = _SetVal;
	}
	get actualSLDGAApprovalToken(): ActualDateToken {
		return this._actualSLDGAApprovalToken;
	}
	set actualSLDGAApprovalToken(_SetVal: ActualDateToken) {
		if (this._actualSLDGAApprovalToken.expActualDate == null)
			this._actualSLDGAApprovalToken.expActualDate = this.plannedSLDGAApprovalDate;
		this._actualSLDGAApprovalToken.actualDate = _SetVal.actualDate;
		this._actualSLDGAApprovalToken.isOveridden = _SetVal.isOveridden;
		this._actualSLDGAApprovalToken.addNotes = _SetVal.addNotes;
		this._actualSLDGAApprovalToken.userOveridden = _SetVal.userOveridden;
	}
	get actualSLDGAApprovalDate(): Date {
		return this._actualSLDGAApprovalToken.actualDate;
	}
	set actualSLDGAApprovalDate(_SetVal: Date) {
		// console.log("Possible wrong place for execution, not supposed to set actualSLDGAApprovalDate directly");
		this._actualSLDGAApprovalToken.actualDate = _SetVal;
	}

	// Returns sibling sub-orders eligible to receive the current sub-order's Initial SLD Submission Actual date.
	// Excludes: current sub-order, sub-orders whose Initial SLD Submission Actual is already set, dispatched sub-orders.
	getEligibleSiblingSubOrdersForSLDPropagation(): Array<SubSalesOrder> {
		let _list: Array<SubSalesOrder> = [];
		if (!this.parentSORef || !this.parentSORef.subSalesOrder || !this.parentSubSORef) return _list;
		let _currentId: string = this.parentSubSORef.subOrderNoId;
		for (let i = 0; i < this.parentSORef.subSalesOrder.length; i++) {
			let _sso: SubSalesOrder = this.parentSORef.subSalesOrder[i];
			if (!_sso || !_sso.enggDrawIP) continue;
			if (_sso.subOrderNoId == _currentId) continue;
			if (_sso.isSSOStatusSet(SSOStatus.Dispatched)) continue;
			if (_sso.enggDrawIP.initialSLDSubmissionActualDateToken.actualDate != null) continue;
			_list.push(_sso);
		}
		return _list;
	}

	// Applies uploadedDate to current + eligible target sub-orders. Never overwrites existing dates. Returns a summary.
	applySLDDatePropagation(uploadedDate: Date, targetSubOrderIds: Array<string>, userId: string): SLDPropagationResult {
		let _updated: Array<string> = [];
		let _skipped: Array<{ subOrderNoId: string, reason: string }> = [];
		let _now: Date = new Date();
		if (!uploadedDate) {
			return new SLDPropagationResult(this.parentSubSORef ? this.parentSubSORef.subOrderNoId : null,
				_updated, _skipped, uploadedDate, _now);
		}
		let _currentId: string = this.parentSubSORef ? this.parentSubSORef.subOrderNoId : null;
		// current sub-order
		if (this._initialSLDSubmissionActualDateToken.actualDate == null) {
			let _plannedCurrent: Date = this.parentSubSORef && this.parentSubSORef.pmTechSubSalesOrder
				? this.parentSubSORef.pmTechSubSalesOrder.plannedSldSubmissionDate : null;
			this._initialSLDSubmissionActualDateToken = new ActualDateToken(
				new Date(uploadedDate.getTime()), false, _plannedCurrent, "Set from SLD upload", userId
			);
			_updated.push(_currentId);
		} else {
			_skipped.push({ subOrderNoId: _currentId, reason: "Date already exists" });
		}
		if (!this.parentSORef || !this.parentSORef.subSalesOrder || !targetSubOrderIds) {
			return new SLDPropagationResult(_currentId, _updated, _skipped, uploadedDate, _now);
		}
		for (let i = 0; i < targetSubOrderIds.length; i++) {
			let _tid: string = targetSubOrderIds[i];
			if (!_tid || _tid == _currentId) continue;
			let _sso: SubSalesOrder = null;
			for (let j = 0; j < this.parentSORef.subSalesOrder.length; j++) {
				if (this.parentSORef.subSalesOrder[j].subOrderNoId == _tid) {
					_sso = this.parentSORef.subSalesOrder[j];
					break;
				}
			}
			if (!_sso) {
				_skipped.push({ subOrderNoId: _tid, reason: "Sub-order not found" });
				continue;
			}
			if (!_sso.enggDrawIP) {
				_skipped.push({ subOrderNoId: _tid, reason: "Engineering Drawing section unavailable" });
				continue;
			}
			if (_sso.isSSOStatusSet(SSOStatus.Dispatched)) {
				_skipped.push({ subOrderNoId: _tid, reason: "Sub-order is dispatched" });
				continue;
			}
			try {
				if (_sso.enggDrawIP.initialSLDSubmissionActualDateToken.actualDate != null) {
					_skipped.push({ subOrderNoId: _tid, reason: "Date already exists" });
					continue;
				}
				let _planned: Date = _sso.pmTechSubSalesOrder ? _sso.pmTechSubSalesOrder.plannedSldSubmissionDate : null;
				// Enhanced: Keep isOveridden=false and add dynamic source sub-order reference with user email
				_sso.enggDrawIP.initialSLDSubmissionActualDateToken = new ActualDateToken(
					new Date(uploadedDate.getTime()), false, _planned, "Set from SLD upload (propagated from Sub-" + _currentId + ")", userId
				);
				_updated.push(_tid);
			} catch (e) {
				_skipped.push({ subOrderNoId: _tid, reason: "Update failed: " + (e && e.message ? e.message : "unknown") });
			}
		}
		return new SLDPropagationResult(_currentId, _updated, _skipped, uploadedDate, _now);
	}

	// Excludes: current sub-order, sub-orders whose Initial Schematic Drawing & BOM Submission Actual is already set, dispatched sub-orders.
	getEligibleSiblingSubOrdersForSchemePropagation(): Array<SubSalesOrder> {
		let _list: Array<SubSalesOrder> = [];
		if (!this.parentSORef || !this.parentSORef.subSalesOrder || !this.parentSubSORef) return _list;
		let _currentId: string = this.parentSubSORef.subOrderNoId;
		for (let i = 0; i < this.parentSORef.subSalesOrder.length; i++) {
			let _sso: SubSalesOrder = this.parentSORef.subSalesOrder[i];
			if (!_sso || !_sso.enggDrawIP) continue;
			if (_sso.subOrderNoId == _currentId) continue;
			if (_sso.isSSOStatusSet(SSOStatus.Dispatched)) continue;
			if (_sso.enggDrawIP.initialSchematicDBOMSubmissionActualDateToken.actualDate != null) continue;
			_list.push(_sso);
		}
		return _list;
	}

	// Applies uploadedDate to current + eligible target sub-orders for Scheme. Never overwrites existing dates. Returns a summary.
	applySchemeDatePropagation(uploadedDate: Date, targetSubOrderIds: Array<string>, userId: string): SchemePropagationResult {
		let _updated: Array<string> = [];
		let _skipped: Array<{ subOrderNoId: string, reason: string }> = [];
		let _now: Date = new Date();
		if (!uploadedDate) {
			return new SchemePropagationResult(this.parentSubSORef ? this.parentSubSORef.subOrderNoId : null,
				_updated, _skipped, uploadedDate, _now);
		}
		let _currentId: string = this.parentSubSORef ? this.parentSubSORef.subOrderNoId : null;
		// current sub-order
		if (this._initialSchematicDBOMSubmissionActualDateToken.actualDate == null) {
			let _plannedCurrent: Date = this.parentSubSORef && this.parentSubSORef.pmTechSubSalesOrder
				? this.parentSubSORef.pmTechSubSalesOrder.plannedSchematicDrawingDate : null;
			this._initialSchematicDBOMSubmissionActualDateToken = new ActualDateToken(
				new Date(uploadedDate.getTime()), false, _plannedCurrent, "Set from Schematic Drawing & BOM upload", userId
			);
			_updated.push(_currentId);
		} else {
			_skipped.push({ subOrderNoId: _currentId, reason: "Date already exists" });
		}
		if (!this.parentSORef || !this.parentSORef.subSalesOrder || !targetSubOrderIds) {
			return new SchemePropagationResult(_currentId, _updated, _skipped, uploadedDate, _now);
		}
		for (let i = 0; i < targetSubOrderIds.length; i++) {
			let _tid: string = targetSubOrderIds[i];
			if (!_tid || _tid == _currentId) continue;
			let _sso: SubSalesOrder = null;
			for (let j = 0; j < this.parentSORef.subSalesOrder.length; j++) {
				if (this.parentSORef.subSalesOrder[j].subOrderNoId == _tid) {
					_sso = this.parentSORef.subSalesOrder[j];
					break;
				}
			}
			if (!_sso) {
				_skipped.push({ subOrderNoId: _tid, reason: "Sub-order not found" });
				continue;
			}
			if (!_sso.enggDrawIP) {
				_skipped.push({ subOrderNoId: _tid, reason: "Engineering Drawing section unavailable" });
				continue;
			}
			if (_sso.isSSOStatusSet(SSOStatus.Dispatched)) {
				_skipped.push({ subOrderNoId: _tid, reason: "Sub-order is dispatched" });
				continue;
			}
			try {
				if (_sso.enggDrawIP.initialSchematicDBOMSubmissionActualDateToken.actualDate != null) {
					_skipped.push({ subOrderNoId: _tid, reason: "Date already exists" });
					continue;
				}
				let _planned: Date = _sso.pmTechSubSalesOrder ? _sso.pmTechSubSalesOrder.plannedSchematicDrawingDate : null;
				// Enhanced: Keep isOveridden=false and add dynamic source sub-order reference with user email
				_sso.enggDrawIP.initialSchematicDBOMSubmissionActualDateToken = new ActualDateToken(
					new Date(uploadedDate.getTime()), false, _planned, "Set from Schematic Drawing & BOM upload (propagated from Sub-" + _currentId + ")", userId
				);
				_updated.push(_tid);
			} catch (e) {
				_skipped.push({ subOrderNoId: _tid, reason: "Update failed: " + (e && e.message ? e.message : "unknown") });
			}
		}
		return new SchemePropagationResult(_currentId, _updated, _skipped, uploadedDate, _now);
	}

	cloneSelf() {
		return new EnggDrawIP(this._electricalDesignEngineerId, this._mechanicalDesignEngineerId, this._c30EngineerId, this.initialSLDSubmissionActualDateToken.cloneSelf(),
			this._initialGAFDSubmissionActualDateToken.cloneSelf(), this._initialSchematicDBOMSubmissionActualDateToken.cloneSelf(),
			this._initialGTPCTPTBBSizingCalcSubmissionActualDateToken.cloneSelf(), this._finalDrawingSubmissionActualDateToken.cloneSelf(),
			// STARTS
			this._plannedMGAToken.cloneSelf(), this._actualMGAToken.cloneSelf(),
			// END
			this._sldGtpUploads.cloneSelf(), this._revSldGtpUploads.cloneSelf(), this._schemeUploads.cloneSelf(), this._gafMgaUploads.cloneSelf(), this._revGafMgaUploads.cloneSelf(),
			this._splMatPriceApplicableId, this._splMatPlannedDateToken.cloneSelf(), this._splMatActualDateToken.cloneSelf(), this._ctFinalizationGivenByEnggToPMPlannedToken.cloneSelf(), this._ctFinalizationGivenByEnggToPMActualToken.cloneSelf(),
			this._plannedSLDGAApprovalToken.cloneSelf(), this._actualSLDGAApprovalToken.cloneSelf(), this._status);
	}
	public static getObj(_json: any): EnggDrawIP {
		return new EnggDrawIP(_json.eleDesignEngId, _json.mechDesignEngId, _json.c30EngId,
			(_json.initSLDSubActToken ? convDefs.convToActualDateToken(_json.initSLDSubActToken) : convDefs.convToActualDateToken_Compat(_json.initSLDSubActDate)),
			(_json.initGAFDSubActToken ? convDefs.convToActualDateToken(_json.initGAFDSubActToken) : convDefs.convToActualDateToken_Compat(_json.initGAFDSubActDate)),
			//GenService.convToDate(_json.initGAFDSubActDate), 
			(_json.initSchematicDBOMSubActToken ? convDefs.convToActualDateToken(_json.initSchematicDBOMSubActToken) : convDefs.convToActualDateToken_Compat(_json.initSchematicDBOMSubActDate)),
			//GenService.convToDate(_json.initSchematicDBOMSubActDate),
			(_json.initGTPCTPBBSizingCalcSubActToken ? convDefs.convToActualDateToken(_json.initGTPCTPBBSizingCalcSubActToken) : convDefs.convToActualDateToken_Compat(_json.initGTPCTPBBSizingCalcSubActDate)),
			//GenService.convToDate(_json.initGTPCTPBBSizingCalcSubActDate), 
			(_json.finalDrawingSubActToken ? convDefs.convToActualDateToken(_json.finalDrawingSubActToken) : convDefs.convToActualDateToken_Compat(_json.finalDrawingSubActDate)),
			//GenService.convToDate(_json.finalDrawingSubActDate),
			// STARTS
			convDefs.convToPlannedDateToken(_json.mgaPlanToken),
			convDefs.convToActualDateToken(_json.mgaActToken),
			// ENDS
			GenFileUploads.getObj(_json.sldGtpUploads), GenFileUploads.getObj(_json.revSldGtpUploads), GenFileUploads.getObj(_json.schemeUploads),
			GenFileUploads.getObj(_json.gafMgaUploads), GenFileUploads.getObj(_json.revGafMgaUploads),
			_json.specialMaterialpriceapplicable, convDefs.convToPlannedDateToken(_json.splMatPlanedDateToken), convDefs.convToActualDateToken(_json.splMatActulDateToken),
			convDefs.convToPlannedDateToken(_json.ctFinalEngToPMPlanToken), convDefs.convToActualDateToken(_json.ctFinalEngToPMActToken),
			convDefs.convToPlannedDateToken(_json.planSLDGAApprovalToken), convDefs.convToActualDateToken(_json.actSLDGAApprovalToken), _json.status);
	}
	public getJson(): any {
		let _json: any = {};

		_json.eleDesignEngId = this.electricalDesignEngineerId;
		_json.mechDesignEngId = this.mechanicalDesignEngineerId;
		_json.c30EngId = this.c30EngineerId;
		//_json.initSLDSubActDate = GenService.convToDateNum(this.initialSLDSubmissionDateActual);
		_json.initSLDSubActToken = this.initialSLDSubmissionActualDateToken.getJson();

		//_json.initGAFDSubActDate = GenService.convToDateNum(this.initialGAFDSubmissionDateActual);
		_json.initGAFDSubActToken = this.initialGAFDSubmissionActualDateToken.getJson();
		//_json.initSchematicDBOMSubActDate = GenService.convToDateNum(this.initialSchematicDBOMSubmissionDateActual);
		_json.initSchematicDBOMSubActToken = this.initialSchematicDBOMSubmissionActualDateToken.getJson();
		//_json.initGTPCTPBBSizingCalcSubActDate = GenService.convToDateNum(this.initialGTPCTPTBBSizingCalcSubmissionDateActual);
		_json.initGTPCTPBBSizingCalcSubActToken = this.initialGTPCTPTBBSizingCalcSubmissionActualDateToken.getJson();
		//_json.finalDrawingSubActDate = GenService.convToDateNum(this.finalDrawingSubmissionDateActual);
		_json.finalDrawingSubActToken = this.finalDrawingSubmissionActualDateToken.getJson();
		// STARTS
		_json.mgaPlanToken = this.plannedMGAToken.getJson();
		_json.mgaActToken = this.actualMGAToken.getJson();
		// ENDS
		_json.sldGtpUploads = this.sldGtpUploads.getJson();
		_json.revSldGtpUploads = this.revSldGtpUploads.getJson();
		_json.schemeUploads = this.schemeUploads.getJson();
		_json.gafMgaUploads = this.gafMgaUploads.getJson();
		_json.revGafMgaUploads = this.revGafMgaUploads.getJson();
		_json.specialMaterialpriceapplicable = this.specialMatPriceApplicabilityId;
		// _json.splmaterialpriceplanneddate = GenService.convToDate(this.splmatplanneddate);
		// _json.splmaterialpriceactualdate = GenService.convToDate(this.splmatactualdate);
		_json.splMatPlanedDateToken = this.splMatPlannedDateToken.getJson();
		_json.splMatActulDateToken = this.splMatActualDateToken.getJson();

		_json.ctFinalEngToPMPlanToken = this.ctFinalizationGivenByEnggToPMPlannedToken.getJson();
		_json.ctFinalEngToPMActToken = this.ctFinalizationGivenByEnggToPMActualToken.getJson();
		_json.planSLDGAApprovalToken = this.plannedSLDGAApprovalToken.getJson();
		_json.actSLDGAApprovalToken = this.actualSLDGAApprovalToken.getJson();
		_json.status = this.status;

		return _json;
	}
}


export class EnggProcureIP {
	constructor(private _plannedC40Token: PlannedDateToken, private _plannedC50Token: PlannedDateToken, private _plannedC60Token: PlannedDateToken,
		private _plannedLongLeadReleaseToken: PlannedDateToken, private _actualLongLeadReleaseToken: ActualDateToken,
		private _actualC40Token: ActualDateToken, private _actualC50Token: ActualDateToken, private _actualC60Token: ActualDateToken, private _relayconfigId: string,
		private _c40c50c60Files: EnggProcFileUploads, private _c50Files: EnggProcFileUploads, private _c60Files: EnggProcFileUploads, private _longLeadFiles: EnggProcFileUploads,
		private _asBuiltDrawFiles: EnggProcFileUploads, private _asBuiltDrawElecFiles: GenFileUploads,
		private _mechDesignChangeNoteFiles: GenFileUploads, private _elecDesignChangeNoteFiles: GenFileUploads,
		private _status: FunctionStatus) {
	}
	private _parentSORef: SalesOrder;
	private _parentSubSORef: SubSalesOrder;

	refreshStatus() {
		if (this.parentSORef && this.parentSubSORef && this.parentSORef.projectStatus >= SOStatus.Sub_Orders) {
			if (this.parentSubSORef.isSSOStatusSet(SSOStatus.Engg_Procurement_From_EnggDraw) == true &&
				this.parentSubSORef.isSSOStatusSet(SSOStatus.Engg_Procurement_From_SCM) == true ||
				this.parentSubSORef.isSSOStatusSet(SSOStatus.Engg_Procurement_From_PM_Tech) == true) {

				if (this.parentSubSORef.isSSOStatusSet(SSOStatus.PO) == true) {
					let _isTempComplete: boolean = this.isFunctionComplete();

					if (_isTempComplete == true) {
						this._status = FunctionStatus.SUBMITTED_COMPLETE;
					}
					else {
						this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
					}
				}
				// New
				else if (this.parentSubSORef.isSSOStatusSet(SSOStatus.Engg_Procurement_From_PM_Tech) == true) {
					let _isTempComplete: boolean = this.isFunctionComplete();

					if (_isTempComplete == true) {
						this._status = FunctionStatus.SUBMITTED_COMPLETE;
					}
					else {
						this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
					}
				}
				else {
					this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
				}

			}
			// New end
			else if (this.parentSubSORef.isSSOStatusSet(SSOStatus.Engg_Procurement_From_EnggDraw) == true ||
				this.parentSubSORef.isSSOStatusSet(SSOStatus.Engg_Procurement_From_SCM) == true ||
				this.parentSubSORef.isSSOStatusSet(SSOStatus.Engg_Procurement_From_PM_Tech) == true) {
				this._status = FunctionStatus.SUBMITTED_WAITING_RESPONSE;
			}
			else {
				this._status = FunctionStatus.WAITING_FOR_PREV;
			}
		}
		else {
			this._status = FunctionStatus.WAITING_FOR_PREV;
		}
	}
	private isFunctionComplete(): boolean {
		if (configDefs.isDtEmty(this.plannedC40Date)) return false;
		if (configDefs.isDtEmty(this.actualC40Date)) return false;
		if (configDefs.isDtEmty(this.plannedC50Date)) return false;
		if (configDefs.isDtEmty(this.actualC50Date)) return false;
		if (configDefs.isDtEmty(this.plannedC60Date)) return false;
		if (configDefs.isDtEmty(this.actualC60Date)) return false;
		if (configDefs.isStrEmty(this.relayconfigId)) return false;
		if (this.isLongLeadApplicable) {
			if (configDefs.isDtEmty(this.plannedLongLeadReleaseDate)) return false;
			if (configDefs.isDtEmty(this.actualLongLeadReleaseDate)) return false;
		}

		return true;
	}
	get isProjectLive(): boolean {
		return this.parentSubSORef.pmTechSubSalesOrder.projStatus == "live";
	}
	get isInputEnabled(): boolean {
		return this.parentSubSORef.isSSOStatusSet(SSOStatus.Engg_Procurement_From_EnggDraw)
			|| this.parentSubSORef.isSSOStatusSet(SSOStatus.Engg_Procurement_From_SCM)
			|| this.parentSubSORef.isSSOStatusSet(SSOStatus.Engg_Procurement_From_PM_Tech);

	}

	// STARTS
	get longleadRDate(): string {
		let _lngldRDate: Date = this.actualLongLeadReleaseDate;
		let _c40Date: Date = this.actualC40Date;

		if (_lngldRDate == null) {
			if (_c40Date != null) {

				return formatDate(_c40Date, 'dd-MMM-yy', 'en-IN');
			}
			else return null;
		}
		return formatDate(_lngldRDate, 'dd-MMM-yy', 'en-IN');
	}

	get c40ActDate(): string {
		let _c40actDate: Date = this.actualC40Date;

		if (_c40actDate != null) {

			return formatDate(_c40actDate, 'dd-MMM-yy', 'en-IN');
		}
		return null;
	}

	get c50ActDate(): string {
		let _c50actDate: Date = this.actualC50Date;

		if (_c50actDate != null) {

			return formatDate(_c50actDate, 'dd-MMM-yy', 'en-IN');
		}
		return null;
	}

	get c60ActDate(): string {
		let _c60actDate: Date = this.actualC60Date;

		if (_c60actDate != null) {

			return formatDate(_c60actDate, 'dd-MMM-yy', 'en-IN');
		}
		return null;
	}


	// ENDS

	enableFormInput(): void {
		if (this.parentSubSORef.isSSOStatusSet(SSOStatus.Engg_Procurement_From_EnggDraw) == true
			&& this.parentSubSORef.isSSOStatusSet(SSOStatus.Engg_Procurement_From_SCM) == true
			&& this.parentSubSORef.isSSOStatusSet(SSOStatus.Engg_Procurement_From_PM_Tech) == true) {
			if (this._status == FunctionStatus.WAITING_FOR_PREV || this._status == FunctionStatus.SUBMITTED_WAITING_RESPONSE) {
				this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
			}
		}
		else {
			if (this._status == FunctionStatus.WAITING_FOR_PREV) {
				this._status = FunctionStatus.SUBMITTED_WAITING_RESPONSE;
			}
		}
	}

	get parentSORef(): SalesOrder {
		return this._parentSORef;
	}
	set parentSORef(SORef: SalesOrder) {
		this._parentSORef = SORef;
		//this.refreshStatus();
	}
	get parentSubSORef(): SubSalesOrder {
		return this._parentSubSORef;
	}
	set parentSubSORef(SubSORef: SubSalesOrder) {
		this._parentSubSORef = SubSORef;
	}
	get relayconfigId(): string {
		return this._relayconfigId;
	}
	set relayconfigId(_setVal: string) {
		this._relayconfigId = _setVal;
	}
	get status(): FunctionStatus {
		return this._status;
	}
	get isPOPlanningSubmitted(): boolean {
		return this.parentSubSORef.isSSOStatusSet(SSOStatus.PO | SSOStatus.Planning);
	}
	get readyForPOPlanning(): boolean {
		if (this.actualC40Date || this.actualLongLeadReleaseDate) return true;
		return false;
	}
	get plannedC40Token(): PlannedDateToken {
		return this._plannedC40Token;
	}
	set plannedC40Token(_SetVal: PlannedDateToken) {
		// if (this._plannedC40Token.actualPlannedDate == null)
		// 	this._plannedC40Token.actualPlannedDate = this.plannedC40Date;
		this._plannedC40Token.plannedDate = _SetVal.plannedDate;
		this._plannedC40Token.isOveridden = _SetVal.isOveridden;
		this._plannedC40Token.addNotes = _SetVal.addNotes;
		this._plannedC40Token.userOveridden = _SetVal.userOveridden;
	}
	get plannedC40DateLabel(): string {
		if (this.plannedC40DateisRevised == true) {
			return "C40 Revised (Planned)"
		}
		else {
			return "C40 Planned"
		}
	}
	get plannedC40DateisRevised(): boolean {
		if (this.plannedC40Date_Initial && this.plannedC40Date) {
			if (GenService.areDatesSame(this.plannedC40Date_Initial, this.plannedC40Date) == false) {
				return true;
			}
		}
		return false;
	}
	get plannedC40Date_Initial(): Date {
		if (this._plannedC40Token.actualPlannedDate == null || this._plannedC40Token.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.pmTechSubSalesOrder.plannedDrawingApprovalDate_Initial;

			if (_tmpDate != null && configDefs.defPlndC40Days) {
				this._plannedC40Token.actualPlannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndC40Days);
			}
			else {
				this._plannedC40Token.actualPlannedDate = null;
			}
		}
		return this._plannedC40Token.actualPlannedDate;
	}
	get plannedC40Date(): Date {
		if (this._plannedC40Token.plannedDate == null || this._plannedC40Token.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.pmTechSubSalesOrder.actOrPlndDrawingApprovalDate;

			if (_tmpDate != null && configDefs.defPlndC40Days) {
				this._plannedC40Token.plannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndC40Days);
			}
			else {
				this._plannedC40Token.plannedDate = null;
			}
		}
		return this._plannedC40Token.plannedDate;
	}
	private _plannedC40Group: RevisedDate;
	get plannedC40Group(): RevisedDate {
		this._plannedC40Group = new RevisedDate(this.plannedC40Date_Initial, this.plannedC40DateisRevised, this.plannedC40Date);

		return this._plannedC40Group;
	}
	set plannedC40Date(_SetVal: Date) {
		// console.log("Possible wrong place for execution, not supposed to set plannedC40Date directly");
		this._plannedC40Token.plannedDate = _SetVal;
	}
	get plannedC50Token(): PlannedDateToken {
		return this._plannedC50Token;
	}
	set plannedC50Token(_SetVal: PlannedDateToken) {
		// if (this._plannedC50Token.actualPlannedDate == null)
		// 	this._plannedC50Token.actualPlannedDate = this.plannedC50Date;
		this._plannedC50Token.plannedDate = _SetVal.plannedDate;
		this._plannedC50Token.isOveridden = _SetVal.isOveridden;
		this._plannedC50Token.addNotes = _SetVal.addNotes;
		this._plannedC50Token.userOveridden = _SetVal.userOveridden;
	}
	get plannedC50DateLabel(): string {
		if (this.plannedC50DateIsRevised == true) {
			return "C50 Revised (Planned)";
		} else {
			return "C50 Planned";
		}
	}
	get plannedC50DateIsRevised(): boolean {
		if (this.plannedC50Date_Initial && this.plannedC50Date) {
			if (GenService.areDatesSame(this.plannedC50Date_Initial, this.plannedC50Date) == false) {
				return true;
			}
		}
		return false;
	}
	get plannedC50Date_Initial(): Date {
		if (this._plannedC50Token.actualPlannedDate == null || this._plannedC50Token.isOveridden == false) {
			var _tmpDate = this.plannedC40Date_Initial;
			if (_tmpDate != null && configDefs.defPlndC50Days) {
				this._plannedC50Token.actualPlannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndC50Days);
			}
			else {
				this._plannedC50Token.actualPlannedDate = null;
			}
		}
		return this._plannedC50Token.actualPlannedDate;
	}
	get plannedC50Date(): Date {
		if (this._plannedC50Token.plannedDate == null || this._plannedC50Token.isOveridden == false) {
			var _tmpDate = this.actualC40Date;
			if (_tmpDate == null) {
				_tmpDate = this.plannedC40Date;
			}
			if (_tmpDate != null && configDefs.defPlndC50Days) {
				this._plannedC50Token.plannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndC50Days);
			}
			else {
				this._plannedC50Token.plannedDate = null;
			}
		}
		return this._plannedC50Token.plannedDate;
	}
	private _plannedC50Group: RevisedDate;
	get plannedC50Group(): RevisedDate {
		this._plannedC50Group = new RevisedDate(this.plannedC50Date_Initial, this.plannedC50DateIsRevised, this.plannedC50Date);

		return this._plannedC50Group;
	}
	set plannedC50Date(_SetVal: Date) {
		// console.log("Possible wrong place for execution, not supposed to set plannedC50Date directly");
		this._plannedC50Token.plannedDate = _SetVal;
	}
	get plannedC60Token(): PlannedDateToken {
		return this._plannedC60Token;
	}
	set plannedC60Token(_SetVal: PlannedDateToken) {
		// if (this._plannedC60Token.actualPlannedDate == null)
		// 	this._plannedC60Token.actualPlannedDate = this.plannedC60Date;
		this._plannedC60Token.plannedDate = _SetVal.plannedDate;
		this._plannedC60Token.isOveridden = _SetVal.isOveridden;
		this._plannedC60Token.addNotes = _SetVal.addNotes;
		this._plannedC60Token.userOveridden = _SetVal.userOveridden;
	}
	get plannedC60DateLabel(): string {
		if (this.plannedC60DateIsRevised == true) {
			return "C60 Revised (Planned)"
		} else {
			return "C60 Planned"
		}
	}
	get plannedC60DateIsRevised(): boolean {
		if (this.plannedC60Date_Initial && this.plannedC60Date) {
			if (GenService.areDatesSame(this.plannedC60Date_Initial, this.plannedC60Date) == false) {
				return true;
			}
		}
		return false;
	}
	get plannedC60Date_Initial(): Date {
		if (this._plannedC60Token.actualPlannedDate == null || this._plannedC60Token.isOveridden == false) {
			var _tmpDate = this.plannedC40Date_Initial;
			if (_tmpDate != null && configDefs.defPlndC60Days) {
				this._plannedC60Token.actualPlannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndC60Days);
			}
			else {
				this._plannedC60Token.actualPlannedDate = null;
			}
		}
		return this._plannedC60Token.actualPlannedDate;
	}
	get plannedC60Date(): Date {
		if (this._plannedC60Token.plannedDate == null || this._plannedC60Token.isOveridden == false) {
			var _tmpDate = this.actualC40Date;
			if (_tmpDate == null) {
				_tmpDate = this.plannedC40Date
			}
			if (_tmpDate != null && configDefs.defPlndC60Days) {
				this._plannedC60Token.plannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndC60Days);
			}
			else {
				this._plannedC60Token.plannedDate = null;
			}
		}
		return this._plannedC60Token.plannedDate;
	}
	private _plannedC60Group: RevisedDate;
	get plannedC60Group(): RevisedDate {
		this._plannedC60Group = new RevisedDate(this.plannedC60Date_Initial, this.plannedC60DateIsRevised, this.plannedC60Date);

		return this._plannedC60Group;
	}
	set plannedC60Date(_SetVal: Date) {
		// console.log("Possible wrong place for execution, not supposed to set plannedC60Date directly");
		this._plannedC60Token.plannedDate = _SetVal;
	}
	get plannedLongLeadReleaseToken(): PlannedDateToken {
		return this._plannedLongLeadReleaseToken;
	}
	set plannedLongLeadReleaseToken(_SetVal: PlannedDateToken) {
		// if (this._plannedLongLeadReleaseToken.actualPlannedDate == null)
		// 	this._plannedLongLeadReleaseToken.actualPlannedDate = this.plannedLongLeadReleaseDate;
		this._plannedLongLeadReleaseToken.plannedDate = _SetVal.plannedDate;
		this._plannedLongLeadReleaseToken.isOveridden = _SetVal.isOveridden;
		this._plannedLongLeadReleaseToken.addNotes = _SetVal.addNotes;
		this._plannedLongLeadReleaseToken.userOveridden = _SetVal.userOveridden;
	}
	get isLongLeadApplicable(): boolean {
		return this.parentSubSORef.pmTechSubSalesOrder.isLongLeadApplicable;
	}
	get plannedLongLeadReleaseDateLabel(): string {
		if (this.plannedLongReleaseDateisRevised == true) {
			return "Long Lead Release Revised (Planned)"
		} else {
			return "Long Lead Release Planned"
		}
	}
	get plannedLongReleaseDateisRevised(): boolean {
		if (this.plannedLongLeadReleaseDate_Initial && this.plannedLongLeadReleaseDate) {
			if (GenService.areDatesSame(this.plannedLongLeadReleaseDate_Initial, this.plannedLongLeadReleaseDate) == false) {
				return true;
			}
		}
		return false;
	}
	get plannedLongLeadReleaseDate_Initial(): Date {
		if (this.isLongLeadApplicable == false)
			return null;

		if (this._plannedLongLeadReleaseToken.actualPlannedDate == null || this._plannedLongLeadReleaseToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.enggDrawIP.plannedSLDGAApprovalDate_Initial;
			if (_tmpDate != null && configDefs.defPlndLongLeadReleaseDays) {
				this._plannedLongLeadReleaseToken.actualPlannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndLongLeadReleaseDays);
			}
			else {
				this._plannedLongLeadReleaseToken.actualPlannedDate = null;
			}
		}
		return this._plannedLongLeadReleaseToken.actualPlannedDate;
	}
	get plannedLongLeadReleaseDate(): Date {
		if (this.isLongLeadApplicable == false)
			return null;

		if (this._plannedLongLeadReleaseToken.plannedDate == null || this._plannedLongLeadReleaseToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.enggDrawIP.actualSLDGAApprovalDate;
			if (_tmpDate == null) {
				_tmpDate = this.parentSubSORef.enggDrawIP.plannedSLDGAApprovalDate
			}
			if (_tmpDate != null && configDefs.defPlndLongLeadReleaseDays) {
				this._plannedLongLeadReleaseToken.plannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndLongLeadReleaseDays);
			}
			else {
				this._plannedLongLeadReleaseToken.plannedDate = null;
			}
		}
		return this._plannedLongLeadReleaseToken.plannedDate;
	}
	private _plannedLongLeadReleaseGroup: RevisedDate;
	get plannedLongLeadReleaseGroup(): RevisedDate {
		this._plannedLongLeadReleaseGroup = new RevisedDate(this.plannedLongLeadReleaseDate_Initial, this.plannedLongReleaseDateisRevised, this.plannedLongLeadReleaseDate);

		return this._plannedLongLeadReleaseGroup;
	}
	set plannedLongLeadReleaseDate(_SetVal: Date) {
		// console.log("Possible wrong place for execution, not supposed to set plannedLongLeadReleaseDate directly");
		this._plannedLongLeadReleaseToken.plannedDate = _SetVal;
	}
	get actualLongLeadReleaseToken(): ActualDateToken {
		return this._actualLongLeadReleaseToken;
	}
	set actualLongLeadReleaseToken(_SetVal: ActualDateToken) {
		if (this._actualLongLeadReleaseToken.expActualDate == null)
			this._actualLongLeadReleaseToken.expActualDate = this.plannedLongLeadReleaseDate;
		this._actualLongLeadReleaseToken.actualDate = _SetVal.actualDate;
		this._actualLongLeadReleaseToken.isOveridden = _SetVal.isOveridden;
		this._actualLongLeadReleaseToken.addNotes = _SetVal.addNotes;
		this._actualLongLeadReleaseToken.userOveridden = _SetVal.userOveridden;
	}
	get actualLongLeadReleaseDate(): Date {
		if (this.isLongLeadApplicable == false) {
			return null;
		}
		// return this._actualLongLeadReleaseToken.actualDate;
		else {
			var fileB = this._longLeadFiles.FileArray;

			if (this._actualLongLeadReleaseToken.actualDate == null) {
				if (fileB.length > 0) {
					this._actualLongLeadReleaseToken.actualDate = new Date(fileB[0].DateTime.toDateString());
					this._actualLongLeadReleaseToken.addNotes = "Auto Date Updated By System";
					this._actualLongLeadReleaseToken.userOveridden = fileB[0].username;
					this._actualLongLeadReleaseToken.expActualDate = this.plannedLongLeadReleaseDate;
					return this._actualLongLeadReleaseToken.actualDate;
				}
			}
			else if (this._actualLongLeadReleaseToken.actualDate != null) {
				return this._actualLongLeadReleaseToken.actualDate;
			}
		}
	}
	set actualLongLeadReleaseDate(_SetVal: Date) {
		// console.log("Possible wrong place for execution, not supposed to set actualLongLeadReleaseDate directly");
		this._actualLongLeadReleaseToken.actualDate = _SetVal;
	}
	get actualC40Token(): ActualDateToken {
		return this._actualC40Token;
	}
	set actualC40Token(_SetVal: ActualDateToken) {
		if (this._actualC40Token.expActualDate == null)
			this._actualC40Token.expActualDate = this.plannedC40Date;
		this._actualC40Token.actualDate = _SetVal.actualDate;
		this._actualC40Token.isOveridden = _SetVal.isOveridden;
		this._actualC40Token.addNotes = _SetVal.addNotes;
		this._actualC40Token.userOveridden = _SetVal.userOveridden;
	}
	get actualC40Date(): Date {
		// return this._actualC40Token.actualDate;
		var fileB = this._c40c50c60Files.FileArray;

		if (this._actualC40Token.actualDate == null) {
			if (fileB.length > 0) {
				this._actualC40Token.actualDate = new Date(fileB[0].DateTime.toDateString());
				this._actualC40Token.addNotes = "Auto Date Updated By System";
				this._actualC40Token.userOveridden = fileB[0].username;
				this._actualC40Token.expActualDate = this.plannedC40Date;
				return this._actualC40Token.actualDate;
			}
		}
		else if (this._actualC40Token.actualDate != null) {
			return this._actualC40Token.actualDate;
		}
	}
	set actualC40Date(_SetVal: Date) {
		// console.log("Possible wrong place for execution, not supposed to set actualC40Date directly");
		this._actualC40Token.actualDate = _SetVal;
	}
	get actualC50Token(): ActualDateToken {
		return this._actualC50Token;
	}
	set actualC50Token(_SetVal: ActualDateToken) {
		if (this._actualC50Token.expActualDate == null)
			this._actualC50Token.expActualDate = this.plannedC50Date;
		this._actualC50Token.actualDate = _SetVal.actualDate;
		this._actualC50Token.isOveridden = _SetVal.isOveridden;
		this._actualC50Token.addNotes = _SetVal.addNotes;
		this._actualC50Token.userOveridden = _SetVal.userOveridden;
	}
	get actualC50Date(): Date {
		// return this._actualC50Token.actualDate;
		var fileB = this._c50Files.FileArray;

		if (this._actualC50Token.actualDate == null) {
			if (fileB.length > 0) {
				this._actualC50Token.actualDate = new Date(fileB[0].DateTime.toDateString());
				this._actualC50Token.addNotes = "Auto Date Updated By System";
				this._actualC50Token.userOveridden = fileB[0].username;
				this._actualC50Token.expActualDate = this.plannedC50Date;
				return this._actualC50Token.actualDate;
			}
		}
		else if (this._actualC50Token.actualDate != null) {
			return this._actualC50Token.actualDate;
		}
	}
	set actualC50Date(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set actualC50Date directly");
		this._actualC50Token.actualDate = _SetVal;
	}
	get actualC60Token(): ActualDateToken {
		return this._actualC60Token;
	}
	set actualC60Token(_SetVal: ActualDateToken) {
		if (this._actualC60Token.expActualDate == null)
			this._actualC60Token.expActualDate = this.plannedC60Date;
		this._actualC60Token.actualDate = _SetVal.actualDate;
		this._actualC60Token.isOveridden = _SetVal.isOveridden;
		this._actualC60Token.addNotes = _SetVal.addNotes;
		this._actualC60Token.userOveridden = _SetVal.userOveridden;
	}
	get actualC60Date(): Date {
		// return this._actualC60Token.actualDate;
		var fileB = this._c60Files.FileArray;

		if (this._actualC60Token.actualDate == null) {
			if (fileB.length > 0) {
				this._actualC60Token.actualDate = new Date(fileB[0].DateTime.toDateString());
				this._actualC60Token.addNotes = "Auto Date Updated By System";
				this._actualC60Token.userOveridden = fileB[0].username;
				this._actualC60Token.expActualDate = this.plannedC60Date;
				return this._actualC60Token.actualDate;
			}
		}
		else if (this._actualC60Token.actualDate != null) {
			return this._actualC60Token.actualDate;
		}
	}
	set actualC60Date(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set actualC60Date directly");
		this._actualC60Token.actualDate = _SetVal;
	}
	get enggProcFile(): EnggProcFileUploads {
		return this._c40c50c60Files;
	}
	set enggProcFile(_SetVal: EnggProcFileUploads) {
		this._c40c50c60Files = _SetVal;
	}
	get c50Files(): EnggProcFileUploads {
		return this._c50Files;
	}
	set c50Files(_SetVal: EnggProcFileUploads) {
		this._c50Files = _SetVal;
	}
	get c60Files(): EnggProcFileUploads {
		return this._c60Files;
	}
	set c60Files(_SetVal: EnggProcFileUploads) {
		this._c60Files = _SetVal;
	}
	get longLeadFiles(): EnggProcFileUploads {
		return this._longLeadFiles;
	}
	set longLeadFiles(_SetVal: EnggProcFileUploads) {
		this._longLeadFiles = _SetVal;
	}
	get asBuiltDrawFile() {
		return this._asBuiltDrawFiles;
	}
	set asBuiltDrawFile(_setVal: EnggProcFileUploads) {
		this._asBuiltDrawFiles = _setVal;
	}
	get asBuiltDrawElecFiles(): GenFileUploads {
		return this._asBuiltDrawElecFiles;
	}
	set asBuiltDrawElecFiles(_SetVal: GenFileUploads) {
		this._asBuiltDrawElecFiles = _SetVal;
	}
	get mechDesignChangeNoteFiles(): GenFileUploads {
		return this._mechDesignChangeNoteFiles;
	}
	set mechDesignChangeNoteFiles(_SetVal: GenFileUploads) {
		this._mechDesignChangeNoteFiles = _SetVal;
	}
	get elecDesignChangeNoteFiles(): GenFileUploads {
		return this._elecDesignChangeNoteFiles;
	}
	set elecDesignChangeNoteFiles(_SetVal: GenFileUploads) {
		this._elecDesignChangeNoteFiles = _SetVal;
	}
	get enggDays(): number {
		let _c40Days: number = configDefs.getDaysDifference(this.plannedC40Date, this.actualC40Date);
		let _c50Days: number = configDefs.getDaysDifference(this.plannedC50Date, this.actualC50Date);
		let _c60Days: number = configDefs.getDaysDifference(this.plannedC60Date, this.actualC60Date);
		return configDefs.getMinValue([_c40Days, _c50Days, _c60Days]);
	}
	get enggDaysTip(): string {
		let _tmpC40PlannedDate: Date = this.plannedC40Date
		let _tmpC40ActualDate: Date = this.actualC40Date
		let _tmpC50PlannedDate: Date = this.plannedC50Date
		let _tmpC50ActualDate: Date = this.actualC50Date
		let _tmpC60PlannedDate: Date = this.plannedC60Date
		let _tmpC60ActualDate: Date = this.actualC60Date
		let _c40Days: number = configDefs.getDaysDifference(this.plannedC40Date, this.actualC40Date);
		let _c50Days: number = configDefs.getDaysDifference(this.plannedC50Date, this.actualC50Date);
		let _c60Days: number = configDefs.getDaysDifference(this.plannedC60Date, this.actualC60Date);

		if (_c40Days || _c50Days || _c50Days) {
			return 'C40 Date : \r\n' +
				'Planned\t> ' + moment(_tmpC40PlannedDate).format(configDefs.dateFormat) + '\r\n' +
				'Actual\t> ' + moment(_tmpC40ActualDate).format(configDefs.dateFormat) + '\r\n' +
				'Diff Days\t> ' + _c40Days + '\r\n\n' +
				'C50 Date : \r\n' +
				'Planned\t> ' + moment(_tmpC50PlannedDate).format(configDefs.dateFormat) + '\r\n' +
				'Actual\t> ' + moment(_tmpC50ActualDate).format(configDefs.dateFormat) + '\r\n' +
				'Diff Days\t> ' + _c50Days + '\r\n\n' +
				'C60 Date : \r\n' +
				'Planned\t> ' + moment(_tmpC60PlannedDate).format(configDefs.dateFormat) + '\r\n' +
				'Actual\t> ' + moment(_tmpC60ActualDate).format(configDefs.dateFormat) + '\r\n' +
				'Diff Days\t> ' + _c60Days;
		}
		return '';
	}
	cloneSelf() {
		return new EnggProcureIP(this._plannedC40Token.cloneSelf(), this._plannedC50Token.cloneSelf(), this._plannedC60Token.cloneSelf(),
			this.plannedLongLeadReleaseToken.cloneSelf(), this._actualLongLeadReleaseToken.cloneSelf(),
			this._actualC40Token.cloneSelf(), this._actualC50Token.cloneSelf(), this._actualC60Token.cloneSelf(), this._relayconfigId, this._c40c50c60Files.cloneSelf(),
			this._c50Files.cloneSelf(), this._c60Files.cloneSelf(), this._longLeadFiles.cloneSelf(), this._asBuiltDrawFiles.cloneSelf(), this._asBuiltDrawElecFiles.cloneSelf(),
			this._mechDesignChangeNoteFiles.cloneSelf(), this._elecDesignChangeNoteFiles.cloneSelf(), this.status);
	}
	public static getObj(_json: any): EnggProcureIP {
		let _enggprocObj: any = _json;
		return new EnggProcureIP(convDefs.convToPlannedDateToken(_json.planC40Token), convDefs.convToPlannedDateToken(_json.planC50Token),
			convDefs.convToPlannedDateToken(_json.planC60Token), convDefs.convToPlannedDateToken(_json.planLongLeadReleaseToken),
			convDefs.convToActualDateToken(_json.actLongLeadReleaseToken), convDefs.convToActualDateToken(_json.actC40Token),
			convDefs.convToActualDateToken(_json.actC50Token), convDefs.convToActualDateToken(_json.actC60Token), _enggprocObj.relayconfigId,
			EnggProcFileUploads.getObj(_json.c40c50c60FilesToken), EnggProcFileUploads.getObj(_json.c50FilesToken),
			EnggProcFileUploads.getObj(_json.c60FilesToken), EnggProcFileUploads.getObj(_json.longLeadFilesToken),
			EnggProcFileUploads.getObj(_json.asBuiltDrawFilesToken),
			GenFileUploads.getObj(_json.asBuiltDrawElecToken), GenFileUploads.getObj(_json.mechDesignChangeNoteToken),
			GenFileUploads.getObj(_json.elecDesignChangeNoteToken), _json.status);
	}
	public getJson(): any {
		let _json: any = {};
		_json.relayconfigId = this.relayconfigId;

		_json.planC40Token = this.plannedC40Token.getJson();
		_json.planC50Token = this.plannedC50Token.getJson();
		_json.planC60Token = this.plannedC60Token.getJson();
		_json.planLongLeadReleaseToken = this.plannedLongLeadReleaseToken.getJson();
		_json.actLongLeadReleaseToken = this.actualLongLeadReleaseToken.getJson();
		_json.actC40Token = this.actualC40Token.getJson();
		_json.actC50Token = this.actualC50Token.getJson();
		_json.actC60Token = this.actualC60Token.getJson();
		_json.c40c50c60FilesToken = (this.enggProcFile ? this.enggProcFile.getJson() : null);
		_json.c50FilesToken = (this.c50Files ? this.c50Files.getJson() : null);
		_json.c60FilesToken = (this.c60Files ? this.c60Files.getJson() : null);
		_json.longLeadFilesToken = (this.longLeadFiles ? this.longLeadFiles.getJson() : null);
		_json.asBuiltDrawFilesToken = (this.asBuiltDrawFile ? this.asBuiltDrawFile.getJson() : null);
		_json.asBuiltDrawElecToken = this.asBuiltDrawElecFiles.getJson();
		_json.mechDesignChangeNoteToken = this.mechDesignChangeNoteFiles.getJson();
		_json.elecDesignChangeNoteToken = this.elecDesignChangeNoteFiles.getJson();
		_json.status = this.status;
		return _json;
	}
}

export class PurchasePOIP {
	constructor(private _importedBreakerPOReleasedPlannedToken: PlannedDateToken, private _importedVSCPOReleasedPlannedToken: PlannedDateToken,
		private _geRelayPOReleasePlannedToken: PlannedDateToken, private _ctPTPOReleasedPlannedToken: PlannedDateToken,
		private _relayPOReleasedPlannedToken: PlannedDateToken, private _breakerPOReleasePlannedToken: PlannedDateToken,
		private _saPOReleasedPlannedToken: PlannedDateToken, private _meteringBoxPOReleasePlannedToken: PlannedDateToken,
		private _importedBreakerPOReleasedActualToken: ActualDateToken, private _importedVSCPOReleasedActualToken: ActualDateToken,
		private _geRelayPOReleaseActualToken: ActualDateToken, private _ctPTPOReleasedActualToken: ActualDateToken,
		private _relayPOReleasedActualToken: ActualDateToken, private _breakerPOReleaseActualToken: ActualDateToken,
		private _saPOReleasedActualToken: ActualDateToken, private _meteringBoxPOReleaseActualToken: ActualDateToken,
		private _status: FunctionStatus) {

	}
	private _parentSORef: SalesOrder;
	private _parentSubSORef: SubSalesOrder;
	refreshStatus() {
		if (this.parentSORef && this.parentSubSORef && this.parentSORef.projectStatus >= SOStatus.Sub_Orders) {
			if (this.parentSubSORef.isSSOStatusSet(SSOStatus.PO) == true ||
				this.parentSubSORef.isSSOStatusSet(SSOStatus.Planning_From_PO)) {
				if (this.parentSubSORef.isSSOStatusSet(SSOStatus.Planning_From_PO) == true) {
					let _isTempComplete: boolean = this.isFunctionComplete();

					if (_isTempComplete == true) {
						this._status = FunctionStatus.SUBMITTED_COMPLETE;
					}
					else {
						this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
					}
				}
				else {
					this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
				}

			}
			else {
				this._status = FunctionStatus.WAITING_FOR_PREV;
			}
		}
		else {
			this._status = FunctionStatus.WAITING_FOR_PREV;
		}
	}
	private isFunctionComplete(): boolean {
		if (this.importedBreakerPOReleasedPlannedDate_Enable) {
			if (configDefs.isDtEmty(this.importedBreakerPOReleasedPlannedDate)) return false;
			if (configDefs.isDtEmty(this.importedBreakerPOReleasedActualDate)) return false;
		}
		if (this.importedVSCPOReleasedActualDate_Enable) {
			if (configDefs.isDtEmty(this.importedVSCPOReleasedPlannedDate)) return false;
			if (configDefs.isDtEmty(this.importedVSCPOReleasedActualDate)) return false;
		}
		if (this.geRelayPOReleaseActualDate_Enable) {
			if (configDefs.isDtEmty(this.geRelayPOReleasePlannedDate)) return false;
			if (configDefs.isDtEmty(this.geRelayPOReleaseActualDate)) return false;
		}
		if (configDefs.isDtEmty(this.ctPTPOReleasedPlannedDate)) return false;
		if (configDefs.isDtEmty(this.ctPTPOReleasedActualDate)) return false;

		if (this.geRelayPOReleasePlannedDate_Enable) {
			if (configDefs.isDtEmty(this.relayPOReleasedPlannedDate)) return false;
			if (configDefs.isDtEmty(this.relayPOReleasedActualDate)) return false;
		}
		if (configDefs.isDtEmty(this.breakerPOReleasePlannedDate)) return false;
		if (configDefs.isDtEmty(this.breakerPOReleaseActualDate)) return false;

		//bypassed SA as per requiremnt change
		//if (configDefs.isDtEmty(this.saPOReleasedPlannedDate)) return false;
		//if (configDefs.isDtEmty(this.saPOReleasedActualDate)) return false;
		if (this.meteringBoxPORelease_Enable) {
			if (configDefs.isDtEmty(this.meteringBoxPOReleasePlannedDate)) return false;
			if (configDefs.isDtEmty(this.meteringBoxPOReleaseActualDate)) return false;
		}


		return true;
	}
	get isProjectLive(): boolean {
		return this.parentSubSORef.pmTechSubSalesOrder.projStatus == "live";
	}
	get isInputEnabled(): boolean {
		return this.parentSubSORef.isSSOStatusSet(SSOStatus.PO);
	}
	get isSubmittedtoPlanning(): boolean {
		return this.parentSubSORef.isSSOStatusSet(SSOStatus.Planning_From_PO);
	}
	get readyForPlanning(): boolean {
		return true;//need to add logic
	}
	get parentSORef(): SalesOrder {
		return this._parentSORef;
	}
	set parentSORef(SORef: SalesOrder) {
		this._parentSORef = SORef;
		//this.refreshStatus();
	}
	enableFormInput(): void {
		if (this._status == FunctionStatus.WAITING_FOR_PREV) {
			this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
		}
	}
	get status(): FunctionStatus {
		return this._status;
	}
	get parentSubSORef(): SubSalesOrder {
		return this._parentSubSORef;
	}
	set parentSubSORef(SubSORef: SubSalesOrder) {
		this._parentSubSORef = SubSORef;
	}
	get importedBreakerPOReleasedPlannedToken(): PlannedDateToken {
		return this._importedBreakerPOReleasedPlannedToken;
	}
	set importedBreakerPOReleasedPlannedToken(_SetVal: PlannedDateToken) {
		// if (this._importedBreakerPOReleasedPlannedToken.actualPlannedDate == null)
		// 	this._importedBreakerPOReleasedPlannedToken.actualPlannedDate = this.importedBreakerPOReleasedPlannedDate;
		this._importedBreakerPOReleasedPlannedToken.plannedDate = _SetVal.plannedDate;
		this._importedBreakerPOReleasedPlannedToken.isOveridden = _SetVal.isOveridden;
		this._importedBreakerPOReleasedPlannedToken.addNotes = _SetVal.addNotes;
		this._importedBreakerPOReleasedPlannedToken.userOveridden = _SetVal.userOveridden;
	}
	get importedBreakerPOReleasedPlannedDateLabel(): string {
		if (this.importedBreakerPOReleasedPlannedDateisRevised == true) {
			return "Revised (Planned) Date";
		}
		else {
			return "Planned Date";
		}
	}
	get importedBreakerPOReleasedPlannedDateisRevised(): boolean {
		if (this.importedBreakerPOReleasedPlannedDate_Initial && this.importedBreakerPOReleasedPlannedDate) {
			if (GenService.areDatesSame(this.importedBreakerPOReleasedPlannedDate_Initial, this.importedBreakerPOReleasedPlannedDate) == false) {
				return true;
			}
		}
		return false;
	}
	get importedBreakerPOReleasedPlannedDate_Initial(): Date {
		if (this._importedBreakerPOReleasedPlannedToken.actualPlannedDate == null || this._importedBreakerPOReleasedPlannedToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.enggProcureIP.plannedLongLeadReleaseDate_Initial;
			if (_tmpDate != null && configDefs.defPlndImpBrkPORlsDays) {
				this._importedBreakerPOReleasedPlannedToken.actualPlannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndImpBrkPORlsDays);
			}
			else {
				this._importedBreakerPOReleasedPlannedToken.actualPlannedDate = null;
			}
		}
		return this._importedBreakerPOReleasedPlannedToken.actualPlannedDate;
	}
	get importedBreakerPOReleasedPlannedDate(): Date {
		if (this._importedBreakerPOReleasedPlannedToken.plannedDate == null || this._importedBreakerPOReleasedPlannedToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.enggProcureIP.actualLongLeadReleaseDate;
			if (_tmpDate == null) {
				_tmpDate = this.parentSubSORef.enggProcureIP.plannedLongLeadReleaseDate;
			}
			if (_tmpDate != null && configDefs.defPlndImpBrkPORlsDays) {
				this._importedBreakerPOReleasedPlannedToken.plannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndImpBrkPORlsDays);
			}
			else {
				this._importedBreakerPOReleasedPlannedToken.plannedDate = null;
			}
		}
		return this._importedBreakerPOReleasedPlannedToken.plannedDate;
	}
	private _importedBreakerPOReleasedPlannedGroup: RevisedDate;
	get importedBreakerPOReleasedPlannedGroup(): RevisedDate {
		this._importedBreakerPOReleasedPlannedGroup = new RevisedDate(this.importedBreakerPOReleasedPlannedDate_Initial, this.importedBreakerPOReleasedPlannedDateisRevised, this.importedBreakerPOReleasedPlannedDate);

		return this._importedBreakerPOReleasedPlannedGroup;
	}
	get importedBreakerPOReleasedPlannedDate_Enable(): boolean {
		return this.parentSubSORef.pmTechSubSalesOrder.breakerApplicability_Enable;
	}
	set importedBreakerPOReleasedPlannedDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set importedBreakerPOReleasedPlannedDate directly");
		this._importedBreakerPOReleasedPlannedToken.plannedDate = _SetVal;
	}
	get importedVSCPOReleasedPlannedToken(): PlannedDateToken {
		return this._importedVSCPOReleasedPlannedToken;
	}
	set importedVSCPOReleasedPlannedToken(_SetVal: PlannedDateToken) {
		// if (this._importedVSCPOReleasedPlannedToken.actualPlannedDate == null)
		// 	this._importedVSCPOReleasedPlannedToken.actualPlannedDate = this.importedVSCPOReleasedPlannedDate;
		this._importedVSCPOReleasedPlannedToken.plannedDate = _SetVal.plannedDate;
		this._importedVSCPOReleasedPlannedToken.isOveridden = _SetVal.isOveridden;
		this._importedVSCPOReleasedPlannedToken.addNotes = _SetVal.addNotes;
		this._importedVSCPOReleasedPlannedToken.userOveridden = _SetVal.userOveridden;
	}
	get importedVSCPOReleasedPlannedDateLabel(): string {
		if (this.importedVSCPOReleasedPlannedDateisRevised == true) {
			return "Revised (Planned) Date";
		}
		else {
			return "Planned Date";
		}
	}
	get importedVSCPOReleasedPlannedDateisRevised(): boolean {
		if (this.importedVSCPOReleasedPlannedDate_Initial && this.importedVSCPOReleasedPlannedDate) {
			if (GenService.areDatesSame(this.importedVSCPOReleasedPlannedDate_Initial, this.importedVSCPOReleasedPlannedDate) == false) {
				return true;
			}
		}
		return false;
	}
	get importedVSCPOReleasedPlannedDate_Initial(): Date {
		if (this._importedVSCPOReleasedPlannedToken.actualPlannedDate == null || this._importedVSCPOReleasedPlannedToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.enggProcureIP.plannedLongLeadReleaseDate_Initial;
			if (_tmpDate != null && configDefs.defPlndImpVSCPORlsDays) {
				this._importedVSCPOReleasedPlannedToken.actualPlannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndImpVSCPORlsDays);
			}
			else {
				this._importedVSCPOReleasedPlannedToken.actualPlannedDate = null;
			}
		}
		return this._importedVSCPOReleasedPlannedToken.actualPlannedDate;
	}
	get importedVSCPOReleasedPlannedDate(): Date {
		if (this._importedVSCPOReleasedPlannedToken.plannedDate == null || this._importedVSCPOReleasedPlannedToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.enggProcureIP.actualLongLeadReleaseDate;
			if (_tmpDate == null) {
				_tmpDate = this.parentSubSORef.enggProcureIP.plannedLongLeadReleaseDate;
			}
			if (_tmpDate != null && configDefs.defPlndImpVSCPORlsDays) {
				this._importedVSCPOReleasedPlannedToken.plannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndImpVSCPORlsDays);
			}
			else {
				this._importedVSCPOReleasedPlannedToken.plannedDate = null;
			}
		}
		return this._importedVSCPOReleasedPlannedToken.plannedDate;
	}
	private _importedVSCPOReleasedPlannedGroup: RevisedDate;
	get importedVSCPOReleasedPlannedGroup(): RevisedDate {
		this._importedVSCPOReleasedPlannedGroup = new RevisedDate(this.importedVSCPOReleasedPlannedDate_Initial, this.importedVSCPOReleasedPlannedDateisRevised, this.importedVSCPOReleasedPlannedDate);

		return this._importedVSCPOReleasedPlannedGroup;
	}
	get importedVSCPOReleasedDate_Enable(): boolean {
		return this.parentSubSORef.pmTechSubSalesOrder.vscApplicability_Enable;
	}
	set importedVSCPOReleasedPlannedDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set importedVSCPOReleasedPlannedDate directly");
		this._importedVSCPOReleasedPlannedToken.plannedDate = _SetVal;
	}
	get geRelayPOReleasePlannedToken(): PlannedDateToken {
		return this._geRelayPOReleasePlannedToken;
	}
	set geRelayPOReleasePlannedToken(_SetVal: PlannedDateToken) {
		// if (this._geRelayPOReleasePlannedToken.actualPlannedDate == null)
		// 	this._geRelayPOReleasePlannedToken.actualPlannedDate = this.geRelayPOReleasePlannedDate;
		this._geRelayPOReleasePlannedToken.plannedDate = _SetVal.plannedDate;
		this._geRelayPOReleasePlannedToken.isOveridden = _SetVal.isOveridden;
		this._geRelayPOReleasePlannedToken.addNotes = _SetVal.addNotes;
		this._geRelayPOReleasePlannedToken.userOveridden = _SetVal.userOveridden;
	}
	get geRelayPOReleasePlannedDateLabel(): string {
		if (this.geRelayPOReleasePlannedDateIsRevised == true) {
			return "Revised (Planned) Date";
		} else {
			return "Planned Date";
		}
	}
	get geRelayPOReleasePlannedDateIsRevised(): boolean {
		if (this.geRelayPOReleasePlannedDate_Initial && this.geRelayPOReleasePlannedDate) {
			if (GenService.areDatesSame(this.geRelayPOReleasePlannedDate_Initial, this.geRelayPOReleasePlannedDate) == false) {
				return true;
			}
		}
		return false;
	}
	get geRelayPOReleasePlannedDate_Initial(): Date {
		if (this._geRelayPOReleasePlannedToken.actualPlannedDate == null || this._geRelayPOReleasePlannedToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.pmTechSubSalesOrder.plannedDrawingApprovalDate_Initial;
			if (_tmpDate != null && configDefs.defPlndGERelayPORelDays) {
				this._geRelayPOReleasePlannedToken.actualPlannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndGERelayPORelDays);
			}
			else {
				this._geRelayPOReleasePlannedToken.actualPlannedDate = null;
			}
		}
		return this._geRelayPOReleasePlannedToken.actualPlannedDate;
	}
	get geRelayPOReleasePlannedDate(): Date {
		if (this._geRelayPOReleasePlannedToken.plannedDate == null || this._geRelayPOReleasePlannedToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.pmTechSubSalesOrder.actOrPlndDrawingApprovalDate;

			if (_tmpDate != null && configDefs.defPlndGERelayPORelDays) {
				this._geRelayPOReleasePlannedToken.plannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndGERelayPORelDays);
			}
			else {
				this._geRelayPOReleasePlannedToken.plannedDate = null;
			}
		}
		return this._geRelayPOReleasePlannedToken.plannedDate;
	}
	private _geRelayPOReleasePlannedGroup: RevisedDate;
	get geRelayPOReleasePlannedGroup(): RevisedDate {
		this._geRelayPOReleasePlannedGroup = new RevisedDate(this.geRelayPOReleasePlannedDate_Initial, this.geRelayPOReleasePlannedDateIsRevised, this.geRelayPOReleasePlannedDate);

		return this._geRelayPOReleasePlannedGroup;
	}
	get geRelayPOReleasePlannedDate_Enable(): boolean {
		return this.parentSubSORef.pmTechSubSalesOrder.geRelayApplicability_Enable;
	}
	get meteringBoxPORelease_Enable(): boolean {
		return this.parentSubSORef.planningIP.manufacturingStrategyInhouse_Enable == true
	}
	set geRelayPOReleasePlannedDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set geRelayPOReleasePlannedDate directly");
		this._geRelayPOReleasePlannedToken.plannedDate = _SetVal;
	}
	get ctPTPOReleasedPlannedToken(): PlannedDateToken {
		return this._ctPTPOReleasedPlannedToken;
	}
	set ctPTPOReleasedPlannedToken(_SetVal: PlannedDateToken) {
		if (this._ctPTPOReleasedPlannedToken.actualPlannedDate == null)
			// 	this._ctPTPOReleasedPlannedToken.actualPlannedDate = this.ctPTPOReleasedPlannedDate;
			// this._ctPTPOReleasedPlannedToken.plannedDate = _SetVal.plannedDate;
			this._ctPTPOReleasedPlannedToken.isOveridden = _SetVal.isOveridden;
		this._ctPTPOReleasedPlannedToken.addNotes = _SetVal.addNotes;
		this._ctPTPOReleasedPlannedToken.userOveridden = _SetVal.userOveridden;
	}
	get ctPTPOReleasedPlannedDateLabel(): string {
		if (this.ctPTPOReleasedPlannedDateIsRevised == true) {
			return "Revised (Planned) Date"
		} else {
			return "Planned Date"
		}
	}
	get ctPTPOReleasedPlannedDateIsRevised(): boolean {
		if (this.ctPTPOReleasedPlannedDate_Initial && this.ctPTPOReleasedPlannedDate) {
			if (GenService.areDatesSame(this.ctPTPOReleasedPlannedDate_Initial, this.ctPTPOReleasedPlannedDate) == false) {
				return true;
			}
		}
		return false;
	}
	get ctPTPOReleasedPlannedDate_Initial(): Date {
		if (this._ctPTPOReleasedPlannedToken.actualPlannedDate == null || this._ctPTPOReleasedPlannedToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.enggProcureIP.plannedC40Date_Initial;
			if (_tmpDate != null && configDefs.defPlndCTPTPORlsDays) {
				this._ctPTPOReleasedPlannedToken.actualPlannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndCTPTPORlsDays);
			}
			else {
				this._ctPTPOReleasedPlannedToken.actualPlannedDate = null;
			}
		}
		return this._ctPTPOReleasedPlannedToken.actualPlannedDate;
	}
	get ctPTPOReleasedPlannedDate(): Date {
		if (this._ctPTPOReleasedPlannedToken.plannedDate == null || this._ctPTPOReleasedPlannedToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.enggProcureIP.actualC40Date;
			if (_tmpDate == null) {
				_tmpDate = this.parentSubSORef.enggProcureIP.plannedC40Date;
			}
			if (_tmpDate != null && configDefs.defPlndCTPTPORlsDays) {
				this._ctPTPOReleasedPlannedToken.plannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndCTPTPORlsDays);
			}
			else {
				this._ctPTPOReleasedPlannedToken.plannedDate = null;
			}
		}
		return this._ctPTPOReleasedPlannedToken.plannedDate;
	}
	private _ctPTPOReleasedPlannedGroup: RevisedDate;
	get ctPTPOReleasedPlannedGroup(): RevisedDate {
		this._ctPTPOReleasedPlannedGroup = new RevisedDate(this.ctPTPOReleasedPlannedDate_Initial, this.ctPTPOReleasedPlannedDateIsRevised, this.ctPTPOReleasedPlannedDate);

		return this._ctPTPOReleasedPlannedGroup;
	}
	set ctPTPOReleasedPlannedDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set ctPTPOReleasedPlannedDate directly");
		this._ctPTPOReleasedPlannedToken.plannedDate = _SetVal;
	}
	get relayPOReleasedPlannedToken(): PlannedDateToken {
		return this._relayPOReleasedPlannedToken;
	}
	set relayPOReleasedPlannedToken(_SetVal: PlannedDateToken) {
		// if (this._relayPOReleasedPlannedToken.actualPlannedDate == null)
		// 	this._relayPOReleasedPlannedToken.actualPlannedDate = this.relayPOReleasedPlannedDate;
		this._relayPOReleasedPlannedToken.plannedDate = _SetVal.plannedDate;
		this._relayPOReleasedPlannedToken.isOveridden = _SetVal.isOveridden;
		this._relayPOReleasedPlannedToken.addNotes = _SetVal.addNotes;
		this._relayPOReleasedPlannedToken.userOveridden = _SetVal.userOveridden;
	}
	get relayPOReleasedPlannedDateLabel(): string {
		if (this.relayPOReleasedPlannedDateIsRevised == true) {
			return "Revised (Planned) Date"
		} else {
			return "Planned Date"
		}
	}
	get relayPOReleasedPlannedDateIsRevised(): boolean {
		if (this.relayPOReleasedPlannedDate_Initial && this.relayPOReleasedPlannedDate) {
			if (GenService.areDatesSame(this.relayPOReleasedPlannedDate_Initial, this.relayPOReleasedPlannedDate) == false) {
				return true;
			}
		}
		return false;
	}
	get relayPOReleasedPlannedDate_Initial(): Date {
		if (this._relayPOReleasedPlannedToken.actualPlannedDate == null || this._relayPOReleasedPlannedToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.enggProcureIP.plannedC40Date_Initial;
			if (_tmpDate != null && configDefs.defPlndRelayPORlsDays) {
				this._relayPOReleasedPlannedToken.actualPlannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndRelayPORlsDays);
			}
			else {
				this._relayPOReleasedPlannedToken.actualPlannedDate = null;
			}
		}
		return this._relayPOReleasedPlannedToken.actualPlannedDate;
	}
	get relayPOReleasedPlannedDate(): Date {
		if (this._relayPOReleasedPlannedToken.plannedDate == null || this._relayPOReleasedPlannedToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.enggProcureIP.actualC40Date;
			if (_tmpDate == null) {
				_tmpDate = this.parentSubSORef.enggProcureIP.plannedC40Date;
			}
			if (_tmpDate != null && configDefs.defPlndRelayPORlsDays) {
				this._relayPOReleasedPlannedToken.plannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndRelayPORlsDays);
			}
			else {
				this._relayPOReleasedPlannedToken.plannedDate = null;
			}
		}
		return this._relayPOReleasedPlannedToken.plannedDate;
	}
	private _relayPOReleasedPlannedGroup: RevisedDate;
	get relayPOReleasedPlannedGroup(): RevisedDate {
		this._relayPOReleasedPlannedGroup = new RevisedDate(this.relayPOReleasedPlannedDate_Initial, this.relayPOReleasedPlannedDateIsRevised, this.relayPOReleasedPlannedDate);

		return this._relayPOReleasedPlannedGroup;
	}
	set relayPOReleasedPlannedDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set relayPOReleasedPlannedDate directly");
		this._relayPOReleasedPlannedToken.plannedDate = _SetVal;
	}
	get breakerPOReleasePlannedToken(): PlannedDateToken {
		return this._breakerPOReleasePlannedToken;
	}
	set breakerPOReleasePlannedToken(_SetVal: PlannedDateToken) {
		// if (this._breakerPOReleasePlannedToken.actualPlannedDate == null)
		// 	this._breakerPOReleasePlannedToken.actualPlannedDate = this.breakerPOReleasePlannedDate;
		this._breakerPOReleasePlannedToken.plannedDate = _SetVal.plannedDate;
		this._breakerPOReleasePlannedToken.isOveridden = _SetVal.isOveridden;
		this._breakerPOReleasePlannedToken.addNotes = _SetVal.addNotes;
		this._breakerPOReleasePlannedToken.userOveridden = _SetVal.userOveridden;
	}
	get breakerPOReleasePlannedDateLabel(): string {
		if (this.breakerPOReleasePlannedDateIsRevised == true) {
			return "Revised (Planned) Date"
		} else {
			return "Planned Date"
		}
	}
	get breakerPOReleasePlannedDateIsRevised(): boolean {
		if (this.breakerPOReleasePlannedDate_Initial && this.breakerPOReleasePlannedDate) {
			if (GenService.areDatesSame(this.breakerPOReleasePlannedDate_Initial, this.breakerPOReleasePlannedDate) == false) {
				return true;
			}
		}
		return false;
	}
	get breakerPOReleasePlannedDate_Initial(): Date {
		if (this._breakerPOReleasePlannedToken.actualPlannedDate == null || this._breakerPOReleasePlannedToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.enggProcureIP.plannedC40Date_Initial;
			if (_tmpDate != null && configDefs.defPlndBrkrPORlsDays) {
				this._breakerPOReleasePlannedToken.actualPlannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndRelayPORlsDays);
			}
			else {
				this._breakerPOReleasePlannedToken.actualPlannedDate = null;
			}
		}
		return this._breakerPOReleasePlannedToken.actualPlannedDate;
	}
	get breakerPOReleasePlannedDate(): Date {
		if (this._breakerPOReleasePlannedToken.plannedDate == null || this._breakerPOReleasePlannedToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.enggProcureIP.actualC40Date;
			if (_tmpDate == null) {
				_tmpDate = this.parentSubSORef.enggProcureIP.plannedC40Date;
			}
			if (_tmpDate != null && configDefs.defPlndBrkrPORlsDays) {
				this._breakerPOReleasePlannedToken.plannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndRelayPORlsDays);
			}
			else {
				this._breakerPOReleasePlannedToken.plannedDate = null;
			}
		}
		return this._breakerPOReleasePlannedToken.plannedDate;
	}
	private _breakerPOReleasePlannedGroup: RevisedDate;
	get breakerPOReleasePlannedGroup(): RevisedDate {
		this._breakerPOReleasePlannedGroup = new RevisedDate(this.breakerPOReleasePlannedDate_Initial, this.breakerPOReleasePlannedDateIsRevised, this.breakerPOReleasePlannedDate);

		return this._breakerPOReleasePlannedGroup;
	}
	set breakerPOReleasePlannedDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set breakerPOReleasePlannedDate directly");
		this._breakerPOReleasePlannedToken.plannedDate = _SetVal;
	}
	get saPOReleasedPlannedToken(): PlannedDateToken {
		return this._saPOReleasedPlannedToken;
	}
	set saPOReleasedPlannedToken(_SetVal: PlannedDateToken) {
		// if (this._saPOReleasedPlannedToken.actualPlannedDate == null)
		// 	this._saPOReleasedPlannedToken.actualPlannedDate = this.saPOReleasedPlannedDate;
		this._saPOReleasedPlannedToken.plannedDate = _SetVal.plannedDate;
		this._saPOReleasedPlannedToken.isOveridden = _SetVal.isOveridden;
		this._saPOReleasedPlannedToken.addNotes = _SetVal.addNotes;
		this._saPOReleasedPlannedToken.userOveridden = _SetVal.userOveridden;
	}
	get saPOReleasedPlannedDateLabel(): string {
		if (this.saPOReleasedPlannedDateIsRevised == true) {
			return "Revised (Planned) Date"
		} else {
			return "Planned Date"
		}
	}
	get saPOReleasedPlannedDateIsRevised(): boolean {
		if (this.saPOReleasedPlannedDate_Initial && this.saPOReleasedPlannedDate) {
			if (GenService.areDatesSame(this.saPOReleasedPlannedDate_Initial, this.saPOReleasedPlannedDate) == false) {
				return true;
			}
		}
		return false;
	}
	get saPOReleasedPlannedDate_Initial(): Date {
		if (this._saPOReleasedPlannedToken.actualPlannedDate == null || this._saPOReleasedPlannedToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.enggProcureIP.plannedC40Date_Initial;

			if (_tmpDate != null && configDefs.defPlndSAPORlsDays) {
				this._saPOReleasedPlannedToken.actualPlannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndRelayPORlsDays);
			}
			else {
				this._saPOReleasedPlannedToken.actualPlannedDate = null;
			}
		}
		return this._saPOReleasedPlannedToken.actualPlannedDate;
	}
	get saPOReleasedPlannedDate(): Date {
		if (this._saPOReleasedPlannedToken.plannedDate == null || this._saPOReleasedPlannedToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.enggProcureIP.actualC40Date;
			if (_tmpDate == null) {
				_tmpDate = this.parentSubSORef.enggProcureIP.plannedC40Date;
			}
			if (_tmpDate != null && configDefs.defPlndSAPORlsDays) {
				this._saPOReleasedPlannedToken.plannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndRelayPORlsDays);
			}
			else {
				this._saPOReleasedPlannedToken.plannedDate = null;
			}
		}
		return this._saPOReleasedPlannedToken.plannedDate;
	}
	private _saPOReleasedPlannedGroup: RevisedDate;
	get saPOReleasedPlannedGroup(): RevisedDate {
		this._saPOReleasedPlannedGroup = new RevisedDate(this.saPOReleasedPlannedDate_Initial, this.saPOReleasedPlannedDateIsRevised, this.saPOReleasedPlannedDate);

		return this._saPOReleasedPlannedGroup;
	}
	set saPOReleasedPlannedDate(_SetVal: Date) {
		this._saPOReleasedPlannedToken.plannedDate = _SetVal;
	}
	get meteringBoxPOReleasePlannedToken(): PlannedDateToken {
		return this._meteringBoxPOReleasePlannedToken;
	}
	set meteringBoxPOReleasePlannedToken(_SetVal: PlannedDateToken) {
		// if (this._meteringBoxPOReleasePlannedToken.actualPlannedDate == null)
		// 	this._meteringBoxPOReleasePlannedToken.actualPlannedDate = this.meteringBoxPOReleasePlannedDate;
		this._meteringBoxPOReleasePlannedToken.plannedDate = _SetVal.plannedDate;
		this._meteringBoxPOReleasePlannedToken.isOveridden = _SetVal.isOveridden;
		this._meteringBoxPOReleasePlannedToken.addNotes = _SetVal.addNotes;
		this._meteringBoxPOReleasePlannedToken.userOveridden = _SetVal.userOveridden;
	}
	get meteringBoxPOReleasePlannedDateLabel(): string {
		if (this.meteringBoxPOReleasePlannedDateIsRevised == true) {
			return "Revised (Planned) Date"
		} else {
			return "Planned Date"
		}
	}
	get meteringBoxPOReleasePlannedDateIsRevised(): boolean {
		if (this.meteringBoxPOReleasePlannedDate_Initial && this.meteringBoxPOReleasePlannedDate) {
			if (GenService.areDatesSame(this.meteringBoxPOReleasePlannedDate_Initial, this.meteringBoxPOReleasePlannedDate) == false) {
				return true;
			}
		}
		return false;
	}
	get meteringBoxPOReleasePlannedDate_Initial(): Date {
		if (this._meteringBoxPOReleasePlannedToken.actualPlannedDate == null || this._meteringBoxPOReleasePlannedToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.enggProcureIP.plannedC50Date_Initial;

			if (_tmpDate != null && configDefs.defPlndMtrBoxPORlsDays) {
				this._meteringBoxPOReleasePlannedToken.actualPlannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndMtrBoxPORlsDays);
			}
			else {
				this._meteringBoxPOReleasePlannedToken.actualPlannedDate = null;
			}
		}
		return this._meteringBoxPOReleasePlannedToken.actualPlannedDate;
	}
	get meteringBoxPOReleasePlannedDate(): Date {
		if (this._meteringBoxPOReleasePlannedToken.plannedDate == null || this._meteringBoxPOReleasePlannedToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.enggProcureIP.actualC50Date;
			if (_tmpDate == null) {
				_tmpDate = this.parentSubSORef.enggProcureIP.plannedC50Date;
			}
			if (_tmpDate != null && configDefs.defPlndMtrBoxPORlsDays) {
				this._meteringBoxPOReleasePlannedToken.plannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndMtrBoxPORlsDays);
			}
			else {
				this._meteringBoxPOReleasePlannedToken.plannedDate = null;
			}
		}
		return this._meteringBoxPOReleasePlannedToken.plannedDate;
	}
	private _meteringBoxPOReleasePlannedGroup: RevisedDate;
	get meteringBoxPOReleasePlannedGroup(): RevisedDate {
		this._meteringBoxPOReleasePlannedGroup = new RevisedDate(this.meteringBoxPOReleasePlannedDate_Initial, this.meteringBoxPOReleasePlannedDateIsRevised, this.meteringBoxPOReleasePlannedDate);

		return this._meteringBoxPOReleasePlannedGroup;
	}
	set meteringBoxPOReleasePlannedDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set meteringBoxPOReleasePlannedDate directly");
		this._meteringBoxPOReleasePlannedToken.plannedDate = _SetVal;
	}
	get importedBreakerPOReleasedActualToken(): ActualDateToken {
		return this._importedBreakerPOReleasedActualToken;
	}
	set importedBreakerPOReleasedActualToken(_SetVal: ActualDateToken) {
		if (this._importedBreakerPOReleasedActualToken.expActualDate == null)
			this._importedBreakerPOReleasedActualToken.expActualDate = this.importedBreakerPOReleasedActualDate;
		this._importedBreakerPOReleasedActualToken.actualDate = _SetVal.actualDate;
		this._importedBreakerPOReleasedActualToken.isOveridden = _SetVal.isOveridden;
		this._importedBreakerPOReleasedActualToken.addNotes = _SetVal.addNotes;
		this._importedBreakerPOReleasedActualToken.userOveridden = _SetVal.userOveridden;
	}
	get importedBreakerPOReleasedActualDate(): Date {
		return this._importedBreakerPOReleasedActualToken.actualDate;
	}
	get importedBreakerPOReleasedActualDate_Enable(): boolean {
		return this.parentSubSORef.pmTechSubSalesOrder.breakerApplicability_Enable;
	}
	set importedBreakerPOReleasedActualDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set importedBreakerPOReleasedActualDate directly");
		this._importedBreakerPOReleasedActualToken.actualDate = _SetVal;
	}
	get importedVSCPOReleasedActualToken(): ActualDateToken {
		return this._importedVSCPOReleasedActualToken;
	}
	set importedVSCPOReleasedActualToken(_SetVal: ActualDateToken) {
		if (this._importedVSCPOReleasedActualToken.expActualDate == null)
			this._importedVSCPOReleasedActualToken.expActualDate = this.importedVSCPOReleasedActualDate;
		this._importedVSCPOReleasedActualToken.actualDate = _SetVal.actualDate;
		this._importedVSCPOReleasedActualToken.isOveridden = _SetVal.isOveridden;
		this._importedVSCPOReleasedActualToken.addNotes = _SetVal.addNotes;
		this._importedVSCPOReleasedActualToken.userOveridden = _SetVal.userOveridden;
	}
	get importedVSCPOReleasedActualDate(): Date {
		return this._importedVSCPOReleasedActualToken.actualDate;
	}
	get importedVSCPOReleasedActualDate_Enable(): boolean {
		return this.parentSubSORef.pmTechSubSalesOrder.vscApplicability_Enable;
	}
	set importedVSCPOReleasedActualDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set importedVSCPOReleasedActualDate directly");
		this._importedVSCPOReleasedActualToken.actualDate = _SetVal;
	}
	get geRelayPOReleaseActualToken(): ActualDateToken {
		return this._geRelayPOReleaseActualToken;
	}
	set geRelayPOReleaseActualToken(_SetVal: ActualDateToken) {
		if (this._geRelayPOReleaseActualToken.expActualDate == null)
			this._geRelayPOReleaseActualToken.expActualDate = this.geRelayPOReleaseActualDate;
		this._geRelayPOReleaseActualToken.actualDate = _SetVal.actualDate;
		this._geRelayPOReleaseActualToken.isOveridden = _SetVal.isOveridden;
		this._geRelayPOReleaseActualToken.addNotes = _SetVal.addNotes;
		this._geRelayPOReleaseActualToken.userOveridden = _SetVal.userOveridden;
	}
	get geRelayPOReleaseActualDate(): Date {
		return this._geRelayPOReleaseActualToken.actualDate;
	}
	get geRelayPOReleaseActualDate_Enable(): boolean {
		return this.parentSubSORef.pmTechSubSalesOrder.geRelayApplicability_Enable;
	}
	set geRelayPOReleaseActualDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set geRelayPOReleaseActualDate directly");
		this._geRelayPOReleaseActualToken.actualDate = _SetVal;
	}
	get ctPTPOReleasedActualToken(): ActualDateToken {
		return this._ctPTPOReleasedActualToken;
	}
	set ctPTPOReleasedActualToken(_SetVal: ActualDateToken) {
		if (this._ctPTPOReleasedActualToken.expActualDate == null)
			this._ctPTPOReleasedActualToken.expActualDate = this.ctPTPOReleasedActualDate;
		this._ctPTPOReleasedActualToken.actualDate = _SetVal.actualDate;
		this._ctPTPOReleasedActualToken.isOveridden = _SetVal.isOveridden;
		this._ctPTPOReleasedActualToken.addNotes = _SetVal.addNotes;
		this._ctPTPOReleasedActualToken.userOveridden = _SetVal.userOveridden;
	}
	get ctPTPOReleasedActualDate(): Date {
		return this._ctPTPOReleasedActualToken.actualDate;
	}
	set ctPTPOReleasedActualDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set ctPTPOReleasedActualDate directly");
		this._ctPTPOReleasedActualToken.actualDate = _SetVal;
	}
	get relayPOReleasedActualToken(): ActualDateToken {
		return this._relayPOReleasedActualToken;
	}
	set relayPOReleasedActualToken(_SetVal: ActualDateToken) {
		if (this._relayPOReleasedActualToken.expActualDate == null)
			this._relayPOReleasedActualToken.expActualDate = this.relayPOReleasedActualDate;
		this._relayPOReleasedActualToken.actualDate = _SetVal.actualDate;
		this._relayPOReleasedActualToken.isOveridden = _SetVal.isOveridden;
		this._relayPOReleasedActualToken.addNotes = _SetVal.addNotes;
		this._relayPOReleasedActualToken.userOveridden = _SetVal.userOveridden;
	}
	get relayPOReleasedActualDate(): Date {
		return this._relayPOReleasedActualToken.actualDate;
	}
	set relayPOReleasedActualDate(_SetVal: Date) {
		this._relayPOReleasedActualToken.actualDate = _SetVal;
	}
	get breakerPOReleaseActualToken(): ActualDateToken {
		return this._breakerPOReleaseActualToken;
	}
	set breakerPOReleaseActualToken(_SetVal: ActualDateToken) {
		if (this._breakerPOReleaseActualToken.expActualDate == null)
			this._breakerPOReleaseActualToken.expActualDate = this.breakerPOReleaseActualDate;
		this._breakerPOReleaseActualToken.actualDate = _SetVal.actualDate;
		this._breakerPOReleaseActualToken.isOveridden = _SetVal.isOveridden;
		this._breakerPOReleaseActualToken.addNotes = _SetVal.addNotes;
		this._breakerPOReleaseActualToken.userOveridden = _SetVal.userOveridden;
	}
	get breakerPOReleaseActualDate(): Date {
		return this._breakerPOReleaseActualToken.actualDate;
	}
	set breakerPOReleaseActualDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set breakerPOReleaseActualDate directly");
		this._breakerPOReleaseActualToken.actualDate = _SetVal;
	}
	get saPOReleasedActualToken(): ActualDateToken {
		return this._saPOReleasedActualToken;
	}
	set saPOReleasedActualToken(_SetVal: ActualDateToken) {
		if (this._saPOReleasedActualToken.expActualDate == null)
			this._saPOReleasedActualToken.expActualDate = this.saPOReleasedActualDate;
		this._saPOReleasedActualToken.actualDate = _SetVal.actualDate;
		this._saPOReleasedActualToken.isOveridden = _SetVal.isOveridden;
		this._saPOReleasedActualToken.addNotes = _SetVal.addNotes;
		this._saPOReleasedActualToken.userOveridden = _SetVal.userOveridden;
	}
	get saPOReleasedActualDate(): Date {
		return this._saPOReleasedActualToken.actualDate;
	}
	set saPOReleasedActualDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set saPOReleasedActualDate directly");
		this._saPOReleasedActualToken.actualDate = _SetVal;
	}
	get meteringBoxPOReleaseActualToken(): ActualDateToken {
		return this._meteringBoxPOReleaseActualToken;
	}
	set meteringBoxPOReleaseActualToken(_SetVal: ActualDateToken) {
		if (this._meteringBoxPOReleaseActualToken.expActualDate == null)
			this._meteringBoxPOReleaseActualToken.expActualDate = this.meteringBoxPOReleaseActualDate;
		this._meteringBoxPOReleaseActualToken.actualDate = _SetVal.actualDate;
		this._meteringBoxPOReleaseActualToken.isOveridden = _SetVal.isOveridden;
		this._meteringBoxPOReleaseActualToken.addNotes = _SetVal.addNotes;
		this._meteringBoxPOReleaseActualToken.userOveridden = _SetVal.userOveridden;
	}
	get meteringBoxPOReleaseActualDate(): Date {
		return this._meteringBoxPOReleaseActualToken.actualDate;
	}
	set meteringBoxPOReleaseActualDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set meteringBoxPOReleaseActualDate directly");
		this._meteringBoxPOReleaseActualToken.actualDate = _SetVal;
	}
	get purPODays(): number {
		let _ctptDays: number = configDefs.getDaysDifference(this.ctPTPOReleasedPlannedDate, this.ctPTPOReleasedActualDate);
		let _mbpoDays: number = configDefs.getDaysDifference(this.meteringBoxPOReleasePlannedDate, this.meteringBoxPOReleaseActualDate);
		return configDefs.getMinValue([_ctptDays, _mbpoDays]);
	}
	get purPODaysTip(): string {
		let _tmpCTPTPOReleasePlannedDate: Date = this.ctPTPOReleasedPlannedDate
		let _tmpCTPTPOReleaseActualDate: Date = this.ctPTPOReleasedActualDate
		let _tmpMBoxPOReleasePlannedDate: Date = this.meteringBoxPOReleasePlannedDate
		let _tmpMBoxPOReleaseActualDate: Date = this.meteringBoxPOReleaseActualDate
		let _ctptDays: number = configDefs.getDaysDifference(this.ctPTPOReleasedPlannedDate, this.ctPTPOReleasedActualDate);
		let _mbpoDays: number = configDefs.getDaysDifference(this.meteringBoxPOReleasePlannedDate, this.meteringBoxPOReleaseActualDate);
		if (_ctptDays || _mbpoDays) {
			return 'CT/PT PO Release Date : \r\n' +
				'\tPlanned\t> ' + moment(_tmpCTPTPOReleasePlannedDate).format(configDefs.dateFormat) + '\r\n' +
				'\tActual\t> ' + moment(_tmpCTPTPOReleaseActualDate).format(configDefs.dateFormat) + '\r\n' +
				'\tDiff Days\t> ' + _ctptDays + '\r\n\n' +
				'Metering Box PO Release Date : \r\n' +
				'\tPlanned\t> ' + moment(_tmpMBoxPOReleasePlannedDate).format(configDefs.dateFormat) + '\r\n' +
				'\tActual\t> ' + moment(_tmpMBoxPOReleaseActualDate).format(configDefs.dateFormat) + '\r\n' +
				'\tDiff Days\t> ' + _mbpoDays;
		}
		return '';
	}
	cloneSelf() {
		return new PurchasePOIP(this._importedBreakerPOReleasedPlannedToken.cloneSelf(), this._importedVSCPOReleasedPlannedToken.cloneSelf(),
			this._geRelayPOReleasePlannedToken.cloneSelf(), this._ctPTPOReleasedPlannedToken.cloneSelf(), this._relayPOReleasedPlannedToken.cloneSelf(),
			this._breakerPOReleasePlannedToken.cloneSelf(), this._saPOReleasedPlannedToken.cloneSelf(), this._meteringBoxPOReleasePlannedToken.cloneSelf(),
			this._importedBreakerPOReleasedActualToken.cloneSelf(), this._importedVSCPOReleasedActualToken.cloneSelf(), this._geRelayPOReleaseActualToken.cloneSelf(),
			this._ctPTPOReleasedActualToken.cloneSelf(), this._relayPOReleasedActualToken.cloneSelf(), this._breakerPOReleaseActualToken.cloneSelf(),
			this._saPOReleasedActualToken.cloneSelf(), this._meteringBoxPOReleaseActualToken.cloneSelf(), this._status);
	}
	public static getObj(_json: any): PurchasePOIP {
		return new PurchasePOIP(convDefs.convToPlannedDateToken(_json.impBrkrPOReleasePlanToken), convDefs.convToPlannedDateToken(_json.impVSCPOReleasePlanToken),
			convDefs.convToPlannedDateToken(_json.geRelayPOReleasePlanToken), convDefs.convToPlannedDateToken(_json.ctPTPOReleasePlanToken),
			convDefs.convToPlannedDateToken(_json.relayPORealsePlanToken), convDefs.convToPlannedDateToken(_json.brkrPOReleasePlanToken),
			convDefs.convToPlannedDateToken(_json.saPOReleasePlanToken), convDefs.convToPlannedDateToken(_json.meteringBoxPOReleasePlanToken),
			convDefs.convToActualDateToken(_json.impBrkrPOReleaseActToken), convDefs.convToActualDateToken(_json.impVSCPOReleaseActToken),
			convDefs.convToActualDateToken(_json.geRelayPOReleaseActToken), convDefs.convToActualDateToken(_json.ctPTPOReleaseActToken),
			convDefs.convToActualDateToken(_json.relayPOReleaseActToken), convDefs.convToActualDateToken(_json.brkrPOReleaseActToken),
			convDefs.convToActualDateToken(_json.saPOReleaseActToken), convDefs.convToActualDateToken(_json.meteringBoxPOReleaseActToken), _json.status);
	}
	public getJson(): any {
		let _json: any = {};

		_json.impBrkrPOReleasePlanToken = this.importedBreakerPOReleasedPlannedToken.getJson();
		_json.impVSCPOReleasePlanToken = this.importedVSCPOReleasedPlannedToken.getJson();
		_json.geRelayPOReleasePlanToken = this.geRelayPOReleasePlannedToken.getJson();
		_json.ctPTPOReleasePlanToken = this.ctPTPOReleasedPlannedToken.getJson();
		_json.relayPORealsePlanToken = this.relayPOReleasedPlannedToken.getJson();
		_json.brkrPOReleasePlanToken = this.breakerPOReleasePlannedToken.getJson();
		_json.saPOReleasePlanToken = this.saPOReleasedPlannedToken.getJson();
		_json.meteringBoxPOReleasePlanToken = this.meteringBoxPOReleasePlannedToken.getJson();
		_json.impBrkrPOReleaseActToken = this.importedBreakerPOReleasedActualToken.getJson();
		_json.impVSCPOReleaseActToken = this.importedVSCPOReleasedActualToken.getJson();
		_json.geRelayPOReleaseActToken = this.geRelayPOReleaseActualToken.getJson();
		_json.ctPTPOReleaseActToken = this.ctPTPOReleasedActualToken.getJson();
		_json.relayPOReleaseActToken = this.relayPOReleasedActualToken.getJson();
		_json.brkrPOReleaseActToken = this.breakerPOReleaseActualToken.getJson();
		_json.saPOReleaseActToken = this.saPOReleasedActualToken.getJson();
		_json.meteringBoxPOReleaseActToken = this.meteringBoxPOReleaseActualToken.getJson();
		_json.status = this.status;

		return _json;
	}
}
export class SerialNum {
	constructor(private _sNo: string) {

	}
	get sNo(): string {
		return this._sNo;
	}
	set sNo(_SetVal: string) {
		this._sNo = _SetVal;
	}
	cloneSelf() {
		return new SerialNum(this.sNo);
	}
}
export class LineItem {
	constructor(private _lineItm: string) {

	}
	get lineItm(): string {
		return this._lineItm;
	}
	set lineItm(_SetVal: string) {
		this._lineItm = _SetVal;
	}
	cloneSelf() {
		return new LineItem(this.lineItm);
	}
}
export class SerialData {
	constructor(private _matNo: string, private _serialNo: string, private _itemNo: string, private _descp: string) {

	}
	get matNo(): string {
		return this._matNo;
	}
	set matNo(_SetVal: string) {
		this._matNo = _SetVal;
	}
	get serialNo(): string {
		return this._serialNo;
	}
	set serialNo(_SetVal: string) {
		this._serialNo = _SetVal;
	}
	get itemNo(): string {
		return this._itemNo;
	}
	set itemNo(_SetVal: string) {
		this._itemNo = _SetVal;
	}
	get descp(): string {
		return this._descp;
	}
	set descp(_SetVal: string) {
		this._descp = _SetVal;
	}
	cloneSelf() {
		return new SerialData(this.matNo, this.serialNo, this.itemNo, this.descp);
	}
	static getObj(_json: any): SerialData {
		return new SerialData(_json.matNo, _json.serialNo, _json.itemNo, _json.descp);
	}
	public getJson(): any {
		let _json: any = {};
		_json.matNo = this.matNo;
		_json.serialNo = this.serialNo;
		_json.itemNo = this.itemNo;
		_json.descp = this.descp;
		return _json;

	}
}
export class DataSheetImportDef {
	constructor(private _gen_sysVolt: string, private _gen_ratVolt: string, private _gen_dryFrq: string, private _gen_ratImpVolt: string, private _gen_frq: string, private _gen_swtCrRat: string, private _gen_shtTimeCrRat: string, private _gen_dynmPeakCrr: string,
		private _gen_ambTmp: string, private _gen_alt: string, private _gen_intArc: string, private _pan_enclosure: string, private _bb_busBarSys: string, private _conAux_springChrgMtr: string, private _cb_ratMkCrr: string) {

	}
	get gen_sysVolt(): string {
		return this._gen_sysVolt;
	}
	set gen_sysVolt(_SetVal: string) {
		this._gen_sysVolt = _SetVal;
	}
	get gen_ratVolt(): string {
		return this._gen_ratVolt;
	}
	set gen_ratVolt(_SetVal: string) {
		this._gen_ratVolt = _SetVal;
	}
	get gen_dryFrq(): string {
		return this._gen_dryFrq;
	}
	set gen_dryFrq(_SetVal: string) {
		this._gen_dryFrq = _SetVal;
	}
	get gen_ratImpVolt(): string {
		return this._gen_ratImpVolt;
	}
	set gen_ratImpVolt(_SetVal: string) {
		this._gen_ratImpVolt = _SetVal;
	}
	get gen_frq(): string {
		return this._gen_frq;
	}
	set gen_frq(_SetVal: string) {
		this._gen_frq = _SetVal;
	}
	get gen_swtCrRat(): string {
		return this._gen_swtCrRat;
	}
	set gen_swtCrRat(_SetVal: string) {
		this._gen_swtCrRat = _SetVal;
	}
	get gen_shtTimeCrRat(): string {
		return this._gen_shtTimeCrRat;
	}
	set gen_shtTimeCrRat(_SetVal: string) {
		this._gen_shtTimeCrRat = _SetVal;
	}
	get gen_dynmPeakCrr(): string {
		return this._gen_dynmPeakCrr;
	}
	set gen_dynmPeakCrr(_SetVal: string) {
		this._gen_dynmPeakCrr = _SetVal;
	}
	get gen_ambTmp(): string {
		return this._gen_ambTmp;
	}
	set gen_ambTmp(_SetVal: string) {
		this._gen_ambTmp = _SetVal;
	}
	get gen_alt(): string {
		return this._gen_alt;
	}
	set gen_alt(_SetVal: string) {
		this._gen_alt = _SetVal;
	}
	get gen_intArc(): string {
		return this._gen_intArc;
	}
	set gen_intArc(_SetVal: string) {
		this._gen_intArc = _SetVal;
	}
	get pan_enclosure(): string {
		return this._pan_enclosure;
	}
	set pan_enclosure(_SetVal: string) {
		this._pan_enclosure = _SetVal;
	}
	get bb_busBarSys(): string {
		return this._bb_busBarSys;
	}
	set bb_busBarSys(_SetVal: string) {
		this._bb_busBarSys = _SetVal;
	}
	get conAux_springChrgMtr(): string {
		return this._conAux_springChrgMtr;
	}
	set conAux_springChrgMtr(_SetVal: string) {
		this._conAux_springChrgMtr = _SetVal;
	}
	get cb_ratMkCrr(): string {
		return this._cb_ratMkCrr;
	}
	set cb_ratMkCrr(_SetVal: string) {
		this._cb_ratMkCrr = _SetVal;
	}
	cloneSelf() {
		return new DataSheetImportDef(this.gen_sysVolt, this.gen_ratVolt, this.gen_dryFrq, this.gen_ratImpVolt, this.gen_frq, this.gen_swtCrRat, this.gen_shtTimeCrRat, this.gen_dynmPeakCrr,
			this.gen_ambTmp, this.gen_alt, this.gen_intArc, this.pan_enclosure, this.bb_busBarSys, this.conAux_springChrgMtr, this.cb_ratMkCrr);
	}
	static getObj(_json: any): DataSheetImportDef {
		return new DataSheetImportDef(_json.gen_sysVolt, _json.gen_ratVolt, _json.gen_dryFrq, _json.gen_ratImpVolt, _json.gen_frq, _json.gen_swtCrRat, _json.gen_shtTimeCrRat, _json.gen_dynmPeakCrr,
			_json.gen_ambTmp, _json.gen_alt, _json.gen_intArc, _json.pan_enclosure, _json.bb_busBarSys, _json.conAux_springChrgMtr, _json.cb_ratMkCrr);
	}
	public getJson(): any {
		let _json: any = {};
		_json.gen_sysVolt = this.gen_sysVolt;
		_json.gen_ratVolt = this.gen_ratVolt;
		_json.gen_dryFrq = this.gen_dryFrq;
		_json.gen_ratImpVolt = this.gen_ratImpVolt;
		_json.gen_frq = this.gen_frq;
		_json.gen_swtCrRat = this.gen_swtCrRat;
		_json.gen_shtTimeCrRat = this.gen_shtTimeCrRat;
		_json.gen_dynmPeakCrr = this.gen_dynmPeakCrr;
		_json.gen_ambTmp = this.gen_ambTmp;
		_json.gen_alt = this.gen_alt;
		_json.gen_intArc = this.gen_intArc;
		_json.pan_enclosure = this.pan_enclosure;
		_json.bb_busBarSys = this.bb_busBarSys;
		_json.conAux_springChrgMtr = this.conAux_springChrgMtr;
		_json.cb_ratMkCrr = this.cb_ratMkCrr;
		return _json;

	}
}
export class PlanningIP {
	constructor(private _plannedManufacturingMonth: Date, private _manufacturingStrategy: string, private _plannedLineLoadingToken: PlannedDateToken,
		private _requestedLineLoadingToken: RequestDateToken, private _panelReadinessDate: Date, private _pnlReadyComment: string, private _plannedPickListIssueToStoreToken: PlannedDateToken,
		private _requestedPickListIssueToStoreToken: RequestDateToken,
		private _actualPickListIssueToStoreToken: ActualDateToken, private _serialNums: Array<SerialNum>, private _lineItems: Array<LineItem>,
		private _serialData: Array<SerialData>, private _sapStartRange: string, private _sapEndRange: string, private _status: FunctionStatus) {
	}
	private _parentSORef: SalesOrder;
	private _parentSubSORef: SubSalesOrder;

	refreshStatus() {
		if (this.parentSORef && this.parentSubSORef && this.parentSORef.projectStatus >= SOStatus.Sub_Orders) {
			if (this.parentSubSORef.isSSOStatusSet(SSOStatus.Planning) == true ||
				this.parentSubSORef.isSSOStatusSet(SSOStatus.Planning_From_PO) == true) {

				if (this.parentSubSORef.isSSOStatusSet(SSOStatus.Material_Receipt) == true ||
					this.parentSubSORef.isSSOStatusSet(SSOStatus.Store) == true ||
					this.parentSubSORef.isSSOStatusSet(SSOStatus.Production) == true) {

					let _isTempComplete: boolean = this.isFunctionComplete();

					if (_isTempComplete == true) {
						this._status = FunctionStatus.SUBMITTED_COMPLETE;
					}
					else {
						this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
					}
				}
				else {
					this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
				}
			}
			else if (this.parentSubSORef.isSSOStatusSet(SSOStatus.Planning_From_PMTech) == true) {
				this._status = FunctionStatus.SUBMITTED_WAITING_RESPONSE;
			}
			else {
				this._status = FunctionStatus.WAITING_FOR_PREV;
			}
		}
		else {
			this._status = FunctionStatus.WAITING_FOR_PREV;
		}
	}
	private isFunctionComplete(): boolean {
		if (configDefs.isDtEmty(this.plannedManufacturingMonth)) return false;
		if (configDefs.isStrEmty(this.manufacturingStrategy)) return false;
		if (configDefs.isDtEmty(this.plannedLineLoadingDate)) return false;
		if (configDefs.isDtEmty(this.requestedLineLoadingDate)) return false;
		if (this.manufacturingStrategyInhouse_Enable) {
			if (configDefs.isDtEmty(this.plannedPickListIssueToStoreDate)) return false;
			if (configDefs.isDtEmty(this.requestedPickListIssueToStoreDate)) return false;
			if (configDefs.isDtEmty(this.actualPickListIssueToStoreDate)) return false;
		}
		for (var i = 0; i < this.serialNums.length; i++) {
			if (this.serialNums.length > 0) {
				if (configDefs.isStrEmty(this.serialNums[i].sNo)) return false;
			}
		}
		for (var i = 0; i < this.lineItems.length; i++) {
			if (this.lineItems.length > 0) {
				if (configDefs.isStrEmty(this.lineItems[i].lineItm)) return false;
			}
		}
		return true;
	}
	get isProjectLive(): boolean {
		return this.parentSubSORef.pmTechSubSalesOrder.projStatus == "live"
	}
	get isInputEnabled(): boolean {
		return this.parentSubSORef.isSSOStatusSet(SSOStatus.Planning) ||
			this.parentSubSORef.isSSOStatusSet(SSOStatus.Planning_From_PO) ||
			this.parentSubSORef.isSSOStatusSet(SSOStatus.Planning_From_PMTech);
	}
	get parentSORef(): SalesOrder {
		return this._parentSORef;
	}
	set parentSORef(SORef: SalesOrder) {
		this._parentSORef = SORef;
		//this.refreshStatus();
	}
	get parentSubSORef(): SubSalesOrder {
		return this._parentSubSORef;
	}
	set parentSubSORef(SubSORef: SubSalesOrder) {
		this._parentSubSORef = SubSORef;
	}
	get status(): FunctionStatus {
		return this._status;
	}
	get isSubmittedtoMRSP(): boolean {
		return this.parentSubSORef.isSSOStatusSet(SSOStatus.Material_Receipt | SSOStatus.Store | SSOStatus.Production);
	}
	get readyForMRSP(): boolean {
		//by passing the condition 19Apr2019, as no condition is required
		//if (this.requestedLineLoadingDate) return true;
		return this.parentSubSORef.isSSOStatusSet(SSOStatus.Planning) ||
			this.parentSubSORef.isSSOStatusSet(SSOStatus.Planning_From_PO);
		//return true;
	}
	enableFormInput(): void {
		if (this._status == FunctionStatus.WAITING_FOR_PREV) {
			this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
		}
	}
	get plannedManufacturingMonth(): Date {
		return this._plannedManufacturingMonth;
	}
	set plannedManufacturingMonth(_SetVal: Date) {
		this._plannedManufacturingMonth = _SetVal;
	}
	get manufacturingStrategy(): string {
		return this._manufacturingStrategy;
	}
	get manufacturingStrategyInhouse_Enable(): boolean {
		if (this._manufacturingStrategy)
			return this._manufacturingStrategy == "inhouse";
		return null;
	}
	// get manufacturingStrategyBroughtout_Enable(): boolean {
	// 	return this._manufacturingStrategy == "boughtout";
	// }
	get LineLoadingLabel(): string {
		if (this.manufacturingStrategyInhouse_Enable == true)
			return '(inHouse)';
		else if (this.manufacturingStrategyInhouse_Enable == false)
			return '(Vendor)';
		return '';
	}
	set manufacturingStrategy(_SetVal: string) {
		this._manufacturingStrategy = _SetVal;
	}
	get plannedLineLoadingToken(): PlannedDateToken {
		return this._plannedLineLoadingToken;
	}
	set plannedLineLoadingToken(_SetVal: PlannedDateToken) {
		// if (this._plannedLineLoadingToken.actualPlannedDate == null)
		// 	this._plannedLineLoadingToken.actualPlannedDate = this.plannedLineLoadingDate;
		this._plannedLineLoadingToken.plannedDate = _SetVal.plannedDate;
		this._plannedLineLoadingToken.isOveridden = _SetVal.isOveridden;
		this._plannedLineLoadingToken.addNotes = _SetVal.addNotes;
		this._plannedLineLoadingToken.userOveridden = _SetVal.userOveridden;
	}
	get plannedLineLoadingDateLabel(): string {
		if (this.plannedLineLoadingDateIsRevised == true) {
			return "Revised (Planned) Date"
		} else {
			return "Planned Date"
		}
	}
	get plannedLineLoadingDateIsRevised(): boolean {
		if (this.plannedLineLoadingDate_Initial && this.plannedLineLoadingDate) {
			if (GenService.areDatesSame(this.plannedLineLoadingDate_Initial, this.plannedLineLoadingDate) == false) {
				return true;
			}
		}
		return false;
	}
	get plannedLineLoadingDate_Initial(): Date {
		if (this._plannedLineLoadingToken.actualPlannedDate == null || this._plannedLineLoadingToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.enggProcureIP.plannedC40Date_Initial;

			if (_tmpDate != null && configDefs.defPlndLinLoadWeeks) {
				this._plannedLineLoadingToken.actualPlannedDate = configDefs.addWorkingWeeks(_tmpDate, configDefs.defPlndLinLoadWeeks);
			}
			else {
				this._plannedLineLoadingToken.actualPlannedDate = null;
			}
		}
		return this._plannedLineLoadingToken.actualPlannedDate;
	}
	get plannedLineLoadingDate(): Date {
		if (this._plannedLineLoadingToken.plannedDate == null || this._plannedLineLoadingToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.enggProcureIP.actualC40Date;
			if (_tmpDate == null) {
				_tmpDate = this.parentSubSORef.enggProcureIP.plannedC40Date
			}
			if (_tmpDate != null && configDefs.defPlndLinLoadWeeks) {
				this._plannedLineLoadingToken.plannedDate = configDefs.addWorkingWeeks(_tmpDate, configDefs.defPlndLinLoadWeeks);
			}
			else {
				this._plannedLineLoadingToken.plannedDate = null;
			}
		}
		return this._plannedLineLoadingToken.plannedDate;
	}
	private _plannedLineLoadingGroup: RevisedDate;
	get plannedLineLoadingGroup(): RevisedDate {
		this._plannedLineLoadingGroup = new RevisedDate(this.plannedLineLoadingDate_Initial, this.plannedLineLoadingDateIsRevised, this.plannedLineLoadingDate);

		return this._plannedLineLoadingGroup;
	}
	set plannedLineLoadingDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set plannedLineLoadingDate directly");
		this._plannedLineLoadingToken.plannedDate = _SetVal;
	}
	get requestedLineLoadingToken(): RequestDateToken {
		return this._requestedLineLoadingToken;
	}
	set requestedLineLoadingToken(_SetVal: RequestDateToken) {
		if (this.requestedLineLoadingToken.plndRequestDate == null)
			this.requestedLineLoadingToken.plndRequestDate = this.requestedLineLoadingDate;
		this.requestedLineLoadingToken.requestDate = _SetVal.requestDate;
		this.requestedLineLoadingToken.isOveridden = _SetVal.isOveridden;
		this.requestedLineLoadingToken.addNotes = _SetVal.addNotes;
		this.requestedLineLoadingToken.userOveridden = _SetVal.userOveridden;
	}
	get panelReadinessDate(): Date {
		return this._panelReadinessDate;
	}
	set panelReadinessDate(_SetVal: Date) {
		this._panelReadinessDate = _SetVal;
	}
	get pnlReadyComment(): string {
		return this._pnlReadyComment;
	}
	set pnlReadyComment(_SetVal: string) {
		this._pnlReadyComment = _SetVal;
	}
	get requestedLineLoadingDate(): Date {
		return this.requestedLineLoadingToken.requestDate;
	}
	set requestedLineLoadingDate(_SetVal: Date) {
		console.log('wrong execution, requestedLineLoadingDate')
		this.requestedLineLoadingToken.requestDate = _SetVal;
	}
	get plannedPickListIssueToStoreToken(): PlannedDateToken {
		return this._plannedPickListIssueToStoreToken;
	}
	set plannedPickListIssueToStoreToken(_SetVal: PlannedDateToken) {
		// if (this._plannedPickListIssueToStoreToken.actualPlannedDate == null)
		// 	this._plannedPickListIssueToStoreToken.actualPlannedDate = this.plannedPickListIssueToStoreDate;
		this._plannedPickListIssueToStoreToken.plannedDate = _SetVal.plannedDate;
		this._plannedPickListIssueToStoreToken.isOveridden = _SetVal.isOveridden;
		this._plannedPickListIssueToStoreToken.addNotes = _SetVal.addNotes;
		this._plannedPickListIssueToStoreToken.userOveridden = _SetVal.userOveridden;
	}
	get plannedPickListIssueToStoreDateLabel(): string {
		if (this.plannedPickListIssueToStoreDateIsRevised == true) {
			return "Revised (Planned) Date"
		} else {
			return "Planned Date"
		}
	}
	get plannedPickListIssueToStoreDateIsRevised(): boolean {
		if (this.plannedPickListIssueToStoreDate_Initial && this.plannedPickListIssueToStoreDate) {
			if (GenService.areDatesSame(this.plannedPickListIssueToStoreDate_Initial, this.plannedPickListIssueToStoreDate) == false) {
				return true;
			}
		}
		return false;

	}
	get plannedPickListIssueToStoreDate_Initial(): Date {
		if (this._plannedPickListIssueToStoreToken.actualPlannedDate == null || this._plannedPickListIssueToStoreToken.isOveridden == false) {
			var _tmpDate = this.plannedLineLoadingDate_Initial;
			if (_tmpDate != null && configDefs.defPlndPicLisIsuToStorDays) {
				this._plannedPickListIssueToStoreToken.actualPlannedDate = configDefs.subtractWorkingDays(_tmpDate, configDefs.defPlndPicLisIsuToStorDays);
			}
			else {
				this._plannedPickListIssueToStoreToken.actualPlannedDate = null;
			}
		}
		return this._plannedPickListIssueToStoreToken.actualPlannedDate;
	}
	get plannedPickListIssueToStoreDate(): Date {
		if (this._plannedPickListIssueToStoreToken.plannedDate == null || this._plannedPickListIssueToStoreToken.isOveridden == false) {
			// var _tmpDate = this.parentSubSORef.productionIP.lineLoadingActualDate;
			// if(_tmpDate == null ){
			var _tmpDate = this.plannedLineLoadingDate;
			//}
			if (_tmpDate != null && configDefs.defPlndPicLisIsuToStorDays) {
				this._plannedPickListIssueToStoreToken.plannedDate = configDefs.subtractWorkingDays(_tmpDate, configDefs.defPlndPicLisIsuToStorDays);
			}
			else {
				this._plannedPickListIssueToStoreToken.plannedDate = null;
			}
		}
		return this._plannedPickListIssueToStoreToken.plannedDate;
	}
	private _plannedPickListIssueToStoreGroup: RevisedDate;
	get plannedPickListIssueToStoreGroup(): RevisedDate {
		this._plannedPickListIssueToStoreGroup = new RevisedDate(this.plannedPickListIssueToStoreDate_Initial, this.plannedPickListIssueToStoreDateIsRevised, this.plannedPickListIssueToStoreDate);

		return this._plannedPickListIssueToStoreGroup;
	}
	set plannedPickListIssueToStoreDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set plannedPickListIssueToStoreDate directly");
		this._plannedPickListIssueToStoreToken.plannedDate = _SetVal;
	}
	get requestedPickListIssueToStoreToken(): RequestDateToken {
		return this._requestedPickListIssueToStoreToken;
	}
	set requestedPickListIssueToStoreToken(_SetVal: RequestDateToken) {
		if (this._requestedPickListIssueToStoreToken.plndRequestDate == null)
			this._requestedPickListIssueToStoreToken.plndRequestDate = this.requestedPickListIssueToStoreDate;
		this._requestedPickListIssueToStoreToken.requestDate = _SetVal.requestDate;
		this._requestedPickListIssueToStoreToken.isOveridden = _SetVal.isOveridden;
		this._requestedPickListIssueToStoreToken.addNotes = _SetVal.addNotes;
		this._requestedPickListIssueToStoreToken.userOveridden = _SetVal.userOveridden;
	}
	get requestedPickListIssueToStoreDate(): Date {
		if (this._requestedPickListIssueToStoreToken.requestDate == null || this._requestedPickListIssueToStoreToken.isOveridden == false) {
			var _tmpDate = this.requestedLineLoadingDate;
			if (_tmpDate != null && configDefs.defReqPicLisIsuToStorDays) {
				this._requestedPickListIssueToStoreToken.requestDate = configDefs.subtractWorkingDays(_tmpDate, configDefs.defReqPicLisIsuToStorDays);
			}
			else {
				this._requestedPickListIssueToStoreToken.requestDate = null;
			}
		}
		return this._requestedPickListIssueToStoreToken.requestDate;
	}
	set requestedPickListIssueToStoreDate(_SetVal: Date) {
		console.log('wrong execution, requestedPickListIssueToStoreDate')
		this._requestedPickListIssueToStoreToken.requestDate = _SetVal;
	}
	get actualPickListIssueToStoreToken(): ActualDateToken {
		return this._actualPickListIssueToStoreToken;
	}
	set actualPickListIssueToStoreToken(_SetVal: ActualDateToken) {
		if (this._actualPickListIssueToStoreToken.expActualDate == null)
			this._actualPickListIssueToStoreToken.expActualDate = this.actualPickListIssueToStoreDate;
		this._actualPickListIssueToStoreToken.actualDate = _SetVal.actualDate;
		this._actualPickListIssueToStoreToken.isOveridden = _SetVal.isOveridden;
		this._actualPickListIssueToStoreToken.addNotes = _SetVal.addNotes;
		this._actualPickListIssueToStoreToken.userOveridden = _SetVal.userOveridden;
	}
	get actualPickListIssueToStoreDate(): Date {
		return this._actualPickListIssueToStoreToken.actualDate;
	}
	set actualPickListIssueToStoreDate(_SetVal: Date) {
		console.log('wrong execution, actualPickListIssueToStoreDate')
		this._actualPickListIssueToStoreToken.actualDate = _SetVal;
	}
	get serialNums(): Array<SerialNum> {
		if (this._serialNums && this._serialNums.length > 0)
			return this._serialNums;
		return [];
	}
	set serialNums(_SetVal: Array<SerialNum>) {
		this._serialNums = _SetVal;
	}

	get lineItems(): Array<LineItem> {
		if (this._lineItems && this._lineItems.length > 0)
			return this._lineItems;
		return [];
	}
	set lineItems(_SetVal: Array<LineItem>) {
		this._lineItems = _SetVal;
	}
	get serialData(): Array<SerialData> {
		if (this._serialData && this._serialData.length > 0)
			return this._serialData;
		return [];
	}
	set serialData(_SetVal: Array<SerialData>) {
		this._serialData = _SetVal;
	}
	get sapStartRange(): string {
		return this._sapStartRange;
	}
	set sapStartRange(_SetVal: string) {
		this._sapStartRange = _SetVal;
	}
	get sapEndRange(): string {
		return this._sapEndRange;
	}
	set sapEndRange(_SetVal: string) {
		this._sapEndRange = _SetVal;
	}
	addSerialNumber(_serial: string) {
		if (!this._serialNums) {
			this._serialNums = [];
		}
		this._serialNums.push(new SerialNum(_serial));
	}
	removeSerialNumber(_index: number) {
		this._serialNums.splice(_index, 1);
	}
	addLineItem(_lineItem: string) {
		if (!this._lineItems) {
			this._lineItems = [];
		}
		this._lineItems.push(new LineItem(_lineItem));
	}
	removeLineItem(_index: number) {
		this._lineItems.splice(_index, 1);
	}
	addSerialData(_serial: SerialData) {
		if (!this._serialData) {
			this._serialData = [];
		}
		this._serialData.push(new SerialData(_serial.matNo, _serial.serialNo, _serial.itemNo, _serial.descp));
	}
	removeSerialData(_index: number) {
		this._serialData.splice(_index, 1);
	}
	get planDays(): number {
		return configDefs.getDaysDifference(this.requestedLineLoadingDate, this._parentSubSORef.productionIP.lineLoadingActualDate);
	}
	get planDaysTip(): string {
		let _tmpRequestedDate: Date = this.requestedLineLoadingDate
		let _tmpActualDate: Date = this._parentSubSORef.productionIP.lineLoadingActualDate
		if (_tmpRequestedDate && _tmpActualDate) {
			return 'Line Loading Date : \r\n' +
				'\tRequest\t> ' + moment(_tmpRequestedDate).format(configDefs.dateFormat) + '\r\n' +
				'\tActual\t> ' + moment(_tmpActualDate).format(configDefs.dateFormat);
		}
		return '';
	}

	cloneSelf() {
		let _tmpSerialNums: Array<SerialNum> = [];
		this.serialNums.forEach((_tmpSNo: SerialNum) => {
			_tmpSerialNums.push(_tmpSNo.cloneSelf())
		})
		let _tmpLineItems: Array<LineItem> = [];
		this.lineItems.forEach((_tmpSNo: LineItem) => {
			_tmpLineItems.push(_tmpSNo.cloneSelf())
		})
		let _tmpSerialData: Array<SerialData> = [];
		this.serialData.forEach((_tmpSNo: SerialData) => {
			_tmpSerialData.push(_tmpSNo.cloneSelf())
		})

		return new PlanningIP(configDefs.cloneDt(this._plannedManufacturingMonth), this._manufacturingStrategy, this._plannedLineLoadingToken.cloneSelf(),
			this._requestedLineLoadingToken.cloneSelf(), configDefs.cloneDt(this._panelReadinessDate), this.pnlReadyComment, this._plannedPickListIssueToStoreToken.cloneSelf(),
			this._requestedPickListIssueToStoreToken.cloneSelf(), this._actualPickListIssueToStoreToken.cloneSelf(), _tmpSerialNums, _tmpLineItems, _tmpSerialData, this._sapStartRange, this._sapEndRange, this.status);
	}
	public static getObj(_json: any): PlanningIP {
		let _tmpSerialNums: Array<SerialNum> = [];
		if (_json.serials && _json.serials.length > 0) {
			_json.serials.forEach(sno => {
				_tmpSerialNums.push(new SerialNum(sno));
			});
		}
		let _tmpLineItems: Array<LineItem> = [];
		if (_json.lineItems && _json.lineItems.length > 0) {
			_json.lineItems.forEach(sno => {
				_tmpLineItems.push(new LineItem(sno));
			});
		}
		let _tmpSerialData: Array<SerialData> = [];
		if (_json.serialData) {
			for (var i = 0; i < _json.serialData.length; i++) {
				_tmpSerialData.push(SerialData.getObj(_json.serialData[i]));
			}
		}
		return new PlanningIP(GenService.convToDate(_json.planManfacMonth), _json.manfacStrategy, convDefs.convToPlannedDateToken(_json.planLineLoadToken),
			RequestDateToken.getObj(_json.reqLineLoadToken), GenService.convToDate(_json.pnlReadinessDt), _json.pnlReadyComment, convDefs.convToPlannedDateToken(_json.planPickListIssueToken),
			RequestDateToken.getObj(_json.reqPickListIssueToken), convDefs.convToActualDateToken(_json.actPickListIssueToken), _tmpSerialNums, _tmpLineItems, _tmpSerialData, _json.sapStartRange, _json.sapEndRange, _json.status);
	}
	public getJson(): any {
		let _json: any = {};

		_json.planManfacMonth = GenService.convToDateNum(this.plannedManufacturingMonth);
		_json.manfacStrategy = this.manufacturingStrategy;
		_json.planLineLoadToken = this.plannedLineLoadingToken.getJson();
		_json.reqLineLoadToken = this.requestedLineLoadingToken.getJson();
		_json.pnlReadinessDt = GenService.convToDateNum(this.panelReadinessDate);
		_json.pnlReadyComment = this.pnlReadyComment;
		_json.planPickListIssueToken = this.plannedPickListIssueToStoreToken.getJson();
		_json.reqPickListIssueToken = this.requestedPickListIssueToStoreToken.getJson();
		_json.actPickListIssueToken = this.actualPickListIssueToStoreToken.getJson();
		_json.serials = [];
		if (this.serialNums && this.serialNums.length > 0) {
			this.serialNums.forEach(_sno => {
				_json.serials.push(_sno.sNo)
			});
		}
		_json.lineItems = [];
		if (this.lineItems && this.lineItems.length > 0) {
			this.lineItems.forEach(_line => {
				_json.lineItems.push(_line.lineItm)
			});
		}
		_json.serialData = [];
		if (this.serialData && this.serialData.length > 0) {
			this.serialData.forEach((sno: SerialData) => {
				_json.serialData.push(sno.getJson());
			});
		}
		_json.sapStartRange = this.sapStartRange;
		_json.sapEndRange = this.sapEndRange;
		_json.status = this.status;

		return _json;
	}
}

export class PurchaseMaterialReceiptIP {
	constructor(private _importedBreakerPlannedReceiptToken: PlannedDateToken, private _importedBreakerRequestedReceiptDate: Date, private _importedBreakerSupplierCommittedDate: Date,
		private _importedBreakerActualReceiptToken: ActualDateToken, private _importedVSCPlannedReceiptToken: PlannedDateToken, private _importedVSCRequestedReceiptDate: Date,
		private _importedVSCSupplierCommittedDate: Date, private _importedVSCActualReceiptToken: ActualDateToken, private _geRelayPlannedReceiptToken: PlannedDateToken,
		private _geRelayRequestedReceiptDate: Date, private _geRelaySupplierCommittedDate: Date, private _geRelayActualReceiptToken: ActualDateToken,
		private _ctPTPlannedReceiptToken: PlannedDateToken, private _ctPTRequestedReceiptDate: Date, private _ctPTSupplierCommittedDate: Date,
		private _ctPTActualReceiptToken: ActualDateToken, private _ctPTActualReceiptFirstDate: Date, private _ctApplicability: string, private _ctptPoNo: string,
		private _relayPoNo: string, private _breakerPoNo: string, private _saPoNo: string, private _meteringBoxPoNo: string,
		private _relayPlannedReceiptToken: PlannedDateToken, private _relayRequestedReceiptDate: Date,
		private _relaySupplierCommittedDate: Date, private _relayActualReceiptToken: ActualDateToken, private _breakerPlannedReceiptToken: PlannedDateToken,
		private _breakerRequestedReceiptDate: Date, private _breakerSupplierCommittedDate: Date, private _breakerActualReceiptToken: ActualDateToken, private _breakerApplicability: string,
		private _jumperPlannedReceiptToken: PlannedDateToken, private _jumperRequestedReceiptDate: Date, private _jumperSupplierCommittedDate: Date,
		private _jumperActualReceiptToken: ActualDateToken, private _meteringBoxPlannedReceiptToken: PlannedDateToken, private _meteringBoxRequestedReceiptDate: Date,
		private _meteringBoxSupplierCommittedDate: Date, private _meteringBoxActualReceiptToken: ActualDateToken, private _meteringBoxApplicability: string, private _saPlannedReceiptToken: PlannedDateToken,
		private _saRequestedReceiptDate: Date, private _saSupplierCommittedDate: Date, private _saActualReceiptToken: ActualDateToken,
		private _broughtoutFabricationPlannedReceiptToken: PlannedDateToken, private _broughtoutFabricationRequestedReceiptDate: Date, private _broughtoutFabricationSupplierCommittedDate: Date,
		private _broughtoutFabricationActualReceiptToken: ActualDateToken,
		private _inHouseFabricationPlannedReceiptToken: PlannedDateToken, private _inHouseFabricationRequestedReceiptDate: Date, private _inHouseFabricationSupplierCommittedDate: Date,
		private _inHouseFabricationActualReceiptToken: ActualDateToken, private _status: FunctionStatus) {
	}
	private _parentSORef: SalesOrder;
	private _parentSubSORef: SubSalesOrder;

	refreshStatus() {
		if (this.parentSORef && this.parentSubSORef && this.parentSORef.projectStatus >= SOStatus.Sub_Orders) {
			if (this.parentSubSORef.isSSOStatusSet(SSOStatus.Material_Receipt) == true) {

				if (this.parentSubSORef.isSSOStatusSet(SSOStatus.Store_From_MaterialReceipt) == true) {

					let _isTempComplete: boolean = this.isFunctionComplete();

					if (_isTempComplete == true) {
						this._status = FunctionStatus.SUBMITTED_COMPLETE;
					}
					else {
						this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
					}
				}
				else {
					this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
				}
			}
			else {
				this._status = FunctionStatus.WAITING_FOR_PREV;
			}
		}
		else {
			this._status = FunctionStatus.WAITING_FOR_PREV;
		}
	}

	private isFunctionComplete(): boolean {
		if (this.importedBreakerPlannedReceiptDate_Enable) {
			if (configDefs.isDtEmty(this.importedBreakerPlannedReceiptDate)) return false;
			if (configDefs.isDtEmty(this.importedBreakerRequestedReceiptDate)) return false;
			if (configDefs.isDtEmty(this.importedBreakerSupplierCommittedDate)) return false;
			if (configDefs.isDtEmty(this.importedBreakerActualReceiptDate)) return false;
		}

		if (this.importedVSCPlannedReceiptDate_Enable) {
			if (configDefs.isDtEmty(this.importedVSCPlannedReceiptDate)) return false;
			if (configDefs.isDtEmty(this.importedVSCRequestedReceiptDate)) return false;
			if (configDefs.isDtEmty(this.importedVSCSupplierCommittedDate)) return false;
			if (configDefs.isDtEmty(this.importedVSCActualReceiptDate)) return false;
		}

		if (this.geRelayPlannedReceiptDate_Enable) {
			if (configDefs.isDtEmty(this.geRelayPlannedReceiptDate)) return false;
			if (configDefs.isDtEmty(this.geRelayRequestedReceiptDate)) return false;
			if (configDefs.isDtEmty(this.geRelaySupplierCommittedDate)) return false;
			if (configDefs.isDtEmty(this.geRelayActualReceiptDate)) return false;
		}

		if (configDefs.isDtEmty(this.ctPTPlannedReceiptDate)) return false;
		if (configDefs.isDtEmty(this.ctPTActualReceiptFirstDate)) return false;
		if (configDefs.isDtEmty(this.ctPTRequestedReceiptDate)) return false;
		if (configDefs.isDtEmty(this.ctPTSupplierCommittedDate)) return false;
		if (configDefs.isDtEmty(this.ctPTActualReceiptDate)) return false;
		if (configDefs.isStrEmty(this.ctApplicability)) return false;

		if (configDefs.isDtEmty(this.relayPlannedReceiptDate)) return false;
		if (configDefs.isDtEmty(this.relayRequestedReceiptDate)) return false;
		if (configDefs.isDtEmty(this.relaySupplierCommittedDate)) return false;
		if (configDefs.isDtEmty(this.relayActualReceiptDate)) return false;

		if (configDefs.isDtEmty(this.breakerPlannedReceiptDate)) return false;
		if (configDefs.isDtEmty(this.breakerRequestedReceiptDate)) return false;
		if (configDefs.isDtEmty(this.breakerSupplierCommittedDate)) return false;
		if (configDefs.isDtEmty(this.breakerActualReceiptDate)) return false;
		if (configDefs.isStrEmty(this.breakerApplicability)) return false;

		if (this.jumperPlannedReceiptDate_Enable) {
			if (configDefs.isDtEmty(this.jumperPlannedReceiptDate)) return false;
			if (configDefs.isDtEmty(this.jumperRequestedReceiptDate)) return false;
			if (configDefs.isDtEmty(this.jumperSupplierCommittedDate)) return false;
			if (configDefs.isDtEmty(this.jumperActualReceiptDate)) return false;
		}


		if (this.meteringBoxPlannedReceiptDate_Enable) {
			if (configDefs.isDtEmty(this.meteringBoxPlannedReceiptDate)) return false;
			if (configDefs.isDtEmty(this.meteringBoxRequestedReceiptDate)) return false;
			if (configDefs.isDtEmty(this.meteringBoxSupplierCommittedDate)) return false;
			if (configDefs.isDtEmty(this.meteringBoxActualReceiptDate)) return false;
			if (configDefs.isStrEmty(this.meteringBoxApplicability)) return false;

		}

		//bypassed SA as per the user requirement
		// if (configDefs.isDtEmty(this.saPlannedReceiptDate)) return false;
		// if (configDefs.isDtEmty(this.saRequestedReceiptDate)) return false;
		// if (configDefs.isDtEmty(this.saSupplierCommittedDate)) return false;
		// if (configDefs.isDtEmty(this.saActualReceiptDate)) return false;

		if (this.broughtoutFabricationPlannedReceiptDate_Enable) {
			if (configDefs.isDtEmty(this.broughtoutFabricationPlannedReceiptDate)) return false;
			if (configDefs.isDtEmty(this.broughtoutFabricationRequestedReceiptDate)) return false;
			if (configDefs.isDtEmty(this.broughtoutFabricationSupplierCommittedDate)) return false;
			if (configDefs.isDtEmty(this.broughtoutFabricationActualReceiptDate)) return false;
		}
		if (this.inHouseFabricationPlannedReceiptDate_Enable) {
			if (configDefs.isDtEmty(this.inHouseFabricationPlannedReceiptDate)) return false;
			if (configDefs.isDtEmty(this.inHouseFabricationRequestedReceiptDate)) return false;
			if (configDefs.isDtEmty(this.inHouseFabricationSupplierCommittedDate)) return false;
			if (configDefs.isDtEmty(this.inHouseFabricationActualReceiptDate)) return false;
		}
		return true;
	}
	get isProjectLive(): boolean {
		return this.parentSubSORef.pmTechSubSalesOrder.projStatus == "live";
	}
	get isInputEnabled(): boolean {
		return this.parentSubSORef.isSSOStatusSet(SSOStatus.Material_Receipt);
	}
	get isSubmittedtoStore(): boolean {
		return this.parentSubSORef.isSSOStatusSet(SSOStatus.Store_From_MaterialReceipt);
	}
	get readyForStore(): boolean {
		return this.parentSubSORef.isSSOStatusSet(SSOStatus.Material_Receipt);
	}
	get parentSORef(): SalesOrder {
		return this._parentSORef;
	}
	set parentSORef(SORef: SalesOrder) {
		this._parentSORef = SORef;
		//this.refreshStatus();
	}
	get parentSubSORef(): SubSalesOrder {
		return this._parentSubSORef;
	}
	set parentSubSORef(SubSORef: SubSalesOrder) {
		this._parentSubSORef = SubSORef;
	}
	get status(): FunctionStatus {
		return this._status;
	}
	enableFormInput(): void {
		if (this._status == FunctionStatus.WAITING_FOR_PREV) {
			this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
		}
	}

	get ctApplicability(): string {
		return this._ctApplicability;
	}
	set ctApplicability(_SetVal: string) {
		this._ctApplicability = _SetVal;
	}

	get isctApplicability(): boolean {
		return this._ctApplicability == "001";
	}

	get breakerApplicability(): string {
		return this._breakerApplicability;
	}
	set breakerApplicability(_SetVal: string) {
		this._breakerApplicability = _SetVal;
	}

	get isbreakerApplicability(): boolean {
		return this._breakerApplicability == "001";
	}

	get meteringBoxApplicability(): string {
		return this._meteringBoxApplicability;
	}
	set meteringBoxApplicability(_SetVal: string) {
		this._meteringBoxApplicability = _SetVal;
	}

	get ismeteringBoxApplicability(): boolean {
		return this._meteringBoxApplicability == "001";
	}

	get importedBreaker_Enable(): boolean {
		return this.parentSubSORef.pmTechSubSalesOrder.breakerApplicability_Enable;
	}
	get importedBreakerPlannedReceiptToken(): PlannedDateToken {
		return this._importedBreakerPlannedReceiptToken;
	}
	set importedBreakerPlannedReceiptToken(_SetVal: PlannedDateToken) {
		// if (this._importedBreakerPlannedReceiptToken.actualPlannedDate == null)
		// 	this._importedBreakerPlannedReceiptToken.actualPlannedDate = this.importedBreakerPlannedReceiptDate;
		this._importedBreakerPlannedReceiptToken.plannedDate = _SetVal.plannedDate;
		this._importedBreakerPlannedReceiptToken.isOveridden = _SetVal.isOveridden;
		this._importedBreakerPlannedReceiptToken.addNotes = _SetVal.addNotes;
		this._importedBreakerPlannedReceiptToken.userOveridden = _SetVal.userOveridden;
	}

	get importedBreakerPlannedReceiptDateLabel(): string {
		if (this.importedBreakerPlannedReceiptDateIsRevised == true) {
			return "Revised (Planned) Receipt Date"
		}
		else {
			return "Planned Receipt Date"
		}
	}
	get importedBreakerPlannedReceiptDateIsRevised(): boolean {
		if (this.importedBreakerPlannedReceiptDate_Initial && this.importedBreakerPlannedReceiptDate) {
			if (GenService.areDatesSame(this.importedBreakerPlannedReceiptDate_Initial, this.importedBreakerPlannedReceiptDate) == false) {
				return true;
			}
		}
		return false;

	}
	get importedBreakerPlannedReceiptDate_Initial(): Date {
		if (this._importedBreakerPlannedReceiptToken.actualPlannedDate == null || this._importedBreakerPlannedReceiptToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.purchasePOIP.importedBreakerPOReleasedPlannedDate_Initial;

			if (_tmpDate != null && configDefs.defPlndImpBrkrRcptWeeks) {
				this._importedBreakerPlannedReceiptToken.actualPlannedDate = configDefs.addWorkingWeeks(_tmpDate, configDefs.defPlndImpBrkrRcptWeeks);
			}
			else {
				this._importedBreakerPlannedReceiptToken.actualPlannedDate = null;
			}
		}
		return this._importedBreakerPlannedReceiptToken.actualPlannedDate;
	}
	get importedBreakerPlannedReceiptDate(): Date {
		if (this._importedBreakerPlannedReceiptToken.plannedDate == null || this._importedBreakerPlannedReceiptToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.purchasePOIP.importedBreakerPOReleasedActualDate;
			if (_tmpDate == null) {
				_tmpDate = this.parentSubSORef.purchasePOIP.importedBreakerPOReleasedPlannedDate;
			}
			if (_tmpDate != null && configDefs.defPlndImpBrkrRcptWeeks) {
				this._importedBreakerPlannedReceiptToken.plannedDate = configDefs.addWorkingWeeks(_tmpDate, configDefs.defPlndImpBrkrRcptWeeks);
			}
			else {
				this._importedBreakerPlannedReceiptToken.plannedDate = null;
			}
		}
		return this._importedBreakerPlannedReceiptToken.plannedDate;
	}
	private _importedBreakerPlannedReceiptGroup: RevisedDate;
	get importedBreakerPlannedReceiptGroup(): RevisedDate {
		this._importedBreakerPlannedReceiptGroup = new RevisedDate(this.importedBreakerPlannedReceiptDate_Initial, this.importedBreakerPlannedReceiptDateIsRevised, this.importedBreakerPlannedReceiptDate);

		return this._importedBreakerPlannedReceiptGroup;
	}
	set importedBreakerPlannedReceiptDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set importedBreakerPlannedReceiptDate directly");
		this._importedBreakerPlannedReceiptToken.plannedDate = _SetVal;
	}
	get importedBreakerPlannedReceiptDate_Enable(): boolean {
		return this.parentSubSORef.pmTechSubSalesOrder.breakerApplicability_Enable;
	}

	get importedBreakerRequestedReceiptDate(): Date {
		//if(this._importedBreakerRequestedReceiptDate == null && this.importedBreakerRequestedReceiptDate_Enable == true ){
		if (this.importedBreakerRequestedReceiptDate_Enable == true) {
			var _tmpDate = this.parentSubSORef.planningIP.requestedLineLoadingDate;
			if (_tmpDate != null && configDefs.defReqImpBrekRecptDays) {
				this._importedBreakerRequestedReceiptDate = configDefs.subtractWorkingDays(_tmpDate, configDefs.defReqImpBrekRecptDays);
			}
			else {
				this._importedBreakerRequestedReceiptDate = null;
			}
		}
		return this._importedBreakerRequestedReceiptDate;
	}
	get importedBreakerRequestedReceiptDate_Enable(): boolean {
		return this.parentSubSORef.pmTechSubSalesOrder.breakerApplicability_Enable;
	}
	set importedBreakerRequestedReceiptDate(_SetVal: Date) {
		this._importedBreakerRequestedReceiptDate = _SetVal;
	}
	get importedBreakerSupplierCommittedDate(): Date {
		return this._importedBreakerSupplierCommittedDate;
	}
	set importedBreakerSupplierCommittedDate(_SetVal: Date) {
		this._importedBreakerSupplierCommittedDate = _SetVal;
	}
	get importedBreakerActualReceiptToken(): ActualDateToken {
		return this._importedBreakerActualReceiptToken;
	}
	set importedBreakerActualReceiptToken(_SetVal: ActualDateToken) {
		if (this._importedBreakerActualReceiptToken.expActualDate == null)
			this._importedBreakerActualReceiptToken.expActualDate = this.importedBreakerActualReceiptDate;
		this._importedBreakerActualReceiptToken.actualDate = _SetVal.actualDate;
		this._importedBreakerActualReceiptToken.isOveridden = _SetVal.isOveridden;
		this._importedBreakerActualReceiptToken.addNotes = _SetVal.addNotes;
		this._importedBreakerActualReceiptToken.userOveridden = _SetVal.userOveridden;
	}
	get importedBreakerActualReceiptDate(): Date {
		return this._importedBreakerActualReceiptToken.actualDate;
	}
	set importedBreakerActualReceiptDate(_SetVal: Date) {
		console.log('wrong execution, importedBreakerActualReceiptDate');
		this._importedBreakerActualReceiptToken.actualDate = _SetVal;
	}
	get importedVSCPlannedReceiptToken(): PlannedDateToken {
		return this._importedVSCPlannedReceiptToken;
	}
	set importedVSCPlannedReceiptToken(_SetVal: PlannedDateToken) {
		// if (this._importedVSCPlannedReceiptToken.actualPlannedDate == null)
		// 	this._importedVSCPlannedReceiptToken.actualPlannedDate = this.importedVSCPlannedReceiptDate;
		this._importedVSCPlannedReceiptToken.plannedDate = _SetVal.plannedDate;
		this._importedVSCPlannedReceiptToken.isOveridden = _SetVal.isOveridden;
		this._importedVSCPlannedReceiptToken.addNotes = _SetVal.addNotes;
		this._importedVSCPlannedReceiptToken.userOveridden = _SetVal.userOveridden;
	}
	get importedVSCPlannedReceiptDateLabel(): string {
		if (this.importedVSCPlannedReceiptDateIsRevised == true) {
			return "Revised (Planned) Receipt Date"
		}
		else {
			return "Planned Date Receipt Date"
		}
	}
	get importedVSCPlannedReceiptDateIsRevised(): boolean {
		if (this.importedVSCPlannedReceiptDate_Initial && this.importedVSCPlannedReceiptDate) {
			if (GenService.areDatesSame(this.importedVSCPlannedReceiptDate_Initial, this.importedVSCPlannedReceiptDate) == false) {
				return true;
			}
		}
		return false;
	}
	get importedVSCPlannedReceiptDate_Initial(): Date {
		if (this._importedVSCPlannedReceiptToken.actualPlannedDate == null || this._importedVSCPlannedReceiptToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.purchasePOIP.importedVSCPOReleasedPlannedDate_Initial;

			if (_tmpDate != null && configDefs.defPlndImpVSCRcptWeeks) {
				this._importedVSCPlannedReceiptToken.actualPlannedDate = configDefs.addWorkingWeeks(_tmpDate, configDefs.defPlndImpVSCRcptWeeks);
			}
			else {
				this._importedVSCPlannedReceiptToken.actualPlannedDate = null;
			}
		}
		return this._importedVSCPlannedReceiptToken.actualPlannedDate;
	}
	get importedVSCPlannedReceiptDate(): Date {
		if (this._importedVSCPlannedReceiptToken.plannedDate == null || this._importedVSCPlannedReceiptToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.purchasePOIP.importedVSCPOReleasedActualDate;
			if (_tmpDate == null) {
				_tmpDate = this.parentSubSORef.purchasePOIP.importedVSCPOReleasedPlannedDate;
			}

			if (_tmpDate != null && configDefs.defPlndImpVSCRcptWeeks) {
				this._importedVSCPlannedReceiptToken.plannedDate = configDefs.addWorkingWeeks(_tmpDate, configDefs.defPlndImpVSCRcptWeeks);
			}
			else {
				this._importedVSCPlannedReceiptToken.plannedDate = null;
			}
		}
		return this._importedVSCPlannedReceiptToken.plannedDate;
	}
	private _importedVSCPlannedReceiptGroup: RevisedDate;
	get importedVSCPlannedReceiptGroup(): RevisedDate {
		this._importedVSCPlannedReceiptGroup = new RevisedDate(this.importedVSCPlannedReceiptDate_Initial, this.importedVSCPlannedReceiptDateIsRevised, this.importedVSCPlannedReceiptDate);

		return this._importedVSCPlannedReceiptGroup;
	}
	set importedVSCPlannedReceiptDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set importedVSCPlannedReceiptDate directly");
		this._importedVSCPlannedReceiptToken.plannedDate = _SetVal;
	}
	get importedVSCPlannedReceiptDate_Enable(): boolean {
		return this.parentSubSORef.pmTechSubSalesOrder.vscApplicability_Enable;
	}

	get importedVSCRequestedReceiptDate(): Date {
		//if(this._importedVSCRequestedReceiptDate == null && this.importedVSCRequestedReceiptDate_Enable == true){
		var _tmpDate = this.parentSubSORef.planningIP.requestedLineLoadingDate;
		if (_tmpDate != null && configDefs.defReqImpVSCRecptDays) {
			this._importedVSCRequestedReceiptDate = configDefs.subtractWorkingDays(_tmpDate, configDefs.defReqImpVSCRecptDays);
		}
		else {
			this._importedVSCRequestedReceiptDate = null;
		}
		//}
		return this._importedVSCRequestedReceiptDate;
	}
	get importedVSCRequestedReceiptDate_Enable(): boolean {
		return this.parentSubSORef.pmTechSubSalesOrder.vscApplicability_Enable;
	}
	set importedVSCRequestedReceiptDate(_SetVal: Date) {
		this._importedVSCRequestedReceiptDate = _SetVal;
	}
	get importedVSCSupplierCommittedDate(): Date {
		return this._importedVSCSupplierCommittedDate;
	}
	set importedVSCSupplierCommittedDate(_SetVal: Date) {
		this._importedVSCSupplierCommittedDate = _SetVal;
	}
	get importedVSCActualReceiptToken(): ActualDateToken {
		return this._importedVSCActualReceiptToken;
	}
	set importedVSCActualReceiptToken(_SetVal: ActualDateToken) {
		if (this._importedVSCActualReceiptToken.expActualDate == null)
			this._importedVSCActualReceiptToken.expActualDate = this.importedVSCActualReceiptDate;
		this._importedVSCActualReceiptToken.actualDate = _SetVal.actualDate;
		this._importedVSCActualReceiptToken.isOveridden = _SetVal.isOveridden;
		this._importedVSCActualReceiptToken.addNotes = _SetVal.addNotes;
		this._importedVSCActualReceiptToken.userOveridden = _SetVal.userOveridden;
	}
	get importedVSCActualReceiptDate(): Date {
		return this._importedVSCActualReceiptToken.actualDate;
	}
	set importedVSCActualReceiptDate(_SetVal: Date) {
		console.log('wrong execution, importedVSCActualReceiptDate')
		this._importedVSCActualReceiptToken.actualDate = _SetVal;
	}
	get geRelayPlannedReceiptToken(): PlannedDateToken {
		return this._geRelayPlannedReceiptToken;
	}
	set plannedGaDrawingSubmissionToken(_SetVal: PlannedDateToken) {
		// if (this._geRelayPlannedReceiptToken.actualPlannedDate == null)
		// 	this._geRelayPlannedReceiptToken.actualPlannedDate = this.geRelayPlannedReceiptDate;
		this._geRelayPlannedReceiptToken.plannedDate = _SetVal.plannedDate;
		this._geRelayPlannedReceiptToken.isOveridden = _SetVal.isOveridden;
		this._geRelayPlannedReceiptToken.addNotes = _SetVal.addNotes;
		this._geRelayPlannedReceiptToken.userOveridden = _SetVal.userOveridden;
	}

	get geRelayPlannedReceiptDateLabel(): string {
		if (this.geRelayPlannedReceiptDateIsRevised == true) {
			return "Revised (Planned) Receipt Date"
		}
		else {
			return "Planned Date Receipt Date"
		}
	}
	get geRelayPlannedReceiptDateIsRevised(): boolean {
		if (this.geRelayPlannedReceiptDate_Initial && this.geRelayPlannedReceiptDate) {
			if (GenService.areDatesSame(this.geRelayPlannedReceiptDate_Initial, this.geRelayPlannedReceiptDate) == false) {
				return true;
			}
		}
		return false;
	}
	get geRelayPlannedReceiptDate_Initial(): Date {
		if (this._geRelayPlannedReceiptToken.actualPlannedDate == null || this._geRelayPlannedReceiptToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.purchasePOIP.geRelayPOReleasePlannedDate_Initial;

			if (_tmpDate != null && configDefs.defPlndGERelayRecptWeek) {
				this._geRelayPlannedReceiptToken.actualPlannedDate = configDefs.addWorkingWeeks(_tmpDate, configDefs.defPlndGERelayRecptWeek);
			}
			else {
				this._geRelayPlannedReceiptToken.actualPlannedDate = null;
			}
		}
		return this._geRelayPlannedReceiptToken.actualPlannedDate;
	}
	get geRelayPlannedReceiptDate(): Date {
		if (this._geRelayPlannedReceiptToken.plannedDate == null || this._geRelayPlannedReceiptToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.purchasePOIP.geRelayPOReleaseActualDate;
			if (_tmpDate == null) {
				_tmpDate = this.parentSubSORef.purchasePOIP.geRelayPOReleasePlannedDate;
			}
			if (_tmpDate != null && configDefs.defPlndGERelayRecptWeek) {
				this._geRelayPlannedReceiptToken.plannedDate = configDefs.addWorkingWeeks(_tmpDate, configDefs.defPlndGERelayRecptWeek);
			}
			else {
				this._geRelayPlannedReceiptToken.plannedDate = null;
			}
		}
		return this._geRelayPlannedReceiptToken.plannedDate;
	}
	private _geRelayPlannedReceiptGroup: RevisedDate;
	get geRelayPlannedReceiptGroup(): RevisedDate {
		this._geRelayPlannedReceiptGroup = new RevisedDate(this.geRelayPlannedReceiptDate_Initial, this.geRelayPlannedReceiptDateIsRevised, this.geRelayPlannedReceiptDate);

		return this._geRelayPlannedReceiptGroup;
	}
	set geRelayPlannedReceiptDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set geRelayPlannedReceiptDate directly");
		this._geRelayPlannedReceiptToken.plannedDate = _SetVal;
	}
	get geRelayPlannedReceiptDate_Enable(): boolean {
		return this.parentSubSORef.pmTechSubSalesOrder.geRelayApplicability_Enable;
	}

	get geRelayRequestedReceiptDate(): Date {
		//if(this._geRelayRequestedReceiptDate == null && this.geRelayRequestedReceiptDate_Enable == true){
		var _tmpDate = this.parentSubSORef.planningIP.requestedLineLoadingDate;
		if (_tmpDate != null && configDefs.defReqGERelayRecptDays) {
			this._geRelayRequestedReceiptDate = configDefs.subtractWorkingDays(_tmpDate, configDefs.defReqGERelayRecptDays);
		}
		else {
			this._geRelayRequestedReceiptDate = null;
		}
		//}
		return this._geRelayRequestedReceiptDate;
	}
	get geRelayRequestedReceiptDate_Enable(): boolean {
		return this.parentSubSORef.pmTechSubSalesOrder.geRelayApplicability_Enable;
	}
	set geRelayRequestedReceiptDate(_SetVal: Date) {
		this._geRelayRequestedReceiptDate = _SetVal;
	}
	get geRelaySupplierCommittedDate(): Date {
		return this._geRelaySupplierCommittedDate;
	}
	set geRelaySupplierCommittedDate(_SetVal: Date) {
		this._geRelaySupplierCommittedDate = _SetVal;
	}
	get geRelayActualReceiptToken(): ActualDateToken {
		return this._geRelayActualReceiptToken;
	}
	set geRelayActualReceiptToken(_SetVal: ActualDateToken) {
		if (this._geRelayActualReceiptToken.expActualDate == null)
			this._geRelayActualReceiptToken.expActualDate = this.geRelayActualReceiptDate;
		this._geRelayActualReceiptToken.actualDate = _SetVal.actualDate;
		this._geRelayActualReceiptToken.isOveridden = _SetVal.isOveridden;
		this._geRelayActualReceiptToken.addNotes = _SetVal.addNotes;
		this._geRelayActualReceiptToken.userOveridden = _SetVal.userOveridden;
	}
	get geRelayActualReceiptDate(): Date {
		return this._geRelayActualReceiptToken.actualDate;
	}
	set geRelayActualReceiptDate(_SetVal: Date) {
		console.log('wrong execution , geRelayActualReceiptDate')
		this._geRelayActualReceiptToken.actualDate = _SetVal;
	}
	get ctPTPlannedReceiptToken(): PlannedDateToken {
		return this._ctPTPlannedReceiptToken;
	}
	set ctPTPlannedReceiptToken(_SetVal: PlannedDateToken) {
		// if (this._ctPTPlannedReceiptToken.actualPlannedDate == null)
		// 	this._ctPTPlannedReceiptToken.actualPlannedDate = this.ctPTPlannedReceiptDate;
		this._ctPTPlannedReceiptToken.plannedDate = _SetVal.plannedDate;
		this._ctPTPlannedReceiptToken.isOveridden = _SetVal.isOveridden;
		this._ctPTPlannedReceiptToken.addNotes = _SetVal.addNotes;
		this._ctPTPlannedReceiptToken.userOveridden = _SetVal.userOveridden;
	}
	get ctPTPlannedReceiptDateLabel(): string {
		if (this.ctPTPlannedReceiptDateIsRevised == true) {
			return "Revised (Planned) Receipt Date"
		}
		else {
			return "Planned Date Receipt Date"
		}
	}
	get ctPTPlannedReceiptDateIsRevised(): boolean {
		if (this.ctPTPlannedReceiptDate_Initial && this.ctPTPlannedReceiptDate) {
			if (GenService.areDatesSame(this.ctPTPlannedReceiptDate_Initial, this.ctPTPlannedReceiptDate) == false) {
				return true;
			}
		}
		return false;
	}
	get ctPTPlannedReceiptDate_Initial(): Date {
		if (this._ctPTPlannedReceiptToken.actualPlannedDate == null || this._ctPTPlannedReceiptToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.purchasePOIP.ctPTPOReleasedPlannedDate_Initial;

			if (_tmpDate != null && configDefs.defPlndCTPTRecptWeeks) {
				this._ctPTPlannedReceiptToken.actualPlannedDate = configDefs.addWorkingWeeks(_tmpDate, configDefs.defPlndCTPTRecptWeeks);
			}
			else {
				this._ctPTPlannedReceiptToken.actualPlannedDate = null;
			}
		}
		return this._ctPTPlannedReceiptToken.actualPlannedDate;
	}
	get ctPTPlannedReceiptDate(): Date {
		if (this._ctPTPlannedReceiptToken.plannedDate == null || this._ctPTPlannedReceiptToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.purchasePOIP.ctPTPOReleasedActualDate;
			if (_tmpDate == null) {
				_tmpDate = this.parentSubSORef.purchasePOIP.ctPTPOReleasedPlannedDate;
			}
			if (_tmpDate != null && configDefs.defPlndCTPTRecptWeeks) {
				this._ctPTPlannedReceiptToken.plannedDate = configDefs.addWorkingWeeks(_tmpDate, configDefs.defPlndCTPTRecptWeeks);
			}
			else {
				this._ctPTPlannedReceiptToken.plannedDate = null;
			}
		}
		return this._ctPTPlannedReceiptToken.plannedDate;
	}
	private _ctPTPlannedReceiptGroup: RevisedDate;
	get ctPTPlannedReceiptGroup(): RevisedDate {
		this._ctPTPlannedReceiptGroup = new RevisedDate(this.ctPTPlannedReceiptDate_Initial, this.ctPTPlannedReceiptDateIsRevised, this.ctPTPlannedReceiptDate);

		return this._ctPTPlannedReceiptGroup;
	}
	set ctPTPlannedReceiptDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set ctPTPlannedReceiptDate directly");
		this._ctPTPlannedReceiptToken.plannedDate = _SetVal;
	}
	get ctPTRequestedReceiptDate(): Date {
		//if(this._ctPTRequestedReceiptDate == null ){
		var _tmpDate = this.parentSubSORef.planningIP.requestedLineLoadingDate;
		if (_tmpDate != null && configDefs.defReqCTPTRecptDays) {
			this._ctPTRequestedReceiptDate = configDefs.subtractWorkingDays(_tmpDate, configDefs.defReqCTPTRecptDays);
		}
		else {
			this._ctPTRequestedReceiptDate = null;
		}
		//}
		return this._ctPTRequestedReceiptDate;
	}
	set ctPTRequestedReceiptDate(_SetVal: Date) {
		this._ctPTRequestedReceiptDate = _SetVal;
	}
	get ctPTSupplierCommittedDate(): Date {
		return this._ctPTSupplierCommittedDate;
	}
	set ctPTSupplierCommittedDate(_SetVal: Date) {
		this._ctPTSupplierCommittedDate = _SetVal;
	}

	// STARTS
	get ctPTActualReceiptFirstDate(): Date {
		return this._ctPTActualReceiptFirstDate;
	}
	set ctPTActualReceiptFirstDate(_SetVal: Date) {
		this._ctPTActualReceiptFirstDate = _SetVal;
	}

	// ENDS

	get ctPTActualReceiptToken(): ActualDateToken {
		return this._ctPTActualReceiptToken;
	}
	set ctPTActualReceiptToken(_SetVal: ActualDateToken) {
		if (this._ctPTActualReceiptToken.expActualDate == null)
			this._ctPTActualReceiptToken.expActualDate = this.ctPTActualReceiptDate;
		this._ctPTActualReceiptToken.actualDate = _SetVal.actualDate;
		this._ctPTActualReceiptToken.isOveridden = _SetVal.isOveridden;
		this._ctPTActualReceiptToken.addNotes = _SetVal.addNotes;
		this._ctPTActualReceiptToken.userOveridden = _SetVal.userOveridden;
	}
	get ctPTActualReceiptDate(): Date {
		return this._ctPTActualReceiptToken.actualDate;
	}
	set ctPTActualReceiptDate(_SetVal: Date) {
		console.log('wrong execution, ctPTActualReceiptDate');
		this._ctPTActualReceiptToken.actualDate = _SetVal;
	}
	get ctptPoNo(): string {
		return this._ctptPoNo;
	}
	set ctptPoNo(_SetVal: string) {
		this._ctptPoNo = _SetVal;
	}
	get relayPoNo(): string {
		return this._relayPoNo;
	}
	set relayPoNo(_SetVal: string) {
		this._relayPoNo = _SetVal;
	}
	get breakerPoNo(): string {
		return this._breakerPoNo;
	}
	set breakerPoNo(_SetVal: string) {
		this._breakerPoNo = _SetVal;
	}
	get saPoNo(): string {
		return this._saPoNo;
	}
	set saPoNo(_SetVal: string) {
		this._saPoNo = _SetVal;
	}
	get meteringBoxPoNo(): string {
		return this._meteringBoxPoNo;
	}
	set meteringBoxPoNo(_SetVal: string) {
		this._meteringBoxPoNo = _SetVal;
	}
	get relayPlannedReceiptToken(): PlannedDateToken {
		return this._relayPlannedReceiptToken;
	}
	set relayPlannedReceiptToken(_SetVal: PlannedDateToken) {
		// if (this._relayPlannedReceiptToken.actualPlannedDate == null)
		// 	this._relayPlannedReceiptToken.actualPlannedDate = this.relayPlannedReceiptDate;
		this._relayPlannedReceiptToken.plannedDate = _SetVal.plannedDate;
		this._relayPlannedReceiptToken.isOveridden = _SetVal.isOveridden;
		this._relayPlannedReceiptToken.addNotes = _SetVal.addNotes;
		this._relayPlannedReceiptToken.userOveridden = _SetVal.userOveridden;
	}

	get relayPlannedReceiptDateDateLabel(): string {
		if (this.relayPlannedReceiptDateIsRevised == true) {
			return "Revised (Planned) Receipt Date"
		}
		else {
			return "Planned Date Receipt Date"
		}
	}
	get relayPlannedReceiptDateIsRevised(): boolean {
		if (this.relayPlannedReceiptDate_Initial && this.relayPlannedReceiptDate) {
			if (GenService.areDatesSame(this.relayPlannedReceiptDate_Initial, this.relayPlannedReceiptDate) == false) {
				return true;
			}
		}
		return false;
	}
	get relayPlannedReceiptDate_Initial(): Date {
		if (this._relayPlannedReceiptToken.actualPlannedDate == null || this._relayPlannedReceiptToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.purchasePOIP.relayPOReleasedPlannedDate_Initial;

			if (_tmpDate != null && configDefs.defPlndRelRecptWeeks) {
				this._relayPlannedReceiptToken.actualPlannedDate = configDefs.addWorkingWeeks(_tmpDate, configDefs.defPlndRelRecptWeeks);
			}
			else {
				this._relayPlannedReceiptToken.actualPlannedDate = null;
			}
		}
		return this._relayPlannedReceiptToken.actualPlannedDate;
	}
	get relayPlannedReceiptDate(): Date {
		if (this._relayPlannedReceiptToken.plannedDate == null || this._relayPlannedReceiptToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.purchasePOIP.relayPOReleasedActualDate;
			if (_tmpDate == null) {
				_tmpDate = this.parentSubSORef.purchasePOIP.relayPOReleasedPlannedDate;
			}
			if (_tmpDate != null && configDefs.defPlndRelRecptWeeks) {
				this._relayPlannedReceiptToken.plannedDate = configDefs.addWorkingWeeks(_tmpDate, configDefs.defPlndRelRecptWeeks);
			}
			else {
				this._relayPlannedReceiptToken.plannedDate = null;
			}
		}
		return this._relayPlannedReceiptToken.plannedDate;
	}
	private _relayPlannedReceiptGroup: RevisedDate;
	get relayPlannedReceiptGroup(): RevisedDate {
		this._relayPlannedReceiptGroup = new RevisedDate(this.relayPlannedReceiptDate_Initial, this.relayPlannedReceiptDateIsRevised, this.relayPlannedReceiptDate);

		return this._relayPlannedReceiptGroup;
	}
	set relayPlannedReceiptDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set relayPlannedReceiptDate directly");
		this._relayPlannedReceiptToken.plannedDate = _SetVal;
	}
	get relayRequestedReceiptDate(): Date {
		//if(this._relayRequestedReceiptDate == null ){
		var _tmpDate = this.parentSubSORef.planningIP.requestedLineLoadingDate;
		if (_tmpDate != null && configDefs.defReqRelRecptDays) {
			this._relayRequestedReceiptDate = configDefs.subtractWorkingDays(_tmpDate, configDefs.defReqRelRecptDays);
		}
		else {
			this._relayRequestedReceiptDate = null;
		}
		//}
		return this._relayRequestedReceiptDate;
	}
	set relayRequestedReceiptDate(_SetVal: Date) {
		this._relayRequestedReceiptDate = _SetVal;
	}
	get relaySupplierCommittedDate(): Date {
		return this._relaySupplierCommittedDate;
	}
	set relaySupplierCommittedDate(_SetVal: Date) {
		this._relaySupplierCommittedDate = _SetVal;
	}
	get relayActualReceiptToken(): ActualDateToken {
		return this._relayActualReceiptToken;
	}
	set relayActualReceiptToken(_SetVal: ActualDateToken) {
		if (this._relayActualReceiptToken.expActualDate == null)
			this._relayActualReceiptToken.expActualDate = this.relayActualReceiptDate;
		this._relayActualReceiptToken.actualDate = _SetVal.actualDate;
		this._relayActualReceiptToken.isOveridden = _SetVal.isOveridden;
		this._relayActualReceiptToken.addNotes = _SetVal.addNotes;
		this._relayActualReceiptToken.userOveridden = _SetVal.userOveridden;
	}
	get relayActualReceiptDate(): Date {
		return this._relayActualReceiptToken.actualDate;
	}
	set relayActualReceiptDate(_SetVal: Date) {
		this._relayActualReceiptToken.actualDate = _SetVal;
	}
	get breakerPlannedReceiptToken(): PlannedDateToken {
		return this._breakerPlannedReceiptToken;
	}
	set breakerPlannedReceiptToken(_SetVal: PlannedDateToken) {
		// if (this._breakerPlannedReceiptToken.actualPlannedDate == null)
		// 	this._breakerPlannedReceiptToken.actualPlannedDate = this.breakerPlannedReceiptDate;
		this._breakerPlannedReceiptToken.plannedDate = _SetVal.plannedDate;
		this._breakerPlannedReceiptToken.isOveridden = _SetVal.isOveridden;
		this._breakerPlannedReceiptToken.addNotes = _SetVal.addNotes;
		this._breakerPlannedReceiptToken.userOveridden = _SetVal.userOveridden;
	}
	get breakerPlannedReceiptDateLabel(): string {
		if (this.breakerPlannedReceiptDateIsRevised == true) {
			return "Revised (Planned) Receipt Date"
		}
		else {
			return "Planned Date Receipt Date"
		}
	}
	get breakerPlannedReceiptDateIsRevised(): boolean {
		if (this.breakerPlannedReceiptDate_Initial && this.breakerPlannedReceiptDate) {
			if (GenService.areDatesSame(this.breakerPlannedReceiptDate_Initial, this.breakerPlannedReceiptDate) == false) {
				return true;
			}
		}
		return false;
	}
	get breakerPlannedReceiptDate_Initial(): Date {
		if (this._breakerPlannedReceiptToken.actualPlannedDate == null || this._breakerPlannedReceiptToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.planningIP.plannedLineLoadingDate_Initial;
			if (_tmpDate) {
				this._breakerPlannedReceiptToken.actualPlannedDate = configDefs.cloneDt(_tmpDate);
			}
			else {
				this._breakerPlannedReceiptToken.actualPlannedDate = null;
			}
		}
		return this._breakerPlannedReceiptToken.actualPlannedDate;
	}
	get breakerPlannedReceiptDate(): Date {
		if (this._breakerPlannedReceiptToken.plannedDate == null || this._breakerPlannedReceiptToken.isOveridden == false) {
			// var _tmpDate = this.parentSubSORef.productionIP.lineLoadingActualDate;
			// if(_tmpDate == null){
			var _tmpDate = this.parentSubSORef.planningIP.plannedLineLoadingDate;
			// }
			if (_tmpDate) {
				this._breakerPlannedReceiptToken.plannedDate = configDefs.cloneDt(_tmpDate);
			}
			else {
				this._breakerPlannedReceiptToken.plannedDate = null;
			}
		}
		return this._breakerPlannedReceiptToken.plannedDate;
	}
	private _breakerPlannedReceiptGroup: RevisedDate;
	get breakerPlannedReceiptGroup(): RevisedDate {
		this._breakerPlannedReceiptGroup = new RevisedDate(this.breakerPlannedReceiptDate_Initial, this.breakerPlannedReceiptDateIsRevised, this.breakerPlannedReceiptDate);

		return this._breakerPlannedReceiptGroup;
	}
	set breakerPlannedReceiptDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set breakerPlannedReceiptDate directly");
		this._breakerPlannedReceiptToken.plannedDate = _SetVal;
	}
	get breakerRequestedReceiptDate(): Date {
		//if(this._breakerRequestedReceiptDate == null){
		this._breakerRequestedReceiptDate = this.parentSubSORef.planningIP.requestedLineLoadingDate;
		//}
		return this._breakerRequestedReceiptDate;
	}
	set breakerRequestedReceiptDate(_SetVal: Date) {
		this._breakerRequestedReceiptDate = _SetVal;
	}
	get breakerSupplierCommittedDate(): Date {
		return this._breakerSupplierCommittedDate;
	}
	set breakerSupplierCommittedDate(_SetVal: Date) {
		this._breakerSupplierCommittedDate = _SetVal;
	}
	get breakerActualReceiptToken(): ActualDateToken {
		return this._breakerActualReceiptToken;
	}
	set breakerActualReceiptToken(_SetVal: ActualDateToken) {
		if (this._breakerActualReceiptToken.expActualDate == null)
			this._breakerActualReceiptToken.expActualDate = this.breakerActualReceiptDate;
		this._breakerActualReceiptToken.actualDate = _SetVal.actualDate;
		this._breakerActualReceiptToken.isOveridden = _SetVal.isOveridden;
		this._breakerActualReceiptToken.addNotes = _SetVal.addNotes;
		this._breakerActualReceiptToken.userOveridden = _SetVal.userOveridden;
	}
	get breakerActualReceiptDate(): Date {
		return this._breakerActualReceiptToken.actualDate;
	}
	set breakerActualReceiptDate(_SetVal: Date) {
		console.log('wrong execution, breakerActualReceiptDate');
		this._breakerActualReceiptToken.actualDate = _SetVal;
	}
	get jumperPlannedReceiptToken(): PlannedDateToken {
		return this._jumperPlannedReceiptToken;
	}
	set jumperPlannedReceiptToken(_SetVal: PlannedDateToken) {
		// if (this._jumperPlannedReceiptToken.actualPlannedDate == null)
		// 	this._jumperPlannedReceiptToken.actualPlannedDate = this.jumperPlannedReceiptDate;
		this._jumperPlannedReceiptToken.plannedDate = _SetVal.plannedDate;
		this._jumperPlannedReceiptToken.isOveridden = _SetVal.isOveridden;
		this._jumperPlannedReceiptToken.addNotes = _SetVal.addNotes;
		this._jumperPlannedReceiptToken.userOveridden = _SetVal.userOveridden;
	}
	get jumperPlannedReceiptDateLabel(): string {
		if (this.jumperPlannedReceiptDateIsRevised == true) {
			return "Revised (Planned) Receipt Date"
		}
		else {
			return "Planned Date Receipt Date"
		}
	}
	get jumperPlannedReceiptDateIsRevised(): boolean {
		if (this.jumperPlannedReceiptDate_Initial && this.jumperPlannedReceiptDate) {
			if (GenService.areDatesSame(this.jumperPlannedReceiptDate_Initial, this.jumperPlannedReceiptDate) == false) {
				return true;
			}
		}
		return false;
	}
	get jumperPlannedReceiptDate_Initial(): Date {
		if (this._jumperPlannedReceiptToken.actualPlannedDate == null || this._jumperPlannedReceiptToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.planningIP.plannedLineLoadingDate_Initial;

			if (_tmpDate) {
				this._jumperPlannedReceiptToken.actualPlannedDate = configDefs.cloneDt(_tmpDate);
			}
			else {
				this._jumperPlannedReceiptToken.actualPlannedDate = null;
			}
		}
		return this._jumperPlannedReceiptToken.actualPlannedDate;
	}
	get jumperPlannedReceiptDate(): Date {
		if (this._jumperPlannedReceiptToken.plannedDate == null || this._jumperPlannedReceiptToken.isOveridden == false) {
			// var _tmpDate = this.parentSubSORef.productionIP.lineLoadingActualDate;
			// if(_tmpDate == null){
			var _tmpDate = this.parentSubSORef.planningIP.plannedLineLoadingDate;
			// }
			if (_tmpDate) {
				this._jumperPlannedReceiptToken.plannedDate = configDefs.cloneDt(_tmpDate);
			}
			else {
				this._jumperPlannedReceiptToken.plannedDate = null;
			}
		}
		return this._jumperPlannedReceiptToken.plannedDate;
	}
	private _jumperPlannedReceiptGroup: RevisedDate;
	get jumperPlannedReceiptGroup(): RevisedDate {
		this._jumperPlannedReceiptGroup = new RevisedDate(this.jumperPlannedReceiptDate_Initial, this.jumperPlannedReceiptDateIsRevised, this.jumperPlannedReceiptDate);

		return this._jumperPlannedReceiptGroup;
	}
	set jumperPlannedReceiptDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set jumperPlannedReceiptDate directly");
		this._jumperPlannedReceiptToken.plannedDate = _SetVal;
	}
	get jumperPlannedReceiptDate_Enable(): boolean {
		return this.parentSubSORef.planningIP.manufacturingStrategyInhouse_Enable == true;
	}

	get jumperRequestedReceiptDate(): Date {
		//if(this._jumperRequestedReceiptDate == null && this.jumperRequestedReceiptDate_Enable == false){
		var _tmpDate = this.parentSubSORef.planningIP.requestedLineLoadingDate;
		if (_tmpDate != null && configDefs.defReqJumRecptDays) {
			this._jumperRequestedReceiptDate = configDefs.subtractWorkingDays(_tmpDate, configDefs.defReqJumRecptDays);
		}
		else {
			this._jumperRequestedReceiptDate = null;
		}
		//}
		return this._jumperRequestedReceiptDate;
	}
	get jumperRequestedReceiptDate_Enable(): boolean {
		return this.parentSubSORef.planningIP.manufacturingStrategyInhouse_Enable == true;
	}
	set jumperRequestedReceiptDate(_SetVal: Date) {
		this._jumperRequestedReceiptDate = _SetVal;
	}
	get jumperSupplierCommittedDate(): Date {
		return this._jumperSupplierCommittedDate;
	}
	set jumperSupplierCommittedDate(_SetVal: Date) {
		this._jumperSupplierCommittedDate = _SetVal;
	}
	get jumperActualReceiptToken(): ActualDateToken {
		return this._jumperActualReceiptToken;
	}
	set jumperActualReceiptToken(_SetVal: ActualDateToken) {
		if (this._jumperActualReceiptToken.expActualDate == null)
			this._jumperActualReceiptToken.expActualDate = this.jumperActualReceiptDate;
		this._jumperActualReceiptToken.actualDate = _SetVal.actualDate;
		this._jumperActualReceiptToken.isOveridden = _SetVal.isOveridden;
		this._jumperActualReceiptToken.addNotes = _SetVal.addNotes;
		this._jumperActualReceiptToken.userOveridden = _SetVal.userOveridden;
	}
	get jumperActualReceiptDate(): Date {
		return this._jumperActualReceiptToken.actualDate;
	}
	set jumperActualReceiptDate(_SetVal: Date) {
		this._jumperActualReceiptToken.actualDate = _SetVal;
	}
	get meteringBoxPlannedReceiptToken(): PlannedDateToken {
		return this._meteringBoxPlannedReceiptToken;
	}
	set meteringBoxPlannedReceiptToken(_SetVal: PlannedDateToken) {
		// if (this._meteringBoxPlannedReceiptToken.actualPlannedDate == null)
		// 	this._meteringBoxPlannedReceiptToken.actualPlannedDate = this.meteringBoxPlannedReceiptDate;
		this._meteringBoxPlannedReceiptToken.plannedDate = _SetVal.plannedDate;
		this._meteringBoxPlannedReceiptToken.isOveridden = _SetVal.isOveridden;
		this._meteringBoxPlannedReceiptToken.addNotes = _SetVal.addNotes;
		this._meteringBoxPlannedReceiptToken.userOveridden = _SetVal.userOveridden;
	}
	get meteringBoxPlannedReceiptDateLabel(): string {
		if (this.meteringBoxPlannedReceiptDateIsRevised == true) {
			return "Revised (Planned) Receipt Date"
		}
		else {
			return "Planned Date Receipt Date"
		}
	}
	get meteringBoxPlannedReceiptDateIsRevised(): boolean {
		if (this.meteringBoxPlannedReceiptDate_Initial && this.meteringBoxPlannedReceiptDate) {
			if (GenService.areDatesSame(this.meteringBoxPlannedReceiptDate_Initial, this.meteringBoxPlannedReceiptDate) == false) {
				return true;
			}
		}
		return false;
	}
	get meteringBoxPlannedReceiptDate_Initial(): Date {
		if (this._meteringBoxPlannedReceiptToken.actualPlannedDate == null || this._meteringBoxPlannedReceiptToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.planningIP.plannedLineLoadingDate_Initial;

			if (_tmpDate) {
				this._meteringBoxPlannedReceiptToken.actualPlannedDate = configDefs.cloneDt(_tmpDate);
			}
			else {
				this._meteringBoxPlannedReceiptToken.actualPlannedDate = null;
			}
		}
		return this._meteringBoxPlannedReceiptToken.actualPlannedDate;
	}
	get meteringBoxPlannedReceiptDate(): Date {
		if (this._meteringBoxPlannedReceiptToken.plannedDate == null || this._meteringBoxPlannedReceiptToken.isOveridden == false) {
			// var _tmpDate = this.parentSubSORef.productionIP.lineLoadingActualDate; 
			// if(_tmpDate == null){
			var _tmpDate = this.parentSubSORef.planningIP.plannedLineLoadingDate;
			// }
			if (_tmpDate) {
				this._meteringBoxPlannedReceiptToken.plannedDate = configDefs.cloneDt(_tmpDate);
			}
			else {
				this._meteringBoxPlannedReceiptToken.plannedDate = null;
			}
		}
		return this._meteringBoxPlannedReceiptToken.plannedDate;
	}
	private _meteringBoxPlannedReceiptGroup: RevisedDate;
	get meteringBoxPlannedReceiptGroup(): RevisedDate {
		this._meteringBoxPlannedReceiptGroup = new RevisedDate(this.meteringBoxPlannedReceiptDate_Initial, this.meteringBoxPlannedReceiptDateIsRevised, this.meteringBoxPlannedReceiptDate);

		return this._meteringBoxPlannedReceiptGroup;
	}
	set meteringBoxPlannedReceiptDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set meteringBoxPlannedReceiptDate directly");
		this._meteringBoxPlannedReceiptToken.plannedDate = _SetVal;
	}
	get meteringBoxPlannedReceiptDate_Enable(): boolean {
		return this.parentSubSORef.planningIP.manufacturingStrategyInhouse_Enable == true;
	}

	get meteringBoxRequestedReceiptDate(): Date {
		if (this.meteringBoxRequestedReceiptDate_Enable == true) {
			return this.parentSubSORef.planningIP.requestedLineLoadingDate;
		}
		return this._meteringBoxRequestedReceiptDate;
	}
	get meteringBoxRequestedReceiptDate_Enable(): boolean {
		return this.parentSubSORef.planningIP.manufacturingStrategyInhouse_Enable == true;
	}
	set meteringBoxRequestedReceiptDate(_SetVal: Date) {
		this._meteringBoxRequestedReceiptDate = _SetVal;
	}
	get meteringBoxSupplierCommittedDate(): Date {
		return this._meteringBoxSupplierCommittedDate;
	}
	set meteringBoxSupplierCommittedDate(_SetVal: Date) {
		this._meteringBoxSupplierCommittedDate = _SetVal;
	}
	get meteringBoxActualReceiptToken(): ActualDateToken {
		return this._meteringBoxActualReceiptToken;
	}
	set meteringBoxActualReceiptToken(_SetVal: ActualDateToken) {
		if (this._meteringBoxActualReceiptToken.expActualDate == null)
			this._meteringBoxActualReceiptToken.expActualDate = this.meteringBoxActualReceiptDate;
		this._meteringBoxActualReceiptToken.actualDate = _SetVal.actualDate;
		this._meteringBoxActualReceiptToken.isOveridden = _SetVal.isOveridden;
		this._meteringBoxActualReceiptToken.addNotes = _SetVal.addNotes;
		this._meteringBoxActualReceiptToken.userOveridden = _SetVal.userOveridden;
	}
	get meteringBoxActualReceiptDate(): Date {
		return this._meteringBoxActualReceiptToken.actualDate;
	}
	set meteringBoxActualReceiptDate(_SetVal: Date) {
		console.log('wrong execution, meteringBoxActualReceiptDate');
		this._meteringBoxActualReceiptToken.actualDate = _SetVal;
	}
	get saPlannedReceiptToken(): PlannedDateToken {
		return this._saPlannedReceiptToken;
	}
	set saPlannedReceiptToken(_SetVal: PlannedDateToken) {
		// if (this._saPlannedReceiptToken.actualPlannedDate == null)
		// 	this._saPlannedReceiptToken.actualPlannedDate = this.saPlannedReceiptDate;
		this._saPlannedReceiptToken.plannedDate = _SetVal.plannedDate;
		this._saPlannedReceiptToken.isOveridden = _SetVal.isOveridden;
		this._saPlannedReceiptToken.addNotes = _SetVal.addNotes;
		this._saPlannedReceiptToken.userOveridden = _SetVal.userOveridden;
	}
	get saPlannedReceiptDateLabel(): string {
		if (this.saPlannedReceiptDateIsRevised == true) {
			return "Revised (Planned) Receipt Date"
		}
		else {
			return "Planned Date Receipt Date"
		}
	}
	get saPlannedReceiptDateIsRevised(): boolean {
		if (this.saPlannedReceiptDate_Initial && this.saPlannedReceiptDate) {
			if (GenService.areDatesSame(this.saPlannedReceiptDate_Initial, this.saPlannedReceiptDate) == false) {
				return true;
			}
		}
		return false;
	}
	get saPlannedReceiptDate_Initial(): Date {
		if (this._saPlannedReceiptToken.actualPlannedDate == null || this._saPlannedReceiptToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.purchasePOIP.saPOReleasedPlannedDate_Initial;

			if (_tmpDate != null && configDefs.defPlndSARecptWeeks) {
				this._saPlannedReceiptToken.actualPlannedDate = configDefs.addWorkingWeeks(_tmpDate, configDefs.defPlndSARecptWeeks);
			}
			else {
				this._saPlannedReceiptToken.actualPlannedDate = null;
			}
		}
		return this._saPlannedReceiptToken.actualPlannedDate;
	}
	get saPlannedReceiptDate(): Date {
		if (this._saPlannedReceiptToken.plannedDate == null || this._saPlannedReceiptToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.purchasePOIP.saPOReleasedActualDate;

			if (_tmpDate == null) {
				_tmpDate = this.parentSubSORef.purchasePOIP.saPOReleasedPlannedDate;
			}
			if (_tmpDate != null && configDefs.defPlndSARecptWeeks) {
				this._saPlannedReceiptToken.plannedDate = configDefs.addWorkingWeeks(_tmpDate, configDefs.defPlndSARecptWeeks);
			}
			else {
				this._saPlannedReceiptToken.plannedDate = null;
			}
		}
		return this._saPlannedReceiptToken.plannedDate;
	}
	private _saPlannedReceiptGroup: RevisedDate;
	get saPlannedReceiptGroup(): RevisedDate {
		this._saPlannedReceiptGroup = new RevisedDate(this.saPlannedReceiptDate_Initial, this.saPlannedReceiptDateIsRevised, this.saPlannedReceiptDate);

		return this._saPlannedReceiptGroup;
	}
	set saPlannedReceiptDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set saPlannedReceiptDate directly");
		this._saPlannedReceiptToken.plannedDate = _SetVal;
	}
	get saRequestedReceiptDate(): Date {
		//if(this._saRequestedReceiptDate == null ){
		var _tmpDate = this.parentSubSORef.planningIP.requestedLineLoadingDate;
		if (_tmpDate != null && configDefs.defReqSARecptDays) {
			this._saRequestedReceiptDate = configDefs.subtractWorkingDays(_tmpDate, configDefs.defReqSARecptDays);
		}
		else {
			this._saRequestedReceiptDate = null;
		}
		//}
		return this._saRequestedReceiptDate;
	}
	set saRequestedReceiptDate(_SetVal: Date) {
		this._saRequestedReceiptDate = _SetVal;
	}
	get saSupplierCommittedDate(): Date {
		return this._saSupplierCommittedDate;
	}
	set saSupplierCommittedDate(_SetVal: Date) {
		this._saSupplierCommittedDate = _SetVal;
	}
	get saActualReceiptToken(): ActualDateToken {
		return this._saActualReceiptToken;
	}
	set saActualReceiptToken(_SetVal: ActualDateToken) {
		if (this._saActualReceiptToken.expActualDate == null)
			this._saActualReceiptToken.expActualDate = this.saActualReceiptDate;
		this._saActualReceiptToken.actualDate = _SetVal.actualDate;
		this._saActualReceiptToken.isOveridden = _SetVal.isOveridden;
		this._saActualReceiptToken.addNotes = _SetVal.addNotes;
		this._saActualReceiptToken.userOveridden = _SetVal.userOveridden;
	}
	get saActualReceiptDate(): Date {
		return this._saActualReceiptToken.actualDate;
	}
	set saActualReceiptDate(_SetVal: Date) {
		console.log('wrong execution, saActualReceiptDate');
		this._saActualReceiptToken.actualDate = _SetVal;
	}
	get broughtoutFabricationPlannedReceiptToken(): PlannedDateToken {
		return this._broughtoutFabricationPlannedReceiptToken;
	}
	set broughtoutFabricationPlannedReceiptToken(_SetVal: PlannedDateToken) {
		// if (this._broughtoutFabricationPlannedReceiptToken.actualPlannedDate == null)
		// 	this._broughtoutFabricationPlannedReceiptToken.actualPlannedDate = this.broughtoutFabricationPlannedReceiptDate;
		this._broughtoutFabricationPlannedReceiptToken.plannedDate = _SetVal.plannedDate;
		this._broughtoutFabricationPlannedReceiptToken.isOveridden = _SetVal.isOveridden;
		this._broughtoutFabricationPlannedReceiptToken.addNotes = _SetVal.addNotes;
		this._broughtoutFabricationPlannedReceiptToken.userOveridden = _SetVal.userOveridden;
	}
	get broughtoutFabricationPlannedReceiptDateLabel(): string {
		if (this.broughtoutFabricationPlannedReceiptDateIsRevised == true) {
			return "Revised (Planned) Receipt Date"
		}
		else {
			return "Planned Date Receipt Date"
		}
	}
	get broughtoutFabricationPlannedReceiptDateIsRevised(): boolean {
		if (this.broughtoutFabricationPlannedReceiptDate_Initial && this.broughtoutFabricationPlannedReceiptDate) {
			if (GenService.areDatesSame(this.broughtoutFabricationPlannedReceiptDate_Initial, this.broughtoutFabricationPlannedReceiptDate) == false) {
				return true;
			}
		}
		return false;
	}
	get broughtoutFabricationPlannedReceiptDate_Initial(): Date {
		if (this._broughtoutFabricationPlannedReceiptToken.actualPlannedDate == null || this._broughtoutFabricationPlannedReceiptToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.planningIP.plannedLineLoadingDate_Initial;

			if (_tmpDate) {
				this._broughtoutFabricationPlannedReceiptToken.actualPlannedDate = configDefs.cloneDt(_tmpDate);
			}
			else {
				this._broughtoutFabricationPlannedReceiptToken.actualPlannedDate = null;
			}
		}
		return this._broughtoutFabricationPlannedReceiptToken.actualPlannedDate;
	}
	get broughtoutFabricationPlannedReceiptDate(): Date {
		if (this._broughtoutFabricationPlannedReceiptToken.plannedDate == null || this._broughtoutFabricationPlannedReceiptToken.isOveridden == false) {
			// var _tmpDate = this.parentSubSORef.productionIP.lineLoadingActualDate;

			// if (_tmpDate == null) {
			var _tmpDate = this.parentSubSORef.planningIP.plannedLineLoadingDate;
			// } 
			if (_tmpDate) {
				this._broughtoutFabricationPlannedReceiptToken.plannedDate = configDefs.cloneDt(_tmpDate);
			}
			else {
				this._broughtoutFabricationPlannedReceiptToken.plannedDate = null;
			}
		}
		return this._broughtoutFabricationPlannedReceiptToken.plannedDate;
	}
	private _broughtoutFabricationPlannedReceiptGroup: RevisedDate;
	get broughtoutFabricationPlannedReceiptGroup(): RevisedDate {
		this._broughtoutFabricationPlannedReceiptGroup = new RevisedDate(this.broughtoutFabricationPlannedReceiptDate_Initial, this.broughtoutFabricationPlannedReceiptDateIsRevised, this.broughtoutFabricationPlannedReceiptDate);

		return this._broughtoutFabricationPlannedReceiptGroup;
	}
	set broughtoutFabricationPlannedReceiptDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set broughtoutFabricationPlannedReceiptDate directly");
		this._broughtoutFabricationPlannedReceiptToken.plannedDate = _SetVal;
	}
	get broughtoutFabricationPlannedReceiptDate_Enable(): boolean {
		return this.parentSubSORef.planningIP.manufacturingStrategyInhouse_Enable == true;
	}

	get broughtoutFabricationRequestedReceiptDate(): Date {
		//if(this.broughtoutFabricationRequestedReceiptDate_Enable == false){
		this._broughtoutFabricationRequestedReceiptDate = configDefs.cloneDt(this.parentSubSORef.planningIP.requestedLineLoadingDate);
		//}
		return this._broughtoutFabricationRequestedReceiptDate;
	}
	get broughtoutFabricationRequestedReceiptDate_Enable(): boolean {
		return this.parentSubSORef.planningIP.manufacturingStrategyInhouse_Enable != true;
	}
	set broughtoutFabricationRequestedReceiptDate(_SetVal: Date) {
		this._broughtoutFabricationRequestedReceiptDate = _SetVal;
	}
	get broughtoutFabricationSupplierCommittedDate(): Date {
		return this._broughtoutFabricationSupplierCommittedDate;
	}
	set broughtoutFabricationSupplierCommittedDate(_SetVal: Date) {
		this._broughtoutFabricationSupplierCommittedDate = _SetVal;
	}
	get broughtoutFabricationActualReceiptToken(): ActualDateToken {
		return this._broughtoutFabricationActualReceiptToken;
	}
	set broughtoutFabricationActualReceiptToken(_SetVal: ActualDateToken) {
		if (this._broughtoutFabricationActualReceiptToken.expActualDate == null)
			this._broughtoutFabricationActualReceiptToken.expActualDate = this.broughtoutFabricationActualReceiptDate;
		this._broughtoutFabricationActualReceiptToken.actualDate = _SetVal.actualDate;
		this._broughtoutFabricationActualReceiptToken.isOveridden = _SetVal.isOveridden;
		this._broughtoutFabricationActualReceiptToken.addNotes = _SetVal.addNotes;
		this._broughtoutFabricationActualReceiptToken.userOveridden = _SetVal.userOveridden;
	}
	get broughtoutFabricationActualReceiptDate(): Date {
		return this._broughtoutFabricationActualReceiptToken.actualDate;
	}
	set broughtoutFabricationActualReceiptDate(_SetVal: Date) {
		console.log('wrong execution, broughtoutFabricationActualReceiptDate');
		this._broughtoutFabricationActualReceiptToken.actualDate = _SetVal;
	}
	//  inhouse fabricatiuon properties
	get inHouseFabricationPlannedReceiptToken(): PlannedDateToken {
		return this._inHouseFabricationPlannedReceiptToken;
	}
	set inHouseFabricationPlannedReceiptToken(_SetVal: PlannedDateToken) {
		// if (this._inHouseFabricationPlannedReceiptToken.actualPlannedDate == null)
		// 	this._inHouseFabricationPlannedReceiptToken.actualPlannedDate = this.inHouseFabricationPlannedReceiptDate;
		this._inHouseFabricationPlannedReceiptToken.plannedDate = _SetVal.plannedDate;
		this._inHouseFabricationPlannedReceiptToken.isOveridden = _SetVal.isOveridden;
		this._inHouseFabricationPlannedReceiptToken.addNotes = _SetVal.addNotes;
		this._inHouseFabricationPlannedReceiptToken.userOveridden = _SetVal.userOveridden;
	}
	get inHouseFabricationPlannedReceiptDateLabel(): string {
		if (this.broughtoutFabricationPlannedReceiptDateIsRevised == true) {
			return "Revised (Planned) Receipt Date"
		} else {
			return "Planned Date Receipt Date"
		}
	}
	get inHouseFabricationPlannedReceiptDateIsRevised(): boolean {
		if (this.inHouseFabricationPlannedReceiptDate_Initial && this.inHouseFabricationPlannedReceiptDate) {
			if (GenService.areDatesSame(this.inHouseFabricationPlannedReceiptDate_Initial, this.inHouseFabricationPlannedReceiptDate) == false) {
				return true;
			}
		}
		return false;
	}
	get inHouseFabricationPlannedReceiptDate_Initial(): Date {
		if (this._inHouseFabricationPlannedReceiptToken.actualPlannedDate == null || this._inHouseFabricationPlannedReceiptToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.planningIP.plannedLineLoadingDate_Initial;

			if (_tmpDate != null && configDefs.defInhouseFabsubtracdays) {
				this._inHouseFabricationPlannedReceiptToken.actualPlannedDate = configDefs.subtractWorkingDays(_tmpDate, configDefs.defInhouseFabsubtracdays);
			}
			else {
				this._inHouseFabricationPlannedReceiptToken.actualPlannedDate = null;
			}
		}
		return this._inHouseFabricationPlannedReceiptToken.actualPlannedDate;
	}
	get inHouseFabricationPlannedReceiptDate(): Date {
		if (this._inHouseFabricationPlannedReceiptToken.plannedDate == null || this._inHouseFabricationPlannedReceiptToken.isOveridden == false) {
			// var _tmpDate = this.parentSubSORef.productionIP.lineLoadingActualDate;
			// if (_tmpDate == null) {
			var _tmpDate = this.parentSubSORef.planningIP.plannedLineLoadingDate;
			// } 
			if (_tmpDate != null && configDefs.defInhouseFabsubtracdays) {
				this._inHouseFabricationPlannedReceiptToken.plannedDate = configDefs.subtractWorkingDays(_tmpDate, configDefs.defInhouseFabsubtracdays);
			}
			else {
				this._inHouseFabricationPlannedReceiptToken.plannedDate = null;
			}
		}
		return this._inHouseFabricationPlannedReceiptToken.plannedDate;
	}
	private _inHouseFabricationPlannedReceiptGroup: RevisedDate
	get inHouseFabricationPlannedReceiptGroup(): RevisedDate {
		this._inHouseFabricationPlannedReceiptGroup = new RevisedDate(this.inHouseFabricationPlannedReceiptDate_Initial, this.inHouseFabricationPlannedReceiptDateIsRevised, this.inHouseFabricationPlannedReceiptDate);

		return this._inHouseFabricationPlannedReceiptGroup;
	}
	set inHouseFabricationPlannedReceiptDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set inHouseFabricationPlannedReceiptDate directly");
		this._inHouseFabricationPlannedReceiptToken.plannedDate = _SetVal;
	}
	get inHouseFabricationPlannedReceiptDate_Enable(): boolean {
		return this.parentSubSORef.planningIP.manufacturingStrategyInhouse_Enable == true;
	}


	get inHouseFabricationRequestedReceiptDate(): Date {
		var _tmpDate = this.parentSubSORef.planningIP.requestedLineLoadingDate
		if (_tmpDate != null && configDefs.defInhouseFabsubtracdays) {
			this._inHouseFabricationRequestedReceiptDate = configDefs.subtractWorkingDays(_tmpDate, configDefs.defInhouseFabsubtracdays);
		}
		else {
			this._inHouseFabricationRequestedReceiptDate = null;
		}
		return this._inHouseFabricationRequestedReceiptDate;
	}
	get inHouseFabricationRequestedReceiptDate_Enable(): boolean {
		return this.parentSubSORef.planningIP.manufacturingStrategyInhouse_Enable == true;
	}
	set inHouseFabricationRequestedReceiptDate(_SetVal: Date) {
		this._inHouseFabricationRequestedReceiptDate = _SetVal;
	}
	get inHouseFabricationSupplierCommittedDate(): Date {
		return this._inHouseFabricationSupplierCommittedDate;
	}
	set inHouseFabricationSupplierCommittedDate(_SetVal: Date) {
		this._inHouseFabricationSupplierCommittedDate = _SetVal;
	}

	get inHouseFabricationActualReceiptToken(): ActualDateToken {
		return this._inHouseFabricationActualReceiptToken;
	}
	set inHouseFabricationActualReceiptToken(_SetVal: ActualDateToken) {
		if (this._inHouseFabricationActualReceiptToken.expActualDate == null)
			this._inHouseFabricationActualReceiptToken.expActualDate = this.broughtoutFabricationActualReceiptDate;
		this._inHouseFabricationActualReceiptToken.actualDate = _SetVal.actualDate;
		this._inHouseFabricationActualReceiptToken.isOveridden = _SetVal.isOveridden;
		this._inHouseFabricationActualReceiptToken.addNotes = _SetVal.addNotes;
		this._inHouseFabricationActualReceiptToken.userOveridden = _SetVal.userOveridden;
	}
	get inHouseFabricationActualReceiptDate(): Date {
		return this._inHouseFabricationActualReceiptToken.actualDate;
	}
	set inHouseFabricationActualReceiptDate(_SetVal: Date) {
		console.log('wrong execution, inHouseFabricationActualReceiptDate');
		this._inHouseFabricationActualReceiptToken.actualDate = _SetVal;
	}
	get purMatRcptDays(): number {
		let _ctptMatRcptDays: number = configDefs.getDaysDifference(this.ctPTRequestedReceiptDate, this.ctPTActualReceiptDate);
		let _mtrBoxMatRcptDays: number = configDefs.getDaysDifference(this.meteringBoxRequestedReceiptDate, this.meteringBoxActualReceiptDate);
		let _jumprMatRcptDays: number = configDefs.getDaysDifference(this.jumperRequestedReceiptDate, this.jumperActualReceiptDate);
		return configDefs.getMinValue([_ctptMatRcptDays, _mtrBoxMatRcptDays, _jumprMatRcptDays]);
	}
	get purMatRcptDaysTip(): string {
		let _tmpCTPTRequestDate: Date = this.ctPTRequestedReceiptDate
		let _tmpCTPTActualDate: Date = this.ctPTActualReceiptDate
		let _tmpMtrBoxRequestDate: Date = this.meteringBoxRequestedReceiptDate
		let _tmpMtrBoxActualDate: Date = this.meteringBoxActualReceiptDate
		let _tmpJmprRequestDate: Date = this.jumperRequestedReceiptDate
		let _tmpJmprActualDate: Date = this.jumperActualReceiptDate
		let _ctptMatRcptDays: number = configDefs.getDaysDifference(this.ctPTRequestedReceiptDate, this.ctPTActualReceiptDate);
		let _mtrBoxMatRcptDays: number = configDefs.getDaysDifference(this.meteringBoxRequestedReceiptDate, this.meteringBoxActualReceiptDate);
		let _jumprMatRcptDays: number = configDefs.getDaysDifference(this.jumperRequestedReceiptDate, this.jumperActualReceiptDate);
		if (_ctptMatRcptDays || _mtrBoxMatRcptDays || _jumprMatRcptDays) {
			return 'CT/PT Receipt Date : \r\n' +
				'\tRequest\t> ' + moment(_tmpCTPTRequestDate).format(configDefs.dateFormat) + '\r\n' +
				'\tActual\t> ' + moment(_tmpCTPTActualDate).format(configDefs.dateFormat) + '\r\n' +
				'\tDiff Days\t> ' + _ctptMatRcptDays + '\r\n\n' +
				'Metering Box Receipt Date : \r\n' +
				'\tRequest\t> ' + moment(_tmpMtrBoxRequestDate).format(configDefs.dateFormat) + '\r\n' +
				'\tActual\t> ' + moment(_tmpMtrBoxActualDate).format(configDefs.dateFormat) + '\r\n' +
				'\tDiff Days\t> ' + _mtrBoxMatRcptDays + '\r\n\n' +
				'Jumper Receipt Date : \r\n' +
				'\tRequest\t> ' + moment(_tmpJmprRequestDate).format(configDefs.dateFormat) + '\r\n' +
				'\tActual\t> ' + moment(_tmpJmprActualDate).format(configDefs.dateFormat) + '\r\n' +
				'\tDiff Days\t> ' + _jumprMatRcptDays;
		}
		return '';
	}

	// STARTS
	get relayRecpDate(): string {
		let _relrpctDate: Date = this.relayActualReceiptDate;

		if (_relrpctDate != null) {

			return formatDate(_relrpctDate, 'dd-MMM-yy', 'en-IN');
		}
		return null;
	}

	get ctRecpDateStatus(): string {
		let _ctrpctFirstDate: Date = this.ctPTActualReceiptFirstDate;
		let _ctrpctLastDate: Date = this.ctPTActualReceiptDate;

		if (_ctrpctFirstDate != null) {
			if (_ctrpctLastDate != null) {

				return "green"; // Last Date	
			}
			else return "yellow"; // First Date
		}
		else {
			if (_ctrpctLastDate != null) {

				return "green"; // Last Date	
			}
		}

		// return null;
	}

	get ctRecpDate(): string {
		let _ctrpctFirstDate: Date = this.ctPTActualReceiptFirstDate;
		let _ctrpctLastDate: Date = this.ctPTActualReceiptDate;

		if (_ctrpctFirstDate != null) {

			return formatDate(_ctrpctFirstDate, 'dd-MMM-yy', 'en-IN');
		}
		else if (_ctrpctLastDate != null) {

			return formatDate(_ctrpctLastDate, 'dd-MMM-yy', 'en-IN');
		}
		return null;
	}

	get mbRecpDate(): string {
		let _mbrpctDate: Date = this.meteringBoxActualReceiptDate;

		if (_mbrpctDate != null) {

			return formatDate(_mbrpctDate, 'dd-MMM-yy', 'en-IN');
		}
		return null;

	}

	get mbRecpDateStatus(): string {
		// this is to conditionally format the colour of the cell in the table
		// let _mbrpctStatus:boolean = this.meteringBoxPlannedReceiptDate_Enable;
		let _mbrpctStatus: string = this.parentSubSORef.planningIP.manufacturingStrategy;
		let _mbVal: string;

		switch (_mbrpctStatus) {
			case "inhouse":
			case null:
				_mbVal = "Applicable";
				break;
			case "boughtout":
				_mbVal = "NA";
				break;
		}

		return _mbVal;
	}

	get cbRecpDate(): string {
		let _cbrpctDate: Date = this.breakerActualReceiptDate;

		if (_cbrpctDate != null) {

			return formatDate(_cbrpctDate, 'dd-MMM-yy', 'en-IN');
		}
		return null;
	}

	get ctRecpApplicablity(): boolean {
		let _applic = this.ctApplicability;
		if (!_applic || _applic == "001") {
			return true;
		}
		return false;
	}
	// ENDS

	cloneSelf() {
		return new PurchaseMaterialReceiptIP(this._importedBreakerPlannedReceiptToken.cloneSelf(), configDefs.cloneDt(this.importedBreakerRequestedReceiptDate),
			configDefs.cloneDt(this._importedBreakerSupplierCommittedDate), this._importedBreakerActualReceiptToken.cloneSelf(), this._importedVSCPlannedReceiptToken.cloneSelf(),
			configDefs.cloneDt(this._importedVSCRequestedReceiptDate), configDefs.cloneDt(this._importedVSCSupplierCommittedDate), this._importedVSCActualReceiptToken.cloneSelf(),
			this._geRelayPlannedReceiptToken.cloneSelf(), configDefs.cloneDt(this._geRelayRequestedReceiptDate), configDefs.cloneDt(this._geRelaySupplierCommittedDate),
			this._geRelayActualReceiptToken.cloneSelf(), this._ctPTPlannedReceiptToken.cloneSelf(), configDefs.cloneDt(this._ctPTRequestedReceiptDate),
			configDefs.cloneDt(this._ctPTSupplierCommittedDate), this._ctPTActualReceiptToken.cloneSelf(), configDefs.cloneDt(this._ctPTActualReceiptFirstDate), this.ctApplicability,
			this._ctptPoNo, this._relayPoNo, this._breakerPoNo, this._saPoNo, this._meteringBoxPoNo, this._relayPlannedReceiptToken.cloneSelf(),
			configDefs.cloneDt(this._relayRequestedReceiptDate), configDefs.cloneDt(this._relaySupplierCommittedDate), this._relayActualReceiptToken.cloneSelf(),
			this._breakerPlannedReceiptToken.cloneSelf(), configDefs.cloneDt(this._breakerRequestedReceiptDate), configDefs.cloneDt(this._breakerSupplierCommittedDate),
			this._breakerActualReceiptToken.cloneSelf(), this.breakerApplicability, this._jumperPlannedReceiptToken.cloneSelf(), configDefs.cloneDt(this._jumperRequestedReceiptDate),
			configDefs.cloneDt(this._jumperSupplierCommittedDate), this._jumperActualReceiptToken.cloneSelf(), this._meteringBoxPlannedReceiptToken.cloneSelf(),
			configDefs.cloneDt(this._meteringBoxRequestedReceiptDate), configDefs.cloneDt(this._meteringBoxSupplierCommittedDate), this._meteringBoxActualReceiptToken.cloneSelf(), this.meteringBoxApplicability,
			this._saPlannedReceiptToken.cloneSelf(), configDefs.cloneDt(this._saRequestedReceiptDate), configDefs.cloneDt(this._saSupplierCommittedDate), this._saActualReceiptToken.cloneSelf(),
			this._broughtoutFabricationPlannedReceiptToken.cloneSelf(), configDefs.cloneDt(this._broughtoutFabricationRequestedReceiptDate), configDefs.cloneDt(this._broughtoutFabricationSupplierCommittedDate),
			this._broughtoutFabricationActualReceiptToken.cloneSelf(), this._inHouseFabricationPlannedReceiptToken.cloneSelf(), configDefs.cloneDt(this._inHouseFabricationRequestedReceiptDate),
			configDefs.cloneDt(this._inHouseFabricationSupplierCommittedDate), this._inHouseFabricationActualReceiptToken.cloneSelf(), this._status);
	}
	public static getObj(_json: any): PurchaseMaterialReceiptIP {
		return new PurchaseMaterialReceiptIP(convDefs.convToPlannedDateToken(_json.impBrkrPlanRcptToken), GenService.convToDate(_json.impBrkrReqRcptDate),
			GenService.convToDate(_json.impBrkrSupCmtedDate), convDefs.convToActualDateToken(_json.impBrkrActRcptToken), convDefs.convToPlannedDateToken(_json.impVSCPlanRcptToken),
			GenService.convToDate(_json.impVSCReqRcptDate), GenService.convToDate(_json.impVSCSupCmtedDate), convDefs.convToActualDateToken(_json.impVSCActRcptToken),
			convDefs.convToPlannedDateToken(_json.geRelayPlanRcptToken), GenService.convToDate(_json.geRelayReqRcptDate), GenService.convToDate(_json.geRelaySupCmtedDate),
			convDefs.convToActualDateToken(_json.geRelayActRcptToken), convDefs.convToPlannedDateToken(_json.ctPTPlanRcptToken), GenService.convToDate(_json.ctPTReqRcptDate),
			GenService.convToDate(_json.ctPTSupCmtedDate), convDefs.convToActualDateToken(_json.ctPTActRcptToken), GenService.convToDate(_json.ctPTFirstDate), _json.ctApplic,
			_json.ctptPoNo, _json.relayPoNo, _json.breakerPoNo, _json.saPoNo, _json.meteringBoxPoNo, convDefs.convToPlannedDateToken(_json.relayPlanRcptToken), GenService.convToDate(_json.relayReqRcptDate),
			GenService.convToDate(_json.relaySupCmtedDate), convDefs.convToActualDateToken(_json.relayActRcptToken), convDefs.convToPlannedDateToken(_json.brkrPlanRcptToken), GenService.convToDate(_json.brkrReqRcptDate),
			GenService.convToDate(_json.brkrSupCmtedDate), convDefs.convToActualDateToken(_json.brkrActRcptToken), _json.brkrApplic, convDefs.convToPlannedDateToken(_json.jumperPlanRcptToken), GenService.convToDate(_json.jumperReqRcptDate),
			GenService.convToDate(_json.jumperSupCmtedDate), convDefs.convToActualDateToken(_json.jumperActRcptToken), convDefs.convToPlannedDateToken(_json.mtringBoxPlanRcptToken), GenService.convToDate(_json.mtringBoxReqRcptDate),
			GenService.convToDate(_json.mtringBoxSupCmtedDate), convDefs.convToActualDateToken(_json.mtringBoxActRcptToken), _json.mtringBoxApplic, convDefs.convToPlannedDateToken(_json.saPlanRcptToken), GenService.convToDate(_json.saReqRcptDate),
			GenService.convToDate(_json.saSupCmtedDate), convDefs.convToActualDateToken(_json.saActRcptToken), convDefs.convToPlannedDateToken(_json.brgtoutFabPlanRcptToken), GenService.convToDate(_json.brgtoutFabReqRcptDate),
			GenService.convToDate(_json.brgtoutFabSupCmtedDate), convDefs.convToActualDateToken(_json.brgtoutFabActRcptToken),
			convDefs.convToPlannedDateToken(_json.inHouseFabPlanRcptToken), GenService.convToDate(_json.inHouseFabReqRcptDate),
			GenService.convToDate(_json.inHouseFabSupCmtedDate), convDefs.convToActualDateToken(_json.inHouseFabActRcptToken), _json.status);
	}
	public getJson(): any {
		let _json: any = {};

		_json.impBrkrPlanRcptToken = this.importedBreakerPlannedReceiptToken.getJson();
		_json.impBrkrReqRcptDate = GenService.convToDateNum(this.importedBreakerRequestedReceiptDate);
		_json.impBrkrSupCmtedDate = GenService.convToDateNum(this.importedBreakerSupplierCommittedDate);
		_json.impBrkrActRcptToken = this.importedBreakerActualReceiptToken.getJson();
		_json.impVSCPlanRcptToken = this.importedVSCPlannedReceiptToken.getJson();
		_json.impVSCReqRcptDate = GenService.convToDateNum(this.importedVSCRequestedReceiptDate);
		_json.impVSCSupCmtedDate = GenService.convToDateNum(this.importedVSCSupplierCommittedDate);
		_json.impVSCActRcptToken = this.importedVSCActualReceiptToken.getJson();
		_json.geRelayPlanRcptToken = this.geRelayPlannedReceiptToken.getJson();
		_json.geRelayReqRcptDate = GenService.convToDateNum(this.geRelayRequestedReceiptDate);
		_json.geRelaySupCmtedDate = GenService.convToDateNum(this.geRelaySupplierCommittedDate);
		_json.geRelayActRcptToken = this.geRelayActualReceiptToken.getJson();
		_json.ctPTFirstDate = GenService.convToDateNum(this.ctPTActualReceiptFirstDate);
		_json.ctPTPlanRcptToken = this.ctPTPlannedReceiptToken.getJson();
		_json.ctPTReqRcptDate = GenService.convToDateNum(this.ctPTRequestedReceiptDate);
		_json.ctPTSupCmtedDate = GenService.convToDateNum(this.ctPTSupplierCommittedDate);
		_json.ctPTActRcptToken = this.ctPTActualReceiptToken.getJson();
		_json.ctApplic = this.ctApplicability;
		_json.ctptPoNo = this.ctptPoNo;
		_json.relayPoNo = this.relayPoNo;
		_json.breakerPoNo = this.breakerPoNo;
		_json.saPoNo = this.saPoNo;
		_json.meteringBoxPoNo = this.meteringBoxPoNo;
		_json.relayPlanRcptToken = this.relayPlannedReceiptToken.getJson();
		_json.relayReqRcptDate = GenService.convToDateNum(this.relayRequestedReceiptDate);
		_json.relaySupCmtedDate = GenService.convToDateNum(this.relaySupplierCommittedDate);
		_json.relayActRcptToken = this.relayActualReceiptToken.getJson();
		_json.brkrPlanRcptToken = this.breakerPlannedReceiptToken.getJson();
		_json.brkrReqRcptDate = GenService.convToDateNum(this.breakerRequestedReceiptDate);
		_json.brkrSupCmtedDate = GenService.convToDateNum(this.breakerSupplierCommittedDate);
		_json.brkrActRcptToken = this.breakerActualReceiptToken.getJson();
		_json.brkrApplic = this.breakerApplicability;
		_json.jumperPlanRcptToken = this.jumperPlannedReceiptToken.getJson();
		_json.jumperReqRcptDate = GenService.convToDateNum(this.jumperRequestedReceiptDate);
		_json.jumperSupCmtedDate = GenService.convToDateNum(this.jumperSupplierCommittedDate);
		_json.jumperActRcptToken = this.jumperActualReceiptToken.getJson();
		_json.mtringBoxPlanRcptToken = this.meteringBoxPlannedReceiptToken.getJson();
		_json.mtringBoxReqRcptDate = GenService.convToDateNum(this.meteringBoxRequestedReceiptDate);
		_json.mtringBoxSupCmtedDate = GenService.convToDateNum(this.meteringBoxSupplierCommittedDate);
		_json.mtringBoxActRcptToken = this.meteringBoxActualReceiptToken.getJson();
		_json.mtringBoxApplic = this.meteringBoxApplicability;
		_json.saPlanRcptToken = this.saPlannedReceiptToken.getJson();
		_json.saReqRcptDate = GenService.convToDateNum(this.saRequestedReceiptDate);
		_json.saSupCmtedDate = GenService.convToDateNum(this.saSupplierCommittedDate);
		_json.saActRcptToken = this.saActualReceiptToken.getJson();
		_json.brgtoutFabPlanRcptToken = this.broughtoutFabricationPlannedReceiptToken.getJson();
		_json.brgtoutFabReqRcptDate = GenService.convToDateNum(this.broughtoutFabricationRequestedReceiptDate);
		_json.brgtoutFabSupCmtedDate = GenService.convToDateNum(this.broughtoutFabricationSupplierCommittedDate);
		_json.brgtoutFabActRcptToken = this.broughtoutFabricationActualReceiptToken.getJson();

		_json.inHouseFabPlanRcptToken = this.inHouseFabricationPlannedReceiptToken.getJson();
		_json.inHouseFabReqRcptDate = GenService.convToDateNum(this.inHouseFabricationRequestedReceiptDate);
		_json.inHouseFabSupCmtedDate = GenService.convToDateNum(this.inHouseFabricationSupplierCommittedDate);
		_json.inHouseFabActRcptToken = this.inHouseFabricationActualReceiptToken.getJson();
		_json.status = this.status;

		return _json;
	}
}

export class StoreIP {
	constructor(private _materialIssueToLinePlannedToken: PlannedDateToken, private _materialIssueToLineRequestLineLodingDate: Date, private _materialIssueToLineActualToken: ActualDateToken,
		private _looseMaterialIssueToDispatchPlannedToken: PlannedDateToken, private _looseMaterialIssueToDispatchRequestToken: RequestDateToken, private _looseMaterialIssueToDispatchActualToken: ActualDateToken,
		private _pickListFiles: GenFileUploads, private _sparePickListFiles: GenFileUploads, private _status: FunctionStatus) {
	}
	private _parentSORef: SalesOrder;
	private _parentSubSORef: SubSalesOrder;
	refreshStatus() {
		if (this.parentSORef && this.parentSubSORef && this.parentSORef.projectStatus >= SOStatus.Sub_Orders) {
			if (this.parentSubSORef.isSSOStatusSet(SSOStatus.Store) == true) {
				if (this.parentSubSORef.isSSOStatusSet(SSOStatus.Production_From_Store) == true) {

					let _isTempComplete: boolean = this.isFunctionComplete();

					if (_isTempComplete == true) {
						this._status = FunctionStatus.SUBMITTED_COMPLETE;
					}
					else {
						this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
					}
				}
				else {
					this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
				}
			}
			else {
				this._status = FunctionStatus.WAITING_FOR_PREV;
			}
		}
		else {
			this._status = FunctionStatus.WAITING_FOR_PREV;
		}
	}
	private isFunctionComplete(): boolean {
		if (this.parentSubSORef.planningIP.manufacturingStrategyInhouse_Enable) {
			if (configDefs.isDtEmty(this.materialIssueToLinePlannedDate)) return false;
			if (configDefs.isDtEmty(this.materialIssueToLineRequestLineLodingDate)) return false;
			if (configDefs.isDtEmty(this.materialIssueToLineActualDate)) return false;
		}


		//if(configDefs.isDtEmty(this.pick)) return false;
		if (configDefs.isDtEmty(this.looseMaterialIssueToDispatchPlannedDate)) return false;
		if (configDefs.isDtEmty(this.looseMaterialIssueToDispatchRequestDate)) return false;
		if (configDefs.isDtEmty(this.looseMaterialIssueToDispatchActualDate)) return false;

		return true;
	}
	get isProjectLive(): boolean {
		return this.parentSubSORef.pmTechSubSalesOrder.projStatus == "live";
	}
	get isInputEnabled(): boolean {
		return this.parentSubSORef.isSSOStatusSet(SSOStatus.Store) || this.parentSubSORef.isSSOStatusSet(SSOStatus.Store_From_MaterialReceipt)
	}
	get parentSORef(): SalesOrder {
		return this._parentSORef;
	}
	set parentSORef(SORef: SalesOrder) {
		this._parentSORef = SORef;
		//this.refreshStatus();
	}
	get parentSubSORef(): SubSalesOrder {
		return this._parentSubSORef;
	}
	set parentSubSORef(SubSORef: SubSalesOrder) {
		this._parentSubSORef = SubSORef;
	}
	get status(): FunctionStatus {
		return this._status;
	}
	get isProductionSubmitted(): boolean {
		return this.parentSubSORef.isSSOStatusSet(SSOStatus.Production_From_Store);
	}
	get readyForProduction(): boolean {
		return true;
	}

	enableFormInput(): void {
		if (this._status == FunctionStatus.WAITING_FOR_PREV) {
			this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
		}
	}
	get manufacturingStrategyInhouse_Enable(): boolean {
		return this.parentSubSORef.planningIP.manufacturingStrategyInhouse_Enable;
	}
	get materialIssueToLinePlannedToken(): PlannedDateToken {
		return this._materialIssueToLinePlannedToken;
	}
	set materialIssueToLinePlannedToken(_SetVal: PlannedDateToken) {
		// if (this._materialIssueToLinePlannedToken.actualPlannedDate == null)
		// 	this._materialIssueToLinePlannedToken.actualPlannedDate = this.materialIssueToLinePlannedDate;
		this._materialIssueToLinePlannedToken.plannedDate = _SetVal.plannedDate;
		this._materialIssueToLinePlannedToken.isOveridden = _SetVal.isOveridden;
		this._materialIssueToLinePlannedToken.addNotes = _SetVal.addNotes;
		this._materialIssueToLinePlannedToken.userOveridden = _SetVal.userOveridden;
	}
	//checkhere


	get materialIssueToLinePlannedDateLabel(): string {
		if (this.materialIssueToLinePlannedDateIsRevised == true) {
			return "Revised (Planned) Date"
		}
		else {
			return "Planned Date"
		}
	}
	get materialIssueToLinePlannedDateIsRevised(): boolean {
		if (this.materialIssueToLinePlannedDate_Initial && this.materialIssueToLinePlannedDate) {
			if (GenService.areDatesSame(this.materialIssueToLinePlannedDate_Initial, this.materialIssueToLinePlannedDate) == false) {
				return true;
			}
		}
		return false;
	}
	get materialIssueToLinePlannedDate_Initial(): Date {
		if (this._materialIssueToLinePlannedToken.actualPlannedDate == null || this._materialIssueToLinePlannedToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.planningIP.plannedPickListIssueToStoreDate_Initial;
			if (_tmpDate != null && configDefs.defPlndMatIsuToLineDays) {
				this._materialIssueToLinePlannedToken.actualPlannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndMatIsuToLineDays);
			}
			else {
				this._materialIssueToLinePlannedToken.actualPlannedDate = null;
			}
		}
		return this._materialIssueToLinePlannedToken.actualPlannedDate;
	}
	get materialIssueToLinePlannedDate(): Date {
		if (this._materialIssueToLinePlannedToken.plannedDate == null || this._materialIssueToLinePlannedToken.isOveridden == false) {
			// var _tmpDate = this.parentSubSORef.planningIP.actualPickListIssueToStoreDate;
			// if (_tmpDate == null){
			var _tmpDate = this.parentSubSORef.planningIP.plannedPickListIssueToStoreDate;

			//}
			if (_tmpDate != null && configDefs.defPlndMatIsuToLineDays) {
				this._materialIssueToLinePlannedToken.plannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndMatIsuToLineDays);
			}
			else {
				this._materialIssueToLinePlannedToken.plannedDate = null;
			}
		}
		return this._materialIssueToLinePlannedToken.plannedDate;
	}
	private _materialIssueToLinePlannedGroup: RevisedDate;
	get materialIssueToLinePlannedGroup(): RevisedDate {
		this._materialIssueToLinePlannedGroup = new RevisedDate(this.materialIssueToLinePlannedDate_Initial, this.materialIssueToLinePlannedDateIsRevised, this.materialIssueToLinePlannedDate);

		return this._materialIssueToLinePlannedGroup;
	}
	set materialIssueToLinePlannedDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set materialIssueToLinePlannedDate directly");
		this._materialIssueToLinePlannedToken.plannedDate = _SetVal;
	}
	get materialIssueToLineRequestLineLodingDate(): Date {
		//if(this._materialIssueToLineRequestLineLodingDate == null ){
		//var _tmpDate = this.parentSubSORef.planningIP.requestedPickListIssueToStoreDate;
		var _tmpDate = this.parentSubSORef.planningIP.actualPickListIssueToStoreDate;
		if (_tmpDate == null) {
			_tmpDate = this.parentSubSORef.planningIP.requestedPickListIssueToStoreDate;
		}
		if (_tmpDate != null && configDefs.defReqMatIsuToLineDays) {
			this._materialIssueToLineRequestLineLodingDate = configDefs.addWorkingDays(_tmpDate, configDefs.defReqMatIsuToLineDays);
		}
		else {
			this._materialIssueToLineRequestLineLodingDate = null;
		}
		//}

		return this._materialIssueToLineRequestLineLodingDate;
	}
	set materialIssueToLineRequestLineLodingDate(_SetVal: Date) {
		this._materialIssueToLineRequestLineLodingDate = _SetVal;
	}
	get materialIssueToLineActualToken(): ActualDateToken {
		return this._materialIssueToLineActualToken;
	}
	set materialIssueToLineActualToken(_SetVal: ActualDateToken) {
		if (this._materialIssueToLineActualToken.expActualDate == null)
			this._materialIssueToLineActualToken.expActualDate = this.materialIssueToLineActualDate;
		this._materialIssueToLineActualToken.actualDate = _SetVal.actualDate;
		this._materialIssueToLineActualToken.isOveridden = _SetVal.isOveridden;
		this._materialIssueToLineActualToken.addNotes = _SetVal.addNotes;
		this._materialIssueToLineActualToken.userOveridden = _SetVal.userOveridden;
	}
	get materialIssueToLineActualDate(): Date {
		return this._materialIssueToLineActualToken.actualDate;
	}
	set materialIssueToLineActualDate(_SetVal: Date) {
		console.log('wrong execution, materialIssueToLineActualDate');
		this._materialIssueToLineActualToken.actualDate = _SetVal;
	}
	get looseMaterialIssueToDispatchPlannedToken(): PlannedDateToken {
		return this._looseMaterialIssueToDispatchPlannedToken;
	}
	set looseMaterialIssueToDispatchPlannedToken(_SetVal: PlannedDateToken) {
		if (this._looseMaterialIssueToDispatchPlannedToken.actualPlannedDate == null)
			this._looseMaterialIssueToDispatchPlannedToken.actualPlannedDate = this.looseMaterialIssueToDispatchPlannedDate;
		this._looseMaterialIssueToDispatchPlannedToken.plannedDate = _SetVal.plannedDate;
		this._looseMaterialIssueToDispatchPlannedToken.isOveridden = _SetVal.isOveridden;
		this._looseMaterialIssueToDispatchPlannedToken.addNotes = _SetVal.addNotes;
		this._looseMaterialIssueToDispatchPlannedToken.userOveridden = _SetVal.userOveridden;
	}
	get looseMaterialIssueToDispatchPlannedDateLabel(): string {
		if (this.looseMaterialIssueToDispatchPlannedDateIsRevised == true) {
			return "Revised (Planned) Receipt Date"
		} else {
			return "Planned Date"
		}
	}
	get looseMaterialIssueToDispatchPlannedDateIsRevised(): boolean {
		//    return this.parentSubSORef.pmTechSubSalesOrder.actualPackingDate != null;
		if (this.parentSubSORef.pmTechSubSalesOrder.plannedPackingDisptachClearanceDate_Initial && this.parentSubSORef.pmTechSubSalesOrder.plannedPackingDisptachClearanceDate) {
			if (GenService.areDatesSame(this.parentSubSORef.pmTechSubSalesOrder.plannedPackingDisptachClearanceDate,
				this.parentSubSORef.pmTechSubSalesOrder.plannedPackingDisptachClearanceDate_Initial) == false) {
				return true;
			}
		}
		return false;
	}
	get looseMaterialIssueToDispatchPlannedDate_initial(): Date {
		if (this._looseMaterialIssueToDispatchPlannedToken.actualPlannedDate == null || this._looseMaterialIssueToDispatchPlannedToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.pmTechSubSalesOrder.plannedPackingDisptachClearanceDate_Initial;
			if (_tmpDate != null && configDefs.defPlndLooseMatIsuToDisp) {
				this._looseMaterialIssueToDispatchPlannedToken.actualPlannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndLooseMatIsuToDisp);
			}
			else {
				this._looseMaterialIssueToDispatchPlannedToken.actualPlannedDate = null;
			}
		}
		return this._looseMaterialIssueToDispatchPlannedToken.actualPlannedDate;
	}
	get looseMaterialIssueToDispatchPlannedDate(): Date {
		if (this._looseMaterialIssueToDispatchPlannedToken.plannedDate == null || this._looseMaterialIssueToDispatchPlannedToken.isOveridden == false) {
			// var _tmpDate = this.parentSubSORef.pmTechSubSalesOrder.actualPackingDate;
			// if(_tmpDate==null){
			var _tmpDate = this.parentSubSORef.pmTechSubSalesOrder.plannedPackingDisptachClearanceDate;
			// }
			if (_tmpDate != null && configDefs.defPlndLooseMatIsuToDisp) {
				this._looseMaterialIssueToDispatchPlannedToken.plannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndLooseMatIsuToDisp);
			}
			else {
				this._looseMaterialIssueToDispatchPlannedToken.plannedDate = null;
			}
		}
		return this._looseMaterialIssueToDispatchPlannedToken.plannedDate;
	}
	private _looseMaterialIssueToDispatchPlannedGroup: RevisedDate;
	get looseMaterialIssueToDispatchPlannedGroup(): RevisedDate {
		this._looseMaterialIssueToDispatchPlannedGroup = new RevisedDate(this.looseMaterialIssueToDispatchPlannedDate_initial, this.looseMaterialIssueToDispatchPlannedDateIsRevised, this.looseMaterialIssueToDispatchPlannedDate);

		return this._looseMaterialIssueToDispatchPlannedGroup;
	}
	set looseMaterialIssueToDispatchPlannedDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set looseMaterialIssueToDispatchPlannedDate directly");
		this._looseMaterialIssueToDispatchPlannedToken.plannedDate = _SetVal;
	}
	get looseMaterialIssueToDispatchRequestToken(): RequestDateToken {
		return this._looseMaterialIssueToDispatchRequestToken;
	}
	set looseMaterialIssueToDispatchRequestToken(_SetVal: RequestDateToken) {
		if (this._looseMaterialIssueToDispatchRequestToken.plndRequestDate == null)
			this._looseMaterialIssueToDispatchRequestToken.plndRequestDate = this.looseMaterialIssueToDispatchRequestDate;
		this._looseMaterialIssueToDispatchRequestToken.requestDate = _SetVal.requestDate;
		this._looseMaterialIssueToDispatchRequestToken.isOveridden = _SetVal.isOveridden;
		this._looseMaterialIssueToDispatchRequestToken.addNotes = _SetVal.addNotes;
		this._looseMaterialIssueToDispatchRequestToken.userOveridden = _SetVal.userOveridden;
	}
	get looseMaterialIssueToDispatchRequestDate(): Date {
		if (this._looseMaterialIssueToDispatchRequestToken.requestDate == null || this._looseMaterialIssueToDispatchRequestToken.isOveridden == false) {
			// var _tmpDate = this.parentSubSORef.pmTechSubSalesOrder.requestPackingDate;
			var _tmpDate = this.parentSubSORef.pmTechSubSalesOrder.actualPackingDate;
			if (_tmpDate == null) {
				_tmpDate = this.parentSubSORef.pmTechSubSalesOrder.requestPackingDate;
			}
			if (_tmpDate != null && configDefs.defReqLooseMatIsuToDisp) {
				this._looseMaterialIssueToDispatchRequestToken.requestDate = configDefs.addWorkingDays(_tmpDate, configDefs.defReqLooseMatIsuToDisp);
			}
			else {
				this._looseMaterialIssueToDispatchRequestToken.requestDate = null;
			}
		}
		return this._looseMaterialIssueToDispatchRequestToken.requestDate;
	}
	set looseMaterialIssueToDispatchRequestDate(_SetVal: Date) {
		console.log('wrong execution, looseMaterialIssueToDispatchRequestDate');
		this._looseMaterialIssueToDispatchRequestToken.requestDate = _SetVal;
	}
	get looseMaterialIssueToDispatchActualToken(): ActualDateToken {
		return this._looseMaterialIssueToDispatchActualToken;
	}
	set looseMaterialIssueToDispatchActualToken(_SetVal: ActualDateToken) {
		if (this._looseMaterialIssueToDispatchActualToken.expActualDate == null)
			this._looseMaterialIssueToDispatchActualToken.expActualDate = this.looseMaterialIssueToDispatchActualDate;
		this._looseMaterialIssueToDispatchActualToken.actualDate = _SetVal.actualDate;
		this._looseMaterialIssueToDispatchActualToken.isOveridden = _SetVal.isOveridden;
		this._looseMaterialIssueToDispatchActualToken.addNotes = _SetVal.addNotes;
		this._looseMaterialIssueToDispatchActualToken.userOveridden = _SetVal.userOveridden;
	}
	get looseMaterialIssueToDispatchActualDate(): Date {
		return this._looseMaterialIssueToDispatchActualToken.actualDate;
	}
	set looseMaterialIssueToDispatchActualDate(_SetVal: Date) {
		console.log('wrong execution, looseMaterialIssueToDispatchActualDate')
		this._looseMaterialIssueToDispatchActualToken.actualDate = _SetVal;
	}
	get sparePickListFiles(): GenFileUploads {
		return this._sparePickListFiles;
	}
	set sparePickListFiles(_SetVal: GenFileUploads) {
		this._sparePickListFiles = _SetVal;
	}
	get pickListFiles(): GenFileUploads {
		return this._pickListFiles;
	}
	set pickListFiles(_SetVal: GenFileUploads) {
		this._pickListFiles = _SetVal;
	}
	get storeDays(): number {
		return configDefs.getDaysDifference(this.looseMaterialIssueToDispatchRequestDate, this.looseMaterialIssueToDispatchActualDate);
	}
	get storeDaysTip(): string {
		let _tmpRequestDate: Date = this.looseMaterialIssueToDispatchRequestDate
		let _tmpActualDate: Date = this.looseMaterialIssueToDispatchActualDate
		if (_tmpRequestDate && _tmpActualDate) {
			return 'Loose Material Issue to Dispatch Date : \r\n' +
				'\tRequest\t> ' + moment(_tmpRequestDate).format(configDefs.dateFormat) + '\r\n' +
				'\tActual\t> ' + moment(_tmpActualDate).format(configDefs.dateFormat);
		}
		return '';
	}
	cloneSelf() {
		return new StoreIP(this._materialIssueToLinePlannedToken.cloneSelf(), configDefs.cloneDt(this.materialIssueToLineRequestLineLodingDate),
			this._materialIssueToLineActualToken.cloneSelf(), this._looseMaterialIssueToDispatchPlannedToken.cloneSelf(),
			this._looseMaterialIssueToDispatchRequestToken.cloneSelf(), this._looseMaterialIssueToDispatchActualToken.cloneSelf(),
			this._pickListFiles.cloneSelf(), this._sparePickListFiles.cloneSelf(), this._status);
	}
	public static getObj(_json: any): StoreIP {
		return new StoreIP(convDefs.convToPlannedDateToken(_json.matIssueLinePlanToken), GenService.convToDate(_json.matIssueLineLoadDate), convDefs.convToActualDateToken(_json.matIssueLineActToken),
			convDefs.convToPlannedDateToken(_json.looseMatIssueDispPlanToken), RequestDateToken.getObj(_json.looseMatIssueDispReqToken),
			convDefs.convToActualDateToken(_json.looseMatIssueDispActToken), GenFileUploads.getObj(_json.pickListFiles),
			GenFileUploads.getObj(_json.sparePickListFiles), _json.status);
	}
	public getJson(): any {
		let _json: any = {};

		_json.matIssueLinePlanToken = this._materialIssueToLinePlannedToken.getJson();
		_json.matIssueLineLoadDate = GenService.convToDateNum(this.materialIssueToLineRequestLineLodingDate);
		_json.matIssueLineActToken = this.materialIssueToLineActualToken.getJson();
		_json.looseMatIssueDispPlanToken = this.looseMaterialIssueToDispatchPlannedToken.getJson();
		_json.looseMatIssueDispReqToken = this.looseMaterialIssueToDispatchRequestToken.getJson();
		_json.looseMatIssueDispActToken = this.looseMaterialIssueToDispatchActualToken.getJson();
		_json.pickListFiles = this.pickListFiles.getJson();
		_json.sparePickListFiles = this.sparePickListFiles.getJson();
		_json.status = this.status;

		return _json;
	}
}
export class ProductionIP {
	constructor(private _lineLoadingActualToken: ActualDateToken, private _mechanicalStickerPlannedToken: PlannedDateToken, private _mechanicalStickerRequestedToken: RequestDateToken,
		private _mechanicalStickerActualToken: ActualDateToken, private _status: FunctionStatus) {
	}
	private _parentSORef: SalesOrder;
	private _parentSubSORef: SubSalesOrder;
	refreshStatus() {
		if (this.parentSORef && this.parentSubSORef && this.parentSORef.projectStatus >= SOStatus.Sub_Orders) {
			if (this.parentSubSORef.isSSOStatusSet(SSOStatus.Production) == true) {
				if (this.parentSubSORef.isSSOStatusSet(SSOStatus.Quality) == true) {

					let _isTempComplete: boolean = this.isFunctionComplete();

					if (_isTempComplete == true) {
						this._status = FunctionStatus.SUBMITTED_COMPLETE;
					}
					else {
						this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
					}
				}
				else if ((configDefs.isDtEmty(this.lineLoadingActualDate) == false) && (configDefs.isDtEmty(this.mechanicalStickerActualDate) == true)) {
					this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
				}
				else {
					this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
				}
			}
			else {
				this._status = FunctionStatus.WAITING_FOR_PREV;
			}
		}
		else {
			this._status = FunctionStatus.WAITING_FOR_PREV;
		}
	}
	private isFunctionComplete(): boolean {
		if (configDefs.isDtEmty(this.lineLoadingActualDate)) return false;
		if (configDefs.isDtEmty(this.mechanicalStickerPlannedDate)) return false;
		if (configDefs.isDtEmty(this.mechanicalStickerRequestedDate)) return false;
		if (configDefs.isDtEmty(this.mechanicalStickerActualDate)) return false;

		return true;
	}
	get isProjectLive(): boolean {
		return this.parentSubSORef.pmTechSubSalesOrder.projStatus == "live";
	}
	get isInputEnabled(): boolean {
		return this.parentSubSORef.isSSOStatusSet(SSOStatus.Production) || this.parentSubSORef.isSSOStatusSet(SSOStatus.Production_From_Store)
	}
	get isSubmittedtoQuality(): boolean {
		return this.parentSubSORef.isSSOStatusSet(SSOStatus.Quality);
	}
	get readyForQuality(): boolean {
		if (this.mechanicalStickerActualDate) return true;
		return false;
	}
	get parentSORef(): SalesOrder {
		return this._parentSORef;
	}
	set parentSORef(SORef: SalesOrder) {
		this._parentSORef = SORef;
		//this.refreshStatus();
	}
	get parentSubSORef(): SubSalesOrder {
		return this._parentSubSORef;
	}
	set parentSubSORef(SubSORef: SubSalesOrder) {
		this._parentSubSORef = SubSORef;
	}
	get status(): FunctionStatus {
		return this._status;
	}
	enableFormInput(): void {
		if (this._status == FunctionStatus.WAITING_FOR_PREV) {
			this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
		}
	}
	get MechanicalStickerLabel(): string {
		if (this.manufacturingStrategyInhouse_Enable == true)
			return '(inHouse)';
		else
			return '(Vendor)';
	}
	get manufacturingStrategyInhouse_Enable(): boolean {
		return this.parentSubSORef.planningIP.manufacturingStrategyInhouse_Enable;
	}
	get lineLoadingActualDate(): Date {
		return this._lineLoadingActualToken.actualDate;
	}
	set lineLoadingActualDate(_SetVal: Date) {
		console.log('wrong execution, lineLoadingActualDate');
		this._lineLoadingActualToken.actualDate = _SetVal;
	}
	get lineLoadingActualToken(): ActualDateToken {
		return this._lineLoadingActualToken;
	}
	set lineLoadingActualToken(_SetVal: ActualDateToken) {
		if (this._lineLoadingActualToken.expActualDate == null)
			this._lineLoadingActualToken.expActualDate = this.parentSubSORef.planningIP.requestedLineLoadingDate;
		this._lineLoadingActualToken.actualDate = _SetVal.actualDate;
		this._lineLoadingActualToken.isOveridden = _SetVal.isOveridden;
		this._lineLoadingActualToken.addNotes = _SetVal.addNotes;
		this._lineLoadingActualToken.userOveridden = _SetVal.userOveridden;
	}
	get requestedLineLoadingDate(): Date {
		return this.parentSubSORef.planningIP.requestedLineLoadingDate;
	}
	get mechanicalStickerPlannedToken(): PlannedDateToken {
		return this._mechanicalStickerPlannedToken;
	}
	set mechanicalStickerPlannedToken(_SetVal: PlannedDateToken) {
		// if (this._mechanicalStickerPlannedToken.actualPlannedDate == null)
		// 	this._mechanicalStickerPlannedToken.actualPlannedDate = this.mechanicalStickerPlannedDate;
		this._mechanicalStickerPlannedToken.plannedDate = _SetVal.plannedDate;
		this._mechanicalStickerPlannedToken.isOveridden = _SetVal.isOveridden;
		this._mechanicalStickerPlannedToken.addNotes = _SetVal.addNotes;
		this._mechanicalStickerPlannedToken.userOveridden = _SetVal.userOveridden;
	}
	get mechanicalStickerPlannedDateLabel(): string {
		if (this.mechanicalStickerPlannedDateIsRevised == true) {
			return "Revised (Planned) Date"
		}
		else {
			return "Planned Date"
		}
	}
	get mechanicalStickerPlannedDateIsRevised(): boolean {
		if (this.mechanicalStickerPlannedDate_Initial && this.mechanicalStickerPlannedDate) {
			if (GenService.areDatesSame(this.mechanicalStickerPlannedDate_Initial, this.mechanicalStickerPlannedDate) == false) {
				return true;
			}
		}
		return false;
	}
	get mechanicalStickerPlannedDate_Initial(): Date {
		if (this._mechanicalStickerPlannedToken.actualPlannedDate == null || this._mechanicalStickerPlannedToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.planningIP.plannedLineLoadingDate_Initial;
			if (_tmpDate != null && configDefs.defPlndMechStikrDays) {
				this._mechanicalStickerPlannedToken.actualPlannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndMechStikrDays);
			}
			else {
				this._mechanicalStickerPlannedToken.actualPlannedDate = null;
			}
		}
		return this._mechanicalStickerPlannedToken.actualPlannedDate;
	}
	get mechanicalStickerPlannedDate(): Date {
		if (this._mechanicalStickerPlannedToken.plannedDate == null || this._mechanicalStickerPlannedToken.isOveridden == false) {
			// var _tmpDate = this.lineLoadingActualDate;
			// if(_tmpDate == null){
			var _tmpDate = this.parentSubSORef.planningIP.plannedLineLoadingDate;
			//}
			if (_tmpDate != null && configDefs.defPlndMechStikrDays) {
				this._mechanicalStickerPlannedToken.plannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndMechStikrDays);
			}
			else {
				this._mechanicalStickerPlannedToken.plannedDate = null;
			}
		}
		return this._mechanicalStickerPlannedToken.plannedDate;
	}
	private _mechanicalStickerPlannedGroup: RevisedDate;
	get mechanicalStickerPlannedGroup(): RevisedDate {
		this._mechanicalStickerPlannedGroup = new RevisedDate(this.mechanicalStickerPlannedDate_Initial, this.mechanicalStickerPlannedDateIsRevised, this.mechanicalStickerPlannedDate);

		return this._mechanicalStickerPlannedGroup;
	}
	set mechanicalStickerPlannedDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set mechanicalStickerPlannedDate directly");
		this._mechanicalStickerPlannedToken.plannedDate = _SetVal;
	}
	get mechanicalStickerRequestedToken(): RequestDateToken {
		return this._mechanicalStickerRequestedToken;
	}
	set mechanicalStickerRequestedToken(_SetVal: RequestDateToken) {
		if (this._mechanicalStickerRequestedToken.plndRequestDate == null)
			this._mechanicalStickerRequestedToken.plndRequestDate = this.mechanicalStickerRequestedDate;
		this._mechanicalStickerRequestedToken.requestDate = _SetVal.requestDate;
		this._mechanicalStickerRequestedToken.isOveridden = _SetVal.isOveridden;
		this._mechanicalStickerRequestedToken.addNotes = _SetVal.addNotes;
		this._mechanicalStickerRequestedToken.userOveridden = _SetVal.userOveridden;
	}
	get mechanicalStickerRequestedDate(): Date {
		if (this._mechanicalStickerRequestedToken.requestDate == null || this._mechanicalStickerRequestedToken.isOveridden == false) {
			var _tmpDate = this.lineLoadingActualDate;
			if (_tmpDate == null) {
				_tmpDate = this.parentSubSORef.planningIP.requestedLineLoadingDate
			}
			var _noOfDays: number = configDefs.defReqMechStikrDays;
			if (this.manufacturingStrategyInhouse_Enable == false) {
				_noOfDays = configDefs.defReqMechStikrDaysBoughtout;
			}
			if (_tmpDate != null && _noOfDays) {
				this._mechanicalStickerRequestedToken.requestDate = configDefs.addWorkingDays(_tmpDate, _noOfDays);
			}
			else {
				this._mechanicalStickerRequestedToken.requestDate = null;
			}
		}
		return this._mechanicalStickerRequestedToken.requestDate;
	}
	set mechanicalStickerRequestedDate(_SetVal: Date) {
		console.log('wrong execution, mechanicalStickerRequestedDate')
		this._mechanicalStickerRequestedToken.requestDate = _SetVal;
	}
	get mechanicalStickerActualToken(): ActualDateToken {
		return this._mechanicalStickerActualToken;
	}
	set mechanicalStickerActualToken(_SetVal: ActualDateToken) {
		if (this._mechanicalStickerActualToken.expActualDate == null)
			this._mechanicalStickerActualToken.expActualDate = this.mechanicalStickerActualDate;
		this._mechanicalStickerActualToken.actualDate = _SetVal.actualDate;
		this._mechanicalStickerActualToken.isOveridden = _SetVal.isOveridden;
		this._mechanicalStickerActualToken.addNotes = _SetVal.addNotes;
		this._mechanicalStickerActualToken.userOveridden = _SetVal.userOveridden;
	}
	get mechanicalStickerActualDate(): Date {
		return this._mechanicalStickerActualToken.actualDate;
	}
	set mechanicalStickerActualDate(_SetVal: Date) {
		console.log('wrong execution, mechanicalStickerActualDate');
		this._mechanicalStickerActualToken.actualDate = _SetVal;
	}
	get productionDays(): number {
		return configDefs.getDaysDifference(this.mechanicalStickerRequestedDate, this.mechanicalStickerActualDate);
	}
	get productionDaysTip(): string {
		let _tmpRequestDate: Date = this.mechanicalStickerRequestedDate
		let _tmpActualDate: Date = this.mechanicalStickerActualDate
		if (_tmpRequestDate && _tmpActualDate) {
			return 'Mechanical Sticker Date : \r\n' +
				'\tRequest\t> ' + moment(_tmpRequestDate).format(configDefs.dateFormat) + '\r\n' +
				'\tActual\t> ' + moment(_tmpActualDate).format(configDefs.dateFormat);
		}
		return '';
	}

	// STARTS
	get lineLoadActDate(): string {
		let _lineLdDate_planning: Date = this.parentSubSORef.planningIP.requestedLineLoadingDate;
		let _lineLdDate_prod: Date = this.lineLoadingActualDate;

		// if (_lineLdDate_planning == null) {
		// 	if (_lineLdDate_prod != null) {

		// 		return formatDate(_lineLdDate_prod, 'dd-MMM-yy', 'en-IN');
		// 	}
		// 	else
		// 		return null;
		// }
		// return formatDate(_lineLdDate_planning, 'dd-MMM-yy', 'en-IN');
		if (_lineLdDate_planning != null) {
			if (_lineLdDate_prod != null) {

				return formatDate(_lineLdDate_prod, 'dd-MMM-yy', 'en-IN');
			}
			else
				return formatDate(_lineLdDate_planning, 'dd-MMM-yy', 'en-IN');
		}
		else {
			if (_lineLdDate_prod != null) {
				return formatDate(_lineLdDate_prod, 'dd-MMM-yy', 'en-IN');
			}
			else
				return null;
		}

	}


	get lineLoadActDateStatus(): string {
		// this is to conditionally format the colour of the cell in the table
		let _lineLdDate_planning: Date = this.parentSubSORef.planningIP.requestedLineLoadingDate;
		let _lineLdDate_prod: Date = this.lineLoadingActualDate;

		if (_lineLdDate_planning != null) {
			if (_lineLdDate_prod != null) {

				return "green"; // Production	
			}
			else return "yellow"; // Planning
		}
		else {
			if (_lineLdDate_prod != null) {

				return "green"; // Production	
			}
		}
		// return null;
	}

	get mechStickerDate(): string {
		let _mchStkrDate: Date = this.mechanicalStickerActualDate;

		if (_mchStkrDate != null) {

			return formatDate(_mchStkrDate, 'dd-MMM-yy', 'en-IN');
		}
		return null;
	}

	// ENDS
	cloneSelf() {
		return new ProductionIP(this._lineLoadingActualToken.cloneSelf(), this._mechanicalStickerPlannedToken.cloneSelf(),
			this._mechanicalStickerRequestedToken.cloneSelf(), this._mechanicalStickerActualToken.cloneSelf(),
			this._status);
	}
	public static getObj(_json: any): ProductionIP {
		return new ProductionIP(convDefs.convToActualDateToken(_json.lineLoadActToken), convDefs.convToPlannedDateToken(_json.mechStkrPlanToken),
			RequestDateToken.getObj(_json.mechStkrReqToken), convDefs.convToActualDateToken(_json.mechStkrActToken), _json.status);
	}
	public getJson(): any {
		let _json: any = {};

		_json.lineLoadActToken = this.lineLoadingActualToken.getJson();
		_json.mechStkrPlanToken = this.mechanicalStickerPlannedToken.getJson();
		_json.mechStkrReqToken = this.mechanicalStickerRequestedToken.getJson();
		_json.mechStkrActToken = this.mechanicalStickerActualToken.cloneSelf();
		_json.status = this._status;

		return _json;
	}
}

export class QualityIP {
	constructor(private _mechanicalElectricalTestingPlannedToken: PlannedDateToken, private _mechanicalElectricalTestingRequestedToken: RequestDateToken, private _mechanicalElectricalTestingActualToken: ActualDateToken,
		private _fatPlannedToken: PlannedDateToken, private _fatRequestedToken: RequestDateToken, private _fatActualToken: ActualDateToken,
		private _greenStickerPlannedToken: PlannedDateToken, private _greenStickerRequestedToken: RequestDateToken, private _greenStickerActualToken: ActualDateToken,
		private _fileUploadsForTesting: GenFileUploads, private _finalRlyPrgFiles: GenFileUploads,
		private _mechTestEnggId: string, private _elecTestEnggId: string, private _status: FunctionStatus) {
	}
	private _parentSORef: SalesOrder;
	private _parentSubSORef: SubSalesOrder;
	refreshStatus() {
		if (this.parentSORef && this.parentSubSORef && this.parentSORef.projectStatus >= SOStatus.Sub_Orders) {
			if (this.parentSubSORef.isSSOStatusSet(SSOStatus.Quality) == true) {
				if (this.parentSubSORef.isSSOStatusSet(SSOStatus.Logistic) == true) {

					let _isTempComplete: boolean = this.isFunctionComplete();
					if (_isTempComplete == true) {
						this._status = FunctionStatus.SUBMITTED_COMPLETE;
					}
					// New
					// else if(this.fileUploadForTesting.FileArray.length <1){
					// 	this._status = FunctionStatus.RELAY_PENDING;
					// }
					// New end
					else {
						this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
					}
				}

				else {

					if ((configDefs.isDtEmty(this.mechanicalElectricalTestingActualDate)) && (configDefs.isDtEmty(this.greenStickerActualDate)) && (configDefs.isDtEmty(this.fatActualDate))) {
						this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
					}
					else if ((configDefs.isDtEmty(this.mechanicalElectricalTestingActualDate)) || (configDefs.isDtEmty(this.greenStickerActualDate)) || (configDefs.isDtEmty(this.fatActualDate))) {
						this._status = FunctionStatus.SUBMITTED_INCOMPLETE;

					}
					if ((configDefs.isDtEmty(this.mechanicalElectricalTestingActualDate) == false) && (configDefs.isDtEmty(this.greenStickerActualDate) == false) && (configDefs.isDtEmty(this.fatActualDate) == false)) {
						this._status = FunctionStatus.NOT_SUBMITTED_BUT_READY;
					}
					// New
					// if(this.fileUploadForTesting.FileArray.length <1){
					// 	this._status = FunctionStatus.RELAY_PENDING;
					// }
					// New end
					// else{
					// 	this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
					// }
				}
			}
			else if (this.fileUploadForTesting.FileArray.length < 1) {
				this._status = FunctionStatus.RELAY_PENDING;
			}
			else {
				this._status = FunctionStatus.WAITING_FOR_PREV;
			}
		}
		else {
			this._status = FunctionStatus.WAITING_FOR_PREV;
		}
	}
	private isFunctionComplete(): boolean {
		if (configDefs.isDtEmty(this.mechanicalElectricalTestingPlannedDate)) return false;
		if (configDefs.isDtEmty(this.mechanicalElectricalTestingRequestedDate)) return false;
		if (configDefs.isDtEmty(this.mechanicalElectricalTestingActualDate)) return false;
		if (configDefs.isDtEmty(this.fatPlannedDate)) return false;
		if (configDefs.isDtEmty(this.fatRequestedDate)) return false;
		if (configDefs.isDtEmty(this.fatActualDate)) return false;
		if (configDefs.isDtEmty(this.greenStickerPlannedDate)) return false;
		if (configDefs.isDtEmty(this.greenStickerRequestedDate)) return false;
		if (configDefs.isDtEmty(this.greenStickerActualDate)) return false;

		return true;
	}
	private islogiccomplet(): boolean {
		if (configDefs.isDtEmty(this.mechanicalElectricalTestingPlannedDate)) return false;
		if (configDefs.isDtEmty(this.mechanicalElectricalTestingRequestedDate)) return false;
		if (configDefs.isDtEmty(this.mechanicalElectricalTestingActualDate)) return true;
		if (configDefs.isDtEmty(this.fatPlannedDate)) return false;
		if (configDefs.isDtEmty(this.fatRequestedDate)) return false;
		if (configDefs.isDtEmty(this.fatActualDate)) return true;
		if (configDefs.isDtEmty(this.greenStickerPlannedDate)) return false;
		if (configDefs.isDtEmty(this.greenStickerRequestedDate)) return false;
		if (configDefs.isDtEmty(this.greenStickerActualDate)) return true;

		return true;
	}
	get isProjectLive(): boolean {
		return this.parentSubSORef.pmTechSubSalesOrder.projStatus == "live";
	}
	get isInputEnabled(): boolean {
		return this.parentSubSORef.isSSOStatusSet(SSOStatus.Quality);
	}
	get isSubmittedtoLogistics(): boolean {
		return this.parentSubSORef.isSSOStatusSet(SSOStatus.Logistic);
	}
	get readyForLogistic(): boolean {
		if (this.greenStickerActualDate) return true;
		return false;
	}
	get parentSORef(): SalesOrder {
		return this._parentSORef;
	}
	set parentSORef(SORef: SalesOrder) {
		this._parentSORef = SORef;
		//this.refreshStatus();
	}
	get parentSubSORef(): SubSalesOrder {
		return this._parentSubSORef;
	}
	set parentSubSORef(SubSORef: SubSalesOrder) {
		this._parentSubSORef = SubSORef;
	}
	enableFormInput(): void {
		if (this._status == FunctionStatus.WAITING_FOR_PREV) {
			this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
		}
	}
	get status(): FunctionStatus {
		return this._status;
	}

	get mechanicalElectricalTestingPlannedToken(): PlannedDateToken {
		return this._mechanicalElectricalTestingPlannedToken;
	}
	set mechanicalElectricalTestingPlannedToken(_SetVal: PlannedDateToken) {
		// if (this._mechanicalElectricalTestingPlannedToken.actualPlannedDate == null)
		// 	this._mechanicalElectricalTestingPlannedToken.actualPlannedDate = this.mechanicalElectricalTestingPlannedDate;
		this._mechanicalElectricalTestingPlannedToken.plannedDate = _SetVal.plannedDate;
		this._mechanicalElectricalTestingPlannedToken.isOveridden = _SetVal.isOveridden;
		this._mechanicalElectricalTestingPlannedToken.addNotes = _SetVal.addNotes;
		this._mechanicalElectricalTestingPlannedToken.userOveridden = _SetVal.userOveridden;
	}
	get mechanicalElectricalTestingPlannedDateLabel(): string {
		if (this.mechanicalElectricalTestingPlannedDateIsRevised == true) {
			return "Revised (Planned) Date"
		} else {
			return "Planned Date"
		}
	}
	get mechanicalElectricalTestingPlannedDateIsRevised(): boolean {
		if (this.mechanicalElectricalTestingPlannedDate_Initial && this.mechanicalElectricalTestingPlannedDate) {
			if (GenService.areDatesSame(this.mechanicalElectricalTestingPlannedDate_Initial, this.mechanicalElectricalTestingPlannedDate) == false) {
				return true;
			}
		}
		return false;
	}
	get mechanicalElectricalTestingPlannedDate_Initial(): Date {
		if (this._mechanicalElectricalTestingPlannedToken.actualPlannedDate == null || this._mechanicalElectricalTestingPlannedToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.productionIP.mechanicalStickerPlannedDate_Initial;

			if (_tmpDate != null && configDefs.defPlndMechElecTestDays) {
				this._mechanicalElectricalTestingPlannedToken.actualPlannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndMechElecTestDays);
			}
			else {
				this._mechanicalElectricalTestingPlannedToken.actualPlannedDate = null;
			}
		}
		return this._mechanicalElectricalTestingPlannedToken.actualPlannedDate;
	}
	get mechanicalElectricalTestingPlannedDate(): Date {
		if (this._mechanicalElectricalTestingPlannedToken.plannedDate == null || this._mechanicalElectricalTestingPlannedToken.isOveridden == false) {
			// var _tmpDate = this.parentSubSORef.productionIP.mechanicalStickerActualDate;
			// if (_tmpDate == null){
			var _tmpDate = this.parentSubSORef.productionIP.mechanicalStickerPlannedDate;
			//}
			if (_tmpDate != null && configDefs.defPlndMechElecTestDays) {
				this._mechanicalElectricalTestingPlannedToken.plannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndMechElecTestDays);
			}
			else {
				this._mechanicalElectricalTestingPlannedToken.plannedDate = null;
			}
		}
		return this._mechanicalElectricalTestingPlannedToken.plannedDate;
	}
	private _mechanicalElectricalTestingPlannedGroup: RevisedDate;
	get mechanicalElectricalTestingPlannedGroup(): RevisedDate {
		this._mechanicalElectricalTestingPlannedGroup = new RevisedDate(this.mechanicalElectricalTestingPlannedDate_Initial, this.mechanicalElectricalTestingPlannedDateIsRevised, this.mechanicalElectricalTestingPlannedDate);

		return this._mechanicalElectricalTestingPlannedGroup;
	}
	set mechanicalElectricalTestingPlannedDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set mechanicalElectricalTestingPlannedDate directly");
		this._mechanicalElectricalTestingPlannedToken.plannedDate = _SetVal;
	}
	get mechanicalElectricalTestingRequestedToken(): RequestDateToken {
		return this._mechanicalElectricalTestingRequestedToken;
	}
	set mechanicalElectricalTestingRequestedToken(_SetVal: RequestDateToken) {
		if (this._mechanicalElectricalTestingRequestedToken.plndRequestDate == null)
			this._mechanicalElectricalTestingRequestedToken.plndRequestDate = this.mechanicalElectricalTestingRequestedDate;
		this._mechanicalElectricalTestingRequestedToken.requestDate = _SetVal.requestDate;
		this._mechanicalElectricalTestingRequestedToken.isOveridden = _SetVal.isOveridden;
		this._mechanicalElectricalTestingRequestedToken.addNotes = _SetVal.addNotes;
		this._mechanicalElectricalTestingRequestedToken.userOveridden = _SetVal.userOveridden;
	}
	get mechanicalElectricalTestingRequestedDate(): Date {
		if (this._mechanicalElectricalTestingRequestedToken.requestDate == null || this._mechanicalElectricalTestingRequestedToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.productionIP.mechanicalStickerActualDate;
			if (_tmpDate == null) {
				_tmpDate = this.parentSubSORef.productionIP.mechanicalStickerRequestedDate;
			}
			//var _tmpDate = this.parentSubSORef.productionIP.mechanicalStickerRequestedDate;
			if (_tmpDate != null && configDefs.defReqMechElecTestDays) {
				this._mechanicalElectricalTestingRequestedToken.requestDate = configDefs.addWorkingDays(_tmpDate, configDefs.defReqMechElecTestDays);
			}
			else {
				this._mechanicalElectricalTestingRequestedToken.requestDate = null;
			}
		}
		return this._mechanicalElectricalTestingRequestedToken.requestDate;
	}
	set mechanicalElectricalTestingRequestedDate(_SetVal: Date) {
		console.log('wrong execution, mechanicalElectricalTestingRequestedDate')
		this._mechanicalElectricalTestingRequestedToken.requestDate = _SetVal;
	}
	get mechanicalElectricalTestingActualToken(): ActualDateToken {
		return this._mechanicalElectricalTestingActualToken;
	}
	set mechanicalElectricalTestingActualToken(_SetVal: ActualDateToken) {
		if (this._mechanicalElectricalTestingActualToken.expActualDate == null)
			this._mechanicalElectricalTestingActualToken.expActualDate = this.mechanicalElectricalTestingActualDate;
		this._mechanicalElectricalTestingActualToken.actualDate = _SetVal.actualDate;
		this._mechanicalElectricalTestingActualToken.isOveridden = _SetVal.isOveridden;
		this._mechanicalElectricalTestingActualToken.addNotes = _SetVal.addNotes;
		this._mechanicalElectricalTestingActualToken.userOveridden = _SetVal.userOveridden;
	}
	get mechanicalElectricalTestingActualDate(): Date {
		return this._mechanicalElectricalTestingActualToken.actualDate;
	}
	set mechanicalElectricalTestingActualDate(_SetVal: Date) {
		console.log('wrong execution, mechanicalElectricalTestingActualDate')
		this._mechanicalElectricalTestingActualToken.actualDate = _SetVal;
	}
	get fatPlannedToken(): PlannedDateToken {
		return this._fatPlannedToken;
	}
	set fatPlannedToken(_SetVal: PlannedDateToken) {
		// if (this._fatPlannedToken.actualPlannedDate == null)
		// 	this._fatPlannedToken.actualPlannedDate = this.fatPlannedDate;
		this._fatPlannedToken.plannedDate = _SetVal.plannedDate;
		this._fatPlannedToken.isOveridden = _SetVal.isOveridden;
		this._fatPlannedToken.addNotes = _SetVal.addNotes;
		this._fatPlannedToken.userOveridden = _SetVal.userOveridden;
	}
	get fatPlannedDateLabel(): string {
		if (this.fatPlannedDateIsRevised == true) {
			return "Revised (Planned) Date"
		}
		else {
			return "Planned Date"
		}
	}
	get fatPlannedDateIsRevised(): boolean {
		if (this.mechanicalElectricalTestingPlannedDate_Initial && this.mechanicalElectricalTestingPlannedDate) {
			if (GenService.areDatesSame(this.mechanicalElectricalTestingPlannedDate_Initial, this.mechanicalElectricalTestingPlannedDate) == false) {
				return true;
			}
		}
		return false;

	}
	get fatPlannedDate_initial(): Date {
		if (this._fatPlannedToken.actualPlannedDate == null || this._fatPlannedToken.isOveridden == false) {
			var _tmpDate = this.mechanicalElectricalTestingPlannedDate_Initial;
			if (_tmpDate != null && configDefs.defPlndFATDays) {
				this._fatPlannedToken.actualPlannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndFATDays);
			}
			else {
				this._fatPlannedToken.actualPlannedDate = null;
			}
		}
		return this._fatPlannedToken.actualPlannedDate;
	}
	get fatPlannedDate(): Date {
		if (this._fatPlannedToken.plannedDate == null || this._fatPlannedToken.isOveridden == false) {
			// var _tmpDate = this.mechanicalElectricalTestingActualDate;
			// if(_tmpDate == null){
			var _tmpDate = this.mechanicalElectricalTestingPlannedDate
			//}
			if (_tmpDate != null && configDefs.defPlndFATDays) {
				this._fatPlannedToken.plannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndFATDays);
			}
			else {
				this._fatPlannedToken.plannedDate = null;
			}
		}
		return this._fatPlannedToken.plannedDate;
	}
	private _fatPlannedGroup: RevisedDate;
	get fatPlannedGroup(): RevisedDate {
		this._fatPlannedGroup = new RevisedDate(this.fatPlannedDate_initial, this.fatPlannedDateIsRevised, this.fatPlannedDate);

		return this._fatPlannedGroup;
	}
	set fatPlannedDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set fatPlannedDate directly");
		this._fatPlannedToken.plannedDate = _SetVal;
	}
	get fatRequestedToken(): RequestDateToken {
		return this._fatRequestedToken;
	}
	set fatRequestedToken(_SetVal: RequestDateToken) {
		if (this._fatRequestedToken.plndRequestDate == null)
			this._fatRequestedToken.plndRequestDate = this.fatRequestedDate;
		this._fatRequestedToken.requestDate = _SetVal.requestDate;
		this._fatRequestedToken.isOveridden = _SetVal.isOveridden;
		this._fatRequestedToken.addNotes = _SetVal.addNotes;
		this._fatRequestedToken.userOveridden = _SetVal.userOveridden;
	}
	get fatRequestedDate(): Date {
		if (this._fatRequestedToken.requestDate == null || this._fatRequestedToken.isOveridden == false) {
			//var _tmpDate = this.mechanicalElectricalTestingRequestedDate;
			var _tmpDate = this.mechanicalElectricalTestingActualDate;
			if (_tmpDate == null) {
				_tmpDate = this.mechanicalElectricalTestingRequestedDate;
			}
			if (_tmpDate != null && configDefs.defReqFATDays) {
				this._fatRequestedToken.requestDate = configDefs.addWorkingDays(_tmpDate, configDefs.defReqFATDays);
			}
			else {
				this._fatRequestedToken.requestDate = null;
			}
		}
		return this._fatRequestedToken.requestDate;
	}
	set fatRequestedDate(_SetVal: Date) {
		console.log('wrong execution, fatRequestedDate')
		this._fatRequestedToken.requestDate = _SetVal;
	}
	get fatActualToken(): ActualDateToken {
		return this._fatActualToken;
	}
	set fatActualToken(_SetVal: ActualDateToken) {
		if (this._fatActualToken.expActualDate == null)
			this._fatActualToken.expActualDate = this.fatActualDate;
		this._fatActualToken.actualDate = _SetVal.actualDate;
		this._fatActualToken.isOveridden = _SetVal.isOveridden;
		this._fatActualToken.addNotes = _SetVal.addNotes;
		this._fatActualToken.userOveridden = _SetVal.userOveridden;
	}
	get fatActualDate(): Date {
		return this._fatActualToken.actualDate;
	}
	set fatActualDate(_SetVal: Date) {
		console.log('wrong execution, fatActualDate')
		this._fatActualToken.actualDate = _SetVal;
	}
	get greenStickerPlannedToken(): PlannedDateToken {
		return this._greenStickerPlannedToken;
	}
	set greenStickerPlannedToken(_SetVal: PlannedDateToken) {
		if (this._greenStickerPlannedToken.actualPlannedDate == null)
			this._greenStickerPlannedToken.actualPlannedDate = this.greenStickerPlannedDate;
		this._greenStickerPlannedToken.plannedDate = _SetVal.plannedDate;
		this._greenStickerPlannedToken.isOveridden = _SetVal.isOveridden;
		this._greenStickerPlannedToken.addNotes = _SetVal.addNotes;
		this._greenStickerPlannedToken.userOveridden = _SetVal.userOveridden;
	}
	get greenStickerPlannedDateLabel(): string {
		if (this.greenStickerPlannedDateIsRevised == true) {
			return "Revised (Planned) Date"
		} else {
			return "Planned Date"
		}
	}
	get greenStickerPlannedDateIsRevised(): boolean {
		//    return this.fatActualDate != null;
		if (this.fatPlannedDate_initial && this.fatPlannedDate) {
			if (GenService.areDatesSame(this.fatPlannedDate,
				this.fatPlannedDate_initial) == false) {
				return true;
			}
		}
		return false;
	}
	get greenStickerPlannedDate_initial(): Date {
		if (this._greenStickerPlannedToken.actualPlannedDate == null || this._greenStickerPlannedToken.isOveridden == false) {
			var _tmpDate = this.fatPlannedDate_initial;

			if (_tmpDate != null && configDefs.defPlndGreStiDays) {
				this._greenStickerPlannedToken.actualPlannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndGreStiDays);
			}
			else {
				this._greenStickerPlannedToken.actualPlannedDate = null;
			}
		}
		return this._greenStickerPlannedToken.actualPlannedDate;
	}
	get greenStickerPlannedDate(): Date {
		if (this._greenStickerPlannedToken.plannedDate == null || this._greenStickerPlannedToken.isOveridden == false) {
			// var _tmpDate = this.fatActualDate;
			// if(_tmpDate == null){
			var _tmpDate = this.fatPlannedDate
			//}
			if (_tmpDate != null && configDefs.defPlndGreStiDays) {
				this._greenStickerPlannedToken.plannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndGreStiDays);
			}
			else {
				this._greenStickerPlannedToken.plannedDate = null;
			}
		}
		return this._greenStickerPlannedToken.plannedDate;
	}
	private _greenStickerPlannedGroup: RevisedDate;
	get greenStickerPlannedGroup(): RevisedDate {
		this._greenStickerPlannedGroup = new RevisedDate(this.greenStickerPlannedDate_initial, this.greenStickerPlannedDateIsRevised, this.greenStickerPlannedDate);

		return this._greenStickerPlannedGroup;
	}
	set greenStickerPlannedDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set greenStickerPlannedDate directly");
		this._greenStickerPlannedToken.plannedDate = _SetVal;
	}
	get greenStickerRequestedToken(): RequestDateToken {
		return this._greenStickerRequestedToken;
	}
	set greenStickerRequestedToken(_SetVal: RequestDateToken) {
		if (this._greenStickerRequestedToken.plndRequestDate == null)
			this._greenStickerRequestedToken.plndRequestDate = this.greenStickerRequestedDate;
		this._greenStickerRequestedToken.requestDate = _SetVal.requestDate;
		this._greenStickerRequestedToken.isOveridden = _SetVal.isOveridden;
		this._greenStickerRequestedToken.addNotes = _SetVal.addNotes;
		this._greenStickerRequestedToken.userOveridden = _SetVal.userOveridden;
	}
	get greenStickerRequestedDate(): Date {
		if (this._greenStickerRequestedToken.requestDate == null || this._greenStickerRequestedToken.isOveridden == false) {
			//var _tmpDate = this.fatRequestedDate;
			var _tmpDate = this.fatActualDate;
			if (_tmpDate == null) {
				_tmpDate = this.fatRequestedDate;
			}
			if (_tmpDate != null && configDefs.defReqGreStiDays) {
				this._greenStickerRequestedToken.requestDate = configDefs.addWorkingDays(_tmpDate, configDefs.defReqGreStiDays);
			}
			else {
				this._greenStickerRequestedToken.requestDate = null;
			}
		}
		return this._greenStickerRequestedToken.requestDate;
	}
	set greenStickerRequestedDate(_SetVal: Date) {
		this._greenStickerRequestedToken.requestDate = _SetVal;
	}
	get greenStickerActualToken(): ActualDateToken {
		return this._greenStickerActualToken;
	}
	set greenStickerActualToken(_SetVal: ActualDateToken) {
		if (this._greenStickerActualToken.expActualDate == null)
			this._greenStickerActualToken.expActualDate = this.greenStickerActualDate;
		this._greenStickerActualToken.actualDate = _SetVal.actualDate;
		this._greenStickerActualToken.isOveridden = _SetVal.isOveridden;
		this._greenStickerActualToken.addNotes = _SetVal.addNotes;
		this._greenStickerActualToken.userOveridden = _SetVal.userOveridden;
	}
	get greenStickerActualDate(): Date {
		return this._greenStickerActualToken.actualDate;
	}
	set greenStickerActualDate(_SetVal: Date) {
		console.log('wrong execution, greenStickerActualDate');
		this._greenStickerActualToken.actualDate = _SetVal;
	}
	get fileUploadForTesting(): GenFileUploads {
		return this._fileUploadsForTesting;
	}
	set fileUploadForTesting(_SetVal: GenFileUploads) {
		this._fileUploadsForTesting = _SetVal;
	}
	get finalRlyPrgFiles(): GenFileUploads {
		return this._finalRlyPrgFiles;
	}
	set finalRlyPrgFiles(_SetVal: GenFileUploads) {
		this._finalRlyPrgFiles = _SetVal;
	}
	get mechTestEnggId(): string {
		return this._mechTestEnggId;
	}
	set mechTestEnggId(_setVal: string) {
		this._mechTestEnggId = _setVal;
	}
	get elecTestEnggId(): string {
		return this._elecTestEnggId;
	}
	set elecTestEnggId(_setVal: string) {
		this._elecTestEnggId = _setVal;
	}
	get qualityDays(): number {
		return configDefs.getDaysDifference(this.mechanicalElectricalTestingRequestedDate, this.mechanicalElectricalTestingActualDate);
	}
	get qualityDaysTip(): string {
		let _tmpRequestDate: Date = this.mechanicalElectricalTestingRequestedDate
		let _tmpActualDate: Date = this.mechanicalElectricalTestingActualDate
		if (_tmpRequestDate && _tmpActualDate) {
			return 'Mechanical/Electrical Testing Date : \r\n' +
				'\tRequest\t> ' + moment(_tmpRequestDate).format(configDefs.dateFormat) + '\r\n' +
				'\tActual\t> ' + moment(_tmpActualDate).format(configDefs.dateFormat);
		}
		return '';
	}

	// STARTS

	get elecMechTestingDate(): string {
		let _elecMechDate: Date = this.mechanicalElectricalTestingActualDate;

		if (_elecMechDate != null) {

			return formatDate(_elecMechDate, 'dd-MMM-yy', 'en-IN');
		}
		return null;
	}

	get FATDate(): string {
		let _fatDate: Date = this.fatActualDate;

		if (_fatDate != null) {

			return formatDate(_fatDate, 'dd-MMM-yy', 'en-IN');
		}
		return null;
	}

	get greenStickerDate(): string {
		let _greenstckDate: Date = this.greenStickerActualDate;

		if (_greenstckDate != null) {

			return formatDate(_greenstckDate, 'dd-MMM-yy', 'en-IN');
		}
		return null;
	}

	get greenstickermonth(): Date {
		if (this.greenStickerActualDate) {
			return this.greenStickerActualDate;
		}
		return null;
	}
	// ENDS
	cloneSelf() {
		return new QualityIP(this._mechanicalElectricalTestingPlannedToken.cloneSelf(), this._mechanicalElectricalTestingRequestedToken.cloneSelf(),
			this._mechanicalElectricalTestingActualToken.cloneSelf(), this._fatPlannedToken.cloneSelf(),
			this._fatRequestedToken.cloneSelf(), this._fatActualToken.cloneSelf(), this._greenStickerPlannedToken.cloneSelf(),
			this._greenStickerRequestedToken.cloneSelf(), this._greenStickerActualToken.cloneSelf(),
			this.fileUploadForTesting.cloneSelf(), this.finalRlyPrgFiles.cloneSelf(),
			this._mechTestEnggId, this._elecTestEnggId, this._status);
	}
	public static getObj(_json: any): QualityIP {
		return new QualityIP(convDefs.convToPlannedDateToken(_json.mechEleTestPlanToken), RequestDateToken.getObj(_json.mechEleTestReqToken),
			convDefs.convToActualDateToken(_json.mechEleTestActToken), convDefs.convToPlannedDateToken(_json.fatPlanToken), RequestDateToken.getObj(_json.fatReqToken),
			convDefs.convToActualDateToken(_json.fatActToken), convDefs.convToPlannedDateToken(_json.grnStkrPlanToken), RequestDateToken.getObj(_json.grnStkrReqToken),
			convDefs.convToActualDateToken(_json.grnStkrActToken), GenFileUploads.getObj(_json.fileUploadForTesting),
			GenFileUploads.getObj(_json.finalRelayPrgFiles),
			_json.mTestEnggId, _json.eTestEnggId, _json.status);
	}
	public getJson(): any {
		let _json: any = {};

		_json.mechEleTestPlanToken = this.mechanicalElectricalTestingPlannedToken.getJson();
		_json.mechEleTestReqToken = this.mechanicalElectricalTestingRequestedToken.getJson();
		_json.mechEleTestActToken = this.mechanicalElectricalTestingActualToken.getJson();
		_json.fatPlanToken = this.fatPlannedToken.getJson();
		_json.fatReqToken = this.fatRequestedToken.getJson();
		_json.fatActToken = this.fatActualToken.getJson();
		_json.grnStkrPlanToken = this.greenStickerPlannedToken.getJson();
		_json.grnStkrReqToken = this.greenStickerRequestedToken.getJson();
		_json.grnStkrActToken = this.greenStickerActualToken.getJson();
		_json.fileUploadForTesting = (this.fileUploadForTesting ? this.fileUploadForTesting.getJson() : null);
		_json.finalRelayPrgFiles = (this.finalRlyPrgFiles ? this.finalRlyPrgFiles.getJson() : null);
		_json.mTestEnggId = this.mechTestEnggId;
		_json.eTestEnggId = this.elecTestEnggId;
		_json.status = this.status;

		return _json;
	}
}

export class PartialDelivery {
	constructor(private _partialDispatchQty: number, private _dispatchFromPlantActualToken: ActualDateToken, private _dispatchActualDate: Date, private _remarks: string = '') {

	}


	get partialDispatchQty(): number {
		return this._partialDispatchQty;
	}
	set partialDispatchQty(_SetVal: number) {
		this._partialDispatchQty = _SetVal;
	}


	get dispatchFromPlantActualToken(): ActualDateToken {
		return this._dispatchFromPlantActualToken;
	}
	set dispatchFromPlantActualToken(_SetVal: ActualDateToken) {
		if (this._dispatchFromPlantActualToken.expActualDate == null)
			this._dispatchFromPlantActualToken.expActualDate = this.dispatchFromPlantActualDate;
		this._dispatchFromPlantActualToken.actualDate = _SetVal.actualDate;
		this._dispatchFromPlantActualToken.isOveridden = _SetVal.isOveridden;
		this._dispatchFromPlantActualToken.addNotes = _SetVal.addNotes;
		this._dispatchFromPlantActualToken.userOveridden = _SetVal.userOveridden;
	}
	get dispatchFromPlantActualDate(): Date {
		return this._dispatchFromPlantActualToken.actualDate;
	}
	set dispatchFromPlantActualDate(_SetVal: Date) {
		console.log('wrong execution, greenStickerActualDate');
		this._dispatchFromPlantActualToken.actualDate = _SetVal;
	}
	get dispatchActualDate(): Date {
		return this._dispatchActualDate;
	}
	set dispatchActualDate(_SetVal: Date) {
		this._dispatchActualDate = _SetVal;
	}
	get remarks(): string {
		return this._remarks || '';
	}
	set remarks(_SetVal: string) {
		this._remarks = _SetVal || '';
	}

	public static getObj(_json: any): PartialDelivery {
		return new PartialDelivery(_json.partialQty,
			convDefs.convToActualDateToken(_json.dispFromPlantActToken), GenService.convToDate(_json.dispActDate), _json.remarks || '');
	}
	getJson(): any {
		let _json: any = {};
		_json.partialQty = this.partialDispatchQty;
		_json.dispFromPlantActToken = this.dispatchFromPlantActualToken.getJson();
		_json.dispActDate = GenService.convToDateNum(this.dispatchActualDate);
		_json.remarks = this.remarks;
		return _json;
	}
	cloneSelf(): PartialDelivery {
		return new PartialDelivery(this.partialDispatchQty, this.dispatchFromPlantActualToken.cloneSelf(), configDefs.cloneDt(this.dispatchActualDate), this.remarks);
	}
}
export class LogisticIP {
	constructor(private _dispatchFromPlantPlannedToken: PlannedDateToken, private _dispatchFromPlantRequestToken: RequestDateToken,
		private _partialDeliveries: Array<PartialDelivery>, private _earthlingTruckActualDispatchDate: Date, private _sparesActualDispatchDate: Date,
		private _packListFiles: GenFileUploads, private _photoUploadFiles: GenFileUploads,
		private _dcUploadFiles: GenFileUploads, private _invoiceUploadFiles: GenFileUploads,
		private _finaldespatchdocuments: GenFileUploads,
		private _ewayBillFiles: GenFileUploads, private _lrCopyFiles: GenFileUploads,
		private _status: FunctionStatus) {


	}
	private _parentSORef: SalesOrder;
	private _parentSubSORef: SubSalesOrder;
	refreshStatus() {
		// let date: Date = new Date();
		// let pmTechSubSalesOrderObj: PmTechnicalIP;
		if (this.parentSORef && this.parentSubSORef && this.parentSORef.projectStatus >= SOStatus.Sub_Orders) {
			if (this.parentSubSORef.isSSOStatusSet(SSOStatus.Logistic) == true ||
				this.parentSubSORef.isSSOStatusSet(SSOStatus.Logistic_From_PM_Tech) == true) {
				if (this.parentSubSORef.isSSOStatusSet(SSOStatus.Dispatched) == true) {

					let _isTempComplete: boolean = this.isFunctionComplete();
					if (_isTempComplete == true) {
						this._status = FunctionStatus.SUBMITTED_COMPLETE;
					}

					else {
						this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
					}
				}

				else {
					for (var i = 0; i < this.partialDeliveries.length; i++) {
						if (configDefs.isDtEmty(this.partialDeliveries[i].dispatchFromPlantActualDate) && (configDefs.isNumEmty(this.partialDeliveries[i].partialDispatchQty)) && (this.partialDeliveries[i].partialDispatchQty < this.parentSubSORef.pmTechSubSalesOrder.panelQuantity)) {
							this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
						} else if (configDefs.isDtEmty(this.partialDeliveries[i].dispatchFromPlantActualDate) || configDefs.isStrEmty(this.logisticDaysTip) == false || (configDefs.isNumEmty(this.partialDeliveries[i].partialDispatchQty)) || (this.partialDeliveries[i].partialDispatchQty < this.parentSubSORef.pmTechSubSalesOrder.panelQuantity)) {
							this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
						} else {
							this._status = FunctionStatus.NOT_SUBMITTED_BUT_READY;
						}
					}

				}
				// New
				if (this.parentSubSORef.isSSOStatusSet(SSOStatus.Dispatched) == true) {

					let _isTempComplete: boolean = this.isFunctionCompleteSpares();
					if (_isTempComplete == true) {
						this._status = FunctionStatus.SUBMITTED_COMPLETE;
					}

					else {
						this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
					}
				}
				else {
					for (var i = 0; i < this.partialDeliveries.length; i++) {
						if (configDefs.isDtEmty(this.partialDeliveries[i].dispatchFromPlantActualDate) && (configDefs.isNumEmty(this.partialDeliveries[i].partialDispatchQty)) && (this.partialDeliveries[i].partialDispatchQty < this.parentSubSORef.pmTechSubSalesOrder.panelQuantity)) {
							this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
						} else if (configDefs.isDtEmty(this.partialDeliveries[i].dispatchFromPlantActualDate) || configDefs.isStrEmty(this.logisticDaysTip) == false || (configDefs.isNumEmty(this.partialDeliveries[i].partialDispatchQty)) || (this.partialDeliveries[i].partialDispatchQty < this.parentSubSORef.pmTechSubSalesOrder.panelQuantity)) {
							this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
						} else {
							this._status = FunctionStatus.NOT_SUBMITTED_BUT_READY;
						}
					}

				}
				// New end
			}
			else {
				this._status = FunctionStatus.WAITING_FOR_PREV;
			}
		}
		else {
			this._status = FunctionStatus.WAITING_FOR_PREV;
		}
	}
	public isFunctionComplete(): boolean {
		if (configDefs.isDtEmty(this.dispatchFromPlantPlannedDate)) return false;
		if (configDefs.isDtEmty(this.dispatchFromPlantRequestDate)) return false;
		for (var i = 0; i < this.partialDeliveries.length; i++) {
			if (configDefs.isDtEmty(this.partialDeliveries[i].dispatchFromPlantActualDate)) return false;
		}
		//if(configDefs.isDtEmty(this.dispatchFromPlantActualDate)) return false;
		//if(configDefs.isStrEmty(this.partialDispatchQty)) return false;
		if (this.isSparesApplicability) {
			if (configDefs.isDtEmty(this.sparesActualDispatchDate)) return false;
		}
		if (this.isETApplicability) {
			if (configDefs.isDtEmty(this.earthlingTruckActualDispatchDate)) return false;
		}

		return true;
	}
	public isFunctionCompleteSpares(): boolean {
		// if (configDefs.isDtEmty(this.dispatchFromPlantPlannedDate)) return false;
		// if (configDefs.isDtEmty(this.dispatchFromPlantRequestDate)) return false;
		for (var i = 0; i < this.partialDeliveries.length; i++) {
			if (configDefs.isDtEmty(this.partialDeliveries[i].dispatchFromPlantActualDate)) return false;
		}
		//if(configDefs.isDtEmty(this.dispatchFromPlantActualDate)) return false;
		//if(configDefs.isStrEmty(this.partialDispatchQty)) return false;
		if (this.isSparesApplicability) {
			if (configDefs.isDtEmty(this.sparesActualDispatchDate)) return false;
		}
		if (this.isETApplicability) {
			if (configDefs.isDtEmty(this.earthlingTruckActualDispatchDate)) return false;
		}

		return true;
	}
	get isProjectLive(): boolean {
		return this.parentSubSORef.pmTechSubSalesOrder.projStatus == "live"
	}
	get isInputEnabled(): boolean {
		return this.parentSubSORef.isSSOStatusSet(SSOStatus.Logistic)
			|| this.parentSubSORef.isSSOStatusSet(SSOStatus.Logistic_From_PM_Tech);

	}

	get parentSORef(): SalesOrder {
		return this._parentSORef;
	}
	set parentSORef(SORef: SalesOrder) {
		this._parentSORef = SORef;
		//this.refreshStatus();
	}
	get parentSubSORef(): SubSalesOrder {
		return this._parentSubSORef;
	}
	set parentSubSORef(SubSORef: SubSalesOrder) {
		this._parentSubSORef = SubSORef;
	}
	get isSubmittedtoDispacthed(): boolean {
		return this.parentSubSORef.isSSOStatusSet(SSOStatus.Dispatched);
	}
	get readyForDispacth(): boolean {
		return (this.totalDispatchQty == this.parentSubSORef.pmTechSubSalesOrder.panelQuantity)
	}
	get dispatchErrorMessage(): string {
		if (this.readyForDispacth == false) {
			return ' Planned Quantity = ' + this.parentSubSORef.pmTechSubSalesOrder.panelQuantity + ", Dispatched Quantity = " + this.totalDispatchQty;
		}
		return '';
	}
	get status(): FunctionStatus {
		return this._status;
	}
	enableFormInput(): void {
		if (this._status == FunctionStatus.WAITING_FOR_PREV) {
			this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
		}
	}
	subOrderComplete(): void {
		//this._status = FunctionStatus.SUBMITTED_COMPLETE;
		this.refreshStatus();
	}
	get dispatchFromPlantPlannedToken(): PlannedDateToken {
		return this._dispatchFromPlantPlannedToken;
	}
	set dispatchFromPlantPlannedToken(_SetVal: PlannedDateToken) {
		if (this._dispatchFromPlantPlannedToken.actualPlannedDate == null)
			this._dispatchFromPlantPlannedToken.actualPlannedDate = this.dispatchFromPlantPlannedDate;
		this._dispatchFromPlantPlannedToken.plannedDate = _SetVal.plannedDate;
		this._dispatchFromPlantPlannedToken.isOveridden = _SetVal.isOveridden;
		this._dispatchFromPlantPlannedToken.addNotes = _SetVal.addNotes;
		this._dispatchFromPlantPlannedToken.userOveridden = _SetVal.userOveridden;
	}
	get dispatchFromPlantPlannedDateLabel(): string {
		if (this.dispatchFromPlantPlannedDateIsRevised == true) {
			return "Revised (Planned) Date"
		} else {
			return "Planned Date"
		}
	}
	get dispatchFromPlantPlannedDateIsRevised(): boolean {
		//    return this.parentSubSORef.qualityIP.greenStickerActualDate != null;
		if (this.parentSubSORef.qualityIP.greenStickerPlannedDate_initial && this.parentSubSORef.qualityIP.greenStickerPlannedDate) {
			if (GenService.areDatesSame(this.parentSubSORef.qualityIP.greenStickerPlannedDate_initial,
				this.parentSubSORef.qualityIP.greenStickerPlannedDate) == false) {
				return true;
			}
		}
		return false;
	}
	get dispatchFromPlantPlannedDate_Initial(): Date {
		if (this._dispatchFromPlantPlannedToken.actualPlannedDate == null || this._dispatchFromPlantPlannedToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.qualityIP.greenStickerPlannedDate_initial;
			if (_tmpDate != null && configDefs.defPlndDispatchDays) {
				this._dispatchFromPlantPlannedToken.actualPlannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndDispatchDays);
			}
			else {
				this._dispatchFromPlantPlannedToken.actualPlannedDate = null;
			}
		}
		return this._dispatchFromPlantPlannedToken.actualPlannedDate;
	}
	get dispatchFromPlantPlannedDate(): Date {
		if (this._dispatchFromPlantPlannedToken.plannedDate == null || this._dispatchFromPlantPlannedToken.isOveridden == false) {
			// var _tmpDate = this.parentSubSORef.qualityIP.greenStickerActualDate;
			// if(_tmpDate == null){
			var _tmpDate = this.parentSubSORef.qualityIP.greenStickerPlannedDate
			//}
			if (_tmpDate != null && configDefs.defPlndDispatchDays) {
				this._dispatchFromPlantPlannedToken.plannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndDispatchDays);
			}
			else {
				this._dispatchFromPlantPlannedToken.plannedDate = null;
			}
		}
		return this._dispatchFromPlantPlannedToken.plannedDate;
	}
	private _dispatchFromPlantPlannedGroup: RevisedDate;
	get dispatchFromPlantPlannedGroup(): RevisedDate {
		this._dispatchFromPlantPlannedGroup = new RevisedDate(this.dispatchFromPlantPlannedDate_Initial, this.dispatchFromPlantPlannedDateIsRevised, this.dispatchFromPlantPlannedDate);

		return this._dispatchFromPlantPlannedGroup;
	}

	set dispatchFromPlantPlannedDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set dispatchFromPlantPlannedDate directly");
		this._dispatchFromPlantPlannedToken.plannedDate = _SetVal;
	}
	get dispatchFromPlantRequestToken(): RequestDateToken {
		return this._dispatchFromPlantRequestToken;
	}
	set dispatchFromPlantRequestToken(_SetVal: RequestDateToken) {
		if (this._dispatchFromPlantRequestToken.plndRequestDate == null)
			this._dispatchFromPlantRequestToken.plndRequestDate = this.dispatchFromPlantRequestDate;
		this._dispatchFromPlantRequestToken.requestDate = _SetVal.requestDate;
		this._dispatchFromPlantRequestToken.isOveridden = _SetVal.isOveridden;
		this._dispatchFromPlantRequestToken.addNotes = _SetVal.addNotes;
		this._dispatchFromPlantRequestToken.userOveridden = _SetVal.userOveridden;
	}
	get dispatchFromPlantRequestDate(): Date {
		if (this._dispatchFromPlantRequestToken.requestDate == null || this._dispatchFromPlantRequestToken.isOveridden == false) {
			//var _tmpDate = this.parentSubSORef.qualityIP.greenStickerRequestedDate;
			var _tmpDate = this.parentSubSORef.qualityIP.greenStickerActualDate;
			if (_tmpDate == null) {
				_tmpDate = this.parentSubSORef.qualityIP.greenStickerRequestedDate;
			}
			if (_tmpDate != null && configDefs.defReqDispatchDays) {
				this._dispatchFromPlantRequestToken.requestDate = configDefs.addWorkingDays(_tmpDate, configDefs.defReqDispatchDays);
			}
			else {
				this._dispatchFromPlantRequestToken.requestDate = null;
			}
		}
		return this._dispatchFromPlantRequestToken.requestDate;
	}
	set dispatchFromPlantRequestDate(_SetVal: Date) {
		console.log('wrong execution, dispatchFromPlantRequestDate');
		this._dispatchFromPlantRequestToken.requestDate = _SetVal;
	}
	get partialDeliveries(): Array<PartialDelivery> {
		return this._partialDeliveries;
	}
	set partialDeliveries(_SetVal: Array<PartialDelivery>) {
		this._partialDeliveries = _SetVal;
	}
	get lastDeliveryActualDate(): Date {
		var _actualDeliveryDate: Date = null;
		if (this.partialDeliveries) {
			this.partialDeliveries.forEach((_pDelivery: PartialDelivery) => {
				_actualDeliveryDate = _pDelivery.dispatchFromPlantActualToken.actualDate;
			})
		}
		return _actualDeliveryDate;
	}
	get lastDeliveryActualDateReason(): string {
		var _actualDeliveryDateReason = '';
		if (this.partialDeliveries) {
			this.partialDeliveries.forEach((_pDelivery: PartialDelivery) => {
				_actualDeliveryDateReason = _pDelivery.dispatchFromPlantActualToken.addNotes;
			})
		}
		return _actualDeliveryDateReason;
	}
	isSubOrdercompleted(): boolean {
		if (this.totalDispatchQty == this.parentSubSORef.pmTechSubSalesOrder.panelQuantity) {
			return true
		}
	}
	get latestPartialDeliveryToken(): any {
		var _lastDeliveryRemarks = "";
		var _lastDeliveryDate: Date = null;
		for (var i = 0; i < this.partialDeliveries.length; i++) {
			if (this.partialDeliveries[i].dispatchFromPlantActualDate) {
				if (_lastDeliveryDate == null ||
					this.partialDeliveries[i].dispatchFromPlantActualDate > _lastDeliveryDate) {
					_lastDeliveryDate = this.partialDeliveries[i].dispatchFromPlantActualDate;
					_lastDeliveryRemarks = this.partialDeliveries[i].dispatchFromPlantActualToken.addNotes;
				}

			}
		}
		return { "delDate": _lastDeliveryDate, "delRemarks": _lastDeliveryRemarks };
	}
	get totalDispatchQty(): number {
		let _dipcQty: number = 0;
		this.partialDeliveries.forEach((_pd: PartialDelivery) => {
			_dipcQty += _pd.partialDispatchQty;
		})
		// this._totalDispatchQty = _dipcQty + "";
		// console.log(this._totalDispatchQty)
		return _dipcQty;
	}
	// set totalDispatchQty(_SetVal: string ){
	// 	this._totalDispatchQty = _SetVal;
	// }
	get isETApplicability(): boolean {
		return this.parentSubSORef.pmTechSubSalesOrder.etApplicability_Enable;
	}
	get earthlingTruckActualDispatchDate(): Date {
		if (this.isETApplicability == true)
			return this._earthlingTruckActualDispatchDate;
		return null;
	}
	set earthlingTruckActualDispatchDate(_SetVal: Date) {
		this._earthlingTruckActualDispatchDate = _SetVal;
	}
	get isSparesApplicability(): boolean {
		return this.parentSubSORef.pmTechSubSalesOrder.spareApplicability_Enable;
	}
	get sparesActualDispatchDate(): Date {
		if (this.isSparesApplicability == true)
			return this._sparesActualDispatchDate;
		return null;
	}
	set sparesActualDispatchDate(_SetVal: Date) {
		this._sparesActualDispatchDate = _SetVal;
	}
	get packListFiles(): GenFileUploads {
		return this._packListFiles;
	}
	set packListFiles(_SetVal: GenFileUploads) {
		this._packListFiles = _SetVal;
	}
	get photoUploadFiles(): GenFileUploads {
		return this._photoUploadFiles;
	}
	set photoUploadFiles(_SetVal: GenFileUploads) {
		this._photoUploadFiles = _SetVal;
	}
	get dcUploadFiles(): GenFileUploads {
		return this._dcUploadFiles;
	}
	set dcUploadFiles(_SetVal: GenFileUploads) {
		this._dcUploadFiles = _SetVal;
	}
	get invoiceUploadFiles(): GenFileUploads {
		return this._invoiceUploadFiles;
	}
	set invoiceUploadFiles(_SetVal: GenFileUploads) {
		this._invoiceUploadFiles = _SetVal;
	}
	get finaldespatchdocuments(): GenFileUploads {
		return this._finaldespatchdocuments;
	}
	set finaldespatchdocuments(_SetVal: GenFileUploads) {
		this._finaldespatchdocuments = _SetVal;
	}
	get ewayBillFiles(): GenFileUploads {
		return this._ewayBillFiles;
	}
	set ewayBillFiles(_SetVal: GenFileUploads) {
		this._ewayBillFiles = _SetVal;
	}
	get lrCopyFiles(): GenFileUploads {
		return this._lrCopyFiles;
	}
	set lrCopyFiles(_SetVal: GenFileUploads) {
		this._lrCopyFiles = _SetVal;
	}

	get logisticDays(): number {
		return configDefs.getDaysDifference(this.dispatchFromPlantRequestDate, this.lastDeliveryActualDate)
	}
	get logisticDaysTip(): string {
		let _tmpRequestDate: Date = this.dispatchFromPlantRequestDate
		let _tmpActualDate: Date = this.lastDeliveryActualDate
		if (_tmpRequestDate && _tmpActualDate) {
			return 'Dispatch from Plant : \r\n' +
				'\tRequest\t> ' + moment(_tmpRequestDate).format(configDefs.dateFormat) + '\r\n' +
				'\tActual\t> ' + moment(_tmpActualDate).format(configDefs.dateFormat);
		}
		return '';
	}
	addPartialDelivery() {
		this._partialDeliveries.push(new PartialDelivery(null, new ActualDateToken(null, false, null, '', ''), null));
	}
	removePartialDelivery(_index: number) {
		this._partialDeliveries.splice(_index, 1);
	}
	cloneSelf() {
		let _tmpDeliveries: Array<PartialDelivery> = [];
		this.partialDeliveries.forEach((_partialDelivery: PartialDelivery) => {
			_tmpDeliveries.push(_partialDelivery.cloneSelf());
		})
		return new LogisticIP(this._dispatchFromPlantPlannedToken.cloneSelf(), this._dispatchFromPlantRequestToken.cloneSelf(),
			_tmpDeliveries, configDefs.cloneDt(this._earthlingTruckActualDispatchDate), configDefs.cloneDt(this._sparesActualDispatchDate),
			this._packListFiles.cloneSelf(), this._photoUploadFiles.cloneSelf(),
			this._dcUploadFiles.cloneSelf(), this._invoiceUploadFiles.cloneSelf(), this._finaldespatchdocuments.cloneSelf(),
			this._ewayBillFiles.cloneSelf(), this._lrCopyFiles.cloneSelf(),
			this._status);
	}
	public static getObj(_json: any): LogisticIP {
		let _partialDeliveries: Array<PartialDelivery> = [];
		if (_json.partialDeliveries) {
			for (var j = 0; j < _json.partialDeliveries.length; j++) {
				_partialDeliveries.push(PartialDelivery.getObj(_json.partialDeliveries[j]));
			}
		}

		if (_partialDeliveries.length == 0) {
			_partialDeliveries.push(new PartialDelivery(0, new ActualDateToken(null, false, null, '', ''), null));
		}

		return new LogisticIP(convDefs.convToPlannedDateToken(_json.dispPlantPlanToken), RequestDateToken.getObj(_json.dispPlantReqToken),
			_partialDeliveries, GenService.convToDate(_json.earthlingTruckActDispDate),
			GenService.convToDate(_json.sparesActDispDate),
			GenFileUploads.getObj(_json.packListFiles), GenFileUploads.getObj(_json.photoFiles),
			GenFileUploads.getObj(_json.dcFiles), GenFileUploads.getObj(_json.invoiceFiles),
			GenFileUploads.getObj(_json.finaldespatchdocuments),
			GenFileUploads.getObj(_json.ewayBillFiles), GenFileUploads.getObj(_json.lrCopyFiles),
			_json.status);
	}
	public getJson(): any {
		let _json: any = {};

		let _partialDlvrs: any = [];
		this.partialDeliveries.forEach((_partialDelivery: PartialDelivery) => {
			_partialDlvrs.push(_partialDelivery.getJson());
		})

		_json.dispPlantPlanToken = this.dispatchFromPlantPlannedToken.getJson();
		_json.dispPlantReqToken = this.dispatchFromPlantRequestToken.getJson();
		_json.partialDeliveries = _partialDlvrs;
		_json.earthlingTruckActDispDate = GenService.convToDateNum(this.earthlingTruckActualDispatchDate);
		_json.totaldispatch = this.totalDispatchQty;
		_json.sparesActDispDate = GenService.convToDateNum(this.sparesActualDispatchDate);
		_json.packListFiles = this.packListFiles.getJson();
		_json.photoFiles = this.photoUploadFiles.getJson();
		_json.dcFiles = this.dcUploadFiles.getJson();
		_json.invoiceFiles = this.invoiceUploadFiles.getJson();
		_json.finaldespatchdocuments = this._finaldespatchdocuments.getJson();
		_json.ewayBillFiles = this.ewayBillFiles.getJson();
		_json.lrCopyFiles = this.lrCopyFiles.getJson();
		_json.status = this.status;

		return _json;
	}
}
export class ChangeNoteDef {
	constructor(private _createdDate: Date, private _userNameId: string, private _userName: string, private _userType: string,
		private _noOfPanels: string, private _natureOfIssuesId: string, private _amountImpact: number, private _excessMatDetails: string,
		private _changeNoteTypeId: string, private _remark: string, private _timeConsumed: number,
		private _description: string, private _labourRate: number, private _fileUploadCN: GenFileUploads, private _issueDetails: string, private _correctiveAction: string,
		private _preventiveAction: string, private _submittedStatus: boolean, private _approverNameL1: string,
		private _approverNameL2: string, private _approvedBy: string, private _completedDate: Date, private _approvalStatus: string,
		private _comments: string, private _completedStatus: boolean, private _changeNoteNo: string, private _cancelReason: string, private _collapsed: boolean
	) {
		if (!this._submittedStatus) this._submittedStatus = false;
	}

	get createdDate(): Date {
		return this._createdDate;
	}
	set createdDate(_SetVal: Date) {
		this._createdDate = _SetVal;
	}
	get userNameId(): string {
		return this._userNameId;
	}
	set userNameId(_SetVal: string) {
		this._userNameId = _SetVal;
	}
	get userName(): string {
		return this._userName;
	}
	set userName(_SetVal: string) {
		this._userName = _SetVal;
	}
	get userType(): string {
		return this._userType;
	}
	set userType(_SetVal: string) {
		this._userType = _SetVal;
	}
	get noOfPanels(): string {
		return this._noOfPanels;
	}
	set noOfPanels(_SetVal: string) {
		this._noOfPanels = _SetVal;
	}
	get natureOfIssuesId(): string {
		return this._natureOfIssuesId;
	}
	set natureOfIssuesId(_SetVal: string) {
		this._natureOfIssuesId = _SetVal;
	}
	get amountImpact(): number {
		return this._amountImpact;
	}
	set amountImpact(_SetVal: number) {
		this._amountImpact = _SetVal;
	}
	get excessMatDetails(): string {
		return this._excessMatDetails;
	}
	set excessMatDetails(_SetVal: string) {
		this._excessMatDetails = _SetVal;
	}
	get changeNoteTypeId(): string {
		return this._changeNoteTypeId;
	}
	set changeNoteTypeId(_SetVal: string) {
		this._changeNoteTypeId = _SetVal;
	}
	get remark(): string {
		return this._remark;
	}
	set remark(_SetVal: string) {
		this._remark = _SetVal;
	}
	get timeConsumed(): number {
		return this._timeConsumed;
	}
	set timeConsumed(_SetVal: number) {
		this._timeConsumed = _SetVal;
	}
	get description(): string {
		return this._description;
	}
	set description(_SetVal: string) {
		this._description = _SetVal;
	}
	get labourRate(): number {
		return this._labourRate;
	}
	set labourRate(_SetVal: number) {
		this._labourRate = _SetVal;
	}
	get fileUploadCN(): GenFileUploads {
		return this._fileUploadCN;
	}
	set fileUploadCN(_SetVal: GenFileUploads) {
		this._fileUploadCN = _SetVal;
	}
	get issueDetails(): string {
		return this._issueDetails;
	}
	set issueDetails(_SetVal: string) {
		this._issueDetails = _SetVal;
	}
	get correctiveAction(): string {
		return this._correctiveAction;
	}
	set correctiveAction(_SetVal: string) {
		this._correctiveAction = _SetVal;
	}
	get preventiveAction(): string {
		return this._preventiveAction;
	}
	set preventiveAction(_SetVal: string) {
		this._preventiveAction = _SetVal;
	}
	get submittedStatus(): boolean {
		return this._submittedStatus;
	}
	set submittedStatus(_SetVal: boolean) {
		this._submittedStatus = _SetVal;
	}
	get approverNameL1(): string {
		return this._approverNameL1;
	}
	set approverNameL1(_SetVal: string) {
		this._approverNameL1 = _SetVal;
	}
	get approverNameL2(): string {
		return this._approverNameL2;
	}
	set approverNameL2(_SetVal: string) {
		this._approverNameL2 = _SetVal;
	}
	get approvedBy(): string {
		return this._approvedBy;
	}
	set approvedBy(_SetVal: string) {
		this._approvedBy = _SetVal;
	}
	get completedDate(): Date {
		return this._completedDate;
	}
	set completedDate(_SetVal: Date) {
		this._completedDate = _SetVal;
	}
	get approvalStatus(): string {
		return this._approvalStatus;
	}
	set approvalStatus(_SetVal: string) {
		this._approvalStatus = _SetVal;
	}
	get comments(): string {
		return this._comments;
	}
	set comments(_SetVal: string) {
		this._comments = _SetVal;
	}
	get completedStatus(): boolean {
		return this._completedStatus;
	}
	set completedStatus(_SetVal: boolean) {
		this._completedStatus = _SetVal;
	}
	get changeNoteNo(): string {
		return this._changeNoteNo;
	}
	set changeNoteNo(_SetVal: string) {
		this._changeNoteNo = _SetVal;
	}
	get cancelReason(): string {
		return this._cancelReason;
	}
	set cancelReason(_SetVal: string) {
		this._cancelReason = _SetVal;
	}
	get collapsed(): boolean {
		return this._collapsed;
	}
	set collapsed(_SetVal: boolean) {
		this._collapsed = _SetVal;
	}

	originalTimeConsumed: number;
	originalLabourRate: number;

	userEnable(_userLogged): boolean {
		let apNames = [];
		let ap1 = this.approverNameL1;
		if (ap1) {
			apNames.push(ap1);
		}
		let ap2 = this.approverNameL2;
		if (ap2) {
			apNames.push(ap2);
		}
		if (apNames.includes(_userLogged) == true) {
			return true;
		}
		else return false;
	}



	cloneSelf(): ChangeNoteDef {
		return new ChangeNoteDef(configDefs.cloneDt(this.createdDate), this.userNameId, this.userName, this.userType, this.noOfPanels, this.natureOfIssuesId,
			this.amountImpact, this.excessMatDetails, this.changeNoteTypeId, this.remark, this.timeConsumed,
			this.description, this.labourRate, this.fileUploadCN.cloneSelf(), this.issueDetails, this.correctiveAction, this.preventiveAction,
			this.submittedStatus, this.approverNameL1, this.approverNameL2, this.approvedBy, configDefs.cloneDt(this.completedDate), this.approvalStatus,
			this.comments, this.completedStatus, this.changeNoteNo, this.cancelReason, this.collapsed);
	}

	public static getObj(_json: any): ChangeNoteDef {
		return new ChangeNoteDef(GenService.convToDate(_json.crDate), _json.userNameId, _json.userName, _json.userType, _json.noOfPanels, _json.natureOfIssuesId,
			_json.amountImpact, _json.excessMatDetails, _json.changeNoteTypeId, _json.remark, _json.timeConsumed, _json.descp, _json.labourRate,
			GenFileUploads.getObj(_json.fileUploadCN), _json.issueDetails, _json.correAction, _json.preveAction,
			_json.submittedStatus, _json.approverNameL1, _json.approverNameL2, _json.approvedBy,
			GenService.convToDate(_json.completedDate), _json.approvalStatus, _json.comments, _json.completedStatus, _json.changeNoteNo,
			_json.cancelReason, _json.collapsed);
	}

	getJson(): any {
		let _json: any = {};
		_json.crDate = GenService.convToDateNum(this.createdDate);
		_json.userNameId = this.userNameId;
		_json.userName = this.userName;
		_json.userType = this.userType;
		_json.noOfPanels = this.noOfPanels;
		_json.natureOfIssuesId = this.natureOfIssuesId;
		_json.amountImpact = this.amountImpact;
		_json.excessMatDetails = this.excessMatDetails;
		_json.changeNoteTypeId = this.changeNoteTypeId;
		_json.remark = this.remark;
		_json.timeConsumed = this.timeConsumed;
		_json.descp = this.description;
		_json.labourRate = this.labourRate;
		_json.fileUploadCN = this.fileUploadCN.getJson();
		_json.issueDetails = this.issueDetails;
		_json.correAction = this.correctiveAction;
		_json.preveAction = this.preventiveAction;
		_json.submittedStatus = this.submittedStatus;
		_json.approverNameL1 = this.approverNameL1;
		_json.approverNameL2 = this.approverNameL2;
		_json.approvedBy = this.approvedBy;
		_json.completedDate = GenService.convToDateNum(this.completedDate);
		_json.approvalStatus = this.approvalStatus;
		_json.comments = this.comments;
		_json.completedStatus = this.completedStatus;
		_json.changeNoteNo = this.changeNoteNo;
		_json.cancelReason = this.cancelReason;
		_json.collapsed = true;

		return _json;
	}
}
export class ChangeNoteIP {
	constructor(private _changeData: Array<ChangeNoteDef>,
		private _status: FunctionStatus) {


	}
	private _parentSORef: SalesOrder;
	private _parentSubSORef: SubSalesOrder;

	get changeData(): Array<ChangeNoteDef> {
		return this._changeData;
	}
	set changeData(_SetVal: Array<ChangeNoteDef>) {
		this._changeData = _SetVal;
	}
	get isProjectLive(): boolean {
		return this.parentSubSORef.pmTechSubSalesOrder.projStatus == "live"
	}
	get isInputEnabled(): boolean {
		return true; // No dependency on other fields/templates
	}
	get isChangeNoteEditable(): boolean {
		if (this.parentSubSORef.isSSOStatusSet(SSOStatus.Dispatched)) {
			return false;
		}
		else return true;
	}

	refreshStatus() {
		// if (this.parentSORef && this.parentSubSORef && this.parentSORef.projectStatus >= SOStatus.Sub_Orders) {
		// 	if (this.parentSubSORef.isSSOStatusSet(SSOStatus.Production) == true) {
		// 		if (this.parentSubSORef.isSSOStatusSet(SSOStatus.Quality) == true) {

		// 			let _isTempComplete: boolean = this.isFunctionComplete();

		// 			if (_isTempComplete == true) {
		// 				this._status = FunctionStatus.SUBMITTED_COMPLETE;
		// 			}
		// 			else {
		// 				this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
		// 			}
		// 		}
		// 		else if ((configDefs.isDtEmty(this.lineLoadingActualDate) == false) && (configDefs.isDtEmty(this.mechanicalStickerActualDate) == true)) {
		// 			this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
		// 		}
		// 		else {
		// 			this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
		// 		}
		// 	}
		// 	else {
		// 		this._status = FunctionStatus.WAITING_FOR_PREV;
		// 	}
		// }
		// else {
		// 	this._status = FunctionStatus.WAITING_FOR_PREV;
		// }
		if (this.parentSORef && this.parentSubSORef && this.parentSORef.projectStatus >= SOStatus.Sub_Orders) {
			if (this.parentSubSORef.isSSOStatusSet(SSOStatus.Dispatched) != true) {
				let _hasData = this.changeData.length;
				if (_hasData > 0) {
					this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
				}
				else {
					this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
				}
			}
			else {
				this._status = FunctionStatus.WAITING_FOR_PREV;
			}


		}
	}
	private isFunctionComplete(): boolean {
		// if (configDefs.isDtEmty(this.lineLoadingActualDate)) return false;
		// if (configDefs.isDtEmty(this.mechanicalStickerPlannedDate)) return false;
		// if (configDefs.isDtEmty(this.mechanicalStickerRequestedDate)) return false;
		// if (configDefs.isDtEmty(this.mechanicalStickerActualDate)) return false;

		return true;
	}
	get parentSORef(): SalesOrder {
		return this._parentSORef;
	}
	set parentSORef(SORef: SalesOrder) {
		this._parentSORef = SORef;
		//this.refreshStatus();
	}
	get parentSubSORef(): SubSalesOrder {
		return this._parentSubSORef;
	}
	set parentSubSORef(SubSORef: SubSalesOrder) {
		this._parentSubSORef = SubSORef;
	}

	get status(): FunctionStatus {
		return this._status;
	}
	enableFormInput(): void {
		if (this._status == FunctionStatus.WAITING_FOR_PREV) {
			this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
		}
	}
	// addChangeNoteData(_userId,_userName, _userType) {
	// 	// this._changeData.push(new ChangeNoteDef(new Date(), _userId, _userName, _userType, "",
	// 	// 						"", null, "", "", "", null, "", new GenFileUploads([]), "", "", "", 
	// 	// 						false, "", "", "", null, "", "", false, ""));
	// 	this._changeData.unshift(new ChangeNoteDef(new Date(new Date().toDateString()), _userId, _userName, _userType, "",
	// 	"", null, "", "", "", null, "", null, new GenFileUploads([]), "", "", "", 
	// 	false, "", "", "", null, "", "", false, "", "", false));
	// }
	// removeChangeNoteData(_index: number) {
	// 	this._changeData.splice(_index, 1);
	// }

	cloneSelf() {
		let _tmpChangeNt: Array<ChangeNoteDef> = [];
		this.changeData.forEach((_Cdata: ChangeNoteDef) => {
			_tmpChangeNt.push(_Cdata.cloneSelf());
		})
		return new ChangeNoteIP(_tmpChangeNt,
			this._status);
	}

	public static emptyObj(): ChangeNoteIP {
		let changeNoteObj: ChangeNoteIP = new ChangeNoteIP([], FunctionStatus.WAITING_FOR_PREV)

		return changeNoteObj;

	}

	public static getObj(_json: any): ChangeNoteIP {
		let _changeData: Array<ChangeNoteDef> = [];
		if (_json.changeData) {
			for (var j = 0; j < _json.changeData.length; j++) {
				_changeData.push(ChangeNoteDef.getObj(_json.changeData[j]));
			}
		}

		// if (_changeData.length == 0) {
		// 	_changeData.push(new ChangeNoteDef(null,'', ''));
		// }

		return new ChangeNoteIP(_changeData, _json.subOrderStatus);
	}
	public getJson(): any {
		let _chgData: any = [];
		this.changeData.forEach((_cD: ChangeNoteDef) => {
			_chgData.push(_cD.getJson());
		})

		let _json: any = {};
		_json.changeData = _chgData;
		_json.status = this.status;
		return _json;
	}
}
export class SalesOrder {
	public tStamp: number;
	public sldPropagationLogs: Array<SLDPropagationLog> = [];
	public schemePropagationLogs: Array<SchemePropagationLog> = [];
	constructor(private _salesOrderId: string, private _marketingIP: MarketingIP, private _dataSheetIP: Array<DataSheetIP>, private _pmCommercial: PmCommercialIP,
		private _subSalesOrder: Array<SubSalesOrder>, private _projectStatus: SOStatus,
		private _dataChangeCount: number) {
		if (this._marketingIP) this._marketingIP.parentSORef = this;
		if (this._dataSheetIP) {
			for (var i = 0; i < this._dataSheetIP.length; i++) {
				this._dataSheetIP[i].parentSORef = this;
				this._dataSheetIP[i].refreshStatus();
			}

		}
		if (this._pmCommercial) this._pmCommercial.parentSORef = this;
		if (this._subSalesOrder) {
			for (var i = 0; i < this._subSalesOrder.length; i++) {
				this._subSalesOrder[i].parentSORef = this;
				this._subSalesOrder[i].refreshStatus();
			}

		}

		this.refreshStatus();
	}

	private refreshStatus() {
		if (this._marketingIP) this._marketingIP.refreshStatus();
		if (this._dataSheetIP) {
			for (var i = 0; i < this._dataSheetIP.length; i++) {
				this._dataSheetIP[i].refreshStatus();
			}
		}
		if (this._pmCommercial) this._pmCommercial.refreshStatus();
		if (this._subSalesOrder) {
			for (var i = 0; i < this._subSalesOrder.length; i++) {
				this._subSalesOrder[i].refreshStatus();
			}
		}
	}
	cloneSelf() {
		return new SalesOrder(this._salesOrderId, this._marketingIP, this._dataSheetIP, this._pmCommercial, this._subSalesOrder, this._projectStatus, this._dataChangeCount);
	}

	get projectStatus(): SOStatus {
		return this._projectStatus;
	}
	set projectStatus(_SetVal: SOStatus) {
		this._projectStatus = _SetVal;
	}
	get changeCounter(): number {
		return this._dataChangeCount;
	}
	set changeCounter(_setVal: number) {
		this._dataChangeCount = _setVal;
	}
	get isSubOrdesEnabled(): boolean {
		return this.projectStatus > SOStatus.PM_Commercial;
	}
	get salesOrderId(): string {
		return this._salesOrderId;
	}
	set salesOrderId(_SetVal: string) {
		this._salesOrderId = _SetVal;
	}
	get marketingIP(): MarketingIP {
		return this._marketingIP;
	}
	set marketingIP(_SetVal: MarketingIP) {
		this._marketingIP = _SetVal;
	}
	get dataSheetIP(): Array<DataSheetIP> {
		return this._dataSheetIP;
	}
	set dataSheetIP(_SetVal: Array<DataSheetIP>) {
		this._dataSheetIP = _SetVal;
	}
	get pmCommercial(): PmCommercialIP {
		return this._pmCommercial;
	}
	set pmCommercial(_SetVal: PmCommercialIP) {
		this._pmCommercial = _SetVal;
	}
	get subSalesOrder(): Array<SubSalesOrder> {
		return this._subSalesOrder;
	}
	set subSalesOrder(_SetVal: Array<SubSalesOrder>) {
		this._subSalesOrder = _SetVal;
	}
	get lastDispatchPlannedFromPlant_Initial(): Date {
		let _lastDispatchPlannedInitial: Date;
		for (var i = 0; i < this.subSalesOrder.length; i++) {
			if (_lastDispatchPlannedInitial) {
				if (_lastDispatchPlannedInitial < this.subSalesOrder[i].logisticIP.dispatchFromPlantPlannedDate_Initial) {
					_lastDispatchPlannedInitial = this.subSalesOrder[i].logisticIP.dispatchFromPlantPlannedDate_Initial
				}
			}
			else {
				_lastDispatchPlannedInitial = this.subSalesOrder[i].logisticIP.dispatchFromPlantPlannedDate_Initial;
			}
		}
		return configDefs.cloneDt(_lastDispatchPlannedInitial);
	}
	get lastDispatchPlannedFromPlant(): Date {
		let _lastDispatchPlanned: Date;
		for (var i = 0; i < this.subSalesOrder.length; i++) {

			// var _tmpDate = this.subSalesOrder[i].logisticIP.dispatchFromPlantRequestDate;
			// if(_tmpDate == null){
			var _tmpDate = this.subSalesOrder[i].logisticIP.dispatchFromPlantPlannedDate;
			// }

			if (_lastDispatchPlanned) {
				if (_lastDispatchPlanned < _tmpDate) {
					_lastDispatchPlanned = _tmpDate;
				}
			}
			else {
				_lastDispatchPlanned = _tmpDate;
			}
		}
		return configDefs.cloneDt(_lastDispatchPlanned);
	}
	get lastDispatchRequestedFromPlant(): Date {
		let _lastrequestedPlanned: Date;
		for (var i = 0; i < this.subSalesOrder.length; i++) {
			if (_lastrequestedPlanned) {
				if (_lastrequestedPlanned < this.subSalesOrder[i].logisticIP.dispatchFromPlantRequestDate) {
					_lastrequestedPlanned = this.subSalesOrder[i].logisticIP.dispatchFromPlantRequestDate
				}
			}
			else {
				_lastrequestedPlanned = this.subSalesOrder[i].logisticIP.dispatchFromPlantRequestDate;
			}
		}
		return configDefs.cloneDt(_lastrequestedPlanned);
	}

	get lastDrawingApprovalPlannedDate(): Date {
		let _lastDrawAprvlPlanned: Date;
		for (var i = 0; i < this.subSalesOrder.length; i++) {
			if (_lastDrawAprvlPlanned) {
				if (_lastDrawAprvlPlanned < this.subSalesOrder[i].pmTechSubSalesOrder.plannedDrawingApprovalDate) {
					_lastDrawAprvlPlanned = this.subSalesOrder[i].pmTechSubSalesOrder.plannedDrawingApprovalDate;
				}
			}
			else {
				_lastDrawAprvlPlanned = this.subSalesOrder[i].pmTechSubSalesOrder.plannedDrawingApprovalDate;
			}
		}
		return configDefs.cloneDt(_lastDrawAprvlPlanned);
	}
	get lastActOrPlndDrawingApprovalIndex(): number {
		let _lastDrawAprvlActOrPlnd: Date;
		let _lastDrawAprvActOrPlndIndex: number = -1;
		for (var i = 0; i < this.subSalesOrder.length; i++) {
			if (_lastDrawAprvlActOrPlnd) {
				if (_lastDrawAprvlActOrPlnd < this.subSalesOrder[i].pmTechSubSalesOrder.actOrPlndDrawingApprovalDate) {
					_lastDrawAprvlActOrPlnd = this.subSalesOrder[i].pmTechSubSalesOrder.actOrPlndDrawingApprovalDate;
					_lastDrawAprvActOrPlndIndex = i;
				}
			}
			else {
				_lastDrawAprvlActOrPlnd = this.subSalesOrder[i].pmTechSubSalesOrder.actOrPlndDrawingApprovalDate;
				_lastDrawAprvActOrPlndIndex = i;
			}
		}
		return _lastDrawAprvActOrPlndIndex;
	}

	get lastContractualDate(): Date {
		var _tmpDate = null;
		for (var i = 0; i < this.subSalesOrder.length; i++) {
			if (this.subSalesOrder[i].pmTechSubSalesOrder.plannedContractualDeliveryDate) {
				if (_tmpDate == null || _tmpDate < this.subSalesOrder[i].pmTechSubSalesOrder.plannedContractualDeliveryDate) {
					_tmpDate = this.subSalesOrder[i].pmTechSubSalesOrder.plannedContractualDeliveryDate;
				}
			}
		}
		return _tmpDate;
	}
	get lastDrawingApprovalActualDate(): Date {
		let _lastDrwAprvlPlndIndex: number = this.lastActOrPlndDrawingApprovalIndex;
		if (_lastDrwAprvlPlndIndex >= 0) {
			return this.subSalesOrder[_lastDrwAprvlPlndIndex].pmTechSubSalesOrder.actualDrawingApprovalDate;
		}
		return null;
	}
	isDataFilledCompletely(): boolean {
		var _isDataFilled: boolean = true;
		this.marketingIP.refreshStatus();
		if (this.marketingIP.status != FunctionStatus.SUBMITTED_COMPLETE) {
			return false;
		}

		this.pmCommercial.refreshStatus();
		if (this.pmCommercial.status != FunctionStatus.SUBMITTED_COMPLETE) {
			return false;
		}

		for (var i = 0; i < this._subSalesOrder.length; i++) {
			if (this._subSalesOrder[i].isDataFilledCompletely() == false) {
				return false;
			}
		}
		return _isDataFilled;
	}
	getSubOrderClone(_subOrderNumId: string): SubSalesOrder {
		for (var i = 0; i < this._subSalesOrder.length; i++) {
			if (this._subSalesOrder[i].subOrderNoId == _subOrderNumId) {
				return this._subSalesOrder[i].cloneSelf();
			}
		}
		return null;
	}
	getSubOrderCloneMainContent(_subOrderNumId: string): SubSalesOrder {
		for (var i = 0; i < this._subSalesOrder.length; i++) {
			if (this._subSalesOrder[i].subOrderNoId == _subOrderNumId) {
				return this._subSalesOrder[i].cloneMinimal();
			}
		}
		return null;
	}
	getDataSheetCloneMainContent(_subOrderNumId: string): DataSheetIP {
		for (var i = 0; i < this._dataSheetIP.length; i++) {
			if (this._dataSheetIP[i].dataSheetId == _subOrderNumId) {
				return this._dataSheetIP[i].cloneMinimal();
			}
		}
		return null;
	}
	static getEmptySubOrder(subSalesOrderNo: string): SubSalesOrder {
		let pmTechSubSalesOrderObj: PmTechnicalIP;
		let scmObj: ScmIP;
		let enggDrawObj: EnggDrawIP;
		let enggProcureObj: EnggProcureIP;
		let purchasePOObj: PurchasePOIP;
		let planningObj: PlanningIP;
		let purchaseMatRecptObj: PurchaseMaterialReceiptIP;
		let storeObj: StoreIP;
		let productionObj: ProductionIP;
		let qualityObj: QualityIP;
		let logisticObj: LogisticIP;
		let changeNoteObj: ChangeNoteIP;
		let dataSheetSubOrderObj: DataSheetSubOrderIP;
		let subSaleOrderObj: SubSalesOrder;

		let brkps: BreakerPS = new BreakerPS("", 0);
		let brkpslist: Array<BreakerPS> = [];
		brkpslist.push(brkps);
		let eqipment: Equipment = new Equipment("", "", "", "", "", "", "", 0, brkpslist);
		let eqipmentList: Array<Equipment> = [];
		eqipmentList.push(eqipment);

		let comments: CommentsOnSubmission = new CommentsOnSubmission(null, null);
		let commentsList: Array<CommentsOnSubmission> = [];
		commentsList.push(comments);

		pmTechSubSalesOrderObj = new PmTechnicalIP(
			"", new GenFileUploads([]), "", "", "", "live", "", "", "", "", "", "", "", "",
			new PlannedDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''),
			null,
			new PlannedDateToken(null, false, null, '', ''),
			null, null, null,
			new PlannedDateToken(null, false, null, '', ''), // ROTD
			"", "", "", "", "", "", "", eqipmentList, "", "", "", "", "", "", "", "", "", commentsList,
			new PlannedDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''),
			new GenFileUploads([]), "",
			new PlannedDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''), null, "",
			new PlannedDateToken(null, false, null, '', ''),
			new RequestDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''),
			FunctionStatus.WAITING_FOR_USER_INPUT
			, null); // TEST FOR COMMENTS

		enggDrawObj = new EnggDrawIP("", "", "001", new ActualDateToken(null, false, null, '', ''), new ActualDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''), new ActualDateToken(null, false, null, '', ''), new ActualDateToken(null, false, null, '', ''),
			// STARTS
			new PlannedDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''),
			// ENDS
			new GenFileUploads([]), new GenFileUploads([]), new GenFileUploads([]), new GenFileUploads([]), new GenFileUploads([]), "",
			new PlannedDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''), FunctionStatus.WAITING_FOR_PREV);
		scmObj = new ScmIP(new PlannedDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''), new PlannedDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''), FunctionStatus.WAITING_FOR_PREV);
		enggProcureObj = new EnggProcureIP(new PlannedDateToken(null, false, null, '', ''), new PlannedDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''), new PlannedDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''), new ActualDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''), new ActualDateToken(null, false, null, '', ''), null,
			new EnggProcFileUploads([]), new EnggProcFileUploads([]), new EnggProcFileUploads([]),
			new EnggProcFileUploads([]), new EnggProcFileUploads([]), new GenFileUploads([]),
			new GenFileUploads([]), new GenFileUploads([]), FunctionStatus.WAITING_FOR_PREV);

		purchasePOObj = new PurchasePOIP(new PlannedDateToken(null, false, null, '', ''), new PlannedDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''), new PlannedDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''), new PlannedDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''), new PlannedDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''), new ActualDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''), new ActualDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''), new ActualDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''), new ActualDateToken(null, false, null, '', '')
			, FunctionStatus.WAITING_FOR_PREV);
		planningObj = new PlanningIP(null, null,
			new PlannedDateToken(null, false, null, '', ''), new RequestDateToken(null, false, null, '', ''), null, "",
			new PlannedDateToken(null, false, null, '', ''), new RequestDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''), [], [], [], null, null, FunctionStatus.WAITING_FOR_PREV);

		purchaseMatRecptObj = new PurchaseMaterialReceiptIP(
			new PlannedDateToken(null, false, null, '', ''), null, null, new ActualDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''), null, null, new ActualDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''), null, null, new ActualDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''), null, null, new ActualDateToken(null, false, null, '', ''), null, null, null, null, null, null, null,
			new PlannedDateToken(null, false, null, '', ''), null, null, new ActualDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''), null, null, new ActualDateToken(null, false, null, '', ''), null,
			new PlannedDateToken(null, false, null, '', ''), null, null, new ActualDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''), null, null, new ActualDateToken(null, false, null, '', ''), null,
			new PlannedDateToken(null, false, null, '', ''), null, null, new ActualDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''), null, null, new ActualDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''), null, null, new ActualDateToken(null, false, null, '', ''),
			FunctionStatus.WAITING_FOR_PREV);

		storeObj = new StoreIP(
			new PlannedDateToken(null, false, null, '', ''),
			null, new ActualDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''),
			new RequestDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''),
			new GenFileUploads([]), new GenFileUploads([]),
			FunctionStatus.WAITING_FOR_PREV);


		productionObj = new ProductionIP(new ActualDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''),
			new RequestDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''), FunctionStatus.WAITING_FOR_PREV);
		qualityObj = new QualityIP(
			new PlannedDateToken(null, false, null, '', ''), new RequestDateToken(null, false, null, '', ''), new ActualDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''), new RequestDateToken(null, false, null, '', ''), new ActualDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''), new RequestDateToken(null, false, null, '', ''), new ActualDateToken(null, false, null, '', ''),
			new GenFileUploads([]), new GenFileUploads([]), null, null, FunctionStatus.WAITING_FOR_PREV);
		logisticObj = new LogisticIP(new PlannedDateToken(null, false, null, '', '')
			, new RequestDateToken(null, false, null, '', ''), [
			new PartialDelivery(null, new ActualDateToken(null, false, null, '', ''), null)
		], null, null,
			new GenFileUploads([]), new GenFileUploads([]), new GenFileUploads([]), new GenFileUploads([]), new GenFileUploads([]),
			new GenFileUploads([]), new GenFileUploads([]), FunctionStatus.WAITING_FOR_PREV);

		let changeData: ChangeNoteDef = new ChangeNoteDef(null, '', '', '', '', '', null, '', '', '', null, '', null, new GenFileUploads([]),
			"", "", "", false, "", "", "", null, "", "", false, "", "", true)

		let changeDataList: Array<ChangeNoteDef> = [];
		changeDataList.push(changeData);

		changeNoteObj = new ChangeNoteIP(changeDataList, FunctionStatus.WAITING_FOR_PREV);

		dataSheetSubOrderObj = null;

		subSaleOrderObj = new SubSalesOrder(subSalesOrderNo, pmTechSubSalesOrderObj, enggDrawObj,
			scmObj, enggProcureObj, purchasePOObj, planningObj, purchaseMatRecptObj,
			storeObj, productionObj, qualityObj, logisticObj, changeNoteObj, dataSheetSubOrderObj, SSOStatus.PM_Tech);
		return subSaleOrderObj;
	}
	public static getEmptyDataSheetObj(datasheetNo: string, datasheetType: string, createdByName: string, createdByMailId: string): DataSheetIP {
		let dsGeneralObj: DsGeneralIP;
		let dsPanelObj: DsPanelIP;
		let dataSheetObj: DataSheetIP;
		let dsBusbarsObj: DsBusbarsIP;
		let dsPaintingObj: DsPaintingIP;
		let dsControlAuxObj: DsControlAuxIP;
		let dsControlWiringObj: DsControlWiringIP;
		let dsTerminalBlocksObj: DsTerminalBlocksIP;
		let dsCircuitBreakerObj: DsCircuitBreakerIP;
		let dsCurrentTrafoObj: DsCurrentTrafoIP;
		let dsPotentialTrafoObj: DsPotentialTrafoIP;
		let dsNumericalRelayObj: DsNumericalRelayIP;
		let dsAuxRelayObj: DsAuxRelayIP;
		let dsMetersObj: DsMetersIP;
		let dsSurgeArrestorObj: DsSurgeArrestorIP;
		let dsAnnuciatorObj: DsAnnuciatorIP;
		let dsSwitchesObj: DsSwitchesIP;
		let dsEthernetSwitchesObj: DsEthernetSwitchesIP;
		let dsEarthingDevicesObj: DsEarthingDevicesIP;
		let dsSpecialDevicesObj: DsSpecialDevicesIP;
		let dsFoundationFrameObj: DsFoundationFrameIP;
		let dsSwbAccessoriesQtyObj: DsSwbAccessoriesQtyIP;

		let feederBPDS: MultiOptDetails_9DS = new MultiOptDetails_9DS("", "", "001", "", "", "", "", "", "");
		let feederBPDSlist: Array<MultiOptDetails_9DS> = [];
		feederBPDSlist.push(feederBPDS);

		let feederNbDS: MultiOptDetails_3DS = new MultiOptDetails_3DS("", "", "");
		let feederNbDSlist: Array<MultiOptDetails_3DS> = [];
		feederNbDSlist.push(feederNbDS);

		let sptColorDS: MultiOptDetails_3DS = new MultiOptDetails_3DS("", "", "");
		let sptColorDSlist: Array<MultiOptDetails_3DS> = [];
		sptColorDSlist.push(sptColorDS);

		let uvCoilDS: MultiOptDetails_1DS = new MultiOptDetails_1DS("");
		let uvCoilDSlist: Array<MultiOptDetails_1DS> = [];
		uvCoilDSlist.push(uvCoilDS);

		let ctMouldDS: MultiOptDetails_8DS = new MultiOptDetails_8DS("", "", "", "", "", "", "", "");
		let ctMouldDSlist: Array<MultiOptDetails_8DS> = [];
		ctMouldDSlist.push(ctMouldDS);

		let ptMountingTyDS: MultiOptDetails_3DS = new MultiOptDetails_3DS("", "", "");
		let ptMountingTyDSlist: Array<MultiOptDetails_3DS> = [];
		ptMountingTyDSlist.push(ptMountingTyDS);

		let trReqDS: MultiOptDetails_2DS = new MultiOptDetails_2DS("", "");
		let trReqDSlist: Array<MultiOptDetails_2DS> = [];
		trReqDSlist.push(trReqDS);

		let multiFDS: MultiOptDetails_6DS = new MultiOptDetails_6DS("", "", "", "", "", "");
		let multiFDSlist: Array<MultiOptDetails_6DS> = [];
		multiFDSlist.push(multiFDS);

		let triVecDS: MultiOptDetails_6DS = new MultiOptDetails_6DS("", "", "", "", "", "");
		let triVecDSlist: Array<MultiOptDetails_6DS> = [];
		triVecDSlist.push(triVecDS);

		let srDS: MultiOptDetails_3DS = new MultiOptDetails_3DS("", "", "");
		let srDSlist: Array<MultiOptDetails_3DS> = [];
		srDSlist.push(srDS);

		let annDS: MultiOptDetails_5DS = new MultiOptDetails_5DS("", "", "", "", "");
		let annDSlist: Array<MultiOptDetails_5DS> = [];
		annDSlist.push(annDS);

		let sdTempScannerDS: MultiOptDetails_2DS = new MultiOptDetails_2DS("", "");
		let sdTempScannerDSlist: Array<MultiOptDetails_2DS> = [];
		sdTempScannerDSlist.push(sdTempScannerDS);

		let sdCurrTransducerDS: MultiOptDetails_2DS = new MultiOptDetails_2DS("", "");
		let sdCurrTransducerDSlist: Array<MultiOptDetails_2DS> = [];
		sdCurrTransducerDSlist.push(sdCurrTransducerDS);

		let sdVoltTransducerDS: MultiOptDetails_2DS = new MultiOptDetails_2DS("", "");
		let sdVoltTransducerDSlist: Array<MultiOptDetails_2DS> = [];
		sdVoltTransducerDSlist.push(sdVoltTransducerDS);

		let sdPowerTransducerDS: MultiOptDetails_2DS = new MultiOptDetails_2DS("", "");
		let sdPowerTransducerDSlist: Array<MultiOptDetails_2DS> = [];
		sdPowerTransducerDSlist.push(sdPowerTransducerDS);

		let sdMultiFuncTransducerDS: MultiOptDetails_2DS = new MultiOptDetails_2DS("", "");
		let sdMultiFuncTransducerDSlist: Array<MultiOptDetails_2DS> = [];
		sdMultiFuncTransducerDSlist.push(sdMultiFuncTransducerDS);

		let additionalPointsDS: MultiOptDetails_4DS = new MultiOptDetails_4DS("", "", "", "");
		let additionalPointsDSlist: Array<MultiOptDetails_4DS> = [];
		additionalPointsDSlist.push(additionalPointsDS);


		dsGeneralObj = new DsGeneralIP("", "", "", "", "", "", "", "", "", "", null, "", "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsPanelObj = new DsPanelIP("", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "",
			"", "", "", "", "", "", "", "", "", "", "", "", "", "", feederBPDSlist, "", "", "", "", "", "", feederNbDSlist, "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsBusbarsObj = new DsBusbarsIP("", "", "", "", "", "", "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsPaintingObj = new DsPaintingIP("", "", "", sptColorDSlist, "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsControlAuxObj = new DsControlAuxIP("", "", "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsControlWiringObj = new DsControlWiringIP("", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsTerminalBlocksObj = new DsTerminalBlocksIP("", "", "", "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsCircuitBreakerObj = new DsCircuitBreakerIP("", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", uvCoilDSlist, "", "", "", "", "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsCurrentTrafoObj = new DsCurrentTrafoIP("", ctMouldDSlist, "", "", "", "", "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsPotentialTrafoObj = new DsPotentialTrafoIP("", ptMountingTyDSlist, "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsNumericalRelayObj = new DsNumericalRelayIP("", "", "", "", "", "", "", "", "", "", trReqDSlist, "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsAuxRelayObj = new DsAuxRelayIP("", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsMetersObj = new DsMetersIP(multiFDSlist, triVecDSlist, "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsSurgeArrestorObj = new DsSurgeArrestorIP(srDSlist, "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsAnnuciatorObj = new DsAnnuciatorIP(annDSlist, "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsSwitchesObj = new DsSwitchesIP("", "", "", "", "", "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsEthernetSwitchesObj = new DsEthernetSwitchesIP("", "", "", "", "", "", "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsEarthingDevicesObj = new DsEarthingDevicesIP("", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsSpecialDevicesObj = new DsSpecialDevicesIP("", "", "", "", "", "", "", "", "", sdTempScannerDSlist, sdCurrTransducerDSlist, sdVoltTransducerDSlist,
			sdPowerTransducerDSlist, sdMultiFuncTransducerDSlist, "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsFoundationFrameObj = new DsFoundationFrameIP("", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsSwbAccessoriesQtyObj = new DsSwbAccessoriesQtyIP(null, null, null, null, null, null, "", "", additionalPointsDSlist, "", "", "", FunctionStatus.WAITING_FOR_PREV);


		dataSheetObj = new DataSheetIP(datasheetNo, datasheetType, dsGeneralObj, dsPanelObj, dsBusbarsObj, dsPaintingObj, dsControlAuxObj, dsControlWiringObj,
			dsTerminalBlocksObj, dsCircuitBreakerObj, dsCurrentTrafoObj, dsPotentialTrafoObj, dsNumericalRelayObj, dsAuxRelayObj, dsMetersObj, dsSurgeArrestorObj,
			dsAnnuciatorObj, dsSwitchesObj, dsEthernetSwitchesObj, dsEarthingDevicesObj, dsSpecialDevicesObj, dsFoundationFrameObj, dsSwbAccessoriesQtyObj,
			createdByName, createdByMailId, new Date(new Date().toDateString()), FunctionStatus.WAITING_FOR_USER_INPUT);
		return dataSheetObj;
	}

	getProjDetails(): string {
		if (this.marketingIP && this.marketingIP.salesOrderNo && this.marketingIP.salesOrderNo != '') {
			return ' (' + this.marketingIP.salesOrderNo +
				(this.marketingIP.customerName && this.marketingIP.customerName != ''
					? ', ' + this.marketingIP.customerName : '')
				+ ')';
		}
		return '';
	}
	addNewSSO(_newSSO: SubSalesOrder) {
		_newSSO.parentSORef = this;
		this._subSalesOrder.push(_newSSO);
	}
	addNewDS(_newDS: DataSheetIP) {
		_newDS.parentSORef = this;
		this._dataSheetIP.push(_newDS);
	}
	get marketingDays(): number {
		return this._marketingIP.marketingDays;
	}
	get marketingDaysTip(): string {
		return this._marketingIP.marketingDaysTooltip;
	}
	get ordertype(): string {
		return this._marketingIP.ordertypeId;
	}
	// get revenueMonths():Array<Date>{
	// 	let _months:Array<Date> = [];
	// 	this.subSalesOrder.forEach((_subOrder:SubSalesOrder) => {
	// 		if(_subOrder.isSSOStatusSet(SSOStatus.Dispatched) == false && _subOrder.pmTechSubSalesOrder && _subOrder.pmTechSubSalesOrder.plannedRevnueMonth){
	// 			let _revMonth:Date = _subOrder.pmTechSubSalesOrder.plannedRevnueMonth;
	// 			let _tmpMonth = _months.find((_month:Date) => {
	// 				return (_revMonth.getFullYear() == _month.getFullYear() && _revMonth.getMonth() == _month.getMonth());
	// 			});
	// 			if(_tmpMonth == null){
	// 				_months.push(_revMonth);
	// 			}
	// 		}
	// 	});
	// 	return _months;
	// }
	// get manufacturingMonths():Array<Date>{
	// 	let _months:Array<Date> = [];
	// 	this.subSalesOrder.forEach((_subOrder:SubSalesOrder) => {
	// 		if(_subOrder.isSSOStatusSet(SSOStatus.Dispatched) == false && _subOrder.planningIP && _subOrder.planningIP.plannedManufacturingMonth){
	// 			let _planManfMonth:Date = _subOrder.planningIP.plannedManufacturingMonth;
	// 			let _tmpMonth = _months.find((_month:Date) => {
	// 				return (_planManfMonth.getFullYear() == _month.getFullYear() && _planManfMonth.getMonth() == _month.getMonth());
	// 			});
	// 			if(_tmpMonth == null){
	// 				_months.push(_planManfMonth);
	// 			}
	// 		}
	// 	});
	// 	return _months;
	// }
	get marketingStatus(): FunctionStatus {
		if (this.marketingIP && this.marketingIP.status) {
			return this.marketingIP.status;
		}
		return FunctionStatus.WAITING_FOR_PREV;
	}
	get dataSheetStatus(): FunctionStatus {
		if (this.projectStatus == SOStatus.Sub_Orders) {
			return FunctionStatus.WAITING_FOR_USER_INPUT;
		}
		if (this.projectStatus == SOStatus.Dispatched) {
			//need to add complete/incomplete logic for this
			return FunctionStatus.SUBMITTED_INCOMPLETE;
		}
		return FunctionStatus.WAITING_FOR_PREV;
	}
	get pmCommercialStatus(): FunctionStatus {
		if (this.pmCommercial && this.pmCommercial.status) {
			return this.pmCommercial.status;
		}
		return FunctionStatus.WAITING_FOR_PREV;
	}
	get subOrdersStatus(): FunctionStatus {
		if (this.projectStatus == SOStatus.Sub_Orders) {
			return FunctionStatus.WAITING_FOR_USER_INPUT;
		}
		if (this.projectStatus == SOStatus.Dispatched) {
			//need to add complete/incomplete logic for this
			return FunctionStatus.SUBMITTED_INCOMPLETE;
		}
		return FunctionStatus.WAITING_FOR_PREV;
	}

	get hasDatasheetInSO(): boolean {
		if (this._dataSheetIP && this._dataSheetIP.length > 0) {
			return true;
		}
		return false;
	}

	hasDatasheetInSubSO(_dsData): boolean {
		let _isTmp = this._subSalesOrder.findIndex(sso => sso.dataSheetSubOrderIP.dataSheetId == _dsData.parentDSRef.dataSheetId)
		if (_isTmp >= 0) {
			return true;
		}
		return false;
	}

	get isDatasheetSubOrderEnabled(): boolean {
		if (this.marketingIP.marketingHandoverDetails.handoverStatus == 'Approved' && this.marketingIP.pmHandoverDetails.handoverStatus == 'Approved' &&
			this.marketingIP.electricalEnggHandoverDetails.handoverStatus == 'Approved' && this.marketingIP.mechanicalEnggHandoverDetails.handoverStatus == 'Approved') {
			return true;
		}
		return false;
	}

	get isDatasheetAllApprovalsDone(): boolean {
		if (this.marketingIP.marketingHandoverDetails.handoverStatus && this.marketingIP.pmHandoverDetails.handoverStatus &&
			this.marketingIP.electricalEnggHandoverDetails.handoverStatus && this.marketingIP.mechanicalEnggHandoverDetails.handoverStatus) {
			return true;
		}
		return false;
	}

	get isDatasheetPMTechnicalEnabled(): boolean {
		if (this.marketingIP.pmHandoverDetails.handoverStatus) {
			return true;
		}
		return false;
	}
	get isDatasheetEnggEnabled(): boolean {
		if (this.marketingIP.electricalEnggHandoverDetails.handoverStatus && this.marketingIP.mechanicalEnggHandoverDetails.handoverStatus) {
			return true;
		}
		return false;
	}
	private static getSubSalesOrderObjList(subSoListJson: any): Array<SubSalesOrder> {
		let _subSoArray: Array<SubSalesOrder> = [];
		for (var i = 0; i < subSoListJson.length; i++) {

			_subSoArray.push(SubSalesOrder.getObj(subSoListJson[i]));
		}
		return _subSoArray;
	}
	private static getDataSheetObjList(dsListJson: any): Array<DataSheetIP> {
		let _dataSheetArray: Array<DataSheetIP> = [];
		// if(dsListJson!= undefined && dsListJson!= null && dsListJson.length > 0){
		for (var i = 0; i < dsListJson.length; i++) {

			_dataSheetArray.push(DataSheetIP.getObj(dsListJson[i]));
		}
		// }
		// else {
		// 	_dataSheetArray.push(DataSheetIP.getEmptyDataSheetObj());
		// }
		return _dataSheetArray;
	}

	public static getObj(_json: any, _tStamp: any): SalesOrder {
		let _retSO: SalesOrder = new SalesOrder(_json.salesOrdId,
			MarketingIP.getObj(_json.mktInp),
			_json.dataSheet ? SalesOrder.getDataSheetObjList(_json.dataSheet) : [],
			PmCommercialIP.getObj(_json.comIP),
			SalesOrder.getSubSalesOrderObjList(_json.subOrdrs),
			_json.projectStatus, _json.dataChangeCount);

		_retSO.tStamp = _tStamp;
		if (Array.isArray(_json.sldPropagationLogs)) {
			for (let i = 0; i < _json.sldPropagationLogs.length; i++) {
				let _log = SLDPropagationLog.getObj(_json.sldPropagationLogs[i]);
				if (_log) _retSO.sldPropagationLogs.push(_log);
			}
		}
		if (Array.isArray(_json.schemePropagationLogs)) {
			for (let i = 0; i < _json.schemePropagationLogs.length; i++) {
				let _log = SchemePropagationLog.getObj(_json.schemePropagationLogs[i]);
				if (_log) _retSO.schemePropagationLogs.push(_log);
			}
		}
		return _retSO;
	}

	public getJson(): any {
		let _json: any = {};

		_json.salesOrdId = this.salesOrderId;
		_json.mktInp = this._marketingIP.getJson();
		_json.dataSheet = [];
		for (var i = 0; i < this._dataSheetIP.length; i++) {
			_json.dataSheet.push(this._dataSheetIP[i].getJson());
		}
		_json.comIP = this._pmCommercial.getJson();
		//_json.techIPSalesOrd = this._pmTechSalesOrder.getJson();
		_json.projectStatus = this.projectStatus;
		_json.dataChangeCount = this._dataChangeCount;
		_json.subOrdrs = [];
		for (var i = 0; i < this._subSalesOrder.length; i++) {
			_json.subOrdrs.push(this._subSalesOrder[i].getJson());
		}
		_json.sldPropagationLogs = [];
		if (this.sldPropagationLogs) {
			for (var i = 0; i < this.sldPropagationLogs.length; i++) {
				_json.sldPropagationLogs.push(this.sldPropagationLogs[i].getJson());
			}
		}
		_json.schemePropagationLogs = [];
		if (this.schemePropagationLogs) {
			for (var i = 0; i < this.schemePropagationLogs.length; i++) {
				_json.schemePropagationLogs.push(this.schemePropagationLogs[i].getJson());
			}
		}
		_json.ts = this.tStamp;
		return _json;
	}
}
export class DataSheetIP {

	constructor(private _dataSheetId: string, private _dataSheetType: string, private _dsGeneralIP: DsGeneralIP, private _dsPanelIP: DsPanelIP, private _dsBusbarsIP: DsBusbarsIP,
		private _dsPaintingIP: DsPaintingIP, private _dsControlAuxIP: DsControlAuxIP, private _dsControlWiringIP: DsControlWiringIP, private _dsTerminalBlocksIP: DsTerminalBlocksIP,
		private _dsCircuitBreakerIP: DsCircuitBreakerIP, private _dsCurrentTrafoIP: DsCurrentTrafoIP, private _dsPotentialTrafoIP: DsPotentialTrafoIP, private _dsNumericalRelayIP: DsNumericalRelayIP,
		private _dsAuxRelayIP: DsAuxRelayIP, private _dsMetersIP: DsMetersIP, private _dsSurgeArrestorIP: DsSurgeArrestorIP, private _dsAnnuciatorIP: DsAnnuciatorIP, private _dsSwitchesIP: DsSwitchesIP,
		private _dsEthernetSwitchesIP: DsEthernetSwitchesIP, private _dsEarthingDevicesIP: DsEarthingDevicesIP, private _dsSpecialDevicesIP: DsSpecialDevicesIP,
		private _dsFoundationFrameIP: DsFoundationFrameIP, private _dsSwbAccessoriesQtyIP: DsSwbAccessoriesQtyIP,
		private _createdByName: string, private _createdByMailId: string, private _createdDate: Date, private _status: FunctionStatus) {
		this._dsGeneralIP.parentDSRef = this;
		this._dsPanelIP.parentDSRef = this;
		this._dsBusbarsIP.parentDSRef = this;
		this._dsPaintingIP.parentDSRef = this;
		this._dsControlAuxIP.parentDSRef = this;
		this._dsControlWiringIP.parentDSRef = this;
		this._dsTerminalBlocksIP.parentDSRef = this;
		this._dsCircuitBreakerIP.parentDSRef = this;
		this._dsCurrentTrafoIP.parentDSRef = this;
		this._dsPotentialTrafoIP.parentDSRef = this;
		this._dsNumericalRelayIP.parentDSRef = this;
		this._dsAuxRelayIP.parentDSRef = this;
		this._dsMetersIP.parentDSRef = this;
		this._dsSurgeArrestorIP.parentDSRef = this;
		this._dsAnnuciatorIP.parentDSRef = this;
		this._dsSwitchesIP.parentDSRef = this;
		this._dsEthernetSwitchesIP.parentDSRef = this;
		this._dsEarthingDevicesIP.parentDSRef = this;
		this._dsSpecialDevicesIP.parentDSRef = this;
		this._dsFoundationFrameIP.parentDSRef = this;
		this._dsSwbAccessoriesQtyIP.parentDSRef = this;
	}

	private _parentSORef: SalesOrder;

	get parentSORef(): SalesOrder {
		return this._parentSORef;
	}
	set parentSORef(SORef: SalesOrder) {
		this._parentSORef = SORef;
		this._dsGeneralIP.parentSORef = SORef;
		this._dsPanelIP.parentSORef = SORef;
		this._dsBusbarsIP.parentSORef = SORef;
		this._dsPaintingIP.parentSORef = SORef;
		this._dsControlAuxIP.parentSORef = SORef;
		this._dsControlWiringIP.parentSORef = SORef;
		this._dsTerminalBlocksIP.parentSORef = SORef;
		this._dsCircuitBreakerIP.parentSORef = SORef;
		this._dsCurrentTrafoIP.parentSORef = SORef;
		this._dsPotentialTrafoIP.parentSORef = SORef;
		this._dsNumericalRelayIP.parentSORef = SORef;
		this._dsAuxRelayIP.parentSORef = SORef;
		this._dsMetersIP.parentSORef = SORef;
		this._dsSurgeArrestorIP.parentSORef = SORef;
		this._dsAnnuciatorIP.parentSORef = SORef;
		this._dsSwitchesIP.parentSORef = SORef;
		this._dsEthernetSwitchesIP.parentSORef = SORef;
		this._dsEarthingDevicesIP.parentSORef = SORef;
		this._dsSpecialDevicesIP.parentSORef = SORef;
		this._dsFoundationFrameIP.parentSORef = SORef;
		this._dsSwbAccessoriesQtyIP.parentSORef = SORef;

	}
	get isInputEnabled(): boolean {
		return true; // No dependency on other fields/templates
	}
	get isDatasheetEditable(): boolean {
		if (this.parentSORef.projectStatus == SOStatus.Dispatched) {
			return false;
		}
		else return true;
	}
	public refreshStatus() {
		this._dsGeneralIP.refreshStatus();
		this._dsPanelIP.refreshStatus();
		this._dsBusbarsIP.refreshStatus();
		this._dsPaintingIP.refreshStatus();
		this._dsControlAuxIP.refreshStatus();
		this._dsControlWiringIP.refreshStatus();
		this._dsTerminalBlocksIP.refreshStatus();
		this._dsCircuitBreakerIP.refreshStatus();
		this._dsCurrentTrafoIP.refreshStatus();
		this._dsPotentialTrafoIP.refreshStatus();
		this._dsNumericalRelayIP.refreshStatus();
		this._dsAuxRelayIP.refreshStatus();
		this._dsMetersIP.refreshStatus();
		this._dsSurgeArrestorIP.refreshStatus();
		this._dsAnnuciatorIP.refreshStatus();
		this._dsSwitchesIP.refreshStatus();
		this._dsEthernetSwitchesIP.refreshStatus();
		this._dsEarthingDevicesIP.refreshStatus();
		this._dsSpecialDevicesIP.refreshStatus();
		this._dsFoundationFrameIP.refreshStatus();
		this._dsSwbAccessoriesQtyIP.refreshStatus();
	}
	get status(): FunctionStatus {
		return this._status;
	}
	get dataSheetId(): string {
		return this._dataSheetId;
	}
	set dataSheetId(_SetVal: string) {
		this._dataSheetId = _SetVal;
	}
	get dataSheetType(): string {
		return this._dataSheetType;
	}
	set dataSheetType(_SetVal: string) {
		this._dataSheetType = _SetVal;
	}
	get dsGeneralIP(): DsGeneralIP {
		return this._dsGeneralIP;
	}
	set dsGeneralIP(_SetVal: DsGeneralIP) {
		this._dsGeneralIP = _SetVal;
	}
	get dsPanelIP(): DsPanelIP {
		return this._dsPanelIP;
	}
	set dsPanelIP(_SetVal: DsPanelIP) {
		this._dsPanelIP = _SetVal;
	}
	get dsBusbarsIP(): DsBusbarsIP {
		return this._dsBusbarsIP;
	}
	set dsBusbarsIP(_SetVal: DsBusbarsIP) {
		this._dsBusbarsIP = _SetVal;
	}
	get dsPaintingIP(): DsPaintingIP {
		return this._dsPaintingIP;
	}
	set dsPaintingIP(_SetVal: DsPaintingIP) {
		this._dsPaintingIP = _SetVal;
	}
	get dsControlAuxIP(): DsControlAuxIP {
		return this._dsControlAuxIP;
	}
	set dsControlAuxIP(_SetVal: DsControlAuxIP) {
		this._dsControlAuxIP = _SetVal;
	}
	get dsControlWiringIP(): DsControlWiringIP {
		return this._dsControlWiringIP;
	}
	set dsControlWiringIP(_SetVal: DsControlWiringIP) {
		this._dsControlWiringIP = _SetVal;
	}
	get dsTerminalBlocksIP(): DsTerminalBlocksIP {
		return this._dsTerminalBlocksIP;
	}
	set dsTerminalBlocksIP(_SetVal: DsTerminalBlocksIP) {
		this._dsTerminalBlocksIP = _SetVal;
	}
	get dsCircuitBreakerIP(): DsCircuitBreakerIP {
		return this._dsCircuitBreakerIP;
	}
	set dsCircuitBreakerIP(_SetVal: DsCircuitBreakerIP) {
		this._dsCircuitBreakerIP = _SetVal;
	}
	get dsCurrentTrafoIP(): DsCurrentTrafoIP {
		return this._dsCurrentTrafoIP;
	}
	set dsCurrentTrafoIP(_SetVal: DsCurrentTrafoIP) {
		this._dsCurrentTrafoIP = _SetVal;
	}
	get dsPotentialTrafoIP(): DsPotentialTrafoIP {
		return this._dsPotentialTrafoIP;
	}
	set dsPotentialTrafoIP(_SetVal: DsPotentialTrafoIP) {
		this._dsPotentialTrafoIP = _SetVal;
	}
	get dsNumericalRelayIP(): DsNumericalRelayIP {
		return this._dsNumericalRelayIP;
	}
	set dsNumericalRelayIP(_SetVal: DsNumericalRelayIP) {
		this._dsNumericalRelayIP = _SetVal;
	}
	get dsAuxRelayIP(): DsAuxRelayIP {
		return this._dsAuxRelayIP;
	}
	set dsAuxRelayIP(_SetVal: DsAuxRelayIP) {
		this._dsAuxRelayIP = _SetVal;
	}
	get dsMetersIP(): DsMetersIP {
		return this._dsMetersIP;
	}
	set dsMetersIP(_SetVal: DsMetersIP) {
		this._dsMetersIP = _SetVal;
	}
	get dsSurgeArrestorIP(): DsSurgeArrestorIP {
		return this._dsSurgeArrestorIP;
	}
	set dsSurgeArrestorIP(_SetVal: DsSurgeArrestorIP) {
		this._dsSurgeArrestorIP = _SetVal;
	}
	get dsAnnuciatorIP(): DsAnnuciatorIP {
		return this._dsAnnuciatorIP;
	}
	set dsAnnuciatorIP(_SetVal: DsAnnuciatorIP) {
		this._dsAnnuciatorIP = _SetVal;
	}
	get dsSwitchesIP(): DsSwitchesIP {
		return this._dsSwitchesIP;
	}
	set dsSwitchesIP(_SetVal: DsSwitchesIP) {
		this._dsSwitchesIP = _SetVal;
	}
	get dsEthernetSwitchesIP(): DsEthernetSwitchesIP {
		return this._dsEthernetSwitchesIP;
	}
	set dsEthernetSwitchesIP(_SetVal: DsEthernetSwitchesIP) {
		this._dsEthernetSwitchesIP = _SetVal;
	}
	get dsEarthingDevicesIP(): DsEarthingDevicesIP {
		return this._dsEarthingDevicesIP;
	}
	set dsEarthingDevicesIP(_SetVal: DsEarthingDevicesIP) {
		this._dsEarthingDevicesIP = _SetVal;
	}
	get dsSpecialDevicesIP(): DsSpecialDevicesIP {
		return this._dsSpecialDevicesIP;
	}
	set dsSpecialDevicesIP(_SetVal: DsSpecialDevicesIP) {
		this._dsSpecialDevicesIP = _SetVal;
	}
	get dsFoundationFrameIP(): DsFoundationFrameIP {
		return this._dsFoundationFrameIP;
	}
	set dsFoundationFrameIP(_SetVal: DsFoundationFrameIP) {
		this._dsFoundationFrameIP = _SetVal;
	}
	get dsSwbAccessoriesQtyIP(): DsSwbAccessoriesQtyIP {
		return this._dsSwbAccessoriesQtyIP;
	}
	set dsSwbAccessoriesQtyIP(_SetVal: DsSwbAccessoriesQtyIP) {
		this._dsSwbAccessoriesQtyIP = _SetVal;
	}
	get createdByName(): string {
		return this._createdByName;
	}
	set createdByName(_SetVal: string) {
		this._createdByName = _SetVal;
	}
	get createdByMailId(): string {
		return this._createdByMailId;
	}
	set createdByMailId(_SetVal: string) {
		this._createdByMailId = _SetVal;
	}
	get createdDate(): Date {
		return this._createdDate;
	}
	set createdDate(_SetVal: Date) {
		this._createdDate = _SetVal;
	}

	addDataSheetImport(_serial: DataSheetImportDef) {
		this._dsGeneralIP.systemVoltage = _serial.gen_sysVolt;
		this._dsGeneralIP.ratedVoltage = _serial.gen_ratVolt;
		this._dsGeneralIP.dryFrqWithstdVolt = _serial.gen_dryFrq;
		this._dsGeneralIP.ratedImpulseVoltage = _serial.gen_ratImpVolt;
		this._dsGeneralIP.frequency = _serial.gen_frq;
		this._dsGeneralIP.switchboardCurrRating = _serial.gen_swtCrRat;
		this._dsGeneralIP.shortTimeCurrRating = _serial.gen_shtTimeCrRat;
		this._dsGeneralIP.dynamicPeakWithstdCurr = _serial.gen_dynmPeakCrr;
		this._dsGeneralIP.ambTempDesign = _serial.gen_ambTmp;
		this._dsGeneralIP.altitude = _serial.gen_alt;
		this._dsGeneralIP.internalArcRating = _serial.gen_intArc;
		this._dsPanelIP.forEnclosure = _serial.pan_enclosure;
		this._dsBusbarsIP.busBarSystem = _serial.bb_busBarSys;
		this._dsControlAuxIP.springChargingMotor = _serial.conAux_springChrgMtr;
		this._dsCircuitBreakerIP.ratedMkCurr = _serial.cb_ratMkCrr;
		this._dsCircuitBreakerIP.cbDynamicPeakCurr = _serial.gen_dynmPeakCrr; // Same mapping as DsGeneralIP - so reused it
	}

	cloneMinimal(): DataSheetIP {
		let dataSheetObj: DataSheetIP;
		let dsGeneralObj: DsGeneralIP;
		let dsPanelObj: DsPanelIP;
		let dsBusbarsObj: DsBusbarsIP;
		let dsPaintingObj: DsPaintingIP;
		let dsControlAuxObj: DsControlAuxIP;
		let dsControlWiringObj: DsControlWiringIP;
		let dsTerminalBlocksObj: DsTerminalBlocksIP;
		let dsCircuitBreakerObj: DsCircuitBreakerIP;
		let dsCurrentTrafoObj: DsCurrentTrafoIP;
		let dsPotentialTrafoObj: DsPotentialTrafoIP;
		let dsNumericalRelayObj: DsNumericalRelayIP;
		let dsAuxRelayObj: DsAuxRelayIP;
		let dsMetersObj: DsMetersIP;
		let dsSurgeArrestorObj: DsSurgeArrestorIP;
		let dsAnnuciatorObj: DsAnnuciatorIP;
		let dsSwitchesObj: DsSwitchesIP;
		let dsEthernetSwitchesObj: DsEthernetSwitchesIP;
		let dsEarthingDevicesObj: DsEarthingDevicesIP;
		let dsSpecialDevicesObj: DsSpecialDevicesIP;
		let dsFoundationFrameObj: DsFoundationFrameIP;
		let dsSwbAccessoriesQtyObj: DsSwbAccessoriesQtyIP;

		let feederBPDS: MultiOptDetails_9DS = new MultiOptDetails_9DS("", "", "001", "", "", "", "", "", "");
		let feederBPDSlist: Array<MultiOptDetails_9DS> = [];
		feederBPDSlist.push(feederBPDS);

		let feederNbDS: MultiOptDetails_3DS = new MultiOptDetails_3DS("", "", "");
		let feederNbDSlist: Array<MultiOptDetails_3DS> = [];
		feederNbDSlist.push(feederNbDS);

		let sptColorDS: MultiOptDetails_3DS = new MultiOptDetails_3DS("", "", "");
		let sptColorDSlist: Array<MultiOptDetails_3DS> = [];
		sptColorDSlist.push(sptColorDS);

		let uvCoilDS: MultiOptDetails_1DS = new MultiOptDetails_1DS("");
		let uvCoilDSlist: Array<MultiOptDetails_1DS> = [];
		uvCoilDSlist.push(uvCoilDS);

		let ctMouldDS: MultiOptDetails_8DS = new MultiOptDetails_8DS("", "", "", "", "", "", "", "");
		let ctMouldDSlist: Array<MultiOptDetails_8DS> = [];
		ctMouldDSlist.push(ctMouldDS);

		let ptMountingTyDS: MultiOptDetails_3DS = new MultiOptDetails_3DS("", "", "");
		let ptMountingTyDSlist: Array<MultiOptDetails_3DS> = [];
		ptMountingTyDSlist.push(ptMountingTyDS);

		let trReqDS: MultiOptDetails_2DS = new MultiOptDetails_2DS("", "");
		let trReqDSlist: Array<MultiOptDetails_2DS> = [];
		trReqDSlist.push(trReqDS);

		let multiFDS: MultiOptDetails_6DS = new MultiOptDetails_6DS("", "", "", "", "", "");
		let multiFDSlist: Array<MultiOptDetails_6DS> = [];
		multiFDSlist.push(multiFDS);

		let triVecDS: MultiOptDetails_6DS = new MultiOptDetails_6DS("", "", "", "", "", "");
		let triVecDSlist: Array<MultiOptDetails_6DS> = [];
		triVecDSlist.push(triVecDS);

		let srDS: MultiOptDetails_3DS = new MultiOptDetails_3DS("", "", "");
		let srDSlist: Array<MultiOptDetails_3DS> = [];
		srDSlist.push(srDS);

		let annDS: MultiOptDetails_5DS = new MultiOptDetails_5DS("", "", "", "", "");
		let annDSlist: Array<MultiOptDetails_5DS> = [];
		annDSlist.push(annDS);

		let sdTempScannerDS: MultiOptDetails_2DS = new MultiOptDetails_2DS("", "");
		let sdTempScannerDSlist: Array<MultiOptDetails_2DS> = [];
		sdTempScannerDSlist.push(sdTempScannerDS);

		let sdCurrTransducerDS: MultiOptDetails_2DS = new MultiOptDetails_2DS("", "");
		let sdCurrTransducerDSlist: Array<MultiOptDetails_2DS> = [];
		sdCurrTransducerDSlist.push(sdCurrTransducerDS);

		let sdVoltTransducerDS: MultiOptDetails_2DS = new MultiOptDetails_2DS("", "");
		let sdVoltTransducerDSlist: Array<MultiOptDetails_2DS> = [];
		sdVoltTransducerDSlist.push(sdVoltTransducerDS);

		let sdPowerTransducerDS: MultiOptDetails_2DS = new MultiOptDetails_2DS("", "");
		let sdPowerTransducerDSlist: Array<MultiOptDetails_2DS> = [];
		sdPowerTransducerDSlist.push(sdPowerTransducerDS);

		let sdMultiFuncTransducerDS: MultiOptDetails_2DS = new MultiOptDetails_2DS("", "");
		let sdMultiFuncTransducerDSlist: Array<MultiOptDetails_2DS> = [];
		sdMultiFuncTransducerDSlist.push(sdMultiFuncTransducerDS);

		let additionalPointsDS: MultiOptDetails_4DS = new MultiOptDetails_4DS("", "", "", "");
		let additionalPointsDSlist: Array<MultiOptDetails_4DS> = [];
		additionalPointsDSlist.push(additionalPointsDS);


		dsGeneralObj = new DsGeneralIP("", "", "", "", "", "", "", "", "", "", null, "", "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsPanelObj = new DsPanelIP("", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "",
			"", "", "", "", "", "", "", "", "", "", "", "", "", "", feederBPDSlist, "", "", "", "", "", "", feederNbDSlist, "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsBusbarsObj = new DsBusbarsIP("", "", "", "", "", "", "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsPaintingObj = new DsPaintingIP("", "", "", sptColorDSlist, "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsControlAuxObj = new DsControlAuxIP("", "", "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsControlWiringObj = new DsControlWiringIP("", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsTerminalBlocksObj = new DsTerminalBlocksIP("", "", "", "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsCircuitBreakerObj = new DsCircuitBreakerIP("", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", uvCoilDSlist, "", "", "", "", "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsCurrentTrafoObj = new DsCurrentTrafoIP("", ctMouldDSlist, "", "", "", "", "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsPotentialTrafoObj = new DsPotentialTrafoIP("", ptMountingTyDSlist, "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsNumericalRelayObj = new DsNumericalRelayIP("", "", "", "", "", "", "", "", "", "", trReqDSlist, "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsAuxRelayObj = new DsAuxRelayIP("", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsMetersObj = new DsMetersIP(multiFDSlist, triVecDSlist, "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsSurgeArrestorObj = new DsSurgeArrestorIP(srDSlist, "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsAnnuciatorObj = new DsAnnuciatorIP(annDSlist, "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsSwitchesObj = new DsSwitchesIP("", "", "", "", "", "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsEthernetSwitchesObj = new DsEthernetSwitchesIP("", "", "", "", "", "", "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsEarthingDevicesObj = new DsEarthingDevicesIP("", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsSpecialDevicesObj = new DsSpecialDevicesIP("", "", "", "", "", "", "", "", "", sdTempScannerDSlist, sdCurrTransducerDSlist, sdVoltTransducerDSlist,
			sdPowerTransducerDSlist, sdMultiFuncTransducerDSlist, "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsFoundationFrameObj = new DsFoundationFrameIP("", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsSwbAccessoriesQtyObj = new DsSwbAccessoriesQtyIP(null, null, null, null, null, null, "", "", additionalPointsDSlist, "", "", "", FunctionStatus.WAITING_FOR_PREV);



		dataSheetObj = new DataSheetIP("", "", dsGeneralObj, dsPanelObj, dsBusbarsObj, dsPaintingObj, dsControlAuxObj, dsControlWiringObj,
			dsTerminalBlocksObj, dsCircuitBreakerObj, dsCurrentTrafoObj, dsPotentialTrafoObj, dsNumericalRelayObj, dsAuxRelayObj,
			dsMetersObj, dsSurgeArrestorObj, dsAnnuciatorObj, dsSwitchesObj, dsEthernetSwitchesObj, dsEarthingDevicesObj, dsSpecialDevicesObj,
			dsFoundationFrameObj, dsSwbAccessoriesQtyObj,
			"", "", null, FunctionStatus.WAITING_FOR_USER_INPUT);

		return dataSheetObj;
	}
	public static getObj(_json: any): DataSheetIP {
		return new DataSheetIP(_json.dataSheetId, _json.dataSheetType,
			DsGeneralIP.getObj(_json.dsGeneralIP), DsPanelIP.getObj(_json.dsPanelIP), DsBusbarsIP.getObj(_json.dsBusbarsIP), DsPaintingIP.getObj(_json.dsPaintingIP),
			DsControlAuxIP.getObj(_json.dsControlAuxIP), DsControlWiringIP.getObj(_json.dsControlWiringIP), DsTerminalBlocksIP.getObj(_json.dsTerminalBlocksIP), DsCircuitBreakerIP.getObj(_json.dsCircuitBreakerIP),
			_json.dsCurrentTrafoIP ? DsCurrentTrafoIP.getObj(_json.dsCurrentTrafoIP) : DsCurrentTrafoIP.emptyObj(),
			_json.dsPotentialTrafoIP ? DsPotentialTrafoIP.getObj(_json.dsPotentialTrafoIP) : DsPotentialTrafoIP.emptyObj(),
			_json.dsNumericalRelayIP ? DsNumericalRelayIP.getObj(_json.dsNumericalRelayIP) : DsNumericalRelayIP.emptyObj(),
			_json.dsAuxRelayIP ? DsAuxRelayIP.getObj(_json.dsAuxRelayIP) : DsAuxRelayIP.emptyObj(),
			_json.dsMetersIP ? DsMetersIP.getObj(_json.dsMetersIP) : DsMetersIP.emptyObj(),
			_json.dsSurgeArrestorIP ? DsSurgeArrestorIP.getObj(_json.dsSurgeArrestorIP) : DsSurgeArrestorIP.emptyObj(),
			_json.dsAnnuciatorIP ? DsAnnuciatorIP.getObj(_json.dsAnnuciatorIP) : DsAnnuciatorIP.emptyObj(),
			_json.dsSwitchesIP ? DsSwitchesIP.getObj(_json.dsSwitchesIP) : DsSwitchesIP.emptyObj(),
			_json.dsEthernetSwitchesIP ? DsEthernetSwitchesIP.getObj(_json.dsEthernetSwitchesIP) : DsEthernetSwitchesIP.emptyObj(),
			_json.dsEarthingDevicesIP ? DsEarthingDevicesIP.getObj(_json.dsEarthingDevicesIP) : DsEarthingDevicesIP.emptyObj(),
			_json.dsSpecialDevicesIP ? DsSpecialDevicesIP.getObj(_json.dsSpecialDevicesIP) : DsSpecialDevicesIP.emptyObj(),
			_json.dsFoundationFrameIP ? DsFoundationFrameIP.getObj(_json.dsFoundationFrameIP) : DsFoundationFrameIP.emptyObj(),
			_json.dsSwbAccessoriesQtyIP ? DsSwbAccessoriesQtyIP.getObj(_json.dsSwbAccessoriesQtyIP) : DsSwbAccessoriesQtyIP.emptyObj(),
			_json.createdByName, _json.createdByMailId, GenService.convToDate(_json.createdDate), _json.status);
	}
	public getJson(): any {
		let _json: any = {};
		_json.dataSheetId = this.dataSheetId;
		_json.dataSheetType = this.dataSheetType;
		_json.dsGeneralIP = this.dsGeneralIP.getJson();
		_json.dsPanelIP = this.dsPanelIP.getJson();
		_json.dsBusbarsIP = this.dsBusbarsIP.getJson();
		_json.dsPaintingIP = this.dsPaintingIP.getJson();
		_json.dsControlAuxIP = this.dsControlAuxIP.getJson();
		_json.dsControlWiringIP = this.dsControlWiringIP.getJson();
		_json.dsTerminalBlocksIP = this.dsTerminalBlocksIP.getJson();
		_json.dsCircuitBreakerIP = this.dsCircuitBreakerIP.getJson();
		_json.dsCurrentTrafoIP = this.dsCurrentTrafoIP.getJson();
		_json.dsPotentialTrafoIP = this.dsPotentialTrafoIP.getJson();
		_json.dsNumericalRelayIP = this.dsNumericalRelayIP.getJson();
		_json.dsAuxRelayIP = this.dsAuxRelayIP.getJson();
		_json.dsMetersIP = this.dsMetersIP.getJson();
		_json.dsSurgeArrestorIP = this.dsSurgeArrestorIP.getJson();
		_json.dsAnnuciatorIP = this.dsAnnuciatorIP.getJson();
		_json.dsSwitchesIP = this.dsSwitchesIP.getJson();
		_json.dsEthernetSwitchesIP = this.dsEthernetSwitchesIP.getJson();
		_json.dsEarthingDevicesIP = this.dsEarthingDevicesIP.getJson();
		_json.dsSpecialDevicesIP = this.dsSpecialDevicesIP.getJson();
		_json.dsFoundationFrameIP = this.dsFoundationFrameIP.getJson();
		_json.dsSwbAccessoriesQtyIP = this.dsSwbAccessoriesQtyIP.getJson();
		_json.createdByName = this.createdByName;
		_json.createdByMailId = this.createdByMailId;
		_json.createdDate = GenService.convToDateNum(this.createdDate);
		_json.status = this.status;
		return _json;
	}
}
export class DsGeneralIP {
	constructor(private _mainSystem: string, private _systemVoltage: string, private _ratedVoltage: string, private _dryFrqWithstdVolt: string, private _ratedImpulseVoltage: string, private _frequency: string,
		private _switchboardCurrRating: string, private _shortTimeCurrRating: string, private _dynamicPeakWithstdCurr: string, private _ambTempDesign: string, private _tempRiseLimit: string,
		private _tempRiseLimitSpecialReq: string, private _earthingSystem: string, private _altitude: string, private _internalArcRating: string, private _internalArcClassification: string, private _typInstallation: string,
		private _sectionNotePM: string, private _sectionNoteEE: string, private _sectionNoteME: string, private _status: FunctionStatus) {
		if (!this._mainSystem) this._mainSystem = "3-Phase; 3-Wire AC";
		if (!this._internalArcClassification) this._internalArcClassification = "AFLR";
		if (!this._typInstallation) this._typInstallation = "Indoor";
		if (!this._sectionNotePM) this._sectionNotePM = "Main Busbars are self supported through top bus side bushing (Top Jumpers)";
	}

	private _parentSORef: SalesOrder;
	private _parentDSRef: DataSheetIP | DataSheetSubOrderIP;

	refreshStatus() {
		if (this.parentSORef) {
			if (this.parentSORef.projectStatus == SOStatus.Marketing) {
				this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
			}
			else if (this.parentSORef.projectStatus > SOStatus.Marketing) {
				let _isTempComplete: boolean = this.isFunctionComplete();

				if (_isTempComplete == true) {
					this._status = FunctionStatus.SUBMITTED_COMPLETE;
				}
				else {
					this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
				}
			}
		}
		else {
			this._status = FunctionStatus.WAITING_FOR_PREV;
		}
	}
	private isFunctionComplete(): boolean {

		if (configDefs.isStrEmty(this.mainSystem)) return false;
		if (configDefs.isStrEmty(this.systemVoltage)) return false;
		if (configDefs.isStrEmty(this.ratedVoltage)) return false;
		if (configDefs.isStrEmty(this.dryFrqWithstdVolt)) return false;
		if (configDefs.isStrEmty(this.ratedImpulseVoltage)) return false;
		if (configDefs.isStrEmty(this.frequency)) return false;
		if (configDefs.isStrEmty(this.switchboardCurrRating)) return false;
		if (configDefs.isStrEmty(this.shortTimeCurrRating)) return false;
		if (configDefs.isStrEmty(this.dynamicPeakWithstdCurr)) return false;
		if (configDefs.isStrEmty(this.ambTempDesign)) return false;
		if (configDefs.isStrEmty(this.tempRiseLimit)) return false;
		if (this.isTempRiseLimitSpecialReqApplic && configDefs.isStrEmty(this.tempRiseLimitSpecialReq)) return false;
		if (configDefs.isStrEmty(this.earthingSystem)) return false;
		if (configDefs.isStrEmty(this.altitude)) return false;
		if (configDefs.isStrEmty(this.internalArcRating)) return false;

		return true;
	}
	get isInputEnabled(): boolean {
		return true; // No dependency on other fields/templates
	}
	get parentSORef(): SalesOrder {
		return this._parentSORef;
	}
	set parentSORef(SORef: SalesOrder) {
		this._parentSORef = SORef;
	}
	get parentDSRef(): DataSheetIP | DataSheetSubOrderIP {
		return this._parentDSRef;
	}
	set parentDSRef(DSRef: DataSheetIP | DataSheetSubOrderIP) {
		this._parentDSRef = DSRef;
	}
	get mainSystem(): string {
		return this._mainSystem;
	}
	set mainSystem(_SetVal: string) {
		this._mainSystem = _SetVal;
	}
	get systemVoltage(): string {
		return this._systemVoltage;
	}
	set systemVoltage(_SetVal: string) {
		this._systemVoltage = _SetVal;
	}
	get ratedVoltage(): string {
		return this._ratedVoltage;
	}
	set ratedVoltage(_SetVal: string) {
		this._ratedVoltage = _SetVal;
	}
	get dryFrqWithstdVolt(): string {
		return this._dryFrqWithstdVolt;
	}
	set dryFrqWithstdVolt(_SetVal: string) {
		this._dryFrqWithstdVolt = _SetVal;
	}
	get ratedImpulseVoltage(): string {
		return this._ratedImpulseVoltage;
	}
	set ratedImpulseVoltage(_SetVal: string) {
		this._ratedImpulseVoltage = _SetVal;
	}
	get frequency(): string {
		return this._frequency;
	}
	set frequency(_SetVal: string) {
		this._frequency = _SetVal;
	}
	get switchboardCurrRating(): string {
		return this._switchboardCurrRating;
	}
	set switchboardCurrRating(_SetVal: string) {
		this._switchboardCurrRating = _SetVal;
	}
	get shortTimeCurrRating(): string {
		return this._shortTimeCurrRating;
	}
	set shortTimeCurrRating(_SetVal: string) {
		this._shortTimeCurrRating = _SetVal;
	}
	get dynamicPeakWithstdCurr(): string {
		return this._dynamicPeakWithstdCurr;
	}
	set dynamicPeakWithstdCurr(_SetVal: string) {
		this._dynamicPeakWithstdCurr = _SetVal;
	}
	get ambTempDesign(): string {
		return this._ambTempDesign;
	}
	set ambTempDesign(_SetVal: string) {
		this._ambTempDesign = _SetVal;
	}
	get tempRiseLimit(): string {
		return this._tempRiseLimit;
	}
	set tempRiseLimit(_SetVal: string) {
		this._tempRiseLimit = _SetVal;
	}
	get tempRiseLimitSpecialReq(): string {
		if (this.isTempRiseLimitSpecialReqApplic == true) {
			return this._tempRiseLimitSpecialReq;
		}
		else {
			return this._tempRiseLimitSpecialReq = "";
		}
	}
	set tempRiseLimitSpecialReq(_SetVal: string) {
		if (this.isTempRiseLimitSpecialReqApplic == true) {
			this._tempRiseLimitSpecialReq = _SetVal;
		}
	}
	get earthingSystem(): string {
		return this._earthingSystem;
	}
	set earthingSystem(_SetVal: string) {
		this._earthingSystem = _SetVal;
	}
	get altitude(): string {
		return this._altitude;
	}
	set altitude(_SetVal: string) {
		this._altitude = _SetVal;
	}
	get internalArcRating(): string {
		return this._internalArcRating;
	}
	set internalArcRating(_SetVal: string) {
		this._internalArcRating = _SetVal;
	}
	get internalArcClassification(): string {
		return this._internalArcClassification;
	}
	set internalArcClassification(_SetVal: string) {
		this._internalArcClassification = _SetVal;
	}
	get typInstallation(): string {
		return this._typInstallation;
	}
	set typInstallation(_SetVal: string) {
		this._typInstallation = _SetVal;
	}
	get sectionNotePM(): string {
		return this._sectionNotePM;
	}
	set sectionNotePM(_SetVal: string) {
		this._sectionNotePM = _SetVal;
	}
	get sectionNoteEE(): string {
		return this._sectionNoteEE;
	}
	set sectionNoteEE(_SetVal: string) {
		this._sectionNoteEE = _SetVal;
	}
	get sectionNoteME(): string {
		return this._sectionNoteME;
	}
	set sectionNoteME(_SetVal: string) {
		this._sectionNoteME = _SetVal;
	}
	get status(): FunctionStatus {
		return this._status;
	}

	get isTempRiseLimitSpecialReqApplic(): boolean {
		if (this.tempRiseLimit == "002") return true;
		return false
	}

	get saveSOValidation(): boolean {
		return this.isFunctionComplete();
	}

	cloneSelf(): DsGeneralIP {
		return new DsGeneralIP(this.mainSystem, this.systemVoltage, this.ratedVoltage, this.dryFrqWithstdVolt, this.ratedImpulseVoltage, this.frequency,
			this.switchboardCurrRating, this.shortTimeCurrRating, this.dynamicPeakWithstdCurr, this.ambTempDesign, this.tempRiseLimit,
			this.tempRiseLimitSpecialReq, this.earthingSystem, this.altitude, this.internalArcRating, this.internalArcClassification,
			this.typInstallation, this.sectionNotePM, this.sectionNoteEE, this.sectionNoteME, this.status);
	}

	public static getObj(_json: any): DsGeneralIP {
		return new DsGeneralIP(_json.mainSystem, _json.systemVoltage, _json.ratedVoltage, _json.dryFrqWithstdVolt, _json.ratedImpulseVoltage, _json.frequency,
			_json.switchboardCurrRating, _json.shortTimeCurrRating, _json.dynamicPeakWithstdCurr, _json.ambTempDesign, _json.tempRiseLimit,
			_json.tempRiseLimitSpecialReq, _json.earthingSystem, _json.altitude, _json.internalArcRating, _json.internalArcClassification,
			_json.typInstallation, _json.sectionNotePM, _json.sectionNoteEE, _json.sectionNoteME, _json.status);
	}
	public getJson(): any {
		let _json: any = {};
		_json.mainSystem = this.mainSystem;
		_json.systemVoltage = this.systemVoltage;
		_json.ratedVoltage = this.ratedVoltage;
		_json.dryFrqWithstdVolt = this.dryFrqWithstdVolt
		_json.ratedImpulseVoltage = this.ratedImpulseVoltage;
		_json.frequency = this.frequency;
		_json.switchboardCurrRating = this.switchboardCurrRating;
		_json.shortTimeCurrRating = this.shortTimeCurrRating;
		_json.dynamicPeakWithstdCurr = this.dynamicPeakWithstdCurr;
		_json.ambTempDesign = this.ambTempDesign;
		_json.tempRiseLimit = this.tempRiseLimit;
		_json.tempRiseLimitSpecialReq = this.tempRiseLimitSpecialReq;
		_json.earthingSystem = this.earthingSystem;
		_json.altitude = this.altitude;
		_json.internalArcRating = this.internalArcRating;
		_json.internalArcClassification = this.internalArcClassification;
		_json.typInstallation = this.typInstallation;
		_json.sectionNotePM = this.sectionNotePM;
		_json.sectionNoteEE = this.sectionNoteEE;
		_json.sectionNoteME = this.sectionNoteME;
		_json.status = this.status;
		return _json;
	}
}
export class DsPanelIP {
	constructor(private _dsPanelType: string, private _prodType: string, private _vcbModelName: string, private _vcbModelDetail: string, private _vcbType: string, private _vcbPole: string, private _rackInOutMech: string,
		private _forEnclosure: string, private _forWithinComp: string, private _forLVCompDoor: string,
		private _forLVCompDoorDetail: string, private _frontDoorEndCover: string, private _restOfPanel: string, private _castleLock: string, private _castleLockPhilosophy: string, private _sheetThickForEnc: string, private _lvCompDoorV2: string, private _breakerCompDoor: string,
		private _rearCover: string, private _extBothSides: string, private _liftArrg: string, private _powerCable: string, private _controlCable: string, private _busduct: string, private _busductEntry: string,
		private _feederNameAppli: string, private _coreCables_3: string, private _singleCoreCables: string, private _gasductExh: string, private _exhType: string, private _exhTypeDetail: string,
		private _feederRatingBreakerPan: Array<MultiOptDetails_9DS>,
		private _forceCoolingApplic: string,
		private _forceCoolingVCBCurr: string, private _forceCoolingFan: string, private _noOfFans: string, private _locationofFans: string,
		private _silverPlatingatJoints: string, private _feederTypeNonBreaker: Array<MultiOptDetails_3DS>,
		private _sectionNotePM: string, private _sectionNoteEE: string, private _sectionNoteME: string,
		private _status: FunctionStatus) {
		if (!this._dsPanelType) this._dsPanelType = "Floor Mounted; Metal Enclosed";
		if (!this._forWithinComp) this._forWithinComp = "IP 2X";
		if (!this._frontDoorEndCover) this._frontDoorEndCover = "CRCA";
		if (!this._sheetThickForEnc) this._sheetThickForEnc = "2mm";
		if (!this._lvCompDoorV2) this._lvCompDoorV2 = "001";
		if (!this._breakerCompDoor) this._breakerCompDoor = "001";
		if (!this._liftArrg) this._liftArrg = "Supply with Loose";
		if (!this._coreCables_3) this._coreCables_3 = "3mm thick GI";
		if (!this._exhType && !this._gasductExh) this._exhType = "001";
		if (!this._silverPlatingatJoints) this._silverPlatingatJoints = "001";


	}

	private _parentSORef: SalesOrder;
	private _parentDSRef: DataSheetIP | DataSheetSubOrderIP;

	refreshStatus() {
		if (this.parentSORef) {
			if (this.parentSORef.projectStatus == SOStatus.Marketing) {
				this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
			}
			else if (this.parentSORef.projectStatus > SOStatus.Marketing) {
				let _isTempComplete: boolean = this.isFunctionComplete();

				if (_isTempComplete == true) {
					this._status = FunctionStatus.SUBMITTED_COMPLETE;
				}
				else {
					this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
				}
			}
		}
		else {
			this._status = FunctionStatus.WAITING_FOR_PREV;
		}
	}
	private isFunctionComplete(): boolean {

		if (configDefs.isStrEmty(this.dsPanelType)) return false;

		return true;
	}
	get parentSORef(): SalesOrder {
		return this._parentSORef;
	}
	set parentSORef(SORef: SalesOrder) {
		this._parentSORef = SORef;
	}
	get parentDSRef(): DataSheetIP | DataSheetSubOrderIP {
		return this._parentDSRef;
	}
	set parentDSRef(DSRef: DataSheetIP | DataSheetSubOrderIP) {
		this._parentDSRef = DSRef;
	}
	get dsPanelType(): string {
		return this._dsPanelType;
	}
	set dsPanelType(_SetVal: string) {
		this._dsPanelType = _SetVal;
	}
	get prodType(): string {
		return this._prodType;
	}
	set prodType(_SetVal: string) {
		this._prodType = _SetVal;
	}
	get vcbModelName(): string {
		return this._vcbModelName;
	}
	set vcbModelName(_SetVal: string) {
		this._vcbModelName = _SetVal;
	}
	get isVcbSpecReqApplicable(): boolean {
		if (this.vcbModelName == "004") return true; // Applicable when option is Special Req
		return false
	}
	get vcbModelDetail(): string {
		if (this.isVcbSpecReqApplicable == true) {
			return this._vcbModelDetail;
		}
		return "";
	}
	set vcbModelDetail(_SetVal: string) {
		if (this.isVcbSpecReqApplicable == true) {
			this._vcbModelDetail = _SetVal;
		}
	}
	get vcbType(): string {
		return this._vcbType;
	}
	set vcbType(_SetVal: string) {
		this._vcbType = _SetVal;
	}
	get vcbPole(): string {
		return this._vcbPole;
	}
	set vcbPole(_SetVal: string) {
		this._vcbPole = _SetVal;
	}
	// get isPanelImpBreakerApplicable():boolean{ // Check if this is needed later
	// 	if(this.parentSORef.marketingIP.ordertypeId == "0003") return true; // Applicable when option is With Breaker
	// 	return false;
	// }
	get rackInOutMech(): string {
		return this._rackInOutMech;
	}
	set rackInOutMech(_SetVal: string) {
		this._rackInOutMech = _SetVal;
	}
	get forEnclosure(): string {
		return this._forEnclosure;
	}
	set forEnclosure(_SetVal: string) {
		this._forEnclosure = _SetVal;
	}
	get forWithinComp(): string {
		return this._forWithinComp;
	}
	set forWithinComp(_SetVal: string) {
		this._forWithinComp = _SetVal;
	}
	get forLVCompDoor(): string {
		return this._forLVCompDoor;
	}
	set forLVCompDoor(_SetVal: string) {
		this._forLVCompDoor = _SetVal;
	}
	get isLvCompDrSpecReqApplicable(): boolean {
		if (this.forLVCompDoor == "002") return true; // Applicable when option is Special Req
		return false
	}
	get forLVCompDoorDetail(): string {
		if (this.isLvCompDrSpecReqApplicable == true) {
			return this._forLVCompDoorDetail;
		}
		return "";
	}
	set forLVCompDoorDetail(_SetVal: string) {
		if (this.isLvCompDrSpecReqApplicable == true) {
			this._forLVCompDoorDetail = _SetVal;
		}
	}
	get rearCover(): string {
		return this._rearCover;
	}
	set rearCover(_SetVal: string) {
		this._rearCover = _SetVal;
	}
	get frontDoorEndCover(): string {
		return this._frontDoorEndCover;
	}
	set frontDoorEndCover(_SetVal: string) {
		this._frontDoorEndCover = _SetVal;
	}
	get restOfPanel(): string {
		return this._restOfPanel;
	}
	set restOfPanel(_SetVal: string) {
		this._restOfPanel = _SetVal;
	}
	get castleLock(): string {
		return this._castleLock;
	}
	set castleLock(_SetVal: string) {
		this._castleLock = _SetVal;
	}
	get isCastleLockPhilosophyApplicable(): boolean {
		if (this.castleLock == "001") return true; // Applicable when option is Special Req
		return false;
	}
	get castleLockPhilosophy(): string {
		if (this.isCastleLockPhilosophyApplicable == true) {
			return this._castleLockPhilosophy;
		}
		return "";
	}
	set castleLockPhilosophy(_SetVal: string) {
		if (this.isCastleLockPhilosophyApplicable == true) {
			this._castleLockPhilosophy = _SetVal;
		}
	}
	get sheetThickForEnc(): string {
		return this._sheetThickForEnc;
	}
	set sheetThickForEnc(_SetVal: string) {
		this._sheetThickForEnc = _SetVal;
	}
	get lvCompDoorV2(): string {
		return this._lvCompDoorV2;
	}
	set lvCompDoorV2(_SetVal: string) {
		this._lvCompDoorV2 = _SetVal;
	}
	get breakerCompDoor(): string {
		return this._breakerCompDoor;
	}
	set breakerCompDoor(_SetVal: string) {
		this._breakerCompDoor = _SetVal;
	}
	get extBothSides(): string {
		return this._extBothSides;
	}
	set extBothSides(_SetVal: string) {
		this._extBothSides = _SetVal;
	}
	get liftArrg(): string {
		return this._liftArrg;
	}
	set liftArrg(_SetVal: string) {
		this._liftArrg = _SetVal;
	}
	get powerCable(): string {
		return this._powerCable;
	}
	set powerCable(_SetVal: string) {
		this._powerCable = _SetVal;
	}
	get controlCable(): string {
		return this._controlCable;
	}
	set controlCable(_SetVal: string) {
		this._controlCable = _SetVal;
	}
	get busduct(): string {
		return this._busduct;
	}
	set busduct(_SetVal: string) {
		this._busduct = _SetVal;
	}
	get isBusductApplicable(): boolean {
		if (this.busduct == "001") return true; // Applicable when option is Special Req
		return false
	}
	get busductEntry(): string {
		if (this.isBusductApplicable == true) {
			return this._busductEntry;
		}
		return "";
	}
	set busductEntry(_SetVal: string) {
		if (this.isBusductApplicable == true) {
			this._busductEntry = _SetVal;
		}
	}
	get feederNameAppli(): string {
		if (this.isBusductApplicable == true) {
			return this._feederNameAppli;
		}
		return "";
	}
	set feederNameAppli(_SetVal: string) {
		if (this.isBusductApplicable == true) {
			this._feederNameAppli = _SetVal;
		}
	}
	get coreCables_3(): string {
		return this._coreCables_3;
	}
	set coreCables_3(_SetVal: string) {
		this._coreCables_3 = _SetVal;
	}
	get singleCoreCables(): string {
		return this._singleCoreCables;
	}
	set singleCoreCables(_SetVal: string) {
		this._singleCoreCables = _SetVal;
	}
	get gasductExh(): string {
		return this._gasductExh;
	}
	set gasductExh(_SetVal: string) {
		this._gasductExh = _SetVal;
	}
	get isExhTypeApplicable(): boolean {
		if (this.gasductExh == "001") return true; // Applicable
		return false
	}
	get exhType(): string {
		return this._exhType;
	}
	set exhType(_SetVal: string) {
		this._exhType = _SetVal;
	}
	get isExhTypeDetailApplicable(): boolean {
		if (this.exhType == "001") return true; // Applicable when option is Gas Duct
		return false;
	}
	get exhTypeDetail(): string {
		if (this.isExhTypeDetailApplicable == true) {
			return this._exhTypeDetail;
		}
		return "";
	}
	set exhTypeDetail(_SetVal: string) {
		if (this.isExhTypeDetailApplicable == true) {
			this._exhTypeDetail = _SetVal;
		}
	}
	get feederRatingBreakerPan(): Array<MultiOptDetails_9DS> {
		return this._feederRatingBreakerPan;
	}
	set feederRatingBreakerPan(_SetVal: Array<MultiOptDetails_9DS>) {
		this._feederRatingBreakerPan = _SetVal;
	}
	addFeederRBPDS(_frDS: MultiOptDetails_9DS) {

		this._feederRatingBreakerPan.push(_frDS);
	}
	removeFeederRBPDS(_rmvFrDS: MultiOptDetails_9DS) {
		let index: number = this._feederRatingBreakerPan.indexOf(_rmvFrDS);
		if (index >= 0) {
			this._feederRatingBreakerPan.splice(index, 1);
		}
	}
	get forceCoolingApplic(): string {
		return this._forceCoolingApplic;
	}
	set forceCoolingApplic(_SetVal: string) {
		this._forceCoolingApplic = _SetVal;
	}

	get isForceCoolingApplicable(): boolean {
		if (this.forceCoolingApplic == "001") return true; // Applicable when option is Force Cooling Applicable
		return false;
	}
	get forceCoolingVCBCurr(): string {
		if (this.isForceCoolingApplicable == true) {
			return this._forceCoolingVCBCurr;
		}
		return "";
	}
	set forceCoolingVCBCurr(_SetVal: string) {
		if (this.isForceCoolingApplicable == true) {
			this._forceCoolingVCBCurr = _SetVal;
		}
	}
	get forceCoolingFan(): string {
		if (this.isForceCoolingApplicable == true) {
			return this._forceCoolingFan;
		}
		return "";
	}
	set forceCoolingFan(_SetVal: string) {
		if (this.isForceCoolingApplicable == true) {
			this._forceCoolingFan = _SetVal;
		}
	}
	get noOfFans(): string {
		if (this.isForceCoolingApplicable == true) {
			return this._noOfFans;
		}
		return "";
	}
	set noOfFans(_SetVal: string) {
		if (this.isForceCoolingApplicable == true) {
			this._noOfFans = _SetVal;
		}
	}
	get locationofFans(): string {
		if (this.isForceCoolingApplicable == true) {
			return this._locationofFans;
		}
		return "";
	}
	set locationofFans(_SetVal: string) {
		if (this.isForceCoolingApplicable == true) {
			this._locationofFans = _SetVal;
		}
	}
	get silverPlatingatJoints(): string {
		return this._silverPlatingatJoints;
	}
	set silverPlatingatJoints(_SetVal: string) {
		this._silverPlatingatJoints = _SetVal;
	}
	get feederTypeNonBreaker(): Array<MultiOptDetails_3DS> {
		return this._feederTypeNonBreaker;
	}
	set feederTypeNonBreaker(_SetVal: Array<MultiOptDetails_3DS>) {
		this._feederTypeNonBreaker = _SetVal;
	}
	addFeederNbDS(_crDS: MultiOptDetails_3DS) {

		this._feederTypeNonBreaker.push(_crDS);
	}
	removeFeederNbDS(_rmvCrDS: MultiOptDetails_3DS) {
		let index: number = this._feederTypeNonBreaker.indexOf(_rmvCrDS);
		if (index >= 0) {
			this._feederTypeNonBreaker.splice(index, 1);
		}
	}
	get sectionNotePM(): string {
		return this._sectionNotePM;
	}
	set sectionNotePM(_SetVal: string) {
		this._sectionNotePM = _SetVal;
	}
	get sectionNoteEE(): string {
		return this._sectionNoteEE;
	}
	set sectionNoteEE(_SetVal: string) {
		this._sectionNoteEE = _SetVal;
	}
	get sectionNoteME(): string {
		return this._sectionNoteME;
	}
	set sectionNoteME(_SetVal: string) {
		this._sectionNoteME = _SetVal;
	}
	get status(): FunctionStatus {
		return this._status;
	}

	filterPanelWidth(_dsType, _pw, _shrtCurr): Array<string> {
		let _filteredList: Array<string> = [];
		switch (_dsType) {
			case "UG ZS1":
				if (_pw <= 1250) {
					if (parseFloat(_shrtCurr) <= 25) {
						_filteredList.push("650");
					}
					else if (parseFloat(_shrtCurr) > 25) {
						_filteredList.push("650");
						_filteredList.push("800");
					}
				}
				else if (_pw > 1250 && _pw <= 2000) {
					if (parseFloat(_shrtCurr) <= 25) {
						_filteredList.push("800");
					}
					else if (parseFloat(_shrtCurr) > 25) {
						_filteredList.push("800");
					}
				}
				else if (_pw == 2500) {
					if (parseFloat(_shrtCurr) >= 25) {
						_filteredList.push("1000");
					}
				}
				else if (_pw == 3150) {
					if (parseFloat(_shrtCurr) >= 15) {
						_filteredList.push("1000");

					}
				}
				break;
			case "UG ZS2":
				if (_pw <= 2000) {
					if (parseFloat(_shrtCurr) <= 31.5) {
						_filteredList.push("1000");

					}
				}
				else if (_pw >= 2500) {
					if (parseFloat(_shrtCurr) <= 31.5) {
						_filteredList.push("1200");

					}
				}

				break;
			case "LG ZN1":
			case "LG ZN9":
				if (_pw <= 1250) {
					if (parseFloat(_shrtCurr) <= 25) {
						_filteredList.push("600");

					}
				}
				else if (_pw >= 1600) {
					if (parseFloat(_shrtCurr) <= 25) {
						_filteredList.push("800");

					}
				}
				break;
		}

		return _filteredList;
	}

	filterNonBPWidth(_dsType, _pw, _shrtCurr, _bpType): Array<string> {
		let _filteredList: Array<string> = [];
		switch (_dsType) {
			case "UG ZS1":
				if (_pw <= 1250) {
					if (parseFloat(_shrtCurr) <= 25) {
						if (_bpType == "002") { // Bus PT
							_filteredList.push("650");
						}
						else if (_bpType == "001") { // BRPT
							_filteredList.push("650");
						}
					}
					else if (parseFloat(_shrtCurr) > 25) {
						if (_bpType == "002") { // Bus PT
							_filteredList.push("650");
						}
						else if (_bpType == "001") { // BRPT
							_filteredList.push("650");
							_filteredList.push("800");
						}
					}
				}
				else if (_pw > 1250 && _pw <= 2000) {
					if (parseFloat(_shrtCurr) <= 25) {
						if (_bpType == "002") { // Bus PT
							_filteredList.push("650");
							_filteredList.push("800");
						}
						else if (_bpType == "001") { // BRPT
							_filteredList.push("800");
						}
					}
					else if (parseFloat(_shrtCurr) > 25) {
						if (_bpType == "002") { // Bus PT
							_filteredList.push("650");
							_filteredList.push("800");
						}
						else if (_bpType == "001") { // BRPT
							_filteredList.push("800");
						}
					}
				}
				else if (_pw == 2500) {
					if (parseFloat(_shrtCurr) >= 25) {
						if (_bpType == "002") { // Bus PT
							_filteredList.push("650");
							_filteredList.push("800");
						}
						else if (_bpType == "001") { // BRPT
							_filteredList.push("800");
							_filteredList.push("1000");
						}
					}
				}
				else if (_pw == 3150) {
					if (parseFloat(_shrtCurr) >= 15) {
						if (_bpType == "002") { // Bus PT
							_filteredList.push("650");
							_filteredList.push("800");
						}
						else if (_bpType == "001") { // BRPT
							_filteredList.push("1000");
						}

					}
				}
				break;
			case "UG ZS2":
				if (_pw <= 2000) {
					if (parseFloat(_shrtCurr) <= 31.5) {
						if (_bpType == "002") { // Bus PT
							_filteredList.push("1000");
						}
						else if (_bpType == "001") { // BRPT
							_filteredList.push("1000");
						}

					}
				}
				else if (_pw >= 2500) {
					if (parseFloat(_shrtCurr) <= 31.5) {
						if (_bpType == "002") { // Bus PT
							_filteredList.push("1000");
						}
						else if (_bpType == "001") { // BRPT
							_filteredList.push("1000");
						}

					}
				}

				break;
			case "LG ZN1":
			case "LG ZN9":
				if (_pw <= 1250) {
					if (parseFloat(_shrtCurr) <= 25) {
						if (_bpType == "002") { // Bus PT
							_filteredList.push("600");
						}
						else if (_bpType == "001") { // BRPT
							_filteredList.push("600");
						}

					}
				}
				else if (_pw >= 1600) {
					if (parseFloat(_shrtCurr) <= 25) {
						if (_bpType == "002") { // Bus PT
							_filteredList.push("600");
						}
						else if (_bpType == "001") { // BRPT
							_filteredList.push("800");
						}

					}
				}
				break;
		}

		return _filteredList;
	}

	filterForceCoolingLocation(_dsType, _pw, _shrtCurr, _bpType): Array<string> {
		let _filteredList: Array<string> = [];
		switch (_dsType) {
			case "UG ZS1":
				if (_pw <= 1250) {
					if (parseFloat(_shrtCurr) <= 25) {
						if (_bpType == "002") { // Bus PT
							_filteredList.push("650");
						}
						else if (_bpType == "001") { // BRPT
							_filteredList.push("650");
						}
					}
					else if (parseFloat(_shrtCurr) > 25) {
						if (_bpType == "002") { // Bus PT
							_filteredList.push("650");
						}
						else if (_bpType == "001") { // BRPT
							_filteredList.push("650");
							_filteredList.push("800");
						}
					}
				}
				else if (_pw > 1250 && _pw <= 2000) {
					if (parseFloat(_shrtCurr) <= 25) {
						if (_bpType == "002") { // Bus PT
							_filteredList.push("650");
							_filteredList.push("800");
						}
						else if (_bpType == "001") { // BRPT
							_filteredList.push("800");
						}
					}
					else if (parseFloat(_shrtCurr) > 25) {
						if (_bpType == "002") { // Bus PT
							_filteredList.push("650");
							_filteredList.push("800");
						}
						else if (_bpType == "001") { // BRPT
							_filteredList.push("800");
						}
					}
				}
				else if (_pw == 2500) {
					if (parseFloat(_shrtCurr) >= 25) {
						if (_bpType == "002") { // Bus PT
							_filteredList.push("650");
							_filteredList.push("800");
						}
						else if (_bpType == "001") { // BRPT
							_filteredList.push("800");
							_filteredList.push("1000");
						}
					}
				}
				else if (_pw == 3150) {
					if (parseFloat(_shrtCurr) >= 15) {
						if (_bpType == "002") { // Bus PT
							_filteredList.push("650");
							_filteredList.push("800");
						}
						else if (_bpType == "001") { // BRPT
							_filteredList.push("1000");
						}

					}
				}
				break;
			case "UG ZS2":
				if (_pw <= 2000) {
					if (parseFloat(_shrtCurr) <= 31.5) {
						if (_bpType == "002") { // Bus PT
							_filteredList.push("1000");
						}
						else if (_bpType == "001") { // BRPT
							_filteredList.push("1000");
						}

					}
				}
				else if (_pw >= 2500) {
					if (parseFloat(_shrtCurr) <= 31.5) {
						if (_bpType == "002") { // Bus PT
							_filteredList.push("1000");
						}
						else if (_bpType == "001") { // BRPT
							_filteredList.push("1000");
						}

					}
				}

				break;
			case "LG ZN1":
			case "LG ZN9":
				if (_pw <= 1250) {
					if (parseFloat(_shrtCurr) <= 25) {
						if (_bpType == "002") { // Bus PT
							_filteredList.push("600");
						}
						else if (_bpType == "001") { // BRPT
							_filteredList.push("600");
						}

					}
				}
				else if (_pw >= 1600) {
					if (parseFloat(_shrtCurr) <= 25) {
						if (_bpType == "002") { // Bus PT
							_filteredList.push("600");
						}
						else if (_bpType == "001") { // BRPT
							_filteredList.push("800");
						}

					}
				}
				break;
		}

		return _filteredList;
	}

	cloneSelf(): DsPanelIP {
		let _tmpf: MultiOptDetails_9DS[] = []
		for (var i = 0; i < this.feederRatingBreakerPan.length; i++) {
			_tmpf.push(this.feederRatingBreakerPan[i].cloneSelf());
		}

		let _tmpnb: MultiOptDetails_3DS[] = []
		for (var i = 0; i < this.feederTypeNonBreaker.length; i++) {
			_tmpnb.push(this.feederTypeNonBreaker[i].cloneSelf());
		}

		return new DsPanelIP(this.dsPanelType, this.prodType, this.vcbModelName, this.vcbModelDetail, this.vcbType, this.vcbPole, this.rackInOutMech, this.forEnclosure, this.forWithinComp,
			this.forLVCompDoor, this.forLVCompDoorDetail, this.frontDoorEndCover, this.restOfPanel, this.castleLock, this.castleLockPhilosophy, this.sheetThickForEnc, this.lvCompDoorV2,
			this.breakerCompDoor, this.rearCover, this.extBothSides, this.liftArrg, this.powerCable, this.controlCable, this.busduct, this.busductEntry,
			this.feederNameAppli, this.coreCables_3, this.singleCoreCables, this.gasductExh, this.exhType, this.exhTypeDetail, _tmpf,
			this.forceCoolingApplic, this.forceCoolingVCBCurr, this.forceCoolingFan, this.noOfFans, this.locationofFans, this.silverPlatingatJoints, _tmpnb,
			this.sectionNotePM, this.sectionNoteEE, this.sectionNoteME, this.status);
	}

	public static getObj(_json: any): DsPanelIP {

		let _tmpf: Array<MultiOptDetails_9DS> = [];
		for (var j = 0; j < _json.feederRatingBreakerPan.length; j++) {
			_tmpf.push(MultiOptDetails_9DS.getObj(_json.feederRatingBreakerPan[j]));
		}

		let _tmpnb: Array<MultiOptDetails_3DS> = [];
		for (var j = 0; j < _json.feederTypeNonBreaker.length; j++) {
			_tmpnb.push(MultiOptDetails_3DS.getObj(_json.feederTypeNonBreaker[j]));
		}

		return new DsPanelIP(_json.dsPanelType, _json.prodType, _json.vcbModelName, _json.vcbModelDetail, _json.vcbType, _json.vcbPole, _json.rackInOutMech, _json.forEnclosure, _json.forWithinComp,
			_json.forLVCompDoor, _json.forLVCompDoorDetail, _json.frontDoorEndCover, _json.restOfPanel, _json.castleLock, _json.castleLockPhilosophy, _json.sheetThickForEnc, _json.lvCompDoorV2,
			_json.breakerCompDoor, _json.rearCover, _json.extBothSides, _json.liftArrg, _json.powerCable, _json.controlCable, _json.busduct, _json.busductEntry,
			_json.feederNameAppli, _json.coreCables_3, _json.singleCoreCables, _json.gasductExh, _json.exhType, _json.exhTypeDetail, _tmpf,
			_json.forceCoolingApplic, _json.forceCoolingVCBCurr, _json.forceCoolingFan, _json.noOfFans, _json.locationofFans, _json.silverPlatingatJoints, _tmpnb,
			_json.sectionNotePM, _json.sectionNoteEE, _json.sectionNoteME, _json.status);
	}
	public getJson(): any {
		let _json: any = {};
		_json.dsPanelType = this.dsPanelType;
		_json.prodType = this.prodType;
		_json.vcbModelName = this.vcbModelName;
		_json.vcbModelDetail = this.vcbModelDetail;
		_json.vcbType = this.vcbType;
		_json.vcbPole = this.vcbPole;
		_json.rackInOutMech = this.rackInOutMech;
		_json.forEnclosure = this.forEnclosure;
		_json.forWithinComp = this.forWithinComp;
		_json.forLVCompDoor = this.forLVCompDoor;
		_json.forLVCompDoorDetail = this.forLVCompDoorDetail;
		_json.rearCover = this.rearCover;
		_json.frontDoorEndCover = this.frontDoorEndCover;
		_json.restOfPanel = this.restOfPanel;
		_json.castleLock = this.castleLock;
		_json.castleLockPhilosophy = this.castleLockPhilosophy;
		_json.sheetThickForEnc = this.sheetThickForEnc;
		_json.lvCompDoorV2 = this.lvCompDoorV2;
		_json.breakerCompDoor = this.breakerCompDoor;
		_json.extBothSides = this.extBothSides;
		_json.liftArrg = this.liftArrg;
		_json.powerCable = this.powerCable;
		_json.controlCable = this.controlCable;
		_json.busduct = this.busduct;
		_json.busductEntry = this.busductEntry;
		_json.feederNameAppli = this.feederNameAppli;
		_json.coreCables_3 = this.coreCables_3;
		_json.singleCoreCables = this.singleCoreCables;
		_json.gasductExh = this.gasductExh;
		_json.exhType = this.exhType;
		_json.exhTypeDetail = this.exhTypeDetail;
		_json.feederRatingBreakerPan = [];
		_json.forceCoolingApplic = this.forceCoolingApplic;
		_json.forceCoolingVCBCurr = this.forceCoolingVCBCurr;
		_json.forceCoolingFan = this.forceCoolingFan;
		_json.noOfFans = this.noOfFans;
		_json.locationofFans = this.locationofFans;
		_json.silverPlatingatJoints = this.silverPlatingatJoints
		_json.feederTypeNonBreaker = [];
		_json.sectionNotePM = this.sectionNotePM;
		_json.sectionNoteEE = this.sectionNoteEE;
		_json.sectionNoteME = this.sectionNoteME;
		_json.status = this.status;

		for (var i = 0; i < this._feederRatingBreakerPan.length; i++) {
			_json.feederRatingBreakerPan.push(this._feederRatingBreakerPan[i].getJson());
		}
		for (var i = 0; i < this._feederTypeNonBreaker.length; i++) {
			_json.feederTypeNonBreaker.push(this._feederTypeNonBreaker[i].getJson());
		}
		return _json;
	}
}
export class DsBusbarsIP {
	constructor(private _busBarSystem: string, private _mainBusCircBreaker: string, private _feederConnect: string, private _mainBusDropper: string, private _htSleeves: string,
		private _htSleevesMake: string, private _insulationBusJoint: string, private _phaseIdentification: string,
		private _earthBBMaterial: string, private _earthBBSize: string, private _earthBBSize_2: string,
		private _sectionNotePM: string, private _sectionNoteEE: string, private _sectionNoteME: string, private _status: FunctionStatus) {
		if (!this._mainBusCircBreaker) this._mainBusCircBreaker = "001";
		if (!this._htSleeves) this._htSleeves = "Full Rated Voltage Sleeve";
		if (!this._insulationBusJoint) this._insulationBusJoint = "Shrouds";
		if (!this._earthBBMaterial) this._earthBBMaterial = "Copper";
		if (!this._phaseIdentification) this._phaseIdentification = "001";
		if (!this._sectionNotePM) this._sectionNotePM = "Main Busbars are self supported through top bus side bushing (Top Jumpers)";

	}

	private _parentSORef: SalesOrder;
	private _parentDSRef: DataSheetIP | DataSheetSubOrderIP;


	refreshStatus() {
		if (this.parentSORef) {
			if (this.parentSORef.projectStatus == SOStatus.Marketing) {
				this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
			}
			else if (this.parentSORef.projectStatus > SOStatus.Marketing) {
				let _isTempComplete: boolean = this.isFunctionComplete();

				if (_isTempComplete == true) {
					this._status = FunctionStatus.SUBMITTED_COMPLETE;
				}
				else {
					this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
				}
			}
		}
		else {
			this._status = FunctionStatus.WAITING_FOR_PREV;
		}
	}
	private isFunctionComplete(): boolean {

		if (configDefs.isStrEmty(this.busBarSystem)) return false;

		return true;
	}
	get isInputEnabled(): boolean {
		return true; // No dependency on other fields/templates
	}
	get parentSORef(): SalesOrder {
		return this._parentSORef;
	}
	set parentSORef(SORef: SalesOrder) {
		this._parentSORef = SORef;
	}
	get parentDSRef(): DataSheetIP | DataSheetSubOrderIP {
		return this._parentDSRef;
	}
	set parentDSRef(DSRef: DataSheetIP | DataSheetSubOrderIP) {
		this._parentDSRef = DSRef;
	}
	get busBarSystem(): string {
		return this._busBarSystem;
	}
	set busBarSystem(_SetVal: string) {
		this._busBarSystem = _SetVal;
	}
	get mainBusCircBreaker(): string {
		return this._mainBusCircBreaker;
	}
	set mainBusCircBreaker(_SetVal: string) {
		this._mainBusCircBreaker = _SetVal;
	}
	get feederConnect(): string {
		return this._feederConnect;
	}
	set feederConnect(_SetVal: string) {
		this._feederConnect = _SetVal;
	}
	get mainBusDropper(): string {
		return this._mainBusDropper;
	}
	set mainBusDropper(_SetVal: string) {
		this._mainBusDropper = _SetVal;
	}
	get htSleeves(): string {
		return this._htSleeves;
	}
	set htSleeves(_SetVal: string) {
		this._htSleeves = _SetVal;
	}
	get htSleevesMake(): string {
		return this._htSleevesMake;
	}
	set htSleevesMake(_SetVal: string) {
		this._htSleevesMake = _SetVal;
	}
	get insulationBusJoint(): string {
		return this._insulationBusJoint;
	}
	set insulationBusJoint(_SetVal: string) {
		this._insulationBusJoint = _SetVal;
	}
	get phaseIdentification(): string {
		return this._phaseIdentification;
	}
	set phaseIdentification(_SetVal: string) {
		this._phaseIdentification = _SetVal;
	}
	get earthBBMaterial(): string {
		return this._earthBBMaterial;
	}
	set earthBBMaterial(_SetVal: string) {
		this._earthBBMaterial = _SetVal;
	}
	get earthBBSize(): string {
		return this._earthBBSize;
	}
	set earthBBSize(_SetVal: string) {
		this._earthBBSize = _SetVal;
	}
	get isEarthSizeSpecReqApplicable(): boolean {
		if (this.earthBBSize == "003") return true; // Applicable when option is Special Req
		return false
	}
	get earthBBSize_2(): string {
		if (this.isEarthSizeSpecReqApplicable == true) {
			return this._earthBBSize_2;
		}
		return "";
	}
	set earthBBSize_2(_SetVal: string) {
		if (this.isEarthSizeSpecReqApplicable == true) {
			this._earthBBSize_2 = _SetVal;
		}
	}
	get sectionNotePM(): string {
		return this._sectionNotePM;
	}
	set sectionNotePM(_SetVal: string) {
		this._sectionNotePM = _SetVal;
	}
	get sectionNoteEE(): string {
		return this._sectionNoteEE;
	}
	set sectionNoteEE(_SetVal: string) {
		this._sectionNoteEE = _SetVal;
	}
	get sectionNoteME(): string {
		return this._sectionNoteME;
	}
	set sectionNoteME(_SetVal: string) {
		this._sectionNoteME = _SetVal;
	}
	get status(): FunctionStatus {
		return this._status;
	}

	cloneSelf(): DsBusbarsIP {
		return new DsBusbarsIP(this.busBarSystem, this.mainBusCircBreaker, this.feederConnect, this.mainBusDropper, this.htSleeves,
			this.htSleevesMake, this.insulationBusJoint, this.phaseIdentification, this.earthBBMaterial, this.earthBBSize, this.earthBBSize_2,
			this.sectionNotePM, this.sectionNoteEE, this.sectionNoteME, this.status);
	}

	public static getObj(_json: any): DsBusbarsIP {
		return new DsBusbarsIP(_json.busBarSystem, _json.mainBusCircBreaker, _json.feederConnect, _json.mainBusDropper, _json.htSleeves,
			_json.htSleevesMake, _json.insulationBusJoint, _json.phaseIdentification, _json.earthBBMaterial, _json.earthBBSize, _json.earthBBSize_2,
			_json.sectionNotePM, _json.sectionNoteEE, _json.sectionNoteME, _json.status);
	}
	public getJson(): any {
		let _json: any = {};
		_json.busBarSystem = this.busBarSystem;
		_json.mainBusCircBreaker = this.mainBusCircBreaker;
		_json.feederConnect = this.feederConnect
		_json.mainBusDropper = this.mainBusDropper;
		_json.htSleeves = this.htSleeves;
		_json.htSleevesMake = this.htSleevesMake;
		_json.insulationBusJoint = this.insulationBusJoint;
		_json.phaseIdentification = this.phaseIdentification;
		_json.earthBBMaterial = this.earthBBMaterial;
		_json.earthBBSize = this.earthBBSize;
		_json.earthBBSize_2 = this.earthBBSize_2;
		_json.sectionNotePM = this.sectionNotePM;
		_json.sectionNoteEE = this.sectionNoteEE;
		_json.sectionNoteME = this.sectionNoteME;
		_json.status = this.status;
		return _json;
	}
}
export class DsPaintingIP {
	constructor(private _applicFrntDoorEndCvr: string, private _applicFrntDoorEndCvrDetail: string, private _paintShadeApplic: string, private _seperateColor: Array<MultiOptDetails_3DS>, private _typOfPaintProc: string, private _paintProcDoc: string, private _paintFinish: string, private _mimic: string, private _mimic_v2: string,
		private _sectionNotePM: string, private _sectionNoteEE: string, private _sectionNoteME: string, private _status: FunctionStatus) {
		if (!this._sectionNotePM) this._sectionNotePM = "Paint shall be provided for Doors and Switcboard End Covers only, which are made of CRCA sheet. All other items which are made of Aluzinc material so painting is not Envisaged.";
	}

	private _parentSORef: SalesOrder;
	private _parentDSRef: DataSheetIP | DataSheetSubOrderIP;


	refreshStatus() {
		if (this.parentSORef) {
			if (this.parentSORef.projectStatus == SOStatus.Marketing) {
				this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
			}
			else if (this.parentSORef.projectStatus > SOStatus.Marketing) {
				let _isTempComplete: boolean = this.isFunctionComplete();

				if (_isTempComplete == true) {
					this._status = FunctionStatus.SUBMITTED_COMPLETE;
				}
				else {
					this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
				}
			}
		}
		else {
			this._status = FunctionStatus.WAITING_FOR_PREV;
		}
	}
	private isFunctionComplete(): boolean {

		if (configDefs.isStrEmty(this.applicFrntDoorEndCvr)) return false;

		return true;
	}
	get isInputEnabled(): boolean {
		return true; // No dependency on other fields/templates
	}
	get parentSORef(): SalesOrder {
		return this._parentSORef;
	}
	set parentSORef(SORef: SalesOrder) {
		this._parentSORef = SORef;
	}
	get parentDSRef(): DataSheetIP | DataSheetSubOrderIP {
		return this._parentDSRef;
	}
	set parentDSRef(DSRef: DataSheetIP | DataSheetSubOrderIP) {
		this._parentDSRef = DSRef;
	}
	get applicFrntDoorEndCvr(): string {
		return this._applicFrntDoorEndCvr;
	}
	set applicFrntDoorEndCvr(_SetVal: string) {
		this._applicFrntDoorEndCvr = _SetVal;
	}
	get isFrntDoorEndCvrSpecReqApplicable(): boolean {
		if (this.applicFrntDoorEndCvr == "006") return true; // Applicable when option is Special Req
		return false
	}
	get applicFrntDoorEndCvrDetail(): string {
		if (this.isFrntDoorEndCvrSpecReqApplicable == true) {
			return this._applicFrntDoorEndCvrDetail;
		}
		return "";
	}
	set applicFrntDoorEndCvrDetail(_SetVal: string) {
		if (this.isFrntDoorEndCvrSpecReqApplicable == true) {
			this._applicFrntDoorEndCvrDetail = _SetVal;
		}
	}
	get paintShadeApplic(): string {
		return this._paintShadeApplic;
	}
	set paintShadeApplic(_SetVal: string) {
		this._paintShadeApplic = _SetVal;
	}
	get seperateColor_Enable(): boolean {
		return (this.paintShadeApplic == "yes"); // Applicable when option is Yes
	}
	get seperateColor(): Array<MultiOptDetails_3DS> {
		if (this.seperateColor_Enable == true) {
			return this._seperateColor;
		}
		return [];
	}
	set seperateColor(_SetVal: Array<MultiOptDetails_3DS>) {
		if (this.seperateColor_Enable == true) {
			this._seperateColor = _SetVal;
		}
	}
	addSeperateColorDS(_scDS: MultiOptDetails_3DS) {
		this._seperateColor.push(_scDS);
	}
	removeSeperateColorDS(_rmvScDS: MultiOptDetails_3DS) {
		let index: number = this._seperateColor.indexOf(_rmvScDS);
		if (index >= 0) {
			this._seperateColor.splice(index, 1);
		}
	}
	get typOfPaintProc(): string {
		return this._typOfPaintProc;
	}
	set typOfPaintProc(_SetVal: string) {
		this._typOfPaintProc = _SetVal;
	}
	get paintProcDoc(): string {
		return this._paintProcDoc;
	}
	set paintProcDoc(_SetVal: string) {
		this._paintProcDoc = _SetVal;
	}
	get paintFinish(): string {
		return this._paintFinish;
	}
	set paintFinish(_SetVal: string) {
		this._paintFinish = _SetVal;
	}
	get mimic(): string {
		return this._mimic;
	}
	set mimic(_SetVal: string) {
		this._mimic = _SetVal;
	}
	get mimic_v2(): string {
		return this._mimic_v2;
	}
	set mimic_v2(_SetVal: string) {
		this._mimic_v2 = _SetVal;
	}
	get sectionNotePM(): string {
		return this._sectionNotePM;
	}
	set sectionNotePM(_SetVal: string) {
		this._sectionNotePM = _SetVal;
	}
	get sectionNoteEE(): string {
		return this._sectionNoteEE;
	}
	set sectionNoteEE(_SetVal: string) {
		this._sectionNoteEE = _SetVal;
	}
	get sectionNoteME(): string {
		return this._sectionNoteME;
	}
	set sectionNoteME(_SetVal: string) {
		this._sectionNoteME = _SetVal;
	}
	get status(): FunctionStatus {
		return this._status;
	}

	cloneSelf(): DsPaintingIP {
		let _tmpsc: MultiOptDetails_3DS[] = []
		if (this.seperateColor) {
			for (var i = 0; i < this.seperateColor.length; i++) {
				_tmpsc.push(this.seperateColor[i].cloneSelf());
			}
		}
		else {
			_tmpsc.push(new MultiOptDetails_3DS("", "", ""));
		}

		return new DsPaintingIP(this.applicFrntDoorEndCvr, this.applicFrntDoorEndCvrDetail, this.paintShadeApplic, _tmpsc, this.typOfPaintProc, this.paintProcDoc, this.paintFinish, this.mimic, this.mimic_v2,
			this.sectionNotePM, this.sectionNoteEE, this.sectionNoteME, this.status);
	}

	public static getObj(_json: any): DsPaintingIP {
		let _tmpsc: Array<MultiOptDetails_3DS> = [];
		if (_json.seperateColor) {
			for (var j = 0; j < _json.seperateColor.length; j++) {
				_tmpsc.push(MultiOptDetails_3DS.getObj(_json.seperateColor[j]));
			}
		}
		else {
			_tmpsc.push(new MultiOptDetails_3DS("", "", ""));
		}
		return new DsPaintingIP(_json.applicFrntDoorEndCvr, _json.applicFrntDoorEndCvrDetail, _json.paintShadeApplic, _tmpsc, _json.typOfPaintProc, _json.paintProcDoc, _json.paintFinish, _json.mimic, _json.mimic_v2,
			_json.sectionNotePM, _json.sectionNoteEE, _json.sectionNoteME, _json.status);
	}
	public getJson(): any {
		let _json: any = {};
		_json.applicFrntDoorEndCvr = this.applicFrntDoorEndCvr;
		_json.applicFrntDoorEndCvrDetail = this.applicFrntDoorEndCvrDetail;
		_json.paintShadeApplic = this.paintShadeApplic;
		_json.seperateColor = [];
		_json.typOfPaintProc = this.typOfPaintProc;
		_json.paintProcDoc = this.paintProcDoc;
		_json.paintFinish = this.paintFinish
		_json.mimic = this.mimic;
		_json.mimic_v2 = this.mimic_v2;
		_json.sectionNotePM = this.sectionNotePM;
		_json.sectionNoteEE = this.sectionNoteEE;
		_json.sectionNoteME = this.sectionNoteME;
		_json.status = this.status;

		for (var i = 0; i < this._seperateColor.length; i++) {
			_json.seperateColor.push(this._seperateColor[i].getJson());
		}
		return _json;
	}
}
export class DsControlAuxIP {
	constructor(private _closeTripCirc: string, private _addTripCoilCirc: string, private _addTripCoilCircDetail: string, private _springChargingMotor: string, private _meteringConAux: string, private _spaceHeater: string, private _annunCircuit: string,
		private _sectionNotePM: string, private _sectionNoteEE: string, private _sectionNoteME: string, private _status: FunctionStatus) {

	}

	private _parentSORef: SalesOrder;
	private _parentDSRef: DataSheetIP | DataSheetSubOrderIP;


	refreshStatus() {
		if (this.parentSORef) {
			if (this.parentSORef.projectStatus == SOStatus.Marketing) {
				this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
			}
			else if (this.parentSORef.projectStatus > SOStatus.Marketing) {
				let _isTempComplete: boolean = this.isFunctionComplete();

				if (_isTempComplete == true) {
					this._status = FunctionStatus.SUBMITTED_COMPLETE;
				}
				else {
					this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
				}
			}
		}
		else {
			this._status = FunctionStatus.WAITING_FOR_PREV;
		}
	}
	private isFunctionComplete(): boolean {

		if (configDefs.isStrEmty(this.closeTripCirc)) return false;

		return true;
	}
	get isInputEnabled(): boolean {
		return true; // No dependency on other fields/templates
	}
	get parentSORef(): SalesOrder {
		return this._parentSORef;
	}
	set parentSORef(SORef: SalesOrder) {
		this._parentSORef = SORef;
	}
	get parentDSRef(): DataSheetIP | DataSheetSubOrderIP {
		return this._parentDSRef;
	}
	set parentDSRef(DSRef: DataSheetIP | DataSheetSubOrderIP) {
		this._parentDSRef = DSRef;
	}
	get closeTripCirc(): string {
		return this._closeTripCirc;
	}
	set closeTripCirc(_SetVal: string) {
		this._closeTripCirc = _SetVal;
	}
	get addTripCoilCirc(): string {
		return this._addTripCoilCirc;
	}
	set addTripCoilCirc(_SetVal: string) {
		this._addTripCoilCirc = _SetVal;
	}
	get isAddTripCoilSpecReqApplicable(): boolean {
		if (this.addTripCoilCirc == "013") return true; // Applicable when option is Partially Applicable
		return false
	}
	get addTripCoilCircDetail(): string {
		if (this.isAddTripCoilSpecReqApplicable == true) {
			return this._addTripCoilCircDetail;
		}
		else return this._addTripCoilCircDetail = "";
	}
	set addTripCoilCircDetail(_SetVal: string) {
		if (this.isAddTripCoilSpecReqApplicable == true) {
			this._addTripCoilCircDetail = _SetVal;
		}
	}
	get springChargingMotor(): string {
		return this._springChargingMotor;
	}
	set springChargingMotor(_SetVal: string) {
		this._springChargingMotor = _SetVal;
	}
	get meteringConAux(): string {
		return this._meteringConAux;
	}
	set meteringConAux(_SetVal: string) {
		this._meteringConAux = _SetVal;
	}
	get spaceHeater(): string {
		return this._spaceHeater;
	}
	set spaceHeater(_SetVal: string) {
		this._spaceHeater = _SetVal;
	}
	get annunCircuit(): string {
		return this._annunCircuit;
	}
	set annunCircuit(_SetVal: string) {
		this._annunCircuit = _SetVal;
	}
	get sectionNotePM(): string {
		return this._sectionNotePM;
	}
	set sectionNotePM(_SetVal: string) {
		this._sectionNotePM = _SetVal;
	}
	get sectionNoteEE(): string {
		return this._sectionNoteEE;
	}
	set sectionNoteEE(_SetVal: string) {
		this._sectionNoteEE = _SetVal;
	}
	get sectionNoteME(): string {
		return this._sectionNoteME;
	}
	set sectionNoteME(_SetVal: string) {
		this._sectionNoteME = _SetVal;
	}
	get status(): FunctionStatus {
		return this._status;
	}

	cloneSelf(): DsControlAuxIP {
		return new DsControlAuxIP(this.closeTripCirc, this.addTripCoilCirc, this.addTripCoilCircDetail, this.springChargingMotor, this.meteringConAux, this.spaceHeater, this.annunCircuit,
			this.sectionNotePM, this.sectionNoteEE, this.sectionNoteME, this.status);
	}

	public static getObj(_json: any): DsControlAuxIP {
		return new DsControlAuxIP(_json.closeTripCirc, _json.addTripCoilCirc, _json.addTripCoilCircDetail, _json.springChargingMotor, _json.meteringConAux, _json.spaceHeater, _json.annunCircuit,
			_json.sectionNotePM, _json.sectionNoteEE, _json.sectionNoteME, _json.status);
	}
	public getJson(): any {
		let _json: any = {};
		_json.closeTripCirc = this.closeTripCirc;
		_json.addTripCoilCirc = this.addTripCoilCirc;
		_json.addTripCoilCircDetail = this.addTripCoilCircDetail;
		_json.springChargingMotor = this.springChargingMotor;
		_json.meteringConAux = this.meteringConAux
		_json.spaceHeater = this.spaceHeater;
		_json.annunCircuit = this.annunCircuit;
		_json.sectionNotePM = this.sectionNotePM;
		_json.sectionNoteEE = this.sectionNoteEE;
		_json.sectionNoteME = this.sectionNoteME;
		_json.status = this.status;
		return _json;
	}
}
export class DsControlWiringIP {
	constructor(private _conWireType: string, private _conWireTypeDetail: string, private _applicStand: string, private _insulationGrade: string, private _wireTypeV2: string, private _wireTypeV2Detail: string, private _ctCircuit: string, private _ctCircuitColor: string,
		private _ptCircuit: string, private _ptCircuitColor: string, private _dcConCircuit: string, private _dcConCircuitColor: string, private _acConCircuit: string, private _acConCircuitColor: string, private _earthWire: string,
		private _earthWireColor: string, private _hingeDoorEarth: string, private _mainDCCirc: string, private _mainDCCircColor: string, private _mainACCirc: string, private _mainACCircColor: string, private _ferrulling: string,
		private _ferrullingMat: string, private _ferrullingMatDetail: string, private _sectionNotePM: string, private _sectionNoteEE: string, private _sectionNoteME: string,
		private _status: FunctionStatus) {
		if (!this.applicStand) this.applicStand = "002"; // By Default IEC	
		if (!this._wireTypeV2) this._wireTypeV2 = "001"; // By Default Bare Stranded Copper	
		if (!this._hingeDoorEarth) this._hingeDoorEarth = "001"; // By Default Braided Copper	
		if (!this._ferrullingMat) this._ferrullingMat = "001"; // By Default PVC	

	}

	private _parentSORef: SalesOrder;
	private _parentDSRef: DataSheetIP | DataSheetSubOrderIP;

	refreshStatus() {
		if (this.parentSORef) {
			if (this.parentSORef.projectStatus == SOStatus.Marketing) {
				this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
			}
			else if (this.parentSORef.projectStatus > SOStatus.Marketing) {
				let _isTempComplete: boolean = this.isFunctionComplete();

				if (_isTempComplete == true) {
					this._status = FunctionStatus.SUBMITTED_COMPLETE;
				}
				else {
					this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
				}
			}
		}
		else {
			this._status = FunctionStatus.WAITING_FOR_PREV;
		}
	}
	private isFunctionComplete(): boolean {

		if (configDefs.isStrEmty(this.conWireType)) return false;

		return true;
	}
	get parentSORef(): SalesOrder {
		return this._parentSORef;
	}
	set parentSORef(SORef: SalesOrder) {
		this._parentSORef = SORef;
	}
	get parentDSRef(): DataSheetIP | DataSheetSubOrderIP {
		return this._parentDSRef;
	}
	set parentDSRef(DSRef: DataSheetIP | DataSheetSubOrderIP) {
		this._parentDSRef = DSRef;
	}
	get conWireType(): string {
		return this._conWireType;
	}
	set conWireType(_SetVal: string) {
		this._conWireType = _SetVal;
	}
	get isConWireSpecReqApplicable(): boolean {
		if (this.conWireType == "002") return true; // Applicable when option is Special Req
		return false
	}
	get conWireTypeDetail(): string {
		if (this.isConWireSpecReqApplicable == true) {
			return this._conWireTypeDetail;
		}
		return "";
	}
	set conWireTypeDetail(_SetVal: string) {
		if (this.isConWireSpecReqApplicable == true) {
			this._conWireTypeDetail = _SetVal;
		}
	}
	get applicStand(): string {
		return this._applicStand;
	}
	set applicStand(_SetVal: string) {
		this._applicStand = _SetVal;
	}
	get insulationGrade(): string {
		return this._insulationGrade;
	}
	set insulationGrade(_SetVal: string) {
		this._insulationGrade = _SetVal;
	}
	get wireTypeV2(): string {
		return this._wireTypeV2;
	}
	set wireTypeV2(_SetVal: string) {
		this._wireTypeV2 = _SetVal;
	}
	get isWireTypeSpecReqApplicable(): boolean {
		if (this.wireTypeV2 == "002") return true; // Applicable when option is Special Req
		return false
	}
	get wireTypeV2Detail(): string {
		if (this.isWireTypeSpecReqApplicable == true) {
			return this._wireTypeV2Detail;
		}
		return "";
	}
	set wireTypeV2Detail(_SetVal: string) {
		if (this.isWireTypeSpecReqApplicable == true) {
			this._wireTypeV2Detail = _SetVal;
		}
	}
	get ctCircuit(): string {
		return this._ctCircuit;
	}
	set ctCircuit(_SetVal: string) {
		this._ctCircuit = _SetVal;
	}
	get ctCircuitColor(): string {
		return this._ctCircuitColor;
	}
	set ctCircuitColor(_SetVal: string) {
		this._ctCircuitColor = _SetVal;
	}
	get ptCircuit(): string {
		return this._ptCircuit;
	}
	set ptCircuit(_SetVal: string) {
		this._ptCircuit = _SetVal;
	}
	get ptCircuitColor(): string {
		return this._ptCircuitColor;
	}
	set ptCircuitColor(_SetVal: string) {
		this._ptCircuitColor = _SetVal;
	}
	get dcConCircuit(): string {
		return this._dcConCircuit;
	}
	set dcConCircuit(_SetVal: string) {
		this._dcConCircuit = _SetVal;
	}
	get dcConCircuitColor(): string {
		return this._dcConCircuitColor;
	}
	set dcConCircuitColor(_SetVal: string) {
		this._dcConCircuitColor = _SetVal;
	}
	get acConCircuit(): string {
		return this._acConCircuit;
	}
	set acConCircuit(_SetVal: string) {
		this._acConCircuit = _SetVal;
	}
	get acConCircuitColor(): string {
		return this._acConCircuitColor;
	}
	set acConCircuitColor(_SetVal: string) {
		this._acConCircuitColor = _SetVal;
	}
	get earthWire(): string {
		return this._earthWire;
	}
	set earthWire(_SetVal: string) {
		this._earthWire = _SetVal;
	}
	get isEarthWireSpecReqApplicable(): boolean {
		if (this.earthWire == "004") return false; // Disable when option is Braided Copper
		return true;
	}
	get earthWireColor(): string {
		return this._earthWireColor;
	}
	set earthWireColor(_SetVal: string) {
		this._earthWireColor = _SetVal;
	}
	get hingeDoorEarth(): string {
		return this._hingeDoorEarth;
	}
	set hingeDoorEarth(_SetVal: string) {
		this._hingeDoorEarth = _SetVal;
	}
	get mainDCCirc(): string {
		return this._mainDCCirc;
	}
	set mainDCCirc(_SetVal: string) {
		this._mainDCCirc = _SetVal;
	}
	get isMainDCSpecReqApplicable(): boolean {
		if (this.mainDCCirc == "003") return false; // Disable when option is Cu Bus
		return true;
	}
	get mainDCCircColor(): string {
		return this._mainDCCircColor;
	}
	set mainDCCircColor(_SetVal: string) {
		this._mainDCCircColor = _SetVal;
	}
	get mainACCirc(): string {
		return this._mainACCirc;
	}
	set mainACCirc(_SetVal: string) {
		this._mainACCirc = _SetVal;
	}
	get isMainACSpecReqApplicable(): boolean {
		if (this.mainACCirc == "003") return false; // Disable when option is Cu Bus
		return true;
	}
	get mainACCircColor(): string {
		return this._mainACCircColor;
	}
	set mainACCircColor(_SetVal: string) {
		this._mainACCircColor = _SetVal;
	}
	get ferrulling(): string {
		return this._ferrulling;
	}
	set ferrulling(_SetVal: string) {
		this._ferrulling = _SetVal;
	}
	get ferrullingMat(): string {
		return this._ferrullingMat;
	}
	set ferrullingMat(_SetVal: string) {
		this._ferrullingMat = _SetVal;
	}
	get isFerrSpecReqApplicable(): boolean {
		if (this.ferrullingMat == "002") return true; // Applicable when option is Special Req
		return false;
	}
	get ferrullingMatDetail(): string {
		if (this.isFerrSpecReqApplicable == true) {
			return this._ferrullingMatDetail;
		}
		return "";
	}
	set ferrullingMatDetail(_SetVal: string) {
		if (this.isFerrSpecReqApplicable == true) {
			this._ferrullingMatDetail = _SetVal;
		}
	}
	get sectionNotePM(): string {
		return this._sectionNotePM;
	}
	set sectionNotePM(_SetVal: string) {
		this._sectionNotePM = _SetVal;
	}
	get sectionNoteEE(): string {
		return this._sectionNoteEE;
	}
	set sectionNoteEE(_SetVal: string) {
		this._sectionNoteEE = _SetVal;
	}
	get sectionNoteME(): string {
		return this._sectionNoteME;
	}
	set sectionNoteME(_SetVal: string) {
		this._sectionNoteME = _SetVal;
	}
	get status(): FunctionStatus {
		return this._status;
	}

	cloneSelf(): DsControlWiringIP {
		return new DsControlWiringIP(this.conWireType, this.conWireTypeDetail, this.applicStand, this.insulationGrade, this.wireTypeV2, this.wireTypeV2Detail, this.ctCircuit,
			this.ctCircuitColor, this.ptCircuit, this.ptCircuitColor, this.dcConCircuit, this.dcConCircuitColor, this.acConCircuit, this.acConCircuitColor,
			this.earthWire, this.earthWireColor, this.hingeDoorEarth, this.mainDCCirc, this.mainDCCircColor, this.mainACCirc, this.mainACCircColor, this.ferrulling,
			this.ferrullingMat, this.ferrullingMatDetail, this.sectionNotePM, this.sectionNoteEE, this.sectionNoteME, this.status);
	}

	public static getObj(_json: any): DsControlWiringIP {
		return new DsControlWiringIP(_json.conWireType, _json.conWireTypeDetail, _json.applicStand, _json.insulationGrade, _json.wireTypeV2, _json.wireTypeV2Detail, _json.ctCircuit,
			_json.ctCircuitColor, _json.ptCircuit, _json.ptCircuitColor, _json.dcConCircuit, _json.dcConCircuitColor, _json.acConCircuit, _json.acConCircuitColor,
			_json.earthWire, _json.earthWireColor, _json.hingeDoorEarth, _json.mainDCCirc, _json.mainDCCircColor, _json.mainACCirc, _json.mainACCircColor, _json.ferrulling,
			_json.ferrullingMat, _json.ferrullingMatDetail, _json.sectionNotePM, _json.sectionNoteEE, _json.sectionNoteME, _json.status);
	}
	public getJson(): any {
		let _json: any = {};
		_json.conWireType = this.conWireType;
		_json.conWireTypeDetail = this.conWireTypeDetail;
		_json.applicStand = this.applicStand;
		_json.insulationGrade = this.insulationGrade;
		_json.wireTypeV2 = this.wireTypeV2;
		_json.wireTypeV2Detail = this.wireTypeV2Detail;
		_json.ctCircuit = this.ctCircuit;
		_json.ctCircuitColor = this.ctCircuitColor;
		_json.ptCircuit = this.ptCircuit;
		_json.ptCircuitColor = this.ptCircuitColor;
		_json.dcConCircuit = this.dcConCircuit;
		_json.dcConCircuitColor = this.dcConCircuitColor;
		_json.acConCircuit = this.acConCircuit;
		_json.acConCircuitColor = this.acConCircuitColor;
		_json.earthWire = this.earthWire;
		_json.earthWireColor = this.earthWireColor;
		_json.hingeDoorEarth = this.hingeDoorEarth;
		_json.mainDCCirc = this.mainDCCirc;
		_json.mainDCCircColor = this.mainDCCircColor;
		_json.mainACCirc = this.mainACCirc;
		_json.mainACCircColor = this.mainACCircColor;
		_json.ferrulling = this.ferrulling;
		_json.ferrullingMat = this.ferrullingMat;
		_json.ferrullingMatDetail = this.ferrullingMatDetail;
		_json.sectionNotePM = this.sectionNotePM;
		_json.sectionNoteEE = this.sectionNoteEE;
		_json.sectionNoteME = this.sectionNoteME;
		_json.status = this.status;
		return _json;
	}
}
export class DsTerminalBlocksIP {
	constructor(private _termBlockMat: string, private _termBlockMake: string, private _termBlockMakeDetail: string, private _currTrnfCirc: string, private _potentTrnfCirc: string, private _typeOfTermDisc: string, private _termBlockContCirc: string,
		private _typeOfTermNonDisc: string, private _sectionNotePM: string, private _sectionNoteEE: string, private _sectionNoteME: string, private _status: FunctionStatus) {
		if (!this._termBlockMat) this._termBlockMat = "001"; // By Default Polymide
	}

	private _parentSORef: SalesOrder;
	private _parentDSRef: DataSheetIP | DataSheetSubOrderIP;


	refreshStatus() {
		if (this.parentSORef) {
			if (this.parentSORef.projectStatus == SOStatus.Marketing) {
				this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
			}
			else if (this.parentSORef.projectStatus > SOStatus.Marketing) {
				let _isTempComplete: boolean = this.isFunctionComplete();

				if (_isTempComplete == true) {
					this._status = FunctionStatus.SUBMITTED_COMPLETE;
				}
				else {
					this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
				}
			}
		}
		else {
			this._status = FunctionStatus.WAITING_FOR_PREV;
		}
	}
	private isFunctionComplete(): boolean {

		if (configDefs.isStrEmty(this.termBlockMat)) return false;

		return true;
	}
	get isInputEnabled(): boolean {
		return true; // No dependency on other fields/templates
	}
	get parentSORef(): SalesOrder {
		return this._parentSORef;
	}
	set parentSORef(SORef: SalesOrder) {
		this._parentSORef = SORef;
	}
	get parentDSRef(): DataSheetIP | DataSheetSubOrderIP {
		return this._parentDSRef;
	}
	set parentDSRef(DSRef: DataSheetIP | DataSheetSubOrderIP) {
		this._parentDSRef = DSRef;
	}
	get termBlockMat(): string {
		return this._termBlockMat;
	}
	set termBlockMat(_SetVal: string) {
		this._termBlockMat = _SetVal;
	}
	get termBlockMake(): string {
		return this._termBlockMake;
	}
	set termBlockMake(_SetVal: string) {
		this._termBlockMake = _SetVal;
	}
	get isTermBlockMakeSpecReqApplicable(): boolean {
		if (this.termBlockMake == "004") return true; // Applicable when option is Others
		return false;
	}
	get termBlockMakeDetail(): string {
		if (this.isTermBlockMakeSpecReqApplicable == true) {
			return this._termBlockMakeDetail;
		}
		return "";
	}
	set termBlockMakeDetail(_SetVal: string) {
		if (this.isTermBlockMakeSpecReqApplicable == true) {
			this._termBlockMakeDetail = _SetVal;
		}
	}
	get currTrnfCirc(): string {
		return this._currTrnfCirc;
	}
	set currTrnfCirc(_SetVal: string) {
		this._currTrnfCirc = _SetVal;
	}
	get potentTrnfCirc(): string {
		return this._potentTrnfCirc;
	}
	set potentTrnfCirc(_SetVal: string) {
		this._potentTrnfCirc = _SetVal;
	}
	get typeOfTermDisc(): string {
		if (this.isTermBlockMakeSpecReqApplicable == false) { // Disable when option is Others
			return this._typeOfTermDisc;
		}
		return "";
	}
	set typeOfTermDisc(_SetVal: string) {
		if (this.isTermBlockMakeSpecReqApplicable == false) { // Disable when option is Others
			this._typeOfTermDisc = _SetVal;
		}
	}
	get termBlockContCirc(): string {
		return this._termBlockContCirc;
	}
	set termBlockContCirc(_SetVal: string) {
		this._termBlockContCirc = _SetVal;
	}
	get typeOfTermNonDisc(): string {
		if (this.isTermBlockMakeSpecReqApplicable == false) { // Disable when option is Others
			return this._typeOfTermNonDisc;
		}
		return "";
	}
	set typeOfTermNonDisc(_SetVal: string) {
		if (this.isTermBlockMakeSpecReqApplicable == false) { // Disable when option is Others
			this._typeOfTermNonDisc = _SetVal;
		}
	}
	get sectionNotePM(): string {
		return this._sectionNotePM;
	}
	set sectionNotePM(_SetVal: string) {
		this._sectionNotePM = _SetVal;
	}
	get sectionNoteEE(): string {
		return this._sectionNoteEE;
	}
	set sectionNoteEE(_SetVal: string) {
		this._sectionNoteEE = _SetVal;
	}
	get sectionNoteME(): string {
		return this._sectionNoteME;
	}
	set sectionNoteME(_SetVal: string) {
		this._sectionNoteME = _SetVal;
	}
	get status(): FunctionStatus {
		return this._status;
	}

	cloneSelf(): DsTerminalBlocksIP {
		return new DsTerminalBlocksIP(this.termBlockMat, this.termBlockMake, this.termBlockMakeDetail, this.currTrnfCirc, this.potentTrnfCirc, this.typeOfTermDisc, this.termBlockContCirc, this.typeOfTermNonDisc,
			this.sectionNotePM, this.sectionNoteEE, this.sectionNoteME, this.status);
	}

	public static getObj(_json: any): DsTerminalBlocksIP {
		return new DsTerminalBlocksIP(_json.termBlockMat, _json.termBlockMake, _json.termBlockMakeDetail, _json.currTrnfCirc, _json.potentTrnfCirc, _json.typeOfTermDisc, _json.termBlockContCirc,
			_json.typeOfTermNonDisc, _json.sectionNotePM, _json.sectionNoteEE, _json.sectionNoteME, _json.status);
	}
	public getJson(): any {
		let _json: any = {};
		_json.termBlockMat = this.termBlockMat;
		_json.termBlockMake = this.termBlockMake;
		_json.termBlockMakeDetail = this.termBlockMakeDetail;
		_json.currTrnfCirc = this.currTrnfCirc;
		_json.potentTrnfCirc = this.potentTrnfCirc
		_json.typeOfTermDisc = this.typeOfTermDisc;
		_json.termBlockContCirc = this.termBlockContCirc;
		_json.typeOfTermNonDisc = this.typeOfTermNonDisc;
		_json.sectionNotePM = this.sectionNotePM;
		_json.sectionNoteEE = this.sectionNoteEE;
		_json.sectionNoteME = this.sectionNoteME;
		_json.status = this.status;
		return _json;
	}
}
export class DsCircuitBreakerIP {
	constructor(private _cbMake: string, private _diElect: string, private _cbDynamicPeakCurr: string, private _ratedSingleCap: string, private _maxArcTime: string, private _openingTime: string,
		private _totalBreakTime: string, private _closingTime: string, private _ratedOpSeq: string, private _cbClass: string, private _maxDCComp: string, private _maxDCCompDetail: string, private _ratedMkCurr: string,
		private _cbFreeFix: string, private _cbCastleRockReq: string, private _uvCoil: string, private _uvCoilDetail: Array<MultiOptDetails_1DS>, private _cbConVoltUVCoil: string, private _cbWattCloseCoil: string, private _cbWattTripCoil: string, private _cbWattAddTripCoil: string,
		private _cbWattSpringChg: string, private _vacContactor: string, private _vacContType: string, private _cbCloseTripVolt: string, private _cbLatchType: string,
		private _sectionNotePM: string, private _sectionNoteEE: string, private _sectionNoteME: string,
		private _status: FunctionStatus) {
		if (!this._cbMake) this._cbMake = "ABB"; // By Default ABB
		if (!this._ratedSingleCap) this._ratedSingleCap = "001"; // By Default
		if (!this._maxArcTime) this._maxArcTime = "001"; // By Default
		if (!this._openingTime) this._openingTime = "001"; // By Default
		if (!this._totalBreakTime) this._totalBreakTime = "001"; // By Default
		if (!this._closingTime) this._closingTime = "001"; // By Default
		if (!this._ratedOpSeq) this._ratedOpSeq = "001"; // By Default
		if (!this._cbClass) this._cbClass = "001"; // By Default
		if (!this._cbFreeFix) this._cbFreeFix = "001"; // By Default
	}

	private _parentSORef: SalesOrder;
	private _parentDSRef: DataSheetIP | DataSheetSubOrderIP;

	refreshStatus() {
		if (this.parentSORef) {
			if (this.parentSORef.projectStatus == SOStatus.Marketing) {
				this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
			}
			else if (this.parentSORef.projectStatus > SOStatus.Marketing) {
				let _isTempComplete: boolean = this.isFunctionComplete();

				if (_isTempComplete == true) {
					this._status = FunctionStatus.SUBMITTED_COMPLETE;
				}
				else {
					this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
				}
			}
		}
		else {
			this._status = FunctionStatus.WAITING_FOR_PREV;
		}
	}
	private isFunctionComplete(): boolean {

		if (configDefs.isStrEmty(this.cbMake)) return false;

		return true;
	}
	get parentSORef(): SalesOrder {
		return this._parentSORef;
	}
	set parentSORef(SORef: SalesOrder) {
		this._parentSORef = SORef;
	}
	get parentDSRef(): DataSheetIP | DataSheetSubOrderIP {
		return this._parentDSRef;
	}
	set parentDSRef(DSRef: DataSheetIP | DataSheetSubOrderIP) {
		this._parentDSRef = DSRef;
	}
	get cbMake(): string {
		return this._cbMake;
	}
	set cbMake(_SetVal: string) {
		this._cbMake = _SetVal;
	}
	get diElect(): string {
		return this._diElect;
	}
	set diElect(_SetVal: string) {
		this._diElect = _SetVal;
	}
	get cbDynamicPeakCurr(): string {
		return this._cbDynamicPeakCurr;
	}
	set cbDynamicPeakCurr(_SetVal: string) {
		this._cbDynamicPeakCurr = _SetVal;
	}
	get ratedSingleCap(): string {
		return this._ratedSingleCap;
	}
	set ratedSingleCap(_SetVal: string) {
		this._ratedSingleCap = _SetVal;
	}
	get maxArcTime(): string {
		return this._maxArcTime;
	}
	set maxArcTime(_SetVal: string) {
		this._maxArcTime = _SetVal;
	}
	get openingTime(): string {
		return this._openingTime;
	}
	set openingTime(_SetVal: string) {
		this._openingTime = _SetVal;
	}
	get totalBreakTime(): string {
		return this._totalBreakTime;
	}
	set totalBreakTime(_SetVal: string) {
		this._totalBreakTime = _SetVal;
	}
	get closingTime(): string {
		return this._closingTime;
	}
	set closingTime(_SetVal: string) {
		this._closingTime = _SetVal;
	}
	get ratedOpSeq(): string {
		return this._ratedOpSeq;
	}
	set ratedOpSeq(_SetVal: string) {
		this._ratedOpSeq = _SetVal;
	}
	get cbClass(): string {
		return this._cbClass;
	}
	set cbClass(_SetVal: string) {
		this._cbClass = _SetVal;
	}
	get maxDCComp(): string {
		return this._maxDCComp;
	}
	set maxDCComp(_SetVal: string) {
		this._maxDCComp = _SetVal;
	}
	get isMaxDCSpecReqApplicable(): boolean {
		if (this.maxDCComp == "002") return true; // Applicable when option is Special Req
		return false
	}
	get maxDCCompDetail(): string {
		return this._maxDCCompDetail;
	}
	set maxDCCompDetail(_SetVal: string) {
		this._maxDCCompDetail = _SetVal;
	}
	get ratedMkCurr(): string {
		return this._ratedMkCurr;
	}
	set ratedMkCurr(_SetVal: string) {
		this._ratedMkCurr = _SetVal;
	}
	get cbFreeFix(): string {
		return this._cbFreeFix;
	}
	set cbFreeFix(_SetVal: string) {
		this._cbFreeFix = _SetVal;
	}
	get cbCastleRockReq(): string {
		return this._cbCastleRockReq;
	}
	set cbCastleRockReq(_SetVal: string) {
		this._cbCastleRockReq = _SetVal;
	}
	get uvCoil(): string {
		return this._uvCoil;
	}
	set uvCoil(_SetVal: string) {
		this._uvCoil = _SetVal;
	}
	get uvCoilDetail(): Array<MultiOptDetails_1DS> {
		return this._uvCoilDetail;
	}
	set uvCoilDetail(_SetVal: Array<MultiOptDetails_1DS>) {
		this._uvCoilDetail = _SetVal;
	}
	get uvCoilDetail_Enable(): boolean {
		return (this.uvCoil == "003"); // Applicable when option is Partially Applicable
	}

	addUvCoilDetailDS(_crDS: MultiOptDetails_1DS) {

		this._uvCoilDetail.push(_crDS);
	}
	removeUvCoilDetailDS(_rmvCrDS: MultiOptDetails_1DS) {
		let index: number = this._uvCoilDetail.indexOf(_rmvCrDS);
		if (index >= 0) {
			this._uvCoilDetail.splice(index, 1);
		}
	}
	get uvCoilDetailApplicable(): boolean {
		return (this.uvCoil == "001" || this.uvCoil == "003"); // Applicable when option is Applicable or Partially Applicable
	}
	get cbConVoltUVCoil(): string {
		if (this.uvCoilDetailApplicable) {
			return this._cbConVoltUVCoil;
		}
		return this._cbConVoltUVCoil = "";
	}
	set cbConVoltUVCoil(_SetVal: string) {
		if (this.uvCoilDetailApplicable) {
			this._cbConVoltUVCoil = _SetVal;
		}
	}
	get cbWattCloseCoil(): string {
		return this._cbWattCloseCoil;
	}
	set cbWattCloseCoil(_SetVal: string) {
		this._cbWattCloseCoil = _SetVal;
	}
	get cbWattTripCoil(): string {
		return this._cbWattTripCoil;
	}
	set cbWattTripCoil(_SetVal: string) {
		this._cbWattTripCoil = _SetVal;
	}
	get cbWattAddTripCoil(): string {
		return this._cbWattAddTripCoil;
	}
	set cbWattAddTripCoil(_SetVal: string) {
		this._cbWattAddTripCoil = _SetVal;
	}
	get cbWattSpringChg(): string {
		return this._cbWattSpringChg;
	}
	set cbWattSpringChg(_SetVal: string) {
		this._cbWattSpringChg = _SetVal;
	}
	get vacuumCont_Enable(): boolean {
		return this.parentDSRef.dsPanelIP.vcbModelDetail == "005" || this.parentDSRef.dsPanelIP.vcbModelDetail == "003"; // Enable when VCB Model contains "Convac"
	}
	get vacContactor(): string {
		return this._vacContactor;
	}
	set vacContactor(_SetVal: string) {
		this._vacContactor = _SetVal;
	}
	get isVacContSpecReqApplicable(): boolean {
		if (this.vacContactor == "001") return true; // Applicable when option is Applicable
		return false;
	}
	get vacContType(): string {
		return this._vacContType;
	}
	set vacContType(_SetVal: string) {
		this._vacContType = _SetVal;
	}
	get cbCloseTripVolt(): string {
		return this._cbCloseTripVolt;
	}
	set cbCloseTripVolt(_SetVal: string) {
		this._cbCloseTripVolt = _SetVal;
	}
	get cbLatchType(): string {
		if (this.isVacContSpecReqApplicable == true) {
			return this._cbLatchType;
		}
		return "";
	}
	set cbLatchType(_SetVal: string) {
		if (this.isVacContSpecReqApplicable == true) {
			this._cbLatchType = _SetVal;
		}
	}
	get sectionNotePM(): string {
		return this._sectionNotePM;
	}
	set sectionNotePM(_SetVal: string) {
		this._sectionNotePM = _SetVal;
	}
	get sectionNoteEE(): string {
		return this._sectionNoteEE;
	}
	set sectionNoteEE(_SetVal: string) {
		this._sectionNoteEE = _SetVal;
	}
	get sectionNoteME(): string {
		return this._sectionNoteME;
	}
	set sectionNoteME(_SetVal: string) {
		this._sectionNoteME = _SetVal;
	}
	get status(): FunctionStatus {
		return this._status;
	}

	cloneSelf(): DsCircuitBreakerIP {
		let _tmpUv: MultiOptDetails_1DS[] = []
		if (this.uvCoilDetail) {
			for (var i = 0; i < this.uvCoilDetail.length; i++) {
				_tmpUv.push(this.uvCoilDetail[i].cloneSelf());
			}
		}
		else {
			_tmpUv.push(new MultiOptDetails_1DS(""));
		}

		return new DsCircuitBreakerIP(this.cbMake, this.diElect, this.cbDynamicPeakCurr, this.ratedSingleCap, this.maxArcTime,
			this.openingTime, this.totalBreakTime, this.closingTime, this.ratedOpSeq, this.cbClass, this.maxDCComp, this.maxDCCompDetail,
			this.ratedMkCurr, this.cbFreeFix, this.cbCastleRockReq, this.uvCoil, _tmpUv, this.cbConVoltUVCoil, this.cbWattCloseCoil, this.cbWattTripCoil, this.cbWattAddTripCoil,
			this.cbWattSpringChg, this.vacContactor, this.vacContType, this.cbCloseTripVolt, this.cbLatchType, this.sectionNotePM, this.sectionNoteEE, this.sectionNoteME, this.status);
	}

	public static getObj(_json: any): DsCircuitBreakerIP {
		let _tmpUv: MultiOptDetails_1DS[] = []
		if (_json.uvCoilDetail) {
			for (var j = 0; j < _json.uvCoilDetail.length; j++) {
				_tmpUv.push(MultiOptDetails_1DS.getObj(_json.uvCoilDetail[j]));
			}
		}
		else {
			_tmpUv.push(new MultiOptDetails_1DS(""));
		}

		return new DsCircuitBreakerIP(_json.cbMake, _json.diElect, _json.cbDynamicPeakCurr, _json.ratedSingleCap, _json.maxArcTime,
			_json.openingTime, _json.totalBreakTime, _json.closingTime, _json.ratedOpSeq, _json.cbClass, _json.maxDCComp, _json.maxDCCompDetail,
			_json.ratedMkCurr, _json.cbFreeFix, _json.cbCastleRockReq, _json.uvCoil, _tmpUv, _json.cbConVoltUVCoil, _json.cbWattCloseCoil, _json.cbWattTripCoil, _json.cbWattAddTripCoil,
			_json.cbWattSpringChg, _json.vacContactor, _json.vacContType, _json.cbCloseTripVolt, _json.cbLatchType, _json.sectionNotePM, _json.sectionNoteEE, _json.sectionNoteME, _json.status);
	}
	public getJson(): any {
		let _json: any = {};
		_json.cbMake = this.cbMake;
		_json.diElect = this.diElect;
		_json.cbDynamicPeakCurr = this.cbDynamicPeakCurr;
		_json.ratedSingleCap = this.ratedSingleCap;
		_json.maxArcTime = this.maxArcTime;
		_json.openingTime = this.openingTime;
		_json.totalBreakTime = this.totalBreakTime;
		_json.closingTime = this.closingTime;
		_json.ratedOpSeq = this.ratedOpSeq;
		_json.cbClass = this.cbClass;
		_json.maxDCComp = this.maxDCComp;
		_json.maxDCCompDetail = this.maxDCCompDetail;
		_json.ratedMkCurr = this.ratedMkCurr;
		_json.cbFreeFix = this.cbFreeFix;
		_json.cbCastleRockReq = this.cbCastleRockReq;
		_json.uvCoil = this.uvCoil;
		_json.uvCoilDetail = [];
		_json.cbConVoltUVCoil = this.cbConVoltUVCoil;
		_json.cbWattCloseCoil = this.cbWattCloseCoil;
		_json.cbWattAddTripCoil = this.cbWattAddTripCoil;
		_json.cbWattTripCoil = this.cbWattTripCoil;
		_json.cbWattSpringChg = this.cbWattSpringChg;
		_json.vacContactor = this.vacContactor;
		_json.vacContType = this.vacContType;
		_json.cbCloseTripVolt = this.cbCloseTripVolt;
		_json.cbLatchType = this.cbLatchType;
		_json.sectionNotePM = this.sectionNotePM;
		_json.sectionNoteEE = this.sectionNoteEE;
		_json.sectionNoteME = this.sectionNoteME;
		_json.status = this.status;
		for (var i = 0; i < this._uvCoilDetail.length; i++) {
			_json.uvCoilDetail.push(this._uvCoilDetail[i].getJson());
		}
		return _json;
	}
}
export class DsCurrentTrafoIP {
	constructor(private _currTrafoType: string, private _ctMould: Array<MultiOptDetails_8DS>, private _insulationCl: string, private _instruSafety: string, private _ctShortTimeCurrDr: string,
		private _ctShortTimeCurrDrDetail: string, private _ctCBCT: string, private _ctCBCTRatio: string, private _minPrimBal: string,
		private _basicInsuLvl: string, private _ctCBCTId: string, private _sectionNotePM: string, private _sectionNoteEE: string, private _sectionNoteME: string, private _status: FunctionStatus) {
		if (!this._currTrafoType) this._currTrafoType = "Epoxy resin cast"; // By Default Epoxy resin cast
		if (!this._minPrimBal) this._minPrimBal = "001";
		if (!this._basicInsuLvl) this._basicInsuLvl = "001";
		if (!this._sectionNotePM) this._sectionNotePM = "1. For Bushing CT Rated BIL shall be aplicable when CT mounting on bushing.";

	}

	private _parentSORef: SalesOrder;
	private _parentDSRef: DataSheetIP | DataSheetSubOrderIP;


	refreshStatus() {
		if (this.parentSORef) {
			if (this.parentSORef.projectStatus == SOStatus.Marketing) {
				this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
			}
			else if (this.parentSORef.projectStatus > SOStatus.Marketing) {
				let _isTempComplete: boolean = this.isFunctionComplete();

				if (_isTempComplete == true) {
					this._status = FunctionStatus.SUBMITTED_COMPLETE;
				}
				else {
					this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
				}
			}
		}
		else {
			this._status = FunctionStatus.WAITING_FOR_PREV;
		}
	}
	private isFunctionComplete(): boolean {

		if (configDefs.isStrEmty(this.currTrafoType)) return false;

		return true;
	}
	get isInputEnabled(): boolean {
		return true; // No dependency on other fields/templates
	}
	get parentSORef(): SalesOrder {
		return this._parentSORef;
	}
	set parentSORef(SORef: SalesOrder) {
		this._parentSORef = SORef;
	}
	get parentDSRef(): DataSheetIP | DataSheetSubOrderIP {
		return this._parentDSRef;
	}
	set parentDSRef(DSRef: DataSheetIP | DataSheetSubOrderIP) {
		this._parentDSRef = DSRef;
	}
	get currTrafoType(): string {
		return this._currTrafoType;
	}
	set currTrafoType(_SetVal: string) {
		this._currTrafoType = _SetVal;
	}
	get ctMould(): Array<MultiOptDetails_8DS> {
		return this._ctMould;
	}
	set ctMould(_SetVal: Array<MultiOptDetails_8DS>) {
		this._ctMould = _SetVal;
	}
	addCtMouldDS(_crDS: MultiOptDetails_8DS) {
		this._ctMould.push(_crDS);
	}
	removeCtMouldDS(_rmvCrDS: MultiOptDetails_8DS) {
		let index: number = this._ctMould.indexOf(_rmvCrDS);
		if (index >= 0) {
			this._ctMould.splice(index, 1);
		}
	}
	get insulationCl(): string {
		return this._insulationCl;
	}
	set insulationCl(_SetVal: string) {
		this._insulationCl = _SetVal;
	}
	get instruSafety(): string {
		return this._instruSafety;
	}
	set instruSafety(_SetVal: string) {
		this._instruSafety = _SetVal;
	}
	get ctShortTimeCurrDr(): string {
		return this._ctShortTimeCurrDr;
	}
	set ctShortTimeCurrDr(_SetVal: string) {
		this._ctShortTimeCurrDr = _SetVal;
	}
	get isCtShortTimeCurrDrSpecReqApplicable(): boolean {
		if (this.ctShortTimeCurrDr == "003" || this.ctShortTimeCurrDr == "004") return true; // Applicable when option is Special Req
		return false;
	}
	get ctShortTimeCurrDrDetail(): string {
		if (this.isCtShortTimeCurrDrSpecReqApplicable == true) {
			return this._ctShortTimeCurrDrDetail;
		}
		return this._ctShortTimeCurrDrDetail = "";
	}
	set ctShortTimeCurrDrDetail(_SetVal: string) {
		if (this.isCtShortTimeCurrDrSpecReqApplicable == true) {
			this._ctShortTimeCurrDrDetail = _SetVal;
		}
	}
	get ctCBCT(): string {
		return this._ctCBCT;
	}
	set ctCBCT(_SetVal: string) {
		this._ctCBCT = _SetVal;
	}
	get ctCBCTRatio(): string {
		return this._ctCBCTRatio;
	}
	set ctCBCTRatio(_SetVal: string) {
		this._ctCBCTRatio = _SetVal;
	}
	get minPrimBal(): string {
		return this._minPrimBal;
	}
	set minPrimBal(_SetVal: string) {
		this._minPrimBal = _SetVal;
	}
	get basicInsuLvl(): string {
		return this._basicInsuLvl;
	}
	set basicInsuLvl(_SetVal: string) {
		this._basicInsuLvl = _SetVal;
	}
	get ctCBCTId(): string {
		return this._ctCBCTId;
	}
	set ctCBCTId(_SetVal: string) {
		this._ctCBCTId = _SetVal;
	}
	get sectionNotePM(): string {
		return this._sectionNotePM;
	}
	set sectionNotePM(_SetVal: string) {
		this._sectionNotePM = _SetVal;
	}
	get sectionNoteEE(): string {
		return this._sectionNoteEE;
	}
	set sectionNoteEE(_SetVal: string) {
		this._sectionNoteEE = _SetVal;
	}
	get sectionNoteME(): string {
		return this._sectionNoteME;
	}
	set sectionNoteME(_SetVal: string) {
		this._sectionNoteME = _SetVal;
	}
	get status(): FunctionStatus {
		return this._status;
	}

	cloneSelf(): DsCurrentTrafoIP {
		let _tempct: MultiOptDetails_8DS[] = []
		for (var i = 0; i < this.ctMould.length; i++) {
			_tempct.push(this.ctMould[i].cloneSelf());
		}

		return new DsCurrentTrafoIP(this.currTrafoType, _tempct, this.insulationCl, this.instruSafety, this.ctShortTimeCurrDr,
			this.ctShortTimeCurrDrDetail, this.ctCBCT, this.ctCBCTRatio, this.minPrimBal, this.basicInsuLvl, this.ctCBCTId,
			this.sectionNotePM, this.sectionNoteEE, this.sectionNoteME, this.status);
	}

	public static emptyObj(): DsCurrentTrafoIP {
		let ctMouldDS: MultiOptDetails_8DS = new MultiOptDetails_8DS("", "", "", "", "", "", "", "");
		let ctMouldDSlist: Array<MultiOptDetails_8DS> = [];
		ctMouldDSlist.push(ctMouldDS);

		return new DsCurrentTrafoIP("", ctMouldDSlist, "", "", "", "", "", "", "", "", "", "", "", "", null);
	}

	public static getObj(_json: any): DsCurrentTrafoIP {

		let _tempct: Array<MultiOptDetails_8DS> = [];
		for (var j = 0; j < _json.ctMould.length; j++) {
			_tempct.push(MultiOptDetails_8DS.getObj(_json.ctMould[j]));
		}

		return new DsCurrentTrafoIP(_json.currTrafoType, _tempct, _json.insulationCl, _json.instruSafety, _json.ctShortTimeCurrDr,
			_json.ctShortTimeCurrDrDetail, _json.ctCBCT, _json.ctCBCTRatio, _json.minPrimBal, _json.basicInsuLvl, _json.ctCBCTId,
			_json.sectionNotePM, _json.sectionNoteEE, _json.sectionNoteME, _json.status);
	}
	public getJson(): any {
		let _json: any = {};
		_json.currTrafoType = this.currTrafoType;
		_json.ctMould = [];
		_json.insulationCl = this.insulationCl
		_json.instruSafety = this.instruSafety;
		_json.ctShortTimeCurrDr = this.ctShortTimeCurrDr;
		_json.ctShortTimeCurrDrDetail = this.ctShortTimeCurrDrDetail;
		_json.ctCBCT = this.ctCBCT;
		_json.ctCBCTRatio = this.ctCBCTRatio;
		_json.minPrimBal = this.minPrimBal;
		_json.basicInsuLvl = this.basicInsuLvl;
		_json.ctCBCTId = this.ctCBCTId;
		_json.sectionNotePM = this.sectionNotePM;
		_json.sectionNoteEE = this.sectionNoteEE;
		_json.sectionNoteME = this.sectionNoteME;
		_json.status = this.status;

		for (var j = 0; j < this._ctMould.length; j++) {
			_json.ctMould.push(this._ctMould[j].getJson());
		}
		return _json;
	}
}
export class DsPotentialTrafoIP {
	constructor(private _potTrafoType: string, private _potTrafoMountingType: Array<MultiOptDetails_3DS>, private _potTrafoInsulationCl: string, private _basicInsulLvl: string,
		private _sectionNotePM: string, private _sectionNoteEE: string, private _sectionNoteME: string, private _status: FunctionStatus) {
		if (!this._potTrafoType) this._potTrafoType = "Epoxy resin cast"; // By Default Epoxy resin cast

	}

	private _parentSORef: SalesOrder;
	private _parentDSRef: DataSheetIP | DataSheetSubOrderIP;


	refreshStatus() {
		if (this.parentSORef) {
			if (this.parentSORef.projectStatus == SOStatus.Marketing) {
				this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
			}
			else if (this.parentSORef.projectStatus > SOStatus.Marketing) {
				let _isTempComplete: boolean = this.isFunctionComplete();

				if (_isTempComplete == true) {
					this._status = FunctionStatus.SUBMITTED_COMPLETE;
				}
				else {
					this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
				}
			}
		}
		else {
			this._status = FunctionStatus.WAITING_FOR_PREV;
		}
	}
	private isFunctionComplete(): boolean {

		if (configDefs.isStrEmty(this.potTrafoType)) return false;

		return true;
	}
	get isInputEnabled(): boolean {
		return true; // No dependency on other fields/templates
	}
	get parentSORef(): SalesOrder {
		return this._parentSORef;
	}
	set parentSORef(SORef: SalesOrder) {
		this._parentSORef = SORef;
	}
	get parentDSRef(): DataSheetIP | DataSheetSubOrderIP {
		return this._parentDSRef;
	}
	set parentDSRef(DSRef: DataSheetIP | DataSheetSubOrderIP) {
		this._parentDSRef = DSRef;
	}
	get potTrafoType(): string {
		return this._potTrafoType;
	}
	set potTrafoType(_SetVal: string) {
		this._potTrafoType = _SetVal;
	}
	get potTrafoMountingType(): Array<MultiOptDetails_3DS> {
		return this._potTrafoMountingType;
	}
	set potTrafoMountingType(_SetVal: Array<MultiOptDetails_3DS>) {
		this._potTrafoMountingType = _SetVal;
	}
	addPotTrafoMountingTypeDS(_crDS: MultiOptDetails_3DS) {
		this._potTrafoMountingType.push(_crDS);
	}
	removePotTrafoMountingTypeDS(_rmvCrDS: MultiOptDetails_3DS) {
		let index: number = this._potTrafoMountingType.indexOf(_rmvCrDS);
		if (index >= 0) {
			this._potTrafoMountingType.splice(index, 1);
		}
	}
	get potTrafoInsulationCl(): string {
		return this._potTrafoInsulationCl;
	}
	set potTrafoInsulationCl(_SetVal: string) {
		this._potTrafoInsulationCl = _SetVal;
	}
	get basicInsulLvl(): string {
		let _concatVal = "";
		_concatVal = this.parentDSRef.dsGeneralIP.dryFrqWithstdVolt + " / " + this.parentDSRef.dsGeneralIP.ratedImpulseVoltage;
		this._basicInsulLvl = _concatVal;
		return this._basicInsulLvl;
	}
	set basicInsulLvl(_SetVal: string) {
		this._basicInsulLvl = _SetVal;
	}
	get sectionNotePM(): string {
		return this._sectionNotePM;
	}
	set sectionNotePM(_SetVal: string) {
		this._sectionNotePM = _SetVal;
	}
	get sectionNoteEE(): string {
		return this._sectionNoteEE;
	}
	set sectionNoteEE(_SetVal: string) {
		this._sectionNoteEE = _SetVal;
	}
	get sectionNoteME(): string {
		return this._sectionNoteME;
	}
	set sectionNoteME(_SetVal: string) {
		this._sectionNoteME = _SetVal;
	}
	get status(): FunctionStatus {
		return this._status;
	}

	cloneSelf(): DsPotentialTrafoIP {
		let _tempct: MultiOptDetails_3DS[] = []
		for (var i = 0; i < this.potTrafoMountingType.length; i++) {
			_tempct.push(this.potTrafoMountingType[i].cloneSelf());
		}

		return new DsPotentialTrafoIP(this.potTrafoType, _tempct, this.potTrafoInsulationCl, this.basicInsulLvl,
			this.sectionNotePM, this.sectionNoteEE, this.sectionNoteME, this.status);
	}

	public static emptyObj(): DsPotentialTrafoIP {
		let potTrafoMountingTypeDS: MultiOptDetails_3DS = new MultiOptDetails_3DS("", "", "");
		let potTrafoMountingTypeDSlist: Array<MultiOptDetails_3DS> = [];
		potTrafoMountingTypeDSlist.push(potTrafoMountingTypeDS);

		return new DsPotentialTrafoIP("", potTrafoMountingTypeDSlist, "", "", "", "", "", null);
	}

	public static getObj(_json: any): DsPotentialTrafoIP {

		let _tempmt: Array<MultiOptDetails_3DS> = [];
		for (var j = 0; j < _json.potTrafoMountingType.length; j++) {
			_tempmt.push(MultiOptDetails_3DS.getObj(_json.potTrafoMountingType[j]));
		}

		return new DsPotentialTrafoIP(_json.potTrafoType, _tempmt, _json.potTrafoInsulationCl, _json.basicInsulLvl,
			_json.sectionNotePM, _json.sectionNoteEE, _json.sectionNoteME, _json.status);
	}
	public getJson(): any {
		let _json: any = {};
		_json.potTrafoType = this.potTrafoType;
		_json.potTrafoMountingType = [];
		_json.potTrafoInsulationCl = this.potTrafoInsulationCl
		_json.basicInsulLvl = this.basicInsulLvl;
		_json.sectionNotePM = this.sectionNotePM;
		_json.sectionNoteEE = this.sectionNoteEE;
		_json.sectionNoteME = this.sectionNoteME;
		_json.status = this.status;

		for (var j = 0; j < this._potTrafoMountingType.length; j++) {
			_json.potTrafoMountingType.push(this._potTrafoMountingType[j].getJson());
		}
		return _json;
	}
}
export class DsNumericalRelayIP {
	constructor(private _mainProtRelay: string, private _numRelayMake: string, private _numRelayMakeDetail: string, private _numRelayMakeDetailOther: string, private _numRelayType: string, private _relayCommProtcl: string,
		private _relayCommPort: string, private _timeSyncProtCl: string, private _numRelayCoating: string,
		private _numRelayArcProtc: string, private _transducerReqRTD: Array<MultiOptDetails_2DS>,
		private _sectionNotePM: string, private _sectionNoteEE: string, private _sectionNoteME: string, private _status: FunctionStatus) {
		if (!this._numRelayType) this._numRelayType = "001"; // By Default

	}

	private _parentSORef: SalesOrder;
	private _parentDSRef: DataSheetIP | DataSheetSubOrderIP;


	refreshStatus() {
		if (this.parentSORef) {
			if (this.parentSORef.projectStatus == SOStatus.Marketing) {
				this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
			}
			else if (this.parentSORef.projectStatus > SOStatus.Marketing) {
				let _isTempComplete: boolean = this.isFunctionComplete();

				if (_isTempComplete == true) {
					this._status = FunctionStatus.SUBMITTED_COMPLETE;
				}
				else {
					this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
				}
			}
		}
		else {
			this._status = FunctionStatus.WAITING_FOR_PREV;
		}
	}
	private isFunctionComplete(): boolean {

		if (configDefs.isStrEmty(this.mainProtRelay)) return false;

		return true;
	}
	get isInputEnabled(): boolean {
		return true; // No dependency on other fields/templates
	}
	get parentSORef(): SalesOrder {
		return this._parentSORef;
	}
	set parentSORef(SORef: SalesOrder) {
		this._parentSORef = SORef;
	}
	get parentDSRef(): DataSheetIP | DataSheetSubOrderIP {
		return this._parentDSRef;
	}
	set parentDSRef(DSRef: DataSheetIP | DataSheetSubOrderIP) {
		this._parentDSRef = DSRef;
	}
	get mainProtRelay(): string {
		return this._mainProtRelay;
	}
	set mainProtRelay(_SetVal: string) {
		this._mainProtRelay = _SetVal;
	}
	get mainProtRelay_Enable(): boolean {
		if (this.mainProtRelay == "001") return true; // Applicable
		return false
	}
	get numRelayMake(): string {
		return this._numRelayMake;
	}
	set numRelayMake(_SetVal: string) {
		this._numRelayMake = _SetVal;
	}
	get isNumRelayMakeApplicable(): boolean {
		if (this.numRelayMake == "002") return true; // Applicable on Sprecial Req
		return false
	}
	get numRelayMakeDetail(): string {
		if (this.isNumRelayMakeApplicable == true) {
			return this._numRelayMakeDetail;
		}
		return "";
	}
	set numRelayMakeDetail(_SetVal: string) {
		if (this.isNumRelayMakeApplicable == true) {
			this._numRelayMakeDetail = _SetVal;
		}
	}
	get isNumRelayMakeDetailApplicable(): boolean {
		if (this.numRelayMakeDetail == "004") return true; // Applicable when Make is Other
		return false;
	}
	get numRelayMakeDetailOther(): string {
		if (this.isNumRelayMakeDetailApplicable == true) {
			return this._numRelayMakeDetailOther;
		}
		return "";
	}
	set numRelayMakeDetailOther(_SetVal: string) {
		if (this.isNumRelayMakeDetailApplicable == true) {
			this._numRelayMakeDetailOther = _SetVal;
		}
	}
	get numRelayType(): string {
		return this._numRelayType;
	}
	set numRelayType(_SetVal: string) {
		this._numRelayType = _SetVal;
	}
	get relayCommProtcl(): string {
		return this._relayCommProtcl;
	}
	set relayCommProtcl(_SetVal: string) {
		this._relayCommProtcl = _SetVal;
	}
	get relayCommPort(): string {
		return this._relayCommPort;
	}
	set relayCommPort(_SetVal: string) {
		this._relayCommPort = _SetVal;
	}
	get timeSyncProtCl(): string {
		return this._timeSyncProtCl;
	}
	set timeSyncProtCl(_SetVal: string) {
		this._timeSyncProtCl = _SetVal;
	}
	get numRelayCoating(): string {
		return this._numRelayCoating;
	}
	set numRelayCoating(_SetVal: string) {
		this._numRelayCoating = _SetVal;
	}
	get numRelayArcProtc(): string {
		return this._numRelayArcProtc;
	}
	set numRelayArcProtc(_SetVal: string) {
		this._numRelayArcProtc = _SetVal;
	}
	get transducerReqRTD(): Array<MultiOptDetails_2DS> {
		return this._transducerReqRTD;
	}
	set transducerReqRTD(_SetVal: Array<MultiOptDetails_2DS>) {
		this._transducerReqRTD = _SetVal;
	}
	addTransReqDS(_trDS: MultiOptDetails_2DS) {
		this._transducerReqRTD.push(_trDS);
	}
	removeTransReqDS(_rmvTrDS: MultiOptDetails_2DS) {
		let index: number = this._transducerReqRTD.indexOf(_rmvTrDS);
		if (index >= 0) {
			this._transducerReqRTD.splice(index, 1);
		}
	}
	get sectionNotePM(): string {
		return this._sectionNotePM;
	}
	set sectionNotePM(_SetVal: string) {
		this._sectionNotePM = _SetVal;
	}
	get sectionNoteEE(): string {
		return this._sectionNoteEE;
	}
	set sectionNoteEE(_SetVal: string) {
		this._sectionNoteEE = _SetVal;
	}
	get sectionNoteME(): string {
		return this._sectionNoteME;
	}
	set sectionNoteME(_SetVal: string) {
		this._sectionNoteME = _SetVal;
	}
	get status(): FunctionStatus {
		return this._status;
	}

	cloneSelf(): DsNumericalRelayIP {
		let _tempTr: MultiOptDetails_2DS[] = []
		for (var i = 0; i < this.transducerReqRTD.length; i++) {
			_tempTr.push(this.transducerReqRTD[i].cloneSelf());
		}

		return new DsNumericalRelayIP(this.mainProtRelay, this.numRelayMake, this.numRelayMakeDetail, this.numRelayMakeDetailOther, this.numRelayType, this.relayCommProtcl,
			this.relayCommPort, this.timeSyncProtCl, this.numRelayCoating, this.numRelayArcProtc, _tempTr, this.sectionNotePM, this.sectionNoteEE, this.sectionNoteME, this.status);
	}

	public static emptyObj(): DsNumericalRelayIP {
		let trReqDS: MultiOptDetails_2DS = new MultiOptDetails_2DS("", "");
		let trReqDSlist: Array<MultiOptDetails_2DS> = [];
		trReqDSlist.push(trReqDS);

		return new DsNumericalRelayIP("", "", "", "", "", "", "", "", "", "", trReqDSlist, "", "", "", null);
	}

	public static getObj(_json: any): DsNumericalRelayIP {

		let _tempTr: Array<MultiOptDetails_2DS> = [];
		for (var j = 0; j < _json.transducerReqRTD.length; j++) {
			_tempTr.push(MultiOptDetails_2DS.getObj(_json.transducerReqRTD[j]));
		}

		return new DsNumericalRelayIP(_json.mainProtRelay, _json.numRelayMake, _json.numRelayMakeDetail, _json.numRelayMakeDetailOther, _json.numRelayType, _json.relayCommProtcl,
			_json.relayCommPort, _json.timeSyncProtCl, _json.numRelayCoating, _json.numRelayArcProtc, _tempTr, _json.sectionNotePM, _json.sectionNoteEE, _json.sectionNoteME, _json.status);
	}
	public getJson(): any {
		let _json: any = {};
		_json.mainProtRelay = this.mainProtRelay;
		_json.numRelayMake = this.numRelayMake;
		_json.numRelayMakeDetail = this.numRelayMakeDetail;
		_json.numRelayMakeDetailOther = this.numRelayMakeDetailOther;
		_json.numRelayType = this.numRelayType;
		_json.relayCommProtcl = this.relayCommProtcl;
		_json.relayCommPort = this.relayCommPort;
		_json.timeSyncProtCl = this.timeSyncProtCl;
		_json.numRelayCoating = this.numRelayCoating;
		_json.numRelayArcProtc = this.numRelayArcProtc;
		_json.transducerReqRTD = [];
		_json.sectionNotePM = this.sectionNotePM;
		_json.sectionNoteEE = this.sectionNoteEE;
		_json.sectionNoteME = this.sectionNoteME;
		_json.status = this.status;

		for (var j = 0; j < this._transducerReqRTD.length; j++) {
			_json.transducerReqRTD.push(this._transducerReqRTD[j].getJson());
		}
		return _json;
	}
}
export class DsAuxRelayIP {
	constructor(private _auxRelTripCoil1: string, private _auxRelTripCoil2: string, private _auxMasterTripRelay: string,
		private _sectionNotePM: string, private _sectionNoteEE: string, private _sectionNoteME: string, private _status: FunctionStatus) {

	}

	private _parentSORef: SalesOrder;
	private _parentDSRef: DataSheetIP | DataSheetSubOrderIP;


	refreshStatus() {
		if (this.parentSORef) {
			if (this.parentSORef.projectStatus == SOStatus.Marketing) {
				this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
			}
			else if (this.parentSORef.projectStatus > SOStatus.Marketing) {
				let _isTempComplete: boolean = this.isFunctionComplete();

				if (_isTempComplete == true) {
					this._status = FunctionStatus.SUBMITTED_COMPLETE;
				}
				else {
					this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
				}
			}
		}
		else {
			this._status = FunctionStatus.WAITING_FOR_PREV;
		}
	}
	private isFunctionComplete(): boolean {

		if (configDefs.isStrEmty(this.auxRelTripCoil1)) return false;

		return true;
	}
	get isInputEnabled(): boolean {
		return true; // No dependency on other fields/templates
	}
	get parentSORef(): SalesOrder {
		return this._parentSORef;
	}
	set parentSORef(SORef: SalesOrder) {
		this._parentSORef = SORef;
	}
	get parentDSRef(): DataSheetIP | DataSheetSubOrderIP {
		return this._parentDSRef;
	}
	set parentDSRef(DSRef: DataSheetIP | DataSheetSubOrderIP) {
		this._parentDSRef = DSRef;
	}
	get auxRelTripCoil1(): string {
		return this._auxRelTripCoil1;
	}
	set auxRelTripCoil1(_SetVal: string) {
		this._auxRelTripCoil1 = _SetVal;
	}
	get isAuxRelTripCoil2Applicable(): boolean {
		if (this.parentDSRef.dsControlAuxIP.addTripCoilCirc == "012") return false; // Not Applicable the don't have Aux Relay Trip Coil 2
		return true;
	}
	get auxRelTripCoil2(): string {
		if (!this.isAuxRelTripCoil2Applicable) return "";
		return this._auxRelTripCoil2;
	}
	set auxRelTripCoil2(_SetVal: string) {
		if (!this.isAuxRelTripCoil2Applicable) return;
		this._auxRelTripCoil2 = _SetVal;
	}
	get auxMasterTripRelay(): string {
		return this._auxMasterTripRelay;
	}
	set auxMasterTripRelay(_SetVal: string) {
		this._auxMasterTripRelay = _SetVal;
	}
	get sectionNotePM(): string {
		return this._sectionNotePM;
	}
	set sectionNotePM(_SetVal: string) {
		this._sectionNotePM = _SetVal;
	}
	get sectionNoteEE(): string {
		return this._sectionNoteEE;
	}
	set sectionNoteEE(_SetVal: string) {
		this._sectionNoteEE = _SetVal;
	}
	get sectionNoteME(): string {
		return this._sectionNoteME;
	}
	set sectionNoteME(_SetVal: string) {
		this._sectionNoteME = _SetVal;
	}
	get status(): FunctionStatus {
		return this._status;
	}

	cloneSelf(): DsAuxRelayIP {

		return new DsAuxRelayIP(this.auxRelTripCoil1, this.auxRelTripCoil2, this.auxMasterTripRelay, this.sectionNotePM, this.sectionNoteEE, this.sectionNoteME, this.status);
	}

	public static emptyObj(): DsAuxRelayIP {

		return new DsAuxRelayIP("", "", "", "", "", "", null);
	}

	public static getObj(_json: any): DsAuxRelayIP {

		return new DsAuxRelayIP(_json.auxRelTripCoil1, _json.auxRelTripCoil2, _json.auxMasterTripRelay, _json.sectionNotePM, _json.sectionNoteEE, _json.sectionNoteME, _json.status);
	}
	public getJson(): any {
		let _json: any = {};
		_json.auxRelTripCoil1 = this.auxRelTripCoil1;
		_json.auxRelTripCoil2 = this.auxRelTripCoil2
		_json.auxMasterTripRelay = this.auxMasterTripRelay;
		_json.sectionNotePM = this.sectionNotePM;
		_json.sectionNoteEE = this.sectionNoteEE;
		_json.sectionNoteME = this.sectionNoteME;
		_json.status = this.status;

		return _json;
	}
}
export class DsMetersIP {
	constructor(private _multiFuncMeter: Array<MultiOptDetails_6DS>, private _triVectMeter: Array<MultiOptDetails_6DS>, private _ammeterType: string, private _ammeterDisplay: string,
		private _sectionNotePM: string, private _sectionNoteEE: string, private _sectionNoteME: string, private _status: FunctionStatus) {

	}

	private _parentSORef: SalesOrder;
	private _parentDSRef: DataSheetIP | DataSheetSubOrderIP;


	refreshStatus() {
		if (this.parentSORef) {
			if (this.parentSORef.projectStatus == SOStatus.Marketing) {
				this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
			}
			else if (this.parentSORef.projectStatus > SOStatus.Marketing) {
				let _isTempComplete: boolean = this.isFunctionComplete();

				if (_isTempComplete == true) {
					this._status = FunctionStatus.SUBMITTED_COMPLETE;
				}
				else {
					this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
				}
			}
		}
		else {
			this._status = FunctionStatus.WAITING_FOR_PREV;
		}
	}
	private isFunctionComplete(): boolean {

		if (configDefs.isStrEmty(this.ammeterType)) return false;

		return true;
	}
	get isInputEnabled(): boolean {
		return true; // No dependency on other fields/templates
	}
	get parentSORef(): SalesOrder {
		return this._parentSORef;
	}
	set parentSORef(SORef: SalesOrder) {
		this._parentSORef = SORef;
	}
	get parentDSRef(): DataSheetIP | DataSheetSubOrderIP {
		return this._parentDSRef;
	}
	set parentDSRef(DSRef: DataSheetIP | DataSheetSubOrderIP) {
		this._parentDSRef = DSRef;
	}
	get multiFuncMeter(): Array<MultiOptDetails_6DS> {
		return this._multiFuncMeter;
	}
	set multiFuncMeter(_SetVal: Array<MultiOptDetails_6DS>) {
		this._multiFuncMeter = _SetVal;
	}
	addMutliFuncDS(_mfDS: MultiOptDetails_6DS) {
		this._multiFuncMeter.push(_mfDS);
	}
	removeMutliFuncDS(_rmvMfDS: MultiOptDetails_6DS) {
		let index: number = this._multiFuncMeter.indexOf(_rmvMfDS);
		if (index >= 0) {
			this._multiFuncMeter.splice(index, 1);
		}
	}
	get triVectMeter(): Array<MultiOptDetails_6DS> {
		return this._triVectMeter;
	}
	set triVectMeter(_SetVal: Array<MultiOptDetails_6DS>) {
		this._triVectMeter = _SetVal;
	}
	addTriVectDS(_tvDS: MultiOptDetails_6DS) {
		this._triVectMeter.push(_tvDS);
	}
	removeTriVectDS(_rmvTvDS: MultiOptDetails_6DS) {
		let index: number = this._triVectMeter.indexOf(_rmvTvDS);
		if (index >= 0) {
			this._triVectMeter.splice(index, 1);
		}
	}
	get ammeterType(): string {
		return this._ammeterType;
	}
	set ammeterType(_SetVal: string) {
		this._ammeterType = _SetVal;
	}
	get ammeterTypeApplicable(): boolean {
		if (this.ammeterType == "004") return false; // When opt selected is Not Applicable
		return true;
	}
	get ammeterDisplay(): string {
		return this._ammeterDisplay;
	}
	set ammeterDisplay(_SetVal: string) {
		this._ammeterDisplay = _SetVal;
	}
	get sectionNotePM(): string {
		return this._sectionNotePM;
	}
	set sectionNotePM(_SetVal: string) {
		this._sectionNotePM = _SetVal;
	}
	get sectionNoteEE(): string {
		return this._sectionNoteEE;
	}
	set sectionNoteEE(_SetVal: string) {
		this._sectionNoteEE = _SetVal;
	}
	get sectionNoteME(): string {
		return this._sectionNoteME;
	}
	set sectionNoteME(_SetVal: string) {
		this._sectionNoteME = _SetVal;
	}
	get status(): FunctionStatus {
		return this._status;
	}

	cloneSelf(): DsMetersIP {
		let _tempMf: MultiOptDetails_6DS[] = []
		for (var i = 0; i < this.multiFuncMeter.length; i++) {
			_tempMf.push(this.multiFuncMeter[i].cloneSelf());
		}
		let _tempTrv: MultiOptDetails_6DS[] = []
		for (var i = 0; i < this.triVectMeter.length; i++) {
			_tempTrv.push(this.triVectMeter[i].cloneSelf());
		}

		return new DsMetersIP(_tempMf, _tempTrv, this.ammeterType, this.ammeterDisplay, this.sectionNotePM, this.sectionNoteEE, this.sectionNoteME, this.status);
	}

	public static emptyObj(): DsMetersIP {
		let multiFDS: MultiOptDetails_6DS = new MultiOptDetails_6DS("", "", "", "", "", "",);
		let multiFDSlist: Array<MultiOptDetails_6DS> = [];
		multiFDSlist.push(multiFDS);

		let triVecDS: MultiOptDetails_6DS = new MultiOptDetails_6DS("", "", "", "", "", "");
		let triVecDSlist: Array<MultiOptDetails_6DS> = [];
		triVecDSlist.push(triVecDS);

		return new DsMetersIP(multiFDSlist, triVecDSlist, "", "", "", "", "", null);
	}

	public static getObj(_json: any): DsMetersIP {
		let _tempMf: Array<MultiOptDetails_6DS> = [];
		for (var j = 0; j < _json.multiFuncMeter.length; j++) {
			_tempMf.push(MultiOptDetails_6DS.getObj(_json.multiFuncMeter[j]));
		}

		let _tempTriV: Array<MultiOptDetails_6DS> = [];
		for (var j = 0; j < _json.triVectMeter.length; j++) {
			_tempTriV.push(MultiOptDetails_6DS.getObj(_json.triVectMeter[j]));
		}

		return new DsMetersIP(_tempMf, _tempTriV, _json.ammeterType, _json.ammeterDisplay, _json.sectionNotePM, _json.sectionNoteEE, _json.sectionNoteME, _json.status);
	}
	public getJson(): any {
		let _json: any = {};
		_json.multiFuncMeter = [];
		_json.triVectMeter = [];
		_json.ammeterType = this.ammeterType;
		_json.ammeterDisplay = this.ammeterDisplay;
		_json.sectionNotePM = this.sectionNotePM;
		_json.sectionNoteEE = this.sectionNoteEE;
		_json.sectionNoteME = this.sectionNoteME;
		_json.status = this.status;

		for (var j = 0; j < this._multiFuncMeter.length; j++) {
			_json.multiFuncMeter.push(this._multiFuncMeter[j].getJson());
		}
		for (var j = 0; j < this._triVectMeter.length; j++) {
			_json.triVectMeter.push(this._triVectMeter[j].getJson());
		}
		return _json;
	}
}
export class DsSurgeArrestorIP {
	constructor(private _surgeArr: Array<MultiOptDetails_3DS>, private _typeDesg: string, private _disCurrent: string,
		private _sectionNotePM: string, private _sectionNoteEE: string, private _sectionNoteME: string, private _status: FunctionStatus) {

		if (!this._typeDesg) this._typeDesg = "001"; // By Default
		if (!this._disCurrent) this._disCurrent = "001"; // By Default
	}

	private _parentSORef: SalesOrder;
	private _parentDSRef: DataSheetIP | DataSheetSubOrderIP;


	refreshStatus() {
		if (this.parentSORef) {
			if (this.parentSORef.projectStatus == SOStatus.Marketing) {
				this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
			}
			else if (this.parentSORef.projectStatus > SOStatus.Marketing) {
				let _isTempComplete: boolean = this.isFunctionComplete();

				if (_isTempComplete == true) {
					this._status = FunctionStatus.SUBMITTED_COMPLETE;
				}
				else {
					this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
				}
			}
		}
		else {
			this._status = FunctionStatus.WAITING_FOR_PREV;
		}
	}
	private isFunctionComplete(): boolean {

		if (configDefs.isStrEmty(this.typeDesg)) return false;

		return true;
	}
	get isInputEnabled(): boolean {
		return true; // No dependency on other fields/templates
	}
	get parentSORef(): SalesOrder {
		return this._parentSORef;
	}
	set parentSORef(SORef: SalesOrder) {
		this._parentSORef = SORef;
	}
	get parentDSRef(): DataSheetIP | DataSheetSubOrderIP {
		return this._parentDSRef;
	}
	set parentDSRef(DSRef: DataSheetIP | DataSheetSubOrderIP) {
		this._parentDSRef = DSRef;
	}
	get surgeArr(): Array<MultiOptDetails_3DS> {
		return this._surgeArr;
	}
	set surgeArr(_SetVal: Array<MultiOptDetails_3DS>) {
		this._surgeArr = _SetVal;
	}
	addSurgArrDS(_srDS: MultiOptDetails_3DS) {
		this._surgeArr.push(_srDS);
	}
	removeSurgArrDS(_rmvSrDS: MultiOptDetails_3DS) {
		let index: number = this._surgeArr.indexOf(_rmvSrDS);
		if (index >= 0) {
			this._surgeArr.splice(index, 1);
		}
	}
	get typeDesg(): string {
		return this._typeDesg;
	}
	set typeDesg(_SetVal: string) {
		this._typeDesg = _SetVal;
	}
	get disCurrent(): string {
		return this._disCurrent;
	}
	set disCurrent(_SetVal: string) {
		this._disCurrent = _SetVal;
	}
	get sectionNotePM(): string {
		return this._sectionNotePM;
	}
	set sectionNotePM(_SetVal: string) {
		this._sectionNotePM = _SetVal;
	}
	get sectionNoteEE(): string {
		return this._sectionNoteEE;
	}
	set sectionNoteEE(_SetVal: string) {
		this._sectionNoteEE = _SetVal;
	}
	get sectionNoteME(): string {
		return this._sectionNoteME;
	}
	set sectionNoteME(_SetVal: string) {
		this._sectionNoteME = _SetVal;
	}
	get status(): FunctionStatus {
		return this._status;
	}

	cloneSelf(): DsSurgeArrestorIP {
		let _tempSr: MultiOptDetails_3DS[] = []
		for (var i = 0; i < this.surgeArr.length; i++) {
			_tempSr.push(this.surgeArr[i].cloneSelf());
		}

		return new DsSurgeArrestorIP(_tempSr, this.typeDesg, this.disCurrent, this.sectionNotePM, this.sectionNoteEE, this.sectionNoteME, this.status);
	}

	public static emptyObj(): DsSurgeArrestorIP {
		let surArDS: MultiOptDetails_3DS = new MultiOptDetails_3DS("", "", "");
		let surArDSlist: Array<MultiOptDetails_3DS> = [];
		surArDSlist.push(surArDS);


		return new DsSurgeArrestorIP(surArDSlist, "", "", "", "", "", null);
	}

	public static getObj(_json: any): DsSurgeArrestorIP {
		let _tempSr: Array<MultiOptDetails_3DS> = [];
		for (var j = 0; j < _json.surgeArr.length; j++) {
			_tempSr.push(MultiOptDetails_3DS.getObj(_json.surgeArr[j]));
		}

		return new DsSurgeArrestorIP(_tempSr, _json.typeDesg, _json.disCurrent, _json.sectionNotePM, _json.sectionNoteEE, _json.sectionNoteME, _json.status);
	}
	public getJson(): any {
		let _json: any = {};
		_json.surgeArr = [];
		_json.typeDesg = this.typeDesg;
		_json.disCurrent = this.disCurrent;
		_json.sectionNotePM = this.sectionNotePM;
		_json.sectionNoteEE = this.sectionNoteEE;
		_json.sectionNoteME = this.sectionNoteME;
		_json.status = this.status;

		for (var j = 0; j < this._surgeArr.length; j++) {
			_json.surgeArr.push(this._surgeArr[j].getJson());
		}
		return _json;
	}
}
export class DsAnnuciatorIP {
	constructor(private _annunciatorData: Array<MultiOptDetails_5DS>, private _sectionNotePM: string, private _sectionNoteEE: string, private _sectionNoteME: string, private _status: FunctionStatus) {

	}

	private _parentSORef: SalesOrder;
	private _parentDSRef: DataSheetIP | DataSheetSubOrderIP;


	refreshStatus() {
		if (this.parentSORef) {
			if (this.parentSORef.projectStatus == SOStatus.Marketing) {
				this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
			}
			else if (this.parentSORef.projectStatus > SOStatus.Marketing) {
				let _isTempComplete: boolean = this.isFunctionComplete();

				if (_isTempComplete == true) {
					this._status = FunctionStatus.SUBMITTED_COMPLETE;
				}
				else {
					this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
				}
			}
		}
		else {
			this._status = FunctionStatus.WAITING_FOR_PREV;
		}
	}
	private isFunctionComplete(): boolean {


		return true;
	}
	get isInputEnabled(): boolean {
		return true; // No dependency on other fields/templates
	}
	get parentSORef(): SalesOrder {
		return this._parentSORef;
	}
	set parentSORef(SORef: SalesOrder) {
		this._parentSORef = SORef;
	}
	get parentDSRef(): DataSheetIP | DataSheetSubOrderIP {
		return this._parentDSRef;
	}
	set parentDSRef(DSRef: DataSheetIP | DataSheetSubOrderIP) {
		this._parentDSRef = DSRef;
	}
	get annunciatorData(): Array<MultiOptDetails_5DS> {
		return this._annunciatorData;
	}
	set annunciatorData(_SetVal: Array<MultiOptDetails_5DS>) {
		this._annunciatorData = _SetVal;
	}
	get annunciator_Enable(): boolean {
		if (this.parentDSRef.dsControlAuxIP.annunCircuit == "012") return false; // Not Applicable
		return true;
	}
	addAnnunciatorDS(_srDS: MultiOptDetails_5DS) {
		this._annunciatorData.push(_srDS);
	}
	removeAnnunciatorDS(_rmvSrDS: MultiOptDetails_5DS) {
		let index: number = this._annunciatorData.indexOf(_rmvSrDS);
		if (index >= 0) {
			this._annunciatorData.splice(index, 1);
		}
	}
	get sectionNotePM(): string {
		return this._sectionNotePM;
	}
	set sectionNotePM(_SetVal: string) {
		this._sectionNotePM = _SetVal;
	}
	get sectionNoteEE(): string {
		return this._sectionNoteEE;
	}
	set sectionNoteEE(_SetVal: string) {
		this._sectionNoteEE = _SetVal;
	}
	get sectionNoteME(): string {
		return this._sectionNoteME;
	}
	set sectionNoteME(_SetVal: string) {
		this._sectionNoteME = _SetVal;
	}
	get status(): FunctionStatus {
		return this._status;
	}

	cloneSelf(): DsAnnuciatorIP {
		let _tempAnn: MultiOptDetails_5DS[] = []
		for (var i = 0; i < this.annunciatorData.length; i++) {
			_tempAnn.push(this.annunciatorData[i].cloneSelf());
		}

		return new DsAnnuciatorIP(_tempAnn, this.sectionNotePM, this.sectionNoteEE, this.sectionNoteME, this.status);
	}

	public static emptyObj(): DsAnnuciatorIP {
		let annDS: MultiOptDetails_5DS = new MultiOptDetails_5DS("", "", "", "", "");
		let annDSlist: Array<MultiOptDetails_5DS> = [];
		annDSlist.push(annDS);


		return new DsAnnuciatorIP(annDSlist, "", "", "", null);
	}

	public static getObj(_json: any): DsAnnuciatorIP {
		let _tempAnn: Array<MultiOptDetails_5DS> = [];
		for (var j = 0; j < _json.annunciatorData.length; j++) {
			_tempAnn.push(MultiOptDetails_5DS.getObj(_json.annunciatorData[j]));
		}

		return new DsAnnuciatorIP(_tempAnn, _json.sectionNotePM, _json.sectionNoteEE, _json.sectionNoteME, _json.status);
	}
	public getJson(): any {
		let _json: any = {};
		_json.annunciatorData = [];
		_json.sectionNotePM = this.sectionNotePM;
		_json.sectionNoteEE = this.sectionNoteEE;
		_json.sectionNoteME = this.sectionNoteME;
		_json.status = this.status;

		for (var j = 0; j < this._annunciatorData.length; j++) {
			_json.annunciatorData.push(this._annunciatorData[j].getJson());
		}
		return _json;
	}
}
export class DsSwitchesIP {
	constructor(private _breakerTNC: string, private _breakerTNCDetail: string, private _breakrTNCLock: string, private _breakrTNCLmd: string, private _remoteLocalSwLock: string,
		private _remoteLocalSwHandle: string, private _ammSelSwitch: string, private _voltSelSwitch: string,
		private _autoIndepManual: string, private _tripSelSwitch: string, private _sectionNotePM: string, private _sectionNoteEE: string, private _sectionNoteME: string, private _status: FunctionStatus) {

	}

	private _parentSORef: SalesOrder;
	private _parentDSRef: DataSheetIP | DataSheetSubOrderIP;


	refreshStatus() {
		if (this.parentSORef) {
			if (this.parentSORef.projectStatus == SOStatus.Marketing) {
				this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
			}
			else if (this.parentSORef.projectStatus > SOStatus.Marketing) {
				let _isTempComplete: boolean = this.isFunctionComplete();

				if (_isTempComplete == true) {
					this._status = FunctionStatus.SUBMITTED_COMPLETE;
				}
				else {
					this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
				}
			}
		}
		else {
			this._status = FunctionStatus.WAITING_FOR_PREV;
		}
	}
	private isFunctionComplete(): boolean {

		if (configDefs.isStrEmty(this.breakerTNC)) return false;

		return true;
	}
	get isInputEnabled(): boolean {
		return true; // No dependency on other fields/templates
	}
	get parentSORef(): SalesOrder {
		return this._parentSORef;
	}
	set parentSORef(SORef: SalesOrder) {
		this._parentSORef = SORef;
	}
	get parentDSRef(): DataSheetIP | DataSheetSubOrderIP {
		return this._parentDSRef;
	}
	set parentDSRef(DSRef: DataSheetIP | DataSheetSubOrderIP) {
		this._parentDSRef = DSRef;
	}
	get breakerTNC(): string {
		return this._breakerTNC;
	}
	set breakerTNC(_SetVal: string) {
		this._breakerTNC = _SetVal;
	}
	// get breakerTNC_Enable(): boolean {
	// 	if (this.breakerTNC == "001") return true; // Applicable
	// 	return false
	// }
	get isBreakerTNCSpecReqAppli(): boolean {
		if (this.breakerTNC == "002") return true; // Applicable on Sprecial Req
		return false
	}
	get breakerTNCDetail(): string {
		if (this.isBreakerTNCSpecReqAppli == true) {
			return this._breakerTNCDetail;
		}
		else return this._breakerTNCDetail = "";
	}
	set breakerTNCDetail(_SetVal: string) {
		if (this.isBreakerTNCSpecReqAppli == true) {
			this._breakerTNCDetail = _SetVal;
		}
	}
	get breakrTNCLock(): string {
		return this._breakrTNCLock;
	}
	set breakrTNCLock(_SetVal: string) {
		this._breakrTNCLock = _SetVal;
	}
	get breakrTNCLmd(): string {
		return this._breakrTNCLmd;
	}
	set breakrTNCLmd(_SetVal: string) {
		this._breakrTNCLmd = _SetVal;
	}
	get remoteLocalSwLock(): string {
		return this._remoteLocalSwLock;
	}
	set remoteLocalSwLock(_SetVal: string) {
		this._remoteLocalSwLock = _SetVal;
	}
	get remoteLocalSwHandle(): string {
		return this._remoteLocalSwHandle;
	}
	set remoteLocalSwHandle(_SetVal: string) {
		this._remoteLocalSwHandle = _SetVal;
	}
	get ammSelSwitch(): string {
		return this._ammSelSwitch;
	}
	set ammSelSwitch(_SetVal: string) {
		this._ammSelSwitch = _SetVal;
	}
	get voltSelSwitch(): string {
		return this._voltSelSwitch;
	}
	set voltSelSwitch(_SetVal: string) {
		this._voltSelSwitch = _SetVal;
	}
	get autoIndepManual(): string {
		return this._autoIndepManual;
	}
	set autoIndepManual(_SetVal: string) {
		this._autoIndepManual = _SetVal;
	}
	get tripSelSwitch(): string {
		return this._tripSelSwitch;
	}
	set tripSelSwitch(_SetVal: string) {
		this._tripSelSwitch = _SetVal;
	}
	get sectionNotePM(): string {
		return this._sectionNotePM;
	}
	set sectionNotePM(_SetVal: string) {
		this._sectionNotePM = _SetVal;
	}
	get sectionNoteEE(): string {
		return this._sectionNoteEE;
	}
	set sectionNoteEE(_SetVal: string) {
		this._sectionNoteEE = _SetVal;
	}
	get sectionNoteME(): string {
		return this._sectionNoteME;
	}
	set sectionNoteME(_SetVal: string) {
		this._sectionNoteME = _SetVal;
	}
	get status(): FunctionStatus {
		return this._status;
	}

	cloneSelf(): DsSwitchesIP {
		return new DsSwitchesIP(this.breakerTNC, this.breakerTNCDetail, this.breakrTNCLock, this.breakrTNCLmd, this.remoteLocalSwLock,
			this.remoteLocalSwHandle, this.ammSelSwitch, this.voltSelSwitch, this.autoIndepManual, this.tripSelSwitch,
			this.sectionNotePM, this.sectionNoteEE, this.sectionNoteME, this.status);
	}

	public static emptyObj(): DsSwitchesIP {
		return new DsSwitchesIP("", "", "", "", "", "", "", "", "", "", "", "", "", null);
	}

	public static getObj(_json: any): DsSwitchesIP {

		return new DsSwitchesIP(_json.breakerTNC, _json.breakerTNCDetail, _json.breakrTNCLock, _json.breakrTNCLmd, _json.remoteLocalSwLock,
			_json.remoteLocalSwHandle, _json.ammSelSwitch, _json.voltSelSwitch, _json.autoIndepManual, _json.tripSelSwitch,
			_json.sectionNotePM, _json.sectionNoteEE, _json.sectionNoteME, _json.status);
	}
	public getJson(): any {
		let _json: any = {};
		_json.breakerTNC = this.breakerTNC;
		_json.breakerTNCDetail = this.breakerTNCDetail;
		_json.breakrTNCLock = this.breakrTNCLock;
		_json.breakrTNCLmd = this.breakrTNCLmd;
		_json.remoteLocalSwLock = this.remoteLocalSwLock;
		_json.remoteLocalSwHandle = this.remoteLocalSwHandle;
		_json.ammSelSwitch = this.ammSelSwitch;
		_json.voltSelSwitch = this.voltSelSwitch;
		_json.autoIndepManual = this.autoIndepManual;
		_json.tripSelSwitch = this.tripSelSwitch;
		_json.sectionNotePM = this.sectionNotePM;
		_json.sectionNoteEE = this.sectionNoteEE;
		_json.sectionNoteME = this.sectionNoteME;
		_json.status = this.status;

		return _json;
	}
}
export class DsEthernetSwitchesIP {
	constructor(private _ethSwitches: string, private _ethSwMake: string, private _ethSwCommArch: string, private _ethSwConfPopup: string, private _ethSwCommArchDetails: string, private _ethSwRemComm: string,
		private _ethSwAuxSupply: string, private _ethSwPwrSupply1: string, private _ethSwPwrSupply2: string,
		private _ethSwCoating: string, private _ethSwMounting: string, private _sectionNotePM: string, private _sectionNoteEE: string, private _sectionNoteME: string, private _status: FunctionStatus) {

	}

	private _parentSORef: SalesOrder;
	private _parentDSRef: DataSheetIP | DataSheetSubOrderIP;


	refreshStatus() {
		if (this.parentSORef) {
			if (this.parentSORef.projectStatus == SOStatus.Marketing) {
				this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
			}
			else if (this.parentSORef.projectStatus > SOStatus.Marketing) {
				let _isTempComplete: boolean = this.isFunctionComplete();

				if (_isTempComplete == true) {
					this._status = FunctionStatus.SUBMITTED_COMPLETE;
				}
				else {
					this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
				}
			}
		}
		else {
			this._status = FunctionStatus.WAITING_FOR_PREV;
		}
	}
	private isFunctionComplete(): boolean {

		if (configDefs.isStrEmty(this.ethSwitches)) return false;

		return true;
	}
	get isInputEnabled(): boolean {
		return true; // No dependency on other fields/templates
	}
	get parentSORef(): SalesOrder {
		return this._parentSORef;
	}
	set parentSORef(SORef: SalesOrder) {
		this._parentSORef = SORef;
	}
	get parentDSRef(): DataSheetIP | DataSheetSubOrderIP {
		return this._parentDSRef;
	}
	set parentDSRef(DSRef: DataSheetIP | DataSheetSubOrderIP) {
		this._parentDSRef = DSRef;
	}
	get ethSwitches(): string {
		return this._ethSwitches;
	}
	set ethSwitches(_SetVal: string) {
		this._ethSwitches = _SetVal;
	}
	get ethSwitches_Enable(): boolean {
		if (this.ethSwitches == "001") return true; // Applicable
		return false
	}
	get ethSwMake(): string {
		return this._ethSwMake;
	}
	set ethSwMake(_SetVal: string) {
		this._ethSwMake = _SetVal;
	}
	get ethSwCommArch(): string {
		return this._ethSwCommArch;
	}
	set ethSwCommArch(_SetVal: string) {
		this._ethSwCommArch = _SetVal;
	}
	get ethSwConfPopup(): string {
		return this._ethSwConfPopup;
	}
	set ethSwConfPopup(_SetVal: string) {
		this._ethSwConfPopup = _SetVal;
	}

	get isEthSwitchDetailsApplicable(): boolean {
		return this.parentDSRef.dsNumericalRelayIP.relayCommPort == "001";
	}

	get ethSwCommArchDetails(): string {
		if (this.isEthSwitchDetailsApplicable) {
			return this._ethSwCommArchDetails;
		}
		return this._ethSwCommArchDetails = "";
	}
	set ethSwCommArchDetails(_SetVal: string) {
		if (this.isEthSwitchDetailsApplicable) {
			this._ethSwCommArchDetails = _SetVal;
		}
	}
	get ethSwRemComm(): string {
		return this._ethSwRemComm;
	}
	set ethSwRemComm(_SetVal: string) {
		this._ethSwRemComm = _SetVal;
	}
	get ethSwAuxSupply(): string {
		return this._ethSwAuxSupply;
	}
	set ethSwAuxSupply(_SetVal: string) {
		this._ethSwAuxSupply = _SetVal;
	}
	get ethSwPwrSupply1(): string {
		return this._ethSwPwrSupply1;
	}
	set ethSwPwrSupply1(_SetVal: string) {
		this._ethSwPwrSupply1 = _SetVal;
	}
	get isAuxSupplyDualApplicable(): boolean {
		if (this.ethSwAuxSupply == "002") return true; // Dual Supply Applicable
		return false;
	}
	get ethSwPwrSupply2(): string {
		if (this.isAuxSupplyDualApplicable) {
			return this._ethSwPwrSupply2;
		}
		return "";
	}
	set ethSwPwrSupply2(_SetVal: string) {
		if (this.isAuxSupplyDualApplicable) {
			this._ethSwPwrSupply2 = _SetVal;
		}
	}
	get ethSwCoating(): string {
		return this._ethSwCoating;
	}
	set ethSwCoating(_SetVal: string) {
		this._ethSwCoating = _SetVal;
	}
	get ethSwMounting(): string {
		return this._ethSwMounting;
	}
	set ethSwMounting(_SetVal: string) {
		this._ethSwMounting = _SetVal;
	}
	get sectionNotePM(): string {
		return this._sectionNotePM;
	}
	set sectionNotePM(_SetVal: string) {
		this._sectionNotePM = _SetVal;
	}
	get sectionNoteEE(): string {
		return this._sectionNoteEE;
	}
	set sectionNoteEE(_SetVal: string) {
		this._sectionNoteEE = _SetVal;
	}
	get sectionNoteME(): string {
		return this._sectionNoteME;
	}
	set sectionNoteME(_SetVal: string) {
		this._sectionNoteME = _SetVal;
	}
	get status(): FunctionStatus {
		return this._status;
	}

	cloneSelf(): DsEthernetSwitchesIP {
		return new DsEthernetSwitchesIP(this.ethSwitches, this.ethSwMake, this.ethSwCommArch, this.ethSwConfPopup, this.ethSwCommArchDetails, this.ethSwRemComm,
			this.ethSwAuxSupply, this.ethSwPwrSupply1, this.ethSwPwrSupply2, this.ethSwCoating, this.ethSwMounting,
			this.sectionNotePM, this.sectionNoteEE, this.sectionNoteME, this.status);
	}

	public static emptyObj(): DsEthernetSwitchesIP {
		return new DsEthernetSwitchesIP("", "", "", "", "", "", "", "", "", "", "", "", "", "", null);
	}

	public static getObj(_json: any): DsEthernetSwitchesIP {

		return new DsEthernetSwitchesIP(_json.ethSwitches, _json.ethSwMake, _json.ethSwCommArch, _json.ethSwConfPopup, _json.ethSwCommArchDetails, _json.ethSwRemComm,
			_json.ethSwAuxSupply, _json.ethSwPwrSupply1, _json.ethSwPwrSupply2, _json.ethSwCoating, _json.ethSwMounting,
			_json.sectionNotePM, _json.sectionNoteEE, _json.sectionNoteME, _json.status);
	}
	public getJson(): any {
		let _json: any = {};
		_json.ethSwitches = this.ethSwitches;
		_json.ethSwMake = this.ethSwMake;
		_json.ethSwCommArch = this.ethSwCommArch;
		_json.ethSwConfPopup = this.ethSwConfPopup;
		_json.ethSwCommArchDetails = this.ethSwCommArchDetails;
		_json.ethSwRemComm = this.ethSwRemComm;
		_json.ethSwAuxSupply = this.ethSwAuxSupply;
		_json.ethSwPwrSupply1 = this.ethSwPwrSupply1;
		_json.ethSwPwrSupply2 = this.ethSwPwrSupply2;
		_json.ethSwCoating = this.ethSwCoating;
		_json.ethSwMounting = this.ethSwMounting;
		_json.sectionNotePM = this.sectionNotePM;
		_json.sectionNoteEE = this.sectionNoteEE;
		_json.sectionNoteME = this.sectionNoteME;
		_json.status = this.status;

		return _json;
	}
}
export class DsEarthingDevicesIP {
	constructor(private _edBus: string, private _edBusDetail: string, private _edCable: string,
		private _sectionNotePM: string, private _sectionNoteEE: string, private _sectionNoteME: string, private _status: FunctionStatus) {

	}

	private _parentSORef: SalesOrder;
	private _parentDSRef: DataSheetIP | DataSheetSubOrderIP;


	refreshStatus() {
		if (this.parentSORef) {
			if (this.parentSORef.projectStatus == SOStatus.Marketing) {
				this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
			}
			else if (this.parentSORef.projectStatus > SOStatus.Marketing) {
				let _isTempComplete: boolean = this.isFunctionComplete();

				if (_isTempComplete == true) {
					this._status = FunctionStatus.SUBMITTED_COMPLETE;
				}
				else {
					this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
				}
			}
		}
		else {
			this._status = FunctionStatus.WAITING_FOR_PREV;
		}
	}
	private isFunctionComplete(): boolean {

		if (configDefs.isStrEmty(this.edBus)) return false;

		return true;
	}
	get isInputEnabled(): boolean {
		return true; // No dependency on other fields/templates
	}
	get parentSORef(): SalesOrder {
		return this._parentSORef;
	}
	set parentSORef(SORef: SalesOrder) {
		this._parentSORef = SORef;
	}
	get parentDSRef(): DataSheetIP | DataSheetSubOrderIP {
		return this._parentDSRef;
	}
	set parentDSRef(DSRef: DataSheetIP | DataSheetSubOrderIP) {
		this._parentDSRef = DSRef;
	}
	get edBus(): string {
		return this._edBus;
	}
	set edBus(_SetVal: string) {
		this._edBus = _SetVal;
	}
	get isEDBusApplicable(): boolean {
		if (this.edBus == "001") return true; // Applicable
		return false;
	}
	get edBusDetail(): string {
		return this._edBusDetail;
	}
	set edBusDetail(_SetVal: string) {
		this._edBusDetail = _SetVal;
	}
	get edCable(): string {
		return this._edCable;
	}
	set edCable(_SetVal: string) {
		this._edCable = _SetVal;
	}
	get sectionNotePM(): string {
		return this._sectionNotePM;
	}
	set sectionNotePM(_SetVal: string) {
		this._sectionNotePM = _SetVal;
	}
	get sectionNoteEE(): string {
		return this._sectionNoteEE;
	}
	set sectionNoteEE(_SetVal: string) {
		this._sectionNoteEE = _SetVal;
	}
	get sectionNoteME(): string {
		return this._sectionNoteME;
	}
	set sectionNoteME(_SetVal: string) {
		this._sectionNoteME = _SetVal;
	}
	get status(): FunctionStatus {
		return this._status;
	}

	cloneSelf(): DsEarthingDevicesIP {

		return new DsEarthingDevicesIP(this.edBus, this.edBusDetail, this.edCable, this.sectionNotePM, this.sectionNoteEE, this.sectionNoteME, this.status);
	}

	public static emptyObj(): DsEarthingDevicesIP {

		return new DsEarthingDevicesIP("", "", "", "", "", "", null);
	}

	public static getObj(_json: any): DsEarthingDevicesIP {


		return new DsEarthingDevicesIP(_json.edBus, _json.edBusDetail, _json.edCable, _json.sectionNotePM, _json.sectionNoteEE, _json.sectionNoteME, _json.status);
	}
	public getJson(): any {
		let _json: any = {};
		_json.edBus = this.edBus;
		_json.edBusDetail = this.edBusDetail;
		_json.edCable = this.edCable
		_json.sectionNotePM = this.sectionNotePM;
		_json.sectionNoteEE = this.sectionNoteEE;
		_json.sectionNoteME = this.sectionNoteME;
		_json.status = this.status;

		return _json;
	}
}
export class DsSpecialDevicesIP {
	constructor(private _sdVoltIndicator: string, private _sdMounting: string, private _sdIRWindow: string, private _sdInspecWindow: string,
		private _sdTMS: string, private _sdTMSSensorType: string, private _sdTMSComm: string, private _sdHumidityMonitoring: string, private _sdHumidityMonitoringMkPhl: string,
		private _sdTempScanner: Array<MultiOptDetails_2DS>, private _sdCurrTransducer: Array<MultiOptDetails_2DS>, private _sdVoltTransducer: Array<MultiOptDetails_2DS>,
		private _sdPowerTransducer: Array<MultiOptDetails_2DS>, private _sdMultiFuncTransducer: Array<MultiOptDetails_2DS>,
		private _sdRTB: string, private _sdTTB: string, private _sdTestPlug: string, private _sdSLT: string, private _mediaConv: string,
		private _sectionNotePM: string, private _sectionNoteEE: string, private _sectionNoteME: string, private _status: FunctionStatus) {
		if (!this._sectionNotePM) this._sectionNotePM = "Default Note: Please mention here 1 phase or 3 phase current transformer is to be offered"; // By Default
	}

	private _parentSORef: SalesOrder;
	private _parentDSRef: DataSheetIP | DataSheetSubOrderIP;


	refreshStatus() {
		if (this.parentSORef) {
			if (this.parentSORef.projectStatus == SOStatus.Marketing) {
				this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
			}
			else if (this.parentSORef.projectStatus > SOStatus.Marketing) {
				let _isTempComplete: boolean = this.isFunctionComplete();

				if (_isTempComplete == true) {
					this._status = FunctionStatus.SUBMITTED_COMPLETE;
				}
				else {
					this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
				}
			}
		}
		else {
			this._status = FunctionStatus.WAITING_FOR_PREV;
		}
	}
	private isFunctionComplete(): boolean {

		if (configDefs.isStrEmty(this.sdVoltIndicator)) return false;

		return true;
	}
	get isInputEnabled(): boolean {
		return true; // No dependency on other fields/templates
	}
	get parentSORef(): SalesOrder {
		return this._parentSORef;
	}
	set parentSORef(SORef: SalesOrder) {
		this._parentSORef = SORef;
	}
	get parentDSRef(): DataSheetIP | DataSheetSubOrderIP {
		return this._parentDSRef;
	}
	set parentDSRef(DSRef: DataSheetIP | DataSheetSubOrderIP) {
		this._parentDSRef = DSRef;
	}
	get sdVoltIndicator(): string {
		return this._sdVoltIndicator;
	}
	set sdVoltIndicator(_SetVal: string) {
		this._sdVoltIndicator = _SetVal;
	}
	get isSdVoltIndicatorApplicable(): boolean {
		if (this.sdVoltIndicator == "003") return false; // Not Applicable
		return true;
	}
	get sdMounting(): string {
		return this._sdMounting;
	}
	set sdMounting(_SetVal: string) {
		this._sdMounting = _SetVal;
	}
	get sdIRWindow(): string {
		return this._sdIRWindow;
	}
	set sdIRWindow(_SetVal: string) {
		this._sdIRWindow = _SetVal;
	}
	get sdInspecWindow(): string {
		return this._sdInspecWindow;
	}
	set sdInspecWindow(_SetVal: string) {
		this._sdInspecWindow = _SetVal;
	}
	get sdTMS(): string {
		return this._sdTMS;
	}
	set sdTMS(_SetVal: string) {
		this._sdTMS = _SetVal;
	}
	get isSdTMSApplicable(): boolean {
		if (this.sdTMS == "009") return false; // Not Applicable
		return true;
	}
	get sdTMSSensorType(): string {
		return this._sdTMSSensorType;
	}
	set sdTMSSensorType(_SetVal: string) {
		this._sdTMSSensorType = _SetVal;
	}
	get sdTMSComm(): string {
		return this._sdTMSComm;
	}
	set sdTMSComm(_SetVal: string) {
		this._sdTMSComm = _SetVal;
	}
	get sdHumidityMonitoring(): string {
		return this._sdHumidityMonitoring;
	}
	set sdHumidityMonitoring(_SetVal: string) {
		this._sdHumidityMonitoring = _SetVal;
	}
	get isSdHumidityMonitoringMkPhlApplicable(): boolean {
		if (this.sdHumidityMonitoring == "001") return true; // Make/Phl Applicable
		return false;
	}
	get sdHumidityMonitoringMkPhl(): string {
		if (this.isSdHumidityMonitoringMkPhlApplicable) {
			return this._sdHumidityMonitoringMkPhl;
		}
		return "";
	}
	set sdHumidityMonitoringMkPhl(_SetVal: string) {
		if (this.isSdHumidityMonitoringMkPhlApplicable) {
			this._sdHumidityMonitoringMkPhl = _SetVal;
		}
	}
	get sdTempScanner(): Array<MultiOptDetails_2DS> {
		return this._sdTempScanner;
	}
	set sdTempScanner(_SetVal: Array<MultiOptDetails_2DS>) {
		this._sdTempScanner = _SetVal;
	}
	addSdTempScannerDS(_tsDS: MultiOptDetails_2DS) {
		this._sdTempScanner.push(_tsDS);
	}
	removeSdTempScannerDS(_rmvTsDS: MultiOptDetails_2DS) {
		let index: number = this._sdTempScanner.indexOf(_rmvTsDS);
		if (index >= 0) {
			this._sdTempScanner.splice(index, 1);
		}
	}
	get sdCurrTransducer(): Array<MultiOptDetails_2DS> {
		return this._sdCurrTransducer;
	}
	set sdCurrTransducer(_SetVal: Array<MultiOptDetails_2DS>) {
		this._sdCurrTransducer = _SetVal;
	}
	addSdCurrTransducerDS(_ctDS: MultiOptDetails_2DS) {
		this._sdCurrTransducer.push(_ctDS);
	}
	removeSdCurrTransducerDS(_rmvCtDS: MultiOptDetails_2DS) {
		let index: number = this._sdCurrTransducer.indexOf(_rmvCtDS);
		if (index >= 0) {
			this._sdCurrTransducer.splice(index, 1);
		}
	}
	get sdVoltTransducer(): Array<MultiOptDetails_2DS> {
		return this._sdVoltTransducer;
	}
	set sdVoltTransducer(_SetVal: Array<MultiOptDetails_2DS>) {
		this._sdVoltTransducer = _SetVal;
	}
	addSdVoltTransducerDS(_vtDS: MultiOptDetails_2DS) {
		this._sdVoltTransducer.push(_vtDS);
	}
	removeSdVoltTransducerDS(_rmvVtDS: MultiOptDetails_2DS) {
		let index: number = this._sdVoltTransducer.indexOf(_rmvVtDS);
		if (index >= 0) {
			this._sdVoltTransducer.splice(index, 1);
		}
	}
	get sdPowerTransducer(): Array<MultiOptDetails_2DS> {
		return this._sdPowerTransducer;
	}
	set sdPowerTransducer(_SetVal: Array<MultiOptDetails_2DS>) {
		this._sdPowerTransducer = _SetVal;
	}
	addSdPowerTransducerDS(_ptDS: MultiOptDetails_2DS) {
		this._sdPowerTransducer.push(_ptDS);
	}
	removeSdPowerTransducerDS(_rmvPtDS: MultiOptDetails_2DS) {
		let index: number = this._sdPowerTransducer.indexOf(_rmvPtDS);
		if (index >= 0) {
			this._sdPowerTransducer.splice(index, 1);
		}
	}
	get sdMultiFuncTransducer(): Array<MultiOptDetails_2DS> {
		return this._sdMultiFuncTransducer;
	}
	set sdMultiFuncTransducer(_SetVal: Array<MultiOptDetails_2DS>) {
		this._sdMultiFuncTransducer = _SetVal;
	}
	addSdMultiFuncTransducerDS(_mftDS: MultiOptDetails_2DS) {
		this._sdMultiFuncTransducer.push(_mftDS);
	}
	removeSdMultiFuncTransducerDS(_rmvMftDS: MultiOptDetails_2DS) {
		let index: number = this._sdMultiFuncTransducer.indexOf(_rmvMftDS);
		if (index >= 0) {
			this._sdMultiFuncTransducer.splice(index, 1);
		}
	}
	get sdRTB(): string {
		return this._sdRTB;
	}
	set sdRTB(_SetVal: string) {
		this._sdRTB = _SetVal;
	}
	get sdTTB(): string {
		return this._sdTTB;
	}
	set sdTTB(_SetVal: string) {
		this._sdTTB = _SetVal;
	}
	get sdTestPlug(): string {
		return this._sdTestPlug;
	}
	set sdTestPlug(_SetVal: string) {
		this._sdTestPlug = _SetVal;
	}
	get sdSLT(): string {
		return this._sdSLT;
	}
	set sdSLT(_SetVal: string) {
		this._sdSLT = _SetVal;
	}
	get mediaConv(): string {
		return this._mediaConv;
	}
	set mediaConv(_SetVal: string) {
		this._mediaConv = _SetVal;
	}
	get sectionNotePM(): string {
		return this._sectionNotePM;
	}
	set sectionNotePM(_SetVal: string) {
		this._sectionNotePM = _SetVal;
	}
	get sectionNoteEE(): string {
		return this._sectionNoteEE;
	}
	set sectionNoteEE(_SetVal: string) {
		this._sectionNoteEE = _SetVal;
	}
	get sectionNoteME(): string {
		return this._sectionNoteME;
	}
	set sectionNoteME(_SetVal: string) {
		this._sectionNoteME = _SetVal;
	}
	get status(): FunctionStatus {
		return this._status;
	}

	cloneSelf(): DsSpecialDevicesIP {
		let _tempts: MultiOptDetails_2DS[] = []
		for (var i = 0; i < this._sdTempScanner.length; i++) {
			_tempts.push(this._sdTempScanner[i].cloneSelf());
		}
		let _tempct: MultiOptDetails_2DS[] = []
		for (var i = 0; i < this._sdCurrTransducer.length; i++) {
			_tempct.push(this._sdCurrTransducer[i].cloneSelf());
		}
		let _tempvt: MultiOptDetails_2DS[] = []
		for (var i = 0; i < this._sdVoltTransducer.length; i++) {
			_tempvt.push(this._sdVoltTransducer[i].cloneSelf());
		}
		let _temppt: MultiOptDetails_2DS[] = []
		for (var i = 0; i < this._sdPowerTransducer.length; i++) {
			_temppt.push(this._sdPowerTransducer[i].cloneSelf());
		}
		let _tempmft: MultiOptDetails_2DS[] = []
		for (var i = 0; i < this._sdMultiFuncTransducer.length; i++) {
			_tempmft.push(this._sdMultiFuncTransducer[i].cloneSelf());
		}
		return new DsSpecialDevicesIP(this.sdVoltIndicator, this.sdMounting, this.sdIRWindow, this.sdInspecWindow, this.sdTMS,
			this.sdTMSSensorType, this.sdTMSComm, this.sdHumidityMonitoring, this.sdHumidityMonitoringMkPhl, _tempts, _tempct, _tempvt, _temppt, _tempmft,
			this.sdRTB, this.sdTTB, this.sdTestPlug, this.sdSLT, this.mediaConv, this.sectionNotePM, this.sectionNoteEE, this.sectionNoteME, this.status);
	}

	public static emptyObj(): DsSpecialDevicesIP {
		let sdTempScannerDS: MultiOptDetails_2DS = new MultiOptDetails_2DS("", "");
		let sdTempScannerDSlist: Array<MultiOptDetails_2DS> = [];
		sdTempScannerDSlist.push(sdTempScannerDS);

		let sdCurrTransducerDS: MultiOptDetails_2DS = new MultiOptDetails_2DS("", "");
		let sdCurrTransducerDSlist: Array<MultiOptDetails_2DS> = [];
		sdCurrTransducerDSlist.push(sdCurrTransducerDS);

		let sdVoltTransducerDS: MultiOptDetails_2DS = new MultiOptDetails_2DS("", "");
		let sdVoltTransducerDSlist: Array<MultiOptDetails_2DS> = [];
		sdVoltTransducerDSlist.push(sdVoltTransducerDS);

		let sdPowerTransducerDS: MultiOptDetails_2DS = new MultiOptDetails_2DS("", "");
		let sdPowerTransducerDSlist: Array<MultiOptDetails_2DS> = [];
		sdPowerTransducerDSlist.push(sdPowerTransducerDS);

		let sdMultiFuncTransducerDS: MultiOptDetails_2DS = new MultiOptDetails_2DS("", "");
		let sdMultiFuncTransducerDSlist: Array<MultiOptDetails_2DS> = [];
		sdMultiFuncTransducerDSlist.push(sdMultiFuncTransducerDS);

		return new DsSpecialDevicesIP("", "", "", "", "", "", "", "", "", sdTempScannerDSlist, sdCurrTransducerDSlist, sdVoltTransducerDSlist,
			sdPowerTransducerDSlist, sdMultiFuncTransducerDSlist, "", "", "", "", "", "", "", "", null);
	}

	public static getObj(_json: any): DsSpecialDevicesIP {

		let _tempts: Array<MultiOptDetails_2DS> = [];
		for (var j = 0; j < _json.sdTempScanner.length; j++) {
			_tempts.push(MultiOptDetails_2DS.getObj(_json.sdTempScanner[j]));
		}

		let _tempcurr: Array<MultiOptDetails_2DS> = [];
		for (var j = 0; j < _json.sdCurrTransducer.length; j++) {
			_tempcurr.push(MultiOptDetails_2DS.getObj(_json.sdCurrTransducer[j]));
		}

		let _tempvolt: Array<MultiOptDetails_2DS> = [];
		for (var j = 0; j < _json.sdVoltTransducer.length; j++) {
			_tempvolt.push(MultiOptDetails_2DS.getObj(_json.sdVoltTransducer[j]));
		}

		let _temppower: Array<MultiOptDetails_2DS> = [];
		for (var j = 0; j < _json.sdPowerTransducer.length; j++) {
			_temppower.push(MultiOptDetails_2DS.getObj(_json.sdPowerTransducer[j]));
		}

		let _tempmulti: Array<MultiOptDetails_2DS> = [];
		for (var j = 0; j < _json.sdMultiFuncTransducer.length; j++) {
			_tempmulti.push(MultiOptDetails_2DS.getObj(_json.sdMultiFuncTransducer[j]));
		}

		return new DsSpecialDevicesIP(_json.sdVoltIndicator, _json.sdMounting, _json.sdIRWindow, _json.sdInspecWindow, _json.sdTMS, _json.sdTMSSensorType,
			_json.sdTMSComm, _json.sdHumidityMonitoring, _json.sdHumidityMonitoringMkPhl, _tempts, _tempcurr, _tempvolt, _temppower, _tempmulti,
			_json.sdRTB, _json.sdTTB, _json.sdTestPlug, _json.sdSLT, _json.mediaConv, _json.sectionNotePM, _json.sectionNoteEE, _json.sectionNoteME, _json.status);
	}
	public getJson(): any {
		let _json: any = {};
		_json.sdVoltIndicator = this.sdVoltIndicator;
		_json.sdMounting = this.sdMounting;
		_json.sdIRWindow = this.sdIRWindow;
		_json.sdInspecWindow = this.sdInspecWindow;
		_json.sdTMS = this.sdTMS;
		_json.sdTMSSensorType = this.sdTMSSensorType;
		_json.sdTMSComm = this.sdTMSComm;
		_json.sdHumidityMonitoring = this.sdHumidityMonitoring;
		_json.sdHumidityMonitoringMkPhl = this.sdHumidityMonitoringMkPhl;
		_json.sdTempScanner = [];
		_json.sdCurrTransducer = [];
		_json.sdVoltTransducer = [];
		_json.sdPowerTransducer = [];
		_json.sdMultiFuncTransducer = [];
		_json.sdRTB = this.sdRTB
		_json.sdTTB = this.sdTTB;
		_json.sdTestPlug = this.sdTestPlug;
		_json.sdSLT = this.sdSLT;
		_json.mediaConv = this.mediaConv;
		_json.sectionNotePM = this.sectionNotePM;
		_json.sectionNoteEE = this.sectionNoteEE;
		_json.sectionNoteME = this.sectionNoteME;
		_json.status = this.status;

		for (var j = 0; j < this._sdTempScanner.length; j++) {
			_json.sdTempScanner.push(this._sdTempScanner[j].getJson());
		}
		for (var j = 0; j < this._sdCurrTransducer.length; j++) {
			_json.sdCurrTransducer.push(this._sdCurrTransducer[j].getJson());
		}
		for (var j = 0; j < this._sdVoltTransducer.length; j++) {
			_json.sdVoltTransducer.push(this._sdVoltTransducer[j].getJson());
		}
		for (var j = 0; j < this._sdPowerTransducer.length; j++) {
			_json.sdPowerTransducer.push(this._sdPowerTransducer[j].getJson());
		}
		for (var j = 0; j < this._sdMultiFuncTransducer.length; j++) {
			_json.sdMultiFuncTransducer.push(this._sdMultiFuncTransducer[j].getJson());
		}
		return _json;
	}
}
export class DsFoundationFrameIP {
	constructor(private _ffrISMC: string, private _ffrCoating: string,
		private _sectionNotePM: string, private _sectionNoteEE: string, private _sectionNoteME: string, private _status: FunctionStatus) {
		if (!this._ffrISMC) this._ffrISMC = "001"; // Default
	}

	private _parentSORef: SalesOrder;
	private _parentDSRef: DataSheetIP | DataSheetSubOrderIP;


	refreshStatus() {
		if (this.parentSORef) {
			if (this.parentSORef.projectStatus == SOStatus.Marketing) {
				this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
			}
			else if (this.parentSORef.projectStatus > SOStatus.Marketing) {
				let _isTempComplete: boolean = this.isFunctionComplete();

				if (_isTempComplete == true) {
					this._status = FunctionStatus.SUBMITTED_COMPLETE;
				}
				else {
					this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
				}
			}
		}
		else {
			this._status = FunctionStatus.WAITING_FOR_PREV;
		}
	}
	private isFunctionComplete(): boolean {

		if (configDefs.isStrEmty(this.ffrISMC)) return false;

		return true;
	}
	get isInputEnabled(): boolean {
		return true; // No dependency on other fields/templates
	}
	get parentSORef(): SalesOrder {
		return this._parentSORef;
	}
	set parentSORef(SORef: SalesOrder) {
		this._parentSORef = SORef;
	}
	get parentDSRef(): DataSheetIP | DataSheetSubOrderIP {
		return this._parentDSRef;
	}
	set parentDSRef(DSRef: DataSheetIP | DataSheetSubOrderIP) {
		this._parentDSRef = DSRef;
	}
	get ffrISMC(): string {
		return this._ffrISMC;
	}
	set ffrISMC(_SetVal: string) {
		this._ffrISMC = _SetVal;
	}
	get isffrCoatingApplicable(): boolean {
		if (this.ffrISMC == "001") return true; // Applicable
		return false;
	}
	get ffrCoating(): string {
		return this._ffrCoating;
	}
	set ffrCoating(_SetVal: string) {
		this._ffrCoating = _SetVal;
	}
	get sectionNotePM(): string {
		return this._sectionNotePM;
	}
	set sectionNotePM(_SetVal: string) {
		this._sectionNotePM = _SetVal;
	}
	get sectionNoteEE(): string {
		return this._sectionNoteEE;
	}
	set sectionNoteEE(_SetVal: string) {
		this._sectionNoteEE = _SetVal;
	}
	get sectionNoteME(): string {
		return this._sectionNoteME;
	}
	set sectionNoteME(_SetVal: string) {
		this._sectionNoteME = _SetVal;
	}
	get status(): FunctionStatus {
		return this._status;
	}

	cloneSelf(): DsFoundationFrameIP {

		return new DsFoundationFrameIP(this.ffrISMC, this.ffrCoating, this.sectionNotePM, this.sectionNoteEE, this.sectionNoteME, this.status);
	}

	public static emptyObj(): DsFoundationFrameIP {

		return new DsFoundationFrameIP("", "", "", "", "", null);
	}

	public static getObj(_json: any): DsFoundationFrameIP {

		return new DsFoundationFrameIP(_json.ffrISMC, _json.ffrCoating, _json.sectionNotePM, _json.sectionNoteEE, _json.sectionNoteME, _json.status);
	}
	public getJson(): any {
		let _json: any = {};
		_json.ffrISMC = this.ffrISMC;
		_json.ffrCoating = this.ffrCoating
		_json.sectionNotePM = this.sectionNotePM;
		_json.sectionNoteEE = this.sectionNoteEE;
		_json.sectionNoteME = this.sectionNoteME;
		_json.status = this.status;

		return _json;
	}
}
export class DsSwbAccessoriesQtyIP {
	constructor(private _swbPanelKey: number, private _swbBreakerRackInOut: number, private _swbEarthSwtHandle: number, private _swbBreakerServiceTrolley: number,
		private _swbRelayTest: number, private _swbPTRamp: string, private _swbSpecialReq: string, private _swbSpecialReqDetails: string,
		private _additionalPoints: Array<MultiOptDetails_4DS>,
		private _sectionNotePM: string, private _sectionNoteEE: string, private _sectionNoteME: string, private _status: FunctionStatus) {
	}

	private _parentSORef: SalesOrder;
	private _parentDSRef: DataSheetIP | DataSheetSubOrderIP;


	refreshStatus() {
		if (this.parentSORef) {
			if (this.parentSORef.projectStatus == SOStatus.Marketing) {
				this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
			}
			else if (this.parentSORef.projectStatus > SOStatus.Marketing) {
				let _isTempComplete: boolean = this.isFunctionComplete();

				if (_isTempComplete == true) {
					this._status = FunctionStatus.SUBMITTED_COMPLETE;
				}
				else {
					this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
				}
			}
		}
		else {
			this._status = FunctionStatus.WAITING_FOR_PREV;
		}
	}
	private isFunctionComplete(): boolean {

		if (configDefs.isNumEmty(this.swbPanelKey)) return false;

		return true;
	}
	get isInputEnabled(): boolean {
		return true; // No dependency on other fields/templates
	}
	get parentSORef(): SalesOrder {
		return this._parentSORef;
	}
	set parentSORef(SORef: SalesOrder) {
		this._parentSORef = SORef;
	}
	get parentDSRef(): DataSheetIP | DataSheetSubOrderIP {
		return this._parentDSRef;
	}
	set parentDSRef(DSRef: DataSheetIP | DataSheetSubOrderIP) {
		this._parentDSRef = DSRef;
	}
	get swbPanelKey(): number {
		return this._swbPanelKey;
	}
	set swbPanelKey(_SetVal: number) {
		this._swbPanelKey = _SetVal;
	}
	get swbBreakerRackInOut(): number {
		return this._swbBreakerRackInOut;
	}
	set swbBreakerRackInOut(_SetVal: number) {
		this._swbBreakerRackInOut = _SetVal;
	}
	get isEarthSwtHandleApplicable(): boolean {
		if (this.parentDSRef.dsEarthingDevicesIP.edBusDetail == "003" || this.parentDSRef.dsEarthingDevicesIP.edCable == "003") return true; // Contains Earthing Switch
		return false;
	}
	get swbEarthSwtHandle(): number {
		if (this.isEarthSwtHandleApplicable) {
			return this._swbEarthSwtHandle;
		}
		else {
			return this._swbEarthSwtHandle = null; // Not Applicable
		}
	}
	set swbEarthSwtHandle(_SetVal: number) {
		if (this.isEarthSwtHandleApplicable) {
			this._swbEarthSwtHandle = _SetVal;
		}
	}
	get isBreakerServiceTrolleyApplicable(): boolean {
		if (this.parentDSRef.dsPanelIP.vcbType == "002") return true; // Applicable
		return false;
	}
	get swbBreakerServiceTrolley(): number {
		return this._swbBreakerServiceTrolley;
	}
	set swbBreakerServiceTrolley(_SetVal: number) {
		this._swbBreakerServiceTrolley = _SetVal;
	}
	get isRelayTestApplicable(): boolean {
		if (this.parentDSRef.dsSpecialDevicesIP.sdRTB == "001") return true; // Applicable
		return false;
	}
	get swbRelayTest(): number {
		return this._swbRelayTest;
	}
	set swbRelayTest(_SetVal: number) {
		this._swbRelayTest = _SetVal;
	}
	get swbPTRamp(): string {
		return this._swbPTRamp;
	}
	set swbPTRamp(_SetVal: string) {
		this._swbPTRamp = _SetVal;
	}
	get swbSpecialReq(): string {
		return this._swbSpecialReq;
	}
	set swbSpecialReq(_SetVal: string) {
		this._swbSpecialReq = _SetVal;
	}
	get swbSpecialReqDetails(): string {
		return this._swbSpecialReqDetails;
	}
	set swbSpecialReqDetails(_SetVal: string) {
		this._swbSpecialReqDetails = _SetVal;
	}
	get additionalPoints(): Array<MultiOptDetails_4DS> {
		return this._additionalPoints;
	}
	set additionalPoints(_SetVal: Array<MultiOptDetails_4DS>) {
		this._additionalPoints = _SetVal;
	}
	addPointsDS(_apDS: MultiOptDetails_4DS) {

		this._additionalPoints.push(_apDS);
	}
	removePointsDS(_rmvApDS: MultiOptDetails_4DS) {
		let index: number = this._additionalPoints.indexOf(_rmvApDS);
		if (index >= 0) {
			this._additionalPoints.splice(index, 1);
		}
	}
	get sectionNotePM(): string {
		return this._sectionNotePM;
	}
	set sectionNotePM(_SetVal: string) {
		this._sectionNotePM = _SetVal;
	}
	get sectionNoteEE(): string {
		return this._sectionNoteEE;
	}
	set sectionNoteEE(_SetVal: string) {
		this._sectionNoteEE = _SetVal;
	}
	get sectionNoteME(): string {
		return this._sectionNoteME;
	}
	set sectionNoteME(_SetVal: string) {
		this._sectionNoteME = _SetVal;
	}
	get status(): FunctionStatus {
		return this._status;
	}

	cloneSelf(): DsSwbAccessoriesQtyIP {

		let _tempAdditionalPoints: MultiOptDetails_4DS[] = []
		for (var i = 0; i < this.additionalPoints.length; i++) {
			_tempAdditionalPoints.push(this.additionalPoints[i].cloneSelf());
		}
		return new DsSwbAccessoriesQtyIP(this.swbPanelKey, this.swbBreakerRackInOut, this.swbEarthSwtHandle, this.swbBreakerServiceTrolley,
			this.swbRelayTest, this.swbPTRamp, this.swbSpecialReq, this.swbSpecialReqDetails, _tempAdditionalPoints,
			this.sectionNotePM, this.sectionNoteEE, this.sectionNoteME, this.status);
	}

	public static emptyObj(): DsSwbAccessoriesQtyIP {
		let additionalPointsDS: MultiOptDetails_4DS = new MultiOptDetails_4DS("", "", "", "");
		let additionalPointsDSlist: Array<MultiOptDetails_4DS> = [];
		additionalPointsDSlist.push(additionalPointsDS);

		return new DsSwbAccessoriesQtyIP(null, null, null, null, null, null, "", "", additionalPointsDSlist, "", "", "", null);
	}

	public static getObj(_json: any): DsSwbAccessoriesQtyIP {
		let _tempAdditionalPoints: Array<MultiOptDetails_4DS> = [];
		if (_json.additionalPoints) {
			for (var j = 0; j < _json.additionalPoints.length; j++) {
				_tempAdditionalPoints.push(MultiOptDetails_4DS.getObj(_json.additionalPoints[j]));
			}
		}
		else {
			_tempAdditionalPoints.push(new MultiOptDetails_4DS("", "", "", ""));
		}


		return new DsSwbAccessoriesQtyIP(_json.swbPanelKey, _json.swbBreakerRackInOut, _json.swbEarthSwtHandle, _json.swbBreakerServiceTrolley,
			_json.swbRelayTest, _json.swbPTRamp, _json.swbSpecialReq, _json.swbSpecialReqDetails, _tempAdditionalPoints,
			_json.sectionNotePM, _json.sectionNoteEE, _json.sectionNoteME, _json.status);
	}
	public getJson(): any {
		let _json: any = {};
		_json.swbPanelKey = this.swbPanelKey;
		_json.swbBreakerRackInOut = this.swbBreakerRackInOut;
		_json.swbEarthSwtHandle = this.swbEarthSwtHandle;
		_json.swbBreakerServiceTrolley = this.swbBreakerServiceTrolley;
		_json.swbRelayTest = this.swbRelayTest;
		_json.swbPTRamp = this.swbPTRamp;
		_json.swbSpecialReq = this.swbSpecialReq;
		_json.swbSpecialReqDetails = this.swbSpecialReqDetails;
		_json.additionalPoints = [];
		_json.sectionNotePM = this.sectionNotePM;
		_json.sectionNoteEE = this.sectionNoteEE;
		_json.sectionNoteME = this.sectionNoteME;
		_json.status = this.status;

		for (var j = 0; j < this._additionalPoints.length; j++) {
			_json.additionalPoints.push(this._additionalPoints[j].getJson());
		}

		return _json;
	}
}
export class DataSheetSubOrderIP {

	constructor(private _dataSheetId: string, private _dataSheetType: string, private _dsGeneralIP: DsGeneralIP, private _dsPanelIP: DsPanelIP, private _dsBusbarsIP: DsBusbarsIP,
		private _dsPaintingIP: DsPaintingIP, private _dsControlAuxIP: DsControlAuxIP, private _dsControlWiringIP: DsControlWiringIP, private _dsTerminalBlocksIP: DsTerminalBlocksIP,
		private _dsCircuitBreakerIP: DsCircuitBreakerIP, private _dsCurrentTrafoIP: DsCurrentTrafoIP, private _dsPotentialTrafoIP: DsPotentialTrafoIP, private _dsNumericalRelayIP: DsNumericalRelayIP,
		private _dsAuxRelayIP: DsAuxRelayIP, private _dsMetersIP: DsMetersIP, private _dsSurgeArrestorIP: DsSurgeArrestorIP, private _dsAnnuciatorIP: DsAnnuciatorIP, private _dsSwitchesIP: DsSwitchesIP,
		private _dsEthernetSwitchesIP: DsEthernetSwitchesIP, private _dsEarthingDevicesIP: DsEarthingDevicesIP, private _dsSpecialDevicesIP: DsSpecialDevicesIP,
		private _dsFoundationFrameIP: DsFoundationFrameIP, private _dsSwbAccessoriesQtyIP: DsSwbAccessoriesQtyIP,
		private _createdByName: string, private _createdByMailId: string, private _createdDate: Date, private _status: FunctionStatus) {
		this._dsGeneralIP.parentDSRef = this;
		this._dsPanelIP.parentDSRef = this;
		this._dsBusbarsIP.parentDSRef = this;
		this._dsPaintingIP.parentDSRef = this;
		this._dsControlAuxIP.parentDSRef = this;
		this._dsControlWiringIP.parentDSRef = this;
		this._dsTerminalBlocksIP.parentDSRef = this;
		this._dsCircuitBreakerIP.parentDSRef = this;
		this._dsCurrentTrafoIP.parentDSRef = this;
		this._dsPotentialTrafoIP.parentDSRef = this;
		this._dsNumericalRelayIP.parentDSRef = this;
		this._dsAuxRelayIP.parentDSRef = this;
		this._dsMetersIP.parentDSRef = this;
		this._dsSurgeArrestorIP.parentDSRef = this;
		this._dsAnnuciatorIP.parentDSRef = this;
		this._dsSwitchesIP.parentDSRef = this;
		this._dsEthernetSwitchesIP.parentDSRef = this;
		this._dsEarthingDevicesIP.parentDSRef = this;
		this._dsSpecialDevicesIP.parentDSRef = this;
		this._dsFoundationFrameIP.parentDSRef = this;
		this._dsSwbAccessoriesQtyIP.parentDSRef = this;
	}

	private _parentSORef: SalesOrder;
	private _parentSubSORef: SubSalesOrder;
	private _versions: Array<any> = [];
	private _currentVersion: string = 'Rev-0';

	get parentSORef(): SalesOrder {
		return this._parentSORef;
	}
	set parentSORef(SORef: SalesOrder) {
		this._parentSORef = SORef;
		this._dsGeneralIP.parentSORef = SORef;
		this._dsPanelIP.parentSORef = SORef;
		this._dsBusbarsIP.parentSORef = SORef;
		this._dsPaintingIP.parentSORef = SORef;
		this._dsControlAuxIP.parentSORef = SORef;
		this._dsControlWiringIP.parentSORef = SORef;
		this._dsTerminalBlocksIP.parentSORef = SORef;
		this._dsCircuitBreakerIP.parentSORef = SORef;
		this._dsCurrentTrafoIP.parentSORef = SORef;
		this._dsPotentialTrafoIP.parentSORef = SORef;
		this._dsNumericalRelayIP.parentSORef = SORef;
		this._dsAuxRelayIP.parentSORef = SORef;
		this._dsMetersIP.parentSORef = SORef;
		this._dsSurgeArrestorIP.parentSORef = SORef;
		this._dsAnnuciatorIP.parentSORef = SORef;
		this._dsSwitchesIP.parentSORef = SORef;
		this._dsEthernetSwitchesIP.parentSORef = SORef;
		this._dsEarthingDevicesIP.parentSORef = SORef;
		this._dsSpecialDevicesIP.parentSORef = SORef;
		this._dsFoundationFrameIP.parentSORef = SORef;
		this._dsSwbAccessoriesQtyIP.parentSORef = SORef;
	}
	get parentSubSORef(): SubSalesOrder {
		return this._parentSubSORef;
	}
	set parentSubSORef(SubSORef: SubSalesOrder) {
		this._parentSubSORef = SubSORef;
	}
	get versions(): Array<any> {
		return this._versions;
	}
	set versions(_SetVal: Array<any>) {
		this._versions = _SetVal;
	}
	get currentVersion(): string {
		return this._currentVersion;
	}
	set currentVersion(_SetVal: string) {
		this._currentVersion = _SetVal;
	}
	get isInputEnabled(): boolean {
		return true; // No dependency on other fields/templates
	}
	get isDatasheetEditable(): boolean {
		if (this.parentSubSORef.isSSOStatusSet(SSOStatus.Dispatched)) {
			return false;
		}
		else return true;
	}
	public refreshStatus() {
		this._dsGeneralIP.refreshStatus();
		this._dsPanelIP.refreshStatus();
		this._dsBusbarsIP.refreshStatus();
		this._dsPaintingIP.refreshStatus();
		this._dsControlAuxIP.refreshStatus();
		this._dsControlWiringIP.refreshStatus();
		this._dsTerminalBlocksIP.refreshStatus();
		this._dsCircuitBreakerIP.refreshStatus();
		this._dsCurrentTrafoIP.refreshStatus();
		this._dsPotentialTrafoIP.refreshStatus();
		this._dsNumericalRelayIP.refreshStatus();
		this._dsAuxRelayIP.refreshStatus();
		this._dsMetersIP.refreshStatus();
		this._dsSurgeArrestorIP.refreshStatus();
		this._dsAnnuciatorIP.refreshStatus();
		this._dsSwitchesIP.refreshStatus();
		this._dsEthernetSwitchesIP.refreshStatus();
		this._dsEarthingDevicesIP.refreshStatus();
		this._dsSpecialDevicesIP.refreshStatus();
		this._dsFoundationFrameIP.refreshStatus();
		this._dsSwbAccessoriesQtyIP.refreshStatus();
	}
	get status(): FunctionStatus {
		return this._status;
	}
	get dataSheetId(): string {
		return this._dataSheetId;
	}
	set dataSheetId(_SetVal: string) {
		this._dataSheetId = _SetVal;
	}
	get dataSheetType(): string {
		return this._dataSheetType;
	}
	set dataSheetType(_SetVal: string) {
		this._dataSheetType = _SetVal;
	}
	get dsGeneralIP(): DsGeneralIP {
		return this._dsGeneralIP;
	}
	set dsGeneralIP(_SetVal: DsGeneralIP) {
		this._dsGeneralIP = _SetVal;
	}
	get dsPanelIP(): DsPanelIP {
		return this._dsPanelIP;
	}
	set dsPanelIP(_SetVal: DsPanelIP) {
		this._dsPanelIP = _SetVal;
	}
	get dsBusbarsIP(): DsBusbarsIP {
		return this._dsBusbarsIP;
	}
	set dsBusbarsIP(_SetVal: DsBusbarsIP) {
		this._dsBusbarsIP = _SetVal;
	}
	get dsPaintingIP(): DsPaintingIP {
		return this._dsPaintingIP;
	}
	set dsPaintingIP(_SetVal: DsPaintingIP) {
		this._dsPaintingIP = _SetVal;
	}
	get dsControlAuxIP(): DsControlAuxIP {
		return this._dsControlAuxIP;
	}
	set dsControlAuxIP(_SetVal: DsControlAuxIP) {
		this._dsControlAuxIP = _SetVal;
	}
	get dsControlWiringIP(): DsControlWiringIP {
		return this._dsControlWiringIP;
	}
	set dsControlWiringIP(_SetVal: DsControlWiringIP) {
		this._dsControlWiringIP = _SetVal;
	}
	get dsTerminalBlocksIP(): DsTerminalBlocksIP {
		return this._dsTerminalBlocksIP;
	}
	set dsTerminalBlocksIP(_SetVal: DsTerminalBlocksIP) {
		this._dsTerminalBlocksIP = _SetVal;
	}
	get dsCircuitBreakerIP(): DsCircuitBreakerIP {
		return this._dsCircuitBreakerIP;
	}
	set dsCircuitBreakerIP(_SetVal: DsCircuitBreakerIP) {
		this._dsCircuitBreakerIP = _SetVal;
	}
	get dsCurrentTrafoIP(): DsCurrentTrafoIP {
		return this._dsCurrentTrafoIP;
	}
	set dsCurrentTrafoIP(_SetVal: DsCurrentTrafoIP) {
		this._dsCurrentTrafoIP = _SetVal;
	}
	get dsPotentialTrafoIP(): DsPotentialTrafoIP {
		return this._dsPotentialTrafoIP;
	}
	set dsPotentialTrafoIP(_SetVal: DsPotentialTrafoIP) {
		this._dsPotentialTrafoIP = _SetVal;
	}
	get dsNumericalRelayIP(): DsNumericalRelayIP {
		return this._dsNumericalRelayIP;
	}
	set dsNumericalRelayIP(_SetVal: DsNumericalRelayIP) {
		this._dsNumericalRelayIP = _SetVal;
	}
	get dsAuxRelayIP(): DsAuxRelayIP {
		return this._dsAuxRelayIP;
	}
	set dsAuxRelayIP(_SetVal: DsAuxRelayIP) {
		this._dsAuxRelayIP = _SetVal;
	}
	get dsMetersIP(): DsMetersIP {
		return this._dsMetersIP;
	}
	set dsMetersIP(_SetVal: DsMetersIP) {
		this._dsMetersIP = _SetVal;
	}
	get dsSurgeArrestorIP(): DsSurgeArrestorIP {
		return this._dsSurgeArrestorIP;
	}
	set dsSurgeArrestorIP(_SetVal: DsSurgeArrestorIP) {
		this._dsSurgeArrestorIP = _SetVal;
	}
	get dsAnnuciatorIP(): DsAnnuciatorIP {
		return this._dsAnnuciatorIP;
	}
	set dsAnnuciatorIP(_SetVal: DsAnnuciatorIP) {
		this._dsAnnuciatorIP = _SetVal;
	}
	get dsSwitchesIP(): DsSwitchesIP {
		return this._dsSwitchesIP;
	}
	set dsSwitchesIP(_SetVal: DsSwitchesIP) {
		this._dsSwitchesIP = _SetVal;
	}
	get dsEthernetSwitchesIP(): DsEthernetSwitchesIP {
		return this._dsEthernetSwitchesIP;
	}
	set dsEthernetSwitchesIP(_SetVal: DsEthernetSwitchesIP) {
		this._dsEthernetSwitchesIP = _SetVal;
	}
	get dsEarthingDevicesIP(): DsEarthingDevicesIP {
		return this._dsEarthingDevicesIP;
	}
	set dsEarthingDevicesIP(_SetVal: DsEarthingDevicesIP) {
		this._dsEarthingDevicesIP = _SetVal;
	}
	get dsSpecialDevicesIP(): DsSpecialDevicesIP {
		return this._dsSpecialDevicesIP;
	}
	set dsSpecialDevicesIP(_SetVal: DsSpecialDevicesIP) {
		this._dsSpecialDevicesIP = _SetVal;
	}
	get dsFoundationFrameIP(): DsFoundationFrameIP {
		return this._dsFoundationFrameIP;
	}
	set dsFoundationFrameIP(_SetVal: DsFoundationFrameIP) {
		this._dsFoundationFrameIP = _SetVal;
	}
	get dsSwbAccessoriesQtyIP(): DsSwbAccessoriesQtyIP {
		return this._dsSwbAccessoriesQtyIP;
	}
	set dsSwbAccessoriesQtyIP(_SetVal: DsSwbAccessoriesQtyIP) {
		this._dsSwbAccessoriesQtyIP = _SetVal;
	}
	get createdByName(): string {
		return this._createdByName;
	}
	set createdByName(_SetVal: string) {
		this._createdByName = _SetVal;
	}
	get createdByMailId(): string {
		return this._createdByMailId;
	}
	set createdByMailId(_SetVal: string) {
		this._createdByMailId = _SetVal;
	}
	get createdDate(): Date {
		return this._createdDate;
	}
	set createdDate(_SetVal: Date) {
		this._createdDate = _SetVal;
	}
	isDataFilledCompletely(): boolean {
		var _isDataFilled: boolean = true;

		this._dsGeneralIP.refreshStatus();
		if (this._dsGeneralIP.status != FunctionStatus.SUBMITTED_COMPLETE) {
			return false;
		}
		this._dsPanelIP.refreshStatus();
		if (this._dsPanelIP.status != FunctionStatus.SUBMITTED_COMPLETE) {
			return false;
		}
		this._dsBusbarsIP.refreshStatus();
		if (this._dsBusbarsIP.status != FunctionStatus.SUBMITTED_COMPLETE) {
			return false;
		}
	}

	cloneSelf() {
		let _clone = new DataSheetSubOrderIP(this._dataSheetId, this._dataSheetType, this._dsGeneralIP.cloneSelf(), this._dsPanelIP.cloneSelf(), this._dsBusbarsIP.cloneSelf(),
			this._dsPaintingIP.cloneSelf(), this._dsControlAuxIP.cloneSelf(), this._dsControlWiringIP.cloneSelf(), this._dsTerminalBlocksIP.cloneSelf(),
			this._dsCircuitBreakerIP.cloneSelf(), this._dsCurrentTrafoIP.cloneSelf(), this._dsPotentialTrafoIP.cloneSelf(), this._dsNumericalRelayIP.cloneSelf(),
			this._dsAuxRelayIP.cloneSelf(), this._dsMetersIP.cloneSelf(), this._dsSurgeArrestorIP.cloneSelf(), this._dsAnnuciatorIP.cloneSelf(), this._dsSwitchesIP.cloneSelf(),
			this._dsEthernetSwitchesIP.cloneSelf(), this._dsEarthingDevicesIP.cloneSelf(), this._dsSpecialDevicesIP.cloneSelf(), this._dsFoundationFrameIP.cloneSelf(), this._dsSwbAccessoriesQtyIP.cloneSelf(),
			this._createdByName, this._createdByMailId, this._createdDate, this._status);
		_clone.versions = JSON.parse(JSON.stringify(this._versions));
		_clone.currentVersion = this._currentVersion;
		return _clone;
	}
	public static emptyObj(): DataSheetSubOrderIP {
		let dataSheetObj: DataSheetSubOrderIP;
		let dsGeneralObj: DsGeneralIP;
		let dsPanelObj: DsPanelIP;
		let dsBusbarsObj: DsBusbarsIP;
		let dsPaintingObj: DsPaintingIP;
		let dsControlAuxObj: DsControlAuxIP;
		let dsControlWiringObj: DsControlWiringIP;
		let dsTerminalBlocksObj: DsTerminalBlocksIP;
		let dsCircuitBreakerObj: DsCircuitBreakerIP;
		let dsCurrentTrafoObj: DsCurrentTrafoIP;
		let dsPotentialTrafoObj: DsPotentialTrafoIP;
		let dsNumericalRelayObj: DsNumericalRelayIP;
		let dsAuxRelayObj: DsAuxRelayIP;
		let dsMetersObj: DsMetersIP;
		let dsSurgeArrestorObj: DsSurgeArrestorIP;
		let dsAnnuciatorObj: DsAnnuciatorIP;
		let dsSwitchesObj: DsSwitchesIP;
		let dsEthernetSwitchesObj: DsEthernetSwitchesIP;
		let dsEarthingDevicesObj: DsEarthingDevicesIP;
		let dsSpecialDevicesObj: DsSpecialDevicesIP;
		let dsFoundationFrameObj: DsFoundationFrameIP;
		let dsSwbAccessoriesQtyObj: DsSwbAccessoriesQtyIP;

		let feederBPDS: MultiOptDetails_9DS = new MultiOptDetails_9DS("", "", "001", "", "", "", "", "", "");
		let feederBPDSlist: Array<MultiOptDetails_9DS> = [];
		feederBPDSlist.push(feederBPDS);

		let feederNbDS: MultiOptDetails_3DS = new MultiOptDetails_3DS("", "", "");
		let feederNbDSlist: Array<MultiOptDetails_3DS> = [];
		feederNbDSlist.push(feederNbDS);

		let sptColorDS: MultiOptDetails_3DS = new MultiOptDetails_3DS("", "", "");
		let sptColorDSlist: Array<MultiOptDetails_3DS> = [];
		sptColorDSlist.push(sptColorDS);

		let uvCoilDS: MultiOptDetails_1DS = new MultiOptDetails_1DS("");
		let uvCoilDSlist: Array<MultiOptDetails_1DS> = [];
		uvCoilDSlist.push(uvCoilDS);

		let ctMouldDS: MultiOptDetails_8DS = new MultiOptDetails_8DS("", "", "", "", "", "", "", "");
		let ctMouldDSlist: Array<MultiOptDetails_8DS> = [];
		ctMouldDSlist.push(ctMouldDS);

		let ptMountingTyDS: MultiOptDetails_3DS = new MultiOptDetails_3DS("", "", "");
		let ptMountingTyDSlist: Array<MultiOptDetails_3DS> = [];
		ptMountingTyDSlist.push(ptMountingTyDS);

		let trReqDS: MultiOptDetails_2DS = new MultiOptDetails_2DS("", "");
		let trReqDSlist: Array<MultiOptDetails_2DS> = [];
		trReqDSlist.push(trReqDS);

		let multiFDS: MultiOptDetails_6DS = new MultiOptDetails_6DS("", "", "", "", "", "");
		let multiFDSlist: Array<MultiOptDetails_6DS> = [];
		multiFDSlist.push(multiFDS);

		let triVecDS: MultiOptDetails_6DS = new MultiOptDetails_6DS("", "", "", "", "", "");
		let triVecDSlist: Array<MultiOptDetails_6DS> = [];
		triVecDSlist.push(triVecDS);

		let srDS: MultiOptDetails_3DS = new MultiOptDetails_3DS("", "", "");
		let srDSlist: Array<MultiOptDetails_3DS> = [];
		srDSlist.push(srDS);

		let annDS: MultiOptDetails_5DS = new MultiOptDetails_5DS("", "", "", "", "");
		let annDSlist: Array<MultiOptDetails_5DS> = [];
		annDSlist.push(annDS);

		let sdTempScannerDS: MultiOptDetails_2DS = new MultiOptDetails_2DS("", "");
		let sdTempScannerDSlist: Array<MultiOptDetails_2DS> = [];
		sdTempScannerDSlist.push(sdTempScannerDS);

		let sdCurrTransducerDS: MultiOptDetails_2DS = new MultiOptDetails_2DS("", "");
		let sdCurrTransducerDSlist: Array<MultiOptDetails_2DS> = [];
		sdCurrTransducerDSlist.push(sdCurrTransducerDS);

		let sdVoltTransducerDS: MultiOptDetails_2DS = new MultiOptDetails_2DS("", "");
		let sdVoltTransducerDSlist: Array<MultiOptDetails_2DS> = [];
		sdVoltTransducerDSlist.push(sdVoltTransducerDS);

		let sdPowerTransducerDS: MultiOptDetails_2DS = new MultiOptDetails_2DS("", "");
		let sdPowerTransducerDSlist: Array<MultiOptDetails_2DS> = [];
		sdPowerTransducerDSlist.push(sdPowerTransducerDS);

		let sdMultiFuncTransducerDS: MultiOptDetails_2DS = new MultiOptDetails_2DS("", "");
		let sdMultiFuncTransducerDSlist: Array<MultiOptDetails_2DS> = [];
		sdMultiFuncTransducerDSlist.push(sdMultiFuncTransducerDS);

		let additionalPointsDS: MultiOptDetails_4DS = new MultiOptDetails_4DS("", "", "", "");
		let additionalPointsDSlist: Array<MultiOptDetails_4DS> = [];
		additionalPointsDSlist.push(additionalPointsDS);

		dsGeneralObj = new DsGeneralIP("", "", "", "", "", "", "", "", "", "", null, "", "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsPanelObj = new DsPanelIP("", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "",
			"", "", "", "", "", "", "", "", "", "", "", "", "", "", feederBPDSlist, "", "", "", "", "", "", feederNbDSlist, "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsBusbarsObj = new DsBusbarsIP("", "", "", "", "", "", "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsPaintingObj = new DsPaintingIP("", "", "", sptColorDSlist, "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsControlAuxObj = new DsControlAuxIP("", "", "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsControlWiringObj = new DsControlWiringIP("", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsTerminalBlocksObj = new DsTerminalBlocksIP("", "", "", "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsCircuitBreakerObj = new DsCircuitBreakerIP("", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", uvCoilDSlist, "", "", "", "", "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsCurrentTrafoObj = new DsCurrentTrafoIP("", ctMouldDSlist, "", "", "", "", "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsPotentialTrafoObj = new DsPotentialTrafoIP("", ptMountingTyDSlist, "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsNumericalRelayObj = new DsNumericalRelayIP("", "", "", "", "", "", "", "", "", "", trReqDSlist, "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsAuxRelayObj = new DsAuxRelayIP("", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsMetersObj = new DsMetersIP(multiFDSlist, triVecDSlist, "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsSurgeArrestorObj = new DsSurgeArrestorIP(srDSlist, "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsAnnuciatorObj = new DsAnnuciatorIP(annDSlist, "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsSwitchesObj = new DsSwitchesIP("", "", "", "", "", "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsEthernetSwitchesObj = new DsEthernetSwitchesIP("", "", "", "", "", "", "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsEarthingDevicesObj = new DsEarthingDevicesIP("", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsSpecialDevicesObj = new DsSpecialDevicesIP("", "", "", "", "", "", "", "", "", sdTempScannerDSlist, sdCurrTransducerDSlist, sdVoltTransducerDSlist,
			sdPowerTransducerDSlist, sdMultiFuncTransducerDSlist, "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsFoundationFrameObj = new DsFoundationFrameIP("", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsSwbAccessoriesQtyObj = new DsSwbAccessoriesQtyIP(null, null, null, null, null, null, "", "", additionalPointsDSlist, "", "", "", FunctionStatus.WAITING_FOR_PREV);



		dataSheetObj = new DataSheetSubOrderIP("", "", dsGeneralObj, dsPanelObj, dsBusbarsObj, dsPaintingObj, dsControlAuxObj, dsControlWiringObj,
			dsTerminalBlocksObj, dsCircuitBreakerObj, dsCurrentTrafoObj, dsPotentialTrafoObj, dsNumericalRelayObj, dsAuxRelayObj,
			dsMetersObj, dsSurgeArrestorObj, dsAnnuciatorObj, dsSwitchesObj, dsEthernetSwitchesObj, dsEarthingDevicesObj, dsSpecialDevicesObj,
			dsFoundationFrameObj, dsSwbAccessoriesQtyObj,
			"", "", null, FunctionStatus.WAITING_FOR_USER_INPUT);

		return dataSheetObj;
	}

	cloneMinimal(): DataSheetSubOrderIP {
		let dataSheetObj: DataSheetSubOrderIP;
		let dsGeneralObj: DsGeneralIP;
		let dsPanelObj: DsPanelIP;
		let dsBusbarsObj: DsBusbarsIP;
		let dsPaintingObj: DsPaintingIP;
		let dsControlAuxObj: DsControlAuxIP;
		let dsControlWiringObj: DsControlWiringIP;
		let dsTerminalBlocksObj: DsTerminalBlocksIP;
		let dsCircuitBreakerObj: DsCircuitBreakerIP;
		let dsCurrentTrafoObj: DsCurrentTrafoIP;
		let dsPotentialTrafoObj: DsPotentialTrafoIP;
		let dsNumericalRelayObj: DsNumericalRelayIP;
		let dsAuxRelayObj: DsAuxRelayIP;
		let dsMetersObj: DsMetersIP;
		let dsSurgeArrestorObj: DsSurgeArrestorIP;
		let dsAnnuciatorObj: DsAnnuciatorIP;
		let dsSwitchesObj: DsSwitchesIP;
		let dsEthernetSwitchesObj: DsEthernetSwitchesIP;
		let dsEarthingDevicesObj: DsEarthingDevicesIP;
		let dsSpecialDevicesObj: DsSpecialDevicesIP;
		let dsFoundationFrameObj: DsFoundationFrameIP;
		let dsSwbAccessoriesQtyObj: DsSwbAccessoriesQtyIP;

		let feederBPDS: MultiOptDetails_9DS = new MultiOptDetails_9DS("", "", "001", "", "", "", "", "", "");
		let feederBPDSlist: Array<MultiOptDetails_9DS> = [];
		feederBPDSlist.push(feederBPDS);

		let feederNbDS: MultiOptDetails_3DS = new MultiOptDetails_3DS("", "", "");
		let feederNbDSlist: Array<MultiOptDetails_3DS> = [];
		feederNbDSlist.push(feederNbDS);

		let sptColorDS: MultiOptDetails_3DS = new MultiOptDetails_3DS("", "", "");
		let sptColorDSlist: Array<MultiOptDetails_3DS> = [];
		sptColorDSlist.push(sptColorDS);

		let uvCoilDS: MultiOptDetails_1DS = new MultiOptDetails_1DS("");
		let uvCoilDSlist: Array<MultiOptDetails_1DS> = [];
		uvCoilDSlist.push(uvCoilDS);

		let ctMouldDS: MultiOptDetails_8DS = new MultiOptDetails_8DS("", "", "", "", "", "", "", "");
		let ctMouldDSlist: Array<MultiOptDetails_8DS> = [];
		ctMouldDSlist.push(ctMouldDS);

		let ptMountingTyDS: MultiOptDetails_3DS = new MultiOptDetails_3DS("", "", "");
		let ptMountingTyDSlist: Array<MultiOptDetails_3DS> = [];
		ptMountingTyDSlist.push(ptMountingTyDS);

		let trReqDS: MultiOptDetails_2DS = new MultiOptDetails_2DS("", "");
		let trReqDSlist: Array<MultiOptDetails_2DS> = [];
		trReqDSlist.push(trReqDS);

		let multiFDS: MultiOptDetails_6DS = new MultiOptDetails_6DS("", "", "", "", "", "");
		let multiFDSlist: Array<MultiOptDetails_6DS> = [];
		multiFDSlist.push(multiFDS);

		let triVecDS: MultiOptDetails_6DS = new MultiOptDetails_6DS("", "", "", "", "", "");
		let triVecDSlist: Array<MultiOptDetails_6DS> = [];
		triVecDSlist.push(triVecDS);

		let srDS: MultiOptDetails_3DS = new MultiOptDetails_3DS("", "", "");
		let srDSlist: Array<MultiOptDetails_3DS> = [];
		srDSlist.push(srDS);

		let annDS: MultiOptDetails_5DS = new MultiOptDetails_5DS("", "", "", "", "");
		let annDSlist: Array<MultiOptDetails_5DS> = [];
		annDSlist.push(annDS);

		let sdTempScannerDS: MultiOptDetails_2DS = new MultiOptDetails_2DS("", "");
		let sdTempScannerDSlist: Array<MultiOptDetails_2DS> = [];
		sdTempScannerDSlist.push(sdTempScannerDS);

		let sdCurrTransducerDS: MultiOptDetails_2DS = new MultiOptDetails_2DS("", "");
		let sdCurrTransducerDSlist: Array<MultiOptDetails_2DS> = [];
		sdCurrTransducerDSlist.push(sdCurrTransducerDS);

		let sdVoltTransducerDS: MultiOptDetails_2DS = new MultiOptDetails_2DS("", "");
		let sdVoltTransducerDSlist: Array<MultiOptDetails_2DS> = [];
		sdVoltTransducerDSlist.push(sdVoltTransducerDS);

		let sdPowerTransducerDS: MultiOptDetails_2DS = new MultiOptDetails_2DS("", "");
		let sdPowerTransducerDSlist: Array<MultiOptDetails_2DS> = [];
		sdPowerTransducerDSlist.push(sdPowerTransducerDS);

		let sdMultiFuncTransducerDS: MultiOptDetails_2DS = new MultiOptDetails_2DS("", "");
		let sdMultiFuncTransducerDSlist: Array<MultiOptDetails_2DS> = [];
		sdMultiFuncTransducerDSlist.push(sdMultiFuncTransducerDS);

		let additionalPointsDS: MultiOptDetails_4DS = new MultiOptDetails_4DS("", "", "", "");
		let additionalPointsDSlist: Array<MultiOptDetails_4DS> = [];
		additionalPointsDSlist.push(additionalPointsDS);


		dsGeneralObj = new DsGeneralIP("", "", "", "", "", "", "", "", "", "", null, "", "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsPanelObj = new DsPanelIP("", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "",
			"", "", "", "", "", "", "", "", "", "", "", "", "", "", feederBPDSlist, "", "", "", "", "", "", feederNbDSlist, "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsBusbarsObj = new DsBusbarsIP("", "", "", "", "", "", "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsPaintingObj = new DsPaintingIP("", "", "", sptColorDSlist, "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsControlAuxObj = new DsControlAuxIP("", "", "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsControlWiringObj = new DsControlWiringIP("", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsTerminalBlocksObj = new DsTerminalBlocksIP("", "", "", "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsCircuitBreakerObj = new DsCircuitBreakerIP("", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", uvCoilDSlist, "", "", "", "", "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsCurrentTrafoObj = new DsCurrentTrafoIP("", ctMouldDSlist, "", "", "", "", "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsPotentialTrafoObj = new DsPotentialTrafoIP("", ptMountingTyDSlist, "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsNumericalRelayObj = new DsNumericalRelayIP("", "", "", "", "", "", "", "", "", "", trReqDSlist, "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsAuxRelayObj = new DsAuxRelayIP("", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsMetersObj = new DsMetersIP(multiFDSlist, triVecDSlist, "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsSurgeArrestorObj = new DsSurgeArrestorIP(srDSlist, "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsAnnuciatorObj = new DsAnnuciatorIP(annDSlist, "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsSwitchesObj = new DsSwitchesIP("", "", "", "", "", "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsEthernetSwitchesObj = new DsEthernetSwitchesIP("", "", "", "", "", "", "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsEarthingDevicesObj = new DsEarthingDevicesIP("", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsSpecialDevicesObj = new DsSpecialDevicesIP("", "", "", "", "", "", "", "", "", sdTempScannerDSlist, sdCurrTransducerDSlist, sdVoltTransducerDSlist,
			sdPowerTransducerDSlist, sdMultiFuncTransducerDSlist, "", "", "", "", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsFoundationFrameObj = new DsFoundationFrameIP("", "", "", "", "", FunctionStatus.WAITING_FOR_PREV);
		dsSwbAccessoriesQtyObj = new DsSwbAccessoriesQtyIP(null, null, null, null, null, null, "", "", additionalPointsDSlist, "", "", "", FunctionStatus.WAITING_FOR_PREV);



		dataSheetObj = new DataSheetSubOrderIP("", "", dsGeneralObj, dsPanelObj, dsBusbarsObj, dsPaintingObj, dsControlAuxObj, dsControlWiringObj,
			dsTerminalBlocksObj, dsCircuitBreakerObj, dsCurrentTrafoObj, dsPotentialTrafoObj, dsNumericalRelayObj, dsAuxRelayObj,
			dsMetersObj, dsSurgeArrestorObj, dsAnnuciatorObj, dsSwitchesObj, dsEthernetSwitchesObj, dsEarthingDevicesObj, dsSpecialDevicesObj,
			dsFoundationFrameObj, dsSwbAccessoriesQtyObj,
			"", "", null, FunctionStatus.WAITING_FOR_USER_INPUT);

		return dataSheetObj;
	}
	public static getObj(_json: any): DataSheetSubOrderIP {
		let _obj = new DataSheetSubOrderIP(_json.dataSheetId, _json.dataSheetType,
			DsGeneralIP.getObj(_json.dsGeneralIP), DsPanelIP.getObj(_json.dsPanelIP), DsBusbarsIP.getObj(_json.dsBusbarsIP), DsPaintingIP.getObj(_json.dsPaintingIP),
			DsControlAuxIP.getObj(_json.dsControlAuxIP), DsControlWiringIP.getObj(_json.dsControlWiringIP), DsTerminalBlocksIP.getObj(_json.dsTerminalBlocksIP), DsCircuitBreakerIP.getObj(_json.dsCircuitBreakerIP),
			_json.dsCurrentTrafoIP ? DsCurrentTrafoIP.getObj(_json.dsCurrentTrafoIP) : DsCurrentTrafoIP.emptyObj(),
			_json.dsPotentialTrafoIP ? DsPotentialTrafoIP.getObj(_json.dsPotentialTrafoIP) : DsPotentialTrafoIP.emptyObj(),
			_json.dsNumericalRelayIP ? DsNumericalRelayIP.getObj(_json.dsNumericalRelayIP) : DsNumericalRelayIP.emptyObj(),
			_json.dsAuxRelayIP ? DsAuxRelayIP.getObj(_json.dsAuxRelayIP) : DsAuxRelayIP.emptyObj(),
			_json.dsMetersIP ? DsMetersIP.getObj(_json.dsMetersIP) : DsMetersIP.emptyObj(),
			_json.dsSurgeArrestorIP ? DsSurgeArrestorIP.getObj(_json.dsSurgeArrestorIP) : DsSurgeArrestorIP.emptyObj(),
			_json.dsAnnuciatorIP ? DsAnnuciatorIP.getObj(_json.dsAnnuciatorIP) : DsAnnuciatorIP.emptyObj(),
			_json.dsSwitchesIP ? DsSwitchesIP.getObj(_json.dsSwitchesIP) : DsSwitchesIP.emptyObj(),
			_json.dsEthernetSwitchesIP ? DsEthernetSwitchesIP.getObj(_json.dsEthernetSwitchesIP) : DsEthernetSwitchesIP.emptyObj(),
			_json.dsEarthingDevicesIP ? DsEarthingDevicesIP.getObj(_json.dsEarthingDevicesIP) : DsEarthingDevicesIP.emptyObj(),
			_json.dsSpecialDevicesIP ? DsSpecialDevicesIP.getObj(_json.dsSpecialDevicesIP) : DsSpecialDevicesIP.emptyObj(),
			_json.dsFoundationFrameIP ? DsFoundationFrameIP.getObj(_json.dsFoundationFrameIP) : DsFoundationFrameIP.emptyObj(),
			_json.dsSwbAccessoriesQtyIP ? DsSwbAccessoriesQtyIP.getObj(_json.dsSwbAccessoriesQtyIP) : DsSwbAccessoriesQtyIP.emptyObj(),
			_json.createdByName, _json.createdByMailId,
			GenService.convToDate(_json.createdDate) ? GenService.convToDate(_json.createdDate) : GenService.convToDate(new Date(_json.createdDate).toDateString()), // To handle both date num and date string
			_json.status);
		_obj.versions = _json.versions || [];
		_obj.currentVersion = _json.currentVersion || 'Rev-0';
		return _obj;
	}
	public getJson(): any {
		let _json: any = {};
		_json.dataSheetId = this.dataSheetId;
		_json.dataSheetType = this.dataSheetType;
		_json.dsGeneralIP = this.dsGeneralIP.getJson();
		_json.dsPanelIP = this.dsPanelIP.getJson();
		_json.dsBusbarsIP = this.dsBusbarsIP.getJson();
		_json.dsPaintingIP = this.dsPaintingIP.getJson();
		_json.dsControlAuxIP = this.dsControlAuxIP.getJson();
		_json.dsControlWiringIP = this.dsControlWiringIP.getJson();
		_json.dsTerminalBlocksIP = this.dsTerminalBlocksIP.getJson();
		_json.dsCircuitBreakerIP = this.dsCircuitBreakerIP.getJson();
		_json.dsCurrentTrafoIP = this.dsCurrentTrafoIP.getJson();
		_json.dsPotentialTrafoIP = this.dsPotentialTrafoIP.getJson();
		_json.dsNumericalRelayIP = this.dsNumericalRelayIP.getJson();
		_json.dsAuxRelayIP = this.dsAuxRelayIP.getJson();
		_json.dsMetersIP = this.dsMetersIP.getJson();
		_json.dsSurgeArrestorIP = this.dsSurgeArrestorIP.getJson();
		_json.dsAnnuciatorIP = this.dsAnnuciatorIP.getJson();
		_json.dsSwitchesIP = this.dsSwitchesIP.getJson();
		_json.dsEthernetSwitchesIP = this.dsEthernetSwitchesIP.getJson();
		_json.dsEarthingDevicesIP = this.dsEarthingDevicesIP.getJson();
		_json.dsSpecialDevicesIP = this.dsSpecialDevicesIP.getJson();
		_json.dsFoundationFrameIP = this.dsFoundationFrameIP.getJson();
		_json.dsSwbAccessoriesQtyIP = this.dsSwbAccessoriesQtyIP.getJson();
		_json.createdByName = this.createdByName;
		_json.createdByMailId = this.createdByMailId;
		_json.createdDate = GenService.convToDateNum(this.createdDate);
		_json.status = this.status;
		_json.versions = this.versions;
		_json.currentVersion = this.currentVersion;
		return _json;
	}
}
export class SubSalesOrder {
	constructor(private _subOrderNoId: string, private _pmTechSubSalesOrder: PmTechnicalIP, private _enggDrawIP: EnggDrawIP, private _scmIP: ScmIP, private _enggProcureIP: EnggProcureIP,
		private _purchasePOIP: PurchasePOIP, private _planningIP: PlanningIP, private _purchaseMatReceipt: PurchaseMaterialReceiptIP,
		private _storeIP: StoreIP, private _productionIP: ProductionIP, private _qualityIP: QualityIP,
		private _logisticIP: LogisticIP,
		private _changeNoteIP: ChangeNoteIP, private _dataSheetSubOrderIP: DataSheetSubOrderIP, private _subOrderStatus: SSOStatus) {
		this._pmTechSubSalesOrder.parentSubSORef = this;
		this._scmIP.parentSubSORef = this;
		this._enggDrawIP.parentSubSORef = this;
		this._enggProcureIP.parentSubSORef = this;
		this._purchasePOIP.parentSubSORef = this;
		this._planningIP.parentSubSORef = this;
		this._purchaseMatReceipt.parentSubSORef = this;
		this._storeIP.parentSubSORef = this;
		this._productionIP.parentSubSORef = this;
		this._qualityIP.parentSubSORef = this;
		this._logisticIP.parentSubSORef = this;
		this._changeNoteIP.parentSubSORef = this;
		if (this._dataSheetSubOrderIP != null) this._dataSheetSubOrderIP.parentSubSORef = this;
	}

	private _parentSORef: SalesOrder;
	get parentSORef(): SalesOrder {
		return this._parentSORef;
	}
	set parentSORef(SORef: SalesOrder) {
		this._parentSORef = SORef;
		this._pmTechSubSalesOrder.parentSORef = SORef;
		this._scmIP.parentSORef = SORef;
		this._enggDrawIP.parentSORef = SORef;
		this._enggProcureIP.parentSORef = SORef;
		this._purchasePOIP.parentSORef = SORef;
		this._planningIP.parentSORef = SORef;
		this._purchaseMatReceipt.parentSORef = SORef;
		this._storeIP.parentSORef = SORef;
		this._productionIP.parentSORef = SORef;
		this._qualityIP.parentSORef = SORef;
		this._logisticIP.parentSORef = SORef;
		this._changeNoteIP.parentSORef = SORef;
		if (this._dataSheetSubOrderIP != null) this._dataSheetSubOrderIP.parentSORef = SORef;
	}
	public refreshStatus() {
		this._pmTechSubSalesOrder.refreshStatus();
		this._scmIP.refreshStatus();
		this._enggDrawIP.refreshStatus();
		this._enggProcureIP.refreshStatus();
		this._purchasePOIP.refreshStatus();
		this._planningIP.refreshStatus();
		this._purchaseMatReceipt.refreshStatus();;
		this._storeIP.refreshStatus();
		this._productionIP.refreshStatus();
		this._qualityIP.refreshStatus();
		this._logisticIP.refreshStatus();
		this._changeNoteIP.refreshStatus();
		this._dataSheetSubOrderIP.refreshStatus();
	}
	get subOrderNoId(): string {
		return this._subOrderNoId;
	}
	set subOrderNoId(_SetVal: string) {
		this._subOrderNoId = _SetVal;
	}
	get pmTechSubSalesOrder(): PmTechnicalIP {
		return this._pmTechSubSalesOrder;
	}
	set pmTechSubSalesOrder(_SetVal: PmTechnicalIP) {
		this._pmTechSubSalesOrder = _SetVal;
	}
	get scmIP(): ScmIP {
		return this._scmIP;
	}
	set scmIP(_SetVal: ScmIP) {
		this._scmIP = _SetVal;
	}
	enableSCMInput() {
		this._subOrderStatus = this._subOrderStatus | SSOStatus.SCM;
		this.scmIP.enableFormInput();
	}
	get enggDrawIP(): EnggDrawIP {
		return this._enggDrawIP;
	}
	set enggDrawIP(_SetVal: EnggDrawIP) {
		this._enggDrawIP = _SetVal;
	}
	enableEnggDrawInput() {
		this._subOrderStatus = this._subOrderStatus | SSOStatus.Engg_Draw;
		this.enggDrawIP.enableFormInput();
	}
	get enggProcureIP(): EnggProcureIP {
		return this._enggProcureIP;
	}
	set enggProcureIP(_SetVal: EnggProcureIP) {
		this._enggProcureIP = _SetVal;
	}
	isDataFilledCompletely(): boolean {
		var _isDataFilled: boolean = true;

		this.pmTechSubSalesOrder.refreshStatus();
		if (this.pmTechSubSalesOrder.status != FunctionStatus.SUBMITTED_COMPLETE) {
			return false;
		}

		this.enggDrawIP.refreshStatus();
		if (this.enggDrawIP.status != FunctionStatus.SUBMITTED_COMPLETE) {
			return false;
		}

		this.scmIP.refreshStatus();
		if (this.scmIP.status != FunctionStatus.SUBMITTED_COMPLETE) {
			return false;
		}

		this.enggProcureIP.refreshStatus();
		if (this.enggProcureIP.status != FunctionStatus.SUBMITTED_COMPLETE) {
			return false;
		}

		this.purchasePOIP.refreshStatus();
		if (this.purchasePOIP.status != FunctionStatus.SUBMITTED_COMPLETE) {
			return false;
		}

		this.planningIP.refreshStatus();
		if (this.planningIP.status != FunctionStatus.SUBMITTED_COMPLETE) {
			return false;
		}

		this.purchaseMatReceipt.refreshStatus();
		if (this.purchaseMatReceipt.status != FunctionStatus.SUBMITTED_COMPLETE) {
			return false;
		}

		this.storeIP.refreshStatus();
		if (this.storeIP.status != FunctionStatus.SUBMITTED_COMPLETE) {
			return false;
		}

		this.productionIP.refreshStatus();
		if (this.productionIP.status != FunctionStatus.SUBMITTED_COMPLETE) {
			return false;
		}

		this.qualityIP.refreshStatus();
		if (this.qualityIP.status != FunctionStatus.SUBMITTED_COMPLETE) {
			return false;
		}

		this.logisticIP.refreshStatus();
		if (this.logisticIP.status != FunctionStatus.SUBMITTED_COMPLETE) {
			return false;
		}

		return _isDataFilled;
	}
	enablePMTechInputFromEnggDraw() {
		this._subOrderStatus = this._subOrderStatus | SSOStatus.PM_Tech_EnggDraw;
		this.pmTechSubSalesOrder.enableFormInput();
	}
	enableEnggProcurementInputFromEnggDraw() {
		this._subOrderStatus = this._subOrderStatus | SSOStatus.Engg_Procurement_From_EnggDraw;
		this.enggProcureIP.enableFormInput();
	}
	enableEnggProcurementInputFromSCM() {
		this._subOrderStatus = this._subOrderStatus | SSOStatus.Engg_Procurement_From_SCM;
		this.enggProcureIP.enableFormInput();
	}
	enablePOPlanningInputFromProc() {
		this._subOrderStatus |= SSOStatus.PO | SSOStatus.Planning;
		this.purchasePOIP.enableFormInput();
		this.planningIP.enableFormInput();
	}
	enablePMTechScmInputFromEnggDraw() {
		this._subOrderStatus |= SSOStatus.PM_Tech_EnggDraw | SSOStatus.SCM;
		this.pmTechSubSalesOrder.enableFormInput();
		this.scmIP.enableFormInput();
	}
	enablePlanningInputFromProc() {
		this._subOrderStatus |= SSOStatus.Planning_From_PO;
		this.planningIP.enableFormInput();
	}
	enablePlanningInputFromPMTech() {
		this._subOrderStatus |= SSOStatus.Planning_From_PMTech;
		this.planningIP.enableFormInput();
	}
	enableMRSPInputFromProc() {
		this._subOrderStatus |= SSOStatus.Material_Receipt | SSOStatus.Store | SSOStatus.Production;
		this.purchaseMatReceipt.enableFormInput();
		this.storeIP.enableFormInput();
		this.productionIP.enableFormInput();
	}
	enableProductionFromStore() {
		this._subOrderStatus |= SSOStatus.Production_From_Store;
		this.productionIP.enableFormInput();
	}
	enableStoreInputFromMaterialReceipt() {
		this._subOrderStatus |= SSOStatus.Store_From_MaterialReceipt;
		this.storeIP.enableFormInput();
	}
	enableQualityInputFromProduction() {
		this._subOrderStatus |= SSOStatus.Quality;
		this.qualityIP.enableFormInput();
	}
	enableLogisticInputFromQuality() {
		this._subOrderStatus |= SSOStatus.Logistic;
		this.logisticIP.enableFormInput();
	}
	enableUndispatchedFromLogistic() {
		this._subOrderStatus = this._subOrderStatus - SSOStatus.Dispatched;
		this.logisticIP.enableFormInput();
	}
	enableSubOrderCompletion() {
		this._subOrderStatus |= SSOStatus.Dispatched;
		this.logisticIP.subOrderComplete();
	}
	enableEnggProcLogisticInputFromPMTech() {
		this._subOrderStatus |= SSOStatus.Engg_Procurement_From_PM_Tech | SSOStatus.Logistic_From_PM_Tech;
		this.enggProcureIP.enableFormInput();
		this.logisticIP.enableFormInput();
	}
	get purchasePOIP(): PurchasePOIP {
		return this._purchasePOIP;
	}
	set purchasePOIP(_SetVal: PurchasePOIP) {
		this._purchasePOIP = _SetVal;
	}
	get planningIP(): PlanningIP {
		return this._planningIP;
	}
	set planningIP(_SetVal: PlanningIP) {
		this._planningIP = _SetVal;
	}
	get purchaseMatReceipt(): PurchaseMaterialReceiptIP {
		return this._purchaseMatReceipt;
	}
	set purchaseMatReceipt(_SetVal: PurchaseMaterialReceiptIP) {
		this._purchaseMatReceipt = _SetVal;
	}
	get storeIP(): StoreIP {
		return this._storeIP;
	}
	set storeIP(_SetVal: StoreIP) {
		this._storeIP = _SetVal;
	}
	get productionIP(): ProductionIP {
		return this._productionIP;
	}
	set productionIP(_SetVal: ProductionIP) {
		this._productionIP = _SetVal;
	}
	get qualityIP(): QualityIP {
		return this._qualityIP;
	}
	set qualityIP(_SetVal: QualityIP) {
		this._qualityIP = _SetVal;
	}
	get logisticIP(): LogisticIP {
		return this._logisticIP;
	}
	set logisticIP(_SetVal: LogisticIP) {
		this._logisticIP = _SetVal;
	}
	get changeNoteIP(): ChangeNoteIP {
		return this._changeNoteIP;
	}
	set changeNoteIP(_SetVal: ChangeNoteIP) {
		this._changeNoteIP = _SetVal;
	}
	get dataSheetSubOrderIP(): DataSheetSubOrderIP {
		return this._dataSheetSubOrderIP;
	}
	set dataSheetSubOrderIP(_SetVal: DataSheetSubOrderIP) {
		this._dataSheetSubOrderIP = _SetVal;
	}
	get estimatedDispatchDate(): Date {
		var _tmpDate: Date
		if (this._logisticIP.dispatchFromPlantPlannedDate != null || this._logisticIP.dispatchFromPlantRequestDate != null) {
			if (this._logisticIP.dispatchFromPlantPlannedDate < this._logisticIP.dispatchFromPlantRequestDate) {
				_tmpDate = this._logisticIP.dispatchFromPlantRequestDate
			}
			else {
				_tmpDate = this._logisticIP.dispatchFromPlantPlannedDate;
			}
		}
		return _tmpDate;
	}
	get dispatchDays(): number {
		let _tmpPlannedContDeliveryDate: Date = this._pmTechSubSalesOrder.plannedContractualDeliveryDate;
		let _tmpTentativeDeliveryDate: Date = this._pmTechSubSalesOrder.reqOrPlndDeliveryDate;

		if (_tmpPlannedContDeliveryDate && _tmpTentativeDeliveryDate) {
			var _deliveryProjection: Date = this._pmTechSubSalesOrder.deliveryProjectionDate;
			if (_deliveryProjection != null && _deliveryProjection.getTime() > _tmpTentativeDeliveryDate.getTime()) {
				return configDefs.getDaysDifference(_tmpPlannedContDeliveryDate, _deliveryProjection)
			}
			else {
				return configDefs.getDaysDifference(_tmpPlannedContDeliveryDate, _tmpTentativeDeliveryDate)
			}

		}
		return null;
	}
	get dispatchDaysTip(): string {
		let _tmpPlannedContDeliveryDate: Date = this._pmTechSubSalesOrder.plannedContractualDeliveryDate;
		let _tmpTentativeDeliveryDate: Date = this._pmTechSubSalesOrder.reqOrPlndDeliveryDate;

		if (_tmpTentativeDeliveryDate && _tmpPlannedContDeliveryDate) {
			var _deliveryProjection: Date = this._pmTechSubSalesOrder.deliveryProjectionDate;
			return 'Delivery Date : \r\n' +
				'\tContractual > ' + moment(_tmpPlannedContDeliveryDate).format(configDefs.dateFormat) + '\r\n' +
				'\tTentative > ' + moment(_tmpTentativeDeliveryDate).format(configDefs.dateFormat) +
				(_deliveryProjection.getTime() > _tmpTentativeDeliveryDate.getTime() ?
					'\r\n\tProjected > ' + moment(_deliveryProjection).format(configDefs.dateFormat)
					: '');
		}
		return '';
	}
	get pmTechDays(): number {
		let _tmpPlannedDate: Date = this._pmTechSubSalesOrder.plannedDrawingApprovalDate
		let _tmpActualDate: Date = this._pmTechSubSalesOrder.actualDrawingApprovalDate
		if (_tmpPlannedDate && _tmpActualDate) {
			return configDefs.getDaysDifference(_tmpPlannedDate, _tmpActualDate);
		}
		return null;
	}
	get pmTechDaysTip(): string {
		let _tmpPlannedDate: Date = this._pmTechSubSalesOrder.plannedDrawingApprovalDate
		let _tmpActualDate: Date = this._pmTechSubSalesOrder.actualDrawingApprovalDate
		if (_tmpPlannedDate && _tmpActualDate) {
			return 'Drawing Approval Date : \r\n' +
				'\tPlanned\t> ' + moment(_tmpPlannedDate).format(configDefs.dateFormat) + '\r\n' +
				'\tActual\t> ' + moment(_tmpActualDate).format(configDefs.dateFormat);
		}
		return '';
	}
	get enggDrawDays(): number {
		return this._enggDrawIP.enggDays;
	}
	get enggDrawDaysTip(): string {
		return this._enggDrawIP.enggDaysTip;
	}
	get scmCTDays(): number {
		return this._pmTechSubSalesOrder.scmCTDays;
	}
	get scmCTDaysTip(): string {
		return this._pmTechSubSalesOrder.scmCTDaysTip;
	}
	get enggProcDays(): number {
		return this._enggProcureIP.enggDays;
	}
	get enggProcDaysTip(): string {
		return this._enggProcureIP.enggDaysTip;
	}
	get purPODays(): number {
		return this._purchasePOIP.purPODays;
	}
	get purPODaysTip(): string {
		return this._purchasePOIP.purPODaysTip;
	}
	get planDays(): number {
		return this._planningIP.planDays;
	}
	get planDaysTip(): string {
		return this._planningIP.planDaysTip;
	}
	get purMatRcptDays(): number {
		return this._purchaseMatReceipt.purMatRcptDays;
	}
	get purMatRcptDaysTip(): string {
		return this._purchaseMatReceipt.purMatRcptDaysTip;
	}
	get storeDays(): number {
		return this._storeIP.storeDays;
	}
	get storeDaysTip(): string {
		return this._storeIP.storeDaysTip;
	}
	get productionDays(): number {
		return this._productionIP.productionDays;
	}
	get productionDaysTip(): string {
		return this._productionIP.productionDaysTip;
	}
	get qualityDays(): number {
		return this._qualityIP.qualityDays;
	}
	get qualityDaysTip(): string {
		return this._qualityIP.qualityDaysTip;
	}
	get logisticDays(): number {
		return this._logisticIP.logisticDays;
	}
	get logisticDaysTip(): string {
		return this._logisticIP.logisticDaysTip;
	}
	get manufacturingMonth(): Date {
		if (this.planningIP && this.planningIP.plannedManufacturingMonth) {
			return this.planningIP.plannedManufacturingMonth;
		}
		return null;
	}
	get invoicingmonth(): Date {
		if (this.pmTechSubSalesOrder && this.pmTechSubSalesOrder.invoicingmonth) {
			return this.pmTechSubSalesOrder.invoicingmonth;
		}
		return null;
	}
	get rotddate(): Date {
		if (this.pmTechSubSalesOrder && this.pmTechSubSalesOrder.rotddate) {
			return this.pmTechSubSalesOrder.rotddate
		}
		return null;
	}

	get revenueMonth(): Date {
		if (this.pmTechSubSalesOrder && this.pmTechSubSalesOrder.plannedRevnueMonth) {
			return this.pmTechSubSalesOrder.plannedRevnueMonth;
		}
		return null;
	}

	get manufacturingStrategy(): string {
		if (this.planningIP && this.planningIP.manufacturingStrategy) {
			return this.planningIP.manufacturingStrategy;
		}
		return null;
	}
	get relayconfig(): string {
		if (this.enggProcureIP && this.enggProcureIP.relayconfigId) {
			return this.enggProcureIP.relayconfigId
		}
		return null
	}

	get subOrderStatus(): SSOStatus {
		return this._subOrderStatus;
	}
	isSSOStatusSet(_checkStatus: SSOStatus): boolean {
		return ((this._subOrderStatus & _checkStatus) == _checkStatus);
	}

	// set subOrderStatus(_SetVal:SSOStatus){
	// 	this._subOrderStatus = _SetVal;
	// }

	// STARTS
	get serialNos(): Array<string> {
		let _tmp = [];
		let _tmpSNo = this.planningIP.serialNums;
		for (let i = 0; i < _tmpSNo.length; i++) {
			let _serial: string = _tmpSNo[i].sNo;
			_tmp.push(_serial.toLowerCase());
		}
		return _tmp;
	}
	// ENDS
	get pmTechSubOrderStatus(): FunctionStatus {
		return this.pmTechSubSalesOrder.status;
	}
	get enggDrawStatus(): FunctionStatus {
		return this.enggDrawIP.status;
	}
	get scmStatus(): FunctionStatus {
		return this.scmIP.status;
	}
	get enggProcureStatus(): FunctionStatus {
		return this.enggProcureIP.status;
	}
	get purchasePOStatus(): FunctionStatus {
		return this.purchasePOIP.status;
	}
	get planningStatus(): FunctionStatus {
		return this.planningIP.status;
	}
	get materialReceiptStatus(): FunctionStatus {
		return this.purchaseMatReceipt.status;
	}
	get storeStatus(): FunctionStatus {
		return this.storeIP.status;
	}
	get productionStatus(): FunctionStatus {
		return this.productionIP.status;
	}
	get qualityStatus(): FunctionStatus {
		return this.qualityIP.status;
	}
	get logisticsStatus(): FunctionStatus {
		return this.logisticIP.status;
	}
	get changeNoteStatus(): FunctionStatus {
		return this.changeNoteIP.status;
	}
	get dataSheetSubOrderStatus(): FunctionStatus {
		if (this._dataSheetSubOrderIP == null) {
			return null;
		}
		else {
			return this._dataSheetSubOrderIP.status;
		}
	}

	addNewDSSubSo(_newDsSSO: DataSheetSubOrderIP) {
		_newDsSSO.parentSubSORef = this;
		_newDsSSO.parentSORef = this.parentSORef;
		this._dataSheetSubOrderIP = _newDsSSO;
	}

	cloneSelf() {
		return new SubSalesOrder(this.subOrderNoId, this._pmTechSubSalesOrder.cloneSelf(), this._enggDrawIP.cloneSelf(), this._scmIP.cloneSelf(),
			this._enggProcureIP.cloneSelf(), this._purchasePOIP.cloneSelf(), this._planningIP.cloneSelf(), this._purchaseMatReceipt.cloneSelf(),
			this._storeIP.cloneSelf(), this._productionIP.cloneSelf(), this._qualityIP.cloneSelf(), this._logisticIP.cloneSelf(),
			this._changeNoteIP.cloneSelf(), this._dataSheetSubOrderIP.cloneSelf(), this.subOrderStatus);
	}
	cloneMinimal() {
		let pmTechSubSalesOrderObj: PmTechnicalIP;
		let scmObj: ScmIP;
		let enggDrawObj: EnggDrawIP;
		let enggProcureObj: EnggProcureIP;
		let purchasePOObj: PurchasePOIP;
		let planningObj: PlanningIP;
		let purchaseMatRecptObj: PurchaseMaterialReceiptIP;
		let storeObj: StoreIP;
		let productionObj: ProductionIP;
		let qualityObj: QualityIP;
		let logisticObj: LogisticIP;
		let changeNoteObj: ChangeNoteIP;
		let dataSheetSubOrderObj: DataSheetSubOrderIP;
		let subSaleOrderObj: SubSalesOrder;

		// let eqipment: Equipment = new Equipment("", "", "", "","","", []);
		// let eqipmentList: Array<Equipment> = [];
		// eqipmentList.push(eqipment);

		pmTechSubSalesOrderObj = this._pmTechSubSalesOrder.cloneSelfMainContent();

		enggDrawObj = new EnggDrawIP("", "", "001",
			new ActualDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''),
			// STARTS
			new PlannedDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''),
			// ENDS
			new GenFileUploads([]),
			new GenFileUploads([]),
			new GenFileUploads([]),
			new GenFileUploads([]),
			new GenFileUploads([]),
			"",
			new PlannedDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''), FunctionStatus.WAITING_FOR_PREV);
		scmObj = new ScmIP(new PlannedDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''), FunctionStatus.WAITING_FOR_PREV);
		enggProcureObj = new EnggProcureIP(new PlannedDateToken(null, false, null, '', ''), new PlannedDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''), new PlannedDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''), new ActualDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''), new ActualDateToken(null, false, null, '', ''), null,
			new EnggProcFileUploads([]), new EnggProcFileUploads([]), new EnggProcFileUploads([]), new EnggProcFileUploads([]),
			new EnggProcFileUploads([]), new GenFileUploads([]),
			new GenFileUploads([]), new GenFileUploads([]), FunctionStatus.WAITING_FOR_PREV);

		purchasePOObj = new PurchasePOIP(new PlannedDateToken(null, false, null, '', ''), new PlannedDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''), new PlannedDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''), new PlannedDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''), new PlannedDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''), new ActualDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''), new ActualDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''), new ActualDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''), new ActualDateToken(null, false, null, '', '')
			, FunctionStatus.WAITING_FOR_PREV);
		planningObj = new PlanningIP(null, null,
			new PlannedDateToken(null, false, null, '', ''), new RequestDateToken(null, false, null, '', ''), null, "",
			new PlannedDateToken(null, false, null, '', ''), new RequestDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''), [], [], [], null, null, FunctionStatus.WAITING_FOR_PREV);

		purchaseMatRecptObj = new PurchaseMaterialReceiptIP(
			new PlannedDateToken(null, false, null, '', ''), null, null, new ActualDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''), null, null, new ActualDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''), null, null, new ActualDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''), null, null, new ActualDateToken(null, false, null, '', ''), null, null, null, null, null, null, null,
			new PlannedDateToken(null, false, null, '', ''), null, null, new ActualDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''), null, null, new ActualDateToken(null, false, null, '', ''), null,
			new PlannedDateToken(null, false, null, '', ''), null, null, new ActualDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''), null, null, new ActualDateToken(null, false, null, '', ''), null,
			new PlannedDateToken(null, false, null, '', ''), null, null, new ActualDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''), null, null, new ActualDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''), null, null, new ActualDateToken(null, false, null, '', ''),
			FunctionStatus.WAITING_FOR_PREV);

		storeObj = new StoreIP(
			new PlannedDateToken(null, false, null, '', ''),
			null, new ActualDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''),
			new RequestDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''),
			new GenFileUploads([]), new GenFileUploads([]),
			FunctionStatus.WAITING_FOR_PREV);


		productionObj = new ProductionIP(new ActualDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''),
			new RequestDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''), FunctionStatus.WAITING_FOR_PREV);
		qualityObj = new QualityIP(
			new PlannedDateToken(null, false, null, '', ''), new RequestDateToken(null, false, null, '', ''), new ActualDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''), new RequestDateToken(null, false, null, '', ''), new ActualDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''), new RequestDateToken(null, false, null, '', ''), new ActualDateToken(null, false, null, '', ''),
			new GenFileUploads([]), new GenFileUploads([]), null, null, FunctionStatus.WAITING_FOR_PREV);
		logisticObj = new LogisticIP(new PlannedDateToken(null, false, null, '', '')
			, new RequestDateToken(null, false, null, '', ''), [
			new PartialDelivery(0, new ActualDateToken(null, false, null, '', ''), null)
		], null, null,
			new GenFileUploads([]), new GenFileUploads([]),
			new GenFileUploads([]), new GenFileUploads([]), new GenFileUploads([]),
			new GenFileUploads([]), new GenFileUploads([]),
			FunctionStatus.WAITING_FOR_PREV);

		let changeData: ChangeNoteDef = new ChangeNoteDef(null, '', '', '', '', '', null, '', '', '', null, '', null, new GenFileUploads([]),
			"", "", "", false, "", "", "", null, "", "", false, "", "", true);

		let changeDataList: Array<ChangeNoteDef> = [];
		changeDataList.push(changeData);

		changeNoteObj = new ChangeNoteIP(changeDataList, FunctionStatus.WAITING_FOR_PREV)

		dataSheetSubOrderObj = null;

		subSaleOrderObj = new SubSalesOrder(this.subOrderNoId, pmTechSubSalesOrderObj, enggDrawObj,
			scmObj, enggProcureObj, purchasePOObj, planningObj, purchaseMatRecptObj,
			storeObj, productionObj, qualityObj, logisticObj, changeNoteObj, dataSheetSubOrderObj, SSOStatus.PM_Tech);
		return subSaleOrderObj;
	}
	public static getObj(_json: any): SubSalesOrder {
		return new SubSalesOrder(_json.subOrdNoId,
			PmTechnicalIP.getObj(_json.techSubSalesOrd), EnggDrawIP.getObj(_json.engDrawIP),
			ScmIP.getObj(_json.scmIP), EnggProcureIP.getObj(_json.engProcureIP),
			PurchasePOIP.getObj(_json.purchasePOIP), PlanningIP.getObj(_json.planIP),
			PurchaseMaterialReceiptIP.getObj(_json.purchaseMatReceipt), StoreIP.getObj(_json.storeIP),
			ProductionIP.getObj(_json.prodIP), QualityIP.getObj(_json.qualIP),
			LogisticIP.getObj(_json.logisticIP),
			_json.changeNoteIP ? ChangeNoteIP.getObj(_json.changeNoteIP) : ChangeNoteIP.emptyObj(),
			_json.dataSheetSubOrderIP ? DataSheetSubOrderIP.getObj(_json.dataSheetSubOrderIP) : DataSheetSubOrderIP.emptyObj(),
			_json.subOrderStatus);
	}
	public getJson(): any {
		let _json: any = {};
		_json.subOrdNoId = this.subOrderNoId;
		_json.techSubSalesOrd = this._pmTechSubSalesOrder.getJson();
		_json.engDrawIP = this._enggDrawIP.getJson();
		_json.scmIP = this._scmIP.getJson();
		_json.engProcureIP = this._enggProcureIP.getJson();
		_json.purchasePOIP = this._purchasePOIP.getJson();
		_json.planIP = this._planningIP.getJson();
		_json.purchaseMatReceipt = this._purchaseMatReceipt.getJson();
		_json.storeIP = this._storeIP.getJson();
		_json.prodIP = this._productionIP.getJson();
		_json.qualIP = this._qualityIP.getJson();
		_json.logisticIP = this._logisticIP.getJson();
		_json.changeNoteIP = this._changeNoteIP.getJson();
		_json.dataSheetSubOrderIP = this._dataSheetSubOrderIP ? this._dataSheetSubOrderIP.getJson() : null;
		_json.subOrderStatus = this.subOrderStatus;
		return _json;
	}
}

export class PmTechnicalIP {
	constructor(private _productVarient: string, private _contractUploads: GenFileUploads, private _boardname: string, private _jsrMatCost: string, private _jsrGm: string,
		private _projStatus: string, private _delayreason, private _jsrNm: string, private _jsrMatCostPercent: string, private _jsrGmPercent: string, private _jsrNmPercent: string,
		private _numberOfPanels: string, private _jobComplexity: string, private _FeederOrLocationTypeNo: string, private _plannedSldSubmissionToken: PlannedDateToken,
		private _plannedGaDrawingSubmissionToken: PlannedDateToken, private _plannedSchematicDrawingToken: PlannedDateToken, private _plannedSizingCalSubmissionToken: PlannedDateToken,
		private _DaysgoodsReach: number, private _tentativeDeliveryToken: PlannedDateToken, private _invoicingmonth: Date, private _plannedRevnueMonth: Date,
		private _rotddate: Date,
		private _rotddateToken: PlannedDateToken,
		private _totalcontval: string, private _totalpanelquant: string, private _sumbreakerquant: string, private _sumvscquant: string, private _contractualvaluesum: string,
		private _panelQuantSum: string, private _insulationLevel: string, private _equipmentList: Array<Equipment>, private _kioskApplicable: string,
		private _tempRaiseTestApplicability: string, private _breakerApplicability: string, private _vscApplicability: string, private _spareApplicability: string,
		private _etApplicability: string, private _geRelayApplicability: string, private _busbarMaterial: string, private _busbarSleeve: string,
		private _commentsDateList: Array<CommentsOnSubmission>, private _plannedDrawingApprovalToken: PlannedDateToken, private _actualDrawingApprovalToken: ActualDateToken,
		private _drawingUploads: GenFileUploads, private _actDrawApprovalComment: string, private _plannedCtFinalizationToken: PlannedDateToken,
		private _actualCtFinalizationToken: ActualDateToken, private _splMatPriceFinalizationPlannedDateToken: PlannedDateToken, private _splMatPriceFinalizationActualDateToken: ActualDateToken,
		private _inspectionCallDate: Date, private _inspCallDtls: string, private _plannedPackingDisptachClearanceToken: PlannedDateToken, private _requestPackingToken: RequestDateToken,
		private _actualPackingToken: ActualDateToken, private _plannedContractualDeliveryToken: PlannedDateToken, private _status: FunctionStatus
		// TEST FOR COMMENTS
		, private _commentsPR) {
	}

	private _parentSORef: SalesOrder;
	private _parentSubSORef: SubSalesOrder;

	public refreshStatus() {
		if (this.parentSORef && this.parentSubSORef && this.parentSORef.projectStatus >= SOStatus.Sub_Orders) {
			if ((this.parentSubSORef.isSSOStatusSet(SSOStatus.PM_Tech) == true)
				//&& this._status != FunctionStatus.WAITING_FOR_PREV
			) {
				if (this.parentSubSORef.isSSOStatusSet(SSOStatus.Engg_Draw) == false) {
					this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
				}
				if (this.parentSubSORef.isSSOStatusSet(SSOStatus.Engg_Draw) == true &&
					this.parentSubSORef.isSSOStatusSet(SSOStatus.SCM) == false) {//if submitted to drawing but not able to get "CT Finalization given by Engg to PM Actual Date" not set
					if (configDefs.isDtEmty(this.parentSubSORef.enggDrawIP.ctFinalizationGivenByEnggToPMActualDate)) {
						this._status = FunctionStatus.SUBMITTED_WAITING_RESPONSE;
					}
					else {
						this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
					}
				}

				if (this.parentSubSORef.isSSOStatusSet(SSOStatus.SCM) == true) {
					let _isTempComplete: boolean = this.isFunctionComplete();

					if (_isTempComplete == true) {
						this._status = FunctionStatus.SUBMITTED_COMPLETE;
					}
					else {
						this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
					}
				}
				// New
				if (this.parentSubSORef.isSSOStatusSet(SSOStatus.Engg_Procurement_From_PM_Tech) == true &&
					this.parentSubSORef.isSSOStatusSet(SSOStatus.Logistic_From_PM_Tech) == true) {
					let _isTempComplete: boolean = this.isFunctionComplete();

					if (_isTempComplete == true) {
						this._status = FunctionStatus.SUBMITTED_COMPLETE;
					}
					else {
						this._status = FunctionStatus.SUBMITTED_INCOMPLETE;
					}
				}
				// New end
			}

		}
		else {
			this._status = FunctionStatus.WAITING_FOR_PREV;
		}
	}
	private isFunctionComplete(): boolean {

		if (configDefs.isStrEmty(this.jsrMatCost)) return false;
		if (configDefs.isStrEmty(this.jsrGm)) return false;
		if (configDefs.isStrEmty(this.jsrNm)) return false;
		if (configDefs.isStrEmty(this.jsrGmPercent)) return false;
		if (configDefs.isStrEmty(this.jsrNmPercent)) return false;
		if (configDefs.isStrEmty(this.productVarient)) return false;
		if (configDefs.isStrEmty(this.numberOfPanels)) return false;
		if (configDefs.isStrEmty(this.jobComplexity)) return false;
		if (configDefs.isStrEmty(this.FeederOrLocationTypeNo)) return false;
		if (configDefs.isDtEmty(this.plannedSldSubmissionDate)) return false;
		if (configDefs.isDtEmty(this.plannedGaDrawingSubmissionDate)) return false;
		if (configDefs.isDtEmty(this.plannedSchematicDrawingDate)) return false;
		if (configDefs.isDtEmty(this.plannedSizingCalSubmissionDate)) return false;
		if (configDefs.isNumEmty(this.DaysgoodsReach)) return false;
		if (configDefs.isDtEmty(this.tentativeDeliveryDate)) return false;
		if (configDefs.isDtEmty(this.invoicingmonth)) return false;
		if (configDefs.isDtEmty(this.plannedRevnueMonth)) return false;
		if (configDefs.isDtEmty(this.rotddate)) return false;
		if (configDefs.isStrEmty(this.totalcontval)) return false;
		if (configDefs.isStrEmty(this.totalpanelquant)) return false;
		if (configDefs.isStrEmty(this.sumbreakerquant)) return false;
		if (configDefs.isStrEmty(this._sumvscquant)) return false;

		if (configDefs.isStrEmty(this.insulationLevel)) return false;
		//type of equip

		if (this.equipmentList && this.equipmentList.length > 0) {
			for (var i = 0; i < this.equipmentList.length; i++) {
				if (this.equipmentList[i].isFunctionComplete == false) {
					return false;
				}
			}
		}

		if (configDefs.isStrEmty(this.kioskApplicable)) return false;
		if (configDefs.isStrEmty(this.tempRaiseTestApplicability)) return false;
		if (configDefs.isStrEmty(this.breakerApplicability)) return false;
		if (configDefs.isStrEmty(this.vscApplicability)) return false;
		if (configDefs.isStrEmty(this.spareApplicability)) return false;
		if (configDefs.isStrEmty(this.etApplicability)) return false;
		if (configDefs.isStrEmty(this.geRelayApplicability)) return false;
		if (configDefs.isStrEmty(this.busbarMaterial)) return false;
		if (configDefs.isStrEmty(this.busbarSleeve)) return false;

		if (this.commentsDateList.length > 0) {
			for (var i = 0; i < this.commentsDateList.length; i++) {
				// if(configDefs.isDtEmty(this.commentsDateList[i].commentRcvdOnSubActDate)) return false
				// if(configDefs.isDtEmty(this.commentsDateList[i].complainceAgnstCommentActDate)) return false

				if (this.commentsDateList[i].isfunctionComplete == false) {
					return false;
				}
			}
		}
		// if (configDefs.isDtEmty(this.plannedDrawingApprovalDate)) return false;
		if (configDefs.isDtEmty(this.actualDrawingApprovalDate)) return false;
		if (this.isSplMatPriceDatesEnabled == true) {
			if (configDefs.isDtEmty(this.splMatFinalizationActualDate)) return false;
		}
		if (this.isCTActualDateAvailableInEnggDraw) {
			if (configDefs.isDtEmty(this.actualCtFinalizationDate)) return false;
			// if (configDefs.isDtEmty(this.plannedCtFinalizationDate)) return false;
		};
		if (configDefs.isDtEmty(this.actualPackingDate)) return false;

		return true;
	}
	get isInputEnabled(): boolean {
		return this.parentSubSORef.isSSOStatusSet(SSOStatus.PM_Tech) ||
			this.parentSubSORef.isSSOStatusSet(SSOStatus.PM_Tech_EnggDraw);
	}
	get status(): FunctionStatus {
		return this._status;
	}

	// STARTS
	get fnCusDrgAprvlDate(): string {
		let _fnCusDate: Date = this.actualDrawingApprovalDate;

		if (_fnCusDate != null) {
			return formatDate(_fnCusDate, 'dd-MMM-yy', 'en-IN');
		}
		return null;
	}


	get fcmCTfinActDate(): string {
		let _fcmCTDate: Date = this.actualCtFinalizationDate;

		if (_fcmCTDate != null) {
			return formatDate(_fcmCTDate, 'dd-MMM-yy', 'en-IN');
		}
		return null;
	}

	get exWorksDate(): string {
		let _exworksDelDate: Date = this.tentativeDeliveryDate;

		if (_exworksDelDate != null) {
			return formatDate(_exworksDelDate, 'dd-MMM-yy', 'en-IN');
		}

		return null;
	}

	equiVarient(_eqpId): boolean {
		let _tempEqp = ["001", "002", "037", "003", "004", "005", "006", "007", "008", "009", "010", "011", "012", "013", "014", "015", "016", "017", "018"];

		if (_tempEqp.includes(_eqpId)) {
			return true;
		}
		else { return false; }

	}

	// For the Days Required column
	get panelTypeEngEfforts(): number {
		let _pTypeEngEfts: number = 0;
		let _pName: string;
		let _tempProdVarient: ProductVariant = configDefs.defTypeOfProducts.find(prodVarient => prodVarient.productVariantId === this.productVarient);
		if (!_tempProdVarient) {
			_pName = "-";
		}
		else _pName = _tempProdVarient.productVariantName;

		switch (_pName) {
			case "UG ZS1":
			case "UG ZS1 DBB":
				_pTypeEngEfts = 1.4;
				break;
			case "LG ZN1":
			case "LG ZS9":
				_pTypeEngEfts = 1;
				break;
			case "UG ZS2":
				_pTypeEngEfts = 1.2;
				break;
			default: _pTypeEngEfts = 0;
		}

		return _pTypeEngEfts;
	}

	get noOfPanelsEngEfforts(): number {
		let _pNosEngEfts: number = 0;
		let _panelNo: string;
		let _tempPanelNum: PanelNumDef = configDefs.defNoOfPanels.find(panelNo => panelNo.noOfPanelsId === this.numberOfPanels);
		if (!_tempPanelNum) {
			_panelNo = "-";
		}
		else _panelNo = _tempPanelNum.noOfPanelsName;
		switch (_panelNo) {
			case "0 to 10":
				_pNosEngEfts = 1;
				break;
			case "11 to 25":
				_pNosEngEfts = 1.5;
				break;
			case "26 to 50":
				_pNosEngEfts = 2;
				break;
			case "Above 50":
				_pNosEngEfts = 2.5;
				break;
			default: _pNosEngEfts = 0;
		}
		return _pNosEngEfts;
	}

	get feederTypeEngEfforts(): number {
		let _feederTyEngEfts: number = 0;
		let _fName: string;

		let _feederTyp: FeederTypeDef = configDefs.defNoOfFeederList.find(fTyp => fTyp.noOfFeederTypesId === this.FeederOrLocationTypeNo);
		if (!_feederTyp) {
			_fName = "-";
		}
		else _fName = _feederTyp.noOfFeederTypeName;
		switch (_fName) {
			case "0 to 5":
				_feederTyEngEfts = 1;
				break;
			case "6 to 10":
				_feederTyEngEfts = 1.5;
				break;
			case "Above 10":
				_feederTyEngEfts = 2;
				break;
			default: _feederTyEngEfts = 0;
		}

		return _feederTyEngEfts;
	}

	get complexityTypeEngEfforts(): number {
		let _complxTyEngEfts: number = 0;
		let _cName: string;

		let _complxTyp: JobComplexityDef = configDefs.defComplexityOfJobs.find(cTyp => cTyp.complexityOfJobsId === this.jobComplexity);
		if (!_complxTyp) {
			_cName = "-";
		}
		else _cName = _complxTyp.complexityOfJobsName;
		switch (_cName) {
			case "Low":
				_complxTyEngEfts = 1;
				break;
			case "Medium":
				_complxTyEngEfts = 1.5;
				break;
			case "High":
				_complxTyEngEfts = 2;
				break;
			default: _complxTyEngEfts = 0;
		}

		return _complxTyEngEfts;
	}

	get effectiveScoreDR(): number {
		let _panelT = this.panelTypeEngEfforts;
		let _panelN = this.noOfPanelsEngEfforts;
		let _panelF = this.feederTypeEngEfforts;
		let _panelC = this.complexityTypeEngEfforts;

		return (_panelT * _panelN * _panelF * _panelC);

	}
	get subSldDaysDR(): number {
		let _selection = 1;
		let _sldCalc = (this.panelTypeEngEfforts * this.complexityTypeEngEfforts) + this.noOfPanelsEngEfforts + this.feederTypeEngEfforts;
		return Math.ceil(_sldCalc);
	}

	get subGaDrDaysDR(): number {
		let _selection = 2;
		let _subGDrCalc = this.subSldDaysDR + _selection;
		return Math.ceil(_subGDrCalc);
	}

	get subSchDrBomDaysDR(): number {
		let _selection = 5;
		let _subSchDrCalc = (this.effectiveScoreDR + _selection) + this.subSldDaysDR;
		return Math.ceil(_subSchDrCalc);
	}

	get subGtpCtPtDaysDR(): number {
		let _selection = 3;
		let _subSchDrCalc = this.subSchDrBomDaysDR + _selection;
		return Math.ceil(_subSchDrCalc);
	}

	get productLeadTimeDR(): Array<number> {
		let _sbSldDays = this.subSldDaysDR;
		let _sbGDDays = this.subGaDrDaysDR - this.subSldDaysDR;
		let _sbSchDBDays = this.subSchDrBomDaysDR - this.subGaDrDaysDR;
		let _sbGCPDays = this.subGtpCtPtDaysDR - this.subSchDrBomDaysDR;

		return [3, _sbSldDays, _sbGDDays, _sbSchDBDays, 3, 2, 0, 5, 2, 1, 4, 1, 7, 1, 0, 0, 37, 0, 3, 5, 3, 1, 3]

	}

	get cursorIndex(): number {
		let _cursorIdx;

		let _temp = [this._parentSORef.marketingIP.homDate,
		this.parentSubSORef.enggDrawIP.sldgtpSubDate,
		this.parentSubSORef.enggDrawIP.gacsSubDate,
		this.parentSubSORef.enggDrawIP.schemeSubDate,
		this.parentSubSORef.enggDrawIP.mgaSubDate,
		this.parentSubSORef.enggDrawIP.sldGaGtpAprvlDate,
		this.parentSubSORef.enggProcureIP.longleadRDate,
		this.fnCusDrgAprvlDate,
		this.parentSubSORef.enggDrawIP.techCTDetsDate,
		this.fcmCTfinActDate,
		this.parentSubSORef.scmIP.CTfinSCMActDate,
		this.parentSubSORef.enggProcureIP.c40ActDate,
		this.parentSubSORef.enggProcureIP.c50ActDate,
		this.parentSubSORef.enggProcureIP.c60ActDate,
		this.parentSubSORef.purchaseMatReceipt.relayRecpDate,
		// this.parentSubSORef.purchaseMatReceipt.ctRecpDate,		
		this.parentSubSORef.purchaseMatReceipt.ctPTActualReceiptDate,
		this.parentSubSORef.purchaseMatReceipt.mbRecpDate,
		this.parentSubSORef.purchaseMatReceipt.cbRecpDate,
		// this.parentSubSORef.productionIP.lineLoadActDate,
		this.parentSubSORef.productionIP.lineLoadingActualDate,
		this.parentSubSORef.productionIP.mechStickerDate,
		this.parentSubSORef.qualityIP.elecMechTestingDate,
		this.parentSubSORef.qualityIP.FATDate,
		this.parentSubSORef.qualityIP.greenStickerDate,
			// this.exWorksDate -- Not to be considered in the critical path
		];

		let _index = _temp.length;
		while (_index-- && !_temp[_index]); // Index of last non null data in array
		_cursorIdx = _index + 1 // Because zero index
		if (_index == 14 && this.parentSubSORef.purchaseMatReceipt.ctRecpApplicablity == false) {
			if (this.parentSubSORef.purchaseMatReceipt.mbRecpDateStatus == "NA") {
				_cursorIdx = _index + 3; // If the CT Recpt is not applicable && MB Recpt is not there then the cursor should not be in CT Recpt cell && in MB cell
			}
			else {
				_cursorIdx = _index + 2; // If the CT Recpt is not applicable then the cursor should not be in CT Recpt cell
			}
		}
		if (_index == 15 && this.parentSubSORef.purchaseMatReceipt.mbRecpDateStatus == "NA") {
			_cursorIdx = _index + 2; // If the MB Recpt is not there then the cursor should not be in MB Recpt cell
		}
		return _cursorIdx;
	}

	get productLeadTimeDays(): number {
		let _tempIdx;
		let _idx = this.cursorIndex;
		let _arr = this.productLeadTimeDR;
		_tempIdx = _idx;

		let _newArr = _arr.slice(_tempIdx);
		let _sum = _newArr.reduce(function (a, b) {
			return a + b;
		}, 0);


		return _sum
	}

	get daysReqPR(): string { // Made string for filter

		let _exWrks = this.exWorksDate;
		let _leadDays = this.productLeadTimeDays;
		let _tempexWrksDate;
		let _daysDiff;
		if (_exWrks != null) {
			_tempexWrksDate = new Date(_exWrks); // check for exworks date else return zero

			let _today = new Date();
			let _estimateDispatchDate = new Date(_today);
			_estimateDispatchDate.setHours(0, 0, 0, 0); // to convert the exact time to 0000 hours because today takes current time as well 
			_estimateDispatchDate.setDate(_today.getDate() + _leadDays);

			let _daysDiff_time = _tempexWrksDate.getTime() - _estimateDispatchDate.getTime();
			_daysDiff = _daysDiff_time / (1000 * 3600 * 24);
			return _daysDiff + "";
		}
		else return "-";
	}

	// TEST FOR COMMENTS

	get commentsPR(): string {
		return this._commentsPR
	}

	set commentsPR(_SetVal: string) {
		this._commentsPR = _SetVal;
	}

	// ENDS


	enableFormInput(): void {
		if (this.parentSubSORef.isSSOStatusSet(SSOStatus.PM_Tech) == true
			&& this.parentSubSORef.isSSOStatusSet(SSOStatus.PM_Tech_EnggDraw) == true) {
			if (this._status == FunctionStatus.WAITING_FOR_PREV || this._status == FunctionStatus.SUBMITTED_WAITING_RESPONSE) {
				this._status = FunctionStatus.WAITING_FOR_USER_INPUT;
			}
		}
		else {
			if (this._status == FunctionStatus.WAITING_FOR_PREV) {
				this._status = FunctionStatus.SUBMITTED_WAITING_RESPONSE;
			}
		}
	}
	get parentSORef(): SalesOrder {
		return this._parentSORef;
	}
	set parentSORef(SORef: SalesOrder) {
		this._parentSORef = SORef;
		//this.refreshStatus();
	}
	get parentSubSORef(): SubSalesOrder {
		return this._parentSubSORef;
	}
	set parentSubSORef(SubSORef: SubSalesOrder) {
		this._parentSubSORef = SubSORef;
	}
	get contractUploads(): GenFileUploads {
		return this._contractUploads;
	}
	set contractUploads(_SetVal: GenFileUploads) {
		this._contractUploads = _SetVal;
	}
	get drawingUploads(): GenFileUploads {
		return this._drawingUploads;
	}
	set drawingUploads(_SetVal: GenFileUploads) {
		this._drawingUploads = _SetVal;
	}
	get projStatus(): string {
		return this._projStatus
	}
	set projStatus(_SetVal: string) {
		this._projStatus = _SetVal;
	}
	get isCTFinalizationActualEnabled(): boolean {
		if (configDefs.isDtEmty(this.parentSubSORef.enggDrawIP.ctFinalizationGivenByEnggToPMActualDate) == false)
			return true;
		return false;
	}
	get isSplMatPriceDatesEnabled(): boolean {
		if (this.parentSubSORef.enggDrawIP.isSplMatPapplicable &&
			(configDefs.isDtEmty(this.parentSubSORef.enggDrawIP.splMatActualDate) == false)
		) {
			return true;
		}
		return false;
	}
	get isSpecailPricesActualEnabled(): boolean {
		if (this.isSplMatPriceDatesEnabled && (configDefs.isDtEmty(this.splMatFinalizationActualDate) == false)) {
			return true;
		}
		return false;
	}
	get subOrderNo(): string {
		return this.parentSubSORef.subOrderNoId;
	}
	set subOrderNo(_SetVal: string) {
		this.parentSubSORef.subOrderNoId = _SetVal;
	}
	get contractualValue(): number {
		var _retVal: number = 0;
		if (this._equipmentList && this._equipmentList.length > 0) {
			this._equipmentList.forEach((_equipment: Equipment) => {
				if (_equipment && _equipment.contractualValue) {
					var _tmpValue: number = parseFloat(_equipment.contractualValue);
					if (_tmpValue > 0) {
						_retVal += _tmpValue;
					}
				}
			});
		}
		return _retVal;
	}
	get totalBreakerQuantity(): number {
		var _reyVal: number = 0;
		if (this._equipmentList && this._equipmentList.length > 0) {
			this._equipmentList.forEach((_equipment: Equipment) => {
				if (_equipment && _equipment.totalBreakerQuantity) {
					var _tmpVal: number = _equipment.totalBreakerQuantity;
					if (_tmpVal > 0) {
						_reyVal += _tmpVal
					}
				}
			})
		}
		return _reyVal;
	}


	get boardname(): string {
		return this._boardname;
	}
	set boardname(_SetVal: string) {
		this._boardname = _SetVal;
	}

	get totalcontval(): string {
		return this._totalcontval;
	}
	set totalcontval(_setVal: string) {
		this._totalcontval = _setVal;
	}

	get totalpanelquant(): string {
		return this._totalpanelquant;
	}

	set totalpanelquant(_setVal: string) {

		this._totalpanelquant = _setVal;

	}
	get sumbreakerquant(): string {
		let _brekerQty: number = 0;
		this.equipmentList.forEach((_equip: Equipment) => {
			_brekerQty += _equip.totalBreakerQuantity;
		})
		this._sumbreakerquant = _brekerQty.toString();
		return this._sumbreakerquant;
	}
	set sumbreakerquant(_setVal: string) {
		this._sumbreakerquant = _setVal;
	}

	get sumvscquant(): string {
		let _vscQty: number = 0;

		this.equipmentList.forEach((_equip: Equipment) => {
			_vscQty += parseFloat(_equip.vscQuantity);
			//console.log("checking again",_vscQty);
		})

		this._sumvscquant = _vscQty.toString();
		return this._sumvscquant;
	}
	set sumvscquant(_setVal: string) {
		this._sumvscquant = _setVal;
	}

	get contractualvaluesum(): string {
		let _contVal: number = 0;
		this.equipmentList.forEach((_equip: Equipment) => {
			if (isNaN(parseFloat(_equip.contractualValue))) {
				_equip.contractualValue = "0"
			}
			_contVal += parseFloat(_equip.contractualValue);
		})
		this._contractualvaluesum = _contVal.toString();
		return this._contractualvaluesum;
	}

	set contractualvaluesum(_setVal: string) {
		this._contractualvaluesum = _setVal;
	}

	get panelQuantSum(): string {
		let _panelQuant: number = 0;
		this.equipmentList.forEach((_equip: Equipment) => {
			if (isNaN(parseFloat(_equip.panelQuantity))) {
				_equip.panelQuantity = "0";
			}
			_panelQuant += parseFloat(_equip.panelQuantity);
		})
		this._panelQuantSum = _panelQuant.toString();
		return this._panelQuantSum;
	}
	set panelQuantSum(_setVal: string) {
		this._panelQuantSum = _setVal;
	}
	get delayreason(): string {
		return this._delayreason;
	}
	set delayreason(_SetVal: string) {
		this._delayreason = _SetVal;
	}
	get jsrMatCost(): string {
		return this._jsrMatCost;
	}
	set jsrMatCost(_SetVal: string) {
		this._jsrMatCost = _SetVal;
	}
	private _jsrGmGroup: SplitNumber;
	get jsrGmGroup(): SplitNumber {
		if (this._jsrGmGroup == null ||
			this._jsrGmGroup.number1 != this.jsrGm ||
			this._jsrGmGroup.number2 != this.jsrGmPercent) {
			this._jsrGmGroup = new SplitNumber(this.jsrGm, 'MINR', this.jsrGmPercent, '%');
		}
		return this._jsrGmGroup;
	}
	private _jsrNmGroup: SplitNumber;
	get jsrNmGroup(): SplitNumber {
		if (this._jsrNmGroup == null ||
			this._jsrNmGroup.number1 != this.jsrNm ||
			this._jsrNmGroup.number2 != this.jsrNmPercent) {
			this._jsrNmGroup = new SplitNumber(this.jsrNm, 'MINR', this.jsrNmPercent, '%');
		}
		return this._jsrNmGroup;
	}
	get jsrGm(): string {
		return this._jsrGm;
	}
	set jsrGm(_SetVal: string) {
		this._jsrGm = _SetVal;
	}
	get jsrNm(): string {
		return this._jsrNm;
	}
	set jsrNm(_SetVal: string) {
		this._jsrNm = _SetVal;
	}
	get jsrMatCostPercent(): string {
		return this._jsrMatCostPercent;
	}
	set jsrMatCostPercent(_SetVal: string) {
		this._jsrMatCostPercent = _SetVal;
	}
	get jsrGmPercent(): string {
		return this._jsrGmPercent;
	}
	set jsrGmPercent(_SetVal: string) {
		this._jsrGmPercent = _SetVal;
	}
	get jsrNmPercent(): string {
		return this._jsrNmPercent;
	}
	set jsrNmPercent(_SetVal: string) {
		this._jsrNmPercent = _SetVal;
	}
	get productVarient(): string {
		return this._productVarient;
	}
	set productVarient(_SetVal: string) {
		this._productVarient = _SetVal;
	}
	get numberOfPanels(): string {
		return this._numberOfPanels;
	}
	set numberOfPanels(_SetVal: string) {
		this._numberOfPanels = _SetVal;
	}
	get jobComplexity(): string {
		return this._jobComplexity;
	}
	set jobComplexity(_SetVal: string) {
		this._jobComplexity = _SetVal;
	}
	get FeederOrLocationTypeNo(): string {
		return this._FeederOrLocationTypeNo;
	}
	set FeederOrLocationTypeNo(_SetVal: string) {
		this._FeederOrLocationTypeNo = _SetVal;
	}
	get plannedSldSubmissionToken(): PlannedDateToken {
		return this._plannedSldSubmissionToken;
	}
	set plannedSldSubmissionToken(_SetVal: PlannedDateToken) {
		// if (this._plannedSldSubmissionToken.actualPlannedDate == null)
		// 	this._plannedSldSubmissionToken.actualPlannedDate = this.plannedSldSubmissionDate;
		this._plannedSldSubmissionToken.plannedDate = _SetVal.plannedDate;
		this._plannedSldSubmissionToken.isOveridden = _SetVal.isOveridden;
		this._plannedSldSubmissionToken.addNotes = _SetVal.addNotes;
		this._plannedSldSubmissionToken.userOveridden = _SetVal.userOveridden;
	}
	get plannedSldSubmissionDateLabel(): string {
		// console.log(this.plannedSldSubmissionDateIsRevised, this.D12);
		if (this.plannedSldSubmissionDateIsRevised == true && this.D12 != null) {
			return "SLD Submission Revised (Planned)";
		}
		else {
			return 'SLD Submission Planned';
		}
	}
	get plannedSldSubmissionDateIsRevised(): boolean {
		if (this.plannedSldSubmissionDate_Initial && this.plannedSldSubmissionDate) {
			if (GenService.areDatesSame(this.plannedSldSubmissionDate_Initial, this.plannedSldSubmissionDate) == false) {
				return true;
			}
		}
		return false;
	}
	private _plannedSldSubmissionGroup: RevisedDate;

	get plannedSldSubmissionGroup(): RevisedDate {
		this._plannedSldSubmissionGroup = new RevisedDate(this.plannedSldSubmissionDate_Initial, this.plannedSldSubmissionDateIsRevised, this.plannedSldSubmissionDate);

		return this._plannedSldSubmissionGroup;
	}

	get plannedSldSubmissionDate_Initial(): Date {
		if (this._plannedSldSubmissionToken.actualPlannedDate == null || this._plannedSldSubmissionToken.isOveridden == false) {
			var _tmpDate = this.parentSORef.marketingIP.plannedOverHandingDate;

			var _daysRequired = this.D12;
			if (_tmpDate != null && _daysRequired != null) {
				this._plannedSldSubmissionToken.actualPlannedDate = configDefs.addWorkingDays(_tmpDate, _daysRequired);
			}
			else {
				this._plannedSldSubmissionToken.actualPlannedDate = null;
			}
		}
		return this._plannedSldSubmissionToken.actualPlannedDate;
	}
	get plannedSldSubmissionDate(): Date {
		if (this._plannedSldSubmissionToken.plannedDate == null || this._plannedSldSubmissionToken.isOveridden == false) {
			var _tmpDate = this.parentSORef.marketingIP.actualHandingOverDate;
			if (_tmpDate == null) {
				_tmpDate = this.parentSORef.marketingIP.plannedOverHandingDate;
			}
			var _daysRequired = this.D12;
			if (_tmpDate != null && _daysRequired != null) {
				this._plannedSldSubmissionToken.plannedDate = configDefs.addWorkingDays(_tmpDate, _daysRequired);
			}
			else {
				this._plannedSldSubmissionToken.plannedDate = null;
			}
		}
		return this._plannedSldSubmissionToken.plannedDate;
	}
	//logic to avoid calculating same thing multiple times
	private _prevD12productVarient: string;
	private _prevD12numberOfPanels: string;
	private _prevD12jobComplexity: string;
	private _prevD12FeederOrLocationTypeNo: string;
	private _prevD12Calc: number;
	private _jobPriority: string = '2';
	private get D12(): number {//D12 is named from req sheet, Time for Submission of SLD in days
		if (this.productVarient != this._prevD12productVarient || this.numberOfPanels != this._prevD12numberOfPanels ||
			this._jobComplexity != this._prevD12jobComplexity || this.FeederOrLocationTypeNo != this._prevD12FeederOrLocationTypeNo) {
			this._prevD12productVarient = this.productVarient;
			this._prevD12numberOfPanels = this.numberOfPanels;
			this._prevD12jobComplexity = this._jobComplexity;
			this._prevD12FeederOrLocationTypeNo = this.FeederOrLocationTypeNo;
			this._prevD12Calc = configDefs.getTimeForSLDSubmission(this.productVarient, this.numberOfPanels, this._jobComplexity, this._jobPriority, this.FeederOrLocationTypeNo);
		}
		return this._prevD12Calc;
	}
	private _prevD14productVarient: string;
	private _prevD14numberOfPanels: string;
	private _prevD14jobComplexity: string;
	private _prevD14FeederOrLocationTypeNo: string;
	private _prevD14Calc: number;
	private get D14(): number {//D14 is named from req sheet, Time for Submission of Schematic Drawing & BOM in days
		if (this.productVarient != this._prevD14productVarient || this.numberOfPanels != this._prevD14numberOfPanels ||
			this._jobComplexity != this._prevD14jobComplexity || this.FeederOrLocationTypeNo != this._prevD14FeederOrLocationTypeNo) {
			this._prevD14productVarient = this.productVarient;
			this._prevD14numberOfPanels = this.numberOfPanels;
			this._prevD14jobComplexity = this._jobComplexity;
			this._prevD14FeederOrLocationTypeNo = this.FeederOrLocationTypeNo;
			this._prevD14Calc = configDefs.getTimeForSchDrwBOMSubmission(this.productVarient, this.numberOfPanels, this._jobComplexity, this._jobPriority, this.FeederOrLocationTypeNo);
		}
		return this._prevD14Calc;
	}
	set plannedSldSubmissionDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set plannedSldSubmissionDate directly");
		this._plannedSldSubmissionToken.plannedDate = _SetVal;
	}
	get plannedGaDrawingSubmissionToken(): PlannedDateToken {
		return this._plannedGaDrawingSubmissionToken;
	}
	set plannedGaDrawingSubmissionToken(_SetVal: PlannedDateToken) {
		if (this._plannedGaDrawingSubmissionToken.actualPlannedDate == null)
			this._plannedGaDrawingSubmissionToken.actualPlannedDate = this.plannedGaDrawingSubmissionDate;
		this._plannedGaDrawingSubmissionToken.plannedDate = _SetVal.plannedDate;
		this._plannedGaDrawingSubmissionToken.isOveridden = _SetVal.isOveridden;
		this._plannedGaDrawingSubmissionToken.addNotes = _SetVal.addNotes;
		this._plannedGaDrawingSubmissionToken.userOveridden = _SetVal.userOveridden;
	}
	get plannedGaDrawingSubmissionDateLabel(): string {
		if (this.plannedGaDrawingSubmissionDateIsRevised == true && this.D12 != null) {
			return 'GAF Drawing Submission Revised (Planned)';
		}
		else {
			return 'GAF Drawing Submission Planned';
		}
	}
	get plannedGaDrawingSubmissionDateIsRevised(): boolean {
		if (this.plannedGaDrawingSubmissionDate_Initial && this.plannedGaDrawingSubmissionDate) {
			if (GenService.areDatesSame(this.plannedGaDrawingSubmissionDate_Initial, this.plannedGaDrawingSubmissionDate) == false) {
				return true;
			}
		}
		return false;
	}
	get plannedGaDrawingSubmissionDate_Initial(): Date {
		if (this._plannedGaDrawingSubmissionToken.actualPlannedDate == null || this._plannedGaDrawingSubmissionToken.isOveridden == false) {
			var _tmpDate = this.parentSORef.marketingIP.plannedOverHandingDate;

			var _daysRequired = configDefs.getTimeForGAFDrwSubmission(this.D12);
			if (_tmpDate != null && _daysRequired) {
				this._plannedGaDrawingSubmissionToken.actualPlannedDate = configDefs.addWorkingDays(_tmpDate, _daysRequired);
			}
			else {
				this._plannedGaDrawingSubmissionToken.actualPlannedDate = null;
			}
		}
		return this._plannedGaDrawingSubmissionToken.actualPlannedDate;
	}
	get plannedGaDrawingSubmissionDate(): Date {
		if (this._plannedGaDrawingSubmissionToken.plannedDate == null || this._plannedGaDrawingSubmissionToken.isOveridden == false) {
			var _tmpDate = this.parentSORef.marketingIP.actualHandingOverDate;
			if (_tmpDate == null) {
				_tmpDate = this.parentSORef.marketingIP.plannedOverHandingDate;
			}

			var _daysRequired = configDefs.getTimeForGAFDrwSubmission(this.D12);
			if (_tmpDate != null && _daysRequired != null) {
				this._plannedGaDrawingSubmissionToken.plannedDate = configDefs.addWorkingDays(_tmpDate, _daysRequired);
			}
			else {
				this._plannedGaDrawingSubmissionToken.plannedDate = null;
			}
		}
		return this._plannedGaDrawingSubmissionToken.plannedDate;
	}
	private _plannedGaDrawingSubmissionGroup: RevisedDate;
	get plannedGaDrawingSubmissionGroup(): RevisedDate {
		this._plannedGaDrawingSubmissionGroup = new RevisedDate(this.plannedGaDrawingSubmissionDate_Initial, this.plannedGaDrawingSubmissionDateIsRevised, this.plannedGaDrawingSubmissionDate);

		return this._plannedGaDrawingSubmissionGroup;
	}

	set plannedGaDrawingSubmissionDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set plannedGaDrawingSubmissionDate directly");
		this._plannedGaDrawingSubmissionToken.plannedDate = _SetVal;
	}
	get plannedSchematicDrawingToken(): PlannedDateToken {
		return this._plannedSchematicDrawingToken;
	}
	set plannedSchematicDrawingToken(_SetVal: PlannedDateToken) {
		// if (this._plannedSchematicDrawingToken.actualPlannedDate == null)
		// 	this._plannedSchematicDrawingToken.actualPlannedDate = this.plannedSchematicDrawingDate;
		this._plannedSchematicDrawingToken.plannedDate = _SetVal.plannedDate;
		this._plannedSchematicDrawingToken.isOveridden = _SetVal.isOveridden;
		this._plannedSchematicDrawingToken.addNotes = _SetVal.addNotes;
		this._plannedSchematicDrawingToken.userOveridden = _SetVal.userOveridden;
	}
	get plannedSchematicDrawingDateLabel(): string {
		if (this.plannedSchematicDrawingDateIsRevised == true && this.D14 != null) {
			return 'Sch Drawing & BOM Submission Revised (Planned)';
		}
		else {
			return 'Sch Drawing & BOM Submission Planned';
		}
	}
	get plannedSchematicDrawingDateIsRevised(): boolean {
		// return this.parentSORef.marketingIP.actualHandingOverDate != null;
		if (this.plannedSchematicDrawingDate_Initial && this.plannedSchematicDrawingDate) {
			if (GenService.areDatesSame(this.plannedSchematicDrawingDate_Initial, this.plannedSchematicDrawingDate) == false) {
				return true;
			}
		}
		return false;
	}
	get plannedSchematicDrawingDate_Initial(): Date {
		if (this._plannedSchematicDrawingToken.actualPlannedDate == null || this._plannedSchematicDrawingToken.isOveridden == false) {
			var _tmpDate = this.parentSORef.marketingIP.plannedOverHandingDate;
			var _daysRequired = this.D14;
			if (_tmpDate != null && _daysRequired != null) {
				this._plannedSchematicDrawingToken.actualPlannedDate = configDefs.addWorkingDays(_tmpDate, _daysRequired);
			}
			else {
				this._plannedSchematicDrawingToken.actualPlannedDate = null;
			}
		}
		return this._plannedSchematicDrawingToken.actualPlannedDate;
	}
	get plannedSchematicDrawingDate(): Date {
		if (this._plannedSchematicDrawingToken.plannedDate == null || this._plannedSchematicDrawingToken.isOveridden == false) {
			var _tmpDate = this.parentSORef.marketingIP.actualHandingOverDate;;
			if (_tmpDate == null) {
				_tmpDate = this.parentSORef.marketingIP.plannedOverHandingDate;
			}
			var _daysRequired = this.D14;
			if (_tmpDate != null && _daysRequired != null) {
				this._plannedSchematicDrawingToken.plannedDate = configDefs.addWorkingDays(_tmpDate, _daysRequired);
			}
			else {
				this._plannedSchematicDrawingToken.plannedDate = null;
			}
		}
		return this._plannedSchematicDrawingToken.plannedDate;
	}
	private _plannedSchematicDrawingGroup: RevisedDate;
	get plannedSchematicDrawingGroup(): RevisedDate {
		this._plannedSchematicDrawingGroup = new RevisedDate(this.plannedSchematicDrawingDate_Initial, this.plannedSchematicDrawingDateIsRevised, this.plannedSchematicDrawingDate);

		return this._plannedSchematicDrawingGroup;
	}
	set plannedSchematicDrawingDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set plannedSchematicDrawingDate directly");
		this._plannedSchematicDrawingToken.plannedDate = _SetVal;
	}
	get plannedSizingCalSubmissionToken(): PlannedDateToken {
		return this._plannedSizingCalSubmissionToken;
	}
	set plannedSizingCalSubmissionToken(_SetVal: PlannedDateToken) {
		if (this._plannedSizingCalSubmissionToken.actualPlannedDate == null)
			this._plannedSizingCalSubmissionToken.actualPlannedDate = this.plannedSizingCalSubmissionDate;
		this._plannedSizingCalSubmissionToken.plannedDate = _SetVal.plannedDate;
		this._plannedSizingCalSubmissionToken.isOveridden = _SetVal.isOveridden;
		this._plannedSizingCalSubmissionToken.addNotes = _SetVal.addNotes;
		this._plannedSizingCalSubmissionToken.userOveridden = _SetVal.userOveridden;
	}
	get plannedSizingCalSubmissionDateLabel(): string {
		if (this.plannedSizingCalSubmissionDateIsRevised == true && this.D14 != null) {
			return "GTP,CT,PT Busbar Sizing Calculation Submission Revised (Planned)";
		}
		else {
			return "GTP,CT,PT Busbar Sizing Calculation Submission Planned";
		}
	}
	get plannedSizingCalSubmissionDateIsRevised(): boolean {
		// return this.parentSORef.marketingIP.actualHandingOverDate != null;
		if (this.plannedSizingCalSubmissionDate_Initial && this.plannedSizingCalSubmissionDate) {
			if (GenService.areDatesSame(this.plannedSizingCalSubmissionDate_Initial, this.plannedSizingCalSubmissionDate) == false) {
				return true;
			}
		}
		return false;
	}
	get plannedSizingCalSubmissionDate_Initial(): Date {
		if (this._plannedSizingCalSubmissionToken.actualPlannedDate == null || this._plannedSizingCalSubmissionToken.isOveridden == false) {
			var _tmpDate = this.parentSORef.marketingIP.plannedOverHandingDate;

			var _daysRequired = configDefs.getTimeForGTPCTPTBBSizingSubmission(this.D14);//ROUNDUP(D12+C13)
			if (_tmpDate != null && _daysRequired) {
				this._plannedSizingCalSubmissionToken.actualPlannedDate = configDefs.addWorkingDays(_tmpDate, _daysRequired);
			}
			else {
				this._plannedSizingCalSubmissionToken.actualPlannedDate = null;
			}
		}
		return this._plannedSizingCalSubmissionToken.actualPlannedDate;
	}
	get plannedSizingCalSubmissionDate(): Date {
		if (this._plannedSizingCalSubmissionToken.plannedDate == null || this._plannedSizingCalSubmissionToken.isOveridden == false) {
			var _tmpDate = this.parentSORef.marketingIP.actualHandingOverDate;
			if (_tmpDate == null) {
				_tmpDate = this.parentSORef.marketingIP.plannedOverHandingDate
			}
			var _daysRequired = configDefs.getTimeForGTPCTPTBBSizingSubmission(this.D14);//ROUNDUP(D12+C13)
			if (_tmpDate != null && _daysRequired != null) {
				this._plannedSizingCalSubmissionToken.plannedDate = configDefs.addWorkingDays(_tmpDate, _daysRequired);
			}
			else {
				this._plannedSizingCalSubmissionToken.plannedDate = null;
			}
		}
		return this._plannedSizingCalSubmissionToken.plannedDate;
	}
	private _plannedSizingCalSubmissionGroup: RevisedDate;
	get plannedSizingCalSubmissionGroup(): RevisedDate {
		this._plannedSizingCalSubmissionGroup = new RevisedDate(this.plannedSizingCalSubmissionDate_Initial, this.plannedSizingCalSubmissionDateIsRevised, this.plannedSizingCalSubmissionDate);

		return this._plannedSizingCalSubmissionGroup;
	}
	set plannedSizingCalSubmissionDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set plannedSizingCalSubmissionDate directly");
		this._plannedSizingCalSubmissionToken.plannedDate = _SetVal;
	}
	get DaysgoodsReach(): number {
		return this._DaysgoodsReach;
	}
	set DaysgoodsReach(_SetVal: number) {
		this._DaysgoodsReach = _SetVal;
	}

	get tentativeDeliveryToken(): PlannedDateToken {
		return this._tentativeDeliveryToken;
	}
	set tentativeDeliveryToken(_SetVal: PlannedDateToken) {
		if (this._tentativeDeliveryToken.actualPlannedDate == null)
			this._tentativeDeliveryToken.actualPlannedDate = this.tentativeDeliveryDate;
		this._tentativeDeliveryToken.plannedDate = _SetVal.plannedDate;
		this._tentativeDeliveryToken.isOveridden = _SetVal.isOveridden;
		this._tentativeDeliveryToken.addNotes = _SetVal.addNotes;
		this._tentativeDeliveryToken.userOveridden = _SetVal.userOveridden;
	}
	get deliveryProjectionDate(): Date {
		var _tmpDate = new Date();
		var noOfDayToReachSite = this.DaysgoodsReach;

		if (_tmpDate != null && !configDefs.isNumEmty(noOfDayToReachSite)) {
			return configDefs.addWorkingDays(_tmpDate, noOfDayToReachSite);
		}
		return null;
	}
	get reqOrPlndDeliveryDate(): Date {
		var _tmpDate = this.parentSubSORef.logisticIP.latestPartialDeliveryToken.delDate;
		if (_tmpDate == null) {
			_tmpDate = this.parentSubSORef.logisticIP.dispatchFromPlantRequestDate;
			if (_tmpDate == null) {
				_tmpDate = this.parentSubSORef.logisticIP.dispatchFromPlantPlannedDate;
				if (_tmpDate == null) {
					_tmpDate = this.parentSubSORef.logisticIP.dispatchFromPlantPlannedDate_Initial;
				}
			}
		}
		var noOfDayToReachSite = this.DaysgoodsReach;
		if (_tmpDate != null && !configDefs.isNumEmty(noOfDayToReachSite)) {
			return configDefs.addWorkingDays(_tmpDate, noOfDayToReachSite);
		}
		return null;
	}
	get tentativeDeliveryDate(): Date {
		if (this.tentativeDeliveryToken.plannedDate == null || this._tentativeDeliveryToken.isOveridden == false) {
			var _tmpDate = this.rotddate;
			// if (this.parentSORef.marketingIP.isContractDeliveryDateFirm == true) {
			// 	_tmpDate = this.parentSORef.marketingIP.contractDeliveryDate;
			// }
			// else {
			// 	_tmpDate = this.actualContractualDeliveryDate;
			// 	// var _plndApprovalDate = this.plannedDrawingApprovalDate;
			// 	// var _noOfWeekAfterApproval = this.parentSORef.marketingIP.contractDeliveryDateInWeek;
			// 	// if (_plndApprovalDate != null && _noOfWeekAfterApproval != null) {
			// 	// 	_tmpDate = configDefs.addWorkingWeeks(_plndApprovalDate, _noOfWeekAfterApproval);
			// 	// }
			// }
			var noOfDayToReachSite = this.DaysgoodsReach;

			if (_tmpDate != null && !configDefs.isNumEmty(noOfDayToReachSite)) {
				this.tentativeDeliveryToken.plannedDate = configDefs.subtractWorkingDays(_tmpDate, noOfDayToReachSite);
			}
			else {
				this.tentativeDeliveryToken.plannedDate = null;
			}
		}

		return this.tentativeDeliveryToken.plannedDate;
	}
	set tentativeDeliveryDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set tentativeDeliveryDate directly");
		this._tentativeDeliveryToken.plannedDate = _SetVal;
	}
	get actualContractualDeliveryDate(): Date {
		var _tmpDate;
		var _drwApprovalDate = this.actualDrawingApprovalDate;
		if (_drwApprovalDate == null) {
			_drwApprovalDate = this.plannedDrawingApprovalDate;
		}

		var _noOfWeekAfterApproval = this.parentSORef.marketingIP.contractDeliveryDateInWeek;
		if (_drwApprovalDate != null && _noOfWeekAfterApproval != null) {
			_tmpDate = configDefs.addWorkingWeeks(_drwApprovalDate, _noOfWeekAfterApproval);
		}

		return _tmpDate;
	}
	get plannedContractualDeliveryToken(): PlannedDateToken {
		return this._plannedContractualDeliveryToken;
	}
	set plannedContractualDeliveryToken(_SetVal: PlannedDateToken) {
		if (this._plannedContractualDeliveryToken.actualPlannedDate == null)
			this._plannedContractualDeliveryToken.actualPlannedDate = this.plannedContractualDeliveryDate;
		this._plannedContractualDeliveryToken.plannedDate = _SetVal.plannedDate;
		this._plannedContractualDeliveryToken.isOveridden = _SetVal.isOveridden;
		this._plannedContractualDeliveryToken.addNotes = _SetVal.addNotes;
		this._plannedContractualDeliveryToken.userOveridden = _SetVal.userOveridden;
	}
	get plannedContractualDeliveryDate(): Date {
		if (this.plannedContractualDeliveryToken.plannedDate == null || this.plannedContractualDeliveryToken.isOveridden == false) {
			var _tmpDate = null;
			if (this.parentSORef.marketingIP.isContractDeliveryDateFirm == true) {
				_tmpDate = this.parentSORef.marketingIP.contractDeliveryDate;
			}
			else {
				var _plndApprovalDate = this.plannedDrawingApprovalDate_Initial;
				var _noOfWeekAfterApproval = this.parentSORef.marketingIP.contractDeliveryDateInWeek;
				if (_plndApprovalDate != null && _noOfWeekAfterApproval != null) {
					_tmpDate = configDefs.addWorkingWeeks(_plndApprovalDate, _noOfWeekAfterApproval);
				}
			}

			this.plannedContractualDeliveryToken.plannedDate = _tmpDate;
			// var noOfDayToReachSite = this.DaysgoodsReach;

			// if (_tmpDate != null && !configDefs.isNumEmty(noOfDayToReachSite)) {
			// 	this.plannedContractualDeliveryToken.plannedDate = configDefs.subtractWorkingDays(_tmpDate, noOfDayToReachSite);
			// }
			// else{
			// 	this.plannedContractualDeliveryToken.plannedDate = null;
			// }
		}

		return this.plannedContractualDeliveryToken.plannedDate;
	}
	set plannedContractualDeliveryDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set plannedContractualDeliveryToken directly");
		this._plannedContractualDeliveryToken.plannedDate = _SetVal;
	}
	get plannedContractualDeliveryDateLabel(): string {
		if (this.plannedContractualDeliveryDateIsRevised == true) {
			return "Contractual Delivery Date (Initial)";
		}
		else {
			return "Contractual Delivery Date";
		}
	}
	get plannedContractualDeliveryDateIsRevised(): boolean {
		if (this.plannedContractualDeliveryToken.isOveridden == true) {
			if (GenService.areDatesSame(this.plannedContractualDeliveryToken.actualPlannedDate, this.plannedContractualDeliveryToken.plannedDate) == false) {
				return true;
			}
		}
		return false;
	}
	private _plannedContractualDeliveryGroup: RevisedDate;
	get plannedContractualDeliveryGroup(): RevisedDate {
		this._plannedContractualDeliveryGroup = new RevisedDate(this.plannedContractualDeliveryToken.actualPlannedDate, this.plannedContractualDeliveryDateIsRevised, this.plannedContractualDeliveryToken.plannedDate);

		return this._plannedContractualDeliveryGroup;
	}
	get invoicingmonth(): Date {
		return this._invoicingmonth;
	}
	set invoicingmonth(_setVal: Date) {
		this._invoicingmonth = _setVal;
	}
	get plannedRevnueMonth(): Date {
		return this._plannedRevnueMonth;
	}
	set plannedRevnueMonth(_SetVal: Date) {
		this._plannedRevnueMonth = _SetVal;
	}
	// get rotddate(): Date {
	// 	return this._rotddate;
	// }
	// set rotddate(_SetVal: Date) {
	// 	this._rotddate = _SetVal;
	// 	console.log("check for rotd date", this.rotddate);
	// }

	// STARTS
	get rotddateToken(): PlannedDateToken {
		return this._rotddateToken;
	}
	set rotddateToken(_SetVal: PlannedDateToken) {
		if (this._rotddateToken.actualPlannedDate == null)
			this._rotddateToken.actualPlannedDate = this.rotddate;
		this._rotddateToken.plannedDate = _SetVal.plannedDate;
		this._rotddateToken.isOveridden = _SetVal.isOveridden;
		this._rotddateToken.addNotes = _SetVal.addNotes;
		this._rotddateToken.userOveridden = _SetVal.userOveridden;
	}
	get rotddate(): Date {
		if (this.rotddateToken.plannedDate == null || this.rotddateToken.isOveridden == false) {
			var _tmpDate = null;
			// var _tmpDate;

			if (this.parentSORef.marketingIP.isContractDeliveryDateFirm == false) {
				var _plndApprovalDate = this.actualDrawingApprovalDate;
				var _noOfWeekAfterApproval = this.parentSORef.marketingIP.contractDeliveryDateInWeek;
				if (_plndApprovalDate != null && _noOfWeekAfterApproval != null) {
					_tmpDate = configDefs.addWorkingWeeks(_plndApprovalDate, _noOfWeekAfterApproval);
				}
			}

			this.rotddateToken.plannedDate = _tmpDate;

		}

		return this.rotddateToken.plannedDate;
	}
	set rotddate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set rotddate directly");
		this._rotddateToken.plannedDate = _SetVal;
	}

	get rotddateIsRevised(): boolean {
		if (this.rotddateToken.isOveridden == true) {
			if (GenService.areDatesSame(this.rotddateToken.actualPlannedDate, this.rotddateToken.plannedDate) == false) {
				return true;
			}
		}
		return false;
	}
	get rotddateLabel(): string {
		if (this.rotddateIsRevised == true) {
			return "Customer Requested Date (Initial)";
		}
		else {
			return "Customer Requested Date";
		}
	}
	private _rotddateGroup: RevisedDate;
	get rotddateGroup(): RevisedDate {
		this._rotddateGroup = new RevisedDate(this.rotddateToken.actualPlannedDate, this.rotddateIsRevised, this.rotddateToken.plannedDate);

		return this._rotddateGroup;
	}
	// ENDS

	get insulationLevel(): string {
		return this._insulationLevel;
	}
	set insulationLevel(_SetVal: string) {
		this._insulationLevel = _SetVal;
	}
	get equipmentList(): Array<Equipment> {
		var totalcontract: number = 0;
		const precisionTolerance: number = 0.000001;
		var _tmpDate = this.parentSORef.marketingIP.clearPoReceiptDate;
		let dateTime = new Date("2020-10-27")
		let eqptypelst = ['019', '020', '021', '022', '023', '024', '025', '026', '027', '028', '029', '030', '031', '032', '033', '034', '035', '036'];
		var _totalcontval: number = parseFloat(this.totalcontval);
		if (dateTime < _tmpDate) {
			//  console.log("yes its inside");
			if (this._equipmentList && this._equipmentList.length > 0) {
				this._equipmentList.forEach((_equipment: Equipment) => {
					if (!eqptypelst.includes(_equipment.equipmentType)) {
						_equipment.contractualValue = ((_totalcontval / parseFloat(this.totalpanelquant)) * parseFloat(_equipment.panelQuantity)).toString()
					}
					totalcontract += parseFloat(_equipment.contractualValue);
					//console.log("chal ja bhai",totalcontract);
					// if (totalcontract > _totalcontval) {
					if ((totalcontract - _totalcontval) > precisionTolerance) {
						_equipment.contractualValue = "0";
					}
				});
			}
			return this._equipmentList;
		}
		else {
			//  console.log("its not inside");
			return this._equipmentList;
		}
	}
	set equipmentList(_SetVal: Array<Equipment>) {
		this._equipmentList = _SetVal;
	}
	addEquipmentList(_newEquip: Equipment) {
		this._equipmentList.push(_newEquip);
	}
	removeEquipment(_remEquip: Equipment) {
		let index: number = this._equipmentList.indexOf(_remEquip);
		if (index >= 0) {
			this._equipmentList.splice(index, 1);
		}
	}

	// get equipmentbreakerList(): Array<equipmentbreaker>{
	// return this._equipmentbreakerList;
	// 	}
	// 	set equipmentbreakerList(_SetVal: Array<equipmentbreaker>) {
	// 		this._equipmentbreakerList = _SetVal;
	// 	}
	get panelQuantity(): number {
		let _panelQty: number = 0;

		this.equipmentList.forEach((_equip: Equipment) => {
			_panelQty += _equip.panelQuantityNum;

		})
		return _panelQty;
	}
	get kioskApplicable(): string {
		return this._kioskApplicable;
	}
	set kioskApplicable(_SetVal: string) {
		this._kioskApplicable = _SetVal;
	}
	get tempRaiseTestApplicability(): string {
		return this._tempRaiseTestApplicability;
	}
	set tempRaiseTestApplicability(_SetVal: string) {
		this._tempRaiseTestApplicability = _SetVal;
	}
	get breakerApplicability(): string {
		return this._breakerApplicability;
	}
	get breakerApplicability_Enable(): boolean {
		return this._breakerApplicability == "001";
	}
	set breakerApplicability(_SetVal: string) {
		this._breakerApplicability = _SetVal;
	}
	get vscApplicability(): string {
		return this._vscApplicability;
	}
	get vscApplicability_Enable(): boolean {
		return this._vscApplicability == "001";
	}
	set vscApplicability(_SetVal: string) {
		this._vscApplicability = _SetVal;
	}
	get isLongLeadApplicable(): boolean {
		return (this.breakerApplicability_Enable || this.vscApplicability_Enable);
	}
	get isSpecialRelyApplicale(): boolean {
		return (this.geRelayApplicability_Enable);

	}
	get spareApplicability(): string {
		return this._spareApplicability;
	}
	get spareApplicability_Enable(): boolean {
		return this._spareApplicability == "001";
	}
	set spareApplicability(_SetVal: string) {
		this._spareApplicability = _SetVal;
	}
	get etApplicability(): string {
		return this._etApplicability;
	}
	get etApplicability_Enable(): boolean {
		return this._etApplicability == "001";
	}
	set etApplicability(_SetVal: string) {
		this._etApplicability = _SetVal;
	}
	get geRelayApplicability(): string {
		return this._geRelayApplicability;
	}
	get geRelayApplicability_Enable(): boolean {
		return this._geRelayApplicability == "001";
	}
	set geRelayApplicability(_SetVal: string) {
		this._geRelayApplicability = _SetVal;
	}
	get busbarMaterial(): string {
		return this._busbarMaterial;
	}
	set busbarMaterial(_SetVal: string) {
		this._busbarMaterial = _SetVal;
	}
	get busbarSleeve(): string {
		return this._busbarSleeve;
	}
	set busbarSleeve(_SetVal: string) {
		this._busbarSleeve = _SetVal;
	}
	get commentsDateList(): Array<CommentsOnSubmission> {
		return this._commentsDateList;
	}
	set commentDatesinSubmissoin(_SetVal: Array<CommentsOnSubmission>) {
		this._commentsDateList = _SetVal;
	}
	addCommentslist(_newComments: CommentsOnSubmission) {
		this._commentsDateList.push(_newComments);
	}
	removeCommentslist(_remComments: CommentsOnSubmission) {
		let index: number = this._commentsDateList.indexOf(_remComments);
		if (index >= 0) {
			this._commentsDateList.splice(index, 1);
		}
	}

	get plannedDrawingApprovalToken(): PlannedDateToken {
		return this._plannedDrawingApprovalToken;
	}
	set plannedDrawingApprovalToken(_SetVal: PlannedDateToken) {
		if (this._plannedDrawingApprovalToken.actualPlannedDate == null)
			this._plannedDrawingApprovalToken.actualPlannedDate = this.plannedDrawingApprovalDate;
		this._plannedDrawingApprovalToken.plannedDate = _SetVal.plannedDate;
		this._plannedDrawingApprovalToken.isOveridden = _SetVal.isOveridden;
		this._plannedDrawingApprovalToken.addNotes = _SetVal.addNotes;
		this._plannedDrawingApprovalToken.userOveridden = _SetVal.userOveridden;
	}
	get plannedDrawingApprovalDateIsRevised(): boolean {
		if (this.plannedDrawingApprovalDate_Initial && this.plannedDrawingApprovalDate) {
			if (GenService.areDatesSame(this.plannedDrawingApprovalDate_Initial, this.plannedDrawingApprovalDate) == false) {
				return true;
			}
		}
		return false;
	}
	get plannedDrawingApprovalDateLabel(): string {
		if (this.plannedSizingCalSubmissionDateIsRevised == true && this.D14 != null) {
			return "Drawing Approval Revised (Planned)";
		}
		else {
			return "Drawing Approval Planned";
		}
	}
	get plannedDrawingApprovalDate_Initial(): Date {
		if (this._plannedDrawingApprovalToken.actualPlannedDate == null || this._plannedDrawingApprovalToken.isOveridden == false) {
			var _tmpDate = this.plannedSchematicDrawingDate_Initial;
			if (_tmpDate != null && configDefs.defPlndDrawingApprovalDays) {
				this._plannedDrawingApprovalToken.actualPlannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndDrawingApprovalDays);
			}
			else {
				this._plannedDrawingApprovalToken.actualPlannedDate = null;
			}
		}
		return this._plannedDrawingApprovalToken.actualPlannedDate;
	}
	get plannedDrawingApprovalDate(): Date {
		if (this._plannedDrawingApprovalToken.plannedDate == null || this._plannedDrawingApprovalToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.enggDrawIP.initialSchematicDBOMSubmissionDateActual;
			if (_tmpDate == null) {
				var _tmpDate = this.plannedSchematicDrawingDate;
			}
			if (_tmpDate != null && configDefs.defPlndDrawingApprovalDays) {
				this._plannedDrawingApprovalToken.plannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndDrawingApprovalDays);
			}
			else {
				this._plannedDrawingApprovalToken.plannedDate = null
			}
		}
		return this._plannedDrawingApprovalToken.plannedDate;
	}
	get actOrPlndDrawingApprovalDate(): Date {
		var _tmpDate = this.parentSubSORef.pmTechSubSalesOrder.actualDrawingApprovalDate;
		if (_tmpDate == null) {
			_tmpDate = this.parentSubSORef.pmTechSubSalesOrder.plannedDrawingApprovalDate;
		}
		return _tmpDate;
	}
	private _plannedDrawingApprovalGroup: RevisedDate;
	get plannedDrawingApprovalGroup(): RevisedDate {
		this._plannedDrawingApprovalGroup = new RevisedDate(this.plannedDrawingApprovalDate_Initial, this.plannedDrawingApprovalDateIsRevised, this.plannedDrawingApprovalDate);

		return this._plannedDrawingApprovalGroup;
	}
	set plannedDrawingApprovalDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set plannedDrawingApprovalDate directly");
		this._plannedDrawingApprovalToken.plannedDate = _SetVal;
	}
	get actualDrawingApprovalToken(): ActualDateToken {
		return this._actualDrawingApprovalToken;
	}
	set actualDrawingApprovalToken(_SetVal: ActualDateToken) {
		if (this._actualDrawingApprovalToken.expActualDate == null)
			this._actualDrawingApprovalToken.expActualDate = this.actualDrawingApprovalDate;
		this._actualDrawingApprovalToken.actualDate = _SetVal.actualDate;
		this._actualDrawingApprovalToken.isOveridden = _SetVal.isOveridden;
		this._actualDrawingApprovalToken.addNotes = _SetVal.addNotes;
		this._actualDrawingApprovalToken.userOveridden = _SetVal.userOveridden;
	}
	get actualDrawingApprovalDate(): Date {
		return this._actualDrawingApprovalToken.actualDate;
	}
	set actualDrawingApprovalDate(_SetVal: Date) {
		this._actualDrawingApprovalToken.actualDate = _SetVal;
	}
	get actualDrawingApprovalDateComment(): string {
		return this._actDrawApprovalComment;
	}
	set actualDrawingApprovalDateComment(_SetVal: string) {
		this._actDrawApprovalComment = _SetVal;
	}
	get plannedCtFinalizationToken(): PlannedDateToken {
		return this._plannedCtFinalizationToken;
	}
	set plannedCtFinalizationToken(_SetVal: PlannedDateToken) {
		// if (this._plannedCtFinalizationToken.actualPlannedDate == null)
		// 	this._plannedCtFinalizationToken.actualPlannedDate = this.plannedCtFinalizationDate;
		this._plannedCtFinalizationToken.plannedDate = _SetVal.plannedDate;
		this._plannedCtFinalizationToken.isOveridden = _SetVal.isOveridden;
		this._plannedCtFinalizationToken.addNotes = _SetVal.addNotes;
		this._plannedCtFinalizationToken.userOveridden = _SetVal.userOveridden;
	}

	get plannedCtFinalizationDateLabel(): string {
		if (this.plannedCtFinalizationDateIsRevised == true) {
			return "FCM info for CT Finalization Given By PM To SCM Revised (Planned)"
		}
		else {
			return "FCM info for CT Finalization Given By PM To SCM Planned"
		}
	}
	get plannedCtFinalizationDateIsRevised(): boolean {
		if (this.plannedCtFinalizationDate_Initial && this.plannedCtFinalizationDate) {
			if (GenService.areDatesSame(this.plannedCtFinalizationDate_Initial, this.plannedCtFinalizationDate) == false) {
				return true;
			}
		}
		return false;
	}
	get plannedCtFinalizationDate_Initial(): Date {
		if (this._plannedCtFinalizationToken.actualPlannedDate == null || this._plannedCtFinalizationToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.enggDrawIP.ctFinalizationGivenByEnggToPMPlannedDate_Initial;
			if (_tmpDate != null && configDefs.defPlndCTFinByPMToSCMDays) {
				this._plannedCtFinalizationToken.actualPlannedDate = configDefs.addWorkingDays(_tmpDate, 1);
			}
			else {
				this._plannedCtFinalizationToken.actualPlannedDate = null;
			}
		}
		return this._plannedCtFinalizationToken.actualPlannedDate;
	}
	get plannedCtFinalizationDate(): Date {
		if (this._plannedCtFinalizationToken.plannedDate == null || this._plannedCtFinalizationToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.enggDrawIP.ctFinalizationGivenByEnggToPMActualDate;
			if (_tmpDate == null) {
				_tmpDate = this.plannedDrawingApprovalDate
			}
			if (_tmpDate != null && configDefs.defPlndCTFinByPMToSCMDays) {
				this._plannedCtFinalizationToken.plannedDate = configDefs.addWorkingDays(_tmpDate, 1);
			}
			else {
				this._plannedCtFinalizationToken.plannedDate = null;
			}
		}
		return this._plannedCtFinalizationToken.plannedDate;
	}
	private _plannedCtFinalizationGroup: RevisedDate;
	get plannedCtFinalizationGroup(): RevisedDate {
		this._plannedCtFinalizationGroup = new RevisedDate(this.plannedCtFinalizationDate_Initial, this.plannedCtFinalizationDateIsRevised, this.plannedCtFinalizationDate);
		return this._plannedCtFinalizationGroup;
	}
	set plannedCtFinalizationDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set plannedCtFinalizationDate directly");
		this._plannedCtFinalizationToken.plannedDate = _SetVal;
	}
	get actualCtFinalizationToken(): ActualDateToken {
		return this._actualCtFinalizationToken;
	}
	set actualCtFinalizationToken(_SetVal: ActualDateToken) {
		if (this._actualCtFinalizationToken.expActualDate == null)
			this._actualCtFinalizationToken.expActualDate = this.actualCtFinalizationDate;
		this._actualCtFinalizationToken.actualDate = _SetVal.actualDate;
		this._actualCtFinalizationToken.isOveridden = _SetVal.isOveridden;
		this._actualCtFinalizationToken.addNotes = _SetVal.addNotes;
		this._actualCtFinalizationToken.userOveridden = _SetVal.userOveridden;
	}
	get isCTActualDateAvailableInEnggDraw(): boolean {
		if (this.parentSubSORef.enggDrawIP.ctFinalizationGivenByEnggToPMActualDate) {
			return true
		}
		else
			return false
	}
	get actualCtFinalizationDate(): Date {
		return this._actualCtFinalizationToken.actualDate;
	}
	set actualCtFinalizationDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set actualCtFinalizationDate directly");
		this._actualCtFinalizationToken.actualDate = _SetVal;
	}
	get SplMatFinalizationPlannedDateToken(): PlannedDateToken {
		return this._splMatPriceFinalizationPlannedDateToken;
	}
	set SplMatFinalizationPlannedDateToken(_SetVal: PlannedDateToken) {
		// if (this._splMatPriceFinalizationPlannedDateToken.actualPlannedDate == null)
		// this._splMatPriceFinalizationPlannedDateToken.actualPlannedDate == this.splMatPriceFinalizationPlannedDate;
		this._splMatPriceFinalizationPlannedDateToken.plannedDate = _SetVal.plannedDate;
		this._splMatPriceFinalizationPlannedDateToken.isOveridden = _SetVal.isOveridden;
		this._splMatPriceFinalizationPlannedDateToken.addNotes = _SetVal.addNotes;
		this._splMatPriceFinalizationPlannedDateToken.userOveridden = _SetVal.userOveridden;

	}
	get splMatPriceFinalizationPlannedDateLabel(): string {
		if (this.splMatPriceFinalizationPlannedDateIsRevised == true && this.parentSubSORef.enggDrawIP.isSplMatPapplicable == true && this.parentSubSORef.enggDrawIP.splMatActualDate != null) {
			return "Special Material Price Given By PM To SCM Revised (Planned)"
		}
		else {
			return "Special Material Price Given By PM To SCM Planned"
		}
	}
	get splMatPriceFinalizationPlannedDateIsRevised(): boolean {
		if (this.splMatPriceFinalizationPlannedDate_Initial && this.splMatPriceFinalizationPlannedDate) {
			if (GenService.areDatesSame(this.splMatPriceFinalizationPlannedDate_Initial, this.splMatPriceFinalizationPlannedDate) == false) {
				return true;
			}
		}
		return false;
	}
	private _splMatPriceFinalizationPlannedGroup: RevisedDate;
	get splMatPriceFinalizationPlannedGroup(): RevisedDate {
		this._splMatPriceFinalizationPlannedGroup = new RevisedDate(this.splMatPriceFinalizationPlannedDate_Initial, this.splMatPriceFinalizationPlannedDateIsRevised, this.splMatPriceFinalizationPlannedDate);

		return this._splMatPriceFinalizationPlannedGroup;
	}
	get splMatPriceFinalizationPlannedDate_Initial(): Date {
		if (this.isSplMatPriceDatesEnabled == true) {
			if (this._splMatPriceFinalizationPlannedDateToken.actualPlannedDate == null || this._splMatPriceFinalizationPlannedDateToken.isOveridden == false) {
				var _tmpDate = this.plannedDrawingApprovalDate_Initial;
				if (_tmpDate != null && configDefs.defsplmatpricactPlannDays) {
					this._splMatPriceFinalizationPlannedDateToken.actualPlannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defsplmatpricactPlannDays);
				}
				else {
					this._splMatPriceFinalizationPlannedDateToken.actualPlannedDate = null;
				}
			}
			return this._splMatPriceFinalizationPlannedDateToken.actualPlannedDate;
		}
		return null;
	}
	get splMatPriceFinalizationPlannedDate(): Date {
		if (this.isSplMatPriceDatesEnabled == true) {
			if (this._splMatPriceFinalizationPlannedDateToken.plannedDate == null || this._splMatPriceFinalizationPlannedDateToken.isOveridden == false) {
				var _tmpDate = this.actualDrawingApprovalDate;
				if (_tmpDate == null) {
					_tmpDate = this.plannedDrawingApprovalDate;
				}
				if (_tmpDate != null && configDefs.defsplmatpricactPlannDays) {
					this._splMatPriceFinalizationPlannedDateToken.plannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defsplmatpricactPlannDays);
				}
				else {
					this._splMatPriceFinalizationPlannedDateToken.plannedDate = null;
				}
			}
			return this._splMatPriceFinalizationPlannedDateToken.plannedDate;
		}
		return null;
	}
	set splMatPriceFinalizationPlannedDate(_SetVal: Date) {
		this._splMatPriceFinalizationPlannedDateToken.plannedDate = _SetVal;
	}
	get inspectionCallDate(): Date {
		return this._inspectionCallDate;
	}
	set inspectionCallDate(_SetVal: Date) {
		this._inspectionCallDate = _SetVal;
	}
	get inspCallDtls(): string {
		return this._inspCallDtls;
	}
	set inspCallDtls(_SetVal: string) {
		this._inspCallDtls = _SetVal;
	}
	get splMatFinalizationActualDateToken(): ActualDateToken {
		return this._splMatPriceFinalizationActualDateToken;
	}
	set splMatFinalizationActualDateToken(_SetVal: ActualDateToken) {
		if (this._splMatPriceFinalizationActualDateToken.expActualDate == null)
			this._splMatPriceFinalizationActualDateToken.expActualDate = this.actualCtFinalizationDate;
		this._splMatPriceFinalizationActualDateToken.actualDate = _SetVal.actualDate;
		this._splMatPriceFinalizationActualDateToken.isOveridden = _SetVal.isOveridden;
		this._splMatPriceFinalizationActualDateToken.addNotes = _SetVal.addNotes;
		this._splMatPriceFinalizationActualDateToken.userOveridden = _SetVal.userOveridden;
	}
	get splMatFinalizationActualDate(): Date {
		if (this.isSplMatPriceDatesEnabled == false) {
			this._splMatPriceFinalizationActualDateToken.actualDate = null;
		}
		return this._splMatPriceFinalizationActualDateToken.actualDate;
	}
	set splMatFinalizationActualDate(_SetVal: Date) {
		this._splMatPriceFinalizationActualDateToken.actualDate = _SetVal;
	}
	get plannedPackingDisptachClearanceToken(): PlannedDateToken {
		return this._plannedPackingDisptachClearanceToken;
	}
	set plannedPackingDisptachClearanceToken(_SetVal: PlannedDateToken) {
		// if (this._plannedPackingDisptachClearanceToken.actualPlannedDate == null)
		// 	this._plannedPackingDisptachClearanceToken.actualPlannedDate = this.plannedPackingDisptachClearanceDate;
		this._plannedPackingDisptachClearanceToken.plannedDate = _SetVal.plannedDate;
		this._plannedPackingDisptachClearanceToken.isOveridden = _SetVal.isOveridden;
		this._plannedPackingDisptachClearanceToken.addNotes = _SetVal.addNotes;
		this._plannedPackingDisptachClearanceToken.userOveridden = _SetVal.userOveridden;
	}
	get plannedPackingDisptachClearanceDateLabel(): string {
		if (this.plannedPackingDisptachClearanceDateIsRevised == true) {
			return "Revised (Planned) Date"
		} else {
			return "Planned Date"
		}
	}
	get plannedPackingDisptachClearanceDateIsRevised(): boolean {
		// return this.parentSubSORef.qualityIP.fatActualDate != null;
		if (this.parentSubSORef.qualityIP.fatPlannedDate_initial && this.parentSubSORef.qualityIP.fatPlannedDate) {
			if (GenService.areDatesSame(this.parentSubSORef.qualityIP.fatPlannedDate_initial, this.parentSubSORef.qualityIP.fatPlannedDate) == false) {
				return true;
			}
		}
		return false;
	}
	get plannedPackingDisptachClearanceDate_Initial(): Date {
		if (this.plannedPackingDisptachClearanceToken.actualPlannedDate == null || this.plannedPackingDisptachClearanceToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.qualityIP.fatPlannedDate_initial;

			if (_tmpDate != null && configDefs.defPlndPacDispClrDays) {
				this.plannedPackingDisptachClearanceToken.actualPlannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndPacDispClrDays);
			}
			else {
				this.plannedPackingDisptachClearanceToken.actualPlannedDate = null;
			}
		}
		return this._plannedPackingDisptachClearanceToken.actualPlannedDate;
	}
	get plannedPackingDisptachClearanceDate(): Date {
		if (this.plannedPackingDisptachClearanceToken.plannedDate == null || this.plannedPackingDisptachClearanceToken.isOveridden == false) {
			// var _tmpDate = this.parentSubSORef.qualityIP.fatActualDate;
			// if(_tmpDate==null){
			var _tmpDate = this.parentSubSORef.qualityIP.fatPlannedDate
			//}
			if (_tmpDate != null && configDefs.defPlndPacDispClrDays) {
				this.plannedPackingDisptachClearanceToken.plannedDate = configDefs.addWorkingDays(_tmpDate, configDefs.defPlndPacDispClrDays);
			}
			else {
				this.plannedPackingDisptachClearanceToken.plannedDate = null;
			}
		}
		return this._plannedPackingDisptachClearanceToken.plannedDate;
	}
	private _plannedPackingDisptachClearanceGroup: RevisedDate;
	get plannedPackingDisptachClearanceGroup(): RevisedDate {
		this._plannedPackingDisptachClearanceGroup = new RevisedDate(this.plannedPackingDisptachClearanceDate_Initial, this.plannedPackingDisptachClearanceDateIsRevised, this.plannedPackingDisptachClearanceDate);

		return this._plannedPackingDisptachClearanceGroup;
	}
	set plannedPackingDisptachClearanceDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set plannedPackingDisptachClearanceDate directly");
		this._plannedPackingDisptachClearanceToken.plannedDate = _SetVal;
	}
	get requestPackingToken(): RequestDateToken {
		return this._requestPackingToken;
	}
	set requestPackingToken(_SetVal: RequestDateToken) {
		if (this._requestPackingToken.plndRequestDate == null)
			this._requestPackingToken.plndRequestDate = this.requestPackingDate;
		this._requestPackingToken.requestDate = _SetVal.requestDate;
		this._requestPackingToken.isOveridden = _SetVal.isOveridden;
		this._requestPackingToken.addNotes = _SetVal.addNotes;
		this._requestPackingToken.userOveridden = _SetVal.userOveridden;
	}
	get requestPackingDate(): Date {
		if (this.requestPackingToken.requestDate == null || this.requestPackingToken.isOveridden == false) {
			var _tmpDate = this.parentSubSORef.qualityIP.fatRequestedDate;
			if (_tmpDate != null && configDefs.defReqPacDispClrDays) {
				this._requestPackingToken.requestDate = configDefs.addWorkingDays(_tmpDate, configDefs.defReqPacDispClrDays);
			}
			else {
				this._requestPackingToken.requestDate = null;
			}
		}
		return this._requestPackingToken.requestDate;
	}
	set requestPackingDate(_SetVal: Date) {
		console.log('wrong execution, requestPackingDate');
		this._requestPackingToken.requestDate = _SetVal;
	}
	get actualPackingToken(): ActualDateToken {
		return this._actualPackingToken;
	}
	set actualPackingToken(_SetVal: ActualDateToken) {
		if (this._actualPackingToken.expActualDate == null)
			this._actualPackingToken.expActualDate = this.actualPackingDate;
		this._actualPackingToken.actualDate = _SetVal.actualDate;
		this._actualPackingToken.isOveridden = _SetVal.isOveridden;
		this._actualPackingToken.addNotes = _SetVal.addNotes;
		this._actualPackingToken.userOveridden = _SetVal.userOveridden;
	}
	get actualPackingDate(): Date {
		return this._actualPackingToken.actualDate;
	}
	set actualPackingDate(_SetVal: Date) {
		console.log("Possible wrong place for execution, not supposed to set soCreationDateActual directly");
		this._actualPackingToken.actualDate = _SetVal;
	}
	get scmCTDays(): number {
		return configDefs.getDaysDifference(this.parentSubSORef.scmIP.ctFinalizationFromSCMPlannedDate, this.parentSubSORef.scmIP.ctFinalizationFromSCMActualDate);
	}
	get scmCTDaysTip(): string {
		let _tmpPlannedDate: Date = this.parentSubSORef.scmIP.ctFinalizationFromSCMPlannedDate;
		let _tmpActualDate: Date = this.parentSubSORef.scmIP.ctFinalizationFromSCMActualDate;
		if (_tmpPlannedDate && _tmpActualDate) {
			return 'CT Finalization Date : \r\n' +
				'\tPlanned\t> ' + moment(_tmpPlannedDate).format(configDefs.dateFormat) + '\r\n' +
				'\tActual\t> ' + moment(_tmpActualDate).format(configDefs.dateFormat);
		}
		return '';
	}
	get isEnggDrawSubmitted(): boolean {
		return this.parentSubSORef.isSSOStatusSet(SSOStatus.Engg_Draw);
	}


	isSpecifiedEquipType1(_equipTypeId: string) {
		let cacheSpecifiedEquipType1 = {};

		if (_equipTypeId == null || _equipTypeId == '') {
			return false;
		}
		if (cacheSpecifiedEquipType1[_equipTypeId] != null) {
			return cacheSpecifiedEquipType1[_equipTypeId];
		}
		let x = this.equiVarient(_equipTypeId);
		let _result;
		if (x == true) {
			_result = true;
		}
		else _result = false

		cacheSpecifiedEquipType1[_equipTypeId] = _result;
		// console.log("_result",_result);

		return _result;
	}

	get equiValidation(): boolean {
		var equiApp_true_ESW_true = [];
		var equiApp_true_ESW_false = [];
		var equiApp_false = [];

		this.equipmentList.forEach(val => {
			var equiApp = this.isSpecifiedEquipType1(val.equipmentType)
			switch (equiApp) {
				case true:
					switch (val.earthSwithApplicability) {
						case "001":
							// if (val.earthSwitchQuantity !=null || val.earthSwitchQuantity!= undefined) {
							if (val.earthSwitchQuantity === null || val.earthSwitchQuantity === "") {

								// equiApp_true_ESW_true.push(true);
								equiApp_true_ESW_true.push(false);

							}
							else {

								// equiApp_true_ESW_true.push(false);
								equiApp_true_ESW_true.push(true);

							}
							break;
						case "002":
							equiApp_true_ESW_false.push(true);
							break;

						default:
							equiApp_true_ESW_false.push(false);
							break;
					}

					break;
				case false:

					equiApp_false.push(true);
					break;

			}

		});

		var equiApp_true = equiApp_true_ESW_true.concat(equiApp_true_ESW_false, equiApp_false);
		if (equiApp_true.includes(false)) {
			return false;
		}
		else return true;

	}
	get readyForEnggDrawing(): boolean {

		if (this.DaysgoodsReach) {
			if (this.parentSORef.marketingIP.contractDeliveryDateFirm != null && this.parentSORef.marketingIP.isContractDeliveryDateFirm == false && this.equiValidation == true) {
				return true;
			}
			else {
				if (this.parentSORef.marketingIP.contractDeliveryDateFirm != null && this.parentSORef.marketingIP.isContractDeliveryDateFirm == true && this.rotddate && this.equiValidation == true) {
					return true;
				}
			}
		}
		return false;
	}
	get readyForPlanning(): boolean {
		if (this.DaysgoodsReach) return true;
		return false;
	}
	// get isDayOfReachGiven(): boolean{
	// 	return this.DaysgoodsReach != null;
	// }
	get isSCMSubmitted(): boolean {
		return this.parentSubSORef.isSSOStatusSet(SSOStatus.SCM);
	}
	get isPlanningEnabledOutside(): boolean {
		return this.parentSubSORef.isSSOStatusSet(SSOStatus.Planning) ||
			this.parentSubSORef.isSSOStatusSet(SSOStatus.Planning_From_PO);
	}
	get isPlanningEnabledFromPMTech(): boolean {
		return this.parentSubSORef.isSSOStatusSet(SSOStatus.Planning_From_PMTech);
	}
	get readyForSCM(): boolean {
		if (this.actualCtFinalizationDate &&
			(this.isSplMatPriceDatesEnabled == false || this.isSpecailPricesActualEnabled == true)) {
			return true;
		}
		return false;
	}
	get panelsValidation(): boolean {
		var equiTy_panels = [];
		let _tempEqp = ["001", "002", "037", "003", "004", "005", "006", "007", "008", "009", "010", "011", "012", "013", "014", "015", "016", "017", "018"];

		this.equipmentList.forEach(val => {
			var _eq = val.equipmentType;
			if (_eq) {
				if (_tempEqp.includes(_eq)) {
					equiTy_panels.push(true);
				}
				else { equiTy_panels.push(false); }
			}
			else { equiTy_panels.push(null); }
		});
		if (equiTy_panels.includes(true)) {
			return true;
		}
		else if (equiTy_panels.every(element => element === null)) {
			return true;
		}
		else { return false; }
	}

	get readyForEnggProcLogistic(): boolean {
		if (this.panelsValidation == true) {
			return true;
		}
		else if (this.panelsValidation == false) {
			return false;
		}
	}
	get isEnggProcLogisticSubmitted(): boolean {
		return this.parentSubSORef.isSSOStatusSet(SSOStatus.Engg_Procurement_From_PM_Tech | SSOStatus.Logistic_From_PM_Tech);
	}
	cloneSelf() {
		let _eqListClone: Equipment[] = []
		for (var i = 0; i < this.equipmentList.length; i++) {
			_eqListClone.push(this.equipmentList[i].cloneSelf());
		}
		let _comments: CommentsOnSubmission[] = []
		if (this.commentDatesinSubmissoin) {
			for (var i = 0; i < this.commentDatesinSubmissoin.length; i++) {
				_comments.push(this.commentDatesinSubmissoin[i].cloneSelf());
			}
		}
		else {
			_comments.push(new CommentsOnSubmission(null, null));
		}


		return new PmTechnicalIP(this.productVarient, this.contractUploads.cloneSelf(), this.boardname,
			// this.statusHold,this.statusCancel,
			this.jsrMatCost, this.jsrGm, this.projStatus, this._delayreason, this.jsrNm, this.jsrMatCostPercent, this.jsrGmPercent, this.jsrNmPercent, this.numberOfPanels,
			this.jobComplexity, this.FeederOrLocationTypeNo, this.plannedSldSubmissionToken.cloneSelf(), this.plannedGaDrawingSubmissionToken.cloneSelf(),
			this.plannedSchematicDrawingToken.cloneSelf(), this.plannedSizingCalSubmissionToken.cloneSelf(), this.DaysgoodsReach, this.tentativeDeliveryToken.cloneSelf(),
			configDefs.cloneDt(this.invoicingmonth), configDefs.cloneDt(this.plannedRevnueMonth),
			this._rotddate, // ROTD
			this._rotddateToken.cloneSelf(),// ROTD
			this.totalcontval, this.totalpanelquant, this.sumbreakerquant,
			this.sumvscquant, this.contractualvaluesum, this.panelQuantSum, this.insulationLevel, _eqListClone, this.kioskApplicable, this.tempRaiseTestApplicability,
			this.breakerApplicability, this.vscApplicability, this.spareApplicability, this.etApplicability, this.geRelayApplicability, this.busbarMaterial, this.busbarSleeve,
			_comments, this.plannedDrawingApprovalToken.cloneSelf(), this.actualDrawingApprovalToken.cloneSelf(), this.drawingUploads.cloneSelf(), this.actualDrawingApprovalDateComment,
			this.plannedCtFinalizationToken.cloneSelf(), this.actualCtFinalizationToken.cloneSelf(), this.SplMatFinalizationPlannedDateToken.cloneSelf(),
			this.splMatFinalizationActualDateToken.cloneSelf(), configDefs.cloneDt(this.inspectionCallDate), this.inspCallDtls, this.plannedPackingDisptachClearanceToken.cloneSelf(),
			this._requestPackingToken.cloneSelf(), this.actualPackingToken.cloneSelf(), this.plannedContractualDeliveryToken.cloneSelf(), this.status
			, this.commentsPR);  // TEST FOR COMMENTS
	}
	cloneSelfMainContent() {
		let _eqListClone: Equipment[] = []
		for (var i = 0; i < this.equipmentList.length; i++) {
			_eqListClone.push(this.equipmentList[i].cloneSelf());
		}
		let _comments: CommentsOnSubmission[] = [];
		if (this.commentDatesinSubmissoin) {
			for (var i = 0; i < this.commentDatesinSubmissoin.length; i++) {
				_comments.push(this.commentDatesinSubmissoin[i].cloneSelf());
			}
		}
		else {
			_comments.push(new CommentsOnSubmission(null, null));
		}

		return new PmTechnicalIP(this.productVarient, new GenFileUploads([]), "",
			this.jsrMatCost, this.jsrGm, this.projStatus, "", this.jsrNm, this.jsrMatCostPercent, this.jsrGmPercent, this.jsrNmPercent, this.numberOfPanels, this.jobComplexity,
			this.FeederOrLocationTypeNo,
			new PlannedDateToken(null, false, null, '', ''), new PlannedDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''), new PlannedDateToken(null, false, null, '', ''),
			this.DaysgoodsReach, new PlannedDateToken(null, false, null, '', ''), configDefs.cloneDt(this.invoicingmonth),
			configDefs.cloneDt(this.plannedRevnueMonth),
			this._rotddate, // ROTD
			new PlannedDateToken(null, false, null, '', ''),//ROTD
			this.totalcontval, this.totalpanelquant, this.sumbreakerquant, this.sumvscquant, this.contractualvaluesum,
			this.panelQuantSum, this.insulationLevel, _eqListClone, this.kioskApplicable, this.tempRaiseTestApplicability, this.breakerApplicability, this.vscApplicability,
			this.spareApplicability, this.etApplicability, this.geRelayApplicability, this.busbarMaterial, this.busbarSleeve, _comments,
			new PlannedDateToken(null, false, null, '', ''), new ActualDateToken(null, false, null, '', ''),
			new GenFileUploads([]), "",
			new PlannedDateToken(null, false, null, '', ''), new ActualDateToken(null, false, null, '', ''),
			new PlannedDateToken(null, false, null, '', ''), new ActualDateToken(null, false, null, '', ''), null, "",
			new PlannedDateToken(null, false, null, '', ''), new RequestDateToken(null, false, null, '', ''),
			new ActualDateToken(null, false, null, '', ''), new PlannedDateToken(null, false, null, '', ''), this.status
			, this.commentsPR); // TEST FOR COMMENTS
	}
	public static getObj(_json: any): PmTechnicalIP {

		let _equipmentList: Array<Equipment> = [];
		for (var j = 0; j < _json.equipList.length; j++) {
			_equipmentList.push(Equipment.getObj(_json.equipList[j]));
		}
		let _commentsDateList: Array<CommentsOnSubmission> = [];
		if (_json.commList) {
			for (var i = 0; i < _json.commList.length; i++) {
				_commentsDateList.push(CommentsOnSubmission.getObj(_json.commList[i]));
			}
		}
		else {
			_commentsDateList.push(new CommentsOnSubmission(null, null));

		}


		return new PmTechnicalIP(_json.prodVariant, GenFileUploads.getObj(_json.contractUploads), _json.boardname,
			_json.jsrMatCost, _json.jsrGm, _json.projStatus, _json.delayreason, _json.jsrNm, _json._jsrMatCostPercent, _json.jsrGmPercent, _json.jsrNmPercent, _json.numOfPanels, _json.jobComplexity, _json.feederLocationNo,
			convDefs.convToPlannedDateToken(_json.planGaDrawingSubmissionToken), convDefs.convToPlannedDateToken(_json.planGaDrawingSubmissionToken),
			convDefs.convToPlannedDateToken(_json.planSchematicDrawingToken), convDefs.convToPlannedDateToken(_json.planSizzingCalSubmissionToken),
			_json.daysGoodsReach, convDefs.convToPlannedDateToken(_json.tentativeDlvryToken), GenService.convToDate(_json.invoicingmonth),
			GenService.convToDate(_json.planRvnueMon),
			GenService.convToDate(_json.rotddate), // ROTD
			convDefs.convToPlannedDateToken(_json.rotddateToken),// ROTD
			_json.totalcontval, _json.totalpanelquant, _json.sumbreakerquant, _json.sumvscquant, _json.contractualvaluesum, _json.panelQuantSum, _json.insulationLevel, _equipmentList, _json.kioskApplic,
			_json.tmpRaiseTestApplic, _json.brkrApplic, _json.vscApplic, _json.spareApplic, _json.etApplic,
			_json.geRelayApplic, _json.busbarMaterial, _json.busbarSleeve, _commentsDateList,
			convDefs.convToPlannedDateToken(_json.planDrawingApprovalToken), convDefs.convToActualDateToken(_json.actDrawingApprovalToken),
			GenFileUploads.getObj(_json.drawingUploads), _json.actDrwCmnt,
			convDefs.convToPlannedDateToken(_json.planCtFinalToken), convDefs.convToActualDateToken(_json.actCtFinalToken),
			convDefs.convToPlannedDateToken(_json.splMatFinPlaDate), convDefs.convToActualDateToken(_json.splMatFinActDate),
			GenService.convToDate(_json.inspCallDate), _json.inspCallDtls,
			convDefs.convToPlannedDateToken(_json.planPackToken), convDefs.convToRequestDateToken(_json.reqPackToken), convDefs.convToActualDateToken(_json.actPackToken),
			convDefs.convToPlannedDateToken(_json.planContractualDeliveryToken),
			_json.status
			, _json.commentsPR);// TEST FOR COMMENTS
	}

	public getJson(): any {
		let _json: any = {};

		_json.prodVariant = this.productVarient;
		_json.contractUploads = this.contractUploads.getJson();
		_json.projStatus = this.projStatus;
		_json.delayreason = this.delayreason;
		_json.boardname = this.boardname;
		_json.jsrMatCost = this.jsrMatCost;
		_json.jsrGm = this.jsrGm;
		_json.jsrNm = this.jsrNm;
		_json.totalcontval = this.totalcontval;
		_json.totalpanelquant = this.totalpanelquant;
		_json.sumbreakerquant = this.sumbreakerquant;
		_json.sumvscquant = this.sumvscquant;
		_json.contractualvaluesum = this.contractualvaluesum;
		_json.panelQuantSum = this.panelQuantSum;
		_json._jsrMatCostPercent = this.jsrMatCostPercent;
		_json.jsrGmPercent = this.jsrGmPercent;
		_json.jsrNmPercent = this.jsrNmPercent;
		_json.numOfPanels = this.numberOfPanels;
		_json.jobComplexity = this.jobComplexity;
		_json.feederLocationNo = this.FeederOrLocationTypeNo;
		_json.planSldSubmissionToken = this.plannedSldSubmissionToken.getJson();
		_json.planGaDrawingSubmissionToken = this.plannedGaDrawingSubmissionToken.getJson();
		_json.planSchematicDrawingToken = this.plannedSchematicDrawingToken.getJson();
		_json.planSizzingCalSubmissionToken = this.plannedSizingCalSubmissionToken.getJson();
		_json.daysGoodsReach = this.DaysgoodsReach;
		_json.tentativeDlvryToken = this.tentativeDeliveryToken.getJson();
		_json.invoicingmonth = GenService.convToDateNum(this.invoicingmonth);
		_json.planRvnueMon = GenService.convToDateNum(this.plannedRevnueMonth);
		_json.rotddate = GenService.convToDateNum(this.rotddate);	// ROTD	
		_json.rotddateToken = this.rotddateToken.getJson();		// ROTD
		_json.insulationLevel = this.insulationLevel;
		_json.equipList = [];
		_json.kioskApplic = this.kioskApplicable;
		_json.tmpRaiseTestApplic = this.tempRaiseTestApplicability;
		_json.brkrApplic = this.breakerApplicability;
		_json.vscApplic = this.vscApplicability;
		_json.spareApplic = this.spareApplicability;
		_json.etApplic = this.etApplicability;
		_json.geRelayApplic = this.geRelayApplicability;
		_json.busbarMaterial = this.busbarMaterial;
		_json.busbarSleeve = this.busbarSleeve;
		_json.commList = [];
		_json.planDrawingApprovalToken = this.plannedDrawingApprovalToken.getJson();
		_json.actDrawingApprovalToken = this.actualDrawingApprovalToken.getJson();
		_json.drawingUploads = this.drawingUploads.getJson();
		_json.actDrwCmnt = this.actualDrawingApprovalDateComment;
		_json.planCtFinalToken = this.plannedCtFinalizationToken.getJson();
		_json.actCtFinalToken = this.actualCtFinalizationToken.getJson();
		_json.splMatFinPlaDate = this.SplMatFinalizationPlannedDateToken.getJson();
		_json.splMatFinActDate = this.splMatFinalizationActualDateToken.getJson();
		_json.inspCallDate = GenService.convToDateNum(this.inspectionCallDate);
		_json.inspCallDtls = this.inspCallDtls;
		_json.planPackToken = this.plannedPackingDisptachClearanceToken.getJson();
		_json.reqPackToken = this.requestPackingToken.getJson();
		_json.actPackToken = this.actualPackingToken.getJson();
		_json.planContractualDeliveryToken = this.plannedContractualDeliveryToken.getJson();

		_json.status = this.status;
		_json.commentsPR = this.commentsPR; // TEST FOR COMMENTS
		for (var i = 0; i < this._commentsDateList.length; i++) {
			_json.commList.push(this._commentsDateList[i].getJson());
		}
		for (var i = 0; i < this._equipmentList.length; i++) {
			_json.equipList.push(this._equipmentList[i].getJson());
		}
		return _json;
	}
}

export class UiSoOrder {
	constructor(private _flag: number, private _obj: SalesOrder, private _sSoIndex: number, private _bottomBorder: boolean) {

	}

}

export class UiTblSubSO {
	public plantName: string;
	public customerName: string;
	public projectName: string;
	public salesOrderNo: string;
	public subSalesOrderNo: string;
	public rowHeader: string;
	public plannedRevenueMonth: string;
	public plannedManfMonth: string;
	public manfStrategy: string;
	public plndLineLoadingDate: string;
	public reqLineLoadingDate: string;
	public actLineLoadingDate: string;
	public customerPoValue: string;
	public contractualValue: string;
	public marketingEngineer: string;
	public projectManager: string;
	public projectEngineer: string;
	public elecDesignEngineer: string;
	public mechDesignEngineer: string;
	public salesChannelName: string;
	public regionName: string;
	public poDate: string;
	public clearPODate: string;
	public consultantName: string;
	public warrantyMonths: string;
	public specialPoint: string;
	public specialPointFiles: Array<FileElement> = [];
	public splPriceFileTokens: Array<FileElement> = [];
	public ordertypeName: string;
	public contractDeliveryFirm: string;
	public contractDeliveryWeeks: string;
	public contractDeliveryDate: string;
	public ldApplicability: string;
	public ldPercentage: string;
	public ldCap: string;
	public deliveryTerm: string;
	public placeOfDelivery: string;
	public daysgoodsReach: string;
	public deliveryFromAbb: string;
	public paymentTerm: string;
	public paymentDays: string;
	public FCMMatCost: string;
	public totalcontval: string;
	public totalpanelquant: string;
	public sumbreakerquant: string;
	public sumvscquant: string;
	public JSRMatCost: string;
	public FCMGM: string;
	public JSRGM: string;
	public FCMNM: string;
	public JSRNM: string;
	public AdvPmtCondition: string;
	public AdvPmt: string;
	public AdvPmtMilestone: string;
	public PBGPayCondition: string;
	public CPBGPayCondition: string;
	public SOCreationPlanned: string;
	public SOCreationActual: string;
	public SOCreationRemarks: string;
	public SOReleasePlanned: string;
	public SOReleaseActual: string;
	public SOReleaseRemarks: string;
	public OrderHandOverPlanned: string;
	public OrderHandOverActual: string;
	public OrderHandOverRemarks: string;
	public ABGACGSubmissionDetails: string;
	public ABGACGActSubmissDate: string;
	public ABGACGActCollectDate: string;
	public PBGSubmissionDetails: string;
	public PBGActSubmissDate: string;
	public PBGActCollectDate: string;
	public CPBGSubmissionDetails: string;
	public CPBGActSubmissDate: string;
	public CPBGActCollectDate: string;
	public variantOfProduct: string;
	public noOfPanels: string;
	public complexityOfJobs: string;
	public noOfFeedertypes: string;
	public plannedSLDSubmissDate: string;
	public initialSLDSubmissActualDate: string;
	public remarkForSLDSubmission: string;
	public plannedGAFDrawSubmissDate: string;
	public actualGAFDrawSubmissDate: string;
	public remarkForGAFSubmissActualDate: string;

	public plannedSchBOMSubmissDate: string;
	public actualSchBOMSubmisDate: string;
	public remarkSchBOMSubmissDate: string;
	public plannedBusBarSizingCalcSubmissDate: string;
	public actualBusBarSizingCalcSubmissDate: string;
	public remarkBusBarSizingCalcSubmissDate: string;
	public finalDrawingSubmissDate: string;
	public insulationLevelKV: string;
	public typeOfEquipment: string;
	public typeOfBreaker: string;
	public qtyOfPanel: string;
	public qtyOfBreaker: string;
	public breakerPS: string;
	public importedEarthingSwitchApplicability: string;

	public qtyOfVSC: string;
	public kioskApplic: string;
	public tempRiseTestApplic: string;
	public impBrkApplic: string;
	public impVSCApplic: string;
	public spareApplic: string;
	public etApplic: string;
	public geRelayApplic: string;

	public busbarMaterial: string;
	public busbarSleeve: string;
	public cmntOnActualSubmissDate: string;
	public cmntOnActualComplainceDate: string;
	public plannedDrawingAprvlDate: string;
	public actualDrawingAprvlDate: string;
	public remarkDrawingAprvlDate: string;
	public plannedCTFinalEnggToPMDate: string;
	public actualCtFinalEnggToPMDate: string;
	public remarkCtFinalEnggToPMDate: string;

	public plannedCTFinalPMtoSCMDate: string;
	public actualCTFinalPMtoSCMDate: string;
	public remarkCTFinalPMtoSCMDate: string;
	public plannedCTFinalfromSCMDate: string;
	public actualCTFinalfromSCMDate: string;
	public remarkCTFinalfromSCMDate: string;
	public plannedPackingDispatchClrDate: string;
	public actualPackingDispatchClrDate: string;
	public remarkPackingDispatchClrDate: string;
	public plannedSLDApprovalDate: string;
	public actualSLDApprovalDate: string;
	public remarkSLDApprovalDate: string;
	public plannedC40Date: string;
	public actualC40Date: string;
	public remarkC40Date: string;
	public plannedC50Date: string;
	public actualC50Date: string;
	public remarkC50Date: string;
	public plannedC60Date: string;
	public actualC60Date: string;
	public remarkC60Date: string;
	public plannedLongLeadDate: string;
	public actualLongLeadDate: string;
	public remarkLongLeadDate: string;
	public plannedImpBrkrPORlsDate: string;
	public actualImpBrkrPORlsDate: string;
	public remarkImpBrkrPORlsDate: string;

	public plannedImpVscPORlsDate: string;
	public actualImpVscPORlsDate: string;
	public remarkImpVscPORlsDate: string;
	public plannedGERelayPORlsDate: string;
	public actualGERelayPORlsDate: string;
	public remarkGERelayPORlsDate: string;
	public plannedCTPTPORlsDate: string;
	public actualCTPTPORlsDate: string;
	public remarkCTPTPORlsDate: string;
	public plannedRelayPORlsDate: string;
	public actualRelayPORlsDate: string;
	public remarkRelayPORlsDate: string;
	public plannedBreakerPORlsDate: string;
	public actualBreakerPORlsDate: string;
	public remarkBreakerPORlsDate: string;
	public plannedSAPORlsDate: string;
	public actualSAPORlsDate: string;
	public remarkSAPORlsDate: string;
	public plannedMeteringBoxPORlsDate: string;
	public actualMeteringBoxPORlsDate: string;
	public remarkMeteringBoxPORlsDate: string;
	public plannedPickListtoStoresDate: string;
	public requestedPickListtoStoresDate: string;
	public actualPickListtoStoresDate: string;
	public remarkPickListtoStoresDate: string;

	public plannedImpBrkrRcptDate: string;
	public requestedImpBrkrRcptDate: string;
	public supplierImpBrkrRcptDate: string;
	public actualImpBrkrRcptDate: string;
	public remarkImpBrkrRcptDate: string;
	public plannedImpVSCRcptDate: string;
	public requestedImpVSCRcptDate: string;
	public supplierImpVSCRcptDate: string;
	public actualImpVSCRcptDate: string;
	public remarkImpVSCRcptDate: string;
	public plannedGERelayRcptDate: string;
	public requestedGERelayRcptDate: string;
	public supplierGERelayRcptDate: string;
	public actualGERelayRcptDate: string;
	public remarkGERelayRcptDate: string;
	public plannedCTPTRcptDate: string;
	public requestedCTPTRcptDate: string;
	public supplierCTPTRcptDate: string;
	public actualCTPTRcptDate: string;
	public remarkCTPTRcptDate: string;
	public plannedRelayRcptDate: string;
	public requestedRelayRcptDate: string;
	public supplierRelayRcptDate: string;
	public actualRelayRcptDate: string;
	public remarkRelayRcptDate: string;
	public plannedBreakerRcptDate: string;
	public requestedBreakerRcptDate: string;
	public supplierBreakerRcptDate: string;
	public actualBreakerRcptDate: string;
	public remarkBreakerRcptDate: string;
	public plannedJumperRcptDate: string;
	public requestedJumperRcptDate: string;
	public supplierJumperRcptDate: string;
	public actualJumperRcptDate: string;
	public remarkJumperRcptDate: string;
	public plannedMeterBoxRcptDate: string;
	public requestedMeterBoxRcptDate: string;
	public supplierMeterBoxRcptDate: string;
	public actualMeterBoxRcptDate: string;
	public remarkMeterBoxRcptDate: string;
	public plannedSARcptDate: string;
	public requestedSARcptDate: string;
	public supplierSARcptDate: string;
	public actualSARcptDate: string;
	public remarkSARcptDate: string;
	public plannedBoughtoutFabricationRcptDate: string;
	public requestedBoughtoutFabricationRcptDate: string;
	public supplierBoughtoutFabricationRcptDate: string;
	public actualBoughtoutFabricationRcptDate: string;
	public remarkBoughtoutFabricationRcptDate: string;

	public plannedMatIssuetoLineDate: string;
	public requestedMatIssuetoLineDate: string;
	public actualMatIssuetoLineDate: string;
	public remarkMatIssuetoLineDate: string;
	public plannedLooseMatIssueDate: string;
	public actualLooseMatIssueDate: string;
	public remarkLooseMatIssueDate: string;
	public plannedMechStickerDate: string;
	public requestedMechStickerDate: string;
	public actualMechStickerDate: string;
	public remarkMechStickerDate: string;
	public plannedMechElecTestDate: string;
	public requestedMechElecTestDate: string;
	public actualMechElecTestDate: string;
	public remarkMechElecTestDate: string;
	public plannedFATDate: string;
	public requestedFATDate: string;
	public actualFATDate: string;
	public remarkFATDate: string;
	public plannedGreenStickerDate: string;
	public requestedGreenStickerDate: string;
	public actualGreenStickerDate: string;
	public remarkGreenStickerDate: string;
	public plannedDispatchDate: string;
	public requestedDispatchDate: string;
	public actualDispatchDate: string;
	public remarkDispatchDate: string;
	public partialDispatchQty: string;
	public actualEarthlingTruckDispatchDate: string;
	public actualSparesDispatchDate: string;
	public boardname: string;
	public delayreason: string;




	constructor(private _subSoActObj: SubSalesOrder) {

	}



	searchText(_srchText: string): boolean {
		_srchText = _srchText.toLowerCase();
		if (this.plantName && this.plantName.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.customerName && this.customerName.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.projectName && this.projectName.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.salesOrderNo && this.salesOrderNo.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.subSalesOrderNo && this.subSalesOrderNo.toLowerCase().indexOf(_srchText) >= 0) return true;

		if (this.manfStrategy && this.manfStrategy.toLowerCase().indexOf(_srchText) >= 0) return true;
		//if(this.customerPoValue && this.customerPoValue.toLowerCase().indexOf(_srchText) >= 0) return true;
		//if(this.contractualValue && this.contractualValue.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.marketingEngineer && this.marketingEngineer.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.projectManager && this.projectManager.toLowerCase().indexOf(_srchText) >= 0) return true;

		if (this.projectEngineer && this.projectEngineer.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.elecDesignEngineer && this.elecDesignEngineer.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.mechDesignEngineer && this.mechDesignEngineer.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.salesChannelName && this.salesChannelName.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.regionName && this.regionName.toLowerCase().indexOf(_srchText) >= 0) return true;

		if (this.consultantName && this.consultantName.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.specialPoint && this.specialPoint.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.ordertypeName && this.ordertypeName.toLocaleLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.placeOfDelivery && this.placeOfDelivery.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.salesChannelName && this.salesChannelName.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.SOCreationRemarks && this.SOCreationRemarks.toLowerCase().indexOf(_srchText) >= 0) return true;

		if (this.SOReleaseRemarks && this.SOReleaseRemarks.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.OrderHandOverRemarks && this.OrderHandOverRemarks.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.placeOfDelivery && this.placeOfDelivery.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.salesChannelName && this.salesChannelName.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.SOCreationRemarks && this.SOCreationRemarks.toLowerCase().indexOf(_srchText) >= 0) return true;



		return false;
	}
	get sso(): SubSalesOrder {
		return this._subSoActObj;
	}
	// public prepareUIData(){

	// }
}
export class UiSummarySO {
	public subOrderCount: number = 0;
	public projExecStatus: string = "";
	public marketingDaysCss: string;
	public pmCommercialHeadCss: string;
	public pmTechDaysHeadCss: string;
	public enggDrawDaysHeadCss: string;
	public scmCtDaysHeadCss: string;
	public enggProcDaysHeadCss: string;
	public purchPoDaysHeadCss: string;
	public planDaysHeadCss: string;
	public purchMatRecptDaysHeadCss: string;
	public storeDaysHeadCss: string;
	public productionDaysHeadCss: string;
	public qualityDaysHeadCss: string;
	public logisticDaysHeadCss: string;

	public marketingDaysBodyCss: string;
	public pmTechDaysBodyCss: string;
	public enggDrawDaysBodyCss: string;
	public scmCtDaysBodyCss: string;
	public enggProcDaysBodyCss: string;
	public purchPoDaysBodyCss: string;
	public planDaysBodyCss: string;
	public purchMatRecptDaysBodyCss: string;
	public storeDaysBodyCss: string;
	public productionDaysBodyCss: string;
	public qualityDaysBodyCss: string;
	public logisticDaysBodyCss: string;
	public relayConfigCss: string;

	constructor(private _soId: string, private _type: string, private _soNo: string, private _ssoNo: string,
		private _custName: string, private _varientType: string, private _quantity: string,
		private _showSSo: boolean, private _showRow: boolean, private _islastSSo: boolean,
		private _marketStatus: FunctionStatus, private _pmCommercialStatus: FunctionStatus,
		private _pmTechStatus: FunctionStatus,
		private _enggDrawingStatus: FunctionStatus, private _scmCtStatus: FunctionStatus,
		private _enggProcurementStatus: FunctionStatus, private _purchPoStatus: FunctionStatus, private _planStatus: FunctionStatus,
		private _purchMatRecptStatus: FunctionStatus, private _storeStatus: FunctionStatus, private _productionStatus: FunctionStatus,
		private _qualityStatus: FunctionStatus, private _logisticStatus: FunctionStatus,
		private _marketingDays: number, public marketingDaysTip: string,
		private _pmTechDays: number, public pmTechDaysTip: string,
		private _enggDrawDays: number, public enggDrawDaysTip: string,
		private _scmCtDays: number, public scmCTDaysTip: string,
		private _enggProcDays: number, public enggProcDaysTip: string,
		private _purchPoDays: number, public purchPoDaysTip: string,
		private _planDays: number, public planDaysTip: string,
		private _purchMatRecptDays: number, public purchMatRecptDaysTip: string,
		private _storeDays: number, public storeDaysTip: string,
		private _productionDays: number, public productionDaysTip: string,
		private _qualityDays: number, public qualityDaysTip: string,
		private _logisticDays: number, public logisticDaysTip: string,
		private _contractualDate: string,
		private _foreCastDate: string, private _difrnceinDeliverydates: number, public dispatchDaysTip: string,
		private _committedDate: string, private _projectStatus: SOStatus,
		private _isSaleOrderChngApplic: boolean, private _newSaleOrderNo: string,
		private _revenueMonth: Date = null, private _manufacturingMonth: Date = null
	) {
		this.setCssStyles()
	}
	private setCssStyles() {
		// console.log(this.pmTechStatus, this.pmTechDaysHeadCss)
		this.marketingDaysCss = this.getHeadStatusCSS(this._marketStatus) + ' ' + this.getBodyStatusCSS(this.marketingDays);
		this.pmCommercialHeadCss = this.getHeadStatusCSS(this._pmCommercialStatus);
		this.pmTechDaysHeadCss = this.getHeadStatusCSS(this._pmTechStatus);
		this.enggDrawDaysHeadCss = this.getHeadStatusCSS(this._enggDrawingStatus);
		this.scmCtDaysHeadCss = this.getHeadStatusCSS(this._scmCtStatus);
		this.enggProcDaysHeadCss = this.getHeadStatusCSS(this._enggProcurementStatus);
		this.purchPoDaysHeadCss = this.getHeadStatusCSS(this._purchPoStatus);
		this.planDaysHeadCss = this.getHeadStatusCSS(this.planStatus);
		this.purchMatRecptDaysHeadCss = this.getHeadStatusCSS(this._purchMatRecptStatus);
		this.storeDaysHeadCss = this.getHeadStatusCSS(this.storeStatus);
		this.productionDaysHeadCss = this.getHeadStatusCSS(this.productionStatus);
		this.qualityDaysHeadCss = this.getHeadStatusCSS(this.qualityStatus);
		this.logisticDaysHeadCss = this.getHeadStatusCSS(this.logisticStatus);

		this.marketingDaysBodyCss = this.getBodyStatusCSS(this.marketingDays);
		this.pmTechDaysBodyCss = this.getBodyStatusCSS(this.pmTechDays);
		this.enggDrawDaysBodyCss = this.getBodyStatusCSS(this.enggDrawDays);
		this.scmCtDaysBodyCss = this.getBodyStatusCSS(this.scmCtDays);
		this.enggProcDaysBodyCss = this.getBodyStatusCSS(this.enggProcDays);
		this.purchPoDaysBodyCss = this.getBodyStatusCSS(this.purchPoDays);
		this.planDaysBodyCss = this.getBodyStatusCSS(this.planDays);
		this.purchMatRecptDaysBodyCss = this.getBodyStatusCSS(this.purchMatRecptDays);
		this.storeDaysBodyCss = this.getBodyStatusCSS(this.storeDays);
		this.productionDaysBodyCss = this.getBodyStatusCSS(this.productionDays);
		this.qualityDaysBodyCss = this.getBodyStatusCSS(this.qualityDays);
		this.logisticDaysBodyCss = this.getBodyStatusCSS(this.logisticDays);
	}
	private getHeadStatusCSS(_status: FunctionStatus): string {

		switch (_status) {
			case FunctionStatus.WAITING_FOR_PREV:
				return "tab-legend white-legend";
			case FunctionStatus.WAITING_FOR_USER_INPUT:
				return "tab-legend grey-legend";
			case FunctionStatus.SUBMITTED_INCOMPLETE:
				return "tab-legend yellow-legend";
			case FunctionStatus.SUBMITTED_COMPLETE:
				return "tab-legend green-legend";
			case FunctionStatus.SUBMITTED_WAITING_RESPONSE:
				return "tab-legend blue-legend";
			case FunctionStatus.NOT_SUBMITTED_BUT_READY:
				return "tab-legend yellow-legend";
			default:
				return "tab-legend white-legend";
		}
	}
	private getBodyStatusCSS(_Val): string {
		if (_Val == null) return 'hide';
		if (_Val > 0) {
			return 'clr-green';
		}
		else if (_Val < 0) {
			return 'clr-red';
		}
		else
			return 'clr-black';
	}
	searchSaleOrder(_srchText: string, revenueMonthFilter: monthFilter, manfMonthFilter: monthFilter, manfStrategyId: string): boolean {
		let searchSuccess: boolean = false;
		if (_srchText != '') {
			_srchText = _srchText.toLowerCase();
			if (this.soNo && (this.soNo + '').toLowerCase().indexOf(_srchText) >= 0) {
				searchSuccess = true;
			}
			if (this.custName && this.custName.toLowerCase().indexOf(_srchText) >= 0) {
				searchSuccess = true;
			}
		}
		else {
			searchSuccess = true;
		}

		if (searchSuccess == true && revenueMonthFilter != null) {
			if (revenueMonthFilter.isWithInFilterScope(this._revenueMonth) == false) {
				searchSuccess = false;
			}
		}

		if (searchSuccess == true && manfMonthFilter != null) {
			if (manfMonthFilter.isWithInFilterScope(this._manufacturingMonth) == false) {
				searchSuccess = false;
			}
		}

		// if(searchSuccess == true && manfStrategyId != null){
		// 	this.
		// }

		return searchSuccess;
	}

	get soId(): string {
		return this._soId;
	}
	set soId(_SetVal: string) {
		this._soId = _SetVal;
	}
	get type(): string {
		return this._type;
	}
	set type(_SetVal: string) {
		this._type = _SetVal;
	}
	get soNoV2Title(): string {
		if (this.isSaleOrderChngApplic == true) {
			return 'Initial Sale Order No : ' + this._soNo + '\n' +
				'Changed Sale Order No : ' + this._newSaleOrderNo;
		}
		return '';
	}
	get soNoV2(): string {
		if (this.isSaleOrderChngApplic == true) {
			return this._newSaleOrderNo;
		}
		return this._soNo;
	}
	get soNo(): string {
		return this._soNo;
	}
	set soNo(_SetVal: string) {
		this._soNo = _SetVal;
	}
	get isSaleOrderChngApplic(): boolean {
		return this._isSaleOrderChngApplic == true && configDefs.isStrEmty(this._newSaleOrderNo) == false;
	}
	get newSaleOrderNo(): string {
		return this._newSaleOrderNo;
	}
	get ssoNo(): string {
		return this._ssoNo;
	}
	set ssoNo(_SetVal: string) {
		this._ssoNo = _SetVal;
	}
	get custName(): string {
		return this._custName;
	}
	set custName(_SetVal: string) {
		this._custName = _SetVal;
	}
	get varientType(): string {
		return this._varientType;
	}
	set varientType(_SetVal: string) {
		this._varientType = _SetVal;
	}
	get quantity(): string {
		return this._quantity;
	}
	set quantity(_SetVal: string) {
		this._quantity = _SetVal;
	}
	get showSSo(): boolean {
		return this._showSSo;
	}
	set showSSo(_SetVal: boolean) {
		this._showSSo = _SetVal;
	}
	get showRow(): boolean {
		return this._showRow;
	}
	set showRow(_SetVal: boolean) {
		this._showRow = _SetVal;
	}
	get islastSSo(): boolean {
		return this._islastSSo;
	}
	set islastSSo(_SetVal: boolean) {
		this._islastSSo = _SetVal;
	}
	get marketStatus(): number {
		return this._marketStatus;
	}
	set marketStatus(_SetVal: number) {
		this._marketStatus = _SetVal;
	}//_pmCommercialStatus
	get pmCommercialStatus(): number {
		return this._pmCommercialStatus;
	}
	set pmCommercialStatus(_SetVal: number) {
		this._pmCommercialStatus = _SetVal;
	}
	get pmTechStatus(): number {
		return this._pmTechStatus;
	}
	set pmTechStatus(_SetVal: number) {
		this._pmTechStatus = _SetVal;
	}
	get enggDrawingStatus(): number {
		return this._enggDrawingStatus;
	}
	set enggDrawingStatus(_SetVal: number) {
		this._enggDrawingStatus = _SetVal;
	}
	get scmCtStatus(): number {
		return this._scmCtStatus;
	}
	set scmCtStatus(_SetVal: number) {
		this._scmCtStatus = _SetVal;
	}
	get enggProcurementStatus(): number {
		return this._enggProcurementStatus;
	}
	set enggProcurementStatus(_SetVal: number) {
		this._enggProcurementStatus = _SetVal;
	}
	get purchPoStatus(): number {
		return this._purchPoStatus;
	}
	set purchPoStatus(_SetVal: number) {
		this._purchPoStatus = _SetVal;
	}
	get planStatus(): number {
		return this._planStatus;
	}
	set planStatus(_SetVal: number) {
		this._planStatus = _SetVal;
	}
	get purchMatRecptStatus(): number {
		return this._purchMatRecptStatus;
	}
	set purchMatRecptStatus(_SetVal: number) {
		this._purchMatRecptStatus = _SetVal;
	}
	get storeStatus(): number {
		return this._storeStatus;
	}
	set storeStatus(_SetVal: number) {
		this._storeStatus = _SetVal;
	}
	get productionStatus(): number {
		return this._productionStatus;
	}
	set productionStatus(_SetVal: number) {
		this._productionStatus = _SetVal;
	}
	get qualityStatus(): number {
		return this._qualityStatus;
	}
	set qualityStatus(_SetVal: number) {
		this._qualityStatus = _SetVal;
	}
	get logisticStatus(): number {
		return this._logisticStatus;
	}
	set logisticStatus(_SetVal: number) {
		this._logisticStatus = _SetVal;
	}
	get marketingDays(): number {
		return this._marketingDays;
	}
	set marketingDays(_SetVal: number) {
		this._marketingDays = _SetVal;
	}
	get pmTechDays(): number {
		return this._pmTechDays;
	}
	set pmTechDays(_SetVal: number) {
		this._pmTechDays = _SetVal;
	}
	get enggDrawDays(): number {
		return this._enggDrawDays;
	}
	set enggDrawDays(_SetVal: number) {
		this.enggDrawDays = _SetVal;
	}
	get scmCtDays(): number {
		return this._scmCtDays;
	}
	set scmCtDays(_SetVal: number) {
		this._scmCtDays = _SetVal;
	}
	get enggProcDays(): number {
		return this._enggProcDays;
	}
	set enggProcDays(_SetVal: number) {
		this._enggProcDays = _SetVal;
	}
	get purchPoDays(): number {
		return this._purchPoDays;
	}
	set purchPoDays(_SetVal: number) {
		this._purchPoDays = _SetVal;
	}
	get planDays(): number {
		return this._planDays;
	}
	set planDays(_SetVal: number) {
		this._planDays = _SetVal;
	}
	get purchMatRecptDays(): number {
		return this._purchMatRecptDays;
	}
	set purchMatRecptDays(_SetVal: number) {
		this._purchMatRecptDays = _SetVal;
	}
	get storeDays(): number {
		return this._storeDays;
	}
	set storeDays(_SetVal: number) {
		this._storeDays = _SetVal;
	}
	get productionDays(): number {
		return this._productionDays;
	}
	set productionDays(_SetVal: number) {
		this._productionDays = _SetVal;
	}
	get qualityDays(): number {
		return this._qualityDays;
	}
	set qualityDays(_SetVal: number) {
		this._qualityDays = _SetVal;
	}
	get logisticDays(): number {
		return this._logisticDays;
	}
	set logisticDays(_SetVal: number) {
		this._logisticDays = _SetVal;
	}
	get foreCastDate(): string {
		return this._foreCastDate;
	}
	set foreCastDate(_SetVal: string) {
		this._foreCastDate = _SetVal;
	}
	get contractualDate(): string {
		return this._contractualDate;
	}
	get differenceInDeliverydates(): number {
		return this._difrnceinDeliverydates;
	}
	set differenceInDeliverydates(_SetVal: number) {
		this._difrnceinDeliverydates = _SetVal;
	}
	get committedDate(): string {
		return this._committedDate;
	}
	set committedDate(_SetVal: string) {
		this._committedDate = _SetVal;
	}

	get projectStatus(): SOStatus {
		return this._projectStatus;
	}

}
// STARTS
export class UiReviewSO {
	public subOrderCount: number = 0;
	public projExecStatus: string = "";

	// public cursorIndex:number;
	// public prdLeadTime:Array<number>;
	// public prdLeadTimeDays :number;
	// public daysReq:number;

	public homDatePRBodyCss: string;
	public sldgtpSubDatePRBodyCss: string;
	public gacsSubDatePRBodyCss: string;
	public schemeSubDatePRBodyCss: string;
	public mgaSubDatePRBodyCss: string;
	public sldGaGtpAprvlDatePRBodyCss: string;
	public longleadRDatePRBodyCss: string;
	public fnCusDrgAprvlDatePRBodyCss: string;
	public techCTDetsDatePRBodyCss: string;
	public fcmCTfinActDatePRBodyCss: string;
	public CTfinSCMActDatePRBodyCss: string;
	public c40ActDatePRBodyCss: string;
	public c50ActDatePRBodyCss: string;
	public c60ActDatePRBodyCss: string;
	public relayRecpDatePRBodyCss: string;
	public ctRecpDatePRBodyCss: string
	public cbRecpDatePRBodyCss: string;
	public mbRecpDatePRBodyCss: string;
	public lineLoadActDatePRBodyCss: string;
	public mechStickerDatePRBodyCss: string;
	public elecMechTestingDatePRBodyCss: string;
	public FATDatePRBodyCss: string;
	public greenStickerDatePRBodyCss: string;
	public exWorksDatePRBodyCss: string;

	public mbRecpDateStatusPRBodyCss: string;
	public lineLoadActDateStatusPRBodyCss: string;

	constructor(private _soId: string, private _type: string, private _soNo: string, private _ssoNo: string,
		private _custName: string, private _varientType: string, private _quantity: string,
		private _showSSo: boolean, private _showRow: boolean, private _islastSSo: boolean,
		private _projectStatus: SOStatus,
		private _isSaleOrderChngApplic: boolean, private _newSaleOrderNo: string,
		private _revenueMonth: Date = null, private _manufacturingMonth: Date = null, private _homDate: string,
		private _sldgtpSubDate: string, private _gacsSubDate: string, private _schemeSubDate: string, private _mgaSubDate: string,
		private _sldGaGtpAprvlDate: string, private _longleadRDate: string, private _fnCusDrgAprvlDate: string, private _techCTDetsDate: string,
		private _fcmCTfinActDate: string, private _CTfinSCMActDate: string, private _c40ActDate: string, private _c50ActDate: string,
		private _c60ActDate: string, private _relayRecpDate: string, private _ctRecpDate: string, private _ctRecpDateStatus: string, private _ctRecpApplic: boolean,
		private _mbRecpDate: string, private _mbRecpDateStatus: string, private _cbRecpDate: string, private _lineLoadActDate: string, private _lineLoadActDateStatus: string,
		private _mechStickerDate: string, private _elecMechTestingDate: string, private _FATDate: string,
		private _greenStickerDate: string, private _exWorksDate: string, private _cursorIndex: number,
		private _productLeadTimeDays: number, private _daysReqPR: string,
		// TEST FOR COMMENTS
		private _commentsPR: string, private _projectEngName: string, private _designEngName: string


	) {
		this.setCssStyles()
	}
	private setCssStyles() {

		this.homDatePRBodyCss = this.getPRBodyCss(this.homDate);
		this.sldgtpSubDatePRBodyCss = this.getPRBodyCss(this.sldgtpSubDate);
		this.gacsSubDatePRBodyCss = this.getPRBodyCss(this.gacsSubDate);
		this.schemeSubDatePRBodyCss = this.getPRBodyCss(this.schemeSubDate);
		this.mgaSubDatePRBodyCss = this.getPRBodyCss(this.mgaSubDate);
		this.sldGaGtpAprvlDatePRBodyCss = this.getPRBodyCss(this.sldGaGtpAprvlDate);
		this.longleadRDatePRBodyCss = this.getPRBodyCss(this.longleadRDate);
		this.fnCusDrgAprvlDatePRBodyCss = this.getPRBodyCss(this.fnCusDrgAprvlDate);
		this.techCTDetsDatePRBodyCss = this.getPRBodyCss(this.techCTDetsDate);
		this.fcmCTfinActDatePRBodyCss = this.getPRBodyCss(this.fcmCTfinActDate);
		this.CTfinSCMActDatePRBodyCss = this.getPRBodyCss_4(this.CTfinSCMActDate, this.c40ActDate);//////
		this.c40ActDatePRBodyCss = this.getPRBodyCss(this.c40ActDate);
		this.c50ActDatePRBodyCss = this.getPRBodyCss(this.c50ActDate);
		this.c60ActDatePRBodyCss = this.getPRBodyCss(this.c60ActDate);
		this.relayRecpDatePRBodyCss = this.getPRBodyCss(this.relayRecpDate);
		this.ctRecpDatePRBodyCss = this.getPRBodyCss_CT(this.ctRecpDate, this.ctRecpDateStatus, this.ctRecpApplic);
		this.mbRecpDatePRBodyCss = this.getPRBodyCss_3(this.mbRecpDate, this.mbRecpDateStatus);
		this.cbRecpDatePRBodyCss = this.getPRBodyCss(this.cbRecpDate);
		this.lineLoadActDatePRBodyCss = this.getPRBodyCss_2(this.lineLoadActDate, this.lineLoadActDateStatus);
		this.mechStickerDatePRBodyCss = this.getPRBodyCss(this.mechStickerDate);
		this.elecMechTestingDatePRBodyCss = this.getPRBodyCss(this.elecMechTestingDate);
		this.FATDatePRBodyCss = this.getPRBodyCss(this.FATDate);
		this.greenStickerDatePRBodyCss = this.getPRBodyCss(this.greenStickerDate);
		// this.exWorksDatePRBodyCss = this.getPRBodyCss(this.exWorksDate);


		let idx = this.cursorIndex;
		let stringPRPath = PRPath[idx]; // Var Name of the number  
		switch (stringPRPath) {
			case PRPathName.homDatePRBodyCss:
				if (this.homDatePRBodyCss == "tab-legend-pr white-legend") {
					this.homDatePRBodyCss = "tab-legend-pr triangle-up";
				}
				break;
			case PRPathName.sldgtpSubDatePRBodyCss:
				if (this.sldgtpSubDatePRBodyCss == "tab-legend-pr white-legend") {
					this.sldgtpSubDatePRBodyCss = "tab-legend-pr triangle-up";
				}
				break;
			case PRPathName.gacsSubDatePRBodyCss:
				if (this.gacsSubDatePRBodyCss == "tab-legend-pr white-legend") {
					this.gacsSubDatePRBodyCss = "tab-legend-pr triangle-up";
				}
				break;
			case PRPathName.schemeSubDatePRBodyCss:
				if (this.schemeSubDatePRBodyCss == "tab-legend-pr white-legend") {
					this.schemeSubDatePRBodyCss = "tab-legend-pr triangle-up";
				}
				break;
			case PRPathName.mgaSubDatePRBodyCss:
				if (this.mgaSubDatePRBodyCss == "tab-legend-pr white-legend") {
					this.mgaSubDatePRBodyCss = "tab-legend-pr triangle-up";
				}
				break;
			case PRPathName.sldGaGtpAprvlDatePRBodyCss:
				if (this.sldGaGtpAprvlDatePRBodyCss == "tab-legend-pr white-legend") {
					this.sldGaGtpAprvlDatePRBodyCss = "tab-legend-pr triangle-up";
				}
				break;
			case PRPathName.longleadRDatePRBodyCss:
				if (this.longleadRDatePRBodyCss == "tab-legend-pr white-legend") {
					this.longleadRDatePRBodyCss = "tab-legend-pr triangle-up";
				}
				break;
			case PRPathName.fnCusDrgAprvlDatePRBodyCss:
				if (this.fnCusDrgAprvlDatePRBodyCss == "tab-legend-pr white-legend") {
					this.fnCusDrgAprvlDatePRBodyCss = "tab-legend-pr triangle-up";
				}
				break;
			case PRPathName.techCTDetsDatePRBodyCss:
				if (this.techCTDetsDatePRBodyCss == "tab-legend-pr white-legend") {
					this.techCTDetsDatePRBodyCss = "tab-legend-pr triangle-up";
				}
				break;
			case PRPathName.fcmCTfinActDatePRBodyCss:
				if (this.fcmCTfinActDatePRBodyCss == "tab-legend-pr white-legend") {
					this.fcmCTfinActDatePRBodyCss = "tab-legend-pr triangle-up";
				}
				break;
			case PRPathName.CTfinSCMActDatePRBodyCss:
				if (this.CTfinSCMActDatePRBodyCss == "tab-legend-pr white-legend") {
					this.CTfinSCMActDatePRBodyCss = "tab-legend-pr triangle-up";
				}
				break;
			case PRPathName.c40ActDatePRBodyCss:
				if (this.c40ActDatePRBodyCss == "tab-legend-pr white-legend") {
					this.c40ActDatePRBodyCss = "tab-legend-pr triangle-up";
				}
				break;
			case PRPathName.c50ActDatePRBodyCss:
				if (this.c50ActDatePRBodyCss == "tab-legend-pr white-legend") {
					this.c50ActDatePRBodyCss = "tab-legend-pr triangle-up";
				}
				break;
			case PRPathName.c60ActDatePRBodyCss:
				if (this.c60ActDatePRBodyCss == "tab-legend-pr white-legend") {
					this.c60ActDatePRBodyCss = "tab-legend-pr triangle-up";
				}
				break;
			case PRPathName.relayRecpDatePRBodyCss:
				if (this.relayRecpDatePRBodyCss == "tab-legend-pr white-legend") {
					this.relayRecpDatePRBodyCss = "tab-legend-pr triangle-up";
				}
				break;
			case PRPathName.ctRecpDatePRBodyCss:
				// if (this.ctRecpDatePRBodyCss == "tab-legend-pr white-legend") {
				if (this.ctRecpDatePRBodyCss == "tab-legend-pr white-legend" || this.ctRecpDatePRBodyCss == "tab-legend-pr yellow-legend") {
					// 2 conditions Because ctRecpDate returns 2 values and only actual Date value needs to considerd for the red triangle
					this.ctRecpDatePRBodyCss = "tab-legend-pr triangle-up";
				}
				break;
			case PRPathName.mbRecpDatePRBodyCss:
				if (this.mbRecpDatePRBodyCss == "tab-legend-pr white-legend") {
					this.mbRecpDatePRBodyCss = "tab-legend-pr triangle-up";
				}
				break;
			case PRPathName.cbRecpDatePRBodyCss:
				if (this.cbRecpDatePRBodyCss == "tab-legend-pr white-legend") {
					this.cbRecpDatePRBodyCss = "tab-legend-pr triangle-up";
				}
				break;
			case PRPathName.lineLoadActDatePRBodyCss:
				// if (this.lineLoadActDatePRBodyCss == "tab-legend-pr white-legend") {
				if (this.lineLoadActDatePRBodyCss == "tab-legend-pr white-legend" || this.lineLoadActDatePRBodyCss == "tab-legend-pr yellow-legend") {
					// 2 conditions Because lineLoadActDate returns 2 values and only actual Date value needs to considerd for the red triangle
					this.lineLoadActDatePRBodyCss = "tab-legend-pr triangle-up";
				}
				break;
			case PRPathName.mechStickerDatePRBodyCss:
				if (this.mechStickerDatePRBodyCss == "tab-legend-pr white-legend") {
					this.mechStickerDatePRBodyCss = "tab-legend-pr triangle-up";
				}
				break;
			case PRPathName.elecMechTestingDatePRBodyCss:
				if (this.elecMechTestingDatePRBodyCss == "tab-legend-pr white-legend") {
					this.elecMechTestingDatePRBodyCss = "tab-legend-pr triangle-up";
				}
				break;
			case PRPathName.FATDatePRBodyCss:
				if (this.FATDatePRBodyCss == "tab-legend-pr white-legend") {
					this.FATDatePRBodyCss = "tab-legend-pr triangle-up";
				}
				break;
			case PRPathName.greenStickerDatePRBodyCss:
				if (this.greenStickerDatePRBodyCss == "tab-legend-pr white-legend") {
					this.greenStickerDatePRBodyCss = "tab-legend-pr triangle-up";
				}
				break;

		}


	}


	private getPRBodyCss(_Val): string {

		if (_Val == null) return "tab-legend-pr white-legend";
		if (_Val != null) {
			return "tab-legend-pr green-legend";
		}

		else
			return 'clr-black';
	}

	private getPRBodyCss_2(_Val, _Status): string { // This is to conditionally format the cells

		if (_Val == null) return "tab-legend-pr white-legend";
		if (_Val != null) {
			if (_Status == "yellow") {
				return "tab-legend-pr yellow-legend";
			}
			else if (_Status == "green") {
				return "tab-legend-pr green-legend";
			}
		}
		else
			return 'clr-black';
	}

	private getPRBodyCss_3(_Val, _Status): string { // This is to conditionally format the cells
		if (_Status == "NA") {
			return "tab-legend-pr grey-legend";
		}
		else if (_Status == "Applicable") {
			if (_Val == null) return "tab-legend-pr white-legend";
			if (_Val != null) {
				return "tab-legend-pr green-legend";

			}
		}

		else
			return 'clr-black';
	}

	private getPRBodyCss_4(_Val1, _Val2): string { // This is to conditionally format the cells

		if (_Val1 == null) {
			if (_Val2 != null) {
				return "tab-legend-pr blue-legend";
			}
			else return "tab-legend-pr white-legend";
		}
		if (_Val1 != null) {
			return "tab-legend-pr green-legend";
		}
		else
			return 'clr-black';

	}
	private getPRBodyCss_CT(_Val, _Status, _Applic): string { // This is to conditionally format the cells
		if (_Applic == false) {
			return "tab-legend-pr grey-legend";
		}
		else if (_Applic == true) {
			if (_Val == null) return "tab-legend-pr white-legend";
			if (_Val != null) {
				if (_Status == "yellow") {
					return "tab-legend-pr yellow-legend";
				}
				else if (_Status == "green") {
					return "tab-legend-pr green-legend";
				}
			}
		}
		else
			return 'clr-black';
	}

	searchSaleOrder(_srchText: string, revenueMonthFilter: monthFilter, manfMonthFilter: monthFilter, manfStrategyId: string): boolean {
		let searchSuccess: boolean = false;
		if (_srchText != '') {
			_srchText = _srchText.toLowerCase();
			if (this.soNo && (this.soNo + '').toLowerCase().indexOf(_srchText) >= 0) {
				searchSuccess = true;
			}
			if (this.custName && this.custName.toLowerCase().indexOf(_srchText) >= 0) {
				searchSuccess = true;
			}
		}
		else {
			searchSuccess = true;
		}

		if (searchSuccess == true && revenueMonthFilter != null) {
			if (revenueMonthFilter.isWithInFilterScope(this._revenueMonth) == false) {
				searchSuccess = false;
			}
		}

		if (searchSuccess == true && manfMonthFilter != null) {
			if (manfMonthFilter.isWithInFilterScope(this._manufacturingMonth) == false) {
				searchSuccess = false;
			}
		}

		// if(searchSuccess == true && manfStrategyId != null){
		// 	this.
		// }

		return searchSuccess;
	}

	get soId(): string {
		return this._soId;
	}
	set soId(_SetVal: string) {
		this._soId = _SetVal;
	}
	get type(): string {
		return this._type;
	}
	set type(_SetVal: string) {
		this._type = _SetVal;
	}
	get soNoV2Title(): string {
		if (this.isSaleOrderChngApplic == true) {
			return 'Initial Sale Order No : ' + this._soNo + '\n' +
				'Changed Sale Order No : ' + this._newSaleOrderNo;
		}
		return '';
	}
	get soNoV2(): string {
		if (this.isSaleOrderChngApplic == true) {
			return this._newSaleOrderNo;
		}
		return this._soNo;
	}
	get soNo(): string {
		return this._soNo;
	}
	set soNo(_SetVal: string) {
		this._soNo = _SetVal;
	}
	get isSaleOrderChngApplic(): boolean {
		return this._isSaleOrderChngApplic == true && configDefs.isStrEmty(this._newSaleOrderNo) == false;
	}
	get newSaleOrderNo(): string {
		return this._newSaleOrderNo;
	}
	get ssoNo(): string {
		return this._ssoNo;
	}
	set ssoNo(_SetVal: string) {
		this._ssoNo = _SetVal;
	}
	get custName(): string {
		return this._custName;
	}
	set custName(_SetVal: string) {
		this._custName = _SetVal;
	}
	get varientType(): string {
		return this._varientType;
	}
	set varientType(_SetVal: string) {
		this._varientType = _SetVal;
	}
	get quantity(): string {
		return this._quantity;
	}
	set quantity(_SetVal: string) {
		this._quantity = _SetVal;
	}
	get showSSo(): boolean {
		return this._showSSo;
	}
	set showSSo(_SetVal: boolean) {
		this._showSSo = _SetVal;
	}
	get showRow(): boolean {
		return this._showRow;
	}
	set showRow(_SetVal: boolean) {
		this._showRow = _SetVal;
	}
	get islastSSo(): boolean {
		return this._islastSSo;
	}
	set islastSSo(_SetVal: boolean) {
		this._islastSSo = _SetVal;
	}

	get projectStatus(): SOStatus {
		return this._projectStatus;
	}

	get homDate(): string {
		return this._homDate;
	}
	set homDate(_SetVal: string) {
		this._homDate = _SetVal;
	}

	get sldgtpSubDate(): string {
		return this._sldgtpSubDate;
	}
	set sldgtpSubDate(_SetVal: string) {
		this._sldgtpSubDate = _SetVal;
	}

	get gacsSubDate(): string {
		return this._gacsSubDate;
	}
	set gacsSubDate(_SetVal: string) {
		this._gacsSubDate = _SetVal;
	}

	get schemeSubDate(): string {
		return this._schemeSubDate;
	}
	set schemeSubDate(_SetVal: string) {
		this._schemeSubDate = _SetVal;
	}

	get mgaSubDate(): string {
		return this._mgaSubDate;
	}
	set mgaSubDate(_SetVal: string) {
		this._mgaSubDate = _SetVal;
	}

	get sldGaGtpAprvlDate(): string {
		return this._sldGaGtpAprvlDate;
	}
	set sldGaGtpAprvlDate(_SetVal: string) {
		this._sldGaGtpAprvlDate = _SetVal;
	}

	get longleadRDate(): string {
		return this._longleadRDate;
	}
	set longleadRDate(_SetVal: string) {
		this._longleadRDate = _SetVal;
	}

	get fnCusDrgAprvlDate(): string {
		return this._fnCusDrgAprvlDate;
	}
	set fnCusDrgAprvlDate(_SetVal: string) {
		this._fnCusDrgAprvlDate = _SetVal;
	}

	get techCTDetsDate(): string {
		return this._techCTDetsDate;
	}
	set techCTDetsDate(_SetVal: string) {
		this._techCTDetsDate = _SetVal;
	}

	get fcmCTfinActDate(): string {
		return this._fcmCTfinActDate;
	}
	set fcmCTfinActDate(_SetVal: string) {
		this._fcmCTfinActDate = _SetVal;
	}

	get CTfinSCMActDate(): string {
		return this._CTfinSCMActDate;
	}
	set CTfinSCMActDate(_SetVal: string) {
		this._CTfinSCMActDate = _SetVal;
	}

	get c40ActDate(): string {
		return this._c40ActDate;
	}
	set c40ActDate(_SetVal: string) {
		this._c40ActDate = _SetVal;
	}

	get c50ActDate(): string {
		return this._c50ActDate;
	}
	set c50ActDate(_SetVal: string) {
		this._c50ActDate = _SetVal;
	}

	get c60ActDate(): string {
		return this._c60ActDate;
	}
	set c60ActDate(_SetVal: string) {
		this._c60ActDate = _SetVal;
	}

	get relayRecpDate(): string {
		return this._relayRecpDate;
	}
	set relayRecpDate(_SetVal: string) {
		this._relayRecpDate = _SetVal;
	}

	get ctRecpDate(): string {
		return this._ctRecpDate;
	}
	set ctRecpDate(_SetVal: string) {
		this._ctRecpDate = _SetVal;
	}
	get ctRecpDateStatus(): string {
		return this._ctRecpDateStatus;
	}
	set ctRecpDateStatus(_SetVal: string) {
		this._ctRecpDateStatus = _SetVal;
	}
	get ctRecpApplic(): boolean {
		return this._ctRecpApplic;
	}
	set ctRecpApplic(_SetVal: boolean) {
		this._ctRecpApplic = _SetVal;
	}
	get mbRecpDate(): string {
		return this._mbRecpDate;
	}
	set mbRecpDate(_SetVal: string) {
		this._mbRecpDate = _SetVal;
	}

	get mbRecpDateStatus(): string {
		return this._mbRecpDateStatus;
	}
	set mbRecpDateStatus(_SetVal: string) {
		this.mbRecpDateStatus = _SetVal;
	}

	get lineLoadActDate(): string {
		return this._lineLoadActDate;
	}
	set lineLoadActDate(_SetVal: string) {
		this._lineLoadActDate = _SetVal;
	}

	get lineLoadActDateStatus(): string {
		return this._lineLoadActDateStatus;
	}
	set lineLoadActDateStatus(_SetVal: string) {
		this._lineLoadActDateStatus = _SetVal;
	}

	get cbRecpDate(): string {
		return this._cbRecpDate;
	}
	set cbRecpDate(_SetVal: string) {
		this._cbRecpDate = _SetVal;
	}

	get mechStickerDate(): string {
		return this._mechStickerDate;
	}
	set mechStickerDate(_SetVal: string) {
		this._mechStickerDate = _SetVal;
	}

	get elecMechTestingDate(): string {
		return this._elecMechTestingDate;
	}
	set elecMechTestingDate(_SetVal: string) {
		this._elecMechTestingDate = _SetVal;
	}

	get FATDate(): string {
		return this._FATDate;
	}
	set FATDate(_SetVal: string) {
		this._FATDate = _SetVal;
	}

	get greenStickerDate(): string {
		return this._greenStickerDate;
	}
	set greenStickerDate(_SetVal: string) {
		this._greenStickerDate = _SetVal;
	}

	get exWorksDate(): string {
		return this._exWorksDate;
	}
	set exWorksDate(_SetVal: string) {
		this._exWorksDate = _SetVal;
	}

	get cursorIndex(): number {
		return this._cursorIndex;
	}
	set cursorIndex(_SetVal: number) {
		this._cursorIndex = _SetVal;
	}

	get productLeadTimeDays(): number {
		return this._productLeadTimeDays;
	}
	set productLeadTimeDays(_SetVal: number) {
		this._productLeadTimeDays = _SetVal;
	}

	get daysReqPR(): string {
		return this._daysReqPR;
	}
	set daysReqPR(_SetVal: string) {
		this._daysReqPR = _SetVal;
	}

	// TEST FOR COMMENTS
	get commentsPR(): string {
		return this._commentsPR;
	}
	set commentsPR(_SetVal: string) {
		this._commentsPR = _SetVal;
	}

	get projectEngName(): string {
		return this._projectEngName;
	}
	set projectEngName(_SetVal: string) {
		this._projectEngName = _SetVal;
	}
	get designEngName(): string {
		return this._designEngName;
	}
	set designEngName(_SetVal: string) {
		this._designEngName = _SetVal;
	}

}

export enum PRPath {
	homDatePRBodyCss = 0,
	sldgtpSubDatePRBodyCss = 1,
	gacsSubDatePRBodyCss = 2,
	schemeSubDatePRBodyCss = 3,
	mgaSubDatePRBodyCss = 4,
	sldGaGtpAprvlDatePRBodyCss = 5,
	longleadRDatePRBodyCss = 6,
	fnCusDrgAprvlDatePRBodyCss = 7,
	techCTDetsDatePRBodyCss = 8,
	fcmCTfinActDatePRBodyCss = 9,
	CTfinSCMActDatePRBodyCss = 10,
	c40ActDatePRBodyCss = 11,
	c50ActDatePRBodyCss = 12,
	c60ActDatePRBodyCss = 13,
	relayRecpDatePRBodyCss = 14,
	ctRecpDatePRBodyCss = 15,
	mbRecpDatePRBodyCss = 16,
	cbRecpDatePRBodyCss = 17,
	lineLoadActDatePRBodyCss = 18,
	mechStickerDatePRBodyCss = 19,
	elecMechTestingDatePRBodyCss = 20,
	FATDatePRBodyCss = 21,
	greenStickerDatePRBodyCss = 22,
	exWorksDatePRBodyCss = 23
}

export enum PRPathName {
	homDatePRBodyCss = "homDatePRBodyCss",
	sldgtpSubDatePRBodyCss = "sldgtpSubDatePRBodyCss",
	gacsSubDatePRBodyCss = "gacsSubDatePRBodyCss",
	schemeSubDatePRBodyCss = "schemeSubDatePRBodyCss",
	mgaSubDatePRBodyCss = "mgaSubDatePRBodyCss",
	sldGaGtpAprvlDatePRBodyCss = "sldGaGtpAprvlDatePRBodyCss",
	longleadRDatePRBodyCss = "longleadRDatePRBodyCss",
	fnCusDrgAprvlDatePRBodyCss = "fnCusDrgAprvlDatePRBodyCss",
	techCTDetsDatePRBodyCss = "techCTDetsDatePRBodyCss",
	fcmCTfinActDatePRBodyCss = "fcmCTfinActDatePRBodyCss",
	CTfinSCMActDatePRBodyCss = "CTfinSCMActDatePRBodyCss",
	c40ActDatePRBodyCss = "c40ActDatePRBodyCss",
	c50ActDatePRBodyCss = "c50ActDatePRBodyCss",
	c60ActDatePRBodyCss = "c60ActDatePRBodyCss",
	relayRecpDatePRBodyCss = "relayRecpDatePRBodyCss",
	ctRecpDatePRBodyCss = "ctRecpDatePRBodyCss",
	mbRecpDatePRBodyCss = "mbRecpDatePRBodyCss",
	cbRecpDatePRBodyCss = "cbRecpDatePRBodyCss",
	lineLoadActDatePRBodyCss = "lineLoadActDatePRBodyCss", // UNCOMMENT
	//   lineLoadActDatePRBodyCss = "lineLoadActDatePRBodyCss ",
	mechStickerDatePRBodyCss = "mechStickerDatePRBodyCss",
	elecMechTestingDatePRBodyCss = "elecMechTestingDatePRBodyCss",
	FATDatePRBodyCss = "FATDatePRBodyCss",
	greenStickerDatePRBodyCss = "greenStickerDatePRBodyCss",
	exWorksDatePRBodyCss = "exWorksDatePRBodyCss"
}

export class UiWaitReadySO {


	constructor(
		private _soNo: string, private _ssoNo: string,
		private _custName: string,
		private _isSaleOrderChngApplic: boolean, private _newSaleOrderNo: string,
		private _testingCat: string,
		private _equipTy: string, private _qtyPanel: number, private _daysCase: number, private _typeDays: string


	) { }
	get soNoV2(): string {
		if (this.isSaleOrderChngApplic == true) {
			return this._newSaleOrderNo;
		}
		return this._soNo;
	}

	get isSaleOrderChngApplic(): boolean {
		return this._isSaleOrderChngApplic == true && configDefs.isStrEmty(this._newSaleOrderNo) == false;
	}

	set isSaleOrderChngApplic(_SetVal: boolean) {
		this._isSaleOrderChngApplic = _SetVal;
	}

	get soNo(): string {
		return this._soNo;
	}
	set soNo(_SetVal: string) {
		this._soNo = _SetVal;
	}

	get newSaleOrderNo(): string {
		return this._newSaleOrderNo;
	}
	get ssoNo(): string {
		return this._ssoNo;
	}
	set ssoNo(_SetVal: string) {
		this._ssoNo = _SetVal;
	}
	get custName(): string {
		return this._custName;
	}
	set custName(_SetVal: string) {
		this._custName = _SetVal;
	}
	get equipTy(): string {
		return this._equipTy;
	}
	set equipTy(_SetVal: string) {
		this._equipTy = _SetVal;
	}
	get qtyPanel(): number {
		return this._qtyPanel;
	}
	set qtyPanel(_SetVal: number) {
		this._qtyPanel = _SetVal;
	}
	get testingCat(): string {
		return this._testingCat;
	}
	set testingCat(_SetVal: string) {
		this._testingCat = _SetVal;
	}

	get daysCase(): number {
		return this._daysCase;
	}
	set daysCase(_SetVal: number) {
		this._daysCase = _SetVal;
	}
	get typeDays(): string {
		return this._typeDays;
	}
	set typeDays(_SetVal: string) {
		this._typeDays = _SetVal;
	}


}
export class UiFunctionalKPI {


	constructor(
		private _manfMonth: Date, private _kpiName: string, private _custName: string, private _soNo: string, private _ssoNo: string,
		private _isSaleOrderChngApplic: boolean, private _newSaleOrderNo: string, private _variantType: string, private _qtyPanel: number,
		private _plannedDate: Date, private _revisedDate: Date, private _requestedDate: Date,
		private _actualDate: Date, private _diff: number, private _reason: string


	) { }
	get soNoV2(): string {
		if (this.isSaleOrderChngApplic == true) {
			return this._newSaleOrderNo;
		}
		return this._soNo;
	}

	get isSaleOrderChngApplic(): boolean {
		return this._isSaleOrderChngApplic == true && configDefs.isStrEmty(this._newSaleOrderNo) == false;
	}

	set isSaleOrderChngApplic(_SetVal: boolean) {
		this._isSaleOrderChngApplic = _SetVal;
	}

	get soNo(): string {
		return this._soNo;
	}
	set soNo(_SetVal: string) {
		this._soNo = _SetVal;
	}

	get newSaleOrderNo(): string {
		return this._newSaleOrderNo;
	}
	get ssoNo(): string {
		return this._ssoNo;
	}
	set ssoNo(_SetVal: string) {
		this._ssoNo = _SetVal;
	}
	get manfMonth(): Date {
		return this._manfMonth;
	}
	set manfMonth(_SetVal: Date) {
		this._manfMonth = _SetVal;
	}
	get kpiName(): string {
		return this._kpiName;
	}
	set kpiName(_SetVal: string) {
		this._kpiName = _SetVal;
	}
	get diff(): number {
		return this._diff;
	}
	set diff(_SetVal: number) {
		this._diff = _SetVal;
	}
	get plannedDate(): Date {
		return this._plannedDate;
	}
	set plannedDate(_SetVal: Date) {
		this._plannedDate = _SetVal;
	}

	get revisedDate(): Date {
		return this._revisedDate;
	}
	set revisedDate(_SetVal: Date) {
		this._revisedDate = _SetVal;
	}
	get requestedDate(): Date {
		return this._requestedDate;
	}
	set requestedDate(_SetVal: Date) {
		this._requestedDate = _SetVal;
	}
	get actualDate(): Date {
		return this._actualDate;
	}
	set actualDate(_SetVal: Date) {
		this._actualDate = _SetVal;
	}
	get custName(): string {
		return this._custName;
	}
	set custName(_SetVal: string) {
		this._custName = _SetVal;
	}
	get variantType(): string {
		return this._variantType;
	}
	set variantType(_SetVal: string) {
		this._variantType = _SetVal;
	}
	get qtyPanel(): number {
		return this._qtyPanel;
	}
	set qtyPanel(_SetVal: number) {
		this._qtyPanel = _SetVal;
	}
	get reason(): string {
		return this._reason;
	}
	set reason(_SetVal: string) {
		this._reason = _SetVal;
	}


}
// ENDS

export class MasterPlan {
	constructor(public pm: string, public planManufacturMonth: string, public invoicingmonth: string, public planRevenueMonth: string, public rotddate: string,
		public salesOrder: string, public subOrderNo: number, public customerName: string,
		public projectName: string, public consultantName: string, public saleChannel: string, public region: string,
		public pe: string, public de: string, public contractDeliveryDate: string, public contractValueMINR: string,
		public PayTerm: string, public noOfPayDays: string, public advPay: string, public advPayMilestone: string,
		public advPayCondition: string, public ABGACGSubmissionDetails: string, public ABGACGActualSubmissionDate: string,
		public deliveryTerm: string, public placeOfDelivery: string, public LDApplicability: string, public LDPercent: string,
		public LDCap: string, public variantOfProduct: string, public typrOfEquipment: string,
		public noOfPanels: string, public noOfFeederTypes: string, public complexityOfJob: string, public quantityOfCB: string,
		public quantityOfVC: string, public FCMMatCost: string, public FCMGMPercent: string, public FCMNMPercent: string,
		public JSRMatcost: string, public JSRGMPercent: string, public JSRNMPercent: string, public busbarMaterial: string,
		public impoEarthSwitchApplicability: string, public impoEarthSwitchType: string, public tempRaisTestApplicability: string,
		public impoShutterApplicability: string, public impoShutterType: string, public impoCBApplicability: string,
		public impoVSCApplicability: string, public busbarSleeve: string, public spareETApplicability: string, public vacuumContactorType: string,
		public alstomGERelayApplicability: string, public orderReceiptDate: string, public SOCreationDate: string, public SOReleaseDate: string,
		public plannedOrderHandlingOverDate: string, public revisedPlannedOrderHandingOverDate: string,
		public actualOrderHandingOverDate: string, public remarkForDelayEarlyOverHandingOverDate: string, public planSLDSubmissionDate: string,
		public initialSLDSubmissionDateActual: string, public plannedSchematicDrawingBOMSubmissionDate: string,
		public initailSchematicDrawingBOMSubmissionDateActual: string, public planGAFoundationDrawingSubmissionDate: string, public initialGAFoundationDrawingSubmissionDateActual: string,
		public planGTPCTPTBusbarSizingCalculationSubmissionDate: string, public initialGTPCTPTBusbarSizingCalculationSubmissionDateActual: string,
		public finalDrawingSubmissionDateActual: string, public planDrawingApprovalDate: string, public actualDrawingApprovalDate: string, public latestDrawingRevisionNumber: string,
		public longLeadReleaseDate: string, public planC40Date: string, public actualC40Date: string, public purchaseReleaseDateElectrical: string,
		public planC50Date: string, public actualC50Date: string, public purchaseReleaseDateMechanical: string, public planC60Date: string,
		public actualC60Date: string, public impoBreakerPOReleasedDatePlan: string, public impoBreakerPOReleasedDateActual: string,
		public impoVSCPOReleasedDatePlan: string, public impoVSCPOReleasedDateActual: string, public alstomGERelayPOReleasedDatePlan: string,
		public alstomGERelayPOReleasedDateActual: string, public impoEarthingSwitchPOReleasedDatePlan: string, public impoEarthingSwitchPOReleasedDateActual: string,
		public raychemSleevePOReleaseDateplan: string, public raychemSleevePOReleaseDateActual: string,
		public raychemSleevePOReleaseDate: string, public relayPOReleaseDatePlan: string, public relayPOReleaseDateActual: string,
		public CBPOReleaseDatePlan: string, public CBPOReleaseDateActual: string, public CTPTPOReleaseDatePlan: string, public CTPTPOReleaseDateActual: string,
		public jumperPOReleaseDatePlan: string, public jumperPOReleaseDateActual: string,
		public meteringBoxPOReleaseDatePlan: string, public meteringBoxPOReleaseDateActual: string, public CBPlanReceipt: string,
		public CBActualReceipt: string, public impoBreakerPlanReceiptDate: string,
		public impoBreakerActualReceiptDate: string, public impoVSCPlanReceiptDate: string, public impoVSCActualReceiptDate: string,
		public alstomGERelayPlanReceiptDate: string, public alstomGERelayActualReceiptDate: string, public impoEarthSwitchPlanReceiptDate: string,
		public impoEarthSwitchActualReceiptDate: string,
		public raychemSleeveReceiptDatePlan: string, public raychemSleeveReceiptDateActual: string, public CTPTPlanReceipt: string,
		public CTPTActualReceipt: string, public relayPlanReceipt: string, public relayActualReceipt: string, public jumperPlanReceipt: string,
		public jumperActualReceipt: string, public meteringBoxPlanReceipt: string, public meteringBoxActualReceipt: string, public productionStartDatePlan: string,
		public productionStartDateActual: string, public productionEndDatePlan: string, public productionEndDateActual: string,
		public mechanicalStickerPlanDate: string, public mechanicalStickerActualDate: string, public electricalTestingPlanDate: string,
		public electricalTestingActualDate: string, public fatPlanDate: string, public fatActualDate: string, public dispatchDateFromPlantPlan: string,
		public dispatchDateFromPlantActual: string, public boardname: string, public delayreason: string) { }

}

export class ManufacturingPlan {
	constructor(public planManufacturMonth: string, public customerName: string, public salesOrder: string, public subOrderNo: number, public variantOfProduct: string,
		public quantityOfPanel: string, public manufacturingStrategy: string, public actualC40Date: string, public actualC50Date: string, public actualC60Date: string, public requestLineLoadingDate: string,
		public mechanicalStickerRequestedDate: string, public mechanicalStickerActualDate: string, public mechanicalElectricalTestingRequestedDate: string, public fatRequestedDate: string,
		public importedBreakerPlanReceiptDate: string, public importedBreakerRequestReceiptDate: string, public importedBreakerSupplierReceiptDate: string, public importedBreakerActualReceiptDate: string,
		public importedVSCPlanReceiptDate: string, public importedVSCRequestReceiptDate: string, public importedVSCSupplierReceiptDate: string, public importedVSCActualReceiptDate: string,
		public geRelayPlanReceiptDate: string, public geRelayRequestReceiptDate: string, public geRelaySupplierReceiptDate: string, public geRelayActualReceiptDate: string,
		public ctPTPlanReceiptDate: string, public ctPTRequestReceiptDate: string, public ctPTSupplierReceiptDate: string, public ctPTActualReceiptDate: string,
		public relayPlanReceiptDate: string, public relayRequestReceiptDate: string, public relaySupplierReceiptDate: string, public relayActualReceiptDate: string,
		public breakerPlanReceiptDate: string, public breakerRequestReceiptDate: string, public breakerSupplierReceiptDate: string, public breakerActualReceiptDate: string,
		public jumperPlanReceiptDate: string, public jumperRequestReceiptDate: string, public jumperSupplierReceiptDate: string, public jumperActualReceiptDate: string,
		public meteringBoxPlanReceiptDate: string, public meteringBoxRequestReceiptDate: string, public meteringBoxSupplierReceiptDate: string, public meteringBoxActualReceiptDate: string,
		public saPlanReceiptDate: string, public saRequestReceiptDate: string, public saSupplierReceiptDate: string, public saActualReceiptDate: string,
		public broughtoutFabricationPlanReceiptDate: string, public broughtoutFabricationRequestReceiptDate: string, public broughtoutFabricationSupplierReceiptDate: string, public broughtoutFabricationActualReceiptDate: string) { }
}

export class DateInput {
	constructor() { }

	//set date()
}

export class SaveStatusObj {
	constructor(public source: SOModule, public eventType: SaveEventType, public ssoIndex: number = 0, public ssoSubmitTo: SSOStatus = SSOStatus.Not_Started) {

	}
}
export class fileManagerObject {
	constructor(public source: string, public files: Array<fileObj>) {

	}
}
export class fileObj {
	constructor(public fileName: string, public DateTime: Date, public fileType: string, public fileRef: string) {

	}
}
export class ValidationSummary {
	constructor(public header: string, public items: Array<ValidationItem>) {

	}
}
export class ValidationItem {
	constructor(public itemName: string, public isFullfilled: boolean, public additionalInfo: string) {

	}
}
export class ActualDate2Change {
	constructor(public header: string, public plannedDateName: string, public plannedDate: Date,
		public requestedDateName: string, public requestedDate: Date,
		public actualDateName: string, public actualDate: Date, public comments: string) {

	}
}
export class ActualDateChange {
	constructor(public header: string, public plannedDateName: string, public plannedDate: Date,
		public actualDateName: string, public actualDate: Date, public comments: string) {

	}
}
export class Deletereason {
	constructor(public comments: string) {
	}
	get message(): string {
		return 'delete reason';
	}
}
// STARTS
// TEST FOR COMMENTS
export class CommentsPR {
	constructor(public comments: string) {
	}
	get message(): string {
		return 'comment';
	}
}
// ENDS
export class FatDataList {
	constructor(private _callLetterDate: Date, private _selectedSubOrdNo: string, private _generatedDate: Date, private _generatedBy: string) {

	}

	get callLetterDate(): Date {
		return this._callLetterDate;
	}
	set callLetterDate(_SetVal: Date) {
		this._callLetterDate = _SetVal;
	}
	get selectedSubOrdNo(): string {
		return this._selectedSubOrdNo;
	}
	set selectedSubOrdNo(_SetVal: string) {
		this._selectedSubOrdNo = _SetVal;
	}
	get generatedDate(): Date {
		return this._generatedDate;
	}
	set generatedDate(_SetVal: Date) {
		this._generatedDate = _SetVal;
	}
	get generatedBy(): string {
		return this._generatedBy;
	}
	set generatedBy(_SetVal: string) {
		this._generatedBy = _SetVal;
	}



	cloneSelf(): FatDataList {
		return new FatDataList(configDefs.cloneDt(this.callLetterDate), this.selectedSubOrdNo, configDefs.cloneDt(this.generatedDate), this.generatedBy);
	}

	public static getObj(_json: any): FatDataList {
		return new FatDataList(GenService.convToDate(_json.crDate), _json.selSubOrdNo, GenService.convToDate(_json.genDate), _json.genBy);
	}

	getJson(): any {
		let _json: any = {};
		_json.crDate = GenService.convToDateNum(this.callLetterDate);
		_json.selSubOrdNo = this.selectedSubOrdNo;
		_json.genDate = GenService.convToDateNum(this.generatedDate);
		_json.genBy = this.generatedBy;

		return _json;
	}
}

export class PlannedDateToken {
	constructor(public plannedDate: Date, public isOveridden: boolean = false, public actualPlannedDate: Date, public addNotes: string, public userOveridden: string) {
	}

	cloneSelf(): PlannedDateToken {
		return new PlannedDateToken(configDefs.cloneDt(this.plannedDate), this.isOveridden, configDefs.cloneDt(this.actualPlannedDate), this.addNotes, this.userOveridden);
	}
	getJson(): any {
		let _json: any = {};
		_json.plannedDate = GenService.convToDateNum(this.plannedDate);
		_json.isOveridden = GenService.convToBoolNum(this.isOveridden);
		_json.actualPlannedDate = GenService.convToDateNum(this.actualPlannedDate);
		_json.addNotes = this.addNotes;
		_json.userOveridden = this.userOveridden;
		return _json;
	}
}
export class ActualDateToken {
	constructor(public actualDate: Date, public isOveridden: boolean = false, public expActualDate: Date, public addNotes: string, public userOveridden: string) {
	}
	cloneSelf(): ActualDateToken {
		return new ActualDateToken(configDefs.cloneDt(this.actualDate), this.isOveridden, configDefs.cloneDt(this.expActualDate), this.addNotes, this.userOveridden);
	}
	getJson(): any {
		let _json: any = {};
		_json.actualDate = GenService.convToDateNum(this.actualDate);
		_json.isOveridden = GenService.convToBoolNum(this.isOveridden);
		_json.expActualDate = GenService.convToDateNum(this.expActualDate);
		_json.addNotes = this.addNotes;
		_json.userOveridden = this.userOveridden;
		return _json;
	}
}
export class RequestDateToken {
	constructor(public requestDate: Date, public isOveridden: boolean = false, public plndRequestDate: Date, public addNotes: string, public userOveridden: string) {

	}
	cloneSelf(): RequestDateToken {
		return new RequestDateToken(configDefs.cloneDt(this.requestDate), this.isOveridden, configDefs.cloneDt(this.plndRequestDate), this.addNotes, this.userOveridden);
	}

	getJson(): any {
		let _json: any = {};
		_json.requestDate = GenService.convToDateNum(this.requestDate);
		_json.isOveridden = GenService.convToBoolNum(this.isOveridden);
		_json.plndRequestDate = GenService.convToDateNum(this.plndRequestDate);
		_json.addNotes = this.addNotes;
		_json.userOveridden = this.userOveridden;
		return _json;
	}
	static getObj(_j: any): RequestDateToken {
		if (_j) {
			return new RequestDateToken(
				GenService.convToDate(_j.requestDate), (_j.isOveridden == 1 ? true : false),
				GenService.convToDate(_j.plndRequestDate), _j.addNotes, _j.userOveridden
			);
		}
		return new RequestDateToken(null, false, null, '', '');
	}

}
export class SpecialPoint {
	public readOnly: boolean
	constructor(private _splPointText: string, private _fileArray: Array<FileElement>) {

	}

	get splPointText(): string {
		return this._splPointText;
	}
	set splPointText(_SetVal: string) {
		this._splPointText = _SetVal;
	}
	get FileArray(): Array<FileElement> {
		// console.log("filearray in special Pont")

		return this._fileArray;
	}
	cloneSelf(): SpecialPoint {
		let _fObjs: Array<FileElement> = [];
		for (var i = 0; i < this.FileArray.length; i++) {
			_fObjs.push(this.FileArray[i].cloneSelf())
		}
		return new SpecialPoint(this.splPointText, _fObjs);
	}



	getJson(): any {
		let _json: any = {};
		_json.splPoint = this.splPointText;
		_json.fObjs = [];
		for (var i = 0; i < this.FileArray.length; i++) {
			_json.fObjs.push(this.FileArray[i].getJson());
		}

		return _json;
	}
	static getObj(_j: any): SpecialPoint {
		if (_j) {
			let _fObjs: Array<FileElement> = [];
			for (var i = 0; i < _j.fObjs.length; i++) {
				_fObjs.push(FileElement.getObj(_j.fObjs[i]))
			}
			return new SpecialPoint(_j.splPoint, _fObjs);
		}
		return new SpecialPoint('', []);
	}
}
export class EnggProcFileUploads {
	public headerStr: string = '';
	public disableUpload: boolean;
	constructor(private _fileArray: Array<FileElement>) {

	}
	get FileArray(): Array<FileElement> {
		return this._fileArray;
	}
	cloneSelf(): EnggProcFileUploads {
		let _fObjs: Array<FileElement> = [];
		if (this.FileArray) {
			for (var i = 0; i < this.FileArray.length; i++) {
				_fObjs.push(this.FileArray[i].cloneSelf())
			}
		}
		return new EnggProcFileUploads(_fObjs);
	}



	getJson(): any {
		let _json: any = {};
		_json.fObjs = [];
		for (var i = 0; i < this.FileArray.length; i++) {
			_json.fObjs.push(this.FileArray[i].getJson());
		}

		return _json;
	}
	static getObj(_j: any): EnggProcFileUploads {
		let _fObjs: Array<FileElement> = [];
		if (_j) {
			for (var i = 0; i < _j.fObjs.length; i++) {
				_fObjs.push(FileElement.getObj(_j.fObjs[i]))
			}
		}
		return new EnggProcFileUploads(_fObjs);
	}
}
export class GenFileUploads {
	public headerStr: string = '';
	public disableUpload: boolean;
	constructor(private _fileArray: Array<FileElement>) {

	}
	get FileArray(): Array<FileElement> {
		return this._fileArray;
	}
	cloneSelf(): GenFileUploads {
		let _fObjs: Array<FileElement> = [];
		if (this.FileArray) {
			for (var i = 0; i < this.FileArray.length; i++) {
				_fObjs.push(this.FileArray[i].cloneSelf())
			}
		}
		return new GenFileUploads(_fObjs);
	}



	getJson(): any {
		let _json: any = {};
		_json.fObjs = [];
		for (var i = 0; i < this.FileArray.length; i++) {
			_json.fObjs.push(this.FileArray[i].getJson());
		}

		return _json;
	}
	static getObj(_j: any): GenFileUploads {
		let _fObjs: Array<FileElement> = [];
		if (_j) {
			for (var i = 0; i < _j.fObjs.length; i++) {
				_fObjs.push(FileElement.getObj(_j.fObjs[i]))
			}
		}
		return new GenFileUploads(_fObjs);
	}
}
export class SpecialPriceFile {
	constructor(private _fileArray: Array<FileElement>) {

	}
	public readOnly: boolean
	get FileArray(): Array<FileElement> {
		return this._fileArray;
	}
	cloneSelf(): SpecialPriceFile {
		let _fObjs: Array<FileElement> = [];
		if (this.FileArray) {
			for (var i = 0; i < this.FileArray.length; i++) {
				_fObjs.push(this.FileArray[i].cloneSelf())
			}
		}
		return new SpecialPriceFile(_fObjs);
	}



	getJson(): any {
		let _json: any = {};
		_json.fObjs = [];
		for (var i = 0; i < this.FileArray.length; i++) {
			_json.fObjs.push(this.FileArray[i].getJson());
		}

		return _json;
	}
	static getObj(_j: any): SpecialPriceFile {
		let _fObjs: Array<FileElement> = [];
		if (_j) {
			for (var i = 0; i < _j.fObjs.length; i++) {
				_fObjs.push(FileElement.getObj(_j.fObjs[i]))
			}
		}
		return new SpecialPriceFile(_fObjs);
	}
}
export class FileElement {

	constructor(public sno: number, public filename: string, public username, public filetype: string, public fileref: string, public DateTime: Date, public isSelected: boolean) {

	}
	static getObj(_j: any): FileElement {
		if (_j) return new FileElement(_j.sno, _j.filename, _j.username, _j.filetype, _j.fileref, GenService.convToDate(_j.DateTime), _j.isSelected);

		return null;
	}

	getJson(): any {
		return {
			sno: this.sno,
			filename: this.filename,
			username: this.username,
			filetype: this.filetype,
			fileref: this.fileref,
			DateTime: GenService.convToDateNum(this.DateTime),
			isSelected: this.isSelected
		}
	}

	cloneSelf(): FileElement {
		return new FileElement(this.sno, this.filename, this.username, this.filetype, this.fileref, configDefs.cloneDt(this.DateTime), this.isSelected);
	}
}
export class GenTaskData {
	public displayStatus: boolean = false;
	constructor(public taskId: string, public taskDisplayName: string, public taskDisplayHeadRow: GenTaskHeadRow, public taskDisplayDataRows: Array<GenTaskDataRow>) {
	}

	getDownloadJson(): any {
		var _json: any = {};

		_json.parameterGroupName = this.taskDisplayName;
		_json.taskCount = this.taskDisplayDataRows.length;
		_json.taskHeadCells = this.taskDisplayHeadRow.getDownloadJson();
		_json.tasks = [];

		for (var i = 0; i < this.taskDisplayDataRows.length; i++) {
			_json.tasks.push(this.taskDisplayDataRows[i].getDownloadJson());
		}

		/*
	{
		"parameterGroupName":"SLD Submission Date",
		"taskCount":29,
		"taskHeadCells":[
			"Sale Order","Sub Order","Customer Name","Project Engineer","Electrical Design Engineer","Details"
		],
		"tasks":[
			["42043985435", "03", "Tata Power", "Mahesh Pawar", "-",""]
		]
	}
		*/
		return _json;
	}

	getStructureClone(): GenTaskData {
		return new GenTaskData(this.taskId, this.taskDisplayName, this.taskDisplayHeadRow.cloneSelf(), []);
	}
}

export class GenTaskHeadRow {
	constructor(public headCells: Array<GenTaskHeadCell>) {

	}

	getDownloadJson(): any {
		var _json: Array<string> = [];

		for (var i = 0; i < this.headCells.length; i++) {
			if (this.headCells[i].headCellType != TaskCellType.DELAY_INDICATOR)
				_json.push(this.headCells[i].headCellName);
			else
				_json.push('Days')
		}
		_json.push('Planned/Revised');
		return _json;
	}

	cloneSelf(): GenTaskHeadRow {
		let _tempHeadRow: GenTaskHeadRow = new GenTaskHeadRow([]);
		this.headCells.forEach((_tmpHCell: GenTaskHeadCell) => {
			_tempHeadRow.headCells.push(_tmpHCell.cloneSelf());
		});
		return _tempHeadRow;
	}
}

export class GenTaskHeadCell {
	public filterOption: string = "0";
	constructor(public headCellName: string, public headCellCss: string, public headCellType: TaskCellType = TaskCellType.UNKNOWN) {

	}

	cloneSelf(): GenTaskHeadCell {
		return new GenTaskHeadCell(this.headCellName, this.headCellCss, this.headCellType);
	}
}

export class GenTaskDataRow {
	constructor(public cellRows: Array<GenTaskDataCell>, public titleInfo: string, public downloadTitleInfo: string) {

	}

	searchForContent(_srchtext: string): boolean {
		_srchtext = _srchtext.toLowerCase();
		for (var i = 0; i < this.cellRows.length; i++) {
			if ((this.cellRows[i].dataCellValue + '').toLowerCase().indexOf(_srchtext) >= 0) {
				return true;
			}
		}
		return false;
	}

	cloneSelf(): GenTaskDataRow {
		let _tmpTaskRow: GenTaskDataRow = new GenTaskDataRow([], this.titleInfo, this.downloadTitleInfo)

		for (var i = 0; i < this.cellRows.length; i++) {
			_tmpTaskRow.cellRows.push(this.cellRows[i].cloneSelf());
		}

		return _tmpTaskRow;
	}

	getDownloadJson(): any {
		var _json: Array<string> = [];

		for (var i = 0; i < this.cellRows.length; i++) {
			// if(this.cellRows[i].dataCellType == TaskCellType.SALE_ORDER_NO){
			// 	_json.push(" this.cellRows[i].dataCellValue);
			// }
			// else{
			// console.log(this.cellRows[i].dataCellValue, typeof this.cellRows[i].dataCellValue)s
			// if ()
			_json.push(this.cellRows[i].dataCellValue);
			//}

		}
		_json.push(this.downloadTitleInfo);

		return _json;
	}
}
export class GenTaskDataCell {
	constructor(public dataCellValue: any, public dataCellType: TaskCellType, public additonalParam: any, public dataCellCss: string = '') {

	}

	cloneSelf(): GenTaskDataCell {
		return new GenTaskDataCell(this.dataCellValue, this.dataCellType, this.additonalParam, this.dataCellCss);
	}
}

export class User {
	constructor(private _id: string, private _userName: string, private _userEmail: string, private _userGroupId: string, private _isActive: boolean) {
	}
	isSearchTokenFound(_srchTxt: string): boolean {
		if (this._userName.toLowerCase().indexOf(_srchTxt) >= 0)
			return true;

		if (this._userEmail.toLowerCase().indexOf(_srchTxt) >= 0)
			return true;

		return false;
	}
	get Id(): string {
		return this._id;
	}
	get userName(): string {
		return this._userName;
	}
	set userName(_SetVal: string) {
		this._userName = _SetVal;
	}
	get userEmail(): string {
		return this._userEmail;
	}
	set userEmail(_SetVal: string) {
		this._userEmail = _SetVal;
	}
	get userGroupId(): string {
		// console.log('userGroupId',this._userGroupId)
		return this._userGroupId;
	}
	set userGroupId(_SetVal: string) {
		this._userGroupId = _SetVal;
	}
	get IsActive(): boolean {
		return this._isActive;
	}
	set IsActive(flag: boolean) {
		this._isActive = flag;
	}
	cloneSelf() {
		return new User(this._id, this._userName, this._userEmail, this._userGroupId, this._isActive);
	}
	public static getNewObj(): User {
		return new User('', '', '', '', true);
	}
	public static getObj(_json: any): User {
		let _userObj: User = new User(_json.id, _json.userName, _json.userEmail, _json.userGroupId, _json.isActive);
		return _userObj;
	}
	public getJson(): any {
		let _json: any = {}
		_json.id = this.Id;
		_json.userName = this.userName;
		_json.userEmail = this.userEmail;
		_json.userGroupId = this.userGroupId;
		_json.isActive = this.IsActive;
		return _json;
	}


}
export class monthFilter {
	constructor(private _fromMonth: number, private _fromYear: number, private _toMonth: number, private _toYear: number) {

	}
	getCookieStr(): string {
		return this._fromMonth + "," + this._fromYear + "," + this._toMonth + "," + this._toYear;
	}
	static getObjFromCookieStr(_cookie: string): monthFilter {
		let _tokens: Array<string> = _cookie.split(',');
		if (_tokens.length == 4) {
			return new monthFilter(
				parseInt(_tokens[0], 10), parseInt(_tokens[1]),
				parseInt(_tokens[2], 10), parseInt(_tokens[3], 10)
			);
		}

		return null;
	}
	get fromMonth(): number {
		return this._fromMonth;
	}
	get fromYear(): number {
		return this._fromYear;
	}
	get toMonth(): number {
		return this._toMonth;
	}
	get toYear(): number {
		return this._toYear;
	}
	get fromMonthToken(): number {
		return ((this.fromYear * 100) + this.fromMonth);
	}
	get toMonthToken(): number {
		return ((this.toYear * 100) + this.toMonth);
	}
	getMonthToken(_dt: Date) {
		return ((_dt.getFullYear() * 100) + (_dt.getMonth() + 1));
	}

	get fromMonthName(): string {
		return GenService.getMonthDispName(this.fromYear, this.fromMonth - 1);
	}
	get toMonthName(): string {
		return GenService.getMonthDispName(this.toYear, this.toMonth - 1);
	}

	isWithInFilterScope(_date: Date): boolean {
		if (_date == null) {
			return false;
		}
		var fromToken: number = this.fromMonthToken;
		var toToken: number = this.toMonthToken;
		var refToken: number = this.getMonthToken(_date);
		if (fromToken <= refToken && toToken >= refToken) {
			return true;
		}
		return false;
	}

	nextFromMonth() {
		if (this._fromMonth >= 12) {
			this._fromMonth = 1;
			this._fromYear++;
		}
		else {
			this._fromMonth++;
		}
		if (this._fromYear > this._toYear || (this._fromYear == this._toYear && this._fromMonth > this._toMonth)) {
			this._toYear = this._fromYear;
			this._toMonth = this._fromMonth;
		}
	}
	prevFromMonth() {
		if (this._fromMonth <= 1) {
			this._fromMonth = 12;
			this._fromYear--;
		}
		else {
			this._fromMonth--;
		}
		if (this._fromYear > this._toYear || (this._fromYear == this._toYear && this._fromMonth > this._toMonth)) {
			this._toYear = this._fromYear;
			this._toMonth = this._fromMonth;
		}
	}
	nextToMonth() {
		if (this._toMonth >= 12) {
			this._toMonth = 1;
			this._toYear++;
		}
		else {
			this._toMonth++;
		}
		if (this._fromYear > this._toYear || (this._fromYear == this._toYear && this._fromMonth > this._toMonth)) {
			this._fromYear = this._toYear;
			this._fromMonth = this._toMonth;
		}
	}
	prevToMonth() {
		if (this._toMonth <= 1) {
			this._toMonth = 12;
			this._toYear--;
		}
		else {
			this._toMonth--;
		}
		if (this._fromYear > this._toYear || (this._fromYear == this._toYear && this._fromMonth > this._toMonth)) {
			this._fromYear = this._toYear;
			this._fromMonth = this._toMonth;
		}
	}
	nextFromMonth12() {
		if (this._fromMonth >= 12) {
			this._fromMonth = 1;
			this._fromYear++;
			this._toMonth = 12;
			this._toYear = this._fromYear;

		}
		else {
			this._fromMonth++;
			this._toMonth = this._fromMonth - 1;
			this._toYear = this._fromYear + 1;
		}
		if (this._fromYear > this._toYear || (this._fromYear == this._toYear && this._fromMonth > this._toMonth)) {
			this._toYear = this._fromYear + 1;
			this._toMonth = this._fromMonth - 1;
		}
	}
	prevFromMonth12() {
		if (this._fromMonth <= 1) {
			this._fromMonth = 12;
			this._fromYear--;
			this._toMonth = this._fromMonth - 1;
			this._toYear = this._fromYear + 1;
		}
		else {
			this._fromMonth--;
			if (this._fromMonth == 1) {
				this._toMonth = 12;
				this._toYear = this._fromYear;
			}
			else {
				this._toMonth = this._fromMonth - 1;
				this._toYear = this._fromYear + 1;
			}
		}
		if (this._fromYear > this._toYear || (this._fromYear == this._toYear && this._fromMonth > this._toMonth)) {
			this._toYear = this._fromYear + 1;
			this._toMonth = this._fromMonth - 1;
		}
	}
	nextToMonth12() {
		if (this._toMonth >= 12) {
			this._toMonth = 1;
			this._toYear++;
			this._fromMonth = 12;
			this._fromYear = this._toYear;
		}
		else {
			this._toMonth++;
			if (this._toMonth == 12) {
				this._fromMonth = 1;
				this._fromYear = this._toYear;
			}
			else {
				this._fromMonth = this._toMonth + 1;
				this._fromYear = this._toYear - 1;
			}
		}
		if (this._fromYear > this._toYear || (this._fromYear == this._toYear && this._fromMonth > this._toMonth)) {
			this._fromYear = this._toYear - 1;
			this._fromMonth = this._toMonth + 1;
		}
	}
	prevToMonth12() {
		if (this._toMonth <= 1) {
			this._toMonth = 12;
			this._toYear--;
			this._fromMonth = 1;
			this._fromYear = this._toYear;
		}
		else {
			this._toMonth--;
			this._fromMonth = this._toMonth + 1;
			this._fromYear = this._toYear - 1;
		}
		if (this._fromYear > this._toYear || (this._fromYear == this._toYear && this._fromMonth > this._toMonth)) {
			this._fromYear = this._toYear + 1;
			this._fromMonth = this._toMonth - 1;
		}
	}
}
export class yearFilter {
	constructor(private _selYear: number) {

	}
	getCookieStr(): string {
		return this._selYear + "";
	}
	static getObjFromCookieStr(_cookie: string): yearFilter {
		let _tokens: string = _cookie;
		if (_tokens.length == 4) {
			return new yearFilter(
				parseInt(_tokens, 10)
			);
		}
		return null;
	}

	get selYear(): number {
		return this._selYear;
	}

	get yearName(): string {
		return this.selYear + "";
	}
	nextYear() {
		this._selYear++;
	}
	prevYear() {
		this._selYear--;
	}

}
export class columnFilter {
	constructor(public dispName: string, public itemId: string, public isSelected: boolean) {

	}

}
export class selectionfilter {
	constructor(public filename: string, public fileId: string, public isSelected: boolean) {

	}
}

export enum TaskCellType {
	SALE_ORDER_NO = 1,
	SUB_ORDER = 2,
	CUSTOMER_NAME = 3,
	MARKETING_ENGINEER = 4,
	PROJECT_ENGINEER = 5,
	GENERIC_LIST = 6,
	DELAY_INDICATOR = 98,
	UNKNOWN = 99
}
export enum SOStatus {
	Marketing = 0,
	PM_Commercial = 1,
	Sub_Orders = 2,
	Dispatched = 3,
	Archived = 4
}
export enum SSOStatus {
	Not_Started = 0x00000001,
	PM_Tech = 0x00000002,
	Engg_Draw = 0x00000004,
	PM_Tech_EnggDraw = 0x00000008,
	SCM = 0x00000010,
	Engg_Procurement_From_EnggDraw = 0x00000020,
	Engg_Procurement_From_SCM = 0x00000040,
	PO = 0x00000080,
	Planning = 0x00000100,
	Planning_From_PO = 0x00000200,
	Material_Receipt = 0x00000400,
	Store = 0x00000800,
	Production = 0x00001000,
	Quality = 0x00002000,
	Logistic = 0x00004000,
	Dispatched = 0x00008000,
	Store_From_MaterialReceipt = 0x00010000,
	Production_From_Store = 0x00020000,
	Planning_From_PMTech = 0x00040000,
	Engg_Procurement_From_PM_Tech = 0x00080000,
	Logistic_From_PM_Tech = 0x00100000,
	UnDispatched = -0x00008000
}
export enum SaveEventType {
	Reload_Data = 0,
	Save_Data = 1,
	Submit_To_Next = 2,
	Delete_Sale_Order = 3,
	Delete_SubSale_Order = 4,
	Save_ChangeData = 5,
	Delete_Datasheet = 6
}
export enum SOModule {
	Marketing = 0,
	PM_Commercial = 1,
	Sub_Orders = 2
}
export enum FunctionStatus {
	WAITING_FOR_PREV = 0,
	WAITING_FOR_USER_INPUT = 1,
	SUBMITTED_INCOMPLETE = 2,
	SUBMITTED_WAITING_RESPONSE = 3,
	SUBMITTED_COMPLETE = 4,
	NOT_SUBMITTED_BUT_READY = 5,
	RELAY_PENDING = 6
}
export enum UserType {
	SUPER_ADMIN = 1,
	MARKETING = 2,
	HOD_MARKETING = 101,
	PROJECT_MANAGEMENT = 3,
	HOD_PROJECT_MANAGEMENT = 102,
	FINANCE = 13,
	HOD_FINANCE = 103,
	MECHANICAL_ENGINEERING = 4,
	ELECTRICAL_ENGINEERING = 5,
	C30_ENGINEERING = 14,
	HOD_ENGINEERING = 104,
	SCM = 6,
	HOD_SCM = 105,
	PURCHASE = 7,
	HOD_PURCHASE = 106,
	PRODUCTION = 8,
	HOD_PRODUCTION = 107,
	PLANNING = 9,
	HOD_PLANNING = 108,
	TESTING = 10,
	HOD_TESTING = 109,
	STORES = 11,
	HOD_STORES = 110,
	LOGISTICS = 12,
	HOD_LOGISTICS = 111,
	PLANNING_PRODUCTION = 15,
	UNKNOWN = 99
}
export enum MyTaskType {
	MARKETING = 1,
	HEAD_MARKETING = 101,
	PROJECT_MANAGEMENT = 2,
	HEAD_PROJECT_MANAGEMENT = 102,
	FINANCE = 13,
	HEAD_FINANCE = 112,
	SCM = 3,
	HEAD_SCM = 103,
	ENGINEERING = 4,
	HEAD_ENGINEERING = 104,
	PURCHASE_PO = 5,
	HEAD_PURCHASE_PO = 105,
	PLANNING = 6,
	HEAD_PLANNING = 106,
	MATERIAL_RECEIPT = 7,
	HEAD_MATERIAL_RECEIPT = 107,
	STORES = 8,
	HEAD_STORES = 108,
	PRODUCTION = 9,
	HEAD_PRODUCTION = 109,
	TESTING = 10,
	HEAD_TESTING = 110,
	LOGISTICS = 11,
	HEAD_LOGISTICS = 111,
	PLANNING_PRODUCTION = 15,
	ADMIN = 12,
	UNKNOWN = 99
}
export enum MyTaskJobStatus {
	DELAYED = 1,
	RUNNING = 2,
	UPCOMING = 3,
	UNKNOWN = 99
}
export enum Task {
	SO_RELEASE = 0,




	UNKNOWN = 99
}
export enum ServerSockEvent {
	SOLOCKFAIL = 0
}
export enum userFilterOption {
	All = 0,
	MarketingEngineer = 1,
	ProjectManager = 2,
	ProjectEngineer = 3,
	ElectricDesignEngineer = 4,
	MechanicalDesignEngineer = 5,
	C30Engineer = 6
}